
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("gGjAb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b0516d70dca921df$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $7ZwLV = parcelRequire("7ZwLV");
var $enb7h = parcelRequire("enb7h");

var $5BRby = parcelRequire("5BRby");

var $cA8OV = parcelRequire("cA8OV");

var $fWkFY = parcelRequire("fWkFY");

var $1Iui1 = parcelRequire("1Iui1");

var $h4Fhh = parcelRequire("h4Fhh");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $k8Qyf = parcelRequire("k8Qyf");

var $keguF = parcelRequire("keguF");

var $7vf5z = parcelRequire("7vf5z");

var $jD3pk = parcelRequire("jD3pk");

var $2j5ni = parcelRequire("2j5ni");

var $dWvpo = parcelRequire("dWvpo");

var $kKzsy = parcelRequire("kKzsy");

var $3e4zR = parcelRequire("3e4zR");

var $6M8Uw = parcelRequire("6M8Uw");

var $51ACp = parcelRequire("51ACp");

var $iJHZm = parcelRequire("iJHZm");

var $dxcfv = parcelRequire("dxcfv");
var $dWLk9 = parcelRequire("dWLk9");
var $3e9vj = parcelRequire("3e9vj");
var $4xHig = parcelRequire("4xHig");

var $jK1pm = parcelRequire("jK1pm");

var $9J3fC = parcelRequire("9J3fC");

var $j0CW6 = parcelRequire("j0CW6");

var $7mFxr = parcelRequire("7mFxr");
const $b0516d70dca921df$var$getInviteThirdPartyTeamsExperiment = ()=>(0, $1ybV0.getMultivariateFeatureFlag)('confluence.frontend.growth.invite-3rd-party-teams', (0, $1Iui1.NOT_ENROLLED), [
        (0, $1Iui1.NOT_ENROLLED),
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.VARIATION)
    ]);
const $b0516d70dca921df$var$PeopleProfilesShell = ({ history: history })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const [{ data: gspData }, { fetchState: fetchState }] = (0, $dWvpo.useGettingStartedPanelState)();
    (0, $eUqFw.useEffect)(()=>{
        if (gspData === undefined) fetchState();
    }, [
        gspData,
        fetchState
    ]);
    const gspProjectId = gspData?.properties?.user?.projectId;
    const { isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = (0, $2j5ni.useIsFirstProjectITSM)(gspProjectId);
    /**
	 * Initializes the active tab to 'alerts' within the Getting Started Panel
	 * specifically for NPLE for ITSM experiment.
	 */ (0, $3e4zR.useInitializeActiveTab)('alerts', gspProjectId);
    const addFlag = (0, $eUqFw.useMemo)(()=>(0, $j0CW6.createShowFlagHandler)(showFlag, dismissFlag), [
        showFlag,
        dismissFlag
    ]);
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const atlassianAccountId = (0, $dxcfv.useAccountId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const environment = (0, $3e9vj.useEnvironment)();
    const locale = (0, $4xHig.useLocale)();
    const previousSubProduct = (0, $keguF.getPreviousSubProduct)();
    const invitePeopleExperimentalFeatures = {
        inviteThirdPartyTeams: $b0516d70dca921df$var$getInviteThirdPartyTeamsExperiment(),
        displayInfiSpotlight: (0, $1ybV0.ff)('confluence.frontend.growth.display-infi-spotlight')
    };
    const { openModal: openModal } = (0, $enb7h.useInvitePeopleModal)({
        continueUrl: window.location.href,
        enableThirdParty: true,
        experimentalFeatures: invitePeopleExperimentalFeatures,
        resourceAri: `ari:cloud:jira::site/${cloudId}`,
        showFlag: addFlag,
        source: 'peopleDirectory',
        subProduct: previousSubProduct === 'unknown' || previousSubProduct === null ? undefined : previousSubProduct
    });
    const invitePeopleHandlers = (0, $eUqFw.useMemo)(()=>({
            handleOpenDialog: openModal
        }), [
        openModal
    ]);
    const { shouldUseJSM: shouldUseJSM } = (0, $h4Fhh.useOgTenantInfo)();
    if (!atlassianAccountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fWkFY.default), null);
    const { push: push, replace: replace } = history;
    const productFeatureFlags = {
        'event-on-call-consolidation_s97c8': true,
        'event-on-call-consolidation-state': shouldUseJSM
    };
    const isNpleForItsmEnabled = isFirstProject && isFirstProjectItsm && (0, $79xbN.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "people-profiles"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        id: "people-profiles"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cA8OV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9J3fC.default), {
        appName: "jira-directory",
        contextSpaPaths: [
            '/browse',
            '/jira',
            '/projects'
        ],
        contextEntryPoint: "/jira/people",
        env: environment === 'prod' ? 'prod' : 'stg',
        locale: locale,
        // @ts-expect-error - TS2322 - Type '(flagFromPTC: FlagFromPTC) => void' is not assignable to type '(props: FlagProps) => void'.
        addFlag: addFlag,
        push: push,
        replace: replace,
        docTitle: {
            end: 'Jira'
        },
        history: history,
        cloudId: cloudId,
        orgId: orgId,
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'JiraSubProduct | undefined'.
        subProduct: previousSubProduct,
        invitePeopleHandlers: invitePeopleHandlers,
        productFeatureFlags: productFeatureFlags
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: "people-profiles",
        isExpectedToHaveSsr: false,
        // @ts-expect-error - TS2769 - No overload matches this call.
        metric: (0, $7mFxr.peopleProfilesPageLoad)
    }), (0, $eI5EY.fg)('set-embedded-directory-spa-ready') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null))), isNpleForItsmEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKzsy.JsdGettingStartedPanelShouldRender), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKzsy.JsdGettingStartedPanelOpenButton), null)));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b0516d70dca921df$export$2e2bcd8739ae039 = ()=>// @ts-expect-error - TS2739 - Type '{ children: (history: any) => Element; }' is missing the following properties from type 'RouteContext': location, query, route, match, action
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51ACp.HistoryAdapter), null, (history)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ZwLV.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0516d70dca921df$var$PeopleProfilesShell, {
            history: history
        })));

});
parcelRegister("cA8OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0809371ccd3c77a9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0809371ccd3c77a9$export$2e2bcd8739ae039 = (0, $kwce8.default).div.withConfig({
    componentId: "h5xpn2-0"
})({
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $c9TLT.fontSize)}px`,
    height: 'inherit',
    letterSpacing: 'normal'
});

});

parcelRegister("fWkFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42223e83f1ce9c0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3da0c = parcelRequire("3da0c");

var $lPArN = parcelRequire("lPArN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b42223e83f1ce9c0$export$2e2bcd8739ae039 = ()=>{
    const { href: href = null } = (0, $3da0c.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lPArN.default), {
            url: `/login.jsp?os_destination=${encodedRedirectUrl}`
        });
    }
    return null;
};

});
parcelRegister("3da0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $156a3428b96ddf9e$export$2e2bcd8739ae039);
/**
 * Wrap window.location so that it's testable.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $156a3428b96ddf9e$export$2e2bcd8739ae039 = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};

});

parcelRegister("lPArN", function(module, exports) {

$parcel$export(module.exports, "default", () => $84dddb8b24cbf4df$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$84dddb8b24cbf4df$export$2e2bcd8739ae039 = ({ url: url })=>{
    window.location.assign(url);
    return null;
};

});


parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $4nnPJ = parcelRequire("4nnPJ");

var $1QVWH = parcelRequire("1QVWH");

var $j2Yjr = parcelRequire("j2Yjr");

var $gnIbC = parcelRequire("gnIbC");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QVWH.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j2Yjr.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $gnIbC.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("j2Yjr", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $9cfce24b860b88bd$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $9cfce24b860b88bd$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $9cfce24b860b88bd$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $9cfce24b860b88bd$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $9cfce24b860b88bd$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fVaJL.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");
var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $5iuyH = parcelRequire("5iuyH");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $4nnPJ = parcelRequire("4nnPJ");

var $5iuyH = parcelRequire("5iuyH");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $5iuyH.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fVaJL.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fVaJL.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $gnIbC = parcelRequire("gnIbC");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("2j5ni", function(module, exports) {

$parcel$export(module.exports, "useGettingStartedPageStateActions", () => $cde75c243fb1da47$export$8d2572f02ec0aa4c);
$parcel$export(module.exports, "useIsFirstProjectITSM", () => $cde75c243fb1da47$export$852fe39748ba826d);
$parcel$export(module.exports, "useGetNpleDisabledProjectProperty", () => $cde75c243fb1da47$export$24659fa3abfd0100);
$parcel$export(module.exports, "useIsGettingStartedPageEnabled", () => $cde75c243fb1da47$export$a58e406dc976509e);

var $eUqFw = parcelRequire("eUqFw");

var $9CmwD = parcelRequire("9CmwD");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $lRmyA = parcelRequire("lRmyA");

var $bFzGY = parcelRequire("bFzGY");

var $dwCxb = parcelRequire("dwCxb");

var $bNe1g = parcelRequire("bNe1g");

var $gd0Sp = parcelRequire("gd0Sp");

var $cwfEs = parcelRequire("cwfEs");

var $2wBzW = parcelRequire("2wBzW");

var $9qZHX = parcelRequire("9qZHX");
const $cde75c243fb1da47$export$8d2572f02ec0aa4c = ()=>{
    const baseUrl = window.location.origin;
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const { data: data } = (0, $bNe1g.useProjectContext)() || {};
    const { projectId: projectId } = data || {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const projectIdString = projectId ? projectId.toString() : '';
    return (0, $eUqFw.useMemo)(()=>{
        const actionProps = {
            baseUrl: baseUrl,
            cloudId: cloudId,
            projectId: projectIdString,
            createAnalyticsEvent: createAnalyticsEvent
        };
        return [
            {
                updateLandingPageStateProperties: (0, $9qZHX.updateLandingPageStateProperties)(actionProps),
                getLandingPageState: (0, $9qZHX.getLandingPageState)(actionProps),
                initialiseLandingPageState: (0, $9qZHX.initialiseLandingPageState)(actionProps)
            }
        ];
    }, [
        baseUrl,
        cloudId,
        createAnalyticsEvent,
        projectIdString
    ]);
};
const $cde75c243fb1da47$export$852fe39748ba826d = (inputProjectId)=>{
    const { data: containerContext, loading: loading } = (0, $bNe1g.useProjectContext)();
    const currentProjectId = inputProjectId || containerContext?.projectId;
    const [isFirstProject, setIsFirstProject] = (0, $eUqFw.useState)(false);
    const [isFirstProjectItsm, setIsFirstProjectItsm] = (0, $eUqFw.useState)(false);
    const [isStateLoading, setStateLoading] = (0, $eUqFw.useState)(true);
    const { error: isFirstProjectError, firstProject: firstProject } = (0, $2wBzW.useFirstProjectDetails)();
    (0, $eUqFw.useEffect)(()=>{
        if (currentProjectId && !isFirstProjectError && firstProject) {
            setIsFirstProject(firstProject.projectId === `${currentProjectId}`);
            setIsFirstProjectItsm(firstProject.projectTemplateKey === (0, $9CmwD.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY));
            setStateLoading(false);
        } else if (isFirstProjectError) setStateLoading(false);
    }, [
        currentProjectId,
        firstProject,
        isFirstProjectError,
        setStateLoading
    ]);
    const memoizedValue = (0, $eUqFw.useMemo)(()=>({
            isLoading: loading || isStateLoading,
            isFirstProject: isFirstProject,
            isFirstProjectItsm: isFirstProjectItsm,
            isFirstProjectError: isFirstProjectError
        }), [
        isFirstProject,
        isFirstProjectItsm,
        isFirstProjectError,
        loading,
        isStateLoading
    ]);
    return memoizedValue;
};
const $cde75c243fb1da47$export$da3441212b1c36fb = (projectId)=>{
    const { [(0, $9CmwD.INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY)]: initialProjectTemplate } = (0, $dwCxb.useProjectProperties)([
        (0, $9CmwD.INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY)
    ], projectId);
    const isLoading = initialProjectTemplate === undefined;
    const { isLoading: isFirstProjectITSMLoading, isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = $cde75c243fb1da47$export$852fe39748ba826d(projectId);
    const excludedProjectTemplates = isFirstProject && isFirstProjectItsm && (0, $79xbN.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation') ? (0, $cwfEs.GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_ITSM) : (0, $cwfEs.GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_PROD);
    return (0, $eUqFw.useMemo)(()=>[
            isLoading || isFirstProjectITSMLoading,
            !!initialProjectTemplate && excludedProjectTemplates.includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            initialProjectTemplate)
        ], [
        excludedProjectTemplates,
        initialProjectTemplate,
        isFirstProjectITSMLoading,
        isLoading
    ]);
};
const $cde75c243fb1da47$export$24659fa3abfd0100 = (projectKeyOrId)=>{
    const [npleDisabled, setNpleDisabled] = (0, $eUqFw.useState)(projectKeyOrId ? undefined : true);
    const isLoading = npleDisabled === undefined;
    const getNpleDisabledProjectProperty = (0, $eUqFw.useCallback)(async ()=>{
        try {
            const response = await (0, $lRmyA.performGetRequest)(`/rest/api/3/project/${projectKeyOrId}/properties/${(0, $cwfEs.DISABLE_NPLE_PROJECT_PROJECT_KEY)}`);
            setNpleDisabled(response.value);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setNpleDisabled(error.statusCode !== 404);
            error.statusCode !== 404 && (0, $guiFP.default)({
                meta: {
                    id: 'getDisableNpleProjectProperty',
                    packageName: (0, $cwfEs.PACKAGE_NAME),
                    teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        projectKeyOrId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (projectKeyOrId) getNpleDisabledProjectProperty();
    }, [
        getNpleDisabledProjectProperty,
        projectKeyOrId
    ]);
    return [
        isLoading,
        npleDisabled
    ];
};
const $cde75c243fb1da47$export$a58e406dc976509e = (customContext)=>{
    const { data: data } = (0, $bNe1g.useProjectContext)(customContext) || {};
    const isNpleProductionised = (0, $1ybV0.ff)('getting_started_page_production_rollout');
    const { simplified: isSimplified = false, isProjectAdmin: isProjectAdmin, projectKey: projectKey, projectId: projectId } = data || {};
    const [isLoading, isExcludedProject] = $cde75c243fb1da47$export$da3441212b1c36fb(projectId?.toString());
    const [isGetNpleDisabledLoading, npleDisabled] = $cde75c243fb1da47$export$24659fa3abfd0100(isNpleProductionised ? projectKey : undefined);
    const isDataLoading = isLoading || isGetNpleDisabledLoading && isNpleProductionised;
    const { appPermissions: appPermissions } = (0, $gd0Sp.useTenantContext)() || {};
    const hasJSMAccess = (0, $eI5EY.fg)('add-product-permission-check-for-nple') ? appPermissions?.hasServiceDeskAccess : true;
    return (0, $eUqFw.useMemo)(()=>[
            isDataLoading,
            !isDataLoading ? hasJSMAccess && isProjectAdmin && !isSimplified && !isExcludedProject && !npleDisabled && isNpleProductionised : false
        ], [
        isDataLoading,
        isProjectAdmin,
        isSimplified,
        isExcludedProject,
        npleDisabled,
        isNpleProductionised,
        hasJSMAccess
    ]);
};

});
parcelRegister("dwCxb", function(module, exports) {

$parcel$export(module.exports, "useProjectProperties", () => $261b340823618fbf$export$58be98885c2d686a);

var $eUqFw = parcelRequire("eUqFw");

var $3OXzs = parcelRequire("3OXzs");

var $hTLlD = parcelRequire("hTLlD");

var $3LiTJ = parcelRequire("3LiTJ");

var $WBLbN = parcelRequire("WBLbN");

var $eI5EY = parcelRequire("eI5EY");

var $cPEpP = parcelRequire("cPEpP");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fML59 = parcelRequire("fML59");
const $261b340823618fbf$export$d4c72bab9d6cc13a = {};
const $261b340823618fbf$var$Store = (0, $WBLbN.createStore)({
    name: 'project-properties',
    initialState: $261b340823618fbf$export$d4c72bab9d6cc13a,
    actions: $fML59.actions
});
const $261b340823618fbf$export$eebf791068e870dd = (0, $WBLbN.createHook)($261b340823618fbf$var$Store);
const $261b340823618fbf$export$58be98885c2d686a = (propertyKeys, projectIdOverride)=>{
    const { data: data } = (0, $cPEpP.useProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const projectId = projectIdOverride !== undefined && (0, $eI5EY.fg)('pass_project_id_to_useprojectproperties') ? projectIdOverride : data?.id && `${data.id}`;
    const [state, { get: get }] = $261b340823618fbf$export$eebf791068e870dd();
    const prevPropertyKeys = (0, $hzcvF.usePrevious)(propertyKeys);
    (0, $eUqFw.useEffect)(()=>{
        if (projectId === undefined && (0, $eI5EY.fg)('pass_project_id_to_useprojectproperties')) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraProjectPropertiesServices undefinedProjectId');
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(propertyKeys, prevPropertyKeys) && !projectIdOverride) return;
        if (projectId) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        get(projectId, propertyKeys);
    }, [
        projectId,
        propertyKeys,
        prevPropertyKeys,
        get,
        createAnalyticsEvent,
        projectIdOverride
    ]);
    return projectId !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))(state[projectId], (_, key)=>(0, (/*@__PURE__*/$parcel$interopDefault($3OXzs)))(propertyKeys, key)) : {};
};

});
parcelRegister("3OXzs", function(module, exports) {

var $jkhuN = parcelRequire("jkhuN");

var $jxg5X = parcelRequire("jxg5X");

var $4ZYEI = parcelRequire("4ZYEI");

var $hNahz = parcelRequire("hNahz");

var $hvbu2 = parcelRequire("hvbu2");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2c84401faa0612b2$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $2c84401faa0612b2$var$includes(collection, value, fromIndex, guard) {
    collection = $jxg5X(collection) ? collection : $hvbu2(collection);
    fromIndex = fromIndex && !guard ? $hNahz(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $2c84401faa0612b2$var$nativeMax(length + fromIndex, 0);
    return $4ZYEI(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $jkhuN(collection, value, fromIndex) > -1;
}
module.exports = $2c84401faa0612b2$var$includes;

});
parcelRegister("4ZYEI", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $1c8hB = parcelRequire("1c8hB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $3a3be8dd1917bddc$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $3a3be8dd1917bddc$var$isString(value) {
    return typeof value == 'string' || !$1c8hB(value) && $hYEMs(value) && $2OY5s(value) == $3a3be8dd1917bddc$var$stringTag;
}
module.exports = $3a3be8dd1917bddc$var$isString;

});


parcelRegister("fML59", function(module, exports) {

$parcel$export(module.exports, "actions", () => $25fe75f2cbd4ad0a$export$e324594224ef24da);

var $eoHhV = parcelRequire("eoHhV");
const $25fe75f2cbd4ad0a$export$e324594224ef24da = {
    get: $eoHhV.get
};

});
parcelRegister("eoHhV", function(module, exports) {

$parcel$export(module.exports, "get", () => $6126316a064d2715$export$3988ae62b71be9a3);

var $iVIEg = parcelRequire("iVIEg");

var $kkgbD = parcelRequire("kkgbD");

var $8nrDO = parcelRequire("8nrDO");

var $dw98K = parcelRequire("dw98K");
const $6126316a064d2715$export$3988ae62b71be9a3 = (projectId, properties)=>({ getState: getState, setState: setState })=>{
        const currentProperties = getState()[projectId] || {};
        const missingProperties = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(properties, (0, (/*@__PURE__*/$parcel$interopDefault($8nrDO)))(currentProperties));
        missingProperties.length && (0, $dw98K.default)({
            baseUrl: '',
            projectId: projectId,
            properties: missingProperties
        }).then((fetchedProperties)=>{
            const latestProperties = getState()[projectId] || {};
            setState({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [projectId]: {
                    ...latestProperties,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    ...missingProperties.reduce((result, name)=>{
                        const reducedResult = result;
                        const fetchedProperty = fetchedProperties[name];
                        // `undefined` inside state means that property was never requested.
                        // If value returned for the property is `undefined`, we will set it to `null`,
                        // to differentiate it from the unrequested state. Otherwise, returned value will be set.
                        reducedResult[name] = (0, (/*@__PURE__*/$parcel$interopDefault($kkgbD)))(fetchedProperty) ? null : fetchedProperty;
                        return reducedResult;
                    }, {})
                }
            });
        });
    };

});
parcelRegister("iVIEg", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $hKE3p = parcelRequire("hKE3p");

var $9eFtX = parcelRequire("9eFtX");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $dc802f203e524f15$var$difference = $9eFtX(function(array, values) {
    return $cRpul(array) ? $fa0Ox(array, $hKE3p(values, 1, $cRpul, true)) : [];
});
module.exports = $dc802f203e524f15$var$difference;

});
parcelRegister("fa0Ox", function(module, exports) {

var $lYFvJ = parcelRequire("lYFvJ");

var $lqZWH = parcelRequire("lqZWH");

var $6v6uu = parcelRequire("6v6uu");

var $kJvGp = parcelRequire("kJvGp");

var $74vSq = parcelRequire("74vSq");

var $8AO5Q = parcelRequire("8AO5Q");
/** Used as the size to enable large array optimizations. */ var $b0986bd506ee8a3d$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $b0986bd506ee8a3d$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $lqZWH, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $kJvGp(values, $74vSq(iteratee));
    if (comparator) {
        includes = $6v6uu;
        isCommon = false;
    } else if (values.length >= $b0986bd506ee8a3d$var$LARGE_ARRAY_SIZE) {
        includes = $8AO5Q;
        isCommon = false;
        values = new $lYFvJ(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $b0986bd506ee8a3d$var$baseDifference;

});


parcelRegister("dw98K", function(module, exports) {

$parcel$export(module.exports, "default", () => $d933a28077a68115$export$2e2bcd8739ae039);

var $95f8K = parcelRequire("95f8K");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d933a28077a68115$export$2e2bcd8739ae039 = async ({ baseUrl: baseUrl, projectId: projectId, properties: properties })=>{
    const { project: project } = await (0, $95f8K.get)(baseUrl, {
        projectId: projectId,
        projectProperties: properties,
        consumerMeta: {
            id: 'remoteGet',
            packageName: 'jiraProjectPropertiesServices',
            teamName: 'jsd-shield'
        }
    });
    return project;
};

});




parcelRegister("cwfEs", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $e789c0ba11eae82e$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "PACKAGE_TEAM_NAME", () => $e789c0ba11eae82e$export$2b3151a089bc8780);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_CHANNELS_CUSTOMISED", () => $e789c0ba11eae82e$export$190fb6b68393ab0a);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_REQUEST_TYPES_REVIEWED", () => $e789c0ba11eae82e$export$b51e545ada86528a);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_REQUEST_QUEUE_CUSTOMISED", () => $e789c0ba11eae82e$export$2527ae3f75e929d);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_ADD_TEAMMATES", () => $e789c0ba11eae82e$export$ad0f77484b3c614d);
$parcel$export(module.exports, "JSM_GETTING_STARTED_PAGE_NAME", () => $e789c0ba11eae82e$export$649bb2ebeb1bddc7);
$parcel$export(module.exports, "REFERRER", () => $e789c0ba11eae82e$export$adee93c2017009c);
$parcel$export(module.exports, "ERROR_CODE_NOT_FOUND", () => $e789c0ba11eae82e$export$7741797ac345bc17);
$parcel$export(module.exports, "CONTACT_SUPPORT_URL", () => $e789c0ba11eae82e$export$2c16bd1d8b68b11f);
$parcel$export(module.exports, "JSM_DOCUMENTATION_URL", () => $e789c0ba11eae82e$export$3b0c21ad7d48c17f);
$parcel$export(module.exports, "ASK_COMMUNITY_URL", () => $e789c0ba11eae82e$export$eb3a822ca5964b4c);
$parcel$export(module.exports, "SAMPLE_SPACE_URL", () => $e789c0ba11eae82e$export$7d64ff3c41d97984);
$parcel$export(module.exports, "GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_PROD", () => $e789c0ba11eae82e$export$eb8426badfb143b);
$parcel$export(module.exports, "GETTING_STARTED_PAGE_EXCLUDED_PROJECT_TEMPLATES_FOR_ITSM", () => $e789c0ba11eae82e$export$6e4b80733f1b287d);
$parcel$export(module.exports, "JSM_EXCLUDED_TEMPLATES_FOR_NPLE", () => $e789c0ba11eae82e$export$849d996b61162ae5);
$parcel$export(module.exports, "REQUEST_CHANNEL_PORTAL", () => $e789c0ba11eae82e$export$84bc97b21fdd244a);
$parcel$export(module.exports, "REQUEST_CHANNEL_CHAT", () => $e789c0ba11eae82e$export$a45136678da730c);
$parcel$export(module.exports, "REQUEST_CHANNEL_EMAIL", () => $e789c0ba11eae82e$export$4585842137473138);
$parcel$export(module.exports, "REQUEST_TYPES_MAX_ELEMENTS", () => $e789c0ba11eae82e$export$4ff5ead961dddcb6);
$parcel$export(module.exports, "ManageQueuesArticleId", () => $e789c0ba11eae82e$export$337d9a01cb6ca6b9);
$parcel$export(module.exports, "RequestChannelsArticleId", () => $e789c0ba11eae82e$export$14ea17a7011e8003);
$parcel$export(module.exports, "RequestTypesArticleId", () => $e789c0ba11eae82e$export$bf7175403ae935b4);
$parcel$export(module.exports, "ViewIssueArticleId", () => $e789c0ba11eae82e$export$3a62b051817d4794);
$parcel$export(module.exports, "LearnAboutProjectRolesArticleId", () => $e789c0ba11eae82e$export$ef07413132434f74);
$parcel$export(module.exports, "REQUEST_CHANNELS", () => $e789c0ba11eae82e$export$66b0ce7a4d805ff);
$parcel$export(module.exports, "REQUEST_TYPES", () => $e789c0ba11eae82e$export$b1183955728be615);
$parcel$export(module.exports, "INVITE_PROJECT_ADMIN", () => $e789c0ba11eae82e$export$d161473fa359f57a);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_PROD", () => $e789c0ba11eae82e$export$56dfbf0bd0f6a594);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_PROD_ITSM", () => $e789c0ba11eae82e$export$7153e91b542b7f0a);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_INVITE_TEAM_MEMBERS_EXPERIMENT_VARIATION", () => $e789c0ba11eae82e$export$ca4e6740a5c6d1f2);
$parcel$export(module.exports, "NEW_LANDING_PAGE_EXPERIENCE_INVITE_TEAM_MEMBERS_EXPERIMENT_CONTROL", () => $e789c0ba11eae82e$export$27a266f610bac60a);
$parcel$export(module.exports, "DEMO_ISSUE_LABEL", () => $e789c0ba11eae82e$export$fe4edbd608405ae2);
$parcel$export(module.exports, "DEMO_ISSUE_ERROR_FLAG_ID", () => $e789c0ba11eae82e$export$b2f56b9b16e7a5d8);
$parcel$export(module.exports, "DISABLE_NPLE_PROJECT_PROJECT_KEY", () => $e789c0ba11eae82e$export$8b55ba9520951f74);
$parcel$export(module.exports, "DISABLE_NPLE_ERROR_FLAG_ID", () => $e789c0ba11eae82e$export$8ce85ec44321d12);
$parcel$export(module.exports, "DISABLE_NPLE_SUCCESS_FLAG_ID", () => $e789c0ba11eae82e$export$2b5c9784d8cd5f0);
$parcel$export(module.exports, "INCIDENTS", () => $e789c0ba11eae82e$export$a50b49a533b5f7bc);
$parcel$export(module.exports, "CHANGES", () => $e789c0ba11eae82e$export$8598196f74460271);
$parcel$export(module.exports, "ALERTS", () => $e789c0ba11eae82e$export$bc57e9dea1fac017);

var $9CmwD = parcelRequire("9CmwD");
const $e789c0ba11eae82e$export$b8b9d90f9e5bd72b = 'jiraServicedeskGettingStartedPage';
const $e789c0ba11eae82e$export$2b3151a089bc8780 = 'itops-mithril';
const $e789c0ba11eae82e$export$190fb6b68393ab0a = 'servicedesk-getting-started-page-request-channels-customised';
const $e789c0ba11eae82e$export$b51e545ada86528a = 'servicedesk-getting-started-page-request-types-reviewed';
const $e789c0ba11eae82e$export$2527ae3f75e929d = 'servicedesk-getting-started-page-queue-customised';
const $e789c0ba11eae82e$export$ad0f77484b3c614d = 'servicedesk-getting-started-page-invite-team';
const $e789c0ba11eae82e$export$649bb2ebeb1bddc7 = 'servicedesk-getting-started-page';
const $e789c0ba11eae82e$export$f250cf2c117f5561 = 'jsm.it-service-management';
const $e789c0ba11eae82e$export$adee93c2017009c = 'referrer';
const $e789c0ba11eae82e$export$7741797ac345bc17 = 404;
const $e789c0ba11eae82e$export$2c16bd1d8b68b11f = 'https://support.atlassian.com/contact/#/';
const $e789c0ba11eae82e$export$3b0c21ad7d48c17f = 'https://support.atlassian.com/jira-service-management-cloud/docs/get-started-with-jira-service-management/';
const $e789c0ba11eae82e$export$eb3a822ca5964b4c = 'https://community.atlassian.com/t5/Jira-Service-Management/Welcome-to-Jira-Service-Management/m-p/2690403?utm_source=community&utm_medium=inapp&utm_campaign=P:jira-service-management%7CO:community%7CC:community%7CW:jsmlp%7CH:05/07/2024%7CI:onboarding%7C';
const $e789c0ba11eae82e$export$7d64ff3c41d97984 = '/jira/servicedesk/itsm-sample-space';
const $e789c0ba11eae82e$export$eb8426badfb143b = [
    (0, $9CmwD.IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY),
    (0, $9CmwD.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY)
];
const $e789c0ba11eae82e$export$6e4b80733f1b287d = [
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY)
];
const $e789c0ba11eae82e$export$849d996b61162ae5 = [
    $e789c0ba11eae82e$export$f250cf2c117f5561,
    (0, $9CmwD.IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY),
    (0, $9CmwD.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY),
    (0, $9CmwD.BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY)
];
const $e789c0ba11eae82e$export$84bc97b21fdd244a = 'Portal';
const $e789c0ba11eae82e$export$a45136678da730c = 'Chat';
const $e789c0ba11eae82e$export$4585842137473138 = 'Email';
const $e789c0ba11eae82e$export$4ff5ead961dddcb6 = 4;
const $e789c0ba11eae82e$export$337d9a01cb6ca6b9 = '5b7BuVaVJqmbyCZ2mbMYHD';
const $e789c0ba11eae82e$export$4427f2578322b0c1 = '3cdZ1Fc5T12gySP1kroJJr';
const $e789c0ba11eae82e$export$14ea17a7011e8003 = '3v4bqtuzeA4dOJq6A4yhiM';
const $e789c0ba11eae82e$export$bf7175403ae935b4 = 'eYQImfQnsXgIvrECKaQTF';
const $e789c0ba11eae82e$export$3a62b051817d4794 = '102lbF25oEeqn7GG1rXPUA';
const $e789c0ba11eae82e$export$ef07413132434f74 = '6aIMqm2F5KAhHo3BbFYp0p';
const $e789c0ba11eae82e$export$66b0ce7a4d805ff = 'RequestChannel';
const $e789c0ba11eae82e$export$b1183955728be615 = 'RequestTypes';
const $e789c0ba11eae82e$export$5b2e9a43da487c8d = 'InviteTeam';
const $e789c0ba11eae82e$export$82cf56f84f36683f = 'ManageQueues';
const $e789c0ba11eae82e$export$d161473fa359f57a = 'InviteProjectAdmin';
const $e789c0ba11eae82e$export$56dfbf0bd0f6a594 = 'newLandingPageExperienceProd';
const $e789c0ba11eae82e$export$7153e91b542b7f0a = 'newLandingPageExperienceProdITSM';
const $e789c0ba11eae82e$export$ca4e6740a5c6d1f2 = 'newLandingPageExperienceInviteTeamMemberExperimentVariation';
const $e789c0ba11eae82e$export$27a266f610bac60a = 'newLandingPageExperienceInviteTeamMemberExperimentControl';
const $e789c0ba11eae82e$export$be01cbdafda7d87f = 'rejected';
const $e789c0ba11eae82e$export$fe4edbd608405ae2 = 'onboarding-learn-by-doing-demo-issue';
const $e789c0ba11eae82e$export$b2f56b9b16e7a5d8 = 'onboarding-sample-issue-error';
const $e789c0ba11eae82e$export$8b55ba9520951f74 = 'npleDisabled';
const $e789c0ba11eae82e$export$8ce85ec44321d12 = 'disable-nple-error';
const $e789c0ba11eae82e$export$2b5c9784d8cd5f0 = 'disable-nple-success';
const $e789c0ba11eae82e$export$a50b49a533b5f7bc = 'incidents';
const $e789c0ba11eae82e$export$8598196f74460271 = 'changes';
const $e789c0ba11eae82e$export$bc57e9dea1fac017 = 'alerts';

});

parcelRegister("2wBzW", function(module, exports) {

$parcel$export(module.exports, "useFirstProjectDetails", () => $dc9ff023e450a76d$export$a2dd21ca7232bc34);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");


var $gd0Sp = parcelRequire("gd0Sp");

var $3tjIy = parcelRequire("3tjIy");
const $dc9ff023e450a76d$var$initialState = {
    error: false,
    firstProject: undefined
};
const $dc9ff023e450a76d$var$setError = (error)=>({ setState: setState })=>{
        setState({
            error: error
        });
    };
const $dc9ff023e450a76d$var$setFirstProject = (firstProject)=>({ setState: setState })=>{
        setState({
            firstProject: firstProject
        });
    };
const $dc9ff023e450a76d$export$e324594224ef24da = {
    setError: $dc9ff023e450a76d$var$setError,
    setFirstProject: $dc9ff023e450a76d$var$setFirstProject
};
const $dc9ff023e450a76d$var$store = (0, $WBLbN.createStore)({
    name: 'getting-started-page-is-first-project',
    initialState: $dc9ff023e450a76d$var$initialState,
    actions: $dc9ff023e450a76d$export$e324594224ef24da
});
const $dc9ff023e450a76d$export$a47f6b1a99a5e57f = (0, $WBLbN.createHook)($dc9ff023e450a76d$var$store);
const $dc9ff023e450a76d$export$a2dd21ca7232bc34 = ()=>{
    const [data, { setError: setErrorState, setFirstProject: setFirstProjectDetails }] = $dc9ff023e450a76d$export$a47f6b1a99a5e57f();
    const { licensedProducts: licensedProducts } = (0, $gd0Sp.useTenantContext)() || {};
    const hasJsmLicense = licensedProducts && licensedProducts[0, $2edfd53057852e41$export$c8c1c8c3f8ddba61];
    (0, $eUqFw.useEffect)(()=>{
        if (!hasJsmLicense || data.firstProject || data.error) return;
        (0, $3tjIy.getFirstProject)().then((response)=>{
            setFirstProjectDetails(response);
        }).catch(()=>{
            setErrorState(true);
        });
    }, [
        hasJsmLicense,
        setErrorState,
        setFirstProjectDetails,
        data.firstProject,
        data.error
    ]);
    return data;
};

});
const $2edfd53057852e41$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $2edfd53057852e41$export$e9c56aa3b027d98f = 'jira-customer-service';
const $2edfd53057852e41$export$1346c9aa3cbb477d = 'jira-software';
const $2edfd53057852e41$export$202f50ee62667e32 = 'jira-product-discovery';
const $2edfd53057852e41$export$db515c8cec1e6f79 = 'jira-core';
const $2edfd53057852e41$export$c811f21c9ad05dc2 = 'confluence';
const $2edfd53057852e41$export$961148c98d198270 = 'opsgenie';

parcelRegister("3tjIy", function(module, exports) {

$parcel$export(module.exports, "getFirstProject", () => $1416e82639659d77$export$197802963901b2fb);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $cwfEs = parcelRequire("cwfEs");
const $1416e82639659d77$export$197802963901b2fb = async ()=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)('/rest/servicedesk/latest/xflow/getFirstProject?type=service_desk');
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode !== 404) (0, $guiFP.default)({
            meta: {
                id: 'getFirstProject',
                packageName: (0, $cwfEs.PACKAGE_NAME),
                teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("9qZHX", function(module, exports) {

$parcel$export(module.exports, "initialiseLandingPageState", () => $37d0166180f1cc09$export$afc4bcbfce806408);
$parcel$export(module.exports, "getLandingPageState", () => $37d0166180f1cc09$export$43654a89c1df0019);
$parcel$export(module.exports, "updateLandingPageStateProperties", () => $37d0166180f1cc09$export$2dede61295d6c46);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $cwfEs = parcelRequire("cwfEs");
const $37d0166180f1cc09$export$afc4bcbfce806408 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async ()=>{
        try {
            await (0, $lRmyA.performPostRequest)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page`);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                actionSubject: 'State',
                action: 'initialised'
            }), 'jiraServicedeskGettingStartedPage.State initialised');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'State',
                    packageName: (0, $cwfEs.PACKAGE_NAME),
                    teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
const $37d0166180f1cc09$export$43654a89c1df0019 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async ()=>{
        try {
            const response = await (0, $lRmyA.performGetRequestWithRetry)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page`);
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'State',
                action: 'fetched'
            }), 'jiraServicedeskGettingStartedPage.State fetched');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'State',
                    packageName: (0, $cwfEs.PACKAGE_NAME),
                    teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
const $37d0166180f1cc09$export$2dede61295d6c46 = ({ projectId: projectId, baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>async (properties)=>{
        const sectionStateString = JSON.stringify(properties);
        try {
            await (0, $lRmyA.performPostRequest)(`${baseUrl}/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/project/${projectId}/list/jsm-getting-started-page/properties`, {
                body: JSON.stringify({
                    sectionState: sectionStateString
                })
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({
                actionSubject: 'Properties',
                action: 'updated'
            }), 'jiraServicedeskGettingStartedPage.Properties updated', {
                property: properties
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'Properties',
                    packageName: (0, $cwfEs.PACKAGE_NAME),
                    teamName: (0, $cwfEs.PACKAGE_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };

});


parcelRegister("dWvpo", function(module, exports) {

$parcel$export(module.exports, "useOpsTeamMode", () => $f367f2772b7579d7$export$97247be508d7d058);
$parcel$export(module.exports, "useGettingStartedPanelState", () => $f367f2772b7579d7$export$50f195e39d82318);
$parcel$export(module.exports, "useGettingStartedPanelActions", () => $f367f2772b7579d7$export$bb089b373d239cdd);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $WBLbN = parcelRequire("WBLbN");

var $bFzGY = parcelRequire("bFzGY");

var $h4Fhh = parcelRequire("h4Fhh");

var $SEaoU = parcelRequire("SEaoU");

var $8XpKd = parcelRequire("8XpKd");
var $5Yzlw = parcelRequire("5Yzlw");

var $IsF0v = parcelRequire("IsF0v");

var $lhDSB = parcelRequire("lhDSB");

var $gEZA0 = parcelRequire("gEZA0");

var $6vrw7 = parcelRequire("6vrw7");

var $gd0Sp = parcelRequire("gd0Sp");

var $8u09c = parcelRequire("8u09c");

var $dIgUk = parcelRequire("dIgUk");
const $f367f2772b7579d7$var$initialState = {
    data: undefined,
    isGspInitialized: true,
    isSaving: false,
    shouldRecordPerformanceExperiences: true
};
const $f367f2772b7579d7$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'GettingStartedPanelState',
    initialState: $f367f2772b7579d7$var$initialState,
    actions: (0, $dIgUk.actions)
});
const $f367f2772b7579d7$var$useGettingStartedPanelStoreState = (0, $WBLbN.createHook)($f367f2772b7579d7$export$6f57813fe9f31bf9, {
    selector: ({ data: data, isGspInitialized: isGspInitialized, shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences })=>{
        const canRender = isGspInitialized && data?.properties.user.activeState === (0, $8u09c.ActiveState).On;
        const canRenderPanel = canRender && data?.properties.user.visualState === (0, $8u09c.VisualState).FullPanel;
        const canRenderOpenButton = canRender && data?.properties.user.visualState === (0, $8u09c.VisualState).Lozenge;
        const canRenderReopenButton = isGspInitialized && data?.properties.user.activeState === (0, $8u09c.ActiveState).Off;
        const canRenderReopenSpotlight = canRenderReopenButton && data?.properties.user.hasSeenReopenSpotlight === (0, $8u09c.HasSeenReopenSpotlight).No;
        const canPollPanelState = data?.properties.user.activeState === (0, $8u09c.ActiveState).On;
        return {
            data: data,
            canRenderPanel: canRenderPanel,
            canRenderOpenButton: canRenderOpenButton,
            canRenderReopenButton: canRenderReopenButton,
            canRenderReopenSpotlight: canRenderReopenSpotlight,
            canPollPanelState: canPollPanelState,
            shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences
        };
    }
});
const $f367f2772b7579d7$var$useGettingStartedPanelStoreActions = (0, $WBLbN.createHook)($f367f2772b7579d7$export$6f57813fe9f31bf9, {
    selector: null
});
/**
 * Hook returns if FSF tour is seen
 */ const $f367f2772b7579d7$var$useIsProjectTourSeen = ()=>{
    const [{ data: data, isLoading: isLoading, error: error }, { getTourState: getTourState }] = (0, $lhDSB.useTourState)();
    const isError = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(error);
    const hasData = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(data);
    (0, $eUqFw.useEffect)(()=>{
        if (!hasData && !isLoading && !isError) getTourState();
    }, [
        hasData,
        isLoading,
        isError,
        getTourState
    ]);
    return data?.seenProjectTour === (0, $ef7033652bab160b$export$e47bc222770d5cfd);
};
/**
 * Hook returns if ITSM sample project
 */ const $f367f2772b7579d7$var$useIsSampleProject = ()=>{
    const { data: isItsmSampleProject } = (0, $gEZA0.useIsItsmSampleProject)();
    const [{ data: containerContext }] = (0, $SEaoU.useContainerContext)();
    if (isItsmSampleProject != null) return isItsmSampleProject;
    /*
    When isItsmSampleProject is null or undefined - return null/undefined, but only if we are in project context
    (this is to identify that this var has not been initialized yet, see isItsmSampleProject usages, where we check for null/isNil);
    return false otherwise
 */ return containerContext?.contextType === 'project' ? isItsmSampleProject : false;
};
const $f367f2772b7579d7$export$2486eddc1a0bc021 = ()=>{
    const { data: isItsmProject } = (0, $IsF0v.useIsItsmTemplateProject)();
    const [{ data: containerContext }] = (0, $SEaoU.useContainerContext)();
    const projectId = containerContext?.contextType === 'project' && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(containerContext.project) ? (0, $6vrw7.toProjectId)(String(containerContext.project.id)) : undefined;
    return {
        isItsmProject: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(projectId) && isItsmProject === true,
        projectId: projectId
    };
};
const $f367f2772b7579d7$export$97247be508d7d058 = ()=>{
    const [{ location: { pathname: pathname } }] = (0, $5Yzlw.useRouter)();
    const { shouldUseJSM: shouldUseJSM } = (0, $h4Fhh.useOgTenantInfo)();
    const isOpsPage = pathname.startsWith('/jira/ops/teams/');
    const [teamId] = (0, $8XpKd.usePathParam)('teamId');
    const enableOpsTeamMode = isOpsPage && teamId !== undefined && !!shouldUseJSM;
    return {
        teamId: teamId,
        enableOpsTeamMode: enableOpsTeamMode
    };
};
const $f367f2772b7579d7$export$678a38a9dc2d3a0 = ()=>{
    const { isItsmProject: isItsmProject } = $f367f2772b7579d7$export$2486eddc1a0bc021();
    const { shouldUseJSM: shouldUseJSM } = (0, $h4Fhh.useOgTenantInfo)();
    const enableUserCentricMode = isItsmProject && !!shouldUseJSM;
    return enableUserCentricMode;
};
const $f367f2772b7579d7$var$useActionsMemo = ({ baseUrl: baseUrl, cloudId: cloudId, accountId: accountId, initializeState: initializeState, reopenGettingStartedPanel: reopenGettingStartedPanel, markReopenSpotlightAsSeen: markReopenSpotlightAsSeen, fetchState: fetchState, savePanelState: savePanelState, resolveTask: resolveTask, saveProperty: saveProperty, stopRecordingPerformanceExperiences: stopRecordingPerformanceExperiences, setOpsAdminTaskVisibility: setOpsAdminTaskVisibility })=>{
    const gatewayBaseUrl = (0, $6vrw7.toBaseUrl)(`${baseUrl}/gateway/api`);
    const isItsmSampleProject = $f367f2772b7579d7$var$useIsSampleProject();
    const { isItsmProject: isItsmProject, projectId: projectId } = $f367f2772b7579d7$export$2486eddc1a0bc021();
    const isProjectTourSeen = $f367f2772b7579d7$var$useIsProjectTourSeen();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { teamId: teamId, enableOpsTeamMode: enableOpsTeamMode } = $f367f2772b7579d7$export$97247be508d7d058();
    const enableUserCentricMode = $f367f2772b7579d7$export$678a38a9dc2d3a0();
    return (0, $eUqFw.useMemo)(()=>{
        const actionProps = {
            createAnalyticsEvent: createAnalyticsEvent,
            baseUrl: gatewayBaseUrl,
            cloudId: cloudId,
            accountId: accountId,
            isItsmSampleProject: isItsmSampleProject,
            isProjectTourSeen: isProjectTourSeen,
            isItsmProject: isItsmProject,
            projectId: projectId,
            ...enableOpsTeamMode && {
                teamId: teamId,
                enableOpsTeamMode: enableOpsTeamMode
            },
            ...enableUserCentricMode && {
                enableUserCentricMode: enableUserCentricMode
            }
        };
        return {
            initializeState: initializeState(actionProps),
            reopenGettingStartedPanel: reopenGettingStartedPanel(actionProps),
            markReopenSpotlightAsSeen: markReopenSpotlightAsSeen(actionProps),
            fetchState: fetchState(actionProps),
            savePanelState: savePanelState(actionProps),
            resolveTask: resolveTask(actionProps),
            saveProperty: saveProperty(actionProps),
            stopRecordingPerformanceExperiences: stopRecordingPerformanceExperiences(),
            setOpsAdminTaskVisibility: setOpsAdminTaskVisibility(actionProps)
        };
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        cloudId,
        accountId,
        isItsmSampleProject,
        isProjectTourSeen,
        isItsmProject,
        projectId,
        enableOpsTeamMode,
        teamId,
        enableUserCentricMode,
        initializeState,
        reopenGettingStartedPanel,
        markReopenSpotlightAsSeen,
        fetchState,
        savePanelState,
        resolveTask,
        saveProperty,
        stopRecordingPerformanceExperiences,
        setOpsAdminTaskVisibility
    ]);
};
const $f367f2772b7579d7$var$useStateMemo = ({ data: data, canRenderPanel: canRenderPanel, canRenderOpenButton: canRenderOpenButton, canRenderReopenButton: canRenderReopenButton, canRenderReopenSpotlight: canRenderReopenSpotlight, canPollPanelState: canPollPanelState, shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences })=>(0, $eUqFw.useMemo)(()=>({
            data: data,
            canRenderPanel: canRenderPanel,
            canRenderOpenButton: canRenderOpenButton,
            canRenderReopenButton: canRenderReopenButton,
            canRenderReopenSpotlight: canRenderReopenSpotlight,
            canPollPanelState: canPollPanelState,
            shouldRecordPerformanceExperiences: shouldRecordPerformanceExperiences
        }), [
        data,
        canRenderPanel,
        canRenderOpenButton,
        canRenderReopenButton,
        canRenderReopenSpotlight,
        canPollPanelState,
        shouldRecordPerformanceExperiences
    ]);
const $f367f2772b7579d7$export$50f195e39d82318 = ()=>{
    const { cloudId: cloudId, atlassianAccountId: accountId, baseUrl: baseUrl } = (0, $gd0Sp.useTenantContext)();
    const [state, actions] = $f367f2772b7579d7$var$useGettingStartedPanelStoreState();
    const memoizedActions = $f367f2772b7579d7$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl,
        cloudId: cloudId,
        accountId: accountId
    });
    const memoizedState = $f367f2772b7579d7$var$useStateMemo(state);
    return (0, $eUqFw.useMemo)(()=>[
            memoizedState,
            memoizedActions
        ], [
        memoizedActions,
        memoizedState
    ]);
};
const $f367f2772b7579d7$export$bb089b373d239cdd = ()=>{
    const { cloudId: cloudId, atlassianAccountId: accountId, baseUrl: baseUrl } = (0, $gd0Sp.useTenantContext)();
    const [, actions] = $f367f2772b7579d7$var$useGettingStartedPanelStoreActions();
    const memoizedActions = $f367f2772b7579d7$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl,
        cloudId: cloudId,
        accountId: accountId
    });
    return (0, $eUqFw.useMemo)(()=>[
            undefined,
            memoizedActions
        ], [
        memoizedActions
    ]);
};

});
parcelRegister("IsF0v", function(module, exports) {

$parcel$export(module.exports, "useIsItsmTemplateProject", () => $07a4c10d5645b4e2$export$7bb46948fb84f164);

var $eUqFw = parcelRequire("eUqFw");

var $8LJqN = parcelRequire("8LJqN");

var $eI5EY = parcelRequire("eI5EY");

var $iZJHG = parcelRequire("iZJHG");

var $6xFTe = parcelRequire("6xFTe");
var $h5RgW = parcelRequire("h5RgW");

var $8hg3R = parcelRequire("8hg3R");


const $07a4c10d5645b4e2$var$getDataLoader = ()=>(parcelRequire("4s5wr"));
const $07a4c10d5645b4e2$var$ONE_DAY_IN_MILLIS = 86400000;
const $07a4c10d5645b4e2$export$920308cef4e291b1 = (0, $6xFTe.createResource)({
    type: (0, $f57291778ecbd978$export$543a8644640f4092),
    getKey: ({ match: match })=>(0, $8hg3R.getProjectKeyOrId)(match),
    getDataLoader: $07a4c10d5645b4e2$var$getDataLoader,
    maxAge: $07a4c10d5645b4e2$var$ONE_DAY_IN_MILLIS
});
const $07a4c10d5645b4e2$var$useIsItsmTemplateProjectNew = (projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $iZJHG.useResourceWithCustomRouterContext)($07a4c10d5645b4e2$export$920308cef4e291b1, projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    return (0, $eUqFw.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};
const $07a4c10d5645b4e2$var$useIsItsmTemplateProjectOld = (_)=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $h5RgW.useResource)($07a4c10d5645b4e2$export$920308cef4e291b1);
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if ((data === null || data === undefined) && !loading && !error) refresh();
    }, [
        data,
        loading,
        error,
        refresh
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: data,
            loading: loading,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error
        }), [
        data,
        loading,
        error
    ]);
};
const $07a4c10d5645b4e2$export$7bb46948fb84f164 = (0, $8LJqN.functionWithCondition)(()=>(0, $eI5EY.fg)('fix_useinitresource_data_bug'), $07a4c10d5645b4e2$var$useIsItsmTemplateProjectNew, $07a4c10d5645b4e2$var$useIsItsmTemplateProjectOld);

});
const $f57291778ecbd978$export$543a8644640f4092 = 'SERVICEDESK_IS_ITSM_PROJECT';

parcelRegister("4s5wr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iNHzY');
        const value = parcelRequire('hQH0C');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iNHzY").then(()=>parcelRequire('hQH0C'));
}

});


const $ef7033652bab160b$export$17227441e89ee693 = 'INITIAL';
const $ef7033652bab160b$export$23324e66dcb20cea = 'NOTSEEN';
const $ef7033652bab160b$export$e47bc222770d5cfd = 'SEEN';
const $ef7033652bab160b$export$103bedf43ba882db = 'ERROR';
const $ef7033652bab160b$export$b8b9d90f9e5bd72b = 'jiraServicedeskItsmFirstSessionFlow';
const $ef7033652bab160b$export$d57b6b390e78d90f = 'itops-mithril';

parcelRegister("lhDSB", function(module, exports) {

$parcel$export(module.exports, "useTourState", () => $3c47e23fdd4320f6$export$4aecabf781c5d857);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");

var $6vrw7 = parcelRequire("6vrw7");

var $d2tO7 = parcelRequire("d2tO7");
const $3c47e23fdd4320f6$export$d4c72bab9d6cc13a = {
    data: undefined,
    isLoading: false,
    error: undefined
};
const $3c47e23fdd4320f6$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'ItsmFirstSessionFlowTourState',
    initialState: $3c47e23fdd4320f6$export$d4c72bab9d6cc13a,
    actions: (0, $d2tO7.actions)
});
const $3c47e23fdd4320f6$var$useStore = (0, $WBLbN.createHook)($3c47e23fdd4320f6$export$6f57813fe9f31bf9);
// @ts-expect-error - TS7031 - Binding element 'baseUrl' implicitly has an 'any' type. | TS7031 - Binding element 'getTourState' implicitly has an 'any' type. | TS7031 - Binding element 'setTourState' implicitly has an 'any' type.
const $3c47e23fdd4320f6$var$useActionsMemo = ({ baseUrl: baseUrl, getTourState: getTourState, setTourState: setTourState })=>(0, $eUqFw.useMemo)(()=>({
            getTourState: getTourState({
                baseUrl: baseUrl
            }),
            setTourState: setTourState({
                baseUrl: baseUrl
            })
        }), [
        baseUrl,
        getTourState,
        setTourState
    ]);
const $3c47e23fdd4320f6$var$useStateMemo = ({ data: data, isLoading: isLoading, error: error })=>(0, $eUqFw.useMemo)(()=>({
            data: data,
            isLoading: isLoading,
            error: error
        }), [
        data,
        isLoading,
        error
    ]);
const $3c47e23fdd4320f6$export$4aecabf781c5d857 = ()=>{
    const baseUrl = (0, $6vrw7.toBaseUrl)('');
    const [state, actions] = $3c47e23fdd4320f6$var$useStore();
    const memoizedActions = $3c47e23fdd4320f6$var$useActionsMemo({
        ...actions,
        baseUrl: baseUrl
    });
    const memoizedState = $3c47e23fdd4320f6$var$useStateMemo(state);
    return (0, $eUqFw.useMemo)(()=>[
            memoizedState,
            memoizedActions
        ], [
        memoizedActions,
        memoizedState
    ]);
};

});
parcelRegister("d2tO7", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5324b94d76febd17$export$e324594224ef24da);

var $eU696 = parcelRequire("eU696");

var $dv6lu = parcelRequire("dv6lu");
const $5324b94d76febd17$export$e324594224ef24da = {
    getTourState: $eU696.getTourState,
    setTourState: $dv6lu.setTourState
};

});
parcelRegister("eU696", function(module, exports) {

$parcel$export(module.exports, "getTourState", () => $4c66438699410e17$export$a758fd93ae41dde5);

var $fVqUX = parcelRequire("fVqUX");

var $guiFP = parcelRequire("guiFP");

var $JRB5w = parcelRequire("JRB5w");

var $7EhAs = parcelRequire("7EhAs");

var $6vrw7 = parcelRequire("6vrw7");

const $4c66438699410e17$var$getUrl = (baseUrl)=>`${baseUrl}/rest/servicedesk/onboarding/latest/fsf`;
const $4c66438699410e17$var$fetchTourState = async (baseUrl)=>{
    const url = $4c66438699410e17$var$getUrl(baseUrl);
    const response = await fetch(url, (0, $fVqUX.default));
    if (!response.ok) {
        const text = await response.text();
        const error = new (0, $7EhAs.default)(response.status, text);
        // Still throw the error even if it's a client fetch error,
        // so we get the error path in the handling code.
        // We only want to skip analytics firing.
        if (!(0, $JRB5w.isClientFetchError)(error)) (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getTourState_responseNotOK',
                packageName: (0, $ef7033652bab160b$export$b8b9d90f9e5bd72b),
                teamName: (0, $ef7033652bab160b$export$d57b6b390e78d90f)
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
    return response.json();
};
const $4c66438699410e17$export$a758fd93ae41dde5 = ({ baseUrl: baseUrl })=>({ getState: getState, setState: setState })=>async ()=>{
            const { data: data, isLoading: isLoading } = getState();
            if (data || isLoading) return;
            setState({
                error: undefined,
                isLoading: true
            });
            try {
                const result = await $4c66438699410e17$var$fetchTourState(baseUrl);
                const { seenProjectTour: seenProjectTour, projectId: projectId } = result;
                setState({
                    data: {
                        seenProjectTour: seenProjectTour,
                        projectId: projectId === null ? null : (0, $6vrw7.toProjectId)(projectId)
                    },
                    isLoading: false
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (!(0, $JRB5w.isClientFetchError)(error)) (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'getTourState',
                        packageName: (0, $ef7033652bab160b$export$b8b9d90f9e5bd72b),
                        teamName: (0, $ef7033652bab160b$export$d57b6b390e78d90f)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    error: error,
                    isLoading: false
                });
                if (!(0, $JRB5w.isClientFetchError)(error)) throw error;
            }
        };

});

parcelRegister("dv6lu", function(module, exports) {

$parcel$export(module.exports, "setTourState", () => $106ad4ed6da8c60b$export$35f9649c739aaca3);

var $fVqUX = parcelRequire("fVqUX");

var $guiFP = parcelRequire("guiFP");

var $7EhAs = parcelRequire("7EhAs");

const $106ad4ed6da8c60b$var$getUrl = (baseUrl)=>`${baseUrl}/rest/servicedesk/onboarding/latest/fsf`;
const $106ad4ed6da8c60b$var$putTourState = async (baseUrl, tourState)=>{
    const url = $106ad4ed6da8c60b$var$getUrl(baseUrl);
    const response = await fetch(url, {
        ...(0, $fVqUX.default),
        method: 'PUT',
        body: JSON.stringify(tourState)
    });
    if (!response.ok) {
        const text = await response.text();
        const error = new (0, $7EhAs.default)(response.status, text);
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'setTourState_responseNotOK',
                packageName: (0, $ef7033652bab160b$export$b8b9d90f9e5bd72b),
                teamName: (0, $ef7033652bab160b$export$d57b6b390e78d90f)
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $106ad4ed6da8c60b$export$35f9649c739aaca3 = ({ baseUrl: baseUrl })=>({ setState: setState })=>// @ts-expect-error - TS2322 - Type 'SetTourState' is not assignable to type 'void | Promise<void>'.
        async (tourState)=>{
            setState({
                error: undefined,
                data: tourState,
                isLoading: true
            });
            try {
                await $106ad4ed6da8c60b$var$putTourState(baseUrl, tourState);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'setTourState',
                        packageName: (0, $ef7033652bab160b$export$b8b9d90f9e5bd72b),
                        teamName: (0, $ef7033652bab160b$export$d57b6b390e78d90f)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    error: error
                });
                throw error;
            } finally{
                setState({
                    isLoading: false
                });
            }
        };

});



parcelRegister("gEZA0", function(module, exports) {

$parcel$export(module.exports, "useIsItsmSampleProject", () => $d550131522ea0515$export$b8afdaba4bd6f483);

var $ldoFd = parcelRequire("ldoFd");

var $IsF0v = parcelRequire("IsF0v");

var $f7V0E = parcelRequire("f7V0E");
const $d550131522ea0515$export$b8afdaba4bd6f483 = ()=>{
    const { data: isDemoProject, loading: loadingIsDemoProject, error: errorIsDemoProject } = (0, $f7V0E.useIsDemoProject)();
    const { data: isItsmProject, loading: loadingIsItsmProject, error: errorIsItsmProject } = (0, $IsF0v.useIsItsmTemplateProject)();
    return {
        data: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isDemoProject) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isItsmProject) ? isDemoProject === true && isItsmProject === true : null,
        loading: loadingIsDemoProject || loadingIsItsmProject,
        error: errorIsDemoProject || errorIsItsmProject
    };
};

});
parcelRegister("f7V0E", function(module, exports) {

$parcel$export(module.exports, "useIsDemoProject", () => $8aa166fc00256124$export$9b4078600f2ad4d2);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $WBLbN = parcelRequire("WBLbN");

var $SEaoU = parcelRequire("SEaoU");

var $6vrw7 = parcelRequire("6vrw7");

var $7kN7I = parcelRequire("7kN7I");

var $au7K4 = parcelRequire("au7K4");
const $8aa166fc00256124$export$d4c72bab9d6cc13a = {};
const $8aa166fc00256124$export$bf108b10a3a0ab90 = (0, $WBLbN.createStore)({
    name: 'IsDemoProject',
    initialState: $8aa166fc00256124$export$d4c72bab9d6cc13a,
    actions: (0, $7kN7I.actions)
});
const $8aa166fc00256124$var$useIsDemoProjectStore = (0, $WBLbN.createHook)($8aa166fc00256124$export$bf108b10a3a0ab90);
// @ts-expect-error - TS7031 - Binding element 'data' implicitly has an 'any' type. | TS7031 - Binding element 'loading' implicitly has an 'any' type. | TS7031 - Binding element 'error' implicitly has an 'any' type.
const $8aa166fc00256124$var$useStateMemo = ({ data: data, loading: loading, error: error })=>(0, $eUqFw.useMemo)(()=>({
            data: data,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
const $8aa166fc00256124$export$9b4078600f2ad4d2 = ()=>{
    const [{ data: contextData }] = (0, $SEaoU.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'. | TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const numProjectId = contextData && contextData.project && contextData.project.id;
    const projectId = (0, $6vrw7.toProjectId)(String(numProjectId));
    const baseUrl = (0, $6vrw7.toBaseUrl)('');
    const [state, { fetchIsDemoProject: fetchIsDemoProject }] = $8aa166fc00256124$var$useIsDemoProjectStore();
    const memoizedState = $8aa166fc00256124$var$useStateMemo({
        ...state[projectId] ?? (0, $au7K4.initialIsDemoProjectState)
    });
    const { data: data } = memoizedState;
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(numProjectId) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(data)) // @ts-expect-error - TS2349 - This expression is not callable.
        fetchIsDemoProject({
            baseUrl: baseUrl,
            projectId: projectId
        })();
    }, [
        fetchIsDemoProject,
        baseUrl,
        numProjectId,
        projectId,
        data
    ]);
    return memoizedState;
};

});
parcelRegister("7kN7I", function(module, exports) {

$parcel$export(module.exports, "actions", () => $284bc3e2d216ef40$export$e324594224ef24da);

var $eQBT8 = parcelRequire("eQBT8");
const $284bc3e2d216ef40$export$e324594224ef24da = {
    fetchIsDemoProject: $eQBT8.fetchIsDemoProject
};

});
parcelRegister("eQBT8", function(module, exports) {

$parcel$export(module.exports, "fetchIsDemoProject", () => $5aa4af5bc33ec272$export$feaee63a215b34da);

var $ldoFd = parcelRequire("ldoFd");

var $iUq1J = parcelRequire("iUq1J");

var $au7K4 = parcelRequire("au7K4");
const $5aa4af5bc33ec272$export$feaee63a215b34da = ({ baseUrl: baseUrl, projectId: projectId })=>// @ts-expect-error - TS2322 - Type '({ getState, setState }: StoreActionApi<Partial<Record<string, DataState<boolean>>>>) => () => Promise<void>' is not assignable to type 'Action<Partial<Record<string, DataState<boolean>>>, void, void | Promise<void>>'.
    ({ getState: getState, setState: setState })=>async ()=>{
            const projectState = getState()[projectId] ?? (0, $au7K4.initialIsDemoProjectState);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(projectState.data) || projectState.loading) return;
            setState({
                ...getState(),
                [String(projectId)]: {
                    ...projectState,
                    loading: true
                }
            });
            try {
                const isDemo = await (0, $iUq1J.isDemoProject)({
                    baseUrl: baseUrl,
                    projectId: projectId
                });
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        data: isDemo,
                        error: null,
                        loading: false
                    }
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    ...getState(),
                    [String(projectId)]: {
                        ...projectState,
                        error: error,
                        loading: false
                    }
                });
                throw error;
            }
        };

});
parcelRegister("iUq1J", function(module, exports) {

$parcel$export(module.exports, "isDemoProject", () => $e1be306bebb9e883$export$cf7813449d38d4ac);
$parcel$export(module.exports, "getItsmSampleProject", () => $e1be306bebb9e883$export$c498e29d716efe7a);

var $lRmyA = parcelRequire("lRmyA");
const $e1be306bebb9e883$export$cf7813449d38d4ac = async ({ baseUrl: baseUrl, projectId: projectId })=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)(`${baseUrl}/rest/api/3/project/${projectId}/properties/isDemo`);
        return !!response && !!response.value;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) /**
			 * Expected when project property is not found.
			 * Demo project has project property "isDemo = true",
			 * otherwise property does not exist
			 * and response status will be 404
			 */ return false;
        throw error;
    }
};
const $e1be306bebb9e883$export$c498e29d716efe7a = async ({ baseUrl: baseUrl })=>{
    try {
        const response = await (0, $lRmyA.performGetRequest)(`${baseUrl}/rest/servicedesk/onboarding/1/itsm/sample-project`);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 404) return undefined;
        throw error;
    }
};

});

parcelRegister("au7K4", function(module, exports) {

$parcel$export(module.exports, "initialIsDemoProjectState", () => $099e9baa7e7daa22$export$f6365b0f25aeae62);
const $099e9baa7e7daa22$export$f6365b0f25aeae62 = {
    data: null,
    loading: false,
    error: null
};

});





parcelRegister("8u09c", function(module, exports) {

$parcel$export(module.exports, "ActiveState", () => $07b01345748f10fb$export$2f27df41e8b7edbb);
$parcel$export(module.exports, "VisualState", () => $07b01345748f10fb$export$285eeaa5f468cfb6);
$parcel$export(module.exports, "Product", () => $07b01345748f10fb$export$264ad599d7cef668);
$parcel$export(module.exports, "Environment", () => $07b01345748f10fb$export$7dc6752a22ab011a);
$parcel$export(module.exports, "GspSectionKey", () => $07b01345748f10fb$export$f4906a03a7a2d0af);
$parcel$export(module.exports, "ChecklistTabKey", () => $07b01345748f10fb$export$4f1a05ccc35315c6);
$parcel$export(module.exports, "ProductTourKey", () => $07b01345748f10fb$export$aa90cbc80c330872);
$parcel$export(module.exports, "HeaderState", () => $07b01345748f10fb$export$38aab4015a34ead);
$parcel$export(module.exports, "TaskId", () => $07b01345748f10fb$export$10cc267f702fbadd);
$parcel$export(module.exports, "BasicsTaskIdsProductionised", () => $07b01345748f10fb$export$fe6666d729b0d637);
$parcel$export(module.exports, "TeamEfficiencyTaskIds", () => $07b01345748f10fb$export$ed4dcaac45c6a484);
$parcel$export(module.exports, "ChangesTaskIds", () => $07b01345748f10fb$export$3de0dd66b0de4cdc);
$parcel$export(module.exports, "IncidentsTaskIds", () => $07b01345748f10fb$export$2852680309cf5a68);
$parcel$export(module.exports, "AlertsTaskIds", () => $07b01345748f10fb$export$4f537e3bd8843f30);
$parcel$export(module.exports, "HasSeenReopenSpotlight", () => $07b01345748f10fb$export$72401d057976d548);
$parcel$export(module.exports, "ContainerType", () => $07b01345748f10fb$export$7d7a98f44861e6f7);
$parcel$export(module.exports, "ExplicitStringBoolean", () => $07b01345748f10fb$export$d7341fa10d264a87);
$parcel$export(module.exports, "PropertyKey", () => $07b01345748f10fb$export$e6bec6a1026bf0b4);
var $07b01345748f10fb$export$2f27df41e8b7edbb;
(function(ActiveState) {
    ActiveState["On"] = "on";
    ActiveState["Off"] = "off";
})($07b01345748f10fb$export$2f27df41e8b7edbb || ($07b01345748f10fb$export$2f27df41e8b7edbb = {}));
var $07b01345748f10fb$export$285eeaa5f468cfb6;
(function(VisualState) {
    VisualState["Lozenge"] = "lozenge";
    VisualState["FullPanel"] = "full-panel";
})($07b01345748f10fb$export$285eeaa5f468cfb6 || ($07b01345748f10fb$export$285eeaa5f468cfb6 = {}));
var $07b01345748f10fb$export$264ad599d7cef668;
(function(Product) {
    Product["ServiceDesk"] = "serviceDesk";
    Product["Opsgenie"] = "opsgenie";
})($07b01345748f10fb$export$264ad599d7cef668 || ($07b01345748f10fb$export$264ad599d7cef668 = {}));
var $07b01345748f10fb$export$7dc6752a22ab011a;
(function(Environment) {
    Environment["Local"] = "local";
    Environment["Dev"] = "dev";
    Environment["Staging"] = "staging";
    Environment["Prod"] = "prod";
})($07b01345748f10fb$export$7dc6752a22ab011a || ($07b01345748f10fb$export$7dc6752a22ab011a = {}));
var $07b01345748f10fb$export$f4906a03a7a2d0af;
(function(GspSectionKey) {
    GspSectionKey["Checklist"] = "checklist";
    GspSectionKey["ProductTours"] = "productTours";
    GspSectionKey["Home"] = "home";
})($07b01345748f10fb$export$f4906a03a7a2d0af || ($07b01345748f10fb$export$f4906a03a7a2d0af = {}));
var $07b01345748f10fb$export$4f1a05ccc35315c6;
(function(ChecklistTabKey) {
    ChecklistTabKey["Basics"] = "basics";
    ChecklistTabKey["TeamEfficiency"] = "teamEfficiency";
    ChecklistTabKey["Incidents"] = "incidents";
    ChecklistTabKey["Changes"] = "changes";
    ChecklistTabKey["Alerts"] = "alerts";
})($07b01345748f10fb$export$4f1a05ccc35315c6 || ($07b01345748f10fb$export$4f1a05ccc35315c6 = {}));
var $07b01345748f10fb$export$aa90cbc80c330872;
(function(ProductTourKey) {
    ProductTourKey["Welcome"] = "welcome";
    ProductTourKey["IncidentManagement"] = "incident-management";
    ProductTourKey["ChangeManagement"] = "change-management";
})($07b01345748f10fb$export$aa90cbc80c330872 || ($07b01345748f10fb$export$aa90cbc80c330872 = {}));
var $07b01345748f10fb$export$38aab4015a34ead;
(function(HeaderState) {
    HeaderState["Minimized"] = "minimized";
    HeaderState["Expanded"] = "expanded";
})($07b01345748f10fb$export$38aab4015a34ead || ($07b01345748f10fb$export$38aab4015a34ead = {}));
var $07b01345748f10fb$export$10cc267f702fbadd;
(function(TaskId) {
    TaskId["CreateItsmProject"] = "servicedesk-itsm-project-created";
    TaskId["CustomizePortal"] = "servicedesk-portal-name-customized";
    TaskId["AddPortalLogo"] = "servicedesk-logo-added-to-portal";
    TaskId["SetupEmailRequests"] = "servicedesk-email-requests-setup";
    TaskId["SetupChatRequests"] = "servicedesk-chat-requests-setup";
    TaskId["SetupServices"] = "servicedesk-services-setup";
    TaskId["AddTeamMember"] = "servicedesk-team-member-added";
    TaskId["GoBeyondBasics"] = "servicedesk-basics-documentation-accessed";
    TaskId["AutomateYourWork"] = "servicedesk-team-efficiency-automate-your-work";
    TaskId["SetupKnowledgeBase"] = "servicedesk-team-efficiency-setup-knowledge-base";
    TaskId["ConnectCiCdPipeline"] = "servicedesk-change-management-pipeline-connected";
    TaskId["AddChangeApprovers"] = "servicedesk-change-management-change-approvers-added";
    TaskId["TurnOnAutomationRules"] = "servicedesk-change-management-automation-rules-on";
    TaskId["MakeTheMostOfChangeManagement"] = "servicedesk-change-management-documentation-accessed";
    TaskId["SetupProfileForNotifications"] = "opsgenie-user-profile-notifications-setup";
    TaskId["SetupTeam"] = "opsgenie-response-team-setup";
    TaskId["AssignOwnerTeamToServices"] = "opsgenie-owner-team-assigned-to-service";
    TaskId["LevelUpIncidentManagement"] = "opsgenie-incident-management-documentation-accessed";
    TaskId["CustomizeRequestChannels"] = "servicedesk-request-channels-email-portal-requests-customised";
    TaskId["CustomizeRequestTypes"] = "servicedesk-request-types-customised";
    TaskId["ReviewQueueConfigurations"] = "servicedesk-queue-configurations-reviewed";
    TaskId["EnableOpsForTeam"] = "opsgenie-enable-ops-for-team";
    TaskId["ReviewOnCallSetup"] = "opsgenie-review-oncall-setup";
    TaskId["AddIntegration"] = "opsgenie-add-integration";
    TaskId["SetupOpsNotifications"] = "opsgenie-setup-ops-notifications";
    TaskId["ReviewAlerts"] = "opsgenie-review-alerts";
})($07b01345748f10fb$export$10cc267f702fbadd || ($07b01345748f10fb$export$10cc267f702fbadd = {}));
const $07b01345748f10fb$export$9846214c9c3411dc = [
    "servicedesk-itsm-project-created",
    "servicedesk-portal-name-customized",
    "servicedesk-logo-added-to-portal",
    "servicedesk-email-requests-setup",
    "servicedesk-services-setup",
    "servicedesk-team-member-added",
    "servicedesk-basics-documentation-accessed"
];
const $07b01345748f10fb$export$fe6666d729b0d637 = [
    "servicedesk-itsm-project-created",
    "servicedesk-portal-name-customized",
    "servicedesk-email-requests-setup",
    "servicedesk-chat-requests-setup",
    "servicedesk-services-setup",
    "servicedesk-team-member-added"
];
const $07b01345748f10fb$export$ed4dcaac45c6a484 = [
    "servicedesk-team-efficiency-automate-your-work",
    "servicedesk-team-efficiency-setup-knowledge-base"
];
const $07b01345748f10fb$export$3de0dd66b0de4cdc = [
    "servicedesk-change-management-pipeline-connected",
    "servicedesk-change-management-change-approvers-added",
    "servicedesk-change-management-documentation-accessed"
];
const $07b01345748f10fb$export$2852680309cf5a68 = [
    "opsgenie-user-profile-notifications-setup",
    "opsgenie-response-team-setup",
    "opsgenie-owner-team-assigned-to-service",
    "opsgenie-incident-management-documentation-accessed"
];
const $07b01345748f10fb$export$4f537e3bd8843f30 = [
    "opsgenie-enable-ops-for-team",
    "opsgenie-review-oncall-setup",
    "opsgenie-add-integration",
    "opsgenie-setup-ops-notifications",
    "opsgenie-review-alerts"
];
var $07b01345748f10fb$export$72401d057976d548;
(function(HasSeenReopenSpotlight) {
    HasSeenReopenSpotlight["Yes"] = "yes";
    HasSeenReopenSpotlight["No"] = "no";
})($07b01345748f10fb$export$72401d057976d548 || ($07b01345748f10fb$export$72401d057976d548 = {}));
var $07b01345748f10fb$export$7d7a98f44861e6f7;
(function(ContainerType) {
    ContainerType["Project"] = "project";
})($07b01345748f10fb$export$7d7a98f44861e6f7 || ($07b01345748f10fb$export$7d7a98f44861e6f7 = {}));
var $07b01345748f10fb$export$d7341fa10d264a87;
(function(ExplicitStringBoolean) {
    ExplicitStringBoolean["Yes"] = "yes";
    ExplicitStringBoolean["No"] = "no";
})($07b01345748f10fb$export$d7341fa10d264a87 || ($07b01345748f10fb$export$d7341fa10d264a87 = {}));
var $07b01345748f10fb$export$e6bec6a1026bf0b4;
(function(PropertyKey) {
    PropertyKey["VisualState"] = "visualState";
    PropertyKey["ActiveState"] = "activeState";
    PropertyKey["SectionState"] = "sectionState";
    PropertyKey["HasSeenReopenSpotlight"] = "hasSeenReopenSpotlight";
})($07b01345748f10fb$export$e6bec6a1026bf0b4 || ($07b01345748f10fb$export$e6bec6a1026bf0b4 = {}));

});

parcelRegister("dIgUk", function(module, exports) {

$parcel$export(module.exports, "actions", () => $74d379822532afde$export$e324594224ef24da);

var $bqfo7 = parcelRequire("bqfo7");

var $lKOEf = parcelRequire("lKOEf");

var $zvnJx = parcelRequire("zvnJx");

var $82jJZ = parcelRequire("82jJZ");

var $kYwcF = parcelRequire("kYwcF");

var $3ZIER = parcelRequire("3ZIER");

var $aXUph = parcelRequire("aXUph");

var $1mctb = parcelRequire("1mctb");

var $ghO9h = parcelRequire("ghO9h");
const $74d379822532afde$export$e324594224ef24da = {
    initializeState: $lKOEf.initializeState,
    fetchState: $bqfo7.fetchState,
    savePanelState: $3ZIER.savePanelState,
    reopenGettingStartedPanel: $82jJZ.reopenGettingStartedPanel,
    markReopenSpotlightAsSeen: $zvnJx.markReopenSpotlightAsSeen,
    resolveTask: $kYwcF.resolveTask,
    saveProperty: $aXUph.saveProperty,
    stopRecordingPerformanceExperiences: $ghO9h.stopRecordingPerformanceExperiences,
    setOpsAdminTaskVisibility: $1mctb.setOpsAdminTaskVisibility
};

});
parcelRegister("bqfo7", function(module, exports) {

$parcel$export(module.exports, "fetchState", () => $966d678a0c07fdc2$export$f3df9013f2b58bce);

var $1c8hB = parcelRequire("1c8hB");

var $hTLlD = parcelRequire("hTLlD");

var $ldoFd = parcelRequire("ldoFd");

var $feGjZ = parcelRequire("feGjZ");

var $4ZYEI = parcelRequire("4ZYEI");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");

var $1dL7Z = parcelRequire("1dL7Z");

var $isHzQ = parcelRequire("isHzQ");

var $ajx4y = parcelRequire("ajx4y");

var $lKOEf = parcelRequire("lKOEf");
const $966d678a0c07fdc2$export$e15c3a0c2c6f7c69 = {
    RESPONSE_NOT_OBJECT: 'response is not an object',
    RESPONSE_COMPLETED_ITEMS_NOT_ARRAY: 'response.completedItems is not an array',
    RESPONSE_PROPERTIES_NOT_OBJECT: 'response.properties is not an object',
    RESPONSE_PROPERTIES_USER_NOT_OBJECT: 'response.properties.user is not an object',
    RESPONSE_PROPERTIES_USER_SECTION_STATE_NOT_STRING: 'response.properties.user.sectionState is not a string',
    FAILED_PANEL_STATE_JSON_PARSE: 'Failed to parse panelState as JSON'
};
const $966d678a0c07fdc2$var$tryInitializeState = async ({ dispatch: dispatch, ...actionProps })=>{
    const { isProjectTourSeen: isProjectTourSeen, isItsmProject: isItsmProject, projectId: projectId, isItsmSampleProject: isItsmSampleProject, enableOpsTeamMode: enableOpsTeamMode } = actionProps;
    const isNpleForItsmEnabled = (0, $79xbN.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation');
    const hasProject = (isNpleForItsmEnabled || isProjectTourSeen) && isItsmProject && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(projectId) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isItsmSampleProject);
    if (hasProject || // We will show the alert tab regardless of the project conditions.
    enableOpsTeamMode) await dispatch((0, $lKOEf.initializeState)(actionProps))({
        projectId: projectId
    });
};
const $966d678a0c07fdc2$export$8f32748afb26c81d = (response)=>{
    try {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(response)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_NOT_OBJECT);
        const completedTasks = response?.completedItems;
        const properties = response?.properties;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(completedTasks)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_COMPLETED_ITEMS_NOT_ARRAY);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(properties)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_NOT_OBJECT);
        const userProperties = properties.user;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(userProperties)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_USER_NOT_OBJECT);
        const sectionStateString = userProperties.sectionState;
        if (sectionStateString === undefined) return undefined;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($4ZYEI)))(sectionStateString)) throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.RESPONSE_PROPERTIES_USER_SECTION_STATE_NOT_STRING);
        try {
            // further validation on this object to be done within the GSP component
            JSON.parse(sectionStateString);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (parseError) {
            throw new Error($966d678a0c07fdc2$export$e15c3a0c2c6f7c69.FAILED_PANEL_STATE_JSON_PARSE);
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'fetchState_constructDataFromResponse',
                packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                teamName: 'itops-mithril'
            },
            attributes: {
                message: error.message
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
const $966d678a0c07fdc2$export$f3df9013f2b58bce = (actionProps)=>({ getState: getState, setState: setState, dispatch: dispatch })=>async ()=>{
            const { isGspInitialized: isGspInitialized, isSaving: isSaving, data: currentData } = getState();
            const { baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent, enableOpsTeamMode: enableOpsTeamMode, teamId: teamId, enableUserCentricMode: enableUserCentricMode } = actionProps;
            // If state is being saved, do not fetch, as it could fetch old state before it has been saved.
            if (isSaving) return;
            // If state is initialized, fetch the state
            if (isGspInitialized) try {
                let response;
                try {
                    response = await (0, $2OdyW.default)((0, $lKOEf.getUrl)({
                        baseUrl: baseUrl,
                        cloudId: cloudId
                    }), {
                        method: 'GET',
                        mode: 'cors',
                        credentials: 'include'
                    });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    // 404 indicates that the checklist is not yet initialized for the user
                    if (error.statusCode !== 404) throw error;
                }
                // If state is being saved, do not save fetched state,
                // as it will override current state that is being saved.
                if (isSaving) return;
                let data = response ? $966d678a0c07fdc2$export$8f32748afb26c81d(response) : undefined;
                if (enableUserCentricMode && data) data = await (0, $ajx4y.handleUserCentricMode)(data, cloudId);
                else if (enableOpsTeamMode && teamId && data) {
                    const opsAdminTaskVisibility = currentData?.properties.user['ops-admin-tasks-visibility'];
                    data.properties.user['ops-admin-tasks-visibility'] = opsAdminTaskVisibility;
                    data = await (0, $isHzQ.handleOpsTeamMode)(data, teamId, cloudId);
                }
                // Skip unnecessary re-renders caused by the data reference changing
                if (!!data && (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(data, currentData)) return;
                setState({
                    data: data,
                    isGspInitialized: !!data
                });
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.fetchState succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if ((0, $1dL7Z.isExpectedError)(error)) return;
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'fetchState',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
            /**
		 * If state is not initialized - try to initialize it
		 * Re-getting isGspInitialized from the getState(), because it might be changed (to false) by the code above
		 */ const { isGspInitialized: currentIsGspInitialized } = getState();
            if (!currentIsGspInitialized) $966d678a0c07fdc2$var$tryInitializeState({
                ...actionProps,
                dispatch: dispatch
            });
        };

});
parcelRegister("1dL7Z", function(module, exports) {

$parcel$export(module.exports, "isInClassicSettingsPage", () => $1d31dcdfdfe25380$export$a6e1eca03e2de987);
$parcel$export(module.exports, "getCurrentPageName", () => $1d31dcdfdfe25380$export$e2c4f60e8cad01fb);
$parcel$export(module.exports, "isExpectedError", () => $1d31dcdfdfe25380$export$8715824c16ceeca0);
$parcel$export(module.exports, "shouldIncludePathname", () => $1d31dcdfdfe25380$export$83501d9ba065ef89);
$parcel$export(module.exports, "shouldExcludePathname", () => $1d31dcdfdfe25380$export$8752a3c4a740bd52);
$parcel$export(module.exports, "shouldExcludeRouteName", () => $1d31dcdfdfe25380$export$5d52a100c70d4375);
// TODO once all pages that checklist cover are in SPA, we should change this to use matchedRoute instead of pathname

var $2oOo5 = parcelRequire("2oOo5");

var $JRB5w = parcelRequire("JRB5w");
const $1d31dcdfdfe25380$export$d7638addf23014e7 = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+$/.test(pathname);
const $1d31dcdfdfe25380$export$1b685dac913c7026 = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+\/[\w\W]+$/.test(pathname) || /\/browse\/[\w\W]+$/.test(pathname);
const $1d31dcdfdfe25380$export$a05100bbf8bc68c3 = (pathname)=>/\/projects\/[\w\d]+\/reports/.test(pathname);
const $1d31dcdfdfe25380$export$e75cc3ec1f686973 = (pathname)=>/\/projects\/[\w\d]+\/knowledge/.test(pathname);
const $1d31dcdfdfe25380$export$6292763547421a38 = (pathname)=>/\/projects\/[\w\d]+\/customers$/.test(pathname);
const $1d31dcdfdfe25380$export$35dc6022d31ad167 = (pathname)=>/\/projects\/[\w\d]+\/organization\/[\d]+$/.test(pathname);
const $1d31dcdfdfe25380$export$f8f0d4e52d7e9716 = (pathname)=>$1d31dcdfdfe25380$export$a05100bbf8bc68c3(pathname) && (pathname.endsWith('edit') || pathname.endsWith('new'));
const $1d31dcdfdfe25380$export$753a23d2a857eec = (pathname)=>/\/projects\/[\w\d]+\/queues\/custom\/[\d]+\/edit$/.test(pathname) || /\/projects\/[\w\d]+\/queues\/custom\/new$/.test(pathname);
const $1d31dcdfdfe25380$export$66d002c194bc72aa = (pathname)=>/\/projects\/[\w\d]+\/services\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$430089990bd4af09 = (pathname)=>/\/projects\/[\w\d]+\/on-call-schedule\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$a655a298d384c316 = (pathname)=>/\/projects\/[\w\d]+\/section\/incidents\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$1c5f444b718144b7 = (pathname)=>/\/projects\/[\w\d]+\/section\/problems\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$42dd8a49c7fa462c = (pathname)=>/\/projects\/[\w\d]+\/section\/changes\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$5c77a7ea15a04e63 = (pathname)=>/\/projects\/[\w\d]+\/section\/service-requests\b\/*.*/.test(pathname);
const $1d31dcdfdfe25380$export$dbf902576403f80e = (pathname)=>/\/secure\/project\/EditProject!default.jspa/.test(pathname);
const $1d31dcdfdfe25380$export$458d0b4237ae1dad = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/people/.test(pathname);
const $1d31dcdfdfe25380$export$3b5fbfd2bca32dde = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/summary/.test(pathname);
const $1d31dcdfdfe25380$export$aeffbab88b3257bb = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/issuetypes/.test(pathname);
const $1d31dcdfdfe25380$export$7e3236de8c2c8fcb = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/request-types\/category\/[\w]+/.test(pathname);
const $1d31dcdfdfe25380$export$908f99db4c2098a0 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/change-management/.test(pathname);
const $1d31dcdfdfe25380$export$c5b9a5ba6b3e9b66 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/customer-permissions/.test(pathname);
const $1d31dcdfdfe25380$export$f4e3d864ce1a2f74 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/language/.test(pathname);
const $1d31dcdfdfe25380$export$21361d1ad00e769e = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/portal-settings/.test(pathname);
const $1d31dcdfdfe25380$export$6208845cb364d4de = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/email-settings/.test(pathname);
const $1d31dcdfdfe25380$export$16978d524c086b4 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/email/.test(pathname);
const $1d31dcdfdfe25380$export$b6d6b41b75346458 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/customer-notifications/.test(pathname);
const $1d31dcdfdfe25380$export$5b2153f9a7427657 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/widget/.test(pathname);
const $1d31dcdfdfe25380$export$c5434c69e9b50e81 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/feedback-settings/.test(pathname);
const $1d31dcdfdfe25380$export$3a7002667b72e8d7 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/confluence-kb/.test(pathname);
const $1d31dcdfdfe25380$export$542a1f79f5837827 = (pathname)=>/\/jira\/servicedesk\/projects\/[\w\d]+\/settings\/sla/.test(pathname);
const $1d31dcdfdfe25380$export$b748c9dbd5996d34 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/automation/.test(pathname);
const $1d31dcdfdfe25380$export$455a6199a321423 = (pathname)=>/\/servicedesk\/admin\/[\w\d]+\/apps/.test(pathname);
const $1d31dcdfdfe25380$export$fa426b2da28e4ae2 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/workflows/.test(pathname);
const $1d31dcdfdfe25380$export$fc0fba46b7584812 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/screens/.test(pathname);
const $1d31dcdfdfe25380$export$882325faa1a194c6 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/fields/.test(pathname);
const $1d31dcdfdfe25380$export$8bb0073f55baf38b = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/administer-versions/.test(pathname);
const $1d31dcdfdfe25380$export$1b69f3aa169f179 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/administer-components/.test(pathname);
const $1d31dcdfdfe25380$export$1c47b1cb87da237 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/permissions/.test(pathname);
const $1d31dcdfdfe25380$export$ee56a66aa8efb6da = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/issuesecurity/.test(pathname);
const $1d31dcdfdfe25380$export$6256b4d737fa56f2 = (pathname)=>/\/plugins\/servlet\/project-config\/[\w\d]+\/notifications/.test(pathname);
const $1d31dcdfdfe25380$export$3f77d24f8de610a0 = (pathname)=>/\/secure\/ViewCollectors!default.jspa/.test(pathname);
const $1d31dcdfdfe25380$export$a6e1eca03e2de987 = (pathname)=>$1d31dcdfdfe25380$export$dbf902576403f80e(pathname) || $1d31dcdfdfe25380$export$458d0b4237ae1dad(pathname) || $1d31dcdfdfe25380$export$3b5fbfd2bca32dde(pathname) || $1d31dcdfdfe25380$export$aeffbab88b3257bb(pathname) || $1d31dcdfdfe25380$export$7e3236de8c2c8fcb(pathname) || $1d31dcdfdfe25380$export$908f99db4c2098a0(pathname) || $1d31dcdfdfe25380$export$c5b9a5ba6b3e9b66(pathname) || $1d31dcdfdfe25380$export$f4e3d864ce1a2f74(pathname) || $1d31dcdfdfe25380$export$21361d1ad00e769e(pathname) || $1d31dcdfdfe25380$export$6208845cb364d4de(pathname) || $1d31dcdfdfe25380$export$16978d524c086b4(pathname) || $1d31dcdfdfe25380$export$b6d6b41b75346458(pathname) || $1d31dcdfdfe25380$export$5b2153f9a7427657(pathname) || $1d31dcdfdfe25380$export$c5434c69e9b50e81(pathname) || $1d31dcdfdfe25380$export$3a7002667b72e8d7(pathname) || $1d31dcdfdfe25380$export$542a1f79f5837827(pathname) || $1d31dcdfdfe25380$export$b748c9dbd5996d34(pathname) || $1d31dcdfdfe25380$export$455a6199a321423(pathname) || $1d31dcdfdfe25380$export$fa426b2da28e4ae2(pathname) || $1d31dcdfdfe25380$export$fc0fba46b7584812(pathname) || $1d31dcdfdfe25380$export$882325faa1a194c6(pathname) || $1d31dcdfdfe25380$export$8bb0073f55baf38b(pathname) || $1d31dcdfdfe25380$export$1b69f3aa169f179(pathname) || $1d31dcdfdfe25380$export$1c47b1cb87da237(pathname) || $1d31dcdfdfe25380$export$ee56a66aa8efb6da(pathname) || $1d31dcdfdfe25380$export$6256b4d737fa56f2(pathname) || $1d31dcdfdfe25380$export$3f77d24f8de610a0(pathname);
const $1d31dcdfdfe25380$var$screenNameMap = {
    queues: $1d31dcdfdfe25380$export$d7638addf23014e7,
    issues: $1d31dcdfdfe25380$export$1b685dac913c7026,
    customers: $1d31dcdfdfe25380$export$6292763547421a38,
    reports: $1d31dcdfdfe25380$export$a05100bbf8bc68c3,
    knowledge: $1d31dcdfdfe25380$export$e75cc3ec1f686973,
    services: $1d31dcdfdfe25380$export$66d002c194bc72aa,
    onCall: $1d31dcdfdfe25380$export$430089990bd4af09,
    incidents: $1d31dcdfdfe25380$export$a655a298d384c316,
    problems: $1d31dcdfdfe25380$export$1c5f444b718144b7,
    changes: $1d31dcdfdfe25380$export$42dd8a49c7fa462c,
    serviceRequests: $1d31dcdfdfe25380$export$5c77a7ea15a04e63,
    classicSettingsDetails: $1d31dcdfdfe25380$export$dbf902576403f80e,
    classicSettingsPeople: $1d31dcdfdfe25380$export$458d0b4237ae1dad,
    classicSettingsSummary: $1d31dcdfdfe25380$export$3b5fbfd2bca32dde,
    classicSettingsIssueTypes: $1d31dcdfdfe25380$export$aeffbab88b3257bb,
    classicSettingsRequestTypes: $1d31dcdfdfe25380$export$7e3236de8c2c8fcb,
    classicSettingsChangeManagement: $1d31dcdfdfe25380$export$908f99db4c2098a0,
    classicSettingsCustomerPermissions: $1d31dcdfdfe25380$export$c5b9a5ba6b3e9b66,
    classicSettingsLanguage: $1d31dcdfdfe25380$export$f4e3d864ce1a2f74,
    classicSettingsPortal: $1d31dcdfdfe25380$export$21361d1ad00e769e,
    classicSettingsEmail: $1d31dcdfdfe25380$export$6208845cb364d4de,
    classicSettingsEmailAlias: $1d31dcdfdfe25380$export$16978d524c086b4,
    classicSettingsCustomerNotifications: $1d31dcdfdfe25380$export$b6d6b41b75346458,
    classicSettingsWidget: $1d31dcdfdfe25380$export$5b2153f9a7427657,
    classicSettingsFeedback: $1d31dcdfdfe25380$export$c5434c69e9b50e81,
    classicSettingsConfluence: $1d31dcdfdfe25380$export$3a7002667b72e8d7,
    classicSettingsSla: $1d31dcdfdfe25380$export$542a1f79f5837827,
    classicSettingsAutomation: $1d31dcdfdfe25380$export$b748c9dbd5996d34,
    classicSettingsApps: $1d31dcdfdfe25380$export$455a6199a321423,
    classicSettingsWorkflows: $1d31dcdfdfe25380$export$fa426b2da28e4ae2,
    classicSettingsScreens: $1d31dcdfdfe25380$export$fc0fba46b7584812,
    classicSettingsFields: $1d31dcdfdfe25380$export$882325faa1a194c6,
    classicSettingsVersions: $1d31dcdfdfe25380$export$8bb0073f55baf38b,
    classicSettingsComponents: $1d31dcdfdfe25380$export$1b69f3aa169f179,
    classicSettingsPermissions: $1d31dcdfdfe25380$export$1c47b1cb87da237,
    classicSettingsIssueSecurity: $1d31dcdfdfe25380$export$ee56a66aa8efb6da,
    classicSettingsNotifications: $1d31dcdfdfe25380$export$6256b4d737fa56f2,
    classicSettingsIssueCollectors: $1d31dcdfdfe25380$export$3f77d24f8de610a0
};
const $1d31dcdfdfe25380$export$e2c4f60e8cad01fb = (pathname)=>(0, (/*@__PURE__*/$parcel$interopDefault($2oOo5)))($1d31dcdfdfe25380$var$screenNameMap, (isCurrentScreen)=>isCurrentScreen(pathname)) || '';
const $1d31dcdfdfe25380$export$8715824c16ceeca0 = (error)=>// these are out of our control so treat them as expected
    (0, $JRB5w.isClientFetchError)(error);
const $1d31dcdfdfe25380$var$GSP_EXCLUDED_PAGES_FILTER = {
    pathnameRegexes: [
        // 'Classic Settings Customer Notifications',
        '/servicedesk/admin/[\\w\\d]+/customer-notifications'
    ],
    pathnameRegexesForNple: [
        // 'Classic Settings Customer Notifications',
        '/servicedesk/admin/[\\w\\d]+/customer-notifications',
        // 'Portal Settings Page'
        '/jira/servicedesk/projects/[\\w\\d]+/settings/portal-settings',
        // 'People Page'
        '/plugins/servlet/project-config/[\\w\\d]+/people',
        // 'Getting Started Page'
        '/jira/servicedesk/projects/[\\w\\d]+/getting-started'
    ],
    routeNames: [
        // 'Reports',
        'servicedesk-reports',
        // 'Reports - Custom',
        'servicedesk-reports-custom',
        // 'Reports - Create',
        'servicedesk-reports-custom-create',
        // 'Reports - Edit',
        'servicedesk-reports-custom-edit',
        // 'Reports - Time Scale Issue',
        'servicedesk-reports-custom-time-scale-issue',
        // 'Reports - Time Scale',
        'servicedesk-reports-custom-time-scale',
        // 'Reports - Satisfaction',
        'servicedesk-reports-satisfaction',
        // 'Reports - Satisfaction Time Scale Issue',
        'servicedesk-reports-satisfaction-time-scale-issue',
        // 'Reports - Satisfaction TIme Scale',
        'servicedesk-reports-satisfaction-time-scale',
        // 'Reports - Summary',
        'servicedesk-reports-summary',
        // 'Reports - Type',
        'servicedesk-reports-type',
        // 'Reports - Workload',
        'servicedesk-reports-workload',
        // 'Queues - New',
        'servicedesk-queues-new',
        // 'Queues - Edit',
        'servicedesk-queues-edit'
    ]
};
const $1d31dcdfdfe25380$var$GSP_INCLUDED_PAGES_FILTER = {
    pathnameRegexes: [
        '/jira/people/search'
    ]
};
const $1d31dcdfdfe25380$export$83501d9ba065ef89 = (pathname)=>$1d31dcdfdfe25380$var$GSP_INCLUDED_PAGES_FILTER.pathnameRegexes.some((regex)=>new RegExp(regex).test(pathname));
const $1d31dcdfdfe25380$export$8752a3c4a740bd52 = (pathname, isNpleForItsmEnabled)=>isNpleForItsmEnabled ? $1d31dcdfdfe25380$var$GSP_EXCLUDED_PAGES_FILTER.pathnameRegexesForNple.some((regex)=>new RegExp(regex).test(pathname)) : $1d31dcdfdfe25380$var$GSP_EXCLUDED_PAGES_FILTER.pathnameRegexes.some((regex)=>new RegExp(regex).test(pathname));
const $1d31dcdfdfe25380$export$5d52a100c70d4375 = (currentRouteName)=>$1d31dcdfdfe25380$var$GSP_EXCLUDED_PAGES_FILTER.routeNames.some((routeName)=>routeName === currentRouteName);

});
parcelRegister("2oOo5", function(module, exports) {

var $1FGIk = parcelRequire("1FGIk");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */ function $1bf4e8901877f248$var$findKey(object, predicate) {
    return $1FGIk(object, $7qARj(predicate, 3), $piimr);
}
module.exports = $1bf4e8901877f248$var$findKey;

});
parcelRegister("1FGIk", function(module, exports) {
/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */ function $137ac0dffc9def22$var$baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
            result = key;
            return false;
        }
    });
    return result;
}
module.exports = $137ac0dffc9def22$var$baseFindKey;

});



const $ae3aa738acb13786$export$a72c07e4474ec8ca = 'jiraServicedeskGettingStartedPanel';
const $ae3aa738acb13786$export$47712c7937145142 = 320;
const $ae3aa738acb13786$export$1cad4f611a1c0229 = 220;
const $ae3aa738acb13786$export$b8b9d90f9e5bd72b = 'jiraServicedeskGettingStartedPanel';
const $ae3aa738acb13786$export$bc8b984358922f81 = 'team';
const $ae3aa738acb13786$export$d59a8243d815f2eb = 'jsm-getting-started-panel';
const $ae3aa738acb13786$export$cbbd90bf5df877bd = 'cloudid';
const $ae3aa738acb13786$export$a74074a8f4372ab0 = 'referrer';

parcelRegister("isHzQ", function(module, exports) {

$parcel$export(module.exports, "handleOpsTeamMode", () => $c920f201dd81d401$export$b05151222ac96edd);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");


var $8u09c = parcelRequire("8u09c");
var $4eEU1 = parcelRequire("4eEU1");
async function $c920f201dd81d401$export$b05151222ac96edd(data, teamId, cloudId) {
    const mutatedData = {
        ...data
    };
    // we need to unset team centric items if they are set in the project page for the user
    mutatedData.completedItems = mutatedData.completedItems.filter((item)=>{
        if (item === (0, $8u09c.TaskId).ReviewOnCallSetup || item === (0, $8u09c.TaskId).AddIntegration) return false;
        return true;
    });
    // If user has not have right to see those items, we don't need to fetch them.
    if (mutatedData.properties.user['ops-admin-tasks-visibility'] === (0, $4eEU1.VisibilityValues).Visible) try {
        const teamCentricResponse = await (0, $2OdyW.default)(`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/team/${teamId}/list/jsm-getting-started-panel`, {
            method: 'GET',
            mode: 'cors'
        });
        // we will override completed items by setting team-centric items
        mutatedData.completedItems = [
            ...mutatedData?.completedItems,
            ...teamCentricResponse?.completedItems
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The list is not initialized yet
        if (error.statusCode !== 404) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'handleOpsTeamMode-TeamCentricResponse',
                    packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                    // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                    teamName: 'Alexstrasza'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return mutatedData;
}

});
parcelRegister("4eEU1", function(module, exports) {

$parcel$export(module.exports, "OpsVisibilityKeys", () => $5d00ee66e441ccba$export$3cae6a891a2fb0c1);
$parcel$export(module.exports, "SdVisibilityKeys", () => $5d00ee66e441ccba$export$9ffa2df2d13a51e4);
$parcel$export(module.exports, "OgVisibilityKeys", () => $5d00ee66e441ccba$export$37aa46ee833f23f2);
$parcel$export(module.exports, "VisibilityValues", () => $5d00ee66e441ccba$export$b715b908ae0969fa);
$parcel$export(module.exports, "SdVisibilityRoles", () => $5d00ee66e441ccba$export$47a23917fcedd235);
var $5d00ee66e441ccba$export$3cae6a891a2fb0c1;
(function(OpsVisibilityKeys) {
    OpsVisibilityKeys["OpsTasksVisibility"] = "ops-tasks-visibility";
    OpsVisibilityKeys["OpsAdminTasksVisibility"] = "ops-admin-tasks-visibility";
})($5d00ee66e441ccba$export$3cae6a891a2fb0c1 || ($5d00ee66e441ccba$export$3cae6a891a2fb0c1 = {}));
var $5d00ee66e441ccba$export$9ffa2df2d13a51e4;
(function(SdVisibilityKeys) {
    SdVisibilityKeys["SdStandardTasksVisibility"] = "servicedesk-standard-tasks-visibility";
    SdVisibilityKeys["SdAdvancedTasksVisibility"] = "servicedesk-advanced-tasks-visibility";
})($5d00ee66e441ccba$export$9ffa2df2d13a51e4 || ($5d00ee66e441ccba$export$9ffa2df2d13a51e4 = {}));
var $5d00ee66e441ccba$export$37aa46ee833f23f2;
(function(OgVisibilityKeys) {
    OgVisibilityKeys["OgSetupProfileForNotificationsTaskVisibility"] = "opsgenie-user-profile-notifications-setup-task-visibility";
    OgVisibilityKeys["OgSetupTeamTaskVisibility"] = "opsgenie-response-team-setup-task-visibility";
    OgVisibilityKeys["OgAssignOwnerTeamToServicesTaskVisibility"] = "opsgenie-owner-team-assigned-to-service-task-visibility";
    OgVisibilityKeys["OgLevelUpIncidentManagementTaskVisibility"] = "opsgenie-incident-management-documentation-accessed-task-visibility";
})($5d00ee66e441ccba$export$37aa46ee833f23f2 || ($5d00ee66e441ccba$export$37aa46ee833f23f2 = {}));
var $5d00ee66e441ccba$export$b715b908ae0969fa;
(function(VisibilityValues) {
    VisibilityValues["Hidden"] = "hidden";
    VisibilityValues["Visible"] = "visible";
    VisibilityValues["Unset"] = "unset";
})($5d00ee66e441ccba$export$b715b908ae0969fa || ($5d00ee66e441ccba$export$b715b908ae0969fa = {}));
var $5d00ee66e441ccba$export$47a23917fcedd235;
(function(SdVisibilityRoles) {
    SdVisibilityRoles["Advanced"] = "advanced";
    SdVisibilityRoles["Standard"] = "standard";
})($5d00ee66e441ccba$export$47a23917fcedd235 || ($5d00ee66e441ccba$export$47a23917fcedd235 = {}));

});


parcelRegister("ajx4y", function(module, exports) {

$parcel$export(module.exports, "handleUserCentricMode", () => $07f045f9f08d9204$export$10caa25085bdca55);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");


var $8u09c = parcelRequire("8u09c");
async function $07f045f9f08d9204$export$10caa25085bdca55(data, cloudId) {
    const mutatedData = {
        ...data
    };
    // we need to unset user centric items if they are set in the ops team page for that user
    mutatedData.completedItems = mutatedData.completedItems.filter((item)=>{
        if (item === (0, $8u09c.TaskId).ReviewOnCallSetup || item === (0, $8u09c.TaskId).AddIntegration) return false;
        return true;
    });
    try {
        const userCentricResponse = await (0, $2OdyW.default)(`/gateway/api/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel`, {
            method: 'GET',
            mode: 'cors'
        });
        // we will override completed items by getting/setting user-centric endpoint
        const userCentricCompletedItems = userCentricResponse.completedItems.filter((item)=>{
            if (item === (0, $8u09c.TaskId).ReviewOnCallSetup || item === (0, $8u09c.TaskId).AddIntegration) return true;
            return false;
        });
        mutatedData.completedItems = [
            ...mutatedData.completedItems,
            ...userCentricCompletedItems
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The list is not initialized yet
        if (error.statusCode !== 404) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'handleUserCentricMode-UserCentricResponse',
                    packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                    // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                    teamName: 'Alexstrasza'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }
    return mutatedData;
}

});

parcelRegister("lKOEf", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $7814cf240c11be32$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "initializeState", () => $7814cf240c11be32$export$3ee49b4c70c0ec29);

var $ldoFd = parcelRequire("ldoFd");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");

var $3gGTI = parcelRequire("3gGTI");

var $8GtZ0 = parcelRequire("8GtZ0");
var $4eEU1 = parcelRequire("4eEU1");

var $isHzQ = parcelRequire("isHzQ");

var $ajx4y = parcelRequire("ajx4y");

var $3ZIER = parcelRequire("3ZIER");
const $7814cf240c11be32$export$94df0e59ebebf4a7 = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/aggregate/list/jsm-getting-started-panel`;
const $7814cf240c11be32$export$3ee49b4c70c0ec29 = (actionProps)=>({ setState: setState, getState: getState, dispatch: dispatch })=>async ({ projectId: projectId })=>{
            const { baseUrl: baseUrl, cloudId: cloudId, isItsmSampleProject: isItsmSampleProject, createAnalyticsEvent: createAnalyticsEvent, enableOpsTeamMode: enableOpsTeamMode, teamId: teamId, enableUserCentricMode: enableUserCentricMode } = actionProps;
            // Do not initialize unless it's known that project is not sample ITSM project
            if (isItsmSampleProject !== false) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(isItsmSampleProject)) (0, $guiFP.default)({
                    meta: {
                        id: 'initializeState_isItsmSampleProject_unknown',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    }
                });
                return;
            }
            const initializeStateOnce = async (attemptIndex, totalAttempts)=>{
                const isFinalAttempt = attemptIndex === totalAttempts - 1;
                // Stop any other updates to the state that might occur
                setState({
                    isSaving: true
                });
                // Fetch any existing data from ST (this will include any task visibility keys)
                let response;
                try {
                    response = await (0, $2OdyW.default)($7814cf240c11be32$export$94df0e59ebebf4a7({
                        baseUrl: baseUrl,
                        cloudId: cloudId
                    }), {
                        method: 'GET',
                        mode: 'cors',
                        credentials: 'include'
                    });
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    // 404 indicates that the checklist is not yet initialized for the user
                    if (error.statusCode === 404) {
                        setState({
                            isSaving: false,
                            isGspInitialized: false
                        });
                        return;
                    }
                    setState({
                        isSaving: false
                    });
                    if (isFinalAttempt) (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'initializeState_fetch',
                            packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    throw error;
                }
                // TODO: validate properly https://jdog.jira-dev.com/browse/JIG-392
                // We can't use constructDataFromResponse because initial server data only
                // contains a subset of the full GSP state (just task visiblity keys)
                const serverData = response;
                /* Merge in server values and defaults, according to the following:
			 *  - completedItems from default state, to allow for reset behaviour with FSF override flag
			 *  - properties comes from server values first, to add task visibility and non-user properties
			 *  - default state user properties are merged in over the top of server properties to reset
			 *    things like sectionState, activeState, visualState, hasSeenReopenSpotlight in the
			 *    case of FSF override flag where server state already exists.
			 *    Assumption: the only properties contained in the default state are user properties
			 *  - projectId from current project
			 */ let data = {
                    completedItems: (0, $8GtZ0.defaultGspState).completedItems,
                    properties: {
                        ...serverData.properties,
                        user: {
                            ...serverData.properties.user,
                            ...(0, $8GtZ0.defaultGspState).properties.user,
                            projectId: projectId
                        }
                    }
                };
                if (enableUserCentricMode && data) data = await (0, $ajx4y.handleUserCentricMode)(data, cloudId);
                else if (enableOpsTeamMode && teamId && data) {
                    const opsAdminTaskVisibility = getState().data?.properties.user['ops-admin-tasks-visibility'] ?? (0, $4eEU1.VisibilityValues).Hidden;
                    data.properties.user['ops-admin-tasks-visibility'] = opsAdminTaskVisibility;
                    data = await (0, $isHzQ.handleOpsTeamMode)(data, teamId, cloudId);
                }
                // Save our newly merged state
                try {
                    setState({
                        data: data,
                        isGspInitialized: true,
                        isSaving: false
                    });
                    await dispatch((0, $3ZIER.savePanelState)(actionProps))(data);
                    (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.initializeState succeeded`);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    setState({
                        isGspInitialized: true,
                        isSaving: false
                    });
                    if (isFinalAttempt) (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'initializeState',
                            packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                            teamName: 'itops-mithril'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            };
            await (0, $3gGTI.withExponentialBackoffRetries)({
                callback: initializeStateOnce,
                totalAttempts: 5,
                baseIntervalMs: 500
            });
        };

});
parcelRegister("3gGTI", function(module, exports) {

$parcel$export(module.exports, "withExponentialBackoffRetries", () => $06938d82719cce50$export$344601bd15a7b6d);
const $06938d82719cce50$var$waitTimeMs = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $06938d82719cce50$export$344601bd15a7b6d = async ({ callback: callback, totalAttempts: totalAttempts, baseIntervalMs: baseIntervalMs })=>{
    for(let attemptIndex = 0; attemptIndex < totalAttempts; attemptIndex += 1)/* eslint-disable no-await-in-loop */ try {
        return await callback(attemptIndex, totalAttempts);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (attemptIndex + 1 < totalAttempts) // if retry attempts remain, wait time before trying again
        await $06938d82719cce50$var$waitTimeMs(baseIntervalMs * Math.pow(2, attemptIndex));
        else // else if no more attempts, throw the error
        throw error;
    }
    throw Error('withExponentialBackoffRetries should not reach');
};

});

parcelRegister("8GtZ0", function(module, exports) {

$parcel$export(module.exports, "defaultGspState", () => $72b93b78f031cb2c$export$4db8363977bdf2d4);
$parcel$export(module.exports, "GSP", () => $72b93b78f031cb2c$export$1cb8c028028700ec);

var $8u09c = parcelRequire("8u09c");
// This is duplicated to avoid importing from section-state
// to attempt to keep bundle size down.
// These values must be manually kept in sync.
const $72b93b78f031cb2c$var$defaultSectionStateV2 = {
    version: 2,
    activeSection: (0, $8u09c.GspSectionKey).Home,
    sections: {
        checklist: {
            headerState: (0, $8u09c.HeaderState).Expanded,
            activeTab: (0, $8u09c.ChecklistTabKey).Basics,
            tabs: {
                basics: {
                    activeTask: undefined
                },
                teamEfficiency: {
                    activeTask: undefined
                },
                incidents: {
                    activeTask: undefined
                },
                changes: {
                    activeTask: undefined
                },
                alerts: {
                    activeTask: undefined
                }
            }
        },
        productTours: {
            headerState: (0, $8u09c.HeaderState).Expanded,
            activeTour: (0, $8u09c.ProductTourKey).Welcome
        }
    }
};
const $72b93b78f031cb2c$export$4db8363977bdf2d4 = {
    completedItems: [
        (0, $8u09c.TaskId).CreateItsmProject
    ],
    properties: {
        containers: [],
        user: {
            activeState: (0, $8u09c.ActiveState).On,
            visualState: (0, $8u09c.VisualState).FullPanel,
            sectionState: JSON.stringify($72b93b78f031cb2c$var$defaultSectionStateV2),
            hasSeenReopenSpotlight: (0, $8u09c.HasSeenReopenSpotlight).No
        }
    }
};
const $72b93b78f031cb2c$export$1cb8c028028700ec = 'GettingStartedPanel';

});

parcelRegister("3ZIER", function(module, exports) {

$parcel$export(module.exports, "savePanelState", () => $98e7316a9047ea56$export$8756ef0989d9dd58);

var $guiFP = parcelRequire("guiFP");

var $5G2eQ = parcelRequire("5G2eQ");

var $jMP2a = parcelRequire("jMP2a");

var $3gGTI = parcelRequire("3gGTI");
const $98e7316a9047ea56$var$getUrl = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel/properties`;
const $98e7316a9047ea56$export$8756ef0989d9dd58 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async (state)=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to save panel state without current GSP state.');
                // Set the state locally without waiting for the API call
                setState({
                    data: state,
                    isSaving: true
                });
                const { sectionState: sectionState, activeState: activeState, visualState: visualState, projectId: projectId, hasSeenReopenSpotlight: hasSeenReopenSpotlight } = state.properties.user;
                await (0, $3gGTI.withExponentialBackoffRetries)({
                    callback: ()=>(0, $5G2eQ.default)($98e7316a9047ea56$var$getUrl({
                            baseUrl: baseUrl,
                            cloudId: cloudId
                        }), {
                            method: 'POST',
                            credentials: 'include',
                            body: JSON.stringify({
                                sectionState: sectionState,
                                activeState: activeState,
                                visualState: visualState,
                                projectId: projectId,
                                hasSeenReopenSpotlight: hasSeenReopenSpotlight
                            })
                        }).toPromise(),
                    totalAttempts: 5,
                    baseIntervalMs: 500
                });
                setState({
                    isSaving: false
                });
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.savePanelState succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'savePanelState',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});
parcelRegister("5G2eQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d9fb25724578ccf$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("iects");

var $fVqUX = parcelRequire("fVqUX");

var $88Osm = parcelRequire("88Osm");

var $7byHA = parcelRequire("7byHA");

var $bH2vr = parcelRequire("bH2vr");

var $etaBp = parcelRequire("etaBp");
const $0d9fb25724578ccf$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$0d9fb25724578ccf$export$2e2bcd8739ae039 = (url, options = {})=>(0, $3JafE.Observable).of(url).mergeMap(()=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $6HC1D.merge)((0, $6HC1D.merge)((0, $fVqUX.default), options), (0, $etaBp.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $88Osm.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $7byHA.default)(status);
        }
        if (response.status === $0d9fb25724578ccf$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $3JafE.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $3JafE.Observable).of(response.responseText || 'OK');
    });

});




parcelRegister("zvnJx", function(module, exports) {

$parcel$export(module.exports, "markReopenSpotlightAsSeen", () => $63ec54d2a46c288c$export$e6838fe71dc9c3f5);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");


var $8u09c = parcelRequire("8u09c");

var $3ZIER = parcelRequire("3ZIER");
const $63ec54d2a46c288c$export$e6838fe71dc9c3f5 = (actionProps)=>({ getState: getState, dispatch: dispatch })=>async ()=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to mark reopen spotlight as seen without current state');
                await dispatch((0, $3ZIER.savePanelState)(actionProps))({
                    ...data,
                    properties: {
                        ...data.properties,
                        user: {
                            ...data.properties.user,
                            hasSeenReopenSpotlight: (0, $8u09c.HasSeenReopenSpotlight).Yes
                        }
                    }
                });
                (0, $jMP2a.fireTrackAnalytics)(actionProps.createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.markReopenSpotlightAsSeen succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'markReopenSpotlightAsSeen',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});

parcelRegister("82jJZ", function(module, exports) {

$parcel$export(module.exports, "reopenGettingStartedPanel", () => $e6623632044ca83f$export$3f8a23b1578c0a37);

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");

var $3gGTI = parcelRequire("3gGTI");

var $8u09c = parcelRequire("8u09c");

var $lKOEf = parcelRequire("lKOEf");

var $aXUph = parcelRequire("aXUph");
const $e6623632044ca83f$export$3f8a23b1578c0a37 = (actionProps)=>({ getState: getState, dispatch: dispatch })=>async ({ projectId: projectId } = {})=>{
            const getStateIfLoaded = async ()=>{
                const state = getState();
                const dataNotYetLoaded = state.isGspInitialized && state.data === undefined;
                if (dataNotYetLoaded) throw new Error('GSP data not yet loaded when trying to reopen');
                return state;
            };
            try {
                // a user can exit a tour and call `reopenGettingStartedPanel` before the GSP
                // state has loaded so retry a few times and hopefully the data will be there.
                // This will only log the final error that is thrown after the retries are exhausted.
                // 6 attempts at 500ms base interval gives us a ~15 second window. We could wait longer
                // but then the GSP reopening would be so far removed from closing the tour that it
                // probably isn't the user experience that we want
                const { data: data, isGspInitialized: isGspInitialized } = await (0, $3gGTI.withExponentialBackoffRetries)({
                    callback: getStateIfLoaded,
                    totalAttempts: 6,
                    baseIntervalMs: 500
                });
                if (!isGspInitialized) {
                    if (projectId !== undefined) {
                        await dispatch((0, $lKOEf.initializeState)(actionProps))({
                            projectId: projectId
                        });
                        return;
                    }
                    throw new Error('No projectId to initialize GSP with');
                }
                if (!data) throw new Error('Trying to reopen GSP without current state');
                await dispatch((0, $aXUph.saveProperty)(actionProps))({
                    key: (0, $8u09c.PropertyKey).VisualState,
                    value: (0, $8u09c.VisualState).FullPanel
                });
                await dispatch((0, $aXUph.saveProperty)(actionProps))({
                    key: (0, $8u09c.PropertyKey).ActiveState,
                    value: (0, $8u09c.ActiveState).On
                });
                (0, $jMP2a.fireTrackAnalytics)(actionProps.createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.reopenGettingStartedPanel succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'reopenGettingStartedPanel',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});
parcelRegister("aXUph", function(module, exports) {

$parcel$export(module.exports, "saveProperty", () => $4fd2e9e2afb8272e$export$3d751d226e9d1512);

var $guiFP = parcelRequire("guiFP");

var $5G2eQ = parcelRequire("5G2eQ");

var $jMP2a = parcelRequire("jMP2a");

var $3gGTI = parcelRequire("3gGTI");
const $4fd2e9e2afb8272e$var$getUrl = ({ baseUrl: baseUrl, cloudId: cloudId })=>`${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/user/list/jsm-getting-started-panel/properties`;
const $4fd2e9e2afb8272e$export$3d751d226e9d1512 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async ({ key: key, value: value })=>{
            const { data: data } = getState();
            try {
                if (!data) throw new Error('Trying to save property without current GSP state.');
                // Set the state locally without waiting for the API call
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                [key.toString()]: value
                            }
                        }
                    },
                    isSaving: true
                });
                await (0, $3gGTI.withExponentialBackoffRetries)({
                    callback: ()=>(0, $5G2eQ.default)($4fd2e9e2afb8272e$var$getUrl({
                            baseUrl: baseUrl,
                            cloudId: cloudId
                        }), {
                            method: 'POST',
                            credentials: 'include',
                            body: JSON.stringify({
                                [key.toString()]: value
                            })
                        }).toPromise(),
                    totalAttempts: 5,
                    baseIntervalMs: 500
                });
                setState({
                    isSaving: false
                });
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.saveProperty succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'saveProperty',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };

});


parcelRegister("kYwcF", function(module, exports) {

$parcel$export(module.exports, "resolveTask", () => $e0acf0603356b206$export$7c43f246bcca61d3);

var $guiFP = parcelRequire("guiFP");

var $5G2eQ = parcelRequire("5G2eQ");

var $jMP2a = parcelRequire("jMP2a");

var $3gGTI = parcelRequire("3gGTI");

var $6vrw7 = parcelRequire("6vrw7");
// Data taken from https://hello.atlassian.net/wiki/spaces/VPORT/pages/808505558/Checklist+Item+Scope+Auto+API+for+Completion
// where 'project' === 'container', 'user' === 'user' and 'instance' === 'workspace'
const $e0acf0603356b206$var$getScopeFromTaskId = (taskId)=>{
    switch(taskId){
        // String literals used instead of `TaskId.<task>` for flow to acknowledge
        // that this is an exhaustive switch statement
        case 'servicedesk-itsm-project-created':
        case 'servicedesk-portal-name-customized':
        case 'servicedesk-logo-added-to-portal':
        case 'servicedesk-email-requests-setup':
        case 'servicedesk-team-member-added':
            return 'container';
        case 'servicedesk-change-management-documentation-accessed':
        case 'servicedesk-basics-documentation-accessed':
        case 'servicedesk-queue-configurations-reviewed':
        case 'servicedesk-request-types-customised':
        case 'servicedesk-request-channels-email-portal-requests-customised':
        case 'servicedesk-chat-requests-setup':
            return 'user';
        case 'servicedesk-services-setup':
        case 'servicedesk-change-management-pipeline-connected':
        case 'servicedesk-change-management-change-approvers-added':
        case 'servicedesk-change-management-automation-rules-on':
            return 'workspace';
        // Note that the following should only ever be completed in
        // Opsgenie but they are included here for type completeness
        case 'opsgenie-user-profile-notifications-setup':
        case 'opsgenie-incident-management-documentation-accessed':
            return 'user';
        case 'opsgenie-response-team-setup':
        case 'opsgenie-owner-team-assigned-to-service':
            return 'workspace';
        default:
            // prettier-ignore
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            taskId; // type level assertion that we have an exhaustive switch
            throw new Error(`Unknown scope for task ${taskId}`); // runtime assertion
    }
};
const $e0acf0603356b206$export$94df0e59ebebf4a7 = ({ baseUrl: baseUrl, cloudId: cloudId, scope: scope, projectId: projectId, taskId: taskId })=>{
    let scopePath = ''; // scope === 'workspace'
    if (scope === 'container') scopePath = `project/${projectId}/`;
    if (scope === 'user') scopePath = 'user/';
    return `${baseUrl}/jsm/onboarding/checklist/v1/cloudid/${cloudId}/${scopePath}list/jsm-getting-started-panel/item/${taskId}`;
};
const $e0acf0603356b206$export$7c43f246bcca61d3 = ({ baseUrl: baseUrl, cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState })=>async (taskId)=>{
            const { data: data } = getState();
            try {
                if (!data) return;
                const { completedItems: completedItems, properties: properties } = data;
                const isTaskAlreadyCompleted = completedItems.includes(taskId);
                if (!isTaskAlreadyCompleted) {
                    const updatedTasks = [
                        ...completedItems,
                        taskId
                    ];
                    // Set the state locally without waiting for the API call
                    setState({
                        data: {
                            ...data,
                            completedItems: updatedTasks
                        },
                        isSaving: true
                    });
                    // Hit the appropriate checklist scope endpoint to add the newly completed task
                    const scope = $e0acf0603356b206$var$getScopeFromTaskId(taskId);
                    const projectId = (0, $6vrw7.toProjectId)(properties.user.projectId || '');
                    await (0, $3gGTI.withExponentialBackoffRetries)({
                        callback: ()=>(0, $5G2eQ.default)($e0acf0603356b206$export$94df0e59ebebf4a7({
                                baseUrl: baseUrl,
                                cloudId: cloudId,
                                scope: scope,
                                projectId: projectId,
                                taskId: taskId
                            }), {
                                method: 'POST',
                                credentials: 'include'
                            }).toPromise(),
                        totalAttempts: 5,
                        baseIntervalMs: 500
                    });
                    // Resume polling for GSP state
                    setState({
                        isSaving: false
                    });
                }
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b)}.resolveTask succeeded`);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    isSaving: false
                });
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'resolveTask',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        teamName: 'itops-mithril'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        };

});

parcelRegister("1mctb", function(module, exports) {

$parcel$export(module.exports, "setOpsAdminTaskVisibility", () => $ac16bf64e18ce8db$export$b9e7846826f1ebfd);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");


var $4eEU1 = parcelRequire("4eEU1");
const $ac16bf64e18ce8db$export$b9e7846826f1ebfd = ({ teamId: teamId, cloudId: cloudId })=>({ getState: getState, setState: setState })=>async ()=>{
            const { data: data } = getState();
            if (!data) throw new Error('Trying to set ops admin task visibility without current GSP state.');
            try {
                const adminTaskVisibilityResponse = await (0, $2OdyW.default)(`/gateway/api/jsm/ops/web/${cloudId}/v1/onboarding/full-panel-access?platformTeamId=${teamId}
            `, {
                    method: 'GET'
                });
                const visibility = adminTaskVisibilityResponse.embeddedValue ? (0, $4eEU1.VisibilityValues).Visible : (0, $4eEU1.VisibilityValues).Hidden;
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                'ops-admin-tasks-visibility': visibility
                            }
                        }
                    }
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setState({
                    data: {
                        ...data,
                        properties: {
                            ...data.properties,
                            user: {
                                ...data.properties.user,
                                'ops-admin-tasks-visibility': (0, $4eEU1.VisibilityValues).Hidden
                            }
                        }
                    }
                });
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'setOpsAdminTaskVisibility',
                        packageName: (0, $ae3aa738acb13786$export$b8b9d90f9e5bd72b),
                        // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                        teamName: 'Alexstrasza'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };

});

parcelRegister("ghO9h", function(module, exports) {

$parcel$export(module.exports, "stopRecordingPerformanceExperiences", () => $73f30f16f4664d6e$export$3566fd94709fa84a);
const $73f30f16f4664d6e$export$3566fd94709fa84a = ()=>({ setState: setState })=>()=>{
            setState({
                shouldRecordPerformanceExperiences: false
            });
        };

});



parcelRegister("kKzsy", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $993d872dc7228c2f$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $993d872dc7228c2f$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $993d872dc7228c2f$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $993d872dc7228c2f$export$c7732c55900cf0b9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hfiyN")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanel = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("hTkS8")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("c3XjM")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("eTjqX")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $993d872dc7228c2f$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelShouldRender, null));
$993d872dc7228c2f$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $993d872dc7228c2f$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanel, null));
$993d872dc7228c2f$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $993d872dc7228c2f$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelOpenButton, null));
$993d872dc7228c2f$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $993d872dc7228c2f$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($993d872dc7228c2f$var$AsyncGettingStartedPanelReopenSpotlight, null));
$993d872dc7228c2f$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("hfiyN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kd6Ju');
        const value = parcelRequire('appSk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kd6Ju").then(()=>parcelRequire('appSk'));
}

});

parcelRegister("hTkS8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('5eFqM')
        ]);
        const value = parcelRequire('ddfk6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("5eFqM")
    ]).then(()=>parcelRequire('ddfk6'));
}

});

parcelRegister("c3XjM", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('ahRif')
        ]);
        const value = parcelRequire('1HvEW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("ahRif")
    ]).then(()=>parcelRequire('1HvEW'));
}

});

parcelRegister("eTjqX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('cxrYi')
        ]);
        const value = parcelRequire('f9sDQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("cxrYi")
    ]).then(()=>parcelRequire('f9sDQ'));
}

});


parcelRegister("3e4zR", function(module, exports) {

$parcel$export(module.exports, "useInitializeActiveTab", () => $fca831ba939738e0$export$b0f185249c3d08fd);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $2j5ni = parcelRequire("2j5ni");

var $dWvpo = parcelRequire("dWvpo");

var $8GtZ0 = parcelRequire("8GtZ0");
var $8u09c = parcelRequire("8u09c");
const $fca831ba939738e0$export$b0f185249c3d08fd = (activeTabName, gspProjectId)=>{
    const { isFirstProject: isFirstProject, isFirstProjectItsm: isFirstProjectItsm } = (0, $2j5ni.useIsFirstProjectITSM)(gspProjectId);
    const isNpleForItsmEnabled = isFirstProject && isFirstProjectItsm && (0, $79xbN.expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation');
    const [{ data: gspStateData }, { saveProperty: saveProperty }] = (0, $dWvpo.useGettingStartedPanelState)();
    const [isInitializedActiveTab, setIsInitializedActiveTab] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (activeTabName === '') return;
        if (!isInitializedActiveTab && isNpleForItsmEnabled && gspStateData) {
            const sectionStateJSON = gspStateData.properties?.user?.sectionState ?? (0, $8GtZ0.defaultGspState).properties.user.sectionState;
            const sectionState = JSON.parse(sectionStateJSON);
            if (sectionState.sections.checklist.activeTab !== activeTabName) {
                sectionState.sections.checklist.activeTab = activeTabName;
                saveProperty({
                    key: (0, $8u09c.PropertyKey).SectionState,
                    value: JSON.stringify(sectionState)
                });
            }
            setIsInitializedActiveTab(true);
        }
    }, [
        isNpleForItsmEnabled,
        gspStateData,
        saveProperty,
        activeTabName,
        isInitializedActiveTab
    ]);
    const resetInitialization = ()=>setIsInitializedActiveTab(false);
    return {
        resetInitialization: resetInitialization
    };
};

});

parcelRegister("51ACp", function(module, exports) {

$parcel$export(module.exports, "HistoryAdapter", () => $7c9b058abf515682$export$d852f51b8427aefc);

var $eUqFw = parcelRequire("eUqFw");

var $4tHLE = parcelRequire("4tHLE");

var $dsNuc = parcelRequire("dsNuc");
// eslint-disable-next-line jira/react/no-class-components
class $7c9b058abf515682$var$HistoryAdapterComponent extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.compatibleHistory = (0, $dsNuc.createReactRouterCompatibleHistory)(props.history);
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.children !== this.props.children;
    }
    componentWillUnmount() {
        this.compatibleHistory.destroy && this.compatibleHistory.destroy();
    }
    render() {
        const { children: children } = this.props;
        return children(this.compatibleHistory);
    }
}
const $7c9b058abf515682$export$d852f51b8427aefc = (0, $4tHLE.withRouter)($7c9b058abf515682$var$HistoryAdapterComponent);

});
parcelRegister("dsNuc", function(module, exports) {

$parcel$export(module.exports, "createReactRouterCompatibleHistory", () => $03e13d3d865e0b52$export$2df73cd79c2401bf);

var $6l6Xk = parcelRequire("6l6Xk");
const $03e13d3d865e0b52$export$2df73cd79c2401bf = (history)=>{
    let cleaned = false;
    let listeners = [];
    // @ts-expect-error - TS2304 - Cannot find name 'HistoryAction'.
    const listen = (callback)=>{
        if (cleaned) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const unsubscribe = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(history.listen(callback));
        const listener = {
            unsubscribe: unsubscribe
        };
        listeners.push(listener);
        return (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(()=>{
            listener.unsubscribe();
        });
    };
    const cleanup = ()=>{
        listeners.forEach(({ unsubscribe: unsubscribe })=>{
            unsubscribe();
        });
        cleaned = true;
        listeners = [];
    };
    return {
        get length () {
            return history.length;
        },
        get location () {
            return history.location;
        },
        get action () {
            return history.action;
        },
        get index () {
            return history.index;
        },
        get entries () {
            return history.entries;
        },
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        push: (path, state)=>history.push(path, state),
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        replace: (path, state)=>history.replace(path, state),
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        go: (n)=>history.go(n),
        goBack: ()=>history.goBack(),
        goForward: ()=>history.goForward(),
        // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
        createHref: (...args)=>history.createHref(...args),
        // Memory only
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        canGo: (n)=>{
            if (history.canGo) return history.canGo(n);
            return true;
        },
        listen: listen,
        // @ts-expect-error - TS7006 - Parameter 'blocker' implicitly has an 'any' type.
        block: (blocker)=>history.block(blocker),
        destroy: cleanup
    };
};

});


parcelRegister("3e9vj", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $f75608ebab912e29$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $f75608ebab912e29$export$b0d8f74f433a09c9);

var $gd0Sp = parcelRequire("gd0Sp");
const $f75608ebab912e29$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $f75608ebab912e29$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext?.environment || $f75608ebab912e29$var$ENVIRONMENT.PROD;
};
const $f75608ebab912e29$export$b0d8f74f433a09c9 = ()=>{
    const env = $f75608ebab912e29$export$ea7ed2425832167d();
    return env === $f75608ebab912e29$var$ENVIRONMENT.STAGING || env === $f75608ebab912e29$var$ENVIRONMENT.DEV || env === $f75608ebab912e29$var$ENVIRONMENT.LOCAL;
};

});

parcelRegister("4xHig", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $d8981c42d4d07028$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $d8981c42d4d07028$export$31652d9c30d7d3f3);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $ao0hp = parcelRequire("ao0hp");

var $gd0Sp = parcelRequire("gd0Sp");
const $d8981c42d4d07028$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $ao0hp.defaultLocale);
};
const $d8981c42d4d07028$export$31652d9c30d7d3f3 = ()=>{
    const locale = $d8981c42d4d07028$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $eUqFw.useMemo)(()=>(0, $ao0hp.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

parcelRegister("9J3fC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e98daa64b3e2536$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Rbdp = parcelRequire("4Rbdp");
var $7YLRZ = parcelRequire("7YLRZ");

var $37mOt = parcelRequire("37mOt");

var $lxT0c = parcelRequire("lxT0c");

const $4e98daa64b3e2536$var$EmbeddableDirectory = (props)=>{
    const { addFlag: addFlag, appName: appName, contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, locale: locale, push: push, replace: replace, docTitle: docTitle, statusCodeHandlers: statusCodeHandlers, env: env, history: history, isSentryEnabled: isSentryEnabled = true, cloudId: cloudId, orgId: orgId, teamCentralHandlers: teamCentralHandlers, subProduct: subProduct, productFeatureFlags: productFeatureFlags, invitePeopleHandlers: invitePeopleHandlers } = props;
    if (env) (0, $37mOt.setEnv)(env);
    const analyticsClient = (0, $4Rbdp.useSetupAnalyticsClient)(cloudId, appName, subProduct);
    const apolloClient = (0, $7YLRZ.useSetupApolloClient)(cloudId);
    if (!analyticsClient) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxT0c.default), {
        apolloClient: apolloClient,
        analytics: analyticsClient,
        appName: appName,
        contextSpaPaths: contextSpaPaths,
        contextEntryPoint: contextEntryPoint,
        env: env,
        push: push,
        replace: replace,
        addFlag: addFlag,
        locale: locale,
        docTitle: docTitle,
        statusCodeHandlers: statusCodeHandlers,
        history: history,
        cloudId: cloudId,
        orgId: orgId,
        teamCentralHandlers: teamCentralHandlers,
        skipI18nProvider: false,
        productFeatureFlags: productFeatureFlags,
        invitePeopleHandlers: invitePeopleHandlers,
        isSentryEnabled: isSentryEnabled
    });
};
var $4e98daa64b3e2536$export$2e2bcd8739ae039 = $4e98daa64b3e2536$var$EmbeddableDirectory;

});
parcelRegister("4Rbdp", function(module, exports) {

$parcel$export(module.exports, "useSetupAnalyticsClient", () => $dd2f4903c9dec189$export$bcd55e98e7c6e45e);

var $eUqFw = parcelRequire("eUqFw");

var $e6nUx = parcelRequire("e6nUx");
function $dd2f4903c9dec189$var$getAnalyticsSubproduct(appName, subProduct) {
    if (!subProduct) return appName;
    return `jira-${subProduct}-directory`;
}
function $dd2f4903c9dec189$export$bcd55e98e7c6e45e(cloudId, appName, subProduct) {
    const analyticsSubProduct = (0, $eUqFw.useMemo)(()=>$dd2f4903c9dec189$var$getAnalyticsSubproduct(appName, subProduct), [
        appName,
        subProduct
    ]);
    const [analyticsClient, setAnalyticsClient] = (0, $eUqFw.useState)((0, $e6nUx.getAnalyticsClient)({
        mode: appName,
        subproduct: analyticsSubProduct,
        cloudId: cloudId
    }));
    // setup analytics object
    (0, $eUqFw.useEffect)(()=>{
        if (!cloudId) return;
        const analytics = (0, $e6nUx.getAnalyticsClient)({
            mode: appName,
            subproduct: analyticsSubProduct,
            cloudId: cloudId
        });
        setAnalyticsClient(analytics);
    }, [
        cloudId,
        analyticsSubProduct,
        appName
    ]);
    // TODO: fix-me - currently, cloudId is required to render People app.
    // When analytics client without cloud id is used, Cypress test `dev-packages/cypress/src/specs/analytics.spec.ts` is flaky.
    // It seems that the analytics client without cloud id used first, then analytics client with cloud is replaced, but the app does not re-render in Cypress tests.
    return cloudId ? analyticsClient : undefined;
}

});
parcelRegister("e6nUx", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsClient", () => $c74395c9cb33ba3a$export$fde53e78fd93a54d);

var $dNAsL = parcelRequire("dNAsL");
var $1C9jQ = parcelRequire("1C9jQ");

var $4GU27 = parcelRequire("4GU27");
var $avLBj = parcelRequire("avLBj");
var $37mOt = parcelRequire("37mOt");

var $aPkDp = parcelRequire("aPkDp");

var $1io2n = parcelRequire("1io2n");

var $hh0j4 = parcelRequire("hh0j4");

var $bsMUn = parcelRequire("bsMUn");
function $c74395c9cb33ba3a$var$getServerName() {
    return window.location.hostname;
}
const { LOCAL: $c74395c9cb33ba3a$var$LOCAL, DEV: $c74395c9cb33ba3a$var$DEV, STAGING: $c74395c9cb33ba3a$var$STAGING, PROD: $c74395c9cb33ba3a$var$PROD } = (0, $1C9jQ.envType);
const $c74395c9cb33ba3a$var$ENV_MAP = {
    local: $c74395c9cb33ba3a$var$LOCAL,
    test: $c74395c9cb33ba3a$var$LOCAL,
    adev: $c74395c9cb33ba3a$var$DEV,
    'stg-east': $c74395c9cb33ba3a$var$STAGING,
    stg: $c74395c9cb33ba3a$var$STAGING
};
const $c74395c9cb33ba3a$var$getEnvType = (env)=>{
    return $c74395c9cb33ba3a$var$ENV_MAP[env] || $c74395c9cb33ba3a$var$PROD;
};
const $c74395c9cb33ba3a$var$analyticsConfig = (0, $avLBj.getConfig)().analytics;
const $c74395c9cb33ba3a$var$SUB_PRODUCT_DEFAULT = 'siteDirectory';
const $c74395c9cb33ba3a$var$PRODUCT_DEFAULT = 'people';
class $c74395c9cb33ba3a$var$AnalyticsClient {
    constructor(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    options = {}, { commonProperties: commonProperties = {}, eventPrefix: eventPrefix = 'atlassian.people', subproduct: subproduct = $c74395c9cb33ba3a$var$SUB_PRODUCT_DEFAULT, cloudId: cloudId = '' } = {}){
        const customOptions = {
            commonProperties: commonProperties,
            eventPrefix: eventPrefix
        };
        this.cloudId = cloudId;
        this.commonProperties = customOptions.commonProperties;
        this.eventPrefix = customOptions.eventPrefix;
        this.state = {
            analyticsscheme: $c74395c9cb33ba3a$var$analyticsConfig.scheme,
            analyticsserver: $c74395c9cb33ba3a$var$analyticsConfig.server,
            server: $c74395c9cb33ba3a$var$getServerName(),
            product: $c74395c9cb33ba3a$var$PRODUCT_DEFAULT,
            isReadyToSend: false,
            pendingEventsQueue: [],
            storage_key: 'atlassian.people.analytics',
            ...options
        };
        // New GAS pipeline client
        this.analyticsWebClient = new (0, $dNAsL.default)({
            env: $c74395c9cb33ba3a$var$getEnvType((0, $37mOt.getEnv)()),
            product: 'people',
            subproduct: subproduct
        }, {});
        this.initUFO();
        this._expTracker = (0, $hh0j4.configureNewTracker)(this);
    }
    setTeamId(teamId) {
        this.teamId = teamId;
    }
    initUFO() {
        if ((0, $4GU27.getAppName)() !== (0, $4GU27.AppNames).STANDALONE_DIRECTORY) return;
        (0, $aPkDp.payloadPublisher).setup({
            gasv3: this.analyticsWebClient,
            product: 'people',
            app: {
                // @ts-ignore
                version: {
                    web: __VERSION__
                }
            },
            region: (0, $37mOt.getEnv)()
        });
    // import { ufologger } from @atlassian/ufo and uncomment the following line to see UFO logs:
    // ufologger.enable();
    }
    getAnalyticsWebClient() {
        return this.analyticsWebClient;
    }
    expTracker() {
        return this._expTracker;
    }
    sendTrackEvent(eventData) {
        this.analyticsWebClient.sendTrackEvent(eventData);
    }
    /**
	 * Checks whether the library has been initialized and decides whether the event should be sent or cached
	 * @param {*} eventType Values could be 'track', 'screen', 'operation, 'ui'
	 * @param {*} eventData Data of the event
	 * @param {Function} cb Callback is called when the event is sent successfully.
	 */ canEventBeSent(eventType, eventData, cb) {
        if (this.state.isReadyToSend) return true;
        // add to `pendingEventsQueue` in order to send the event later
        this.state.pendingEventsQueue.push({
            eventType: eventType,
            eventData: eventData,
            // `eventCallback` is called when `pendingEventsQueue` is processed and eventData is sent
            eventCallback: cb
        });
        return false;
    }
    pushTrackEvent(eventData, cb) {
        if (this.canEventBeSent('track', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendTrackEvent(event, cb);
        }
    }
    pushUIEvent(eventData, cb) {
        if (this.canEventBeSent('ui', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendUIEvent(event, cb);
        }
    }
    pushOperationalEvent(eventData, cb) {
        if (this.canEventBeSent('operation', eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendOperationalEvent(event, cb);
        }
    }
    pushScreenEvent(eventData, cb) {
        const additionalAttributes = (0, $bsMUn.default).get();
        (0, $bsMUn.default).markUsed();
        if (eventData && additionalAttributes) eventData = {
            ...eventData,
            attributes: {
                ...additionalAttributes,
                ...eventData.attributes
            }
        };
        if (this.canEventBeSent('screen', eventData, cb)) this.analyticsWebClient.sendScreenEvent(eventData, cb);
    }
    buildEventPayload(eventData) {
        const attributes = this.teamId || eventData.attributes ? {
            ...this.teamId && {
                teamId: this.teamId
            },
            ...eventData.attributes
        } : null;
        return {
            containerType: null,
            containerId: null,
            objectType: null,
            objectId: null,
            source: null,
            actionSubject: null,
            action: null,
            actionSubjectId: null,
            tags: [],
            ...eventData,
            attributes: attributes
        };
    }
    mapAnalyticsKeyToEvent(analyticsKey) {
        return (0, $1io2n.analyticsKeyToEventMap)[analyticsKey] || null;
    }
    /**
	 *  Start up E-MAU events in the new analytics pipeline (GAS v3)
	 *  See: https://extranet.atlassian.com/display/BPO/DACI%3A+E-MAU+Definition
	 */ async startUIViewedEvent(principalUserId) {
        if (!principalUserId) return;
        this.analyticsWebClient.setTenantInfo((0, $1C9jQ.tenantType).CLOUD_ID, this.cloudId || '');
        this.analyticsWebClient.setUserInfo((0, $1C9jQ.userType).ATLASSIAN_ACCOUNT, principalUserId);
        this.analyticsWebClient.startUIViewedEvent();
        this.state.isReadyToSend = true;
        this.flushPendingEventsQueue();
    }
    /**
	 * Flush all the pending events in the queue
	 */ flushPendingEventsQueue() {
        this.state.pendingEventsQueue.forEach((element)=>{
            const { eventType: eventType, eventData: eventData, eventCallback: eventCallback } = element;
            switch(eventType){
                case 'track':
                    this.pushTrackEvent(eventData, eventCallback);
                    break;
                case 'ui':
                    this.pushUIEvent(eventData, eventCallback);
                    break;
                case 'screen':
                    this.pushScreenEvent(eventData, eventCallback);
                    break;
                case 'operation':
                    this.pushOperationalEvent(eventData, eventCallback);
                    break;
                default:
                    // eslint-disable-next-line no-console
                    console.error('Invalide Event :', element);
                    break;
            }
        });
    }
}
var $c74395c9cb33ba3a$export$2e2bcd8739ae039 = $c74395c9cb33ba3a$var$AnalyticsClient;
let $c74395c9cb33ba3a$var$preservedAnaylticsClient;
const $c74395c9cb33ba3a$export$fde53e78fd93a54d = ({ mode: mode, subproduct: subproduct, cloudId: cloudId })=>{
    if (!cloudId) return;
    if ($c74395c9cb33ba3a$var$preservedAnaylticsClient) return $c74395c9cb33ba3a$var$preservedAnaylticsClient;
    $c74395c9cb33ba3a$var$preservedAnaylticsClient = new $c74395c9cb33ba3a$var$AnalyticsClient({}, {
        commonProperties: {
            mode: mode
        },
        subproduct: subproduct,
        cloudId: cloudId
    });
    return $c74395c9cb33ba3a$var$preservedAnaylticsClient;
};

});
parcelRegister("4GU27", function(module, exports) {

$parcel$export(module.exports, "AppNames", () => $12268ee2ffd3be16$export$b767e803e7ca9563);
$parcel$export(module.exports, "getAppName", () => $12268ee2ffd3be16$export$dcecb2dbc7fe753c);
var $12268ee2ffd3be16$export$b767e803e7ca9563;
(function(AppNames) {
    AppNames["EMBEDDABLE_DIRECTORY"] = "embeddableDirectory";
    AppNames["STANDALONE_DIRECTORY"] = "standaloneDirectory";
})($12268ee2ffd3be16$export$b767e803e7ca9563 || ($12268ee2ffd3be16$export$b767e803e7ca9563 = {}));
function $12268ee2ffd3be16$export$dcecb2dbc7fe753c() {
    // @ts-ignore
    return window.__app_name__ || "embeddableDirectory";
}

});

parcelRegister("avLBj", function(module, exports) {

$parcel$export(module.exports, "isFedramp", () => $3c24c4ec25204a15$export$634ecc602a6871aa);
$parcel$export(module.exports, "getConfig", () => $3c24c4ec25204a15$export$44487a86467333c3);

var $1Zvbf = parcelRequire("1Zvbf");

var $dfBCt = parcelRequire("dfBCt");

var $4GU27 = parcelRequire("4GU27");

var $37mOt = parcelRequire("37mOt");

var $fU34a = parcelRequire("fU34a");
// default configs is also config for production env
const $3c24c4ec25204a15$var$productionConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.atlassian.com',
    teamCentralReactionUrl: '/gateway/api/watermelon/reactions'
};
const $3c24c4ec25204a15$var$devAndStagingConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com',
    teamCentralReactionUrl: '/gateway/api/watermelon/reactions'
};
const $3c24c4ec25204a15$var$localAndTestConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'http',
        server: 'localhost:3000'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard',
    teamCentralUrl: 'https://team.stg.atlassian.com',
    teamCentralReactionUrl: '/gateway/api/watermelon/reactions'
};
const $3c24c4ec25204a15$var$fedrampConfig = {
    stargateRoot: '/gateway/api',
    analytics: {
        scheme: 'https',
        server: 'analytics.atlassian.com'
    },
    feedbackIssueCollectorId: '908df207',
    atlassianAccountUrl: 'https://id.atlassian-us-gov-mod.com',
    permsServiceUrl: '/gateway/api/permissions',
    collaborationGraph: '/gateway/api/collaboration',
    emojiUrl: '/gateway/api/emoji/standard'
};
const $3c24c4ec25204a15$var$EnvOverrideKeys = [
    'adev',
    'stg-east',
    'local',
    'test',
    'fedramp',
    'prod-east'
];
const $3c24c4ec25204a15$var$environmentOverrides = {
    'prod-east': $3c24c4ec25204a15$var$productionConfig,
    local: {
        ...(0, $fU34a.LOCAL_PRODUCTION_BACKEND) ? $3c24c4ec25204a15$var$productionConfig : $3c24c4ec25204a15$var$localAndTestConfig,
        analytics: {
            scheme: 'http',
            server: `${(0, (/*@__PURE__*/$parcel$interopDefault($1Zvbf))).location.hostname}:3000`
        }
    },
    test: {
        ...$3c24c4ec25204a15$var$localAndTestConfig
    },
    adev: $3c24c4ec25204a15$var$devAndStagingConfig,
    'stg-east': $3c24c4ec25204a15$var$devAndStagingConfig,
    fedramp: $3c24c4ec25204a15$var$fedrampConfig
};
const $3c24c4ec25204a15$var$cachedConfig = {};
function $3c24c4ec25204a15$export$634ecc602a6871aa() {
    return (0, $dfBCt.isFedRamp)();
}
function $3c24c4ec25204a15$export$44487a86467333c3() {
    const env = $3c24c4ec25204a15$export$634ecc602a6871aa() ? 'fedramp' : (0, $37mOt.getEnv)();
    const appName = (0, $4GU27.getAppName)();
    const key = `${env}_${appName}`;
    if (!$3c24c4ec25204a15$var$cachedConfig[key]) {
        if ($3c24c4ec25204a15$var$EnvOverrideKeys.includes(env)) $3c24c4ec25204a15$var$cachedConfig[key] = {
            ...$3c24c4ec25204a15$var$environmentOverrides[env]
        };
        else // fallback to prod as customers can have custom domains.
        $3c24c4ec25204a15$var$cachedConfig[key] = {
            ...$3c24c4ec25204a15$var$environmentOverrides['prod-east']
        };
    }
    return $3c24c4ec25204a15$var$cachedConfig[key];
}

});
parcelRegister("37mOt", function(module, exports) {

$parcel$export(module.exports, "setEnv", () => $90cb06051ad5805a$export$84bc02d3c7a6b55f);
$parcel$export(module.exports, "getEnv", () => $90cb06051ad5805a$export$4bd44a2aa29d3d6e);

var $1Zvbf = parcelRequire("1Zvbf");

var $fU34a = parcelRequire("fU34a");
var $90cb06051ad5805a$export$e7dfafc24fab792e;
(function(MicrosEnv) {
    MicrosEnv["ADEV"] = "adev";
    MicrosEnv["STG_EAST"] = "stg-east";
    MicrosEnv["PROD_EAST"] = "prod-east";
})($90cb06051ad5805a$export$e7dfafc24fab792e || ($90cb06051ad5805a$export$e7dfafc24fab792e = {}));
const $90cb06051ad5805a$export$d76bdf9f4281ae1b = {
    local: 'local',
    test: 'test',
    prod: 'prod',
    stg: 'staging',
    ["adev"]: 'staging',
    ["stg-east"]: 'staging',
    ["prod-east"]: 'production'
};
const $90cb06051ad5805a$var$SIMPLE_TO_DAMN_COMPLEX_ENV = {
    prod: 'prod-east',
    stg: 'stg-east'
};
let $90cb06051ad5805a$var$presetEnv;
const $90cb06051ad5805a$export$84bc02d3c7a6b55f = (env)=>{
    const envOverride = $90cb06051ad5805a$var$SIMPLE_TO_DAMN_COMPLEX_ENV[env];
    if (envOverride) $90cb06051ad5805a$var$presetEnv = envOverride;
};
function $90cb06051ad5805a$export$4bd44a2aa29d3d6e() {
    if ($90cb06051ad5805a$var$presetEnv) return $90cb06051ad5805a$var$presetEnv;
    if (0, $fU34a.DEV) return 'local';
    // @ts-ignore
    return (0, (/*@__PURE__*/$parcel$interopDefault($1Zvbf))).__env__;
}
function $90cb06051ad5805a$export$15b8d8b1ba394f55() {
    return $90cb06051ad5805a$export$d76bdf9f4281ae1b[$90cb06051ad5805a$export$4bd44a2aa29d3d6e()];
}

});
parcelRegister("fU34a", function(module, exports) {

$parcel$export(module.exports, "DEV", () => $2486455d18d42cfe$export$404582bc18fe4d9e);
$parcel$export(module.exports, "LOCAL_PRODUCTION_BACKEND", () => $2486455d18d42cfe$export$771a63345d182ddd);
// @ts-ignore
const $2486455d18d42cfe$export$404582bc18fe4d9e = typeof __DEV__ !== 'undefined' && __DEV__;
const $2486455d18d42cfe$export$771a63345d182ddd = // @ts-ignore
typeof __LOCAL_PRODUCTION_BACKEND__ !== 'undefined' && // @ts-ignore
__LOCAL_PRODUCTION_BACKEND__;

});



parcelRegister("1io2n", function(module, exports) {

$parcel$export(module.exports, "AnalyticsKeys", () => $5d8ec327ad207f5d$export$e8d1ded05852e864);
$parcel$export(module.exports, "analyticsKeyToEventMap", () => $5d8ec327ad207f5d$export$6430c2bbc66a6fa);
$parcel$export(module.exports, "AnalyticsEventSource", () => $5d8ec327ad207f5d$export$2102531865f3e90e);
$parcel$export(module.exports, "AnalyticsEventActions", () => $5d8ec327ad207f5d$export$74eee170ad238aae);
$parcel$export(module.exports, "AnalyticsEventSubjects", () => $5d8ec327ad207f5d$export$670f80b77450980d);
const $5d8ec327ad207f5d$export$e8d1ded05852e864 = {
    ACTIVITY_ALL_VIEW: 'activity.all.view',
    ACTIVITY_WATCHING_VIEW: 'activity.watching.view',
    HISTORY_VIEW: 'history.view',
    PEOPLE_VIEW: 'people-search.view',
    PROFILE_PAGE_VIEW: 'profile-page.view',
    AGENT_PROFILE_PAGE_VIEW: 'agent-profile-page.view',
    PROFILE_WORKED_ON_PAGE_VIEW: 'profile-worked-on-page.view',
    PROFILE_SETTINGS_CLOSE_ACCOUNT_VIEW: 'profile-settings.close-account.view',
    PROFILE_SETTINGS_EMAIL_VIEW: 'profile-settings.email.view',
    PROFILE_SETTINGS_GENERAL_VIEW: 'profile-settings.general.view',
    PROFILE_SETTINGS_PROFILE_AND_VISIBILITY_VIEW: 'profile-settings.profile-and-visibility.view',
    PROFILE_SETTINGS_PRIVACY_VIEW: 'profile-settings.privacy.view',
    PROFILE_SETTINGS_PRODUCT_VIEW: 'profile-settings.product.view',
    PROFILE_SETTINGS_SECURITY_VIEW: 'profile-settings.security.view',
    PROFILE_SETTINGS_TWO_STEP_VERIFICATION_VIEW: 'profile-settings.security.two-step-verification.view',
    PROFILE_SETTINGS_API_TOKENS_VIEW: 'profile-settings.security.api-tokens.view',
    PROFILE_SETTINGS_RECENT_DEVICES_VIEW: 'profile-settings.security.recent-devices.view',
    PROFILE_SETTINGS_CONNECTED_APPS_VIEW: 'profile-settings.connected-apps.view',
    TEAM_PROFILE_VIEW: 'team-profile.view',
    KUDOS_PAGE_VIEW: 'kudos-page.view',
    TEAM_PROFILE_BROWSE_ALL: 'team-profile.browse-all',
    ALL_TEAMS_DISABLED: 'profile-search.view.all-teams.disabled',
    // TODO: remove these once we move to a new analytics platform
    LEGACY_ACTIVITY_ALL_VIEW: 'newsfeed.view'
};
const $5d8ec327ad207f5d$export$6430c2bbc66a6fa = {
    [$5d8ec327ad207f5d$export$e8d1ded05852e864.PROFILE_PAGE_VIEW]: 'userProfile',
    [$5d8ec327ad207f5d$export$e8d1ded05852e864.TEAM_PROFILE_BROWSE_ALL]: 'teamsPage'
};
var $5d8ec327ad207f5d$export$2102531865f3e90e;
(function(AnalyticsEventSource) {
    // `/people/<userId>` page
    AnalyticsEventSource["USER_PROFILE_SCREEN"] = "userProfileScreen";
    AnalyticsEventSource["USER_PROFILE_ABOUT"] = "userProfileAbout";
    // `/people/<userId>/work` page
    AnalyticsEventSource["USER_WORK_SCREEN"] = "userWorkScreen";
    // `/people/team/<teamId>` page
    AnalyticsEventSource["TEAM_PROFILE_SCREEN"] = "teamProfileScreen";
    AnalyticsEventSource["TEAM_PROFILE_ABOUT"] = "teamProfileAbout";
    AnalyticsEventSource["TEAM_RESTORE_SCREEN"] = "teamRestoreScreen";
    AnalyticsEventSource["TEAM_RESTORE_SUCCESS_FLAG"] = "teamReactivatedSuccessflag";
    AnalyticsEventSource["TEAM_RESTORE_ERROR_FLAG"] = "teamReactivatedErrorflag";
    AnalyticsEventSource["CREATE_TEAM_MODAL"] = "createTeamModal";
    // `/people/search` page
    AnalyticsEventSource["DIRECTORY_SCREEN"] = "directoryScreen";
    // new `/people/search` page
    AnalyticsEventSource["PEOPLE_HOME"] = "peopleHome";
    AnalyticsEventSource["PEOPLE_DRAWER"] = "peopleDrawer";
    // inside avatar menu
    AnalyticsEventSource["USER_MENU"] = "userMenu";
    // experimentLeaf */
    AnalyticsEventSource["ADD_PEOPLE_MODAL"] = "addPeopleModal";
    // generic metrics
    AnalyticsEventSource["CLIENT_METRICS"] = "clientMetrics";
    // generic metrics
    AnalyticsEventSource["DIRECTORY_APP"] = "directoryApp";
    AnalyticsEventSource["INITIALS_DIALOG"] = "avatarInitialsPicker";
    // /people/kudos/:uuid
    AnalyticsEventSource["KUDOS_SCREEN"] = "kudos";
    AnalyticsEventSource["PROFILE_CARD"] = "profilecard";
    // new `/people/search/teams` page
    AnalyticsEventSource["TEAMS_PAGE"] = "teamsPage";
})($5d8ec327ad207f5d$export$2102531865f3e90e || ($5d8ec327ad207f5d$export$2102531865f3e90e = {}));
var $5d8ec327ad207f5d$export$74eee170ad238aae;
(function(AnalyticsEventActions) {
    AnalyticsEventActions["ACCEPTED"] = "accepted";
    AnalyticsEventActions["CLICKED"] = "clicked";
    AnalyticsEventActions["CLOSED"] = "closed";
    AnalyticsEventActions["COLLAPSED"] = "collapsed";
    AnalyticsEventActions["CREATED"] = "created";
    AnalyticsEventActions["DECLINED"] = "declined";
    AnalyticsEventActions["DELETED"] = "deleted";
    AnalyticsEventActions["EDITED"] = "edited";
    AnalyticsEventActions["EXPANDED"] = "expanded";
    AnalyticsEventActions["EXPOSED"] = "exposed";
    AnalyticsEventActions["FAILED"] = "failed";
    AnalyticsEventActions["JOINED"] = "joined";
    AnalyticsEventActions["REDIRECTED"] = "redirected";
    AnalyticsEventActions["REMOVED"] = "removed";
    AnalyticsEventActions["SENT"] = "sent";
    AnalyticsEventActions["SORTED"] = "sorted";
    AnalyticsEventActions["STARTED"] = "started";
    AnalyticsEventActions["OPENED"] = "opened";
    AnalyticsEventActions["SHOWN"] = "shown";
    AnalyticsEventActions["SUBMITTED"] = "submitted";
    AnalyticsEventActions["SUCCEEDED"] = "succeeded";
    AnalyticsEventActions["TRIGGERED"] = "triggered";
    AnalyticsEventActions["TYPED"] = "typed";
    AnalyticsEventActions["VIEWED"] = "viewed";
    AnalyticsEventActions["MOUNTED"] = "mounted";
    AnalyticsEventActions["MOVED"] = "moved";
    AnalyticsEventActions["DRAGGED"] = "dragged";
    AnalyticsEventActions["SELECTED"] = "selected";
})($5d8ec327ad207f5d$export$74eee170ad238aae || ($5d8ec327ad207f5d$export$74eee170ad238aae = {}));
var $5d8ec327ad207f5d$export$670f80b77450980d;
(function(AnalyticsEventSubjects) {
    AnalyticsEventSubjects["TEAM_LINK"] = "teamLink";
    AnalyticsEventSubjects["BUTTON"] = "button";
    AnalyticsEventSubjects["MODAL_DIALOG"] = "modalDialog";
    AnalyticsEventSubjects["FORM"] = "form";
    AnalyticsEventSubjects["ERROR"] = "error";
})($5d8ec327ad207f5d$export$670f80b77450980d || ($5d8ec327ad207f5d$export$670f80b77450980d = {}));

});

parcelRegister("hh0j4", function(module, exports) {

$parcel$export(module.exports, "configureNewTracker", () => $2039e55a38e3127d$export$54c7ecd74762af6a);
$parcel$export(module.exports, "isNetworkError", () => $2039e55a38e3127d$export$476aa014e2fd89d5);

var $hUYqC = parcelRequire("hUYqC");

var $4GU27 = parcelRequire("4GU27");

var $1io2n = parcelRequire("1io2n");

var $3MeXN = parcelRequire("3MeXN");

var $3W7Kz = parcelRequire("3W7Kz");

var $fECJU = parcelRequire("fECJU");
function $2039e55a38e3127d$export$54c7ecd74762af6a(analytics) {
    const tracker = new $2039e55a38e3127d$var$DirectoryExperienceTracker({
        isNetworkOfflineError: $2039e55a38e3127d$export$476aa014e2fd89d5
    });
    tracker.subscribe((event)=>{
        if (event.action === 'taskStart' || event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail') {
            const performanceAttributes = $2039e55a38e3127d$var$computePerformanceAttributes(event);
            const errorAttributes = $2039e55a38e3127d$var$computeErrorAttributes(event);
            const finalErrorDetails = Object.assign(errorAttributes, performanceAttributes, event.attributes, {
                // Because standalone app is deployed to prod quickly,
                // we will use this attribute to query in Splunk sooner.
                isStandalone: (0, $4GU27.getAppName)() === (0, $4GU27.AppNames).STANDALONE_DIRECTORY,
                hasBrowseUsersPermission: (0, $3MeXN.isFlagEnabled)((0, $26c363c9409b0d5d$export$28456d095a642fd))
            });
            const actionSubject = $2039e55a38e3127d$var$sanitiseExperienceName(event.name);
            analytics.pushOperationalEvent({
                source: (0, $1io2n.AnalyticsEventSource).CLIENT_METRICS,
                actionSubject: actionSubject,
                action: event.action,
                attributes: finalErrorDetails
            });
            if (event.action === 'taskFail') (0, $fECJU.logErrorMessage)(`taskFail:${actionSubject}`, finalErrorDetails);
        }
    });
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('unload', ()=>{
        tracker.abort({
            reason: 'Abort due to Window unloading',
            attributes: {
                cause: 'WINDOW_UNLOAD'
            }
        });
    });
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('pagehide', ()=>{
        tracker.abort({
            reason: 'Window unloading',
            attributes: {
                cause: 'PAGE_HIDE'
            }
        });
    });
    return tracker;
}
function $2039e55a38e3127d$var$sanitiseExperienceName(name) {
    return name.replace(/[\/-]/g, '_');
}
function $2039e55a38e3127d$var$computeErrorAttributes(event) {
    const attributes = {};
    if (event.action === 'taskFail' && event.error) {
        attributes.failError = event.error.message;
        attributes.traceId = event.error.traceId ?? null;
    }
    if (event.action === 'taskAbort' && event.reason) attributes.abortReason = event.reason;
    return attributes;
}
// compute sloSatisfied: true/false based on the latencySlo attribute
// for monitoring in SignalFx
function $2039e55a38e3127d$var$computePerformanceAttributes(event) {
    if (event.action === 'taskStart') return {};
    const duration = event.duration;
    const latencySlo = event.attributes && event.attributes['latencySlo'];
    if (typeof duration !== 'number' || typeof latencySlo !== 'number') return {};
    return {
        sloSatisfied: duration <= latencySlo,
        taskDuration: duration,
        latencySlo: latencySlo
    };
}
class $2039e55a38e3127d$var$DirectoryExperienceTracker extends (0, $hUYqC.ExperienceTracker) {
    constructor(options){
        super(options);
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if ((0, $3W7Kz.isAuthError)(error)) {
            this.abort({
                name: name,
                reason: 'Abort due to user unauthenticated',
                attributes: {
                    cause: 'USER_UNAUTHENTICATED',
                    error: error,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        if ((0, $3W7Kz.isErrorStatusCode)((0, $3W7Kz.StatusCode).GONE, error)) {
            this.abort({
                name: name,
                reason: 'Abort due to unavailable resource',
                attributes: {
                    cause: 'GONE',
                    error: error,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        const reason = (0, $3W7Kz.ignoredErrorReason)(error);
        if (reason) {
            this.abort({
                name: name,
                reason: 'Abort due to an error in ignore list',
                attributes: {
                    cause: reason,
                    ...attributes
                },
                checkForTimeout: false
            });
            return;
        }
        super.stopOnError({
            name: name,
            error: error,
            attributes: attributes
        });
    }
}
function $2039e55a38e3127d$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    // @ts-ignore
    !!(error['graphQLErrors'] && error['networkError']));
}

});
const $26c363c9409b0d5d$export$28456d095a642fd = 'internal.browse-users-allowed';

parcelRegister("3MeXN", function(module, exports) {

$parcel$export(module.exports, "FeatureFlag", () => $607ef5d7f85c9ea8$export$df35587a8f95f16f);
$parcel$export(module.exports, "isFlagEnabled", () => $607ef5d7f85c9ea8$export$ba72073d757a1bc2);

var $82kzV = parcelRequire("82kzV");

var $37mOt = parcelRequire("37mOt");

var $2fFJv = parcelRequire("2fFJv");
var $607ef5d7f85c9ea8$export$df35587a8f95f16f;
(function(FeatureFlag) {
    //CA-13 Adding Tags at profile level
    FeatureFlag["ENABLE_PROJECT_CONNECT_USER_TAGS"] = "enable_skills_and_interest_tags_in_profile_page";
    //Teams in JSM Ops productFeatureFlags
    FeatureFlag["EVENT_ON_CALL_EFF"] = "event-on-call-consolidation_s97c8";
    FeatureFlag["EVENT_ON_CALL_CONSOLIDATION_STATE"] = "event-on-call-consolidation-state";
    // Control for Open Sites permissions check
    FeatureFlag["ENABLE_MOCK_OPEN_SITES_FAIL"] = "ptc-directory-ui.deny-open-sites-in-fe";
    // Atlas
    FeatureFlag["DISABLE_ATLAS_CROSSWFLOW_ADS"] = "disable_atlas_crossflow_ads";
})($607ef5d7f85c9ea8$export$df35587a8f95f16f || ($607ef5d7f85c9ea8$export$df35587a8f95f16f = {}));
// All feature flags must be listed here so that they can be selectively fetched from LaunchDarkly
// For real execution environments, configure flags in https://app.launchdarkly.com/ppl-teams-collective/test/features
// The default values here are used as the fallback when everything else (LD, local storage cache, local overrides) fails
const $607ef5d7f85c9ea8$var$DEFAULT_FEATURE_FLAGS = {
    ["enable_skills_and_interest_tags_in_profile_page"]: false,
    ["ptc-directory-ui.deny-open-sites-in-fe"]: false,
    ["disable_atlas_crossflow_ads"]: false,
    ["event-on-call-consolidation_s97c8"]: false,
    ["event-on-call-consolidation-state"]: false
};
// Overrides only for local/CI environments
const $607ef5d7f85c9ea8$var$LOCAL_OVERRIDE_FEATURE_FLAGS = {
    // Features rolled out to 100%
    // Atlassian-only features
    ["enable_skills_and_interest_tags_in_profile_page"]: true
};
const $607ef5d7f85c9ea8$export$7101ae34ef1f53be = ()=>$2fFJv?.env?.NODE_ENV === 'development' || (0, $37mOt.getEnv)() === 'local' ? {
        ...$607ef5d7f85c9ea8$var$DEFAULT_FEATURE_FLAGS,
        ...$607ef5d7f85c9ea8$var$LOCAL_OVERRIDE_FEATURE_FLAGS
    } : {
        ...$607ef5d7f85c9ea8$var$DEFAULT_FEATURE_FLAGS
    };
function $607ef5d7f85c9ea8$export$ba72073d757a1bc2(flag) {
    return (0, $82kzV.isFlagEnabled)(flag);
}

});
parcelRegister("82kzV", function(module, exports) {

$parcel$export(module.exports, "getSettingsFromStorage", () => $c660a7d1088ec419$export$b40bc67e97afc0ed);
$parcel$export(module.exports, "isFlagEnabled", () => $c660a7d1088ec419$export$ba72073d757a1bc2);

var $chxpa = parcelRequire("chxpa");

var $ezaHs = parcelRequire("ezaHs");

var $60itv = parcelRequire("60itv");
const $c660a7d1088ec419$var$STORAGE_KEY_SETTINGS = 'atlassian.ptc-directory.settings';
function $c660a7d1088ec419$export$d9d01ff109db30f0(settings) {
    (0, $ezaHs.default).setItem($c660a7d1088ec419$var$STORAGE_KEY_SETTINGS, JSON.stringify(settings));
    $c660a7d1088ec419$export$455c5cbefb010abd(settings);
}
function $c660a7d1088ec419$export$b40bc67e97afc0ed() {
    const settingsString = (0, $ezaHs.default).getItem($c660a7d1088ec419$var$STORAGE_KEY_SETTINGS);
    try {
        const parsed = settingsString ? JSON.parse(settingsString) : null;
        if ($c660a7d1088ec419$var$isStringBooleanDictionary(parsed)) return parsed;
        return null;
    } catch (e) {
        (0, $chxpa.logException)(e, 'Could not get settings from storage', {
            locallyStoredSettings: settingsString
        });
        return null;
    }
}
const $c660a7d1088ec419$var$effectiveFlags = {
    ...(0, $60itv.DEFAULT_FEATURE_FLAGS),
    ...$c660a7d1088ec419$export$b40bc67e97afc0ed() || {}
};
function $c660a7d1088ec419$export$455c5cbefb010abd(newFlags) {
    Object.assign($c660a7d1088ec419$var$effectiveFlags, newFlags);
}
/**
 * We use this function to validate that the settings retrieved from local storage are of the correct shape.
 * We intentionally don't check against explicit keys, as keys may have changed since being stored.
 */ function $c660a7d1088ec419$var$isStringBooleanDictionary(result) {
    return result !== null && Object.keys(result).every((resultKey)=>typeof resultKey === 'string' && typeof result[resultKey] === 'boolean');
}
function $c660a7d1088ec419$export$2f63519103163252(featureFlag) {
    return Object.keys((0, $60itv.PRODUCT_FEATURE_FLAGS)).includes(featureFlag);
}
function $c660a7d1088ec419$export$ba72073d757a1bc2(flag) {
    return $c660a7d1088ec419$var$effectiveFlags[flag];
}

});
parcelRegister("chxpa", function(module, exports) {

$parcel$export(module.exports, "logException", () => $64bc0cc2c1c9f8b8$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logInfoMessage", () => $64bc0cc2c1c9f8b8$export$386587bcf05ee8ea);

var $jnlyS = parcelRequire("jnlyS");
const $64bc0cc2c1c9f8b8$var$packageContext = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $64bc0cc2c1c9f8b8$export$f86b2a1a2ce291b3 = (0, $jnlyS.logExceptionWithPackageContext)($64bc0cc2c1c9f8b8$var$packageContext);
const $64bc0cc2c1c9f8b8$export$ece28f5cfa04608 = (0, $jnlyS.logErrorMessageWithPackageContext)($64bc0cc2c1c9f8b8$var$packageContext);
const $64bc0cc2c1c9f8b8$export$386587bcf05ee8ea = (0, $jnlyS.logInfoMessageWithPackageContext)($64bc0cc2c1c9f8b8$var$packageContext);
const $64bc0cc2c1c9f8b8$export$9edc7d6f1c33ddc = (0, $jnlyS.createErrorHandlerWithPackageContext)($64bc0cc2c1c9f8b8$var$packageContext);

});

parcelRegister("ezaHs", function(module, exports) {

$parcel$export(module.exports, "default", () => $c49d4726f7a3a865$export$2e2bcd8739ae039);

var $chxpa = parcelRequire("chxpa");
const $c49d4726f7a3a865$var$PREFIX = 'ptc-dir-ui.';
const $c49d4726f7a3a865$var$memoryLocalStorage = {
    data: {},
    setItem: (key, value)=>{
        $c49d4726f7a3a865$var$memoryLocalStorage.data[key] = value;
    },
    getItem: (key)=>{
        return $c49d4726f7a3a865$var$memoryLocalStorage.data[key];
    },
    removeItem: (key)=>{
        delete $c49d4726f7a3a865$var$memoryLocalStorage.data[key];
    }
};
const $c49d4726f7a3a865$var$localStorage = window.localStorage || $c49d4726f7a3a865$var$memoryLocalStorage;
var // A facade for browser localstorage.
$c49d4726f7a3a865$export$2e2bcd8739ae039 = {
    isQuotaExceeded () {
        const key = `${$c49d4726f7a3a865$var$PREFIX}:${Date.now()}`;
        try {
            $c49d4726f7a3a865$var$localStorage.setItem(key, 'test');
        } catch (e) {
            return true;
        } finally{
            $c49d4726f7a3a865$var$localStorage.removeItem(key);
        }
        return false;
    },
    setItem (key, value) {
        try {
            $c49d4726f7a3a865$var$localStorage.setItem($c49d4726f7a3a865$var$PREFIX + key, value);
            return true;
        } catch (error) {
            // maybe we can use cookie as alternative storage
            (0, $chxpa.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return false;
    },
    getItem (key) {
        try {
            return $c49d4726f7a3a865$var$localStorage.getItem($c49d4726f7a3a865$var$PREFIX + key);
        } catch (error) {
            (0, $chxpa.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return null;
    },
    getItemSafely (key, defaultValue, fallback) {
        try {
            const storedValue = $c49d4726f7a3a865$var$localStorage.getItem($c49d4726f7a3a865$var$PREFIX + key);
            if (storedValue) return storedValue;
            if (this.setItem(key, defaultValue)) return defaultValue;
        } catch (error) {
            (0, $chxpa.logInfoMessage)('Cannot read into localstorage', {
                error: error
            });
        }
        return fallback;
    }
};

});

parcelRegister("60itv", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_FEATURE_FLAGS", () => $8214895edb6008d4$export$f55f538942f87030);
$parcel$export(module.exports, "DEFAULT_FEATURE_FLAGS", () => $8214895edb6008d4$export$f38af5fc86a6e665);
// All feature flags must be listed here so that they can be selectively fetched from LaunchDarkly
// For real execution environments, configure flags in https://app.launchdarkly.com/ppl-teams-collective/test/features
// The default values here are used as the fallback when everything else (LD, local storage cache, local overrides) fails
// This is a list of feature flags that are overwritable by products. The defaults are still loaded from the client
const $8214895edb6008d4$export$f55f538942f87030 = {};
const $8214895edb6008d4$export$f38af5fc86a6e665 = {
    'ptc-directory-ui.enable.cancel-join-requests-silently': false,
    'ptc-directory-ui.deny-open-sites-in-fe': false,
    'ptc-directory-ui.enable.atlas-team-health-monitor': false,
    ...$8214895edb6008d4$export$f55f538942f87030
};

});



parcelRegister("3W7Kz", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $88d59d6acccbea0d$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $88d59d6acccbea0d$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $88d59d6acccbea0d$export$9677d7c364ada66c);
$parcel$export(module.exports, "ignoredErrorReason", () => $88d59d6acccbea0d$export$ece443678e6cc3f5);
$parcel$export(module.exports, "is4xxError", () => $88d59d6acccbea0d$export$94c4b26e937da69);
$parcel$export(module.exports, "doesErrorContainStatus", () => $88d59d6acccbea0d$export$7c7624f23566b6ff);
$parcel$export(module.exports, "DirectoryErrorCode", () => $88d59d6acccbea0d$export$b19e812222b57630);
$parcel$export(module.exports, "isApolloError", () => $88d59d6acccbea0d$export$17f5e6bd290bb15d);
var $88d59d6acccbea0d$export$fe4bb20808298551;
(function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
})($88d59d6acccbea0d$export$fe4bb20808298551 || ($88d59d6acccbea0d$export$fe4bb20808298551 = {}));
var $88d59d6acccbea0d$export$f66f92b8741acd5b;
(function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
})($88d59d6acccbea0d$export$f66f92b8741acd5b || ($88d59d6acccbea0d$export$f66f92b8741acd5b = {}));
function $88d59d6acccbea0d$export$cde1786a482f9a1c(error) {
    return $88d59d6acccbea0d$export$9677d7c364ada66c(401, error) || $88d59d6acccbea0d$export$9677d7c364ada66c(403, error);
}
const $88d59d6acccbea0d$export$c27af9588f06f6fc = [
    'SentryIgnoreError'
];
const $88d59d6acccbea0d$export$f4c3d57f2f41ffe2 = {
    'Could not verify accountId from header': 'AccountIdMismatch'
};
function $88d59d6acccbea0d$export$ece443678e6cc3f5(error) {
    const constructor = error?.constructor.name;
    if (constructor && $88d59d6acccbea0d$export$c27af9588f06f6fc.includes(constructor)) return constructor;
    const message = error?.message || '';
    const containedReason = message && Object.keys($88d59d6acccbea0d$export$f4c3d57f2f41ffe2).find((ignoredMessage)=>message.includes(ignoredMessage));
    if (containedReason) return $88d59d6acccbea0d$export$f4c3d57f2f41ffe2[containedReason];
}
function $88d59d6acccbea0d$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
    error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}
function $88d59d6acccbea0d$export$94c4b26e937da69(error) {
    if (!error) return false;
    const statusCode = error['status'] || error['statusCode'];
    if (parseInt(statusCode, 10) >= 400 && parseInt(statusCode, 10) < 500) return true;
    const reg = new RegExp(/status (code)?.*(4\d\d)/g);
    return !!error.message?.match(reg);
}
function $88d59d6acccbea0d$export$7c7624f23566b6ff(statusCode, message) {
    const reg = new RegExp(`status .*(${statusCode})`);
    return reg.test(message);
}
var $88d59d6acccbea0d$export$b19e812222b57630;
(function(DirectoryErrorCode) {
    DirectoryErrorCode["MISSING_ERROR_MESSAGE"] = "MissingErrorMessage";
})($88d59d6acccbea0d$export$b19e812222b57630 || ($88d59d6acccbea0d$export$b19e812222b57630 = {}));
var $88d59d6acccbea0d$export$c33cd4757598521c;
(function(TeamErrorType) {
    TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
})($88d59d6acccbea0d$export$c33cd4757598521c || ($88d59d6acccbea0d$export$c33cd4757598521c = {}));
function $88d59d6acccbea0d$export$76843b239f07f80a(error, field) {
    return error instanceof Error && field in error;
}
function $88d59d6acccbea0d$export$17f5e6bd290bb15d(err) {
    return typeof err === 'object' && err !== null && 'graphQLErrors' in err;
}

});

parcelRegister("fECJU", function(module, exports) {

$parcel$export(module.exports, "logException", () => $38686236c3951331$export$f86b2a1a2ce291b3);
$parcel$export(module.exports, "logErrorMessage", () => $38686236c3951331$export$ece28f5cfa04608);
$parcel$export(module.exports, "logInfoMessage", () => $38686236c3951331$export$386587bcf05ee8ea);
$parcel$export(module.exports, "createErrorHandler", () => $38686236c3951331$export$9edc7d6f1c33ddc);

var $jnlyS = parcelRequire("jnlyS");
var $fcdA0 = parcelRequire("fcdA0");
const $38686236c3951331$var$packageContext = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $38686236c3951331$export$f86b2a1a2ce291b3 = (0, $jnlyS.logExceptionWithPackageContext)($38686236c3951331$var$packageContext);
const $38686236c3951331$export$ece28f5cfa04608 = (0, $jnlyS.logErrorMessageWithPackageContext)($38686236c3951331$var$packageContext);
const $38686236c3951331$export$386587bcf05ee8ea = (0, $jnlyS.logInfoMessageWithPackageContext)($38686236c3951331$var$packageContext);
const $38686236c3951331$export$9edc7d6f1c33ddc = (0, $jnlyS.createErrorHandlerWithPackageContext)($38686236c3951331$var$packageContext);

});
parcelRegister("fcdA0", function(module, exports) {

$parcel$export(module.exports, "useTeamsSentryClientSetup", () => $a542d775eabef1c8$export$e30f49f36a0eeaeb);

var $eUqFw = parcelRequire("eUqFw");

var $9CTdJ = parcelRequire("9CTdJ");
const $a542d775eabef1c8$export$e30f49f36a0eeaeb = (isSentryEnabled, config)=>{
    const [sentryInitialised, setSentryInitialised] = (0, $eUqFw.useState)(false);
    const setupSentry = (0, $eUqFw.useCallback)(async ()=>{
        if (!sentryInitialised && isSentryEnabled && !(0, $9CTdJ.sentryClient)) await (0, $9CTdJ.setupSentryClient)(config);
    }, [
        config,
        isSentryEnabled,
        sentryInitialised
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setupSentry().then(()=>setSentryInitialised(true));
    }, [
        setupSentry
    ]);
    return 0, $9CTdJ.sentryClient;
};

});



parcelRegister("bsMUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $546a5f695a4fb237$export$2e2bcd8739ae039);
/**
 * A singleton module that will store a referrer data in a closure
 * and retrieve that data in an analytics client untill the app has
 * a route transition happened.
 *
 * How it works:
 * 1. whenever we init our app with `src` or `ref` in the URL we gonna preserve them here
 * 2. in every screen event we gonna retrieve `src` and `ref` and add them to event attributes
 * 3. as soon as app transitions to any other route we gonna cleanup the stored referrer data
 *    to stop tracking it further.
 *
 * Notes:
 *  Due to how `referrerInfo` is used to store data temporarily, now it is used only at 2 places:
 * - Analytic Client `packages/common/src/clients/analytics-client.ts`
 * - RecordTransition `packages/embeddable-directory/src/components/RecordTransition/RecordTransition.tsx`
 * If other codes try to access value inside `referrerInfo`, they may access old/empty data.
 */ 
var $hYfIu = parcelRequire("hYfIu");
// the storage for our referrer info;
let $546a5f695a4fb237$var$data = null;
const $546a5f695a4fb237$var$referrerInfo = {
    // as we preserving the data, we should at least get it once to record in analytics before allowing cleanup
    isUsed: false,
    markUsed () {
        $546a5f695a4fb237$var$referrerInfo.isUsed = true;
    },
    get () {
        return $546a5f695a4fb237$var$data;
    },
    set ({ src: src = '', ref: ref = '' }) {
        // clean up strings
        $546a5f695a4fb237$var$data = {
            src: (0, $hYfIu.sanitiseValue)(src || '', {
                shouldHaveSafeCharsOnly: true,
                shouldEncode: true
            }),
            ref: (0, $hYfIu.sanitiseValue)(ref, {
                shouldHaveSafeCharsOnly: true,
                shouldEncode: true
            })
        };
    },
    cleanup (force) {
        if (!$546a5f695a4fb237$var$referrerInfo.isUsed && !force) return;
        $546a5f695a4fb237$var$data = null;
    }
};
var $546a5f695a4fb237$export$2e2bcd8739ae039 = $546a5f695a4fb237$var$referrerInfo;

});
parcelRegister("hYfIu", function(module, exports) {

$parcel$export(module.exports, "sanitiseValue", () => $571db4be5b3da701$export$b66eb39ba856053f);
const $571db4be5b3da701$var$FORBIDDEN_CODE_CHARS = [
    8207
];
function $571db4be5b3da701$export$b66eb39ba856053f(value, options = {}) {
    let trimmedStr = value.trim();
    $571db4be5b3da701$var$FORBIDDEN_CODE_CHARS.forEach((codeChar)=>{
        const char = String.fromCharCode(codeChar);
        const re = new RegExp(char, 'gm');
        trimmedStr = trimmedStr.replace(re, '');
    });
    if (options.shouldHaveSafeCharsOnly) {
        trimmedStr = trimmedStr.replace(/[^a-z0-9_-]/gim, '');
        trimmedStr = trimmedStr.trim();
    }
    if (options.shouldEncode) trimmedStr = encodeURIComponent(trimmedStr);
    return trimmedStr;
}

});




parcelRegister("7YLRZ", function(module, exports) {

$parcel$export(module.exports, "useSetupApolloClient", () => $6a4f8a0fb42dfb71$export$78cd44b109ba6e2a);

var $eUqFw = parcelRequire("eUqFw");

var $k7WCG = parcelRequire("k7WCG");
function $6a4f8a0fb42dfb71$export$78cd44b109ba6e2a(cloudId) {
    const [apolloClient, setApolloClient] = (0, $eUqFw.useState)((0, $k7WCG.getApolloClient)({
        getCloudId: ()=>cloudId
    }));
    const gatewayClient = (0, $k7WCG.getGatewayClient)();
    // setup directory Apollo client
    (0, $eUqFw.useEffect)(()=>{
        if (!cloudId) return;
        const apolloClient = (0, $k7WCG.getApolloClient)({
            getCloudId: ()=>cloudId
        });
        /**
		 * Enables the field @cloudId in apollo queries
		 */ apolloClient.writeData({
            data: {
                cloudId: cloudId
            }
        });
        setApolloClient(apolloClient);
    }, [
        cloudId
    ]);
    // setup gateway Apollo client
    (0, $eUqFw.useEffect)(()=>{
        /**
		 * Enables the field @cloudId in apollo queries
		 */ gatewayClient.writeData({
            data: {
                cloudId: cloudId || 'None'
            }
        });
    }, [
        cloudId,
        gatewayClient
    ]);
    return apolloClient;
}

});
parcelRegister("k7WCG", function(module, exports) {

$parcel$export(module.exports, "getApolloClient", () => $77a39de2f2aeeb01$export$1e6cfeaf8b88bd01);
$parcel$export(module.exports, "getGatewayClient", () => $77a39de2f2aeeb01$export$719274339c63410a);
$parcel$export(module.exports, "getTeamCentralClient", () => $77a39de2f2aeeb01$export$6ef19f8a51b6041);

var $kj8KJQ = parcelRequire("kj8KJQ");

var $fU34a = parcelRequire("fU34a");
var $avLBj = parcelRequire("avLBj");

var $lhBhN = parcelRequire("lhBhN");
const $77a39de2f2aeeb01$var$customFetch = (0, $lhBhN.withDefaultExponentialBackoff)(fetch);
/*************************************************/ // a common Apollo Client
let $77a39de2f2aeeb01$var$cachedApolloClient;
const $77a39de2f2aeeb01$export$1e6cfeaf8b88bd01 = (customConfig)=>{
    if ($77a39de2f2aeeb01$var$cachedApolloClient) return $77a39de2f2aeeb01$var$cachedApolloClient;
    const apolloClient = $77a39de2f2aeeb01$export$67100df7b1079985(customConfig);
    // don't cache apolloClient when cloudId is empty string
    if (customConfig?.getCloudId && customConfig?.getCloudId()) $77a39de2f2aeeb01$var$cachedApolloClient = apolloClient;
    return apolloClient;
};
const $77a39de2f2aeeb01$export$67100df7b1079985 = (customConfig)=>(0, $kj8KJQ.createApolloClient)({
        connectToDevTools: !!(0, $fU34a.DEV),
        url: {
            stargateRoot: (0, $avLBj.getConfig)().stargateRoot,
            collaborationGraph: (0, $avLBj.getConfig)().collaborationGraph
        },
        customFetch: $77a39de2f2aeeb01$var$customFetch,
        ...customConfig
    });
/*************************************************/ // Worklens client
let $77a39de2f2aeeb01$var$cachedWorklensClient;
const $77a39de2f2aeeb01$export$f0c45e63c1288a74 = ()=>{
    if ($77a39de2f2aeeb01$var$cachedWorklensClient) return $77a39de2f2aeeb01$var$cachedWorklensClient;
    $77a39de2f2aeeb01$var$cachedWorklensClient = (0, $kj8KJQ.createWorklensClient)({
        url: {
            stargateRoot: (0, $avLBj.getConfig)().stargateRoot
        },
        customFetch: $77a39de2f2aeeb01$var$customFetch
    });
    return $77a39de2f2aeeb01$var$cachedWorklensClient;
};
/*************************************************/ // GraphQL Gateway client
let $77a39de2f2aeeb01$var$cachedGatewayClient;
const $77a39de2f2aeeb01$export$719274339c63410a = ()=>{
    if ($77a39de2f2aeeb01$var$cachedGatewayClient) return $77a39de2f2aeeb01$var$cachedGatewayClient;
    $77a39de2f2aeeb01$var$cachedGatewayClient = (0, $kj8KJQ.createAtlassianGatewayClient)({
        url: {
            stargateRoot: (0, $avLBj.getConfig)().stargateRoot
        },
        customFetch: $77a39de2f2aeeb01$var$customFetch
    });
    return $77a39de2f2aeeb01$var$cachedGatewayClient;
};
/*************************************************/ // GraphQL Team Central client
let $77a39de2f2aeeb01$var$cachedTeamCentralClient;
const $77a39de2f2aeeb01$export$6ef19f8a51b6041 = ()=>{
    if ($77a39de2f2aeeb01$var$cachedTeamCentralClient) return $77a39de2f2aeeb01$var$cachedTeamCentralClient;
    $77a39de2f2aeeb01$var$cachedTeamCentralClient = (0, $kj8KJQ.createTeamCentralClient)({
        url: {
            stargateRoot: (0, $avLBj.getConfig)().stargateRoot
        },
        customFetch: $77a39de2f2aeeb01$var$customFetch
    });
    return $77a39de2f2aeeb01$var$cachedTeamCentralClient;
};

});
parcelRegister("kj8KJQ", function(module, exports) {

$parcel$export(module.exports, "createApolloClient", () => $faa19ad8ea5a421f$export$67100df7b1079985);
$parcel$export(module.exports, "createWorklensClient", () => $faa19ad8ea5a421f$export$72afd8225aad0e67);
$parcel$export(module.exports, "createAtlassianGatewayClient", () => $faa19ad8ea5a421f$export$a518457feff205cb);
$parcel$export(module.exports, "createTeamCentralClient", () => $faa19ad8ea5a421f$export$63d9e7c1fb26588f);

var $2vRh6 = parcelRequire("2vRh6");

var $jlBDe = parcelRequire("jlBDe");

var $bvQX6 = parcelRequire("bvQX6");

var $711qW = parcelRequire("711qW");

var $aAMCg = parcelRequire("aAMCg");

var $9rafI = parcelRequire("9rafI");

var $2fzHI = parcelRequire("2fzHI");

var $kc4ri = parcelRequire("kc4ri");

var $dc8YU = parcelRequire("dc8YU");

var $IBBFX = parcelRequire("IBBFX");

var $aF0EL = parcelRequire("aF0EL");

var $5vw7Q = parcelRequire("5vw7Q");
const $faa19ad8ea5a421f$export$67100df7b1079985 = (options)=>{
    const { retryLink: retryOptions = {}, getCloudId: getCloudId, url: url, statusCodeHandlers: statusCodeHandlers = {}, customFetch: customFetch } = options;
    // Build up a list of Apollo links
    const links = [];
    /**
   * Apollo link for handling request errors
   */ const errorLink = (0, $dc8YU.createErrorLink)({
        statusCodeHandlers: statusCodeHandlers
    });
    if (errorLink) links.push(errorLink);
    /**
   * Apollo link for retrying certain failed requests
   */ const retryLink = (0, $IBBFX.createRetryLink)(retryOptions);
    if (retryLink) links.push(retryLink);
    /**
   * Apollo link that determines whether to send a request to directory
   * service or resolve the query locally using a custom resolver
   */ const customResolversLink = new (0, $711qW.SchemaLink)({
        schema: (0, $aAMCg.addResolveFunctionsToSchema)({
            schema: $5vw7Q.schema,
            resolvers: $aF0EL.default
        }),
        context: {
            url: url,
            fetch: (0, $9rafI.getCustomResolversFetch)({
                fetch: customFetch || fetch,
                statusCodeHandlers: statusCodeHandlers
            })
        }
    });
    const directoryHttpLink = (0, $kc4ri.createDirectoryHttpLink)({
        url: `${url ? url.stargateRoot : ''}/directory/graphql`,
        getCloudId: getCloudId
    });
    links.push((0, $bvQX6.split)(// if query has @custom, use customResolversLink
    (operation)=>(0, $2fzHI.isCustomQuery)(operation), customResolversLink, // use directory link
    directoryHttpLink));
    return new (0, $jlBDe.default)({
        connectToDevTools: !!options.connectToDevTools,
        link: (0, $bvQX6.from)(links),
        cache: new (0, $2vRh6.InMemoryCache)(),
        // empty object enables @client directive
        resolvers: {}
    });
};
const $faa19ad8ea5a421f$export$72afd8225aad0e67 = (options)=>{
    const { retryLink: retryOptions = {}, url: url, statusCodeHandlers: statusCodeHandlers = {} } = options;
    const errorLink = (0, $dc8YU.createErrorLink)({
        statusCodeHandlers: statusCodeHandlers
    });
    const retryLink = (0, $IBBFX.createRetryLink)(retryOptions);
    const httpLink = (0, $kc4ri.createDirectoryHttpLink)({
        url: `${url.stargateRoot}/worklens/api/graphql`
    });
    const links = [
        errorLink,
        retryLink,
        httpLink
    ];
    return new (0, $jlBDe.default)({
        link: (0, $bvQX6.from)(links),
        cache: new (0, $2vRh6.InMemoryCache)()
    });
};
const $faa19ad8ea5a421f$export$a518457feff205cb = (options)=>{
    const { retryLink: retryOptions = {}, url: url, statusCodeHandlers: statusCodeHandlers = {} } = options;
    const errorLink = (0, $dc8YU.createErrorLink)({
        statusCodeHandlers: statusCodeHandlers
    });
    const retryLink = (0, $IBBFX.createRetryLink)(retryOptions);
    const httpLink = (0, $kc4ri.createDirectoryHttpLink)({
        url: `${url.stargateRoot}/graphql`
    });
    const links = [
        errorLink,
        retryLink,
        httpLink
    ];
    return new (0, $jlBDe.default)({
        link: (0, $bvQX6.from)(links),
        cache: new (0, $2vRh6.InMemoryCache)(),
        // empty object enables @client directive
        resolvers: {}
    });
};
const $faa19ad8ea5a421f$export$63d9e7c1fb26588f = (options)=>{
    const { retryLink: retryOptions = {}, url: url, statusCodeHandlers: statusCodeHandlers = {} } = options;
    const errorLink = (0, $dc8YU.createErrorLink)({
        statusCodeHandlers: statusCodeHandlers
    });
    const retryLink = (0, $IBBFX.createRetryLink)(retryOptions);
    const httpLink = (0, $kc4ri.createDirectoryHttpLink)({
        url: `${url ? url.stargateRoot : ''}/watermelon/graphql`
    });
    const links = [
        errorLink,
        retryLink,
        httpLink
    ];
    return new (0, $jlBDe.default)({
        link: (0, $bvQX6.from)(links),
        cache: new (0, $2vRh6.InMemoryCache)({
            dataIdFromObject: (obj)=>{
                switch(obj.__typename){
                    case 'Icon':
                        return `${obj.id}:${obj.shortName}|${obj.color}`;
                    case 'GoalPhaseDetails':
                    case 'ProjectPhaseDetails':
                    case 'GqlJiraIssue':
                    case 'GqlJiraIssueType':
                    case 'GqlJiraStatus':
                    case 'GqlJiraStatusCategory':
                        return `${obj.__typename}:${obj.id}`;
                    default:
                        return obj.id;
                }
            }
        })
    });
};

});
parcelRegister("2vRh6", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $1d47cd4d9b8db33d$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $1d47cd4d9b8db33d$export$467265324939f47f);

var $fKE23 = parcelRequire("fKE23");

var $bO1Qv = parcelRequire("bO1Qv");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $7xYai = parcelRequire("7xYai");

var $8j2fP = parcelRequire("8j2fP");
var $1d47cd4d9b8db33d$var$haveWarned = false;
function $1d47cd4d9b8db33d$var$shouldWarn() {
    var answer = !$1d47cd4d9b8db33d$var$haveWarned;
    if (!(0, $42BH7.isTest)()) $1d47cd4d9b8db33d$var$haveWarned = true;
    return answer;
}
var $1d47cd4d9b8db33d$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $1d47cd4d9b8db33d$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $1d47cd4d9b8db33d$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $1d47cd4d9b8db33d$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $8j2fP.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $8j2fP.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $1d47cd4d9b8db33d$var$hasOwn = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $7xYai.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($1d47cd4d9b8db33d$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$1d47cd4d9b8db33d$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory(seed) {
    return new $1d47cd4d9b8db33d$var$DepTrackingCache(seed);
}
var $1d47cd4d9b8db33d$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $7xYai.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $7xYai.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $7xYai.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $42BH7.getQueryDefinition)(query);
        variables = (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $8j2fP.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $66hGB.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $42BH7.getMainDefinition)(query);
        var fragments = (0, $42BH7.getFragmentDefinitions)(query);
        var fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $8j2fP.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $42BH7.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $42BH7.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $42BH7.resultKeyNameFromField)(field),
            directives: (0, $42BH7.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $42BH7.isIdValue)(value)) throw new (0, $8j2fP.InvariantError)(10);
}
function $1d47cd4d9b8db33d$var$defaultFragmentMatcher() {
    return true;
}
function $1d47cd4d9b8db33d$export$7a4899fe13f33235(idValue) {
    (0, $8j2fP.invariant)((0, $42BH7.isIdValue)(idValue), 11);
}
function $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $42BH7.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $42BH7.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $42BH7.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $1d47cd4d9b8db33d$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $1d47cd4d9b8db33d$export$7e2b40d1002de152(seed) {
    return new $1d47cd4d9b8db33d$export$ee7258b8691956a3(seed);
}
var $1d47cd4d9b8db33d$export$de4e6870dc6ac801 = function(_super) {
    (0, $fKE23.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $1d47cd4d9b8db33d$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $1d47cd4d9b8db33d$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $1d47cd4d9b8db33d$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $42BH7.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $42BH7.createFragmentMap)((0, $42BH7.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $1d47cd4d9b8db33d$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var resultFieldKey = (0, $42BH7.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $8j2fP.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $42BH7.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $1d47cd4d9b8db33d$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $42BH7.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $42BH7.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$1d47cd4d9b8db33d$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $8j2fP.invariant)(!semanticId || !$1d47cd4d9b8db33d$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $42BH7.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $42BH7.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $8j2fP.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $8j2fP.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $1d47cd4d9b8db33d$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $66hGB.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $42BH7.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $1d47cd4d9b8db33d$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $1d47cd4d9b8db33d$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $42BH7.isIdValue)(value) && $1d47cd4d9b8db33d$var$isGeneratedId(value.id) && (0, $42BH7.isIdValue)(realValue) && !(0, $66hGB.equal)(value, realValue) && $1d47cd4d9b8db33d$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, generated), real);
    if ((0, $66hGB.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $1d47cd4d9b8db33d$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $1d47cd4d9b8db33d$var$defaultConfig = {
    fragmentMatcher: new $1d47cd4d9b8db33d$export$5d3fcf53267091de(),
    dataIdFromObject: $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $1d47cd4d9b8db33d$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$OptimisticCacheLayer = function(_super) {
    (0, $fKE23.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $1d47cd4d9b8db33d$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($1d47cd4d9b8db33d$export$ee7258b8691956a3);
var $1d47cd4d9b8db33d$export$467265324939f47f = function(_super) {
    (0, $fKE23.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $1d47cd4d9b8db33d$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $1d47cd4d9b8db33d$var$DepTrackingCache() : new $1d47cd4d9b8db33d$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $1d47cd4d9b8db33d$export$eb8361c5d132fb8f();
        _this.storeReader = new $1d47cd4d9b8db33d$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $7xYai.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $8j2fP.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $1d47cd4d9b8db33d$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $1d47cd4d9b8db33d$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $42BH7.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $bO1Qv.ApolloCache));

});
parcelRegister("bO1Qv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $8985cbc47a37b971$export$5fc74f25506aa9c);

var $42BH7 = parcelRequire("42BH7");
function $8985cbc47a37b971$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $8985cbc47a37b971$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $8985cbc47a37b971$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $8985cbc47a37b971$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $8985cbc47a37b971$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $8985cbc47a37b971$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $8985cbc47a37b971$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $8985cbc47a37b971$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $8985cbc47a37b971$export$94affb487e701bf2;
$8985cbc47a37b971$export$94affb487e701bf2 || ($8985cbc47a37b971$export$94affb487e701bf2 = {});

});
parcelRegister("42BH7", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", () => $2f1496a7de754c2a$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $2f1496a7de754c2a$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $2f1496a7de754c2a$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $2f1496a7de754c2a$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $2f1496a7de754c2a$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $2f1496a7de754c2a$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $2f1496a7de754c2a$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $2f1496a7de754c2a$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $2f1496a7de754c2a$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $2f1496a7de754c2a$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $2f1496a7de754c2a$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $2f1496a7de754c2a$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $2f1496a7de754c2a$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $2f1496a7de754c2a$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $2f1496a7de754c2a$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $2f1496a7de754c2a$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $2f1496a7de754c2a$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $2f1496a7de754c2a$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $2f1496a7de754c2a$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $2f1496a7de754c2a$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $2f1496a7de754c2a$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $2f1496a7de754c2a$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $2f1496a7de754c2a$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $2f1496a7de754c2a$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $2f1496a7de754c2a$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $2f1496a7de754c2a$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $2f1496a7de754c2a$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $2f1496a7de754c2a$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $2f1496a7de754c2a$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $2f1496a7de754c2a$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $2f1496a7de754c2a$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $2f1496a7de754c2a$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $2f1496a7de754c2a$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $2f1496a7de754c2a$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $2f1496a7de754c2a$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $2f1496a7de754c2a$export$160070228be94b08);

var $961BR = parcelRequire("961BR");

var $8j2fP = parcelRequire("8j2fP");

var $fKE23 = parcelRequire("fKE23");

var $cGs0N = parcelRequire("cGs0N");

var $66hGB = parcelRequire("66hGB");

var $2fFJv = parcelRequire("2fFJv");
function $2f1496a7de754c2a$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $2f1496a7de754c2a$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $2f1496a7de754c2a$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $2f1496a7de754c2a$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $2f1496a7de754c2a$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $2f1496a7de754c2a$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $2f1496a7de754c2a$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $2f1496a7de754c2a$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $2f1496a7de754c2a$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $2f1496a7de754c2a$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $2f1496a7de754c2a$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $2f1496a7de754c2a$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($2f1496a7de754c2a$var$isIntValue(value) || $2f1496a7de754c2a$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($2f1496a7de754c2a$var$isBooleanValue(value) || $2f1496a7de754c2a$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($2f1496a7de754c2a$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $2f1496a7de754c2a$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($2f1496a7de754c2a$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($2f1496a7de754c2a$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $2f1496a7de754c2a$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($2f1496a7de754c2a$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($2f1496a7de754c2a$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $8j2fP.InvariantError)(17);
}
function $2f1496a7de754c2a$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $2f1496a7de754c2a$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f1496a7de754c2a$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $2f1496a7de754c2a$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $2f1496a7de754c2a$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $2f1496a7de754c2a$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($cGs0N)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($2f1496a7de754c2a$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $2f1496a7de754c2a$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f1496a7de754c2a$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $2f1496a7de754c2a$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $2f1496a7de754c2a$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $2f1496a7de754c2a$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $2f1496a7de754c2a$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $fKE23.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $2f1496a7de754c2a$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $2f1496a7de754c2a$var$defaultValueFromVariable(node) {
    throw new (0, $8j2fP.InvariantError)(18);
}
function $2f1496a7de754c2a$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $2f1496a7de754c2a$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $2f1496a7de754c2a$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $2f1496a7de754c2a$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $2f1496a7de754c2a$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $2f1496a7de754c2a$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $2f1496a7de754c2a$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $2f1496a7de754c2a$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $8j2fP.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $2f1496a7de754c2a$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $961BR.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $2f1496a7de754c2a$export$2dafb573e282fe8d(names, doc) {
    return $2f1496a7de754c2a$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $2f1496a7de754c2a$export$8d1e9e5bbfa5d09a(document) {
    return document && $2f1496a7de754c2a$export$2dafb573e282fe8d([
        'client'
    ], document) && $2f1496a7de754c2a$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $2f1496a7de754c2a$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $2f1496a7de754c2a$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($2f1496a7de754c2a$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $8j2fP.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $8j2fP.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $8j2fP.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $2f1496a7de754c2a$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $8j2fP.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $8j2fP.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, document), {
        definitions: (0, $fKE23.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $2f1496a7de754c2a$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $2f1496a7de754c2a$export$a92e7a440b22bdf0(doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $8j2fP.invariant)(mutationDef, 1);
    return mutationDef;
}
function $2f1496a7de754c2a$export$a7d0d8111d2386df(doc) {
    (0, $8j2fP.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $8j2fP.InvariantError)(3);
        return definition;
    });
    (0, $8j2fP.invariant)(operations.length <= 1, 4);
    return doc;
}
function $2f1496a7de754c2a$export$7a5b1fa979d2c158(doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $2f1496a7de754c2a$export$78a8e95d8d43ad7f(document) {
    var def = $2f1496a7de754c2a$export$7a5b1fa979d2c158(document);
    (0, $8j2fP.invariant)(def, 5);
    return def;
}
function $2f1496a7de754c2a$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $2f1496a7de754c2a$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $2f1496a7de754c2a$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $2f1496a7de754c2a$export$7a5b1fa979d2c158(doc);
    (0, $8j2fP.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $2f1496a7de754c2a$export$772111caef41b3f5(doc) {
    (0, $8j2fP.invariant)(doc.kind === 'Document', 7);
    (0, $8j2fP.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $8j2fP.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $2f1496a7de754c2a$export$f431198736b7f96d(queryDoc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $8j2fP.InvariantError)(10);
}
function $2f1496a7de754c2a$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $2f1496a7de754c2a$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $2f1496a7de754c2a$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $2f1496a7de754c2a$export$e6e34fd1f2686227.apply(void 0, (0, $fKE23.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $2f1496a7de754c2a$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $2f1496a7de754c2a$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $2f1496a7de754c2a$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $2f1496a7de754c2a$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $2f1496a7de754c2a$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $2f1496a7de754c2a$var$nullIfDocIsEmpty(doc) {
    return $2f1496a7de754c2a$var$isEmpty($2f1496a7de754c2a$export$7a5b1fa979d2c158(doc) || $2f1496a7de754c2a$export$772111caef41b3f5(doc), $2f1496a7de754c2a$export$193789b4c8246dd4($2f1496a7de754c2a$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $2f1496a7de754c2a$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $2f1496a7de754c2a$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($2f1496a7de754c2a$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($2f1496a7de754c2a$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $2f1496a7de754c2a$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $2f1496a7de754c2a$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $2f1496a7de754c2a$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $2f1496a7de754c2a$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $2f1496a7de754c2a$export$43b332f87950a467(doc) {
    return (0, $961BR.visit)($2f1496a7de754c2a$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($2f1496a7de754c2a$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    selections: (0, $fKE23.__spreadArrays)(selections, [
                        $2f1496a7de754c2a$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $2f1496a7de754c2a$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $2f1496a7de754c2a$export$74985f3324559867(doc) {
    return $2f1496a7de754c2a$export$e5ae0530da5fe96c([
        $2f1496a7de754c2a$var$connectionRemoveConfig
    ], $2f1496a7de754c2a$export$a7d0d8111d2386df(doc));
}
function $2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$2f1496a7de754c2a$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($2f1496a7de754c2a$var$getDirectiveMatcher(directives)) || nestedCheck && $2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $2f1496a7de754c2a$export$deed3420cb5d2e1d(directives, doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $2f1496a7de754c2a$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $2f1496a7de754c2a$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $2f1496a7de754c2a$var$getArgumentMatcher(config);
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $2f1496a7de754c2a$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($2f1496a7de754c2a$export$fb56ad75dd311c12(selection) || $2f1496a7de754c2a$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $2f1496a7de754c2a$export$57c368c23873f32b(document) {
    var definition = $2f1496a7de754c2a$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $961BR.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $2f1496a7de754c2a$export$8eae69e876ee321e(document) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(document);
    var modifiedDoc = $2f1496a7de754c2a$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $961BR.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $2f1496a7de754c2a$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $2f1496a7de754c2a$var$toString = Object.prototype.toString;
function $2f1496a7de754c2a$export$629a2bd3f5a49ecc(value) {
    return $2f1496a7de754c2a$var$cloneDeepHelper(value, new Map());
}
function $2f1496a7de754c2a$var$cloneDeepHelper(val, seen) {
    switch($2f1496a7de754c2a$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $2f1496a7de754c2a$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $2f1496a7de754c2a$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $2f1496a7de754c2a$export$4bd44a2aa29d3d6e() {
    if (typeof $2fFJv !== 'undefined' && "production") return "production";
    return 'development';
}
function $2f1496a7de754c2a$export$f0cb0fda19c18b37(env) {
    return $2f1496a7de754c2a$export$4bd44a2aa29d3d6e() === env;
}
function $2f1496a7de754c2a$export$f15d00aa73aafac4() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('production') === true;
}
function $2f1496a7de754c2a$export$df77466336fe5355() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('development') === true;
}
function $2f1496a7de754c2a$export$410cbc2864fa25b5() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('test') === true;
}
function $2f1496a7de754c2a$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $2f1496a7de754c2a$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $2f1496a7de754c2a$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $2f1496a7de754c2a$var$deepFreeze(o[prop]);
    });
    return o;
}
function $2f1496a7de754c2a$export$7f9c177735b71f18(obj) {
    if ($2f1496a7de754c2a$export$df77466336fe5355() || $2f1496a7de754c2a$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $2f1496a7de754c2a$var$deepFreeze(obj);
    }
    return obj;
}
var $2f1496a7de754c2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $2f1496a7de754c2a$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $2f1496a7de754c2a$export$160070228be94b08(sources);
}
function $2f1496a7de754c2a$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $2f1496a7de754c2a$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $2f1496a7de754c2a$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $2f1496a7de754c2a$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $2f1496a7de754c2a$var$mergeHelper(target, source, pastCopies) {
    if ($2f1496a7de754c2a$var$isObject(source) && $2f1496a7de754c2a$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $2f1496a7de754c2a$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($2f1496a7de754c2a$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $2f1496a7de754c2a$var$mergeHelper($2f1496a7de754c2a$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $2f1496a7de754c2a$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $fKE23.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $2f1496a7de754c2a$var$haveWarned = Object.create({});
function $2f1496a7de754c2a$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$2f1496a7de754c2a$export$f15d00aa73aafac4() && !$2f1496a7de754c2a$var$haveWarned[msg]) {
        if (!$2f1496a7de754c2a$export$410cbc2864fa25b5()) $2f1496a7de754c2a$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $2f1496a7de754c2a$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("8j2fP", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $60c1d8bb20ac9f24$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $60c1d8bb20ac9f24$export$f5708dca728d7177);

var $fKE23 = parcelRequire("fKE23");

var $2fFJv = parcelRequire("2fFJv");
var $60c1d8bb20ac9f24$var$genericMessage = "Invariant Violation";
var $60c1d8bb20ac9f24$var$_a = Object.setPrototypeOf, $60c1d8bb20ac9f24$var$setPrototypeOf = $60c1d8bb20ac9f24$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $60c1d8bb20ac9f24$var$_a;
var $60c1d8bb20ac9f24$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $60c1d8bb20ac9f24$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $60c1d8bb20ac9f24$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $60c1d8bb20ac9f24$var$genericMessage;
        $60c1d8bb20ac9f24$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $60c1d8bb20ac9f24$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $60c1d8bb20ac9f24$export$cea12affaee22fe8(message);
}
function $60c1d8bb20ac9f24$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $60c1d8bb20ac9f24$var$wrapConsoleMethod("warn");
    invariant.error = $60c1d8bb20ac9f24$var$wrapConsoleMethod("error");
})($60c1d8bb20ac9f24$export$f5708dca728d7177 || ($60c1d8bb20ac9f24$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $60c1d8bb20ac9f24$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $2fFJv === "object") $60c1d8bb20ac9f24$export$e54fe5b0f43758f7 = $2fFJv;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($60c1d8bb20ac9f24$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $60c1d8bb20ac9f24$var$invariant$1 = $60c1d8bb20ac9f24$export$f5708dca728d7177;
var $60c1d8bb20ac9f24$export$2e2bcd8739ae039 = $60c1d8bb20ac9f24$var$invariant$1;

});

parcelRegister("cGs0N", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("66hGB", function(module, exports) {

$parcel$export(module.exports, "equal", () => $471105b2f2fd38f1$export$411ce8e5a71e3069);
var $471105b2f2fd38f1$var$_a = Object.prototype, $471105b2f2fd38f1$var$toString = $471105b2f2fd38f1$var$_a.toString, $471105b2f2fd38f1$var$hasOwnProperty = $471105b2f2fd38f1$var$_a.hasOwnProperty;
var $471105b2f2fd38f1$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $471105b2f2fd38f1$export$411ce8e5a71e3069(a, b) {
    try {
        return $471105b2f2fd38f1$var$check(a, b);
    } finally{
        $471105b2f2fd38f1$var$previousComparisons.clear();
    }
}
function $471105b2f2fd38f1$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $471105b2f2fd38f1$var$toString.call(a);
    var bTag = $471105b2f2fd38f1$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($471105b2f2fd38f1$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$471105b2f2fd38f1$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$471105b2f2fd38f1$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($471105b2f2fd38f1$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$471105b2f2fd38f1$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $471105b2f2fd38f1$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $471105b2f2fd38f1$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $471105b2f2fd38f1$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $471105b2f2fd38f1$export$2e2bcd8739ae039 = $471105b2f2fd38f1$export$411ce8e5a71e3069;

});



parcelRegister("7xYai", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $57ea48f9f955816f$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $57ea48f9f955816f$export$4997ffc0176396a6);

var $182fv = parcelRequire("182fv");
function $57ea48f9f955816f$var$defaultDispose() {}
var $57ea48f9f955816f$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $57ea48f9f955816f$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $57ea48f9f955816f$var$parentEntrySlot = new (0, $182fv.Slot)();
var $57ea48f9f955816f$var$reusableEmptyArray = [];
var $57ea48f9f955816f$var$emptySetPool = [];
var $57ea48f9f955816f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $57ea48f9f955816f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $57ea48f9f955816f$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $57ea48f9f955816f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $57ea48f9f955816f$var$valueCopy(value) {
    return value.slice(0);
}
var $57ea48f9f955816f$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $57ea48f9f955816f$var$assert(!this.recomputing, "already recomputing");
        if (!$57ea48f9f955816f$var$rememberParent(this) && $57ea48f9f955816f$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $57ea48f9f955816f$var$mightBeDirty(this) ? $57ea48f9f955816f$var$reallyRecompute(this) : $57ea48f9f955816f$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $57ea48f9f955816f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $57ea48f9f955816f$var$forgetChildren(this).forEach($57ea48f9f955816f$var$maybeReportOrphan);
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $57ea48f9f955816f$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $57ea48f9f955816f$var$rememberParent(child) {
    var parent = $57ea48f9f955816f$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($57ea48f9f955816f$var$mightBeDirty(child)) $57ea48f9f955816f$var$reportDirtyChild(parent, child);
        else $57ea48f9f955816f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $57ea48f9f955816f$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $57ea48f9f955816f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $57ea48f9f955816f$var$parentEntrySlot.withValue(entry, $57ea48f9f955816f$var$recomputeNewValue, [
        entry
    ]);
    if ($57ea48f9f955816f$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $57ea48f9f955816f$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($57ea48f9f955816f$var$maybeReportOrphan);
    return $57ea48f9f955816f$var$valueGet(entry.value);
}
function $57ea48f9f955816f$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $57ea48f9f955816f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $57ea48f9f955816f$var$setClean(entry) {
    entry.dirty = false;
    if ($57ea48f9f955816f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $57ea48f9f955816f$var$reportClean(entry);
}
function $57ea48f9f955816f$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportDirtyChild(parent, child);
    });
}
function $57ea48f9f955816f$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $57ea48f9f955816f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert($57ea48f9f955816f$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $57ea48f9f955816f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $57ea48f9f955816f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $57ea48f9f955816f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert(!$57ea48f9f955816f$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $57ea48f9f955816f$var$valueCopy(child.value));
    else if (!$57ea48f9f955816f$var$valueIs(childValue, child.value)) parent.setDirty();
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
    if ($57ea48f9f955816f$var$mightBeDirty(parent)) return;
    $57ea48f9f955816f$var$reportClean(parent);
}
function $57ea48f9f955816f$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($57ea48f9f955816f$var$emptySetPool.length < $57ea48f9f955816f$var$POOL_TARGET_SIZE) $57ea48f9f955816f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $57ea48f9f955816f$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $57ea48f9f955816f$var$forgetChildren(parent) {
    var children = $57ea48f9f955816f$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $57ea48f9f955816f$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $57ea48f9f955816f$var$assert(parent.dirtyChildren === null);
    return children;
}
function $57ea48f9f955816f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
}
function $57ea48f9f955816f$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $57ea48f9f955816f$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $57ea48f9f955816f$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $57ea48f9f955816f$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $57ea48f9f955816f$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $57ea48f9f955816f$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $57ea48f9f955816f$var$keyTrie = new $57ea48f9f955816f$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $57ea48f9f955816f$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $57ea48f9f955816f$var$keyTrie.lookupArray(args);
}
var $57ea48f9f955816f$var$caches = new Set();
function $57ea48f9f955816f$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $57ea48f9f955816f$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $57ea48f9f955816f$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$57ea48f9f955816f$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $57ea48f9f955816f$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $57ea48f9f955816f$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$57ea48f9f955816f$var$parentEntrySlot.hasValue()) {
            $57ea48f9f955816f$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $57ea48f9f955816f$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("182fv", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $0d28486785009faf$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $0d28486785009faf$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $0d28486785009faf$var$MISSING_VALUE = {};
var $0d28486785009faf$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $0d28486785009faf$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $0d28486785009faf$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $0d28486785009faf$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $0d28486785009faf$var$MISSING_VALUE) break;
                if (context_1 !== $0d28486785009faf$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $0d28486785009faf$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($0d28486785009faf$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $0d28486785009faf$var$currentContext.slots[this.id] = $0d28486785009faf$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $0d28486785009faf$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $0d28486785009faf$var$currentContext;
            $0d28486785009faf$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $0d28486785009faf$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $0d28486785009faf$var$currentContext;
            return function() {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($0d28486785009faf$var$currentContext) {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $0d28486785009faf$var$globalKey = "@wry/context:Slot";
var $0d28486785009faf$var$host = Array;
var $0d28486785009faf$export$8c6ed5c666ac1360 = $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] || function() {
    var Slot = $0d28486785009faf$var$makeSlotClass();
    try {
        Object.defineProperty($0d28486785009faf$var$host, $0d28486785009faf$var$globalKey, {
            value: $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $0d28486785009faf$export$2385a24977818dd0 = $0d28486785009faf$export$8c6ed5c666ac1360.bind, $0d28486785009faf$export$9fa6f2e300a97f8 = $0d28486785009faf$export$8c6ed5c666ac1360.noContext;
function $0d28486785009faf$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($0d28486785009faf$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $0d28486785009faf$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $0d28486785009faf$export$2385a24977818dd0(gen.next);
        var boundThrow = $0d28486785009faf$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($0d28486785009faf$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $0d28486785009faf$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $0d28486785009faf$var$wrappedFibers = [];
function $0d28486785009faf$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($0d28486785009faf$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $0d28486785009faf$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $0d28486785009faf$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("jlBDe", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $03a288f5350d9e9d$export$bd096ddbd246c79c);
$parcel$export(module.exports, "ApolloError", () => $03a288f5350d9e9d$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $03a288f5350d9e9d$export$13f5a5f0f1dbab88);
$parcel$export(module.exports, "default", () => $03a288f5350d9e9d$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $6XJYy = parcelRequire("6XJYy");

var $8j2fP = parcelRequire("8j2fP");

var $961BR = parcelRequire("961BR");
var $03a288f5350d9e9d$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($03a288f5350d9e9d$export$bd096ddbd246c79c || ($03a288f5350d9e9d$export$bd096ddbd246c79c = {}));
function $03a288f5350d9e9d$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $03a288f5350d9e9d$var$Observable = function(_super) {
    (0, $fKE23.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $6XJYy.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $5ECju.default));
function $03a288f5350d9e9d$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $03a288f5350d9e9d$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $03a288f5350d9e9d$var$generateErrorMessage = function(err) {
    var message = '';
    if ($03a288f5350d9e9d$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $03a288f5350d9e9d$export$26a337512320b8c6 = function(_super) {
    (0, $fKE23.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $03a288f5350d9e9d$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $03a288f5350d9e9d$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($03a288f5350d9e9d$export$160bafb6ac1e0641 || ($03a288f5350d9e9d$export$160bafb6ac1e0641 = {}));
var $03a288f5350d9e9d$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $03a288f5350d9e9d$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $03a288f5350d9e9d$export$6c1b56eac59c9584 = function(_super) {
    (0, $fKE23.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $42BH7.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($03a288f5350d9e9d$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $03a288f5350d9e9d$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $03a288f5350d9e9d$export$bd096ddbd246c79c.loading : $03a288f5350d9e9d$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            stale: false
        }));
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $66hGB.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $8j2fP.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $66hGB.equal)(this.variables, variables)) this.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.variables), variables);
        if (!(0, $66hGB.equal)(this.options.variables, this.variables)) this.options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $03a288f5350d9e9d$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $8j2fP.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $03a288f5350d9e9d$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $66hGB.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $42BH7.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $42BH7.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $03a288f5350d9e9d$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $fKE23.__assign)((0, $fKE23.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $66hGB.equal)(previousVariables, variables)) _this.refetch();
                        else $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($03a288f5350d9e9d$var$Observable);
function $03a288f5350d9e9d$var$defaultSubscriptionObserverErrorCallback(error) {}
function $03a288f5350d9e9d$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $8j2fP.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $03a288f5350d9e9d$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $03a288f5350d9e9d$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $8j2fP.invariant)(!previousQuery || previousQuery.document === query.document || (0, $66hGB.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.loading) {
            if (!(0, $66hGB.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.refetch;
        else networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $03a288f5350d9e9d$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $03a288f5350d9e9d$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $03a288f5350d9e9d$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $42BH7.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $42BH7.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            return (0, $fKE23.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $42BH7.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $42BH7.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $8j2fP.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            return (0, $fKE23.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $fKE23.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $961BR.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $961BR.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $42BH7.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $fKE23.__generator)(this, function(_b) {
                mainDefinition = (0, $42BH7.getMainDefinition)(document);
                fragments = (0, $42BH7.getFragmentDefinitions)(document);
                fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $03a288f5350d9e9d$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $fKE23.__generator)(this, function(_a) {
                            if (!(0, $42BH7.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $42BH7.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $8j2fP.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $42BH7.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $42BH7.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $42BH7.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $03a288f5350d9e9d$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $03a288f5350d9e9d$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $03a288f5350d9e9d$var$asyncMap(observable, mapFn) {
    return new $03a288f5350d9e9d$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $03a288f5350d9e9d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $03a288f5350d9e9d$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $03a288f5350d9e9d$var$MutationStore();
        this.queryStore = new $03a288f5350d9e9d$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $42BH7.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $03a288f5350d9e9d$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8j2fP.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $8j2fP.invariant)(mutation, 9);
                        (0, $8j2fP.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $03a288f5350d9e9d$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $42BH7.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $03a288f5350d9e9d$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $03a288f5350d9e9d$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($03a288f5350d9e9d$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $42BH7.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $42BH7.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $03a288f5350d9e9d$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $03a288f5350d9e9d$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($03a288f5350d9e9d$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $03a288f5350d9e9d$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $03a288f5350d9e9d$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $03a288f5350d9e9d$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $03a288f5350d9e9d$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $03a288f5350d9e9d$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $42BH7.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $42BH7.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $42BH7.getDefaultValues)((0, $42BH7.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $8j2fP.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $fKE23.__assign)({}, options);
        return new $03a288f5350d9e9d$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $8j2fP.invariant)(options.query, 12);
        (0, $8j2fP.invariant)(options.query.kind === 'Document', 13);
        (0, $8j2fP.invariant)(!options.returnPartialData, 14);
        (0, $8j2fP.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8j2fP.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $42BH7.graphQLResultHasError)(result)) throw new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $03a288f5350d9e9d$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $8j2fP.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $42BH7.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $03a288f5350d9e9d$var$multiplex((0, $bvQX6.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $03a288f5350d9e9d$var$multiplex((0, $bvQX6.execute)(link, operation));
        } else {
            observable = $03a288f5350d9e9d$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $03a288f5350d9e9d$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $03a288f5350d9e9d$var$isNonEmptyArray(result.errors)) return reject(new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.ready && query.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $8j2fP.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $03a288f5350d9e9d$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $03a288f5350d9e9d$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $42BH7.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $42BH7.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $42BH7.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $42BH7.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $42BH7.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $42BH7.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $42BH7.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $03a288f5350d9e9d$var$version = "2.6.10";
var $03a288f5350d9e9d$var$hasSuggestedDevtools = false;
var $03a288f5350d9e9d$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $bvQX6.ApolloLink).empty();
        if (!link || !cache) throw new (0, $8j2fP.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $03a288f5350d9e9d$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $03a288f5350d9e9d$var$version;
        this.localState = new $03a288f5350d9e9d$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $03a288f5350d9e9d$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.query), options);
        (0, $8j2fP.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $bvQX6.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $03a288f5350d9e9d$export$2e2bcd8739ae039 = $03a288f5350d9e9d$export$13f5a5f0f1dbab88;

});
parcelRegister("bvQX6", function(module, exports) {

$parcel$export(module.exports, "makePromise", () => makePromise);
$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "split", () => split);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("5ECju")).default);

var $5ECju = parcelRequire("5ECju");

var $8j2fP = parcelRequire("8j2fP");

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $8j2fP.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $fKE23.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $5ECju.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $5ECju.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $42BH7.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $fKE23.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $fKE23.__assign)({}, context, next(context));
        else context = (0, $fKE23.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $fKE23.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $5ECju.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $5ECju.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $5ECju.default).of() : rightLink.request(operation) || (0, $5ECju.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $5ECju.default).of() : rightLink.request(operation, forward) || (0, $5ECju.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $5ECju.default).of();
        }) || (0, $5ECju.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $5ECju.default).of();
        }) || (0, $5ECju.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $8j2fP.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $5ECju.default).of();
}

});
parcelRegister("5ECju", function(module, exports) {

$parcel$export(module.exports, "default", () => $41de6865c2ff0290$export$2e2bcd8739ae039);

var $1eC02 = parcelRequire("1eC02");
var $41de6865c2ff0290$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($1eC02)));
var $41de6865c2ff0290$export$2e2bcd8739ae039 = $41de6865c2ff0290$export$77cea355fa80b5f4;

});
parcelRegister("1eC02", function(module, exports) {

module.exports = (parcelRequire("bhbKH")).Observable;

});
parcelRegister("bhbKH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $835a65fddbd60374$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $835a65fddbd60374$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $835a65fddbd60374$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $835a65fddbd60374$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $835a65fddbd60374$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $835a65fddbd60374$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $835a65fddbd60374$var$hasSymbol = function(name) {
    return $835a65fddbd60374$var$hasSymbols() && Boolean(Symbol[name]);
};
var $835a65fddbd60374$var$getSymbol = function(name) {
    return $835a65fddbd60374$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($835a65fddbd60374$var$hasSymbols() && !$835a65fddbd60374$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $835a65fddbd60374$var$SymbolIterator = $835a65fddbd60374$var$getSymbol('iterator');
var $835a65fddbd60374$var$SymbolObservable = $835a65fddbd60374$var$getSymbol('observable');
var $835a65fddbd60374$var$SymbolSpecies = $835a65fddbd60374$var$getSymbol('species'); // === Abstract Operations ===
function $835a65fddbd60374$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $835a65fddbd60374$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$835a65fddbd60374$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $835a65fddbd60374$var$Observable;
}
function $835a65fddbd60374$var$isObservable(x) {
    return x instanceof $835a65fddbd60374$var$Observable; // SPEC: Brand check
}
function $835a65fddbd60374$var$hostReportError(e) {
    if ($835a65fddbd60374$var$hostReportError.log) $835a65fddbd60374$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $835a65fddbd60374$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $835a65fddbd60374$var$hostReportError(e);
        }
    });
}
function $835a65fddbd60374$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $835a65fddbd60374$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $835a65fddbd60374$var$hostReportError(e);
    }
}
function $835a65fddbd60374$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $835a65fddbd60374$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $835a65fddbd60374$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $835a65fddbd60374$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $835a65fddbd60374$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $835a65fddbd60374$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $835a65fddbd60374$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $835a65fddbd60374$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $835a65fddbd60374$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $835a65fddbd60374$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $835a65fddbd60374$var$enqueue(function() {
            return $835a65fddbd60374$var$flushSubscription(subscription);
        });
        return;
    }
    $835a65fddbd60374$var$notifySubscription(subscription, type, value);
}
var $835a65fddbd60374$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $835a65fddbd60374$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $835a65fddbd60374$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $835a65fddbd60374$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $835a65fddbd60374$var$closeSubscription(this);
                    $835a65fddbd60374$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $835a65fddbd60374$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $835a65fddbd60374$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $835a65fddbd60374$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $835a65fddbd60374$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $835a65fddbd60374$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $835a65fddbd60374$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $835a65fddbd60374$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $835a65fddbd60374$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $835a65fddbd60374$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $835a65fddbd60374$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $835a65fddbd60374$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $835a65fddbd60374$var$getMethod(x, $835a65fddbd60374$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($835a65fddbd60374$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($835a65fddbd60374$var$hasSymbol('iterator')) {
                    method = $835a65fddbd60374$var$getMethod(x, $835a65fddbd60374$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $835a65fddbd60374$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $835a65fddbd60374$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $835a65fddbd60374$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $835a65fddbd60374$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $835a65fddbd60374$var$Observable;
if ($835a65fddbd60374$var$hasSymbols()) Object.defineProperty($835a65fddbd60374$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $835a65fddbd60374$var$SymbolObservable,
        hostReportError: $835a65fddbd60374$var$hostReportError
    },
    configurable: true
});

});





parcelRegister("711qW", function(module, exports) {

$parcel$export(module.exports, "SchemaLink", () => $51b9bd0fcd15a4c3$export$f2b7839aa4c35c8d);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $3MP74 = parcelRequire("3MP74");
var $51b9bd0fcd15a4c3$export$f2b7839aa4c35c8d = function(_super) {
    (0, $fKE23.__extends)(SchemaLink, _super);
    function SchemaLink(_a) {
        var schema = _a.schema, rootValue = _a.rootValue, context = _a.context;
        var _this = _super.call(this) || this;
        _this.schema = schema;
        _this.rootValue = rootValue;
        _this.context = context;
        return _this;
    }
    SchemaLink.prototype.request = function(operation) {
        var _this = this;
        return new (0, $5ECju.default)(function(observer) {
            Promise.resolve((0, $3MP74.execute)(_this.schema, operation.query, _this.rootValue, typeof _this.context === 'function' ? _this.context(operation) : _this.context, operation.variables, operation.operationName)).then(function(data) {
                if (!observer.closed) {
                    observer.next(data);
                    observer.complete();
                }
            }).catch(function(error) {
                if (!observer.closed) observer.error(error);
            });
        });
    };
    return SchemaLink;
}((0, $bvQX6.ApolloLink));
var $51b9bd0fcd15a4c3$export$2e2bcd8739ae039 = $51b9bd0fcd15a4c3$export$f2b7839aa4c35c8d;

});
parcelRegister("3MP74", function(module, exports) {

$parcel$export(module.exports, "execute", () => $28b9215d12482e59$export$51396ec711da548b);
$parcel$export(module.exports, "assertValidExecutionArguments", () => $28b9215d12482e59$export$e02b605d81e17af1);
$parcel$export(module.exports, "buildExecutionContext", () => $28b9215d12482e59$export$312a3f029bac48f9);
$parcel$export(module.exports, "defaultFieldResolver", () => $28b9215d12482e59$export$21fc6d079630d659);
$parcel$export(module.exports, "collectFields", () => $28b9215d12482e59$export$c23741d442fe90e9);
$parcel$export(module.exports, "getFieldDef", () => $28b9215d12482e59$export$dab6dcab745bb1b6);
$parcel$export(module.exports, "buildResolveInfo", () => $28b9215d12482e59$export$27b5443b7768606f);

var $biK02 = parcelRequire("biK02");

var $aF2x8 = parcelRequire("aF2x8");

var $43MJl = parcelRequire("43MJl");

var $fZdRY = parcelRequire("fZdRY");

var $cvCbM = parcelRequire("cvCbM");

var $fbtyx = parcelRequire("fbtyx");

var $8DMvn = parcelRequire("8DMvn");

var $3SMRB = parcelRequire("3SMRB");

var $jvU6q = parcelRequire("jvU6q");

var $kZHaf = parcelRequire("kZHaf");

var $9fgMZ = parcelRequire("9fgMZ");

var $02KAV = parcelRequire("02KAV");

var $1c4hI = parcelRequire("1c4hI");

var $izaFt = parcelRequire("izaFt");

var $h2iUh = parcelRequire("h2iUh");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");

var $bis9F = parcelRequire("bis9F");

var $gqGQB = parcelRequire("gqGQB");
function $28b9215d12482e59$export$51396ec711da548b(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
    /* eslint-enable no-redeclare */ // Extract arguments from object args if provided.
    return arguments.length === 1 ? $28b9215d12482e59$var$executeImpl(argsOrSchema) : $28b9215d12482e59$var$executeImpl({
        schema: argsOrSchema,
        document: document,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        typeResolver: typeResolver
    });
}
function $28b9215d12482e59$export$6d0f20a121527483(args) {
    var result = $28b9215d12482e59$var$executeImpl(args); // Assert that the execution was synchronous.
    if ((0, $cvCbM.default)(result)) throw new Error('GraphQL execution failed to complete synchronously.');
    return result;
}
function $28b9215d12482e59$var$executeImpl(args) {
    var schema = args.schema, document = args.document, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, typeResolver = args.typeResolver; // If arguments are missing or incorrect, throw an error.
    $28b9215d12482e59$export$e02b605d81e17af1(schema, document, variableValues); // If a valid execution context cannot be created due to incorrect arguments,
    // a "Response" with only errors is returned.
    var exeContext = $28b9215d12482e59$export$312a3f029bac48f9(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver); // Return early errors if execution context failed.
    if (Array.isArray(exeContext)) return {
        errors: exeContext
    };
     // Return a Promise that will eventually resolve to the data described by
    // The "Response" section of the GraphQL specification.
    //
    // If errors are encountered while executing a GraphQL field, only that
    // field and its descendants will be omitted, and sibling fields will still
    // be executed. An execution which encounters errors will still result in a
    // resolved Promise.
    var data = $28b9215d12482e59$var$executeOperation(exeContext, exeContext.operation, rootValue);
    return $28b9215d12482e59$var$buildResponse(exeContext, data);
}
/**
 * Given a completed execution context and data, build the { errors, data }
 * response defined by the "Response" section of the GraphQL specification.
 */ function $28b9215d12482e59$var$buildResponse(exeContext, data) {
    if ((0, $cvCbM.default)(data)) return data.then(function(resolved) {
        return $28b9215d12482e59$var$buildResponse(exeContext, resolved);
    });
    return exeContext.errors.length === 0 ? {
        data: data
    } : {
        errors: exeContext.errors,
        data: data
    };
}
function $28b9215d12482e59$export$e02b605d81e17af1(schema, document, rawVariableValues) {
    document || (0, $fZdRY.default)(0, 'Must provide document.'); // If the schema used for execution is invalid, throw an error.
    (0, $izaFt.assertValidSchema)(schema); // Variables, if provided, must be an object.
    rawVariableValues == null || (0, $fbtyx.default)(rawVariableValues) || (0, $fZdRY.default)(0, 'Variables must be provided as an Object where each property is a variable value. Perhaps look to see if an unparsed JSON string was provided.');
}
function $28b9215d12482e59$export$312a3f029bac48f9(schema, document, rootValue, contextValue, rawVariableValues, operationName, fieldResolver, typeResolver) {
    var _definition$name, _operation$variableDe;
    var operation;
    var fragments = Object.create(null);
    for(var _i2 = 0, _document$definitions2 = document.definitions; _i2 < _document$definitions2.length; _i2++){
        var definition = _document$definitions2[_i2];
        switch(definition.kind){
            case (0, $1c4hI.Kind).OPERATION_DEFINITION:
                if (operationName == null) {
                    if (operation !== undefined) return [
                        new (0, $9fgMZ.GraphQLError)('Must provide operation name if query contains multiple operations.')
                    ];
                    operation = definition;
                } else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) operation = definition;
                break;
            case (0, $1c4hI.Kind).FRAGMENT_DEFINITION:
                fragments[definition.name.value] = definition;
                break;
        }
    }
    if (!operation) {
        if (operationName != null) return [
            new (0, $9fgMZ.GraphQLError)("Unknown operation named \"".concat(operationName, "\"."))
        ];
        return [
            new (0, $9fgMZ.GraphQLError)('Must provide an operation.')
        ];
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    var variableDefinitions = (_operation$variableDe = operation.variableDefinitions) !== null && _operation$variableDe !== void 0 ? _operation$variableDe : [];
    var coercedVariableValues = (0, $gqGQB.getVariableValues)(schema, variableDefinitions, rawVariableValues !== null && rawVariableValues !== void 0 ? rawVariableValues : {}, {
        maxErrors: 50
    });
    if (coercedVariableValues.errors) return coercedVariableValues.errors;
    return {
        schema: schema,
        fragments: fragments,
        rootValue: rootValue,
        contextValue: contextValue,
        operation: operation,
        variableValues: coercedVariableValues.coerced,
        fieldResolver: fieldResolver !== null && fieldResolver !== void 0 ? fieldResolver : $28b9215d12482e59$export$21fc6d079630d659,
        typeResolver: typeResolver !== null && typeResolver !== void 0 ? typeResolver : $28b9215d12482e59$export$4a45c17a1ba2cb7,
        errors: []
    };
}
/**
 * Implements the "Evaluating operations" section of the spec.
 */ function $28b9215d12482e59$var$executeOperation(exeContext, operation, rootValue) {
    var type = (0, $bis9F.getOperationRootType)(exeContext.schema, operation);
    var fields = $28b9215d12482e59$export$c23741d442fe90e9(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
    var path = undefined; // Errors from sub-fields of a NonNull type may propagate to the top level,
    // at which point we still log the error and null the parent field, which
    // in this case is the entire response.
    try {
        var result = operation.operation === 'mutation' ? $28b9215d12482e59$var$executeFieldsSerially(exeContext, type, rootValue, path, fields) : $28b9215d12482e59$var$executeFields(exeContext, type, rootValue, path, fields);
        if ((0, $cvCbM.default)(result)) return result.then(undefined, function(error) {
            exeContext.errors.push(error);
            return Promise.resolve(null);
        });
        return result;
    } catch (error) {
        exeContext.errors.push(error);
        return null;
    }
}
/**
 * Implements the "Evaluating selection sets" section of the spec
 * for "write" mode.
 */ function $28b9215d12482e59$var$executeFieldsSerially(exeContext, parentType, sourceValue, path, fields) {
    return (0, $3SMRB.default)(Object.keys(fields), function(results, responseName) {
        var fieldNodes = fields[responseName];
        var fieldPath = (0, $kZHaf.addPath)(path, responseName, parentType.name);
        var result = $28b9215d12482e59$var$resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
        if (result === undefined) return results;
        if ((0, $cvCbM.default)(result)) return result.then(function(resolvedResult) {
            results[responseName] = resolvedResult;
            return results;
        });
        results[responseName] = result;
        return results;
    }, Object.create(null));
}
/**
 * Implements the "Evaluating selection sets" section of the spec
 * for "read" mode.
 */ function $28b9215d12482e59$var$executeFields(exeContext, parentType, sourceValue, path, fields) {
    var results = Object.create(null);
    var containsPromise = false;
    for(var _i4 = 0, _Object$keys2 = Object.keys(fields); _i4 < _Object$keys2.length; _i4++){
        var responseName = _Object$keys2[_i4];
        var fieldNodes = fields[responseName];
        var fieldPath = (0, $kZHaf.addPath)(path, responseName, parentType.name);
        var result = $28b9215d12482e59$var$resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
        if (result !== undefined) {
            results[responseName] = result;
            if ((0, $cvCbM.default)(result)) containsPromise = true;
        }
    } // If there are no promises, we can just return the object
    if (!containsPromise) return results;
     // Otherwise, results is a map from field name to the result of resolving that
    // field, which is possibly a promise. Return a promise that will return this
    // same map, but with any promises replaced with the values they resolved to.
    return (0, $jvU6q.default)(results);
}
function $28b9215d12482e59$export$c23741d442fe90e9(exeContext, runtimeType, selectionSet, fields, visitedFragmentNames) {
    for(var _i6 = 0, _selectionSet$selecti2 = selectionSet.selections; _i6 < _selectionSet$selecti2.length; _i6++){
        var selection = _selectionSet$selecti2[_i6];
        switch(selection.kind){
            case (0, $1c4hI.Kind).FIELD:
                if (!$28b9215d12482e59$var$shouldIncludeNode(exeContext, selection)) continue;
                var name = $28b9215d12482e59$var$getFieldEntryKey(selection);
                if (!fields[name]) fields[name] = [];
                fields[name].push(selection);
                break;
            case (0, $1c4hI.Kind).INLINE_FRAGMENT:
                if (!$28b9215d12482e59$var$shouldIncludeNode(exeContext, selection) || !$28b9215d12482e59$var$doesFragmentConditionMatch(exeContext, selection, runtimeType)) continue;
                $28b9215d12482e59$export$c23741d442fe90e9(exeContext, runtimeType, selection.selectionSet, fields, visitedFragmentNames);
                break;
            case (0, $1c4hI.Kind).FRAGMENT_SPREAD:
                var fragName = selection.name.value;
                if (visitedFragmentNames[fragName] || !$28b9215d12482e59$var$shouldIncludeNode(exeContext, selection)) continue;
                visitedFragmentNames[fragName] = true;
                var fragment = exeContext.fragments[fragName];
                if (!fragment || !$28b9215d12482e59$var$doesFragmentConditionMatch(exeContext, fragment, runtimeType)) continue;
                $28b9215d12482e59$export$c23741d442fe90e9(exeContext, runtimeType, fragment.selectionSet, fields, visitedFragmentNames);
                break;
        }
    }
    return fields;
}
/**
 * Determines if a field should be included based on the @include and @skip
 * directives, where @skip has higher precedence than @include.
 */ function $28b9215d12482e59$var$shouldIncludeNode(exeContext, node) {
    var skip = (0, $gqGQB.getDirectiveValues)((0, $bOniD.GraphQLSkipDirective), node, exeContext.variableValues);
    if ((skip === null || skip === void 0 ? void 0 : skip.if) === true) return false;
    var include = (0, $gqGQB.getDirectiveValues)((0, $bOniD.GraphQLIncludeDirective), node, exeContext.variableValues);
    if ((include === null || include === void 0 ? void 0 : include.if) === false) return false;
    return true;
}
/**
 * Determines if a fragment is applicable to the given type.
 */ function $28b9215d12482e59$var$doesFragmentConditionMatch(exeContext, fragment, type) {
    var typeConditionNode = fragment.typeCondition;
    if (!typeConditionNode) return true;
    var conditionalType = (0, $3zSAT.typeFromAST)(exeContext.schema, typeConditionNode);
    if (conditionalType === type) return true;
    if ((0, $lXoEQ.isAbstractType)(conditionalType)) return exeContext.schema.isSubType(conditionalType, type);
    return false;
}
/**
 * Implements the logic to compute the key of a given field's entry
 */ function $28b9215d12482e59$var$getFieldEntryKey(node) {
    return node.alias ? node.alias.value : node.name.value;
}
/**
 * Resolves the field on the given source object. In particular, this
 * figures out the value that the field returns by calling its resolve function,
 * then calls completeValue to complete promises, serialize scalars, or execute
 * the sub-selection-set for objects.
 */ function $28b9215d12482e59$var$resolveField(exeContext, parentType, source, fieldNodes, path) {
    var _fieldDef$resolve;
    var fieldNode = fieldNodes[0];
    var fieldName = fieldNode.name.value;
    var fieldDef = $28b9215d12482e59$export$dab6dcab745bb1b6(exeContext.schema, parentType, fieldName);
    if (!fieldDef) return;
    var returnType = fieldDef.type;
    var resolveFn = (_fieldDef$resolve = fieldDef.resolve) !== null && _fieldDef$resolve !== void 0 ? _fieldDef$resolve : exeContext.fieldResolver;
    var info = $28b9215d12482e59$export$27b5443b7768606f(exeContext, fieldDef, fieldNodes, parentType, path); // Get the resolve function, regardless of if its result is normal or abrupt (error).
    try {
        // Build a JS object of arguments from the field.arguments AST, using the
        // variables scope to fulfill any variable references.
        // TODO: find a way to memoize, in case this field is within a List type.
        var args = (0, $gqGQB.getArgumentValues)(fieldDef, fieldNodes[0], exeContext.variableValues); // The resolve function's optional third argument is a context value that
        // is provided to every resolve function within an execution. It is commonly
        // used to represent an authenticated user, or request-specific caches.
        var _contextValue = exeContext.contextValue;
        var result = resolveFn(source, args, _contextValue, info);
        var completed;
        if ((0, $cvCbM.default)(result)) completed = result.then(function(resolved) {
            return $28b9215d12482e59$var$completeValue(exeContext, returnType, fieldNodes, info, path, resolved);
        });
        else completed = $28b9215d12482e59$var$completeValue(exeContext, returnType, fieldNodes, info, path, result);
        if ((0, $cvCbM.default)(completed)) // Note: we don't rely on a `catch` method, but we do expect "thenable"
        // to take a second callback for the error case.
        return completed.then(undefined, function(rawError) {
            var error = (0, $02KAV.locatedError)(rawError, fieldNodes, (0, $kZHaf.pathToArray)(path));
            return $28b9215d12482e59$var$handleFieldError(error, returnType, exeContext);
        });
        return completed;
    } catch (rawError) {
        var error = (0, $02KAV.locatedError)(rawError, fieldNodes, (0, $kZHaf.pathToArray)(path));
        return $28b9215d12482e59$var$handleFieldError(error, returnType, exeContext);
    }
}
function $28b9215d12482e59$export$27b5443b7768606f(exeContext, fieldDef, fieldNodes, parentType, path) {
    // The resolve function's optional fourth argument is a collection of
    // information about the current execution state.
    return {
        fieldName: fieldDef.name,
        fieldNodes: fieldNodes,
        returnType: fieldDef.type,
        parentType: parentType,
        path: path,
        schema: exeContext.schema,
        fragments: exeContext.fragments,
        rootValue: exeContext.rootValue,
        operation: exeContext.operation,
        variableValues: exeContext.variableValues
    };
}
function $28b9215d12482e59$var$handleFieldError(error, returnType, exeContext) {
    // If the field type is non-nullable, then it is resolved without any
    // protection from errors, however it still properly locates the error.
    if ((0, $lXoEQ.isNonNullType)(returnType)) throw error;
     // Otherwise, error protection is applied, logging the error and resolving
    // a null value for this field if one is encountered.
    exeContext.errors.push(error);
    return null;
}
/**
 * Implements the instructions for completeValue as defined in the
 * "Field entries" section of the spec.
 *
 * If the field type is Non-Null, then this recursively completes the value
 * for the inner type. It throws a field error if that completion returns null,
 * as per the "Nullability" section of the spec.
 *
 * If the field type is a List, then this recursively completes the value
 * for the inner type on each item in the list.
 *
 * If the field type is a Scalar or Enum, ensures the completed value is a legal
 * value of the type by calling the `serialize` method of GraphQL type
 * definition.
 *
 * If the field is an abstract type, determine the runtime type of the value
 * and then complete based on that type
 *
 * Otherwise, the field type expects a sub-selection set, and will complete the
 * value by evaluating all sub-selections.
 */ function $28b9215d12482e59$var$completeValue(exeContext, returnType, fieldNodes, info, path, result) {
    // If result is an Error, throw a located error.
    if (result instanceof Error) throw result;
     // If field type is NonNull, complete for inner type, and throw field error
    // if result is null.
    if ((0, $lXoEQ.isNonNullType)(returnType)) {
        var completed = $28b9215d12482e59$var$completeValue(exeContext, returnType.ofType, fieldNodes, info, path, result);
        if (completed === null) throw new Error("Cannot return null for non-nullable field ".concat(info.parentType.name, ".").concat(info.fieldName, "."));
        return completed;
    } // If result value is null or undefined then return null.
    if (result == null) return null;
     // If field type is List, complete each item in the list with the inner type
    if ((0, $lXoEQ.isListType)(returnType)) return $28b9215d12482e59$var$completeListValue(exeContext, returnType, fieldNodes, info, path, result);
     // If field type is a leaf type, Scalar or Enum, serialize to a valid value,
    // returning null if serialization is not possible.
    if ((0, $lXoEQ.isLeafType)(returnType)) return $28b9215d12482e59$var$completeLeafValue(returnType, result);
     // If field type is an abstract type, Interface or Union, determine the
    // runtime Object type and complete for that type.
    if ((0, $lXoEQ.isAbstractType)(returnType)) return $28b9215d12482e59$var$completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result);
     // If field type is Object, execute and complete all sub-selections.
    // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isObjectType)(returnType)) return $28b9215d12482e59$var$completeObjectValue(exeContext, returnType, fieldNodes, info, path, result);
     // istanbul ignore next (Not reachable. All possible output types have been considered)
    (0, $43MJl.default)(0, 'Cannot complete value of unexpected output type: ' + (0, $biK02.default)(returnType));
}
/**
 * Complete a list value by completing each item in the list with the
 * inner type
 */ function $28b9215d12482e59$var$completeListValue(exeContext, returnType, fieldNodes, info, path, result) {
    // This is specified as a simple map, however we're optimizing the path
    // where the list contains no Promises by avoiding creating another Promise.
    var itemType = returnType.ofType;
    var containsPromise = false;
    var completedResults = (0, $8DMvn.default)(result, function(item, index) {
        // No need to modify the info object containing the path,
        // since from here on it is not ever accessed by resolver functions.
        var itemPath = (0, $kZHaf.addPath)(path, index, undefined);
        try {
            var completedItem;
            if ((0, $cvCbM.default)(item)) completedItem = item.then(function(resolved) {
                return $28b9215d12482e59$var$completeValue(exeContext, itemType, fieldNodes, info, itemPath, resolved);
            });
            else completedItem = $28b9215d12482e59$var$completeValue(exeContext, itemType, fieldNodes, info, itemPath, item);
            if ((0, $cvCbM.default)(completedItem)) {
                containsPromise = true; // Note: we don't rely on a `catch` method, but we do expect "thenable"
                // to take a second callback for the error case.
                return completedItem.then(undefined, function(rawError) {
                    var error = (0, $02KAV.locatedError)(rawError, fieldNodes, (0, $kZHaf.pathToArray)(itemPath));
                    return $28b9215d12482e59$var$handleFieldError(error, itemType, exeContext);
                });
            }
            return completedItem;
        } catch (rawError) {
            var error = (0, $02KAV.locatedError)(rawError, fieldNodes, (0, $kZHaf.pathToArray)(itemPath));
            return $28b9215d12482e59$var$handleFieldError(error, itemType, exeContext);
        }
    });
    if (completedResults == null) throw new (0, $9fgMZ.GraphQLError)("Expected Iterable, but did not find one for field \"".concat(info.parentType.name, ".").concat(info.fieldName, "\"."));
    return containsPromise ? Promise.all(completedResults) : completedResults;
}
/**
 * Complete a Scalar or Enum by serializing to a valid value, returning
 * null if serialization is not possible.
 */ function $28b9215d12482e59$var$completeLeafValue(returnType, result) {
    var serializedResult = returnType.serialize(result);
    if (serializedResult === undefined) throw new Error("Expected a value of type \"".concat((0, $biK02.default)(returnType), "\" but ") + "received: ".concat((0, $biK02.default)(result)));
    return serializedResult;
}
/**
 * Complete a value of an abstract type by determining the runtime object type
 * of that value, then complete the value for that type.
 */ function $28b9215d12482e59$var$completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result) {
    var _returnType$resolveTy;
    var resolveTypeFn = (_returnType$resolveTy = returnType.resolveType) !== null && _returnType$resolveTy !== void 0 ? _returnType$resolveTy : exeContext.typeResolver;
    var contextValue = exeContext.contextValue;
    var runtimeType = resolveTypeFn(result, contextValue, info, returnType);
    if ((0, $cvCbM.default)(runtimeType)) return runtimeType.then(function(resolvedRuntimeType) {
        return $28b9215d12482e59$var$completeObjectValue(exeContext, $28b9215d12482e59$var$ensureValidRuntimeType(resolvedRuntimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
    });
    return $28b9215d12482e59$var$completeObjectValue(exeContext, $28b9215d12482e59$var$ensureValidRuntimeType(runtimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
}
function $28b9215d12482e59$var$ensureValidRuntimeType(runtimeTypeOrName, exeContext, returnType, fieldNodes, info, result) {
    if (runtimeTypeOrName == null) throw new (0, $9fgMZ.GraphQLError)("Abstract type \"".concat(returnType.name, "\" must resolve to an Object type at runtime for field \"").concat(info.parentType.name, ".").concat(info.fieldName, "\". Either the \"").concat(returnType.name, "\" type should provide a \"resolveType\" function or each possible type should provide an \"isTypeOf\" function."), fieldNodes);
     // FIXME: temporary workaround until support for passing object types would be removed in v16.0.0
    var runtimeTypeName = (0, $lXoEQ.isNamedType)(runtimeTypeOrName) ? runtimeTypeOrName.name : runtimeTypeOrName;
    if (typeof runtimeTypeName !== 'string') throw new (0, $9fgMZ.GraphQLError)("Abstract type \"".concat(returnType.name, "\" must resolve to an Object type at runtime for field \"").concat(info.parentType.name, ".").concat(info.fieldName, "\" with ") + "value ".concat((0, $biK02.default)(result), ", received \"").concat((0, $biK02.default)(runtimeTypeOrName), "\"."));
    var runtimeType = exeContext.schema.getType(runtimeTypeName);
    if (runtimeType == null) throw new (0, $9fgMZ.GraphQLError)("Abstract type \"".concat(returnType.name, "\" was resolve to a type \"").concat(runtimeTypeName, "\" that does not exist inside schema."), fieldNodes);
    if (!(0, $lXoEQ.isObjectType)(runtimeType)) throw new (0, $9fgMZ.GraphQLError)("Abstract type \"".concat(returnType.name, "\" was resolve to a non-object type \"").concat(runtimeTypeName, "\"."), fieldNodes);
    if (!exeContext.schema.isSubType(returnType, runtimeType)) throw new (0, $9fgMZ.GraphQLError)("Runtime Object type \"".concat(runtimeType.name, "\" is not a possible type for \"").concat(returnType.name, "\"."), fieldNodes);
    return runtimeType;
}
/**
 * Complete an Object value by executing all sub-selections.
 */ function $28b9215d12482e59$var$completeObjectValue(exeContext, returnType, fieldNodes, info, path, result) {
    // If there is an isTypeOf predicate function, call it with the
    // current result. If isTypeOf returns false, then raise an error rather
    // than continuing execution.
    if (returnType.isTypeOf) {
        var isTypeOf = returnType.isTypeOf(result, exeContext.contextValue, info);
        if ((0, $cvCbM.default)(isTypeOf)) return isTypeOf.then(function(resolvedIsTypeOf) {
            if (!resolvedIsTypeOf) throw $28b9215d12482e59$var$invalidReturnTypeError(returnType, result, fieldNodes);
            return $28b9215d12482e59$var$collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
        });
        if (!isTypeOf) throw $28b9215d12482e59$var$invalidReturnTypeError(returnType, result, fieldNodes);
    }
    return $28b9215d12482e59$var$collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
}
function $28b9215d12482e59$var$invalidReturnTypeError(returnType, result, fieldNodes) {
    return new (0, $9fgMZ.GraphQLError)("Expected value of type \"".concat(returnType.name, "\" but got: ").concat((0, $biK02.default)(result), "."), fieldNodes);
}
function $28b9215d12482e59$var$collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result) {
    // Collect sub-fields to execute to complete this value.
    var subFieldNodes = $28b9215d12482e59$var$collectSubfields(exeContext, returnType, fieldNodes);
    return $28b9215d12482e59$var$executeFields(exeContext, returnType, result, path, subFieldNodes);
}
/**
 * A memoized collection of relevant subfields with regard to the return
 * type. Memoizing ensures the subfields are not repeatedly calculated, which
 * saves overhead when resolving lists of values.
 */ var $28b9215d12482e59$var$collectSubfields = (0, $aF2x8.default)($28b9215d12482e59$var$_collectSubfields);
function $28b9215d12482e59$var$_collectSubfields(exeContext, returnType, fieldNodes) {
    var subFieldNodes = Object.create(null);
    var visitedFragmentNames = Object.create(null);
    for(var _i8 = 0; _i8 < fieldNodes.length; _i8++){
        var node = fieldNodes[_i8];
        if (node.selectionSet) subFieldNodes = $28b9215d12482e59$export$c23741d442fe90e9(exeContext, returnType, node.selectionSet, subFieldNodes, visitedFragmentNames);
    }
    return subFieldNodes;
}
var $28b9215d12482e59$export$4a45c17a1ba2cb7 = function defaultTypeResolver(value, contextValue, info, abstractType) {
    // First, look for `__typename`.
    if ((0, $fbtyx.default)(value) && typeof value.__typename === 'string') return value.__typename;
     // Otherwise, test each possible type.
    var possibleTypes = info.schema.getPossibleTypes(abstractType);
    var promisedIsTypeOfResults = [];
    for(var i = 0; i < possibleTypes.length; i++){
        var type = possibleTypes[i];
        if (type.isTypeOf) {
            var isTypeOfResult = type.isTypeOf(value, contextValue, info);
            if ((0, $cvCbM.default)(isTypeOfResult)) promisedIsTypeOfResults[i] = isTypeOfResult;
            else if (isTypeOfResult) return type.name;
        }
    }
    if (promisedIsTypeOfResults.length) return Promise.all(promisedIsTypeOfResults).then(function(isTypeOfResults) {
        for(var _i9 = 0; _i9 < isTypeOfResults.length; _i9++){
            if (isTypeOfResults[_i9]) return possibleTypes[_i9].name;
        }
    });
};
var $28b9215d12482e59$export$21fc6d079630d659 = function defaultFieldResolver(source, args, contextValue, info) {
    // ensure source is a value for which property access is acceptable.
    if ((0, $fbtyx.default)(source) || typeof source === 'function') {
        var property = source[info.fieldName];
        if (typeof property === 'function') return source[info.fieldName](args, contextValue, info);
        return property;
    }
};
function $28b9215d12482e59$export$dab6dcab745bb1b6(schema, parentType, fieldName) {
    if (fieldName === (0, $h2iUh.SchemaMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $h2iUh.SchemaMetaFieldDef;
    else if (fieldName === (0, $h2iUh.TypeMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $h2iUh.TypeMetaFieldDef;
    else if (fieldName === (0, $h2iUh.TypeNameMetaFieldDef).name) return 0, $h2iUh.TypeNameMetaFieldDef;
    return parentType.getFields()[fieldName];
}

});
parcelRegister("aF2x8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8e58f7eb075f9f2$export$2e2bcd8739ae039);
/**
 * Memoizes the provided three-argument function.
 */ function $f8e58f7eb075f9f2$export$2e2bcd8739ae039(fn) {
    var cache0;
    return function memoized(a1, a2, a3) {
        if (!cache0) cache0 = new WeakMap();
        var cache1 = cache0.get(a1);
        var cache2;
        if (cache1) {
            cache2 = cache1.get(a2);
            if (cache2) {
                var cachedValue = cache2.get(a3);
                if (cachedValue !== undefined) return cachedValue;
            }
        } else {
            cache1 = new WeakMap();
            cache0.set(a1, cache1);
        }
        if (!cache2) {
            cache2 = new WeakMap();
            cache1.set(a2, cache2);
        }
        var newValue = fn(a1, a2, a3);
        cache2.set(a3, newValue);
        return newValue;
    };
}

});

parcelRegister("cvCbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $23d6e18c41560dd9$export$2e2bcd8739ae039);
/**
 * Returns true if the value acts like a Promise, i.e. has a "then" function,
 * otherwise returns false.
 */ // eslint-disable-next-line no-redeclare
function $23d6e18c41560dd9$export$2e2bcd8739ae039(value) {
    return typeof (value === null || value === void 0 ? void 0 : value.then) === 'function';
}

});

parcelRegister("8DMvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $313b09bab2d4edd6$export$2e2bcd8739ae039);

var $gwa3m = parcelRequire("gwa3m");
function $313b09bab2d4edd6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $313b09bab2d4edd6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $313b09bab2d4edd6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $313b09bab2d4edd6$var$_typeof(obj);
}
function $313b09bab2d4edd6$export$2e2bcd8739ae039(collection) {
    var mapFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function(item) {
        return item;
    };
    if (collection == null || $313b09bab2d4edd6$var$_typeof(collection) !== 'object') return null;
    if (Array.isArray(collection)) return collection.map(mapFn);
     // Is Iterable?
    var iteratorMethod = collection[0, $gwa3m.SYMBOL_ITERATOR];
    if (typeof iteratorMethod === 'function') {
        // $FlowFixMe[incompatible-use]
        var iterator = iteratorMethod.call(collection);
        var result = [];
        var step;
        for(var i = 0; !(step = iterator.next()).done; ++i)result.push(mapFn(step.value, i));
        return result;
    } // Is Array like?
    var length = collection.length;
    if (typeof length === 'number' && length >= 0 && length % 1 === 0) {
        var _result = [];
        for(var _i = 0; _i < length; ++_i){
            if (!Object.prototype.hasOwnProperty.call(collection, _i)) return null;
            _result.push(mapFn(collection[String(_i)], _i));
        }
        return _result;
    }
    return null;
}

});

parcelRegister("3SMRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2153f857d28efb07$export$2e2bcd8739ae039);

var $cvCbM = parcelRequire("cvCbM");
function $2153f857d28efb07$export$2e2bcd8739ae039(values, callback, initialValue) {
    return values.reduce(function(previous, value) {
        return (0, $cvCbM.default)(previous) ? previous.then(function(resolved) {
            return callback(resolved, value);
        }) : callback(previous, value);
    }, initialValue);
}

});

parcelRegister("jvU6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $397d1cfe82a99329$export$2e2bcd8739ae039);
/**
 * This function transforms a JS object `ObjMap<Promise<T>>` into
 * a `Promise<ObjMap<T>>`
 *
 * This is akin to bluebird's `Promise.props`, but implemented only using
 * `Promise.all` so it will work with any implementation of ES6 promises.
 */ function $397d1cfe82a99329$export$2e2bcd8739ae039(object) {
    var keys = Object.keys(object);
    var valuesAndPromises = keys.map(function(name) {
        return object[name];
    });
    return Promise.all(valuesAndPromises).then(function(values) {
        return values.reduce(function(resolvedObject, value, i) {
            resolvedObject[keys[i]] = value;
            return resolvedObject;
        }, Object.create(null));
    });
}

});

parcelRegister("kZHaf", function(module, exports) {

$parcel$export(module.exports, "addPath", () => $d383cb52810c09e2$export$4c25481b843feb0b);
$parcel$export(module.exports, "pathToArray", () => $d383cb52810c09e2$export$38d939edd7751830);
/**
 * Given a Path and a key, return a new Path containing the new key.
 */ function $d383cb52810c09e2$export$4c25481b843feb0b(prev, key, typename) {
    return {
        prev: prev,
        key: key,
        typename: typename
    };
}
function $d383cb52810c09e2$export$38d939edd7751830(path) {
    var flattened = [];
    var curr = path;
    while(curr){
        flattened.push(curr.key);
        curr = curr.prev;
    }
    return flattened.reverse();
}

});

parcelRegister("02KAV", function(module, exports) {

$parcel$export(module.exports, "locatedError", () => $b788feeccd28d1f2$export$d6d5dddbbbfd3fca);

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");
function $b788feeccd28d1f2$export$d6d5dddbbbfd3fca(rawOriginalError, nodes, path) {
    var _nodes;
    // Sometimes a non-error is thrown, wrap it as an Error instance to ensure a consistent Error interface.
    var originalError = rawOriginalError instanceof Error ? rawOriginalError : new Error('Unexpected error value: ' + (0, $biK02.default)(rawOriginalError)); // Note: this uses a brand-check to support GraphQL errors originating from other contexts.
    if (Array.isArray(originalError.path)) return originalError;
    return new (0, $9fgMZ.GraphQLError)(originalError.message, (_nodes = originalError.nodes) !== null && _nodes !== void 0 ? _nodes : nodes, originalError.source, originalError.positions, path, originalError);
}

});

parcelRegister("izaFt", function(module, exports) {

$parcel$export(module.exports, "validateSchema", () => $52ea6309b40538c9$export$4741711f07dbb8e7);
$parcel$export(module.exports, "assertValidSchema", () => $52ea6309b40538c9$export$d32aa1886d3569c6);

var $bmIpK = parcelRequire("bmIpK");

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");

var $02KAV = parcelRequire("02KAV");

var $2atqN = parcelRequire("2atqN");

var $f5cpS = parcelRequire("f5cpS");

var $6BdRO = parcelRequire("6BdRO");

var $h2iUh = parcelRequire("h2iUh");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");
function $52ea6309b40538c9$export$4741711f07dbb8e7(schema) {
    // First check to ensure the provided value is in fact a GraphQLSchema.
    (0, $6BdRO.assertSchema)(schema); // If this Schema has already been validated, return the previous results.
    if (schema.__validationErrors) return schema.__validationErrors;
     // Validate the schema, producing a list of errors.
    var context = new $52ea6309b40538c9$var$SchemaValidationContext(schema);
    $52ea6309b40538c9$var$validateRootTypes(context);
    $52ea6309b40538c9$var$validateDirectives(context);
    $52ea6309b40538c9$var$validateTypes(context); // Persist the results of validation before returning to ensure validation
    // does not run multiple times for this schema.
    var errors = context.getErrors();
    schema.__validationErrors = errors;
    return errors;
}
function $52ea6309b40538c9$export$d32aa1886d3569c6(schema) {
    var errors = $52ea6309b40538c9$export$4741711f07dbb8e7(schema);
    if (errors.length !== 0) throw new Error(errors.map(function(error) {
        return error.message;
    }).join('\n\n'));
}
var $52ea6309b40538c9$var$SchemaValidationContext = /*#__PURE__*/ function() {
    function SchemaValidationContext(schema) {
        this._errors = [];
        this.schema = schema;
    }
    var _proto = SchemaValidationContext.prototype;
    _proto.reportError = function reportError(message, nodes) {
        var _nodes = Array.isArray(nodes) ? nodes.filter(Boolean) : nodes;
        this.addError(new (0, $9fgMZ.GraphQLError)(message, _nodes));
    };
    _proto.addError = function addError(error) {
        this._errors.push(error);
    };
    _proto.getErrors = function getErrors() {
        return this._errors;
    };
    return SchemaValidationContext;
}();
function $52ea6309b40538c9$var$validateRootTypes(context) {
    var schema = context.schema;
    var queryType = schema.getQueryType();
    if (!queryType) context.reportError('Query root type must be provided.', schema.astNode);
    else if (!(0, $lXoEQ.isObjectType)(queryType)) {
        var _getOperationTypeNode;
        context.reportError("Query root type must be Object type, it cannot be ".concat((0, $biK02.default)(queryType), "."), (_getOperationTypeNode = $52ea6309b40538c9$var$getOperationTypeNode(schema, 'query')) !== null && _getOperationTypeNode !== void 0 ? _getOperationTypeNode : queryType.astNode);
    }
    var mutationType = schema.getMutationType();
    if (mutationType && !(0, $lXoEQ.isObjectType)(mutationType)) {
        var _getOperationTypeNode2;
        context.reportError('Mutation root type must be Object type if provided, it cannot be ' + "".concat((0, $biK02.default)(mutationType), "."), (_getOperationTypeNode2 = $52ea6309b40538c9$var$getOperationTypeNode(schema, 'mutation')) !== null && _getOperationTypeNode2 !== void 0 ? _getOperationTypeNode2 : mutationType.astNode);
    }
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType && !(0, $lXoEQ.isObjectType)(subscriptionType)) {
        var _getOperationTypeNode3;
        context.reportError('Subscription root type must be Object type if provided, it cannot be ' + "".concat((0, $biK02.default)(subscriptionType), "."), (_getOperationTypeNode3 = $52ea6309b40538c9$var$getOperationTypeNode(schema, 'subscription')) !== null && _getOperationTypeNode3 !== void 0 ? _getOperationTypeNode3 : subscriptionType.astNode);
    }
}
function $52ea6309b40538c9$var$getOperationTypeNode(schema, operation) {
    var operationNodes = $52ea6309b40538c9$var$getAllSubNodes(schema, function(node) {
        return node.operationTypes;
    });
    for(var _i2 = 0; _i2 < operationNodes.length; _i2++){
        var node = operationNodes[_i2];
        if (node.operation === operation) return node.type;
    }
    return undefined;
}
function $52ea6309b40538c9$var$validateDirectives(context) {
    for(var _i4 = 0, _context$schema$getDi2 = context.schema.getDirectives(); _i4 < _context$schema$getDi2.length; _i4++){
        var directive = _context$schema$getDi2[_i4];
        // Ensure all directives are in fact GraphQL directives.
        if (!(0, $bOniD.isDirective)(directive)) {
            context.reportError("Expected directive but got: ".concat((0, $biK02.default)(directive), "."), directive === null || directive === void 0 ? void 0 : directive.astNode);
            continue;
        } // Ensure they are named correctly.
        $52ea6309b40538c9$var$validateName(context, directive); // TODO: Ensure proper locations.
        // Ensure the arguments are valid.
        for(var _i6 = 0, _directive$args2 = directive.args; _i6 < _directive$args2.length; _i6++){
            var arg = _directive$args2[_i6];
            // Ensure they are named correctly.
            $52ea6309b40538c9$var$validateName(context, arg); // Ensure the type is an input type.
            if (!(0, $lXoEQ.isInputType)(arg.type)) context.reportError("The type of @".concat(directive.name, "(").concat(arg.name, ":) must be Input Type ") + "but got: ".concat((0, $biK02.default)(arg.type), "."), arg.astNode);
            if ((0, $lXoEQ.isRequiredArgument)(arg) && arg.deprecationReason != null) {
                var _arg$astNode;
                context.reportError("Required argument @".concat(directive.name, "(").concat(arg.name, ":) cannot be deprecated."), [
                    $52ea6309b40538c9$var$getDeprecatedDirectiveNode(arg.astNode),
                    (_arg$astNode = arg.astNode) === null || _arg$astNode === void 0 ? void 0 : _arg$astNode.type
                ]);
            }
        }
    }
}
function $52ea6309b40538c9$var$validateName(context, node) {
    // Ensure names are valid, however introspection types opt out.
    var error = (0, $2atqN.isValidNameError)(node.name);
    if (error) context.addError((0, $02KAV.locatedError)(error, node.astNode));
}
function $52ea6309b40538c9$var$validateTypes(context) {
    var validateInputObjectCircularRefs = $52ea6309b40538c9$var$createInputObjectCircularRefsValidator(context);
    var typeMap = context.schema.getTypeMap();
    for(var _i8 = 0, _objectValues2 = (0, $dVq2R.default)(typeMap); _i8 < _objectValues2.length; _i8++){
        var type = _objectValues2[_i8];
        // Ensure all provided types are in fact GraphQL type.
        if (!(0, $lXoEQ.isNamedType)(type)) {
            context.reportError("Expected GraphQL named type but got: ".concat((0, $biK02.default)(type), "."), type.astNode);
            continue;
        } // Ensure it is named correctly (excluding introspection types).
        if (!(0, $h2iUh.isIntrospectionType)(type)) $52ea6309b40538c9$var$validateName(context, type);
        if ((0, $lXoEQ.isObjectType)(type)) {
            // Ensure fields are valid
            $52ea6309b40538c9$var$validateFields(context, type); // Ensure objects implement the interfaces they claim to.
            $52ea6309b40538c9$var$validateInterfaces(context, type);
        } else if ((0, $lXoEQ.isInterfaceType)(type)) {
            // Ensure fields are valid.
            $52ea6309b40538c9$var$validateFields(context, type); // Ensure interfaces implement the interfaces they claim to.
            $52ea6309b40538c9$var$validateInterfaces(context, type);
        } else if ((0, $lXoEQ.isUnionType)(type)) // Ensure Unions include valid member types.
        $52ea6309b40538c9$var$validateUnionMembers(context, type);
        else if ((0, $lXoEQ.isEnumType)(type)) // Ensure Enums have valid values.
        $52ea6309b40538c9$var$validateEnumValues(context, type);
        else if ((0, $lXoEQ.isInputObjectType)(type)) {
            // Ensure Input Object fields are valid.
            $52ea6309b40538c9$var$validateInputFields(context, type); // Ensure Input Objects do not contain non-nullable circular references
            validateInputObjectCircularRefs(type);
        }
    }
}
function $52ea6309b40538c9$var$validateFields(context, type) {
    var fields = (0, $dVq2R.default)(type.getFields()); // Objects and Interfaces both must define one or more fields.
    if (fields.length === 0) context.reportError("Type ".concat(type.name, " must define one or more fields."), $52ea6309b40538c9$var$getAllNodes(type));
    for(var _i10 = 0; _i10 < fields.length; _i10++){
        var field = fields[_i10];
        // Ensure they are named correctly.
        $52ea6309b40538c9$var$validateName(context, field); // Ensure the type is an output type
        if (!(0, $lXoEQ.isOutputType)(field.type)) {
            var _field$astNode;
            context.reportError("The type of ".concat(type.name, ".").concat(field.name, " must be Output Type ") + "but got: ".concat((0, $biK02.default)(field.type), "."), (_field$astNode = field.astNode) === null || _field$astNode === void 0 ? void 0 : _field$astNode.type);
        } // Ensure the arguments are valid
        for(var _i12 = 0, _field$args2 = field.args; _i12 < _field$args2.length; _i12++){
            var arg = _field$args2[_i12];
            var argName = arg.name; // Ensure they are named correctly.
            $52ea6309b40538c9$var$validateName(context, arg); // Ensure the type is an input type
            if (!(0, $lXoEQ.isInputType)(arg.type)) {
                var _arg$astNode2;
                context.reportError("The type of ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) must be Input ") + "Type but got: ".concat((0, $biK02.default)(arg.type), "."), (_arg$astNode2 = arg.astNode) === null || _arg$astNode2 === void 0 ? void 0 : _arg$astNode2.type);
            }
            if ((0, $lXoEQ.isRequiredArgument)(arg) && arg.deprecationReason != null) {
                var _arg$astNode3;
                context.reportError("Required argument ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) cannot be deprecated."), [
                    $52ea6309b40538c9$var$getDeprecatedDirectiveNode(arg.astNode),
                    (_arg$astNode3 = arg.astNode) === null || _arg$astNode3 === void 0 ? void 0 : _arg$astNode3.type
                ]);
            }
        }
    }
}
function $52ea6309b40538c9$var$validateInterfaces(context, type) {
    var ifaceTypeNames = Object.create(null);
    for(var _i14 = 0, _type$getInterfaces2 = type.getInterfaces(); _i14 < _type$getInterfaces2.length; _i14++){
        var iface = _type$getInterfaces2[_i14];
        if (!(0, $lXoEQ.isInterfaceType)(iface)) {
            context.reportError("Type ".concat((0, $biK02.default)(type), " must only implement Interface types, ") + "it cannot implement ".concat((0, $biK02.default)(iface), "."), $52ea6309b40538c9$var$getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        if (type === iface) {
            context.reportError("Type ".concat(type.name, " cannot implement itself because it would create a circular reference."), $52ea6309b40538c9$var$getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        if (ifaceTypeNames[iface.name]) {
            context.reportError("Type ".concat(type.name, " can only implement ").concat(iface.name, " once."), $52ea6309b40538c9$var$getAllImplementsInterfaceNodes(type, iface));
            continue;
        }
        ifaceTypeNames[iface.name] = true;
        $52ea6309b40538c9$var$validateTypeImplementsAncestors(context, type, iface);
        $52ea6309b40538c9$var$validateTypeImplementsInterface(context, type, iface);
    }
}
function $52ea6309b40538c9$var$validateTypeImplementsInterface(context, type, iface) {
    var typeFieldMap = type.getFields(); // Assert each interface field is implemented.
    for(var _i16 = 0, _objectValues4 = (0, $dVq2R.default)(iface.getFields()); _i16 < _objectValues4.length; _i16++){
        var ifaceField = _objectValues4[_i16];
        var fieldName = ifaceField.name;
        var typeField = typeFieldMap[fieldName]; // Assert interface field exists on type.
        if (!typeField) {
            context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expected but ").concat(type.name, " does not provide it."), [
                ifaceField.astNode
            ].concat($52ea6309b40538c9$var$getAllNodes(type)));
            continue;
        } // Assert interface field type is satisfied by type field type, by being
        // a valid subtype. (covariant)
        if (!(0, $f5cpS.isTypeSubTypeOf)(context.schema, typeField.type, ifaceField.type)) {
            var _ifaceField$astNode, _typeField$astNode;
            context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expects type ") + "".concat((0, $biK02.default)(ifaceField.type), " but ").concat(type.name, ".").concat(fieldName, " ") + "is type ".concat((0, $biK02.default)(typeField.type), "."), [
                (_ifaceField$astNode = ifaceField.astNode) === null || _ifaceField$astNode === void 0 ? void 0 : _ifaceField$astNode.type,
                (_typeField$astNode = typeField.astNode) === null || _typeField$astNode === void 0 ? void 0 : _typeField$astNode.type
            ]);
        } // Assert each interface field arg is implemented.
        var _loop = function _loop(_i18, _ifaceField$args2) {
            var ifaceArg = _ifaceField$args2[_i18];
            var argName = ifaceArg.name;
            var typeArg = (0, $bmIpK.default)(typeField.args, function(arg) {
                return arg.name === argName;
            }); // Assert interface field arg exists on object field.
            if (!typeArg) {
                context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) expected but ").concat(type.name, ".").concat(fieldName, " does not provide it."), [
                    ifaceArg.astNode,
                    typeField.astNode
                ]);
                return "continue";
            } // Assert interface field arg type matches object field arg type.
            // (invariant)
            // TODO: change to contravariant?
            if (!(0, $f5cpS.isEqualType)(ifaceArg.type, typeArg.type)) {
                var _ifaceArg$astNode, _typeArg$astNode;
                context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) ") + "expects type ".concat((0, $biK02.default)(ifaceArg.type), " but ") + "".concat(type.name, ".").concat(fieldName, "(").concat(argName, ":) is type ") + "".concat((0, $biK02.default)(typeArg.type), "."), [
                    (_ifaceArg$astNode = ifaceArg.astNode) === null || _ifaceArg$astNode === void 0 ? void 0 : _ifaceArg$astNode.type,
                    (_typeArg$astNode = typeArg.astNode) === null || _typeArg$astNode === void 0 ? void 0 : _typeArg$astNode.type
                ]);
            } // TODO: validate default values?
        };
        for(var _i18 = 0, _ifaceField$args2 = ifaceField.args; _i18 < _ifaceField$args2.length; _i18++){
            var _ret = _loop(_i18, _ifaceField$args2);
            if (_ret === "continue") continue;
        } // Assert additional arguments must not be required.
        var _loop2 = function _loop2(_i20, _typeField$args2) {
            var typeArg = _typeField$args2[_i20];
            var argName = typeArg.name;
            var ifaceArg = (0, $bmIpK.default)(ifaceField.args, function(arg) {
                return arg.name === argName;
            });
            if (!ifaceArg && (0, $lXoEQ.isRequiredArgument)(typeArg)) context.reportError("Object field ".concat(type.name, ".").concat(fieldName, " includes required argument ").concat(argName, " that is missing from the Interface field ").concat(iface.name, ".").concat(fieldName, "."), [
                typeArg.astNode,
                ifaceField.astNode
            ]);
        };
        for(var _i20 = 0, _typeField$args2 = typeField.args; _i20 < _typeField$args2.length; _i20++)_loop2(_i20, _typeField$args2);
    }
}
function $52ea6309b40538c9$var$validateTypeImplementsAncestors(context, type, iface) {
    var ifaceInterfaces = type.getInterfaces();
    for(var _i22 = 0, _iface$getInterfaces2 = iface.getInterfaces(); _i22 < _iface$getInterfaces2.length; _i22++){
        var transitive = _iface$getInterfaces2[_i22];
        if (ifaceInterfaces.indexOf(transitive) === -1) context.reportError(transitive === type ? "Type ".concat(type.name, " cannot implement ").concat(iface.name, " because it would create a circular reference.") : "Type ".concat(type.name, " must implement ").concat(transitive.name, " because it is implemented by ").concat(iface.name, "."), [].concat($52ea6309b40538c9$var$getAllImplementsInterfaceNodes(iface, transitive), $52ea6309b40538c9$var$getAllImplementsInterfaceNodes(type, iface)));
    }
}
function $52ea6309b40538c9$var$validateUnionMembers(context, union) {
    var memberTypes = union.getTypes();
    if (memberTypes.length === 0) context.reportError("Union type ".concat(union.name, " must define one or more member types."), $52ea6309b40538c9$var$getAllNodes(union));
    var includedTypeNames = Object.create(null);
    for(var _i24 = 0; _i24 < memberTypes.length; _i24++){
        var memberType = memberTypes[_i24];
        if (includedTypeNames[memberType.name]) {
            context.reportError("Union type ".concat(union.name, " can only include type ").concat(memberType.name, " once."), $52ea6309b40538c9$var$getUnionMemberTypeNodes(union, memberType.name));
            continue;
        }
        includedTypeNames[memberType.name] = true;
        if (!(0, $lXoEQ.isObjectType)(memberType)) context.reportError("Union type ".concat(union.name, " can only include Object types, ") + "it cannot include ".concat((0, $biK02.default)(memberType), "."), $52ea6309b40538c9$var$getUnionMemberTypeNodes(union, String(memberType)));
    }
}
function $52ea6309b40538c9$var$validateEnumValues(context, enumType) {
    var enumValues = enumType.getValues();
    if (enumValues.length === 0) context.reportError("Enum type ".concat(enumType.name, " must define one or more values."), $52ea6309b40538c9$var$getAllNodes(enumType));
    for(var _i26 = 0; _i26 < enumValues.length; _i26++){
        var enumValue = enumValues[_i26];
        var valueName = enumValue.name; // Ensure valid name.
        $52ea6309b40538c9$var$validateName(context, enumValue);
        if (valueName === 'true' || valueName === 'false' || valueName === 'null') context.reportError("Enum type ".concat(enumType.name, " cannot include value: ").concat(valueName, "."), enumValue.astNode);
    }
}
function $52ea6309b40538c9$var$validateInputFields(context, inputObj) {
    var fields = (0, $dVq2R.default)(inputObj.getFields());
    if (fields.length === 0) context.reportError("Input Object type ".concat(inputObj.name, " must define one or more fields."), $52ea6309b40538c9$var$getAllNodes(inputObj));
     // Ensure the arguments are valid
    for(var _i28 = 0; _i28 < fields.length; _i28++){
        var field = fields[_i28];
        // Ensure they are named correctly.
        $52ea6309b40538c9$var$validateName(context, field); // Ensure the type is an input type
        if (!(0, $lXoEQ.isInputType)(field.type)) {
            var _field$astNode2;
            context.reportError("The type of ".concat(inputObj.name, ".").concat(field.name, " must be Input Type ") + "but got: ".concat((0, $biK02.default)(field.type), "."), (_field$astNode2 = field.astNode) === null || _field$astNode2 === void 0 ? void 0 : _field$astNode2.type);
        }
        if ((0, $lXoEQ.isRequiredInputField)(field) && field.deprecationReason != null) {
            var _field$astNode3;
            context.reportError("Required input field ".concat(inputObj.name, ".").concat(field.name, " cannot be deprecated."), [
                $52ea6309b40538c9$var$getDeprecatedDirectiveNode(field.astNode),
                (_field$astNode3 = field.astNode) === null || _field$astNode3 === void 0 ? void 0 : _field$astNode3.type
            ]);
        }
    }
}
function $52ea6309b40538c9$var$createInputObjectCircularRefsValidator(context) {
    // Modified copy of algorithm from 'src/validation/rules/NoFragmentCycles.js'.
    // Tracks already visited types to maintain O(N) and to ensure that cycles
    // are not redundantly reported.
    var visitedTypes = Object.create(null); // Array of types nodes used to produce meaningful errors
    var fieldPath = []; // Position in the type path
    var fieldPathIndexByTypeName = Object.create(null);
    return detectCycleRecursive; // This does a straight-forward DFS to find cycles.
    // It does not terminate when a cycle was found but continues to explore
    // the graph to find all possible cycles.
    function detectCycleRecursive(inputObj) {
        if (visitedTypes[inputObj.name]) return;
        visitedTypes[inputObj.name] = true;
        fieldPathIndexByTypeName[inputObj.name] = fieldPath.length;
        var fields = (0, $dVq2R.default)(inputObj.getFields());
        for(var _i30 = 0; _i30 < fields.length; _i30++){
            var field = fields[_i30];
            if ((0, $lXoEQ.isNonNullType)(field.type) && (0, $lXoEQ.isInputObjectType)(field.type.ofType)) {
                var fieldType = field.type.ofType;
                var cycleIndex = fieldPathIndexByTypeName[fieldType.name];
                fieldPath.push(field);
                if (cycleIndex === undefined) detectCycleRecursive(fieldType);
                else {
                    var cyclePath = fieldPath.slice(cycleIndex);
                    var pathStr = cyclePath.map(function(fieldObj) {
                        return fieldObj.name;
                    }).join('.');
                    context.reportError("Cannot reference Input Object \"".concat(fieldType.name, "\" within itself through a series of non-null fields: \"").concat(pathStr, "\"."), cyclePath.map(function(fieldObj) {
                        return fieldObj.astNode;
                    }));
                }
                fieldPath.pop();
            }
        }
        fieldPathIndexByTypeName[inputObj.name] = undefined;
    }
}
function $52ea6309b40538c9$var$getAllNodes(object) {
    var astNode = object.astNode, extensionASTNodes = object.extensionASTNodes;
    return astNode ? extensionASTNodes ? [
        astNode
    ].concat(extensionASTNodes) : [
        astNode
    ] : extensionASTNodes !== null && extensionASTNodes !== void 0 ? extensionASTNodes : [];
}
function $52ea6309b40538c9$var$getAllSubNodes(object, getter) {
    var subNodes = [];
    for(var _i32 = 0, _getAllNodes2 = $52ea6309b40538c9$var$getAllNodes(object); _i32 < _getAllNodes2.length; _i32++){
        var _getter;
        var node = _getAllNodes2[_i32];
        // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        subNodes = subNodes.concat((_getter = getter(node)) !== null && _getter !== void 0 ? _getter : []);
    }
    return subNodes;
}
function $52ea6309b40538c9$var$getAllImplementsInterfaceNodes(type, iface) {
    return $52ea6309b40538c9$var$getAllSubNodes(type, function(typeNode) {
        return typeNode.interfaces;
    }).filter(function(ifaceNode) {
        return ifaceNode.name.value === iface.name;
    });
}
function $52ea6309b40538c9$var$getUnionMemberTypeNodes(union, typeName) {
    return $52ea6309b40538c9$var$getAllSubNodes(union, function(unionNode) {
        return unionNode.types;
    }).filter(function(typeNode) {
        return typeNode.name.value === typeName;
    });
}
function $52ea6309b40538c9$var$getDeprecatedDirectiveNode(definitionNode) {
    var _definitionNode$direc;
    // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    return definitionNode === null || definitionNode === void 0 ? void 0 : (_definitionNode$direc = definitionNode.directives) === null || _definitionNode$direc === void 0 ? void 0 : _definitionNode$direc.find(function(node) {
        return node.name.value === (0, $bOniD.GraphQLDeprecatedDirective).name;
    });
}

});
parcelRegister("bmIpK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf979c8600d7bc76$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound]
var $bf979c8600d7bc76$var$find = Array.prototype.find ? function(list, predicate) {
    return Array.prototype.find.call(list, predicate);
} : function(list, predicate) {
    for(var _i2 = 0; _i2 < list.length; _i2++){
        var value = list[_i2];
        if (predicate(value)) return value;
    }
};
var $bf979c8600d7bc76$export$2e2bcd8739ae039 = $bf979c8600d7bc76$var$find;

});

parcelRegister("dVq2R", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba73c2159267889$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var $1ba73c2159267889$var$objectValues = Object.values || function(obj) {
    return Object.keys(obj).map(function(key) {
        return obj[key];
    });
};
var $1ba73c2159267889$export$2e2bcd8739ae039 = $1ba73c2159267889$var$objectValues;

});

parcelRegister("2atqN", function(module, exports) {

$parcel$export(module.exports, "isValidNameError", () => $b83fd21d28648a79$export$4ecdb5b419400d23);

var $fZdRY = parcelRequire("fZdRY");

var $9fgMZ = parcelRequire("9fgMZ");
var $b83fd21d28648a79$var$NAME_RX = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
function $b83fd21d28648a79$export$38c12a9ffd7a1417(name) {
    var error = $b83fd21d28648a79$export$4ecdb5b419400d23(name);
    if (error) throw error;
    return name;
}
function $b83fd21d28648a79$export$4ecdb5b419400d23(name) {
    typeof name === 'string' || (0, $fZdRY.default)(0, 'Expected name to be a string.');
    if (name.length > 1 && name[0] === '_' && name[1] === '_') return new (0, $9fgMZ.GraphQLError)("Name \"".concat(name, "\" must not begin with \"__\", which is reserved by GraphQL introspection."));
    if (!$b83fd21d28648a79$var$NAME_RX.test(name)) return new (0, $9fgMZ.GraphQLError)("Names must match /^[_a-zA-Z][_a-zA-Z0-9]*$/ but \"".concat(name, "\" does not."));
}

});

parcelRegister("f5cpS", function(module, exports) {

$parcel$export(module.exports, "isEqualType", () => $34731a9f0a0c30ed$export$c8e484a9929e6d9f);
$parcel$export(module.exports, "isTypeSubTypeOf", () => $34731a9f0a0c30ed$export$c3f31adb68f3e853);
$parcel$export(module.exports, "doTypesOverlap", () => $34731a9f0a0c30ed$export$5e7a8ea86de754bd);

var $lXoEQ = parcelRequire("lXoEQ");
function $34731a9f0a0c30ed$export$c8e484a9929e6d9f(typeA, typeB) {
    // Equivalent types are equal.
    if (typeA === typeB) return true;
     // If either type is non-null, the other must also be non-null.
    if ((0, $lXoEQ.isNonNullType)(typeA) && (0, $lXoEQ.isNonNullType)(typeB)) return $34731a9f0a0c30ed$export$c8e484a9929e6d9f(typeA.ofType, typeB.ofType);
     // If either type is a list, the other must also be a list.
    if ((0, $lXoEQ.isListType)(typeA) && (0, $lXoEQ.isListType)(typeB)) return $34731a9f0a0c30ed$export$c8e484a9929e6d9f(typeA.ofType, typeB.ofType);
     // Otherwise the types are not equal.
    return false;
}
function $34731a9f0a0c30ed$export$c3f31adb68f3e853(schema, maybeSubType, superType) {
    // Equivalent type is a valid subtype
    if (maybeSubType === superType) return true;
     // If superType is non-null, maybeSubType must also be non-null.
    if ((0, $lXoEQ.isNonNullType)(superType)) {
        if ((0, $lXoEQ.isNonNullType)(maybeSubType)) return $34731a9f0a0c30ed$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType.ofType);
        return false;
    }
    if ((0, $lXoEQ.isNonNullType)(maybeSubType)) // If superType is nullable, maybeSubType may be non-null or nullable.
    return $34731a9f0a0c30ed$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType);
     // If superType type is a list, maybeSubType type must also be a list.
    if ((0, $lXoEQ.isListType)(superType)) {
        if ((0, $lXoEQ.isListType)(maybeSubType)) return $34731a9f0a0c30ed$export$c3f31adb68f3e853(schema, maybeSubType.ofType, superType.ofType);
        return false;
    }
    if ((0, $lXoEQ.isListType)(maybeSubType)) // If superType is not a list, maybeSubType must also be not a list.
    return false;
     // If superType type is an abstract type, check if it is super type of maybeSubType.
    // Otherwise, the child type is not a valid subtype of the parent type.
    return (0, $lXoEQ.isAbstractType)(superType) && ((0, $lXoEQ.isInterfaceType)(maybeSubType) || (0, $lXoEQ.isObjectType)(maybeSubType)) && schema.isSubType(superType, maybeSubType);
}
function $34731a9f0a0c30ed$export$5e7a8ea86de754bd(schema, typeA, typeB) {
    // Equivalent types overlap
    if (typeA === typeB) return true;
    if ((0, $lXoEQ.isAbstractType)(typeA)) {
        if ((0, $lXoEQ.isAbstractType)(typeB)) // If both types are abstract, then determine if there is any intersection
        // between possible concrete types of each.
        return schema.getPossibleTypes(typeA).some(function(type) {
            return schema.isSubType(typeB, type);
        });
         // Determine if the latter type is a possible concrete type of the former.
        return schema.isSubType(typeA, typeB);
    }
    if ((0, $lXoEQ.isAbstractType)(typeB)) // Determine if the former type is a possible concrete type of the latter.
    return schema.isSubType(typeB, typeA);
     // Otherwise the types do not overlap.
    return false;
}

});
parcelRegister("lXoEQ", function(module, exports) {

$parcel$export(module.exports, "isType", () => $4cde51e3b6dfd290$export$26b9f946b448f23e);
$parcel$export(module.exports, "isScalarType", () => $4cde51e3b6dfd290$export$5ef3b9aefb31c08b);
$parcel$export(module.exports, "isObjectType", () => $4cde51e3b6dfd290$export$f3091ca7b0907a5f);
$parcel$export(module.exports, "isInterfaceType", () => $4cde51e3b6dfd290$export$32fba5696fa641e);
$parcel$export(module.exports, "isUnionType", () => $4cde51e3b6dfd290$export$cca4caab5ef5a545);
$parcel$export(module.exports, "isEnumType", () => $4cde51e3b6dfd290$export$360fc30cf304623);
$parcel$export(module.exports, "isInputObjectType", () => $4cde51e3b6dfd290$export$594edc80cf154b94);
$parcel$export(module.exports, "isListType", () => $4cde51e3b6dfd290$export$f1003c1e9d4b008c);
$parcel$export(module.exports, "isNonNullType", () => $4cde51e3b6dfd290$export$146b6508fa0d6c82);
$parcel$export(module.exports, "GraphQLScalarType", () => $4cde51e3b6dfd290$export$64842b98ea53a3c9);
$parcel$export(module.exports, "GraphQLObjectType", () => $4cde51e3b6dfd290$export$375d3757a19c2e6e);
$parcel$export(module.exports, "assertObjectType", () => $4cde51e3b6dfd290$export$37a13eb12fbf3bc7);
$parcel$export(module.exports, "GraphQLInterfaceType", () => $4cde51e3b6dfd290$export$148e92587b8bf1f9);
$parcel$export(module.exports, "assertInterfaceType", () => $4cde51e3b6dfd290$export$b0fa8729bfe4811b);
$parcel$export(module.exports, "GraphQLUnionType", () => $4cde51e3b6dfd290$export$33c479b4c3812d0b);
$parcel$export(module.exports, "GraphQLEnumType", () => $4cde51e3b6dfd290$export$2577fb93f8748953);
$parcel$export(module.exports, "GraphQLInputObjectType", () => $4cde51e3b6dfd290$export$ea29baa44b9fd772);
$parcel$export(module.exports, "GraphQLList", () => $4cde51e3b6dfd290$export$de552006a6243367);
$parcel$export(module.exports, "GraphQLNonNull", () => $4cde51e3b6dfd290$export$ea3122a3d819ac9d);
$parcel$export(module.exports, "isInputType", () => $4cde51e3b6dfd290$export$1e617af703572bb5);
$parcel$export(module.exports, "isOutputType", () => $4cde51e3b6dfd290$export$27aadee607de5794);
$parcel$export(module.exports, "isLeafType", () => $4cde51e3b6dfd290$export$b390adabc64bab3);
$parcel$export(module.exports, "isCompositeType", () => $4cde51e3b6dfd290$export$3d8f0e61f2e75bb0);
$parcel$export(module.exports, "isAbstractType", () => $4cde51e3b6dfd290$export$6ea44a810dec4ac5);
$parcel$export(module.exports, "assertNullableType", () => $4cde51e3b6dfd290$export$9c6e9b78e1767de4);
$parcel$export(module.exports, "getNullableType", () => $4cde51e3b6dfd290$export$88b885687e78334b);
$parcel$export(module.exports, "isNamedType", () => $4cde51e3b6dfd290$export$f99194494d5b1a26);
$parcel$export(module.exports, "getNamedType", () => $4cde51e3b6dfd290$export$e6cd8ba67f39ede0);
$parcel$export(module.exports, "argsToArgsConfig", () => $4cde51e3b6dfd290$export$ae5ade30c645f6fd);
$parcel$export(module.exports, "isRequiredArgument", () => $4cde51e3b6dfd290$export$caef08b21560291a);
$parcel$export(module.exports, "isRequiredInputField", () => $4cde51e3b6dfd290$export$2657dcc79c2b6229);

var $apet0 = parcelRequire("apet0");

var $gwa3m = parcelRequire("gwa3m");

var $biK02 = parcelRequire("biK02");

var $hbiEd = parcelRequire("hbiEd");

var $6MWHL = parcelRequire("6MWHL");

var $eCJ4z = parcelRequire("eCJ4z");

var $fZdRY = parcelRequire("fZdRY");

var $2AFgT = parcelRequire("2AFgT");

var $aVhwC = parcelRequire("aVhwC");

var $8nBnZ = parcelRequire("8nBnZ");

var $fbtyx = parcelRequire("fbtyx");

var $7J7By = parcelRequire("7J7By");

var $51GHS = parcelRequire("51GHS");

var $bru1k = parcelRequire("bru1k");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $aKlnM = parcelRequire("aKlnM");

var $iTQJQ = parcelRequire("iTQJQ");
function $4cde51e3b6dfd290$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4cde51e3b6dfd290$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4cde51e3b6dfd290$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4cde51e3b6dfd290$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $4cde51e3b6dfd290$export$26b9f946b448f23e(type) {
    return $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) || $4cde51e3b6dfd290$export$f3091ca7b0907a5f(type) || $4cde51e3b6dfd290$export$32fba5696fa641e(type) || $4cde51e3b6dfd290$export$cca4caab5ef5a545(type) || $4cde51e3b6dfd290$export$360fc30cf304623(type) || $4cde51e3b6dfd290$export$594edc80cf154b94(type) || $4cde51e3b6dfd290$export$f1003c1e9d4b008c(type) || $4cde51e3b6dfd290$export$146b6508fa0d6c82(type);
}
function $4cde51e3b6dfd290$export$804de46662e4ac95(type) {
    if (!$4cde51e3b6dfd290$export$26b9f946b448f23e(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL type."));
    return type;
}
function $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$64842b98ea53a3c9);
}
function $4cde51e3b6dfd290$export$6bfb69547e804cfa(type) {
    if (!$4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Scalar type."));
    return type;
}
function $4cde51e3b6dfd290$export$f3091ca7b0907a5f(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$375d3757a19c2e6e);
}
function $4cde51e3b6dfd290$export$37a13eb12fbf3bc7(type) {
    if (!$4cde51e3b6dfd290$export$f3091ca7b0907a5f(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Object type."));
    return type;
}
function $4cde51e3b6dfd290$export$32fba5696fa641e(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$148e92587b8bf1f9);
}
function $4cde51e3b6dfd290$export$b0fa8729bfe4811b(type) {
    if (!$4cde51e3b6dfd290$export$32fba5696fa641e(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Interface type."));
    return type;
}
function $4cde51e3b6dfd290$export$cca4caab5ef5a545(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$33c479b4c3812d0b);
}
function $4cde51e3b6dfd290$export$fd1fc643145b79aa(type) {
    if (!$4cde51e3b6dfd290$export$cca4caab5ef5a545(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Union type."));
    return type;
}
function $4cde51e3b6dfd290$export$360fc30cf304623(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$2577fb93f8748953);
}
function $4cde51e3b6dfd290$export$152b058be1610b0e(type) {
    if (!$4cde51e3b6dfd290$export$360fc30cf304623(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Enum type."));
    return type;
}
function $4cde51e3b6dfd290$export$594edc80cf154b94(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$ea29baa44b9fd772);
}
function $4cde51e3b6dfd290$export$d3177a47c4ed448a(type) {
    if (!$4cde51e3b6dfd290$export$594edc80cf154b94(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Input Object type."));
    return type;
}
function $4cde51e3b6dfd290$export$f1003c1e9d4b008c(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$de552006a6243367);
}
function $4cde51e3b6dfd290$export$a4a2309317558e91(type) {
    if (!$4cde51e3b6dfd290$export$f1003c1e9d4b008c(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL List type."));
    return type;
}
function $4cde51e3b6dfd290$export$146b6508fa0d6c82(type) {
    return (0, $aVhwC.default)(type, $4cde51e3b6dfd290$export$ea3122a3d819ac9d);
}
function $4cde51e3b6dfd290$export$4c0a7702e4a2acc9(type) {
    if (!$4cde51e3b6dfd290$export$146b6508fa0d6c82(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL Non-Null type."));
    return type;
}
function $4cde51e3b6dfd290$export$1e617af703572bb5(type) {
    return $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) || $4cde51e3b6dfd290$export$360fc30cf304623(type) || $4cde51e3b6dfd290$export$594edc80cf154b94(type) || $4cde51e3b6dfd290$export$2dbe78c78d9c62bb(type) && $4cde51e3b6dfd290$export$1e617af703572bb5(type.ofType);
}
function $4cde51e3b6dfd290$export$6e3e8b9b85427518(type) {
    if (!$4cde51e3b6dfd290$export$1e617af703572bb5(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL input type."));
    return type;
}
function $4cde51e3b6dfd290$export$27aadee607de5794(type) {
    return $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) || $4cde51e3b6dfd290$export$f3091ca7b0907a5f(type) || $4cde51e3b6dfd290$export$32fba5696fa641e(type) || $4cde51e3b6dfd290$export$cca4caab5ef5a545(type) || $4cde51e3b6dfd290$export$360fc30cf304623(type) || $4cde51e3b6dfd290$export$2dbe78c78d9c62bb(type) && $4cde51e3b6dfd290$export$27aadee607de5794(type.ofType);
}
function $4cde51e3b6dfd290$export$3efb5e473c31d62b(type) {
    if (!$4cde51e3b6dfd290$export$27aadee607de5794(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL output type."));
    return type;
}
function $4cde51e3b6dfd290$export$b390adabc64bab3(type) {
    return $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) || $4cde51e3b6dfd290$export$360fc30cf304623(type);
}
function $4cde51e3b6dfd290$export$2bb5b8127c27d0cc(type) {
    if (!$4cde51e3b6dfd290$export$b390adabc64bab3(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL leaf type."));
    return type;
}
function $4cde51e3b6dfd290$export$3d8f0e61f2e75bb0(type) {
    return $4cde51e3b6dfd290$export$f3091ca7b0907a5f(type) || $4cde51e3b6dfd290$export$32fba5696fa641e(type) || $4cde51e3b6dfd290$export$cca4caab5ef5a545(type);
}
function $4cde51e3b6dfd290$export$5b55b276a74cf725(type) {
    if (!$4cde51e3b6dfd290$export$3d8f0e61f2e75bb0(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL composite type."));
    return type;
}
function $4cde51e3b6dfd290$export$6ea44a810dec4ac5(type) {
    return $4cde51e3b6dfd290$export$32fba5696fa641e(type) || $4cde51e3b6dfd290$export$cca4caab5ef5a545(type);
}
function $4cde51e3b6dfd290$export$d7092fd91c1fbaf8(type) {
    if (!$4cde51e3b6dfd290$export$6ea44a810dec4ac5(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL abstract type."));
    return type;
}
function $4cde51e3b6dfd290$export$de552006a6243367(ofType) {
    // istanbul ignore else (to be removed in v16.0.0)
    if (this instanceof $4cde51e3b6dfd290$export$de552006a6243367) this.ofType = $4cde51e3b6dfd290$export$804de46662e4ac95(ofType);
    else return new $4cde51e3b6dfd290$export$de552006a6243367(ofType);
} // Need to cast through any to alter the prototype.
$4cde51e3b6dfd290$export$de552006a6243367.prototype.toString = function toString() {
    return '[' + String(this.ofType) + ']';
};
$4cde51e3b6dfd290$export$de552006a6243367.prototype.toJSON = function toJSON() {
    return this.toString();
};
Object.defineProperty($4cde51e3b6dfd290$export$de552006a6243367.prototype, (0, $gwa3m.SYMBOL_TO_STRING_TAG), {
    get: function get() {
        return 'GraphQLList';
    }
}); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$de552006a6243367);
function $4cde51e3b6dfd290$export$ea3122a3d819ac9d(ofType) {
    // istanbul ignore else (to be removed in v16.0.0)
    if (this instanceof $4cde51e3b6dfd290$export$ea3122a3d819ac9d) this.ofType = $4cde51e3b6dfd290$export$9c6e9b78e1767de4(ofType);
    else return new $4cde51e3b6dfd290$export$ea3122a3d819ac9d(ofType);
} // Need to cast through any to alter the prototype.
$4cde51e3b6dfd290$export$ea3122a3d819ac9d.prototype.toString = function toString() {
    return String(this.ofType) + '!';
};
$4cde51e3b6dfd290$export$ea3122a3d819ac9d.prototype.toJSON = function toJSON() {
    return this.toString();
};
Object.defineProperty($4cde51e3b6dfd290$export$ea3122a3d819ac9d.prototype, (0, $gwa3m.SYMBOL_TO_STRING_TAG), {
    get: function get() {
        return 'GraphQLNonNull';
    }
}); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$ea3122a3d819ac9d);
function $4cde51e3b6dfd290$export$2dbe78c78d9c62bb(type) {
    return $4cde51e3b6dfd290$export$f1003c1e9d4b008c(type) || $4cde51e3b6dfd290$export$146b6508fa0d6c82(type);
}
function $4cde51e3b6dfd290$export$ee52e012d8d583c6(type) {
    if (!$4cde51e3b6dfd290$export$2dbe78c78d9c62bb(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL wrapping type."));
    return type;
}
function $4cde51e3b6dfd290$export$103e38848746832(type) {
    return $4cde51e3b6dfd290$export$26b9f946b448f23e(type) && !$4cde51e3b6dfd290$export$146b6508fa0d6c82(type);
}
function $4cde51e3b6dfd290$export$9c6e9b78e1767de4(type) {
    if (!$4cde51e3b6dfd290$export$103e38848746832(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL nullable type."));
    return type;
}
function $4cde51e3b6dfd290$export$88b885687e78334b(type) {
    /* eslint-enable no-redeclare */ if (type) return $4cde51e3b6dfd290$export$146b6508fa0d6c82(type) ? type.ofType : type;
}
function $4cde51e3b6dfd290$export$f99194494d5b1a26(type) {
    return $4cde51e3b6dfd290$export$5ef3b9aefb31c08b(type) || $4cde51e3b6dfd290$export$f3091ca7b0907a5f(type) || $4cde51e3b6dfd290$export$32fba5696fa641e(type) || $4cde51e3b6dfd290$export$cca4caab5ef5a545(type) || $4cde51e3b6dfd290$export$360fc30cf304623(type) || $4cde51e3b6dfd290$export$594edc80cf154b94(type);
}
function $4cde51e3b6dfd290$export$57234e7b640498aa(type) {
    if (!$4cde51e3b6dfd290$export$f99194494d5b1a26(type)) throw new Error("Expected ".concat((0, $biK02.default)(type), " to be a GraphQL named type."));
    return type;
}
function $4cde51e3b6dfd290$export$e6cd8ba67f39ede0(type) {
    /* eslint-enable no-redeclare */ if (type) {
        var unwrappedType = type;
        while($4cde51e3b6dfd290$export$2dbe78c78d9c62bb(unwrappedType))unwrappedType = unwrappedType.ofType;
        return unwrappedType;
    }
}
/**
 * Used while defining GraphQL types to allow for circular references in
 * otherwise immutable type definitions.
 */ function $4cde51e3b6dfd290$var$resolveThunk(thunk) {
    // $FlowFixMe[incompatible-use]
    return typeof thunk === 'function' ? thunk() : thunk;
}
function $4cde51e3b6dfd290$var$undefineIfEmpty(arr) {
    return arr && arr.length > 0 ? arr : undefined;
}
var $4cde51e3b6dfd290$export$64842b98ea53a3c9 = /*#__PURE__*/ function() {
    function GraphQLScalarType(config) {
        var _config$parseValue, _config$serialize, _config$parseLiteral;
        var parseValue = (_config$parseValue = config.parseValue) !== null && _config$parseValue !== void 0 ? _config$parseValue : (0, $7J7By.default);
        this.name = config.name;
        this.description = config.description;
        this.specifiedByUrl = config.specifiedByUrl;
        this.serialize = (_config$serialize = config.serialize) !== null && _config$serialize !== void 0 ? _config$serialize : (0, $7J7By.default);
        this.parseValue = parseValue;
        this.parseLiteral = (_config$parseLiteral = config.parseLiteral) !== null && _config$parseLiteral !== void 0 ? _config$parseLiteral : function(node, variables) {
            return parseValue((0, $iTQJQ.valueFromASTUntyped)(node, variables));
        };
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
        config.specifiedByUrl == null || typeof config.specifiedByUrl === 'string' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide \"specifiedByUrl\" as a string, ") + "but got: ".concat((0, $biK02.default)(config.specifiedByUrl), "."));
        config.serialize == null || typeof config.serialize === 'function' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide \"serialize\" function. If this custom Scalar is also used as an input type, ensure \"parseValue\" and \"parseLiteral\" functions are also provided."));
        if (config.parseLiteral) typeof config.parseValue === 'function' && typeof config.parseLiteral === 'function' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide both \"parseValue\" and \"parseLiteral\" functions."));
    }
    var _proto = GraphQLScalarType.prototype;
    _proto.toConfig = function toConfig() {
        var _this$extensionASTNod;
        return {
            name: this.name,
            description: this.description,
            specifiedByUrl: this.specifiedByUrl,
            serialize: this.serialize,
            parseValue: this.parseValue,
            parseLiteral: this.parseLiteral,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod = this.extensionASTNodes) !== null && _this$extensionASTNod !== void 0 ? _this$extensionASTNod : []
        };
    };
    _proto.toString = function toString() {
        return this.name;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLScalarType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLScalarType';
            }
        }
    ]);
    return GraphQLScalarType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$64842b98ea53a3c9);
var $4cde51e3b6dfd290$export$375d3757a19c2e6e = /*#__PURE__*/ function() {
    function GraphQLObjectType(config) {
        this.name = config.name;
        this.description = config.description;
        this.isTypeOf = config.isTypeOf;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        this._fields = $4cde51e3b6dfd290$var$defineFieldMap.bind(undefined, config);
        this._interfaces = $4cde51e3b6dfd290$var$defineInterfaces.bind(undefined, config);
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
        config.isTypeOf == null || typeof config.isTypeOf === 'function' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide \"isTypeOf\" as a function, ") + "but got: ".concat((0, $biK02.default)(config.isTypeOf), "."));
    }
    var _proto2 = GraphQLObjectType.prototype;
    _proto2.getFields = function getFields() {
        if (typeof this._fields === 'function') this._fields = this._fields();
        return this._fields;
    };
    _proto2.getInterfaces = function getInterfaces() {
        if (typeof this._interfaces === 'function') this._interfaces = this._interfaces();
        return this._interfaces;
    };
    _proto2.toConfig = function toConfig() {
        return {
            name: this.name,
            description: this.description,
            interfaces: this.getInterfaces(),
            fields: $4cde51e3b6dfd290$var$fieldsToFieldsConfig(this.getFields()),
            isTypeOf: this.isTypeOf,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: this.extensionASTNodes || []
        };
    };
    _proto2.toString = function toString() {
        return this.name;
    };
    _proto2.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLObjectType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLObjectType';
            }
        }
    ]);
    return GraphQLObjectType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$375d3757a19c2e6e);
function $4cde51e3b6dfd290$var$defineInterfaces(config) {
    var _resolveThunk;
    var interfaces = (_resolveThunk = $4cde51e3b6dfd290$var$resolveThunk(config.interfaces)) !== null && _resolveThunk !== void 0 ? _resolveThunk : [];
    Array.isArray(interfaces) || (0, $fZdRY.default)(0, "".concat(config.name, " interfaces must be an Array or a function which returns an Array."));
    return interfaces;
}
function $4cde51e3b6dfd290$var$defineFieldMap(config) {
    var fieldMap = $4cde51e3b6dfd290$var$resolveThunk(config.fields);
    $4cde51e3b6dfd290$var$isPlainObj(fieldMap) || (0, $fZdRY.default)(0, "".concat(config.name, " fields must be an object with field names as keys or a function which returns such an object."));
    return (0, $6MWHL.default)(fieldMap, function(fieldConfig, fieldName) {
        var _fieldConfig$args;
        $4cde51e3b6dfd290$var$isPlainObj(fieldConfig) || (0, $fZdRY.default)(0, "".concat(config.name, ".").concat(fieldName, " field config must be an object."));
        !('isDeprecated' in fieldConfig) || (0, $fZdRY.default)(0, "".concat(config.name, ".").concat(fieldName, " should provide \"deprecationReason\" instead of \"isDeprecated\"."));
        fieldConfig.resolve == null || typeof fieldConfig.resolve === 'function' || (0, $fZdRY.default)(0, "".concat(config.name, ".").concat(fieldName, " field resolver must be a function if ") + "provided, but got: ".concat((0, $biK02.default)(fieldConfig.resolve), "."));
        var argsConfig = (_fieldConfig$args = fieldConfig.args) !== null && _fieldConfig$args !== void 0 ? _fieldConfig$args : {};
        $4cde51e3b6dfd290$var$isPlainObj(argsConfig) || (0, $fZdRY.default)(0, "".concat(config.name, ".").concat(fieldName, " args must be an object with argument names as keys."));
        var args = (0, $apet0.default)(argsConfig).map(function(_ref) {
            var argName = _ref[0], argConfig = _ref[1];
            return {
                name: argName,
                description: argConfig.description,
                type: argConfig.type,
                defaultValue: argConfig.defaultValue,
                deprecationReason: argConfig.deprecationReason,
                extensions: argConfig.extensions && (0, $eCJ4z.default)(argConfig.extensions),
                astNode: argConfig.astNode
            };
        });
        return {
            name: fieldName,
            description: fieldConfig.description,
            type: fieldConfig.type,
            args: args,
            resolve: fieldConfig.resolve,
            subscribe: fieldConfig.subscribe,
            isDeprecated: fieldConfig.deprecationReason != null,
            deprecationReason: fieldConfig.deprecationReason,
            extensions: fieldConfig.extensions && (0, $eCJ4z.default)(fieldConfig.extensions),
            astNode: fieldConfig.astNode
        };
    });
}
function $4cde51e3b6dfd290$var$isPlainObj(obj) {
    return (0, $fbtyx.default)(obj) && !Array.isArray(obj);
}
function $4cde51e3b6dfd290$var$fieldsToFieldsConfig(fields) {
    return (0, $6MWHL.default)(fields, function(field) {
        return {
            description: field.description,
            type: field.type,
            args: $4cde51e3b6dfd290$export$ae5ade30c645f6fd(field.args),
            resolve: field.resolve,
            subscribe: field.subscribe,
            deprecationReason: field.deprecationReason,
            extensions: field.extensions,
            astNode: field.astNode
        };
    });
}
function $4cde51e3b6dfd290$export$ae5ade30c645f6fd(args) {
    return (0, $2AFgT.default)(args, function(arg) {
        return arg.name;
    }, function(arg) {
        return {
            description: arg.description,
            type: arg.type,
            defaultValue: arg.defaultValue,
            deprecationReason: arg.deprecationReason,
            extensions: arg.extensions,
            astNode: arg.astNode
        };
    });
}
function $4cde51e3b6dfd290$export$caef08b21560291a(arg) {
    return $4cde51e3b6dfd290$export$146b6508fa0d6c82(arg.type) && arg.defaultValue === undefined;
}
var $4cde51e3b6dfd290$export$148e92587b8bf1f9 = /*#__PURE__*/ function() {
    function GraphQLInterfaceType(config) {
        this.name = config.name;
        this.description = config.description;
        this.resolveType = config.resolveType;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        this._fields = $4cde51e3b6dfd290$var$defineFieldMap.bind(undefined, config);
        this._interfaces = $4cde51e3b6dfd290$var$defineInterfaces.bind(undefined, config);
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
        config.resolveType == null || typeof config.resolveType === 'function' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat((0, $biK02.default)(config.resolveType), "."));
    }
    var _proto3 = GraphQLInterfaceType.prototype;
    _proto3.getFields = function getFields() {
        if (typeof this._fields === 'function') this._fields = this._fields();
        return this._fields;
    };
    _proto3.getInterfaces = function getInterfaces() {
        if (typeof this._interfaces === 'function') this._interfaces = this._interfaces();
        return this._interfaces;
    };
    _proto3.toConfig = function toConfig() {
        var _this$extensionASTNod2;
        return {
            name: this.name,
            description: this.description,
            interfaces: this.getInterfaces(),
            fields: $4cde51e3b6dfd290$var$fieldsToFieldsConfig(this.getFields()),
            resolveType: this.resolveType,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod2 = this.extensionASTNodes) !== null && _this$extensionASTNod2 !== void 0 ? _this$extensionASTNod2 : []
        };
    };
    _proto3.toString = function toString() {
        return this.name;
    };
    _proto3.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLInterfaceType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLInterfaceType';
            }
        }
    ]);
    return GraphQLInterfaceType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$148e92587b8bf1f9);
var $4cde51e3b6dfd290$export$33c479b4c3812d0b = /*#__PURE__*/ function() {
    function GraphQLUnionType(config) {
        this.name = config.name;
        this.description = config.description;
        this.resolveType = config.resolveType;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        this._types = $4cde51e3b6dfd290$var$defineTypes.bind(undefined, config);
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
        config.resolveType == null || typeof config.resolveType === 'function' || (0, $fZdRY.default)(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat((0, $biK02.default)(config.resolveType), "."));
    }
    var _proto4 = GraphQLUnionType.prototype;
    _proto4.getTypes = function getTypes() {
        if (typeof this._types === 'function') this._types = this._types();
        return this._types;
    };
    _proto4.toConfig = function toConfig() {
        var _this$extensionASTNod3;
        return {
            name: this.name,
            description: this.description,
            types: this.getTypes(),
            resolveType: this.resolveType,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod3 = this.extensionASTNodes) !== null && _this$extensionASTNod3 !== void 0 ? _this$extensionASTNod3 : []
        };
    };
    _proto4.toString = function toString() {
        return this.name;
    };
    _proto4.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLUnionType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLUnionType';
            }
        }
    ]);
    return GraphQLUnionType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$33c479b4c3812d0b);
function $4cde51e3b6dfd290$var$defineTypes(config) {
    var types = $4cde51e3b6dfd290$var$resolveThunk(config.types);
    Array.isArray(types) || (0, $fZdRY.default)(0, "Must provide Array of types or a function which returns such an array for Union ".concat(config.name, "."));
    return types;
}
var $4cde51e3b6dfd290$export$2577fb93f8748953 = /*#__PURE__*/ function() {
    function GraphQLEnumType(config) {
        this.name = config.name;
        this.description = config.description;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        this._values = $4cde51e3b6dfd290$var$defineEnumValues(this.name, config.values);
        this._valueLookup = new Map(this._values.map(function(enumValue) {
            return [
                enumValue.value,
                enumValue
            ];
        }));
        this._nameLookup = (0, $hbiEd.default)(this._values, function(value) {
            return value.name;
        });
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
    }
    var _proto5 = GraphQLEnumType.prototype;
    _proto5.getValues = function getValues() {
        return this._values;
    };
    _proto5.getValue = function getValue(name) {
        return this._nameLookup[name];
    };
    _proto5.serialize = function serialize(outputValue) {
        var enumValue = this._valueLookup.get(outputValue);
        if (enumValue === undefined) throw new (0, $9fgMZ.GraphQLError)("Enum \"".concat(this.name, "\" cannot represent value: ").concat((0, $biK02.default)(outputValue)));
        return enumValue.name;
    };
    _proto5.parseValue = function parseValue(inputValue) /* T */ {
        if (typeof inputValue !== 'string') {
            var valueStr = (0, $biK02.default)(inputValue);
            throw new (0, $9fgMZ.GraphQLError)("Enum \"".concat(this.name, "\" cannot represent non-string value: ").concat(valueStr, ".") + $4cde51e3b6dfd290$var$didYouMeanEnumValue(this, valueStr));
        }
        var enumValue = this.getValue(inputValue);
        if (enumValue == null) throw new (0, $9fgMZ.GraphQLError)("Value \"".concat(inputValue, "\" does not exist in \"").concat(this.name, "\" enum.") + $4cde51e3b6dfd290$var$didYouMeanEnumValue(this, inputValue));
        return enumValue.value;
    };
    _proto5.parseLiteral = function parseLiteral(valueNode, _variables) /* T */ {
        // Note: variables will be resolved to a value before calling this function.
        if (valueNode.kind !== (0, $1c4hI.Kind).ENUM) {
            var valueStr = (0, $aKlnM.print)(valueNode);
            throw new (0, $9fgMZ.GraphQLError)("Enum \"".concat(this.name, "\" cannot represent non-enum value: ").concat(valueStr, ".") + $4cde51e3b6dfd290$var$didYouMeanEnumValue(this, valueStr), valueNode);
        }
        var enumValue = this.getValue(valueNode.value);
        if (enumValue == null) {
            var _valueStr = (0, $aKlnM.print)(valueNode);
            throw new (0, $9fgMZ.GraphQLError)("Value \"".concat(_valueStr, "\" does not exist in \"").concat(this.name, "\" enum.") + $4cde51e3b6dfd290$var$didYouMeanEnumValue(this, _valueStr), valueNode);
        }
        return enumValue.value;
    };
    _proto5.toConfig = function toConfig() {
        var _this$extensionASTNod4;
        var values = (0, $2AFgT.default)(this.getValues(), function(value) {
            return value.name;
        }, function(value) {
            return {
                description: value.description,
                value: value.value,
                deprecationReason: value.deprecationReason,
                extensions: value.extensions,
                astNode: value.astNode
            };
        });
        return {
            name: this.name,
            description: this.description,
            values: values,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod4 = this.extensionASTNodes) !== null && _this$extensionASTNod4 !== void 0 ? _this$extensionASTNod4 : []
        };
    };
    _proto5.toString = function toString() {
        return this.name;
    };
    _proto5.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLEnumType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLEnumType';
            }
        }
    ]);
    return GraphQLEnumType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$2577fb93f8748953);
function $4cde51e3b6dfd290$var$didYouMeanEnumValue(enumType, unknownValueStr) {
    var allNames = enumType.getValues().map(function(value) {
        return value.name;
    });
    var suggestedValues = (0, $bru1k.default)(unknownValueStr, allNames);
    return (0, $8nBnZ.default)('the enum value', suggestedValues);
}
function $4cde51e3b6dfd290$var$defineEnumValues(typeName, valueMap) {
    $4cde51e3b6dfd290$var$isPlainObj(valueMap) || (0, $fZdRY.default)(0, "".concat(typeName, " values must be an object with value names as keys."));
    return (0, $apet0.default)(valueMap).map(function(_ref2) {
        var valueName = _ref2[0], valueConfig = _ref2[1];
        $4cde51e3b6dfd290$var$isPlainObj(valueConfig) || (0, $fZdRY.default)(0, "".concat(typeName, ".").concat(valueName, " must refer to an object with a \"value\" key ") + "representing an internal value but got: ".concat((0, $biK02.default)(valueConfig), "."));
        !('isDeprecated' in valueConfig) || (0, $fZdRY.default)(0, "".concat(typeName, ".").concat(valueName, " should provide \"deprecationReason\" instead of \"isDeprecated\"."));
        return {
            name: valueName,
            description: valueConfig.description,
            value: valueConfig.value !== undefined ? valueConfig.value : valueName,
            isDeprecated: valueConfig.deprecationReason != null,
            deprecationReason: valueConfig.deprecationReason,
            extensions: valueConfig.extensions && (0, $eCJ4z.default)(valueConfig.extensions),
            astNode: valueConfig.astNode
        };
    });
}
var $4cde51e3b6dfd290$export$ea29baa44b9fd772 = /*#__PURE__*/ function() {
    function GraphQLInputObjectType(config) {
        this.name = config.name;
        this.description = config.description;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = $4cde51e3b6dfd290$var$undefineIfEmpty(config.extensionASTNodes);
        this._fields = $4cde51e3b6dfd290$var$defineInputFieldMap.bind(undefined, config);
        typeof config.name === 'string' || (0, $fZdRY.default)(0, 'Must provide name.');
    }
    var _proto6 = GraphQLInputObjectType.prototype;
    _proto6.getFields = function getFields() {
        if (typeof this._fields === 'function') this._fields = this._fields();
        return this._fields;
    };
    _proto6.toConfig = function toConfig() {
        var _this$extensionASTNod5;
        var fields = (0, $6MWHL.default)(this.getFields(), function(field) {
            return {
                description: field.description,
                type: field.type,
                defaultValue: field.defaultValue,
                deprecationReason: field.deprecationReason,
                extensions: field.extensions,
                astNode: field.astNode
            };
        });
        return {
            name: this.name,
            description: this.description,
            fields: fields,
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod5 = this.extensionASTNodes) !== null && _this$extensionASTNod5 !== void 0 ? _this$extensionASTNod5 : []
        };
    };
    _proto6.toString = function toString() {
        return this.name;
    };
    _proto6.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $4cde51e3b6dfd290$var$_createClass(GraphQLInputObjectType, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLInputObjectType';
            }
        }
    ]);
    return GraphQLInputObjectType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($4cde51e3b6dfd290$export$ea29baa44b9fd772);
function $4cde51e3b6dfd290$var$defineInputFieldMap(config) {
    var fieldMap = $4cde51e3b6dfd290$var$resolveThunk(config.fields);
    $4cde51e3b6dfd290$var$isPlainObj(fieldMap) || (0, $fZdRY.default)(0, "".concat(config.name, " fields must be an object with field names as keys or a function which returns such an object."));
    return (0, $6MWHL.default)(fieldMap, function(fieldConfig, fieldName) {
        !('resolve' in fieldConfig) || (0, $fZdRY.default)(0, "".concat(config.name, ".").concat(fieldName, " field has a resolve property, but Input Types cannot define resolvers."));
        return {
            name: fieldName,
            description: fieldConfig.description,
            type: fieldConfig.type,
            defaultValue: fieldConfig.defaultValue,
            deprecationReason: fieldConfig.deprecationReason,
            extensions: fieldConfig.extensions && (0, $eCJ4z.default)(fieldConfig.extensions),
            astNode: fieldConfig.astNode
        };
    });
}
function $4cde51e3b6dfd290$export$2657dcc79c2b6229(field) {
    return $4cde51e3b6dfd290$export$146b6508fa0d6c82(field.type) && field.defaultValue === undefined;
}

});
parcelRegister("apet0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b08f9c07090601a$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var $7b08f9c07090601a$var$objectEntries = Object.entries || function(obj) {
    return Object.keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
};
var $7b08f9c07090601a$export$2e2bcd8739ae039 = $7b08f9c07090601a$var$objectEntries;

});

parcelRegister("hbiEd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8bc0ac8e121286d$export$2e2bcd8739ae039);
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * for each value in the array.
 *
 * This provides a convenient lookup for the array items if the key function
 * produces unique results.
 *
 *     const phoneBook = [
 *       { name: 'Jon', num: '555-1234' },
 *       { name: 'Jenny', num: '867-5309' }
 *     ]
 *
 *     // { Jon: { name: 'Jon', num: '555-1234' },
 *     //   Jenny: { name: 'Jenny', num: '867-5309' } }
 *     const entriesByName = keyMap(
 *       phoneBook,
 *       entry => entry.name
 *     )
 *
 *     // { name: 'Jenny', num: '857-6309' }
 *     const jennyEntry = entriesByName['Jenny']
 *
 */ function $b8bc0ac8e121286d$export$2e2bcd8739ae039(list, keyFn) {
    return list.reduce(function(map, item) {
        map[keyFn(item)] = item;
        return map;
    }, Object.create(null));
}

});

parcelRegister("6MWHL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8fd45ca354e0fd3$export$2e2bcd8739ae039);

var $apet0 = parcelRequire("apet0");
function $f8fd45ca354e0fd3$export$2e2bcd8739ae039(map, fn) {
    var result = Object.create(null);
    for(var _i2 = 0, _objectEntries2 = (0, $apet0.default)(map); _i2 < _objectEntries2.length; _i2++){
        var _ref2 = _objectEntries2[_i2];
        var _key = _ref2[0];
        var _value = _ref2[1];
        result[_key] = fn(_value, _key);
    }
    return result;
}

});

parcelRegister("eCJ4z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b444aa0d60034f90$export$2e2bcd8739ae039);

var $apet0 = parcelRequire("apet0");
function $b444aa0d60034f90$export$2e2bcd8739ae039(obj) {
    /* eslint-enable no-redeclare */ if (Object.getPrototypeOf(obj) === null) return obj;
    var map = Object.create(null);
    for(var _i2 = 0, _objectEntries2 = (0, $apet0.default)(obj); _i2 < _objectEntries2.length; _i2++){
        var _ref2 = _objectEntries2[_i2];
        var key = _ref2[0];
        var value = _ref2[1];
        map[key] = value;
    }
    return map;
}

});

parcelRegister("2AFgT", function(module, exports) {

$parcel$export(module.exports, "default", () => $825d74909efe1661$export$2e2bcd8739ae039);
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * and a function to produce the values from each item in the array.
 *
 *     const phoneBook = [
 *       { name: 'Jon', num: '555-1234' },
 *       { name: 'Jenny', num: '867-5309' }
 *     ]
 *
 *     // { Jon: '555-1234', Jenny: '867-5309' }
 *     const phonesByName = keyValMap(
 *       phoneBook,
 *       entry => entry.name,
 *       entry => entry.num
 *     )
 *
 */ function $825d74909efe1661$export$2e2bcd8739ae039(list, keyFn, valFn) {
    return list.reduce(function(map, item) {
        map[keyFn(item)] = valFn(item);
        return map;
    }, Object.create(null));
}

});

parcelRegister("8nBnZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35e74e446587809$export$2e2bcd8739ae039);
var $d35e74e446587809$var$MAX_SUGGESTIONS = 5;
function $d35e74e446587809$export$2e2bcd8739ae039(firstArg, secondArg) {
    var _ref = typeof firstArg === 'string' ? [
        firstArg,
        secondArg
    ] : [
        undefined,
        firstArg
    ], subMessage = _ref[0], suggestionsArg = _ref[1];
    var message = ' Did you mean ';
    if (subMessage) message += subMessage + ' ';
    var suggestions = suggestionsArg.map(function(x) {
        return "\"".concat(x, "\"");
    });
    switch(suggestions.length){
        case 0:
            return '';
        case 1:
            return message + suggestions[0] + '?';
        case 2:
            return message + suggestions[0] + ' or ' + suggestions[1] + '?';
    }
    var selected = suggestions.slice(0, $d35e74e446587809$var$MAX_SUGGESTIONS);
    var lastItem = selected.pop();
    return message + selected.join(', ') + ', or ' + lastItem + '?';
}

});

parcelRegister("7J7By", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3262e5f24e9ad17$export$2e2bcd8739ae039);
/**
 * Returns the first argument it receives.
 */ function $a3262e5f24e9ad17$export$2e2bcd8739ae039(x) {
    return x;
}

});

parcelRegister("bru1k", function(module, exports) {

$parcel$export(module.exports, "default", () => $60c1d5be3d827a25$export$2e2bcd8739ae039);

var $daK4l = parcelRequire("daK4l");
function $60c1d5be3d827a25$export$2e2bcd8739ae039(input, options) {
    var optionsByDistance = Object.create(null);
    var lexicalDistance = new $60c1d5be3d827a25$var$LexicalDistance(input);
    var threshold = Math.floor(input.length * 0.4) + 1;
    for(var _i2 = 0; _i2 < options.length; _i2++){
        var option = options[_i2];
        var distance = lexicalDistance.measure(option, threshold);
        if (distance !== undefined) optionsByDistance[option] = distance;
    }
    return Object.keys(optionsByDistance).sort(function(a, b) {
        var distanceDiff = optionsByDistance[a] - optionsByDistance[b];
        return distanceDiff !== 0 ? distanceDiff : (0, $daK4l.default)(a, b);
    });
}
/**
 * Computes the lexical distance between strings A and B.
 *
 * The "distance" between two strings is given by counting the minimum number
 * of edits needed to transform string A into string B. An edit can be an
 * insertion, deletion, or substitution of a single character, or a swap of two
 * adjacent characters.
 *
 * Includes a custom alteration from Damerau-Levenshtein to treat case changes
 * as a single edit which helps identify mis-cased values with an edit distance
 * of 1.
 *
 * This distance can be useful for detecting typos in input or sorting
 */ var $60c1d5be3d827a25$var$LexicalDistance = /*#__PURE__*/ function() {
    function LexicalDistance(input) {
        this._input = input;
        this._inputLowerCase = input.toLowerCase();
        this._inputArray = $60c1d5be3d827a25$var$stringToArray(this._inputLowerCase);
        this._rows = [
            new Array(input.length + 1).fill(0),
            new Array(input.length + 1).fill(0),
            new Array(input.length + 1).fill(0)
        ];
    }
    var _proto = LexicalDistance.prototype;
    _proto.measure = function measure(option, threshold) {
        if (this._input === option) return 0;
        var optionLowerCase = option.toLowerCase(); // Any case change counts as a single edit
        if (this._inputLowerCase === optionLowerCase) return 1;
        var a = $60c1d5be3d827a25$var$stringToArray(optionLowerCase);
        var b = this._inputArray;
        if (a.length < b.length) {
            var tmp = a;
            a = b;
            b = tmp;
        }
        var aLength = a.length;
        var bLength = b.length;
        if (aLength - bLength > threshold) return undefined;
        var rows = this._rows;
        for(var j = 0; j <= bLength; j++)rows[0][j] = j;
        for(var i = 1; i <= aLength; i++){
            var upRow = rows[(i - 1) % 3];
            var currentRow = rows[i % 3];
            var smallestCell = currentRow[0] = i;
            for(var _j = 1; _j <= bLength; _j++){
                var cost = a[i - 1] === b[_j - 1] ? 0 : 1;
                var currentCell = Math.min(upRow[_j] + 1, currentRow[_j - 1] + 1, upRow[_j - 1] + cost // substitute
                );
                if (i > 1 && _j > 1 && a[i - 1] === b[_j - 2] && a[i - 2] === b[_j - 1]) {
                    // transposition
                    var doubleDiagonalCell = rows[(i - 2) % 3][_j - 2];
                    currentCell = Math.min(currentCell, doubleDiagonalCell + 1);
                }
                if (currentCell < smallestCell) smallestCell = currentCell;
                currentRow[_j] = currentCell;
            } // Early exit, since distance can't go smaller than smallest element of the previous row.
            if (smallestCell > threshold) return undefined;
        }
        var distance = rows[aLength % 3][bLength];
        return distance <= threshold ? distance : undefined;
    };
    return LexicalDistance;
}();
function $60c1d5be3d827a25$var$stringToArray(str) {
    var strLength = str.length;
    var array = new Array(strLength);
    for(var i = 0; i < strLength; ++i)array[i] = str.charCodeAt(i);
    return array;
}

});
parcelRegister("daK4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $1240f08dc429303b$export$2e2bcd8739ae039);
/**
 * Returns a number indicating whether a reference string comes before, or after,
 * or is the same as the given string in natural sort order.
 *
 * See: https://en.wikipedia.org/wiki/Natural_sort_order
 *
 */ function $1240f08dc429303b$export$2e2bcd8739ae039(aStr, bStr) {
    var aIdx = 0;
    var bIdx = 0;
    while(aIdx < aStr.length && bIdx < bStr.length){
        var aChar = aStr.charCodeAt(aIdx);
        var bChar = bStr.charCodeAt(bIdx);
        if ($1240f08dc429303b$var$isDigit(aChar) && $1240f08dc429303b$var$isDigit(bChar)) {
            var aNum = 0;
            do {
                ++aIdx;
                aNum = aNum * 10 + aChar - $1240f08dc429303b$var$DIGIT_0;
                aChar = aStr.charCodeAt(aIdx);
            }while ($1240f08dc429303b$var$isDigit(aChar) && aNum > 0);
            var bNum = 0;
            do {
                ++bIdx;
                bNum = bNum * 10 + bChar - $1240f08dc429303b$var$DIGIT_0;
                bChar = bStr.charCodeAt(bIdx);
            }while ($1240f08dc429303b$var$isDigit(bChar) && bNum > 0);
            if (aNum < bNum) return -1;
            if (aNum > bNum) return 1;
        } else {
            if (aChar < bChar) return -1;
            if (aChar > bChar) return 1;
            ++aIdx;
            ++bIdx;
        }
    }
    return aStr.length - bStr.length;
}
var $1240f08dc429303b$var$DIGIT_0 = 48;
var $1240f08dc429303b$var$DIGIT_9 = 57;
function $1240f08dc429303b$var$isDigit(code) {
    return !isNaN(code) && $1240f08dc429303b$var$DIGIT_0 <= code && code <= $1240f08dc429303b$var$DIGIT_9;
}

});


parcelRegister("iTQJQ", function(module, exports) {

$parcel$export(module.exports, "valueFromASTUntyped", () => $da10b2789fd99674$export$448e0963aec9442f);

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $2AFgT = parcelRequire("2AFgT");

var $1c4hI = parcelRequire("1c4hI");
function $da10b2789fd99674$export$448e0963aec9442f(valueNode, variables) {
    switch(valueNode.kind){
        case (0, $1c4hI.Kind).NULL:
            return null;
        case (0, $1c4hI.Kind).INT:
            return parseInt(valueNode.value, 10);
        case (0, $1c4hI.Kind).FLOAT:
            return parseFloat(valueNode.value);
        case (0, $1c4hI.Kind).STRING:
        case (0, $1c4hI.Kind).ENUM:
        case (0, $1c4hI.Kind).BOOLEAN:
            return valueNode.value;
        case (0, $1c4hI.Kind).LIST:
            return valueNode.values.map(function(node) {
                return $da10b2789fd99674$export$448e0963aec9442f(node, variables);
            });
        case (0, $1c4hI.Kind).OBJECT:
            return (0, $2AFgT.default)(valueNode.fields, function(field) {
                return field.name.value;
            }, function(field) {
                return $da10b2789fd99674$export$448e0963aec9442f(field.value, variables);
            });
        case (0, $1c4hI.Kind).VARIABLE:
            return variables === null || variables === void 0 ? void 0 : variables[valueNode.name.value];
    } // istanbul ignore next (Not reachable. All possible value nodes have been considered)
    (0, $43MJl.default)(0, 'Unexpected value node: ' + (0, $biK02.default)(valueNode));
}

});



parcelRegister("6BdRO", function(module, exports) {

$parcel$export(module.exports, "GraphQLSchema", () => $1e230b99124f3642$export$730e8b0fd6e4f02b);
$parcel$export(module.exports, "assertSchema", () => $1e230b99124f3642$export$6554dabc0f90e0c3);

var $bmIpK = parcelRequire("bmIpK");

var $96Cqc = parcelRequire("96Cqc");

var $dVq2R = parcelRequire("dVq2R");

var $gwa3m = parcelRequire("gwa3m");

var $biK02 = parcelRequire("biK02");

var $eCJ4z = parcelRequire("eCJ4z");

var $fZdRY = parcelRequire("fZdRY");

var $aVhwC = parcelRequire("aVhwC");

var $fbtyx = parcelRequire("fbtyx");

var $h2iUh = parcelRequire("h2iUh");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");
function $1e230b99124f3642$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1e230b99124f3642$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1e230b99124f3642$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1e230b99124f3642$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1e230b99124f3642$export$213e2a3e7c4f326e(schema) {
    return (0, $aVhwC.default)(schema, $1e230b99124f3642$export$730e8b0fd6e4f02b);
}
function $1e230b99124f3642$export$6554dabc0f90e0c3(schema) {
    if (!$1e230b99124f3642$export$213e2a3e7c4f326e(schema)) throw new Error("Expected ".concat((0, $biK02.default)(schema), " to be a GraphQL schema."));
    return schema;
}
var $1e230b99124f3642$export$730e8b0fd6e4f02b = /*#__PURE__*/ function() {
    // Used as a cache for validateSchema().
    function GraphQLSchema(config) {
        var _config$directives;
        // If this schema was built from a source known to be valid, then it may be
        // marked with assumeValid to avoid an additional type system validation.
        this.__validationErrors = config.assumeValid === true ? [] : undefined; // Check for common mistakes during construction to produce early errors.
        (0, $fbtyx.default)(config) || (0, $fZdRY.default)(0, 'Must provide configuration object.');
        !config.types || Array.isArray(config.types) || (0, $fZdRY.default)(0, "\"types\" must be Array if provided but got: ".concat((0, $biK02.default)(config.types), "."));
        !config.directives || Array.isArray(config.directives) || (0, $fZdRY.default)(0, '"directives" must be Array if provided but got: ' + "".concat((0, $biK02.default)(config.directives), "."));
        this.description = config.description;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        this.extensionASTNodes = config.extensionASTNodes;
        this._queryType = config.query;
        this._mutationType = config.mutation;
        this._subscriptionType = config.subscription; // Provide specified directives (e.g. @include and @skip) by default.
        this._directives = (_config$directives = config.directives) !== null && _config$directives !== void 0 ? _config$directives : (0, $bOniD.specifiedDirectives); // To preserve order of user-provided types, we add first to add them to
        // the set of "collected" types, so `collectReferencedTypes` ignore them.
        var allReferencedTypes = new Set(config.types);
        if (config.types != null) for(var _i2 = 0, _config$types2 = config.types; _i2 < _config$types2.length; _i2++){
            var type = _config$types2[_i2];
            // When we ready to process this type, we remove it from "collected" types
            // and then add it together with all dependent types in the correct position.
            allReferencedTypes.delete(type);
            $1e230b99124f3642$var$collectReferencedTypes(type, allReferencedTypes);
        }
        if (this._queryType != null) $1e230b99124f3642$var$collectReferencedTypes(this._queryType, allReferencedTypes);
        if (this._mutationType != null) $1e230b99124f3642$var$collectReferencedTypes(this._mutationType, allReferencedTypes);
        if (this._subscriptionType != null) $1e230b99124f3642$var$collectReferencedTypes(this._subscriptionType, allReferencedTypes);
        for(var _i4 = 0, _this$_directives2 = this._directives; _i4 < _this$_directives2.length; _i4++){
            var directive = _this$_directives2[_i4];
            // Directives are not validated until validateSchema() is called.
            if ((0, $bOniD.isDirective)(directive)) for(var _i6 = 0, _directive$args2 = directive.args; _i6 < _directive$args2.length; _i6++){
                var arg = _directive$args2[_i6];
                $1e230b99124f3642$var$collectReferencedTypes(arg.type, allReferencedTypes);
            }
        }
        $1e230b99124f3642$var$collectReferencedTypes((0, $h2iUh.__Schema), allReferencedTypes); // Storing the resulting map for reference by the schema.
        this._typeMap = Object.create(null);
        this._subTypeMap = Object.create(null); // Keep track of all implementations by interface name.
        this._implementationsMap = Object.create(null);
        for(var _i8 = 0, _arrayFrom2 = (0, $96Cqc.default)(allReferencedTypes); _i8 < _arrayFrom2.length; _i8++){
            var namedType = _arrayFrom2[_i8];
            if (namedType == null) continue;
            var typeName = namedType.name;
            typeName || (0, $fZdRY.default)(0, 'One of the provided types for building the Schema is missing a name.');
            if (this._typeMap[typeName] !== undefined) throw new Error("Schema must contain uniquely named types but contains multiple types named \"".concat(typeName, "\"."));
            this._typeMap[typeName] = namedType;
            if ((0, $lXoEQ.isInterfaceType)(namedType)) // Store implementations by interface.
            for(var _i10 = 0, _namedType$getInterfa2 = namedType.getInterfaces(); _i10 < _namedType$getInterfa2.length; _i10++){
                var iface = _namedType$getInterfa2[_i10];
                if ((0, $lXoEQ.isInterfaceType)(iface)) {
                    var implementations = this._implementationsMap[iface.name];
                    if (implementations === undefined) implementations = this._implementationsMap[iface.name] = {
                        objects: [],
                        interfaces: []
                    };
                    implementations.interfaces.push(namedType);
                }
            }
            else if ((0, $lXoEQ.isObjectType)(namedType)) // Store implementations by objects.
            for(var _i12 = 0, _namedType$getInterfa4 = namedType.getInterfaces(); _i12 < _namedType$getInterfa4.length; _i12++){
                var _iface = _namedType$getInterfa4[_i12];
                if ((0, $lXoEQ.isInterfaceType)(_iface)) {
                    var _implementations = this._implementationsMap[_iface.name];
                    if (_implementations === undefined) _implementations = this._implementationsMap[_iface.name] = {
                        objects: [],
                        interfaces: []
                    };
                    _implementations.objects.push(namedType);
                }
            }
        }
    }
    var _proto = GraphQLSchema.prototype;
    _proto.getQueryType = function getQueryType() {
        return this._queryType;
    };
    _proto.getMutationType = function getMutationType() {
        return this._mutationType;
    };
    _proto.getSubscriptionType = function getSubscriptionType() {
        return this._subscriptionType;
    };
    _proto.getTypeMap = function getTypeMap() {
        return this._typeMap;
    };
    _proto.getType = function getType(name) {
        return this.getTypeMap()[name];
    };
    _proto.getPossibleTypes = function getPossibleTypes(abstractType) {
        return (0, $lXoEQ.isUnionType)(abstractType) ? abstractType.getTypes() : this.getImplementations(abstractType).objects;
    };
    _proto.getImplementations = function getImplementations(interfaceType) {
        var implementations = this._implementationsMap[interfaceType.name];
        return implementations !== null && implementations !== void 0 ? implementations : {
            objects: [],
            interfaces: []
        };
    } // @deprecated: use isSubType instead - will be removed in v16.
    ;
    _proto.isPossibleType = function isPossibleType(abstractType, possibleType) {
        return this.isSubType(abstractType, possibleType);
    };
    _proto.isSubType = function isSubType(abstractType, maybeSubType) {
        var map = this._subTypeMap[abstractType.name];
        if (map === undefined) {
            map = Object.create(null);
            if ((0, $lXoEQ.isUnionType)(abstractType)) for(var _i14 = 0, _abstractType$getType2 = abstractType.getTypes(); _i14 < _abstractType$getType2.length; _i14++){
                var type = _abstractType$getType2[_i14];
                map[type.name] = true;
            }
            else {
                var implementations = this.getImplementations(abstractType);
                for(var _i16 = 0, _implementations$obje2 = implementations.objects; _i16 < _implementations$obje2.length; _i16++){
                    var _type = _implementations$obje2[_i16];
                    map[_type.name] = true;
                }
                for(var _i18 = 0, _implementations$inte2 = implementations.interfaces; _i18 < _implementations$inte2.length; _i18++){
                    var _type2 = _implementations$inte2[_i18];
                    map[_type2.name] = true;
                }
            }
            this._subTypeMap[abstractType.name] = map;
        }
        return map[maybeSubType.name] !== undefined;
    };
    _proto.getDirectives = function getDirectives() {
        return this._directives;
    };
    _proto.getDirective = function getDirective(name) {
        return (0, $bmIpK.default)(this.getDirectives(), function(directive) {
            return directive.name === name;
        });
    };
    _proto.toConfig = function toConfig() {
        var _this$extensionASTNod;
        return {
            description: this.description,
            query: this.getQueryType(),
            mutation: this.getMutationType(),
            subscription: this.getSubscriptionType(),
            types: (0, $dVq2R.default)(this.getTypeMap()),
            directives: this.getDirectives().slice(),
            extensions: this.extensions,
            astNode: this.astNode,
            extensionASTNodes: (_this$extensionASTNod = this.extensionASTNodes) !== null && _this$extensionASTNod !== void 0 ? _this$extensionASTNod : [],
            assumeValid: this.__validationErrors !== undefined
        };
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $1e230b99124f3642$var$_createClass(GraphQLSchema, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLSchema';
            }
        }
    ]);
    return GraphQLSchema;
}();
function $1e230b99124f3642$var$collectReferencedTypes(type, typeSet) {
    var namedType = (0, $lXoEQ.getNamedType)(type);
    if (!typeSet.has(namedType)) {
        typeSet.add(namedType);
        if ((0, $lXoEQ.isUnionType)(namedType)) for(var _i20 = 0, _namedType$getTypes2 = namedType.getTypes(); _i20 < _namedType$getTypes2.length; _i20++){
            var memberType = _namedType$getTypes2[_i20];
            $1e230b99124f3642$var$collectReferencedTypes(memberType, typeSet);
        }
        else if ((0, $lXoEQ.isObjectType)(namedType) || (0, $lXoEQ.isInterfaceType)(namedType)) {
            for(var _i22 = 0, _namedType$getInterfa6 = namedType.getInterfaces(); _i22 < _namedType$getInterfa6.length; _i22++){
                var interfaceType = _namedType$getInterfa6[_i22];
                $1e230b99124f3642$var$collectReferencedTypes(interfaceType, typeSet);
            }
            for(var _i24 = 0, _objectValues2 = (0, $dVq2R.default)(namedType.getFields()); _i24 < _objectValues2.length; _i24++){
                var field = _objectValues2[_i24];
                $1e230b99124f3642$var$collectReferencedTypes(field.type, typeSet);
                for(var _i26 = 0, _field$args2 = field.args; _i26 < _field$args2.length; _i26++){
                    var arg = _field$args2[_i26];
                    $1e230b99124f3642$var$collectReferencedTypes(arg.type, typeSet);
                }
            }
        } else if ((0, $lXoEQ.isInputObjectType)(namedType)) for(var _i28 = 0, _objectValues4 = (0, $dVq2R.default)(namedType.getFields()); _i28 < _objectValues4.length; _i28++){
            var _field = _objectValues4[_i28];
            $1e230b99124f3642$var$collectReferencedTypes(_field.type, typeSet);
        }
    }
    return typeSet;
}

});
parcelRegister("96Cqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff75e7d75b147b76$export$2e2bcd8739ae039);

var $gwa3m = parcelRequire("gwa3m");
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound]
var $ff75e7d75b147b76$var$arrayFrom = Array.from || function(obj, mapFn, thisArg) {
    if (obj == null) throw new TypeError('Array.from requires an array-like object - not null or undefined');
     // Is Iterable?
    var iteratorMethod = obj[0, $gwa3m.SYMBOL_ITERATOR];
    if (typeof iteratorMethod === 'function') {
        var iterator = iteratorMethod.call(obj);
        var result = [];
        var step;
        for(var i = 0; !(step = iterator.next()).done; ++i){
            result.push(mapFn.call(thisArg, step.value, i)); // Infinite Iterators could cause forEach to run forever.
            // After a very large number of iterations, produce an error.
            // istanbul ignore if (Too big to actually test)
            if (i > 9999999) throw new TypeError('Near-infinite iteration.');
        }
        return result;
    } // Is Array like?
    var length = obj.length;
    if (typeof length === 'number' && length >= 0 && length % 1 === 0) {
        var _result = [];
        for(var _i = 0; _i < length; ++_i)if (Object.prototype.hasOwnProperty.call(obj, _i)) _result.push(mapFn.call(thisArg, obj[_i], _i));
        return _result;
    }
    return [];
};
var $ff75e7d75b147b76$export$2e2bcd8739ae039 = $ff75e7d75b147b76$var$arrayFrom;

});

parcelRegister("h2iUh", function(module, exports) {

$parcel$export(module.exports, "__Schema", () => $6ebe99021e9a5959$export$1f18df711f6fa0ac);
$parcel$export(module.exports, "TypeKind", () => $6ebe99021e9a5959$export$c29cf3c48471da7c);
$parcel$export(module.exports, "SchemaMetaFieldDef", () => $6ebe99021e9a5959$export$36ed059ad2080404);
$parcel$export(module.exports, "TypeMetaFieldDef", () => $6ebe99021e9a5959$export$87a968d084148b61);
$parcel$export(module.exports, "TypeNameMetaFieldDef", () => $6ebe99021e9a5959$export$b9c17490e825648e);
$parcel$export(module.exports, "introspectionTypes", () => $6ebe99021e9a5959$export$560bc6e8f6d098f4);
$parcel$export(module.exports, "isIntrospectionType", () => $6ebe99021e9a5959$export$e1862b156b15ce4f);

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $aKlnM = parcelRequire("aKlnM");

var $5hGV7 = parcelRequire("5hGV7");

var $cMIyS = parcelRequire("cMIyS");

var $auu22 = parcelRequire("auu22");

var $lXoEQ = parcelRequire("lXoEQ");
var $6ebe99021e9a5959$export$1f18df711f6fa0ac = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__Schema',
    description: 'A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations.',
    fields: function fields() {
        return {
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(schema) {
                    return schema.description;
                }
            },
            types: {
                description: 'A list of all types supported by this server.',
                type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7))),
                resolve: function resolve(schema) {
                    return (0, $dVq2R.default)(schema.getTypeMap());
                }
            },
            queryType: {
                description: 'The type that query operations will be rooted at.',
                type: new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7),
                resolve: function resolve(schema) {
                    return schema.getQueryType();
                }
            },
            mutationType: {
                description: 'If this server supports mutation, the type that mutation operations will be rooted at.',
                type: $6ebe99021e9a5959$export$b46ca740abcddda7,
                resolve: function resolve(schema) {
                    return schema.getMutationType();
                }
            },
            subscriptionType: {
                description: 'If this server support subscription, the type that subscription operations will be rooted at.',
                type: $6ebe99021e9a5959$export$b46ca740abcddda7,
                resolve: function resolve(schema) {
                    return schema.getSubscriptionType();
                }
            },
            directives: {
                description: 'A list of all directives supported by this server.',
                type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$2492e8c5b8ba489f))),
                resolve: function resolve(schema) {
                    return schema.getDirectives();
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$2492e8c5b8ba489f = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__Directive',
    description: "A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.\n\nIn some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.",
    fields: function fields() {
        return {
            name: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
                resolve: function resolve(directive) {
                    return directive.name;
                }
            },
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(directive) {
                    return directive.description;
                }
            },
            isRepeatable: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
                resolve: function resolve(directive) {
                    return directive.isRepeatable;
                }
            },
            locations: {
                type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$70e870c5930737d1))),
                resolve: function resolve(directive) {
                    return directive.locations;
                }
            },
            args: {
                type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$bc79df5a9719c05b))),
                args: {
                    includeDeprecated: {
                        type: (0, $auu22.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(field, _ref) {
                    var includeDeprecated = _ref.includeDeprecated;
                    return includeDeprecated ? field.args : field.args.filter(function(arg) {
                        return arg.deprecationReason == null;
                    });
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$70e870c5930737d1 = new (0, $lXoEQ.GraphQLEnumType)({
    name: '__DirectiveLocation',
    description: 'A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies.',
    values: {
        QUERY: {
            value: (0, $5hGV7.DirectiveLocation).QUERY,
            description: 'Location adjacent to a query operation.'
        },
        MUTATION: {
            value: (0, $5hGV7.DirectiveLocation).MUTATION,
            description: 'Location adjacent to a mutation operation.'
        },
        SUBSCRIPTION: {
            value: (0, $5hGV7.DirectiveLocation).SUBSCRIPTION,
            description: 'Location adjacent to a subscription operation.'
        },
        FIELD: {
            value: (0, $5hGV7.DirectiveLocation).FIELD,
            description: 'Location adjacent to a field.'
        },
        FRAGMENT_DEFINITION: {
            value: (0, $5hGV7.DirectiveLocation).FRAGMENT_DEFINITION,
            description: 'Location adjacent to a fragment definition.'
        },
        FRAGMENT_SPREAD: {
            value: (0, $5hGV7.DirectiveLocation).FRAGMENT_SPREAD,
            description: 'Location adjacent to a fragment spread.'
        },
        INLINE_FRAGMENT: {
            value: (0, $5hGV7.DirectiveLocation).INLINE_FRAGMENT,
            description: 'Location adjacent to an inline fragment.'
        },
        VARIABLE_DEFINITION: {
            value: (0, $5hGV7.DirectiveLocation).VARIABLE_DEFINITION,
            description: 'Location adjacent to a variable definition.'
        },
        SCHEMA: {
            value: (0, $5hGV7.DirectiveLocation).SCHEMA,
            description: 'Location adjacent to a schema definition.'
        },
        SCALAR: {
            value: (0, $5hGV7.DirectiveLocation).SCALAR,
            description: 'Location adjacent to a scalar definition.'
        },
        OBJECT: {
            value: (0, $5hGV7.DirectiveLocation).OBJECT,
            description: 'Location adjacent to an object type definition.'
        },
        FIELD_DEFINITION: {
            value: (0, $5hGV7.DirectiveLocation).FIELD_DEFINITION,
            description: 'Location adjacent to a field definition.'
        },
        ARGUMENT_DEFINITION: {
            value: (0, $5hGV7.DirectiveLocation).ARGUMENT_DEFINITION,
            description: 'Location adjacent to an argument definition.'
        },
        INTERFACE: {
            value: (0, $5hGV7.DirectiveLocation).INTERFACE,
            description: 'Location adjacent to an interface definition.'
        },
        UNION: {
            value: (0, $5hGV7.DirectiveLocation).UNION,
            description: 'Location adjacent to a union definition.'
        },
        ENUM: {
            value: (0, $5hGV7.DirectiveLocation).ENUM,
            description: 'Location adjacent to an enum definition.'
        },
        ENUM_VALUE: {
            value: (0, $5hGV7.DirectiveLocation).ENUM_VALUE,
            description: 'Location adjacent to an enum value definition.'
        },
        INPUT_OBJECT: {
            value: (0, $5hGV7.DirectiveLocation).INPUT_OBJECT,
            description: 'Location adjacent to an input object type definition.'
        },
        INPUT_FIELD_DEFINITION: {
            value: (0, $5hGV7.DirectiveLocation).INPUT_FIELD_DEFINITION,
            description: 'Location adjacent to an input object field definition.'
        }
    }
});
var $6ebe99021e9a5959$export$b46ca740abcddda7 = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__Type',
    description: 'The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.\n\nDepending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.',
    fields: function fields() {
        return {
            kind: {
                type: new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$163610506c99e78f),
                resolve: function resolve(type) {
                    if ((0, $lXoEQ.isScalarType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.SCALAR;
                    if ((0, $lXoEQ.isObjectType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.OBJECT;
                    if ((0, $lXoEQ.isInterfaceType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.INTERFACE;
                    if ((0, $lXoEQ.isUnionType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.UNION;
                    if ((0, $lXoEQ.isEnumType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.ENUM;
                    if ((0, $lXoEQ.isInputObjectType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.INPUT_OBJECT;
                    if ((0, $lXoEQ.isListType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.LIST;
                     // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
                    if ((0, $lXoEQ.isNonNullType)(type)) return $6ebe99021e9a5959$export$c29cf3c48471da7c.NON_NULL;
                     // istanbul ignore next (Not reachable. All possible types have been considered)
                    (0, $43MJl.default)(0, "Unexpected type: \"".concat((0, $biK02.default)(type), "\"."));
                }
            },
            name: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(type) {
                    return type.name !== undefined ? type.name : undefined;
                }
            },
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(type) {
                    return type.description !== undefined ? type.description : undefined;
                }
            },
            specifiedByUrl: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(obj) {
                    return obj.specifiedByUrl !== undefined ? obj.specifiedByUrl : undefined;
                }
            },
            fields: {
                type: new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$c93780024e419b02)),
                args: {
                    includeDeprecated: {
                        type: (0, $auu22.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(type, _ref2) {
                    var includeDeprecated = _ref2.includeDeprecated;
                    if ((0, $lXoEQ.isObjectType)(type) || (0, $lXoEQ.isInterfaceType)(type)) {
                        var fields = (0, $dVq2R.default)(type.getFields());
                        return includeDeprecated ? fields : fields.filter(function(field) {
                            return field.deprecationReason == null;
                        });
                    }
                }
            },
            interfaces: {
                type: new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7)),
                resolve: function resolve(type) {
                    if ((0, $lXoEQ.isObjectType)(type) || (0, $lXoEQ.isInterfaceType)(type)) return type.getInterfaces();
                }
            },
            possibleTypes: {
                type: new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7)),
                resolve: function resolve(type, _args, _context, _ref3) {
                    var schema = _ref3.schema;
                    if ((0, $lXoEQ.isAbstractType)(type)) return schema.getPossibleTypes(type);
                }
            },
            enumValues: {
                type: new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b93e3441ec96b29a)),
                args: {
                    includeDeprecated: {
                        type: (0, $auu22.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(type, _ref4) {
                    var includeDeprecated = _ref4.includeDeprecated;
                    if ((0, $lXoEQ.isEnumType)(type)) {
                        var values = type.getValues();
                        return includeDeprecated ? values : values.filter(function(field) {
                            return field.deprecationReason == null;
                        });
                    }
                }
            },
            inputFields: {
                type: new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$bc79df5a9719c05b)),
                args: {
                    includeDeprecated: {
                        type: (0, $auu22.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(type, _ref5) {
                    var includeDeprecated = _ref5.includeDeprecated;
                    if ((0, $lXoEQ.isInputObjectType)(type)) {
                        var values = (0, $dVq2R.default)(type.getFields());
                        return includeDeprecated ? values : values.filter(function(field) {
                            return field.deprecationReason == null;
                        });
                    }
                }
            },
            ofType: {
                type: $6ebe99021e9a5959$export$b46ca740abcddda7,
                resolve: function resolve(type) {
                    return type.ofType !== undefined ? type.ofType : undefined;
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$c93780024e419b02 = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__Field',
    description: 'Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type.',
    fields: function fields() {
        return {
            name: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
                resolve: function resolve(field) {
                    return field.name;
                }
            },
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(field) {
                    return field.description;
                }
            },
            args: {
                type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$bc79df5a9719c05b))),
                args: {
                    includeDeprecated: {
                        type: (0, $auu22.GraphQLBoolean),
                        defaultValue: false
                    }
                },
                resolve: function resolve(field, _ref6) {
                    var includeDeprecated = _ref6.includeDeprecated;
                    return includeDeprecated ? field.args : field.args.filter(function(arg) {
                        return arg.deprecationReason == null;
                    });
                }
            },
            type: {
                type: new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7),
                resolve: function resolve(field) {
                    return field.type;
                }
            },
            isDeprecated: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
                resolve: function resolve(field) {
                    return field.deprecationReason != null;
                }
            },
            deprecationReason: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(field) {
                    return field.deprecationReason;
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$bc79df5a9719c05b = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__InputValue',
    description: 'Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value.',
    fields: function fields() {
        return {
            name: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
                resolve: function resolve(inputValue) {
                    return inputValue.name;
                }
            },
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(inputValue) {
                    return inputValue.description;
                }
            },
            type: {
                type: new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$b46ca740abcddda7),
                resolve: function resolve(inputValue) {
                    return inputValue.type;
                }
            },
            defaultValue: {
                type: (0, $auu22.GraphQLString),
                description: 'A GraphQL-formatted string representing the default value for this input value.',
                resolve: function resolve(inputValue) {
                    var type = inputValue.type, defaultValue = inputValue.defaultValue;
                    var valueAST = (0, $cMIyS.astFromValue)(defaultValue, type);
                    return valueAST ? (0, $aKlnM.print)(valueAST) : null;
                }
            },
            isDeprecated: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
                resolve: function resolve(field) {
                    return field.deprecationReason != null;
                }
            },
            deprecationReason: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(obj) {
                    return obj.deprecationReason;
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$b93e3441ec96b29a = new (0, $lXoEQ.GraphQLObjectType)({
    name: '__EnumValue',
    description: 'One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string.',
    fields: function fields() {
        return {
            name: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
                resolve: function resolve(enumValue) {
                    return enumValue.name;
                }
            },
            description: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(enumValue) {
                    return enumValue.description;
                }
            },
            isDeprecated: {
                type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
                resolve: function resolve(enumValue) {
                    return enumValue.deprecationReason != null;
                }
            },
            deprecationReason: {
                type: (0, $auu22.GraphQLString),
                resolve: function resolve(enumValue) {
                    return enumValue.deprecationReason;
                }
            }
        };
    }
});
var $6ebe99021e9a5959$export$c29cf3c48471da7c = Object.freeze({
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    INPUT_OBJECT: 'INPUT_OBJECT',
    LIST: 'LIST',
    NON_NULL: 'NON_NULL'
});
var $6ebe99021e9a5959$export$163610506c99e78f = new (0, $lXoEQ.GraphQLEnumType)({
    name: '__TypeKind',
    description: 'An enum describing what kind of type a given `__Type` is.',
    values: {
        SCALAR: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.SCALAR,
            description: 'Indicates this type is a scalar.'
        },
        OBJECT: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.OBJECT,
            description: 'Indicates this type is an object. `fields` and `interfaces` are valid fields.'
        },
        INTERFACE: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.INTERFACE,
            description: 'Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields.'
        },
        UNION: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.UNION,
            description: 'Indicates this type is a union. `possibleTypes` is a valid field.'
        },
        ENUM: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.ENUM,
            description: 'Indicates this type is an enum. `enumValues` is a valid field.'
        },
        INPUT_OBJECT: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.INPUT_OBJECT,
            description: 'Indicates this type is an input object. `inputFields` is a valid field.'
        },
        LIST: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.LIST,
            description: 'Indicates this type is a list. `ofType` is a valid field.'
        },
        NON_NULL: {
            value: $6ebe99021e9a5959$export$c29cf3c48471da7c.NON_NULL,
            description: 'Indicates this type is a non-null. `ofType` is a valid field.'
        }
    }
});
var $6ebe99021e9a5959$export$36ed059ad2080404 = {
    name: '__schema',
    type: new (0, $lXoEQ.GraphQLNonNull)($6ebe99021e9a5959$export$1f18df711f6fa0ac),
    description: 'Access the current type schema of this server.',
    args: [],
    resolve: function resolve(_source, _args, _context, _ref7) {
        var schema = _ref7.schema;
        return schema;
    },
    isDeprecated: false,
    deprecationReason: undefined,
    extensions: undefined,
    astNode: undefined
};
var $6ebe99021e9a5959$export$87a968d084148b61 = {
    name: '__type',
    type: $6ebe99021e9a5959$export$b46ca740abcddda7,
    description: 'Request the type information of a single type.',
    args: [
        {
            name: 'name',
            description: undefined,
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
            defaultValue: undefined,
            deprecationReason: undefined,
            extensions: undefined,
            astNode: undefined
        }
    ],
    resolve: function resolve(_source, _ref8, _context, _ref9) {
        var name = _ref8.name;
        var schema = _ref9.schema;
        return schema.getType(name);
    },
    isDeprecated: false,
    deprecationReason: undefined,
    extensions: undefined,
    astNode: undefined
};
var $6ebe99021e9a5959$export$b9c17490e825648e = {
    name: '__typename',
    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
    description: 'The name of the current Object type at runtime.',
    args: [],
    resolve: function resolve(_source, _args, _context, _ref10) {
        var parentType = _ref10.parentType;
        return parentType.name;
    },
    isDeprecated: false,
    deprecationReason: undefined,
    extensions: undefined,
    astNode: undefined
};
var $6ebe99021e9a5959$export$560bc6e8f6d098f4 = Object.freeze([
    $6ebe99021e9a5959$export$1f18df711f6fa0ac,
    $6ebe99021e9a5959$export$2492e8c5b8ba489f,
    $6ebe99021e9a5959$export$70e870c5930737d1,
    $6ebe99021e9a5959$export$b46ca740abcddda7,
    $6ebe99021e9a5959$export$c93780024e419b02,
    $6ebe99021e9a5959$export$bc79df5a9719c05b,
    $6ebe99021e9a5959$export$b93e3441ec96b29a,
    $6ebe99021e9a5959$export$163610506c99e78f
]);
function $6ebe99021e9a5959$export$e1862b156b15ce4f(type) {
    return $6ebe99021e9a5959$export$560bc6e8f6d098f4.some(function(_ref11) {
        var name = _ref11.name;
        return type.name === name;
    });
}

});
parcelRegister("cMIyS", function(module, exports) {

$parcel$export(module.exports, "astFromValue", () => $8815f467872381b8$export$973c016b19737b40);

var $2ajMd = parcelRequire("2ajMd");

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $fbtyx = parcelRequire("fbtyx");

var $8DMvn = parcelRequire("8DMvn");

var $1c4hI = parcelRequire("1c4hI");

var $auu22 = parcelRequire("auu22");

var $lXoEQ = parcelRequire("lXoEQ");
function $8815f467872381b8$export$973c016b19737b40(value, type) {
    if ((0, $lXoEQ.isNonNullType)(type)) {
        var astValue = $8815f467872381b8$export$973c016b19737b40(value, type.ofType);
        if ((astValue === null || astValue === void 0 ? void 0 : astValue.kind) === (0, $1c4hI.Kind).NULL) return null;
        return astValue;
    } // only explicit null, not undefined, NaN
    if (value === null) return {
        kind: (0, $1c4hI.Kind).NULL
    };
     // undefined
    if (value === undefined) return null;
     // Convert JavaScript array to GraphQL list. If the GraphQLType is a list, but
    // the value is not an array, convert the value using the list's item type.
    if ((0, $lXoEQ.isListType)(type)) {
        var itemType = type.ofType;
        var items = (0, $8DMvn.default)(value);
        if (items != null) {
            var valuesNodes = [];
            for(var _i2 = 0; _i2 < items.length; _i2++){
                var item = items[_i2];
                var itemNode = $8815f467872381b8$export$973c016b19737b40(item, itemType);
                if (itemNode != null) valuesNodes.push(itemNode);
            }
            return {
                kind: (0, $1c4hI.Kind).LIST,
                values: valuesNodes
            };
        }
        return $8815f467872381b8$export$973c016b19737b40(value, itemType);
    } // Populate the fields of the input object by creating ASTs from each value
    // in the JavaScript object according to the fields in the input type.
    if ((0, $lXoEQ.isInputObjectType)(type)) {
        if (!(0, $fbtyx.default)(value)) return null;
        var fieldNodes = [];
        for(var _i4 = 0, _objectValues2 = (0, $dVq2R.default)(type.getFields()); _i4 < _objectValues2.length; _i4++){
            var field = _objectValues2[_i4];
            var fieldValue = $8815f467872381b8$export$973c016b19737b40(value[field.name], field.type);
            if (fieldValue) fieldNodes.push({
                kind: (0, $1c4hI.Kind).OBJECT_FIELD,
                name: {
                    kind: (0, $1c4hI.Kind).NAME,
                    value: field.name
                },
                value: fieldValue
            });
        }
        return {
            kind: (0, $1c4hI.Kind).OBJECT,
            fields: fieldNodes
        };
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isLeafType)(type)) {
        // Since value is an internally represented value, it must be serialized
        // to an externally represented value before converting into an AST.
        var serialized = type.serialize(value);
        if (serialized == null) return null;
         // Others serialize based on their corresponding JavaScript scalar types.
        if (typeof serialized === 'boolean') return {
            kind: (0, $1c4hI.Kind).BOOLEAN,
            value: serialized
        };
         // JavaScript numbers can be Int or Float values.
        if (typeof serialized === 'number' && (0, $2ajMd.default)(serialized)) {
            var stringNum = String(serialized);
            return $8815f467872381b8$var$integerStringRegExp.test(stringNum) ? {
                kind: (0, $1c4hI.Kind).INT,
                value: stringNum
            } : {
                kind: (0, $1c4hI.Kind).FLOAT,
                value: stringNum
            };
        }
        if (typeof serialized === 'string') {
            // Enum types use Enum literals.
            if ((0, $lXoEQ.isEnumType)(type)) return {
                kind: (0, $1c4hI.Kind).ENUM,
                value: serialized
            };
             // ID types can use Int literals.
            if (type === (0, $auu22.GraphQLID) && $8815f467872381b8$var$integerStringRegExp.test(serialized)) return {
                kind: (0, $1c4hI.Kind).INT,
                value: serialized
            };
            return {
                kind: (0, $1c4hI.Kind).STRING,
                value: serialized
            };
        }
        throw new TypeError("Cannot convert value to AST: ".concat((0, $biK02.default)(serialized), "."));
    } // istanbul ignore next (Not reachable. All possible input types have been considered)
    (0, $43MJl.default)(0, 'Unexpected input type: ' + (0, $biK02.default)(type));
}
/**
 * IntValue:
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit ( Digit+ )?
 */ var $8815f467872381b8$var$integerStringRegExp = /^-?(?:0|[1-9][0-9]*)$/;

});
parcelRegister("2ajMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec3464f8e85982de$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var $ec3464f8e85982de$var$isFinitePolyfill = Number.isFinite || function(value) {
    return typeof value === 'number' && isFinite(value);
};
var $ec3464f8e85982de$export$2e2bcd8739ae039 = $ec3464f8e85982de$var$isFinitePolyfill;

});

parcelRegister("auu22", function(module, exports) {

$parcel$export(module.exports, "GraphQLInt", () => $b7a726a9eae6fb8d$export$4d4383325330928b);
$parcel$export(module.exports, "GraphQLFloat", () => $b7a726a9eae6fb8d$export$3b54cc45efb7ef0d);
$parcel$export(module.exports, "GraphQLString", () => $b7a726a9eae6fb8d$export$bf00325280f7630c);
$parcel$export(module.exports, "GraphQLBoolean", () => $b7a726a9eae6fb8d$export$bcd144a2158fe517);
$parcel$export(module.exports, "GraphQLID", () => $b7a726a9eae6fb8d$export$530df982af95a879);
$parcel$export(module.exports, "specifiedScalarTypes", () => $b7a726a9eae6fb8d$export$5df80378609411b9);
$parcel$export(module.exports, "isSpecifiedScalarType", () => $b7a726a9eae6fb8d$export$5d6bb1cb0ae296ca);

var $2ajMd = parcelRequire("2ajMd");

var $nUGRp = parcelRequire("nUGRp");

var $biK02 = parcelRequire("biK02");

var $fbtyx = parcelRequire("fbtyx");

var $1c4hI = parcelRequire("1c4hI");

var $aKlnM = parcelRequire("aKlnM");

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
// 32-bit signed integer, providing the broadest support across platforms.
//
// n.b. JavaScript's integers are safe between -(2^53 - 1) and 2^53 - 1 because
// they are internally represented as IEEE 754 doubles.
var $b7a726a9eae6fb8d$var$MAX_INT = 2147483647;
var $b7a726a9eae6fb8d$var$MIN_INT = -2147483648;
function $b7a726a9eae6fb8d$var$serializeInt(outputValue) {
    var coercedValue = $b7a726a9eae6fb8d$var$serializeObject(outputValue);
    if (typeof coercedValue === 'boolean') return coercedValue ? 1 : 0;
    var num = coercedValue;
    if (typeof coercedValue === 'string' && coercedValue !== '') num = Number(coercedValue);
    if (!(0, $nUGRp.default)(num)) throw new (0, $9fgMZ.GraphQLError)("Int cannot represent non-integer value: ".concat((0, $biK02.default)(coercedValue)));
    if (num > $b7a726a9eae6fb8d$var$MAX_INT || num < $b7a726a9eae6fb8d$var$MIN_INT) throw new (0, $9fgMZ.GraphQLError)('Int cannot represent non 32-bit signed integer value: ' + (0, $biK02.default)(coercedValue));
    return num;
}
function $b7a726a9eae6fb8d$var$coerceInt(inputValue) {
    if (!(0, $nUGRp.default)(inputValue)) throw new (0, $9fgMZ.GraphQLError)("Int cannot represent non-integer value: ".concat((0, $biK02.default)(inputValue)));
    if (inputValue > $b7a726a9eae6fb8d$var$MAX_INT || inputValue < $b7a726a9eae6fb8d$var$MIN_INT) throw new (0, $9fgMZ.GraphQLError)("Int cannot represent non 32-bit signed integer value: ".concat(inputValue));
    return inputValue;
}
var $b7a726a9eae6fb8d$export$4d4383325330928b = new (0, $lXoEQ.GraphQLScalarType)({
    name: 'Int',
    description: 'The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.',
    serialize: $b7a726a9eae6fb8d$var$serializeInt,
    parseValue: $b7a726a9eae6fb8d$var$coerceInt,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $1c4hI.Kind).INT) throw new (0, $9fgMZ.GraphQLError)("Int cannot represent non-integer value: ".concat((0, $aKlnM.print)(valueNode)), valueNode);
        var num = parseInt(valueNode.value, 10);
        if (num > $b7a726a9eae6fb8d$var$MAX_INT || num < $b7a726a9eae6fb8d$var$MIN_INT) throw new (0, $9fgMZ.GraphQLError)("Int cannot represent non 32-bit signed integer value: ".concat(valueNode.value), valueNode);
        return num;
    }
});
function $b7a726a9eae6fb8d$var$serializeFloat(outputValue) {
    var coercedValue = $b7a726a9eae6fb8d$var$serializeObject(outputValue);
    if (typeof coercedValue === 'boolean') return coercedValue ? 1 : 0;
    var num = coercedValue;
    if (typeof coercedValue === 'string' && coercedValue !== '') num = Number(coercedValue);
    if (!(0, $2ajMd.default)(num)) throw new (0, $9fgMZ.GraphQLError)("Float cannot represent non numeric value: ".concat((0, $biK02.default)(coercedValue)));
    return num;
}
function $b7a726a9eae6fb8d$var$coerceFloat(inputValue) {
    if (!(0, $2ajMd.default)(inputValue)) throw new (0, $9fgMZ.GraphQLError)("Float cannot represent non numeric value: ".concat((0, $biK02.default)(inputValue)));
    return inputValue;
}
var $b7a726a9eae6fb8d$export$3b54cc45efb7ef0d = new (0, $lXoEQ.GraphQLScalarType)({
    name: 'Float',
    description: 'The `Float` scalar type represents signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point).',
    serialize: $b7a726a9eae6fb8d$var$serializeFloat,
    parseValue: $b7a726a9eae6fb8d$var$coerceFloat,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $1c4hI.Kind).FLOAT && valueNode.kind !== (0, $1c4hI.Kind).INT) throw new (0, $9fgMZ.GraphQLError)("Float cannot represent non numeric value: ".concat((0, $aKlnM.print)(valueNode)), valueNode);
        return parseFloat(valueNode.value);
    }
}); // Support serializing objects with custom valueOf() or toJSON() functions -
// a common way to represent a complex value which can be represented as
// a string (ex: MongoDB id objects).
function $b7a726a9eae6fb8d$var$serializeObject(outputValue) {
    if ((0, $fbtyx.default)(outputValue)) {
        if (typeof outputValue.valueOf === 'function') {
            var valueOfResult = outputValue.valueOf();
            if (!(0, $fbtyx.default)(valueOfResult)) return valueOfResult;
        }
        if (typeof outputValue.toJSON === 'function') // $FlowFixMe[incompatible-use]
        return outputValue.toJSON();
    }
    return outputValue;
}
function $b7a726a9eae6fb8d$var$serializeString(outputValue) {
    var coercedValue = $b7a726a9eae6fb8d$var$serializeObject(outputValue); // Serialize string, boolean and number values to a string, but do not
    // attempt to coerce object, function, symbol, or other types as strings.
    if (typeof coercedValue === 'string') return coercedValue;
    if (typeof coercedValue === 'boolean') return coercedValue ? 'true' : 'false';
    if ((0, $2ajMd.default)(coercedValue)) return coercedValue.toString();
    throw new (0, $9fgMZ.GraphQLError)("String cannot represent value: ".concat((0, $biK02.default)(outputValue)));
}
function $b7a726a9eae6fb8d$var$coerceString(inputValue) {
    if (typeof inputValue !== 'string') throw new (0, $9fgMZ.GraphQLError)("String cannot represent a non string value: ".concat((0, $biK02.default)(inputValue)));
    return inputValue;
}
var $b7a726a9eae6fb8d$export$bf00325280f7630c = new (0, $lXoEQ.GraphQLScalarType)({
    name: 'String',
    description: 'The `String` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.',
    serialize: $b7a726a9eae6fb8d$var$serializeString,
    parseValue: $b7a726a9eae6fb8d$var$coerceString,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $1c4hI.Kind).STRING) throw new (0, $9fgMZ.GraphQLError)("String cannot represent a non string value: ".concat((0, $aKlnM.print)(valueNode)), valueNode);
        return valueNode.value;
    }
});
function $b7a726a9eae6fb8d$var$serializeBoolean(outputValue) {
    var coercedValue = $b7a726a9eae6fb8d$var$serializeObject(outputValue);
    if (typeof coercedValue === 'boolean') return coercedValue;
    if ((0, $2ajMd.default)(coercedValue)) return coercedValue !== 0;
    throw new (0, $9fgMZ.GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, $biK02.default)(coercedValue)));
}
function $b7a726a9eae6fb8d$var$coerceBoolean(inputValue) {
    if (typeof inputValue !== 'boolean') throw new (0, $9fgMZ.GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, $biK02.default)(inputValue)));
    return inputValue;
}
var $b7a726a9eae6fb8d$export$bcd144a2158fe517 = new (0, $lXoEQ.GraphQLScalarType)({
    name: 'Boolean',
    description: 'The `Boolean` scalar type represents `true` or `false`.',
    serialize: $b7a726a9eae6fb8d$var$serializeBoolean,
    parseValue: $b7a726a9eae6fb8d$var$coerceBoolean,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $1c4hI.Kind).BOOLEAN) throw new (0, $9fgMZ.GraphQLError)("Boolean cannot represent a non boolean value: ".concat((0, $aKlnM.print)(valueNode)), valueNode);
        return valueNode.value;
    }
});
function $b7a726a9eae6fb8d$var$serializeID(outputValue) {
    var coercedValue = $b7a726a9eae6fb8d$var$serializeObject(outputValue);
    if (typeof coercedValue === 'string') return coercedValue;
    if ((0, $nUGRp.default)(coercedValue)) return String(coercedValue);
    throw new (0, $9fgMZ.GraphQLError)("ID cannot represent value: ".concat((0, $biK02.default)(outputValue)));
}
function $b7a726a9eae6fb8d$var$coerceID(inputValue) {
    if (typeof inputValue === 'string') return inputValue;
    if ((0, $nUGRp.default)(inputValue)) return inputValue.toString();
    throw new (0, $9fgMZ.GraphQLError)("ID cannot represent value: ".concat((0, $biK02.default)(inputValue)));
}
var $b7a726a9eae6fb8d$export$530df982af95a879 = new (0, $lXoEQ.GraphQLScalarType)({
    name: 'ID',
    description: 'The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `"4"`) or integer (such as `4`) input value will be accepted as an ID.',
    serialize: $b7a726a9eae6fb8d$var$serializeID,
    parseValue: $b7a726a9eae6fb8d$var$coerceID,
    parseLiteral: function parseLiteral(valueNode) {
        if (valueNode.kind !== (0, $1c4hI.Kind).STRING && valueNode.kind !== (0, $1c4hI.Kind).INT) throw new (0, $9fgMZ.GraphQLError)('ID cannot represent a non-string and non-integer value: ' + (0, $aKlnM.print)(valueNode), valueNode);
        return valueNode.value;
    }
});
var $b7a726a9eae6fb8d$export$5df80378609411b9 = Object.freeze([
    $b7a726a9eae6fb8d$export$bf00325280f7630c,
    $b7a726a9eae6fb8d$export$4d4383325330928b,
    $b7a726a9eae6fb8d$export$3b54cc45efb7ef0d,
    $b7a726a9eae6fb8d$export$bcd144a2158fe517,
    $b7a726a9eae6fb8d$export$530df982af95a879
]);
function $b7a726a9eae6fb8d$export$5d6bb1cb0ae296ca(type) {
    return $b7a726a9eae6fb8d$export$5df80378609411b9.some(function(_ref) {
        var name = _ref.name;
        return type.name === name;
    });
}

});
parcelRegister("nUGRp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c759a73a7c0b3364$export$2e2bcd8739ae039);
/* eslint-disable no-redeclare */ // $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var $c759a73a7c0b3364$var$isInteger = Number.isInteger || function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};
var $c759a73a7c0b3364$export$2e2bcd8739ae039 = $c759a73a7c0b3364$var$isInteger;

});




parcelRegister("bOniD", function(module, exports) {

$parcel$export(module.exports, "isDirective", () => $68b3a31c3f813eb2$export$4b5d79f26e0e3ad5);
$parcel$export(module.exports, "GraphQLDirective", () => $68b3a31c3f813eb2$export$90407e48aac654e9);
$parcel$export(module.exports, "GraphQLIncludeDirective", () => $68b3a31c3f813eb2$export$f92fb5dbf075dbee);
$parcel$export(module.exports, "GraphQLSkipDirective", () => $68b3a31c3f813eb2$export$7adbe9be7084cfe3);
$parcel$export(module.exports, "DEFAULT_DEPRECATION_REASON", () => $68b3a31c3f813eb2$export$15edbda76f1f9a89);
$parcel$export(module.exports, "GraphQLDeprecatedDirective", () => $68b3a31c3f813eb2$export$ed64f8040ac801d1);
$parcel$export(module.exports, "GraphQLSpecifiedByDirective", () => $68b3a31c3f813eb2$export$26ce3cf10bb75d41);
$parcel$export(module.exports, "specifiedDirectives", () => $68b3a31c3f813eb2$export$c48d2e3f4e034403);
$parcel$export(module.exports, "isSpecifiedDirective", () => $68b3a31c3f813eb2$export$7d2e48434602f4fe);

var $apet0 = parcelRequire("apet0");

var $gwa3m = parcelRequire("gwa3m");

var $biK02 = parcelRequire("biK02");

var $eCJ4z = parcelRequire("eCJ4z");

var $fZdRY = parcelRequire("fZdRY");

var $aVhwC = parcelRequire("aVhwC");

var $fbtyx = parcelRequire("fbtyx");

var $51GHS = parcelRequire("51GHS");

var $5hGV7 = parcelRequire("5hGV7");

var $auu22 = parcelRequire("auu22");

var $lXoEQ = parcelRequire("lXoEQ");
function $68b3a31c3f813eb2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $68b3a31c3f813eb2$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $68b3a31c3f813eb2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $68b3a31c3f813eb2$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $68b3a31c3f813eb2$export$4b5d79f26e0e3ad5(directive) {
    return (0, $aVhwC.default)(directive, $68b3a31c3f813eb2$export$90407e48aac654e9);
}
function $68b3a31c3f813eb2$export$976bef3b79eaee5d(directive) {
    if (!$68b3a31c3f813eb2$export$4b5d79f26e0e3ad5(directive)) throw new Error("Expected ".concat((0, $biK02.default)(directive), " to be a GraphQL directive."));
    return directive;
}
var $68b3a31c3f813eb2$export$90407e48aac654e9 = /*#__PURE__*/ function() {
    function GraphQLDirective(config) {
        var _config$isRepeatable, _config$args;
        this.name = config.name;
        this.description = config.description;
        this.locations = config.locations;
        this.isRepeatable = (_config$isRepeatable = config.isRepeatable) !== null && _config$isRepeatable !== void 0 ? _config$isRepeatable : false;
        this.extensions = config.extensions && (0, $eCJ4z.default)(config.extensions);
        this.astNode = config.astNode;
        config.name || (0, $fZdRY.default)(0, 'Directive must be named.');
        Array.isArray(config.locations) || (0, $fZdRY.default)(0, "@".concat(config.name, " locations must be an Array."));
        var args = (_config$args = config.args) !== null && _config$args !== void 0 ? _config$args : {};
        (0, $fbtyx.default)(args) && !Array.isArray(args) || (0, $fZdRY.default)(0, "@".concat(config.name, " args must be an object with argument names as keys."));
        this.args = (0, $apet0.default)(args).map(function(_ref) {
            var argName = _ref[0], argConfig = _ref[1];
            return {
                name: argName,
                description: argConfig.description,
                type: argConfig.type,
                defaultValue: argConfig.defaultValue,
                deprecationReason: argConfig.deprecationReason,
                extensions: argConfig.extensions && (0, $eCJ4z.default)(argConfig.extensions),
                astNode: argConfig.astNode
            };
        });
    }
    var _proto = GraphQLDirective.prototype;
    _proto.toConfig = function toConfig() {
        return {
            name: this.name,
            description: this.description,
            locations: this.locations,
            args: (0, $lXoEQ.argsToArgsConfig)(this.args),
            isRepeatable: this.isRepeatable,
            extensions: this.extensions,
            astNode: this.astNode
        };
    };
    _proto.toString = function toString() {
        return '@' + this.name;
    };
    _proto.toJSON = function toJSON() {
        return this.toString();
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    ;
    $68b3a31c3f813eb2$var$_createClass(GraphQLDirective, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'GraphQLDirective';
            }
        }
    ]);
    return GraphQLDirective;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($68b3a31c3f813eb2$export$90407e48aac654e9);
var $68b3a31c3f813eb2$export$f92fb5dbf075dbee = new $68b3a31c3f813eb2$export$90407e48aac654e9({
    name: 'include',
    description: 'Directs the executor to include this field or fragment only when the `if` argument is true.',
    locations: [
        (0, $5hGV7.DirectiveLocation).FIELD,
        (0, $5hGV7.DirectiveLocation).FRAGMENT_SPREAD,
        (0, $5hGV7.DirectiveLocation).INLINE_FRAGMENT
    ],
    args: {
        if: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
            description: 'Included when true.'
        }
    }
});
var $68b3a31c3f813eb2$export$7adbe9be7084cfe3 = new $68b3a31c3f813eb2$export$90407e48aac654e9({
    name: 'skip',
    description: 'Directs the executor to skip this field or fragment when the `if` argument is true.',
    locations: [
        (0, $5hGV7.DirectiveLocation).FIELD,
        (0, $5hGV7.DirectiveLocation).FRAGMENT_SPREAD,
        (0, $5hGV7.DirectiveLocation).INLINE_FRAGMENT
    ],
    args: {
        if: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean)),
            description: 'Skipped when true.'
        }
    }
});
var $68b3a31c3f813eb2$export$15edbda76f1f9a89 = 'No longer supported';
var $68b3a31c3f813eb2$export$ed64f8040ac801d1 = new $68b3a31c3f813eb2$export$90407e48aac654e9({
    name: 'deprecated',
    description: 'Marks an element of a GraphQL schema as no longer supported.',
    locations: [
        (0, $5hGV7.DirectiveLocation).FIELD_DEFINITION,
        (0, $5hGV7.DirectiveLocation).ARGUMENT_DEFINITION,
        (0, $5hGV7.DirectiveLocation).INPUT_FIELD_DEFINITION,
        (0, $5hGV7.DirectiveLocation).ENUM_VALUE
    ],
    args: {
        reason: {
            type: (0, $auu22.GraphQLString),
            description: 'Explains why this element was deprecated, usually also including a suggestion for how to access supported similar data. Formatted using the Markdown syntax, as specified by [CommonMark](https://commonmark.org/).',
            defaultValue: $68b3a31c3f813eb2$export$15edbda76f1f9a89
        }
    }
});
var $68b3a31c3f813eb2$export$26ce3cf10bb75d41 = new $68b3a31c3f813eb2$export$90407e48aac654e9({
    name: 'specifiedBy',
    description: 'Exposes a URL that specifies the behaviour of this scalar.',
    locations: [
        (0, $5hGV7.DirectiveLocation).SCALAR
    ],
    args: {
        url: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString)),
            description: 'The URL that specifies the behaviour of this scalar.'
        }
    }
});
var $68b3a31c3f813eb2$export$c48d2e3f4e034403 = Object.freeze([
    $68b3a31c3f813eb2$export$f92fb5dbf075dbee,
    $68b3a31c3f813eb2$export$7adbe9be7084cfe3,
    $68b3a31c3f813eb2$export$ed64f8040ac801d1,
    $68b3a31c3f813eb2$export$26ce3cf10bb75d41
]);
function $68b3a31c3f813eb2$export$7d2e48434602f4fe(directive) {
    return $68b3a31c3f813eb2$export$c48d2e3f4e034403.some(function(_ref2) {
        var name = _ref2.name;
        return name === directive.name;
    });
}

});



parcelRegister("3zSAT", function(module, exports) {

$parcel$export(module.exports, "typeFromAST", () => $a77d3e2f56140695$export$292685f75a322892);

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $1c4hI = parcelRequire("1c4hI");

var $lXoEQ = parcelRequire("lXoEQ");
function $a77d3e2f56140695$export$292685f75a322892(schema, typeNode) {
    /* eslint-enable no-redeclare */ var innerType;
    if (typeNode.kind === (0, $1c4hI.Kind).LIST_TYPE) {
        innerType = $a77d3e2f56140695$export$292685f75a322892(schema, typeNode.type);
        return innerType && new (0, $lXoEQ.GraphQLList)(innerType);
    }
    if (typeNode.kind === (0, $1c4hI.Kind).NON_NULL_TYPE) {
        innerType = $a77d3e2f56140695$export$292685f75a322892(schema, typeNode.type);
        return innerType && new (0, $lXoEQ.GraphQLNonNull)(innerType);
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if (typeNode.kind === (0, $1c4hI.Kind).NAMED_TYPE) return schema.getType(typeNode.name.value);
     // istanbul ignore next (Not reachable. All possible type nodes have been considered)
    (0, $43MJl.default)(0, 'Unexpected type node: ' + (0, $biK02.default)(typeNode));
}

});

parcelRegister("bis9F", function(module, exports) {

$parcel$export(module.exports, "getOperationRootType", () => $508b1182b247a60e$export$f5bcbf8a32f314e5);

var $9fgMZ = parcelRequire("9fgMZ");
function $508b1182b247a60e$export$f5bcbf8a32f314e5(schema, operation) {
    if (operation.operation === 'query') {
        var queryType = schema.getQueryType();
        if (!queryType) throw new (0, $9fgMZ.GraphQLError)('Schema does not define the required query root type.', operation);
        return queryType;
    }
    if (operation.operation === 'mutation') {
        var mutationType = schema.getMutationType();
        if (!mutationType) throw new (0, $9fgMZ.GraphQLError)('Schema is not configured for mutations.', operation);
        return mutationType;
    }
    if (operation.operation === 'subscription') {
        var subscriptionType = schema.getSubscriptionType();
        if (!subscriptionType) throw new (0, $9fgMZ.GraphQLError)('Schema is not configured for subscriptions.', operation);
        return subscriptionType;
    }
    throw new (0, $9fgMZ.GraphQLError)('Can only have query, mutation and subscription operations.', operation);
}

});

parcelRegister("gqGQB", function(module, exports) {

$parcel$export(module.exports, "getVariableValues", () => $b695b1e556e9787e$export$2038fbf5c9bccf57);
$parcel$export(module.exports, "getArgumentValues", () => $b695b1e556e9787e$export$5af04a8495f7ef54);
$parcel$export(module.exports, "getDirectiveValues", () => $b695b1e556e9787e$export$1f7174681493b2aa);

var $bmIpK = parcelRequire("bmIpK");

var $hbiEd = parcelRequire("hbiEd");

var $biK02 = parcelRequire("biK02");

var $laAus = parcelRequire("laAus");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $aKlnM = parcelRequire("aKlnM");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");

var $3E0nn = parcelRequire("3E0nn");

var $dEek8 = parcelRequire("dEek8");
function $b695b1e556e9787e$export$2038fbf5c9bccf57(schema, varDefNodes, inputs, options) {
    var errors = [];
    var maxErrors = options === null || options === void 0 ? void 0 : options.maxErrors;
    try {
        var coerced = $b695b1e556e9787e$var$coerceVariableValues(schema, varDefNodes, inputs, function(error) {
            if (maxErrors != null && errors.length >= maxErrors) throw new (0, $9fgMZ.GraphQLError)('Too many errors processing variables, error limit reached. Execution aborted.');
            errors.push(error);
        });
        if (errors.length === 0) return {
            coerced: coerced
        };
    } catch (error) {
        errors.push(error);
    }
    return {
        errors: errors
    };
}
function $b695b1e556e9787e$var$coerceVariableValues(schema, varDefNodes, inputs, onError) {
    var coercedValues = {};
    var _loop = function _loop(_i2) {
        var varDefNode = varDefNodes[_i2];
        var varName = varDefNode.variable.name.value;
        var varType = (0, $3zSAT.typeFromAST)(schema, varDefNode.type);
        if (!(0, $lXoEQ.isInputType)(varType)) {
            // Must use input types for variables. This should be caught during
            // validation, however is checked again here for safety.
            var varTypeStr = (0, $aKlnM.print)(varDefNode.type);
            onError(new (0, $9fgMZ.GraphQLError)("Variable \"$".concat(varName, "\" expected value of type \"").concat(varTypeStr, "\" which cannot be used as an input type."), varDefNode.type));
            return "continue";
        }
        if (!$b695b1e556e9787e$var$hasOwnProperty(inputs, varName)) {
            if (varDefNode.defaultValue) coercedValues[varName] = (0, $3E0nn.valueFromAST)(varDefNode.defaultValue, varType);
            else if ((0, $lXoEQ.isNonNullType)(varType)) {
                var _varTypeStr = (0, $biK02.default)(varType);
                onError(new (0, $9fgMZ.GraphQLError)("Variable \"$".concat(varName, "\" of required type \"").concat(_varTypeStr, "\" was not provided."), varDefNode));
            }
            return "continue";
        }
        var value = inputs[varName];
        if (value === null && (0, $lXoEQ.isNonNullType)(varType)) {
            var _varTypeStr2 = (0, $biK02.default)(varType);
            onError(new (0, $9fgMZ.GraphQLError)("Variable \"$".concat(varName, "\" of non-null type \"").concat(_varTypeStr2, "\" must not be null."), varDefNode));
            return "continue";
        }
        coercedValues[varName] = (0, $dEek8.coerceInputValue)(value, varType, function(path, invalidValue, error) {
            var prefix = "Variable \"$".concat(varName, "\" got invalid value ") + (0, $biK02.default)(invalidValue);
            if (path.length > 0) prefix += " at \"".concat(varName).concat((0, $laAus.default)(path), "\"");
            onError(new (0, $9fgMZ.GraphQLError)(prefix + '; ' + error.message, varDefNode, undefined, undefined, undefined, error.originalError));
        });
    };
    for(var _i2 = 0; _i2 < varDefNodes.length; _i2++){
        var _ret = _loop(_i2);
        if (_ret === "continue") continue;
    }
    return coercedValues;
}
function $b695b1e556e9787e$export$5af04a8495f7ef54(def, node, variableValues) {
    var _node$arguments;
    var coercedValues = {}; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    var argumentNodes = (_node$arguments = node.arguments) !== null && _node$arguments !== void 0 ? _node$arguments : [];
    var argNodeMap = (0, $hbiEd.default)(argumentNodes, function(arg) {
        return arg.name.value;
    });
    for(var _i4 = 0, _def$args2 = def.args; _i4 < _def$args2.length; _i4++){
        var argDef = _def$args2[_i4];
        var name = argDef.name;
        var argType = argDef.type;
        var argumentNode = argNodeMap[name];
        if (!argumentNode) {
            if (argDef.defaultValue !== undefined) coercedValues[name] = argDef.defaultValue;
            else if ((0, $lXoEQ.isNonNullType)(argType)) throw new (0, $9fgMZ.GraphQLError)("Argument \"".concat(name, "\" of required type \"").concat((0, $biK02.default)(argType), "\" ") + 'was not provided.', node);
            continue;
        }
        var valueNode = argumentNode.value;
        var isNull = valueNode.kind === (0, $1c4hI.Kind).NULL;
        if (valueNode.kind === (0, $1c4hI.Kind).VARIABLE) {
            var variableName = valueNode.name.value;
            if (variableValues == null || !$b695b1e556e9787e$var$hasOwnProperty(variableValues, variableName)) {
                if (argDef.defaultValue !== undefined) coercedValues[name] = argDef.defaultValue;
                else if ((0, $lXoEQ.isNonNullType)(argType)) throw new (0, $9fgMZ.GraphQLError)("Argument \"".concat(name, "\" of required type \"").concat((0, $biK02.default)(argType), "\" ") + "was provided the variable \"$".concat(variableName, "\" which was not provided a runtime value."), valueNode);
                continue;
            }
            isNull = variableValues[variableName] == null;
        }
        if (isNull && (0, $lXoEQ.isNonNullType)(argType)) throw new (0, $9fgMZ.GraphQLError)("Argument \"".concat(name, "\" of non-null type \"").concat((0, $biK02.default)(argType), "\" ") + 'must not be null.', valueNode);
        var coercedValue = (0, $3E0nn.valueFromAST)(valueNode, argType, variableValues);
        if (coercedValue === undefined) // Note: ValuesOfCorrectTypeRule validation should catch this before
        // execution. This is a runtime check to ensure execution does not
        // continue with an invalid argument value.
        throw new (0, $9fgMZ.GraphQLError)("Argument \"".concat(name, "\" has invalid value ").concat((0, $aKlnM.print)(valueNode), "."), valueNode);
        coercedValues[name] = coercedValue;
    }
    return coercedValues;
}
function $b695b1e556e9787e$export$1f7174681493b2aa(directiveDef, node, variableValues) {
    var directiveNode = node.directives && (0, $bmIpK.default)(node.directives, function(directive) {
        return directive.name.value === directiveDef.name;
    });
    if (directiveNode) return $b695b1e556e9787e$export$5af04a8495f7ef54(directiveDef, directiveNode, variableValues);
}
function $b695b1e556e9787e$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});
parcelRegister("laAus", function(module, exports) {

$parcel$export(module.exports, "default", () => $227415a0e63f15f5$export$2e2bcd8739ae039);
/**
 * Build a string describing the path.
 */ function $227415a0e63f15f5$export$2e2bcd8739ae039(path) {
    return path.map(function(key) {
        return typeof key === 'number' ? '[' + key.toString() + ']' : '.' + key;
    }).join('');
}

});

parcelRegister("3E0nn", function(module, exports) {

$parcel$export(module.exports, "valueFromAST", () => $d700774db2a0232b$export$d32bfdfcfbe60e55);

var $dVq2R = parcelRequire("dVq2R");

var $hbiEd = parcelRequire("hbiEd");

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $1c4hI = parcelRequire("1c4hI");

var $lXoEQ = parcelRequire("lXoEQ");
function $d700774db2a0232b$export$d32bfdfcfbe60e55(valueNode, type, variables) {
    if (!valueNode) // When there is no node, then there is also no value.
    // Importantly, this is different from returning the value null.
    return;
    if (valueNode.kind === (0, $1c4hI.Kind).VARIABLE) {
        var variableName = valueNode.name.value;
        if (variables == null || variables[variableName] === undefined) // No valid return value.
        return;
        var variableValue = variables[variableName];
        if (variableValue === null && (0, $lXoEQ.isNonNullType)(type)) return; // Invalid: intentionally return no value.
         // Note: This does no further checking that this variable is correct.
        // This assumes that this query has been validated and the variable
        // usage here is of the correct type.
        return variableValue;
    }
    if ((0, $lXoEQ.isNonNullType)(type)) {
        if (valueNode.kind === (0, $1c4hI.Kind).NULL) return; // Invalid: intentionally return no value.
        return $d700774db2a0232b$export$d32bfdfcfbe60e55(valueNode, type.ofType, variables);
    }
    if (valueNode.kind === (0, $1c4hI.Kind).NULL) // This is explicitly returning the value null.
    return null;
    if ((0, $lXoEQ.isListType)(type)) {
        var itemType = type.ofType;
        if (valueNode.kind === (0, $1c4hI.Kind).LIST) {
            var coercedValues = [];
            for(var _i2 = 0, _valueNode$values2 = valueNode.values; _i2 < _valueNode$values2.length; _i2++){
                var itemNode = _valueNode$values2[_i2];
                if ($d700774db2a0232b$var$isMissingVariable(itemNode, variables)) {
                    // If an array contains a missing variable, it is either coerced to
                    // null or if the item type is non-null, it considered invalid.
                    if ((0, $lXoEQ.isNonNullType)(itemType)) return; // Invalid: intentionally return no value.
                    coercedValues.push(null);
                } else {
                    var itemValue = $d700774db2a0232b$export$d32bfdfcfbe60e55(itemNode, itemType, variables);
                    if (itemValue === undefined) return; // Invalid: intentionally return no value.
                    coercedValues.push(itemValue);
                }
            }
            return coercedValues;
        }
        var coercedValue = $d700774db2a0232b$export$d32bfdfcfbe60e55(valueNode, itemType, variables);
        if (coercedValue === undefined) return; // Invalid: intentionally return no value.
        return [
            coercedValue
        ];
    }
    if ((0, $lXoEQ.isInputObjectType)(type)) {
        if (valueNode.kind !== (0, $1c4hI.Kind).OBJECT) return; // Invalid: intentionally return no value.
        var coercedObj = Object.create(null);
        var fieldNodes = (0, $hbiEd.default)(valueNode.fields, function(field) {
            return field.name.value;
        });
        for(var _i4 = 0, _objectValues2 = (0, $dVq2R.default)(type.getFields()); _i4 < _objectValues2.length; _i4++){
            var field = _objectValues2[_i4];
            var fieldNode = fieldNodes[field.name];
            if (!fieldNode || $d700774db2a0232b$var$isMissingVariable(fieldNode.value, variables)) {
                if (field.defaultValue !== undefined) coercedObj[field.name] = field.defaultValue;
                else if ((0, $lXoEQ.isNonNullType)(field.type)) return; // Invalid: intentionally return no value.
                continue;
            }
            var fieldValue = $d700774db2a0232b$export$d32bfdfcfbe60e55(fieldNode.value, field.type, variables);
            if (fieldValue === undefined) return; // Invalid: intentionally return no value.
            coercedObj[field.name] = fieldValue;
        }
        return coercedObj;
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isLeafType)(type)) {
        // Scalars and Enums fulfill parsing a literal value via parseLiteral().
        // Invalid values represent a failure to parse correctly, in which case
        // no value is returned.
        var result;
        try {
            result = type.parseLiteral(valueNode, variables);
        } catch (_error) {
            return; // Invalid: intentionally return no value.
        }
        if (result === undefined) return; // Invalid: intentionally return no value.
        return result;
    } // istanbul ignore next (Not reachable. All possible input types have been considered)
    (0, $43MJl.default)(0, 'Unexpected input type: ' + (0, $biK02.default)(type));
} // Returns true if the provided valueNode is a variable which is not defined
// in the set of variables.
function $d700774db2a0232b$var$isMissingVariable(valueNode, variables) {
    return valueNode.kind === (0, $1c4hI.Kind).VARIABLE && (variables == null || variables[valueNode.name.value] === undefined);
}

});

parcelRegister("dEek8", function(module, exports) {

$parcel$export(module.exports, "coerceInputValue", () => $6618e9631598014d$export$7964ec791f1fa3f1);

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $8nBnZ = parcelRequire("8nBnZ");

var $fbtyx = parcelRequire("fbtyx");

var $8DMvn = parcelRequire("8DMvn");

var $bru1k = parcelRequire("bru1k");

var $laAus = parcelRequire("laAus");

var $kZHaf = parcelRequire("kZHaf");

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
function $6618e9631598014d$export$7964ec791f1fa3f1(inputValue, type) {
    var onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $6618e9631598014d$var$defaultOnError;
    return $6618e9631598014d$var$coerceInputValueImpl(inputValue, type, onError);
}
function $6618e9631598014d$var$defaultOnError(path, invalidValue, error) {
    var errorPrefix = 'Invalid value ' + (0, $biK02.default)(invalidValue);
    if (path.length > 0) errorPrefix += " at \"value".concat((0, $laAus.default)(path), "\"");
    error.message = errorPrefix + ': ' + error.message;
    throw error;
}
function $6618e9631598014d$var$coerceInputValueImpl(inputValue, type, onError, path) {
    if ((0, $lXoEQ.isNonNullType)(type)) {
        if (inputValue != null) return $6618e9631598014d$var$coerceInputValueImpl(inputValue, type.ofType, onError, path);
        onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Expected non-nullable type \"".concat((0, $biK02.default)(type), "\" not to be null.")));
        return;
    }
    if (inputValue == null) // Explicitly return the value null.
    return null;
    if ((0, $lXoEQ.isListType)(type)) {
        var itemType = type.ofType;
        var coercedList = (0, $8DMvn.default)(inputValue, function(itemValue, index) {
            var itemPath = (0, $kZHaf.addPath)(path, index, undefined);
            return $6618e9631598014d$var$coerceInputValueImpl(itemValue, itemType, onError, itemPath);
        });
        if (coercedList != null) return coercedList;
         // Lists accept a non-list value as a list of one.
        return [
            $6618e9631598014d$var$coerceInputValueImpl(inputValue, itemType, onError, path)
        ];
    }
    if ((0, $lXoEQ.isInputObjectType)(type)) {
        if (!(0, $fbtyx.default)(inputValue)) {
            onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Expected type \"".concat(type.name, "\" to be an object.")));
            return;
        }
        var coercedValue = {};
        var fieldDefs = type.getFields();
        for(var _i2 = 0, _objectValues2 = (0, $dVq2R.default)(fieldDefs); _i2 < _objectValues2.length; _i2++){
            var field = _objectValues2[_i2];
            var fieldValue = inputValue[field.name];
            if (fieldValue === undefined) {
                if (field.defaultValue !== undefined) coercedValue[field.name] = field.defaultValue;
                else if ((0, $lXoEQ.isNonNullType)(field.type)) {
                    var typeStr = (0, $biK02.default)(field.type);
                    onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Field \"".concat(field.name, "\" of required type \"").concat(typeStr, "\" was not provided.")));
                }
                continue;
            }
            coercedValue[field.name] = $6618e9631598014d$var$coerceInputValueImpl(fieldValue, field.type, onError, (0, $kZHaf.addPath)(path, field.name, type.name));
        } // Ensure every provided field is defined.
        for(var _i4 = 0, _Object$keys2 = Object.keys(inputValue); _i4 < _Object$keys2.length; _i4++){
            var fieldName = _Object$keys2[_i4];
            if (!fieldDefs[fieldName]) {
                var suggestions = (0, $bru1k.default)(fieldName, Object.keys(type.getFields()));
                onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Field \"".concat(fieldName, "\" is not defined by type \"").concat(type.name, "\".") + (0, $8nBnZ.default)(suggestions)));
            }
        }
        return coercedValue;
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isLeafType)(type)) {
        var parseResult; // Scalars and Enums determine if a input value is valid via parseValue(),
        // which can throw to indicate failure. If it throws, maintain a reference
        // to the original error.
        try {
            parseResult = type.parseValue(inputValue);
        } catch (error) {
            if (error instanceof (0, $9fgMZ.GraphQLError)) onError((0, $kZHaf.pathToArray)(path), inputValue, error);
            else onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Expected type \"".concat(type.name, "\". ") + error.message, undefined, undefined, undefined, undefined, error));
            return;
        }
        if (parseResult === undefined) onError((0, $kZHaf.pathToArray)(path), inputValue, new (0, $9fgMZ.GraphQLError)("Expected type \"".concat(type.name, "\".")));
        return parseResult;
    } // istanbul ignore next (Not reachable. All possible input types have been considered)
    (0, $43MJl.default)(0, 'Unexpected input type: ' + (0, $biK02.default)(type));
}

});




parcelRegister("aAMCg", function(module, exports) {
function $7b62fa5a6bcf3d57$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7b62fa5a6bcf3d57$var$__export((parcelRequire("crrCr")));

$7b62fa5a6bcf3d57$var$__export((parcelRequire("hbdmQ")));

$7b62fa5a6bcf3d57$var$__export((parcelRequire("akAyp")));

$7b62fa5a6bcf3d57$var$__export((parcelRequire("16dWW")));

var $gVW6u = parcelRequire("gVW6u");
module.exports.SchemaDirectiveVisitor = $gVW6u.SchemaDirectiveVisitor;

});
parcelRegister("crrCr", function(module, exports) {
function $90ed6e3aead06406$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");

var $gVW6u = parcelRequire("gVW6u");

var $b3EaX = parcelRequire("b3EaX");

function $90ed6e3aead06406$var$makeExecutableSchema(_a) {
    var typeDefs = _a.typeDefs, _b = _a.resolvers, resolvers = _b === void 0 ? {} : _b, connectors = _a.connectors, logger = _a.logger, _c = _a.allowUndefinedInResolve, allowUndefinedInResolve = _c === void 0 ? true : _c, _d = _a.resolverValidationOptions, resolverValidationOptions = _d === void 0 ? {} : _d, _e = _a.directiveResolvers, directiveResolvers = _e === void 0 ? null : _e, _f = _a.schemaDirectives, schemaDirectives = _f === void 0 ? null : _f, _g = _a.parseOptions, parseOptions = _g === void 0 ? {} : _g, _h = _a.inheritResolversFromInterfaces, inheritResolversFromInterfaces = _h === void 0 ? false : _h;
    // Validate and clean up arguments
    if (typeof resolverValidationOptions !== 'object') throw new (parcelRequire("cYGSS")).SchemaError('Expected `resolverValidationOptions` to be an object');
    if (!typeDefs) throw new (parcelRequire("cYGSS")).SchemaError('Must provide typeDefs');
    if (!resolvers) throw new (parcelRequire("cYGSS")).SchemaError('Must provide resolvers');
    // We allow passing in an array of resolver maps, in which case we merge them
    var resolverMap = Array.isArray(resolvers) ? resolvers.filter(function(resolverObj) {
        return typeof resolverObj === 'object';
    }).reduce($b3EaX.default, {}) : resolvers;
    // Arguments are now validated and cleaned up
    var schema = (parcelRequire("cYGSS")).buildSchemaFromTypeDefinitions(typeDefs, parseOptions);
    schema = (parcelRequire("cYGSS")).addResolveFunctionsToSchema({
        schema: schema,
        resolvers: resolverMap,
        resolverValidationOptions: resolverValidationOptions,
        inheritResolversFromInterfaces: inheritResolversFromInterfaces
    });
    (parcelRequire("cYGSS")).assertResolveFunctionsPresent(schema, resolverValidationOptions);
    if (!allowUndefinedInResolve) $90ed6e3aead06406$var$addCatchUndefinedToSchema(schema);
    if (logger) $90ed6e3aead06406$var$addErrorLoggingToSchema(schema, logger);
    if (typeof resolvers['__schema'] === 'function') // TODO a bit of a hack now, better rewrite generateSchema to attach it there.
    // not doing that now, because I'd have to rewrite a lot of tests.
    (parcelRequire("cYGSS")).addSchemaLevelResolveFunction(schema, resolvers['__schema']);
    if (connectors) // connectors are optional, at least for now. That means you can just import them in the resolve
    // function if you want.
    (parcelRequire("cYGSS")).attachConnectorsToContext(schema, connectors);
    if (directiveResolvers) (parcelRequire("cYGSS")).attachDirectiveResolvers(schema, directiveResolvers);
    if (schemaDirectives) $gVW6u.SchemaDirectiveVisitor.visitSchemaDirectives(schema, schemaDirectives);
    return schema;
}
module.exports.makeExecutableSchema = $90ed6e3aead06406$var$makeExecutableSchema;
function $90ed6e3aead06406$var$decorateToCatchUndefined(fn, hint) {
    if (typeof fn === 'undefined') fn = $3MP74.defaultFieldResolver;
    return function(root, args, ctx, info) {
        var result = fn(root, args, ctx, info);
        if (typeof result === 'undefined') throw new Error("Resolve function for \"" + hint + "\" returned undefined");
        return result;
    };
}
function $90ed6e3aead06406$var$addCatchUndefinedToSchema(schema) {
    (parcelRequire("cYGSS")).forEachField(schema, function(field, typeName, fieldName) {
        var errorHint = typeName + "." + fieldName;
        field.resolve = $90ed6e3aead06406$var$decorateToCatchUndefined(field.resolve, errorHint);
    });
}
module.exports.addCatchUndefinedToSchema = $90ed6e3aead06406$var$addCatchUndefinedToSchema;
function $90ed6e3aead06406$var$addErrorLoggingToSchema(schema, logger) {
    if (!logger) throw new Error('Must provide a logger');
    if (typeof logger.log !== 'function') throw new Error('Logger.log must be a function');
    (parcelRequire("cYGSS")).forEachField(schema, function(field, typeName, fieldName) {
        var errorHint = typeName + "." + fieldName;
        field.resolve = (parcelRequire("cYGSS")).decorateWithLogger(field.resolve, logger, errorHint);
    });
}
module.exports.addErrorLoggingToSchema = $90ed6e3aead06406$var$addErrorLoggingToSchema;

$90ed6e3aead06406$var$__export((parcelRequire("cYGSS")));

});
parcelRegister("gVW6u", function(module, exports) {
var $c53f0a6913fad0c1$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c53f0a6913fad0c1$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $6BdRO = parcelRequire("6BdRO");
var $1c4hI = parcelRequire("1c4hI");

var $gqGQB = parcelRequire("gqGQB");
var $c53f0a6913fad0c1$var$hasOwn = Object.prototype.hasOwnProperty;
// Abstract base class of any visitor implementation, defining the available
// visitor methods along with their parameter types, and providing a static
// helper function for determining whether a subclass implements a given
// visitor method, as opposed to inheriting one of the stubs defined here.
var $c53f0a6913fad0c1$var$SchemaVisitor = /** @class */ function() {
    function SchemaVisitor() {}
    // Determine if this SchemaVisitor (sub)class implements a particular
    // visitor method.
    SchemaVisitor.implementsVisitorMethod = function(methodName) {
        if (!methodName.startsWith('visit')) return false;
        var method = this.prototype[methodName];
        if (typeof method !== 'function') return false;
        if (this === SchemaVisitor) // The SchemaVisitor class implements every visitor method.
        return true;
        var stub = SchemaVisitor.prototype[methodName];
        if (method === stub) // If this.prototype[methodName] was just inherited from SchemaVisitor,
        // then this class does not really implement the method.
        return false;
        return true;
    };
    // Concrete subclasses of SchemaVisitor should override one or more of these
    // visitor methods, in order to express their interest in handling certain
    // schema types/locations. Each method may return null to remove the given
    // type from the schema, a non-null value of the same type to update the
    // type in the schema, or nothing to leave the type as it was.
    /* tslint:disable:no-empty */ SchemaVisitor.prototype.visitSchema = function(schema) {};
    SchemaVisitor.prototype.visitScalar = function(scalar) {};
    SchemaVisitor.prototype.visitObject = function(object) {};
    SchemaVisitor.prototype.visitFieldDefinition = function(field, details) {};
    SchemaVisitor.prototype.visitArgumentDefinition = function(argument, details) {};
    SchemaVisitor.prototype.visitInterface = function(iface) {};
    SchemaVisitor.prototype.visitUnion = function(union) {};
    SchemaVisitor.prototype.visitEnum = function(type) {};
    SchemaVisitor.prototype.visitEnumValue = function(value, details) {};
    SchemaVisitor.prototype.visitInputObject = function(object) {};
    SchemaVisitor.prototype.visitInputFieldDefinition = function(field, details) {};
    return SchemaVisitor;
}();
module.exports.SchemaVisitor = $c53f0a6913fad0c1$var$SchemaVisitor;
// Generic function for visiting GraphQLSchema objects.
function $c53f0a6913fad0c1$var$visitSchema(schema, // To accommodate as many different visitor patterns as possible, the
// visitSchema function does not simply accept a single instance of the
// SchemaVisitor class, but instead accepts a function that takes the
// current VisitableSchemaType object and the name of a visitor method and
// returns an array of SchemaVisitor instances that implement the visitor
// method and have an interest in handling the given VisitableSchemaType
// object. In the simplest case, this function can always return an array
// containing a single visitor object, without even looking at the type or
// methodName parameters. In other cases, this function might sometimes
// return an empty array to indicate there are no visitors that should be
// applied to the given VisitableSchemaType object. For an example of a
// visitor pattern that benefits from this abstraction, see the
// SchemaDirectiveVisitor class below.
visitorSelector) {
    // Helper function that calls visitorSelector and applies the resulting
    // visitors to the given type, with arguments [type, ...args].
    function callMethod(methodName, type) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        visitorSelector(type, methodName).every(function(visitor) {
            var newType = visitor[methodName].apply(visitor, $c53f0a6913fad0c1$var$__spreadArrays([
                type
            ], args));
            if (typeof newType === 'undefined') // Keep going without modifying type.
            return true;
            if (methodName === 'visitSchema' || type instanceof $6BdRO.GraphQLSchema) throw new Error("Method " + methodName + " cannot replace schema with " + newType);
            if (newType === null) {
                // Stop the loop and return null form callMethod, which will cause
                // the type to be removed from the schema.
                type = null;
                return false;
            }
            // Update type to the new type returned by the visitor method, so that
            // later directives will see the new type, and callMethod will return
            // the final type.
            type = newType;
            return true;
        });
        // If there were no directives for this type object, or if all visitor
        // methods returned nothing, type will be returned unmodified.
        return type;
    }
    // Recursive helper function that calls any appropriate visitor methods for
    // each object in the schema, then traverses the object's children (if any).
    function visit(type) {
        if (type instanceof $6BdRO.GraphQLSchema) {
            // Unlike the other types, the root GraphQLSchema object cannot be
            // replaced by visitor methods, because that would make life very hard
            // for SchemaVisitor subclasses that rely on the original schema object.
            callMethod('visitSchema', type);
            $c53f0a6913fad0c1$var$updateEachKey(type.getTypeMap(), function(namedType, typeName) {
                if (!typeName.startsWith('__')) // Call visit recursively to let it determine which concrete
                // subclass of GraphQLNamedType we found in the type map. Because
                // we're using updateEachKey, the result of visit(namedType) may
                // cause the type to be removed or replaced.
                return visit(namedType);
            });
            return type;
        }
        if (type instanceof $lXoEQ.GraphQLObjectType) {
            // Note that callMethod('visitObject', type) may not actually call any
            // methods, if there are no @directive annotations associated with this
            // type, or if this SchemaDirectiveVisitor subclass does not override
            // the visitObject method.
            var newObject = callMethod('visitObject', type);
            if (newObject) visitFields(newObject);
            return newObject;
        }
        if (type instanceof $lXoEQ.GraphQLInterfaceType) {
            var newInterface = callMethod('visitInterface', type);
            if (newInterface) visitFields(newInterface);
            return newInterface;
        }
        if (type instanceof $lXoEQ.GraphQLInputObjectType) {
            var newInputObject_1 = callMethod('visitInputObject', type);
            if (newInputObject_1) $c53f0a6913fad0c1$var$updateEachKey(newInputObject_1.getFields(), function(field) {
                // Since we call a different method for input object fields, we
                // can't reuse the visitFields function here.
                return callMethod('visitInputFieldDefinition', field, {
                    objectType: newInputObject_1
                });
            });
            return newInputObject_1;
        }
        if (type instanceof $lXoEQ.GraphQLScalarType) return callMethod('visitScalar', type);
        if (type instanceof $lXoEQ.GraphQLUnionType) return callMethod('visitUnion', type);
        if (type instanceof $lXoEQ.GraphQLEnumType) {
            var newEnum_1 = callMethod('visitEnum', type);
            if (newEnum_1) $c53f0a6913fad0c1$var$updateEachKey(newEnum_1.getValues(), function(value) {
                return callMethod('visitEnumValue', value, {
                    enumType: newEnum_1
                });
            });
            return newEnum_1;
        }
        throw new Error("Unexpected schema type: " + type);
    }
    function visitFields(type) {
        $c53f0a6913fad0c1$var$updateEachKey(type.getFields(), function(field) {
            // It would be nice if we could call visit(field) recursively here, but
            // GraphQLField is merely a type, not a value that can be detected using
            // an instanceof check, so we have to visit the fields in this lexical
            // context, so that TypeScript can validate the call to
            // visitFieldDefinition.
            var newField = callMethod('visitFieldDefinition', field, {
                // While any field visitor needs a reference to the field object, some
                // field visitors may also need to know the enclosing (parent) type,
                // perhaps to determine if the parent is a GraphQLObjectType or a
                // GraphQLInterfaceType. To obtain a reference to the parent, a
                // visitor method can have a second parameter, which will be an object
                // with an .objectType property referring to the parent.
                objectType: type
            });
            if (newField && newField.args) $c53f0a6913fad0c1$var$updateEachKey(newField.args, function(arg) {
                return callMethod('visitArgumentDefinition', arg, {
                    // Like visitFieldDefinition, visitArgumentDefinition takes a
                    // second parameter that provides additional context, namely the
                    // parent .field and grandparent .objectType. Remember that the
                    // current GraphQLSchema is always available via this.schema.
                    field: newField,
                    objectType: type
                });
            });
            return newField;
        });
    }
    visit(schema);
    // Return the original schema for convenience, even though it cannot have
    // been replaced or removed by the code above.
    return schema;
}
module.exports.visitSchema = $c53f0a6913fad0c1$var$visitSchema;
// Update any references to named schema types that disagree with the named
// types found in schema.getTypeMap().
function $c53f0a6913fad0c1$var$healSchema(schema) {
    heal(schema);
    return schema;
    function heal(type) {
        if (type instanceof $6BdRO.GraphQLSchema) {
            var originalTypeMap_1 = type.getTypeMap();
            var actualNamedTypeMap_1 = Object.create(null);
            // If any of the .name properties of the GraphQLNamedType objects in
            // schema.getTypeMap() have changed, the keys of the type map need to
            // be updated accordingly.
            $c53f0a6913fad0c1$var$each(originalTypeMap_1, function(namedType, typeName) {
                if (typeName.startsWith('__')) return;
                var actualName = namedType.name;
                if (actualName.startsWith('__')) return;
                if ($c53f0a6913fad0c1$var$hasOwn.call(actualNamedTypeMap_1, actualName)) throw new Error("Duplicate schema type name " + actualName);
                actualNamedTypeMap_1[actualName] = namedType;
            // Note: we are deliberately leaving namedType in the schema by its
            // original name (which might be different from actualName), so that
            // references by that name can be healed.
            });
            // Now add back every named type by its actual name.
            $c53f0a6913fad0c1$var$each(actualNamedTypeMap_1, function(namedType, typeName) {
                originalTypeMap_1[typeName] = namedType;
            });
            // Directive declaration argument types can refer to named types.
            $c53f0a6913fad0c1$var$each(type.getDirectives(), function(decl) {
                if (decl.args) $c53f0a6913fad0c1$var$each(decl.args, function(arg) {
                    arg.type = healType(arg.type);
                });
            });
            $c53f0a6913fad0c1$var$each(originalTypeMap_1, function(namedType, typeName) {
                if (!typeName.startsWith('__')) heal(namedType);
            });
            $c53f0a6913fad0c1$var$updateEachKey(originalTypeMap_1, function(namedType, typeName) {
                // Dangling references to renamed types should remain in the schema
                // during healing, but must be removed now, so that the following
                // invariant holds for all names: schema.getType(name).name === name
                if (!typeName.startsWith('__') && !$c53f0a6913fad0c1$var$hasOwn.call(actualNamedTypeMap_1, typeName)) return null;
            });
        } else if (type instanceof $lXoEQ.GraphQLObjectType) {
            healFields(type);
            $c53f0a6913fad0c1$var$each(type.getInterfaces(), function(iface) {
                return heal(iface);
            });
        } else if (type instanceof $lXoEQ.GraphQLInterfaceType) healFields(type);
        else if (type instanceof $lXoEQ.GraphQLInputObjectType) $c53f0a6913fad0c1$var$each(type.getFields(), function(field) {
            field.type = healType(field.type);
        });
        else if (type instanceof $lXoEQ.GraphQLScalarType) ;
        else if (type instanceof $lXoEQ.GraphQLUnionType) $c53f0a6913fad0c1$var$updateEachKey(type.getTypes(), function(t) {
            return healType(t);
        });
        else if (type instanceof $lXoEQ.GraphQLEnumType) ;
        else throw new Error("Unexpected schema type: " + type);
    }
    function healFields(type) {
        $c53f0a6913fad0c1$var$each(type.getFields(), function(field) {
            field.type = healType(field.type);
            if (field.args) $c53f0a6913fad0c1$var$each(field.args, function(arg) {
                arg.type = healType(arg.type);
            });
        });
    }
    function healType(type) {
        // Unwrap the two known wrapper types
        if (type instanceof $lXoEQ.GraphQLList) type = new $lXoEQ.GraphQLList(healType(type.ofType));
        else if (type instanceof $lXoEQ.GraphQLNonNull) type = new $lXoEQ.GraphQLNonNull(healType(type.ofType));
        else if ($lXoEQ.isNamedType(type)) {
            // If a type annotation on a field or an argument or a union member is
            // any `GraphQLNamedType` with a `name`, then it must end up identical
            // to `schema.getType(name)`, since `schema.getTypeMap()` is the source
            // of truth for all named schema types.
            var namedType = type;
            var officialType = schema.getType(namedType.name);
            if (officialType && namedType !== officialType) return officialType;
        }
        return type;
    }
}
module.exports.healSchema = $c53f0a6913fad0c1$var$healSchema;
// This class represents a reusable implementation of a @directive that may
// appear in a GraphQL schema written in Schema Definition Language.
//
// By overriding one or more visit{Object,Union,...} methods, a subclass
// registers interest in certain schema types, such as GraphQLObjectType,
// GraphQLUnionType, etc. When SchemaDirectiveVisitor.visitSchemaDirectives is
// called with a GraphQLSchema object and a map of visitor subclasses, the
// overidden methods of those subclasses allow the visitors to obtain
// references to any type objects that have @directives attached to them,
// enabling visitors to inspect or modify the schema as appropriate.
//
// For example, if a directive called @rest(url: "...") appears after a field
// definition, a SchemaDirectiveVisitor subclass could provide meaning to that
// directive by overriding the visitFieldDefinition method (which receives a
// GraphQLField parameter), and then the body of that visitor method could
// manipulate the field's resolver function to fetch data from a REST endpoint
// described by the url argument passed to the @rest directive:
//
//   const typeDefs = `
//   type Query {
//     people: [Person] @rest(url: "/api/v1/people")
//   }`;
//
//   const schema = makeExecutableSchema({ typeDefs });
//
//   SchemaDirectiveVisitor.visitSchemaDirectives(schema, {
//     rest: class extends SchemaDirectiveVisitor {
//       public visitFieldDefinition(field: GraphQLField<any, any>) {
//         const { url } = this.args;
//         field.resolve = () => fetch(url);
//       }
//     }
//   });
//
// The subclass in this example is defined as an anonymous class expression,
// for brevity. A truly reusable SchemaDirectiveVisitor would most likely be
// defined in a library using a named class declaration, and then exported for
// consumption by other modules and packages.
//
// See below for a complete list of overridable visitor methods, their
// parameter types, and more details about the properties exposed by instances
// of the SchemaDirectiveVisitor class.
var $c53f0a6913fad0c1$var$SchemaDirectiveVisitor = /** @class */ function(_super) {
    $c53f0a6913fad0c1$var$__extends(SchemaDirectiveVisitor, _super);
    // Mark the constructor protected to enforce passing SchemaDirectiveVisitor
    // subclasses (not instances) to visitSchemaDirectives.
    function SchemaDirectiveVisitor(config) {
        var _this = _super.call(this) || this;
        _this.name = config.name;
        _this.args = config.args;
        _this.visitedType = config.visitedType;
        _this.schema = config.schema;
        _this.context = config.context;
        return _this;
    }
    // Override this method to return a custom GraphQLDirective (or modify one
    // already present in the schema) to enforce argument types, provide default
    // argument values, or specify schema locations where this @directive may
    // appear. By default, any declaration found in the schema will be returned.
    SchemaDirectiveVisitor.getDirectiveDeclaration = function(directiveName, schema) {
        return schema.getDirective(directiveName);
    };
    // Call SchemaDirectiveVisitor.visitSchemaDirectives to visit every
    // @directive in the schema and create an appropriate SchemaDirectiveVisitor
    // instance to visit the object decorated by the @directive.
    SchemaDirectiveVisitor.visitSchemaDirectives = function(schema, directiveVisitors, // Optional context object that will be available to all visitor instances
    // via this.context. Defaults to an empty null-prototype object.
    context) {
        if (context === void 0) context = Object.create(null);
        // If the schema declares any directives for public consumption, record
        // them here so that we can properly coerce arguments when/if we encounter
        // an occurrence of the directive while walking the schema below.
        var declaredDirectives = this.getDeclaredDirectives(schema, directiveVisitors);
        // Map from directive names to lists of SchemaDirectiveVisitor instances
        // created while visiting the schema.
        var createdVisitors = Object.create(null);
        Object.keys(directiveVisitors).forEach(function(directiveName) {
            createdVisitors[directiveName] = [];
        });
        function visitorSelector(type, methodName) {
            var visitors = [];
            var directiveNodes = type.astNode && type.astNode.directives;
            if (!directiveNodes) return visitors;
            directiveNodes.forEach(function(directiveNode) {
                var directiveName = directiveNode.name.value;
                if (!$c53f0a6913fad0c1$var$hasOwn.call(directiveVisitors, directiveName)) return;
                var visitorClass = directiveVisitors[directiveName];
                // Avoid creating visitor objects if visitorClass does not override
                // the visitor method named by methodName.
                if (!visitorClass.implementsVisitorMethod(methodName)) return;
                var decl = declaredDirectives[directiveName];
                var args;
                if (decl) // If this directive was explicitly declared, use the declared
                // argument types (and any default values) to check, coerce, and/or
                // supply default values for the given arguments.
                args = $gqGQB.getArgumentValues(decl, directiveNode);
                else {
                    // If this directive was not explicitly declared, just convert the
                    // argument nodes to their corresponding JavaScript values.
                    args = Object.create(null);
                    directiveNode.arguments.forEach(function(arg) {
                        args[arg.name.value] = $c53f0a6913fad0c1$var$valueFromASTUntyped(arg.value);
                    });
                }
                // As foretold in comments near the top of the visitSchemaDirectives
                // method, this is where instances of the SchemaDirectiveVisitor class
                // get created and assigned names. While subclasses could override the
                // constructor method, the constructor is marked as protected, so
                // these are the only arguments that will ever be passed.
                visitors.push(new visitorClass({
                    name: directiveName,
                    args: args,
                    visitedType: type,
                    schema: schema,
                    context: context
                }));
            });
            if (visitors.length > 0) visitors.forEach(function(visitor) {
                createdVisitors[visitor.name].push(visitor);
            });
            return visitors;
        }
        $c53f0a6913fad0c1$var$visitSchema(schema, visitorSelector);
        // Automatically update any references to named schema types replaced
        // during the traversal, so implementors don't have to worry about that.
        $c53f0a6913fad0c1$var$healSchema(schema);
        return createdVisitors;
    };
    SchemaDirectiveVisitor.getDeclaredDirectives = function(schema, directiveVisitors) {
        var declaredDirectives = Object.create(null);
        $c53f0a6913fad0c1$var$each(schema.getDirectives(), function(decl) {
            declaredDirectives[decl.name] = decl;
        });
        // If the visitor subclass overrides getDirectiveDeclaration, and it
        // returns a non-null GraphQLDirective, use that instead of any directive
        // declared in the schema itself. Reasoning: if a SchemaDirectiveVisitor
        // goes to the trouble of implementing getDirectiveDeclaration, it should
        // be able to rely on that implementation.
        $c53f0a6913fad0c1$var$each(directiveVisitors, function(visitorClass, directiveName) {
            var decl = visitorClass.getDirectiveDeclaration(directiveName, schema);
            if (decl) declaredDirectives[directiveName] = decl;
        });
        $c53f0a6913fad0c1$var$each(declaredDirectives, function(decl, name) {
            if (!$c53f0a6913fad0c1$var$hasOwn.call(directiveVisitors, name)) // SchemaDirectiveVisitors.visitSchemaDirectives might be called
            // multiple times with partial directiveVisitors maps, so it's not
            // necessarily an error for directiveVisitors to be missing an
            // implementation of a directive that was declared in the schema.
            return;
            var visitorClass = directiveVisitors[name];
            $c53f0a6913fad0c1$var$each(decl.locations, function(loc) {
                var visitorMethodName = $c53f0a6913fad0c1$var$directiveLocationToVisitorMethodName(loc);
                if ($c53f0a6913fad0c1$var$SchemaVisitor.implementsVisitorMethod(visitorMethodName) && !visitorClass.implementsVisitorMethod(visitorMethodName)) // While visitor subclasses may implement extra visitor methods,
                // it's definitely a mistake if the GraphQLDirective declares itself
                // applicable to certain schema locations, and the visitor subclass
                // does not implement all the corresponding methods.
                throw new Error("SchemaDirectiveVisitor for @" + name + " must implement " + visitorMethodName + " method");
            });
        });
        return declaredDirectives;
    };
    return SchemaDirectiveVisitor;
}($c53f0a6913fad0c1$var$SchemaVisitor);
module.exports.SchemaDirectiveVisitor = $c53f0a6913fad0c1$var$SchemaDirectiveVisitor;
// Convert a string like "FIELD_DEFINITION" to "visitFieldDefinition".
function $c53f0a6913fad0c1$var$directiveLocationToVisitorMethodName(loc) {
    return 'visit' + loc.replace(/([^_]*)_?/g, function(wholeMatch, part) {
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    });
}
function $c53f0a6913fad0c1$var$each(arrayOrObject, callback) {
    Object.keys(arrayOrObject).forEach(function(key) {
        callback(arrayOrObject[key], key);
    });
}
// A more powerful version of each that has the ability to replace or remove
// array or object keys.
function $c53f0a6913fad0c1$var$updateEachKey(arrayOrObject, // The callback can return nothing to leave the key untouched, null to remove
// the key from the array or object, or a non-null V to replace the value.
callback) {
    var deletedCount = 0;
    Object.keys(arrayOrObject).forEach(function(key) {
        var result = callback(arrayOrObject[key], key);
        if (typeof result === 'undefined') return;
        if (result === null) {
            delete arrayOrObject[key];
            deletedCount++;
            return;
        }
        arrayOrObject[key] = result;
    });
    if (deletedCount > 0 && Array.isArray(arrayOrObject)) // Remove any holes from the array due to deleted elements.
    arrayOrObject.splice(0).forEach(function(elem) {
        arrayOrObject.push(elem);
    });
}
// Similar to the graphql-js function of the same name, slightly simplified:
// https://github.com/graphql/graphql-js/blob/master/src/utilities/valueFromASTUntyped.js
function $c53f0a6913fad0c1$var$valueFromASTUntyped(valueNode) {
    switch(valueNode.kind){
        case $1c4hI.Kind.NULL:
            return null;
        case $1c4hI.Kind.INT:
            return parseInt(valueNode.value, 10);
        case $1c4hI.Kind.FLOAT:
            return parseFloat(valueNode.value);
        case $1c4hI.Kind.STRING:
        case $1c4hI.Kind.ENUM:
        case $1c4hI.Kind.BOOLEAN:
            return valueNode.value;
        case $1c4hI.Kind.LIST:
            return valueNode.values.map($c53f0a6913fad0c1$var$valueFromASTUntyped);
        case $1c4hI.Kind.OBJECT:
            var obj_1 = Object.create(null);
            valueNode.fields.forEach(function(field) {
                obj_1[field.name.value] = $c53f0a6913fad0c1$var$valueFromASTUntyped(field.value);
            });
            return obj_1;
        /* istanbul ignore next */ default:
            throw new Error('Unexpected value kind: ' + valueNode.kind);
    }
}

});

parcelRegister("b3EaX", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $80cf239c99e32ce4$var$mergeDeep(target, source) {
    var output = Object.assign({}, target);
    if ($80cf239c99e32ce4$var$isObject(target) && $80cf239c99e32ce4$var$isObject(source)) Object.keys(source).forEach(function(key) {
        var _a, _b;
        if ($80cf239c99e32ce4$var$isObject(source[key])) {
            if (!(key in target)) Object.assign(output, (_a = {}, _a[key] = source[key], _a));
            else output[key] = $80cf239c99e32ce4$var$mergeDeep(target[key], source[key]);
        } else Object.assign(output, (_b = {}, _b[key] = source[key], _b));
    });
    return output;
}
module.exports.default = $80cf239c99e32ce4$var$mergeDeep;
function $80cf239c99e32ce4$var$isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}

});

parcelRegister("cYGSS", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gLRgj = parcelRequire("gLRgj");
module.exports.addResolveFunctionsToSchema = $gLRgj.default;

var $lQXQV = parcelRequire("lQXQV");
module.exports.addSchemaLevelResolveFunction = $lQXQV.default;

var $7ZqjT = parcelRequire("7ZqjT");
module.exports.assertResolveFunctionsPresent = $7ZqjT.default;

var $glxQ5 = parcelRequire("glxQ5");
module.exports.attachDirectiveResolvers = $glxQ5.default;

var $4Vy0J = parcelRequire("4Vy0J");
module.exports.attachConnectorsToContext = $4Vy0J.default;

var $kYZ7H = parcelRequire("kYZ7H");
module.exports.buildSchemaFromTypeDefinitions = $kYZ7H.default;

var $zi3Qo = parcelRequire("zi3Qo");
module.exports.chainResolvers = $zi3Qo.chainResolvers;

var $3zHIx = parcelRequire("3zHIx");
module.exports.checkForResolveTypeResolver = $3zHIx.default;

var $fzT6r = parcelRequire("fzT6r");
module.exports.concatenateTypeDefs = $fzT6r.default;

var $jhVll = parcelRequire("jhVll");
module.exports.decorateWithLogger = $jhVll.default;

var $anY4o = parcelRequire("anY4o");
module.exports.extendResolversFromInterfaces = $anY4o.default;

var $4YHnC = parcelRequire("4YHnC");
module.exports.extractExtensionDefinitions = $4YHnC.default;

var $bKZOs = parcelRequire("bKZOs");
module.exports.forEachField = $bKZOs.default;

var $69KMn = parcelRequire("69KMn");
module.exports.SchemaError = $69KMn.default;

});
parcelRegister("gLRgj", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cYGSS = parcelRequire("cYGSS");

var $lXoEQ = parcelRequire("lXoEQ");
var $6BdRO = parcelRequire("6BdRO");

var $esVhq = parcelRequire("esVhq");

var $cYGSS = parcelRequire("cYGSS");

var $l0ywS = parcelRequire("l0ywS");
function $c35a59e5905db8e3$var$addResolveFunctionsToSchema(options, legacyInputResolvers, legacyInputValidationOptions) {
    if (options instanceof $6BdRO.GraphQLSchema) {
        console.warn('The addResolveFunctionsToSchema function takes named options now; see IAddResolveFunctionsToSchemaOptions');
        options = {
            schema: options,
            resolvers: legacyInputResolvers,
            resolverValidationOptions: legacyInputValidationOptions
        };
    }
    var schema = options.schema, inputResolvers = options.resolvers, _a = options.resolverValidationOptions, resolverValidationOptions = _a === void 0 ? {} : _a, _b = options.inheritResolversFromInterfaces, inheritResolversFromInterfaces = _b === void 0 ? false : _b;
    var _c = resolverValidationOptions.allowResolversNotInSchema, allowResolversNotInSchema = _c === void 0 ? false : _c, requireResolversForResolveType = resolverValidationOptions.requireResolversForResolveType;
    var resolvers = inheritResolversFromInterfaces ? $cYGSS.extendResolversFromInterfaces(schema, inputResolvers) : inputResolvers;
    // Used to map the external value of an enum to its internal value, when
    // that internal value is provided by a resolver.
    var enumValueMap = Object.create(null);
    Object.keys(resolvers).forEach(function(typeName) {
        var resolverValue = resolvers[typeName];
        var resolverType = typeof resolverValue;
        if (resolverType !== 'object' && resolverType !== 'function') throw new $cYGSS.SchemaError("\"" + typeName + "\" defined in resolvers, but has invalid value \"" + resolverValue + "\". A resolver's value " + "must be of type object or function.");
        var type = schema.getType(typeName);
        if (!type && typeName !== '__schema') {
            if (allowResolversNotInSchema) return;
            throw new $cYGSS.SchemaError("\"" + typeName + "\" defined in resolvers, but not in schema");
        }
        Object.keys(resolverValue).forEach(function(fieldName) {
            if (fieldName.startsWith('__')) {
                // this is for isTypeOf and resolveType and all the other stuff.
                type[fieldName.substring(2)] = resolverValue[fieldName];
                return;
            }
            if (type instanceof $lXoEQ.GraphQLScalarType) {
                type[fieldName] = resolverValue[fieldName];
                return;
            }
            if (type instanceof $lXoEQ.GraphQLEnumType) {
                if (!type.getValue(fieldName)) {
                    if (allowResolversNotInSchema) return;
                    throw new $cYGSS.SchemaError(typeName + "." + fieldName + " was defined in resolvers, but enum is not in schema");
                }
                // We've encountered an enum resolver that is being used to provide an
                // internal enum value.
                // Reference: https://www.apollographql.com/docs/graphql-tools/scalars.html#internal-values
                //
                // We're storing a map of the current enums external facing value to
                // its resolver provided internal value. This map is used to transform
                // the current schema to a new schema that includes enums with the new
                // internal value.
                enumValueMap[type.name] = enumValueMap[type.name] || {};
                enumValueMap[type.name][fieldName] = resolverValue[fieldName];
                return;
            }
            // object type
            var fields = $c35a59e5905db8e3$var$getFieldsForType(type);
            if (!fields) {
                if (allowResolversNotInSchema) return;
                throw new $cYGSS.SchemaError(typeName + " was defined in resolvers, but it's not an object");
            }
            if (!fields[fieldName]) {
                if (allowResolversNotInSchema) return;
                throw new $cYGSS.SchemaError(typeName + "." + fieldName + " defined in resolvers, but not in schema");
            }
            var field = fields[fieldName];
            var fieldResolve = resolverValue[fieldName];
            if (typeof fieldResolve === 'function') // for convenience. Allows shorter syntax in resolver definition file
            $c35a59e5905db8e3$var$setFieldProperties(field, {
                resolve: fieldResolve
            });
            else {
                if (typeof fieldResolve !== 'object') throw new $cYGSS.SchemaError("Resolver " + typeName + "." + fieldName + " must be object or function");
                $c35a59e5905db8e3$var$setFieldProperties(field, fieldResolve);
            }
        });
    });
    $cYGSS.checkForResolveTypeResolver(schema, requireResolversForResolveType);
    // If there are any enum resolver functions (that are used to return
    // internal enum values), create a new schema that includes enums with the
    // new internal facing values.
    var updatedSchema = $esVhq.applySchemaTransforms(schema, [
        new $l0ywS.default(enumValueMap)
    ]);
    return updatedSchema;
}
function $c35a59e5905db8e3$var$getFieldsForType(type) {
    if (type instanceof $lXoEQ.GraphQLObjectType || type instanceof $lXoEQ.GraphQLInterfaceType) return type.getFields();
    else return undefined;
}
function $c35a59e5905db8e3$var$setFieldProperties(field, propertiesObj) {
    Object.keys(propertiesObj).forEach(function(propertyName) {
        field[propertyName] = propertiesObj[propertyName];
    });
}
module.exports.default = $c35a59e5905db8e3$var$addResolveFunctionsToSchema;

});
parcelRegister("esVhq", function(module, exports) {
var $a8801cd741f34ae5$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $a8801cd741f34ae5$var$applySchemaTransforms(originalSchema, transforms) {
    return transforms.reduce(function(schema, transform) {
        return transform.transformSchema ? transform.transformSchema(schema) : schema;
    }, originalSchema);
}
module.exports.applySchemaTransforms = $a8801cd741f34ae5$var$applySchemaTransforms;
function $a8801cd741f34ae5$var$applyRequestTransforms(originalRequest, transforms) {
    return transforms.reduce(function(request, transform) {
        return transform.transformRequest ? transform.transformRequest(request) : request;
    }, originalRequest);
}
module.exports.applyRequestTransforms = $a8801cd741f34ae5$var$applyRequestTransforms;
function $a8801cd741f34ae5$var$applyResultTransforms(originalResult, transforms) {
    return transforms.reduce(function(result, transform) {
        return transform.transformResult ? transform.transformResult(result) : result;
    }, originalResult);
}
module.exports.applyResultTransforms = $a8801cd741f34ae5$var$applyResultTransforms;
function $a8801cd741f34ae5$var$composeTransforms() {
    var transforms = [];
    for(var _i = 0; _i < arguments.length; _i++)transforms[_i] = arguments[_i];
    var reverseTransforms = $a8801cd741f34ae5$var$__spreadArrays(transforms).reverse();
    return {
        transformSchema: function(originalSchema) {
            return $a8801cd741f34ae5$var$applySchemaTransforms(originalSchema, transforms);
        },
        transformRequest: function(originalRequest) {
            return $a8801cd741f34ae5$var$applyRequestTransforms(originalRequest, reverseTransforms);
        },
        transformResult: function(result) {
            return $a8801cd741f34ae5$var$applyResultTransforms(result, reverseTransforms);
        }
    };
}
module.exports.composeTransforms = $a8801cd741f34ae5$var$composeTransforms;

});

parcelRegister("l0ywS", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");

var $esiZ2 = parcelRequire("esiZ2");
// Transformation used to modifiy `GraphQLEnumType` values in a schema.
var $f4b461dd5b4b26c8$var$ConvertEnumValues = /** @class */ function() {
    function ConvertEnumValues(enumValueMap) {
        this.enumValueMap = enumValueMap;
    }
    // Walk a schema looking for `GraphQLEnumType` types. If found, and
    // matching types have been identified in `this.enumValueMap`, create new
    // `GraphQLEnumType` types using the `this.enumValueMap` specified new
    // values, and return them in the new schema.
    ConvertEnumValues.prototype.transformSchema = function(schema) {
        var _a;
        var enumValueMap = this.enumValueMap;
        if (!enumValueMap || Object.keys(enumValueMap).length === 0) return schema;
        var transformedSchema = $esiZ2.visitSchema(schema, (_a = {}, _a[$esiZ2.VisitSchemaKind.ENUM_TYPE] = function(enumType) {
            var externalToInternalValueMap = enumValueMap[enumType.name];
            if (externalToInternalValueMap) {
                var values = enumType.getValues();
                var newValues_1 = {};
                values.forEach(function(value) {
                    var newValue = Object.keys(externalToInternalValueMap).includes(value.name) ? externalToInternalValueMap[value.name] : value.name;
                    newValues_1[value.name] = {
                        value: newValue,
                        deprecationReason: value.deprecationReason,
                        description: value.description,
                        astNode: value.astNode
                    };
                });
                return new $lXoEQ.GraphQLEnumType({
                    name: enumType.name,
                    description: enumType.description,
                    astNode: enumType.astNode,
                    values: newValues_1
                });
            }
            return enumType;
        }, _a));
        return transformedSchema;
    };
    return ConvertEnumValues;
}();
module.exports.default = $f4b461dd5b4b26c8$var$ConvertEnumValues;

});
parcelRegister("esiZ2", function(module, exports) {
var $a86267ec7e8e9726$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $6BdRO = parcelRequire("6BdRO");

var $h8S1f = parcelRequire("h8S1f");
var $a86267ec7e8e9726$var$VisitSchemaKind;
(function(VisitSchemaKind) {
    VisitSchemaKind["TYPE"] = "VisitSchemaKind.TYPE";
    VisitSchemaKind["SCALAR_TYPE"] = "VisitSchemaKind.SCALAR_TYPE";
    VisitSchemaKind["ENUM_TYPE"] = "VisitSchemaKind.ENUM_TYPE";
    VisitSchemaKind["COMPOSITE_TYPE"] = "VisitSchemaKind.COMPOSITE_TYPE";
    VisitSchemaKind["OBJECT_TYPE"] = "VisitSchemaKind.OBJECT_TYPE";
    VisitSchemaKind["INPUT_OBJECT_TYPE"] = "VisitSchemaKind.INPUT_OBJECT_TYPE";
    VisitSchemaKind["ABSTRACT_TYPE"] = "VisitSchemaKind.ABSTRACT_TYPE";
    VisitSchemaKind["UNION_TYPE"] = "VisitSchemaKind.UNION_TYPE";
    VisitSchemaKind["INTERFACE_TYPE"] = "VisitSchemaKind.INTERFACE_TYPE";
    VisitSchemaKind["ROOT_OBJECT"] = "VisitSchemaKind.ROOT_OBJECT";
    VisitSchemaKind["QUERY"] = "VisitSchemaKind.QUERY";
    VisitSchemaKind["MUTATION"] = "VisitSchemaKind.MUTATION";
    VisitSchemaKind["SUBSCRIPTION"] = "VisitSchemaKind.SUBSCRIPTION";
})($a86267ec7e8e9726$var$VisitSchemaKind = module.exports.VisitSchemaKind || (module.exports.VisitSchemaKind = {}));
function $a86267ec7e8e9726$var$visitSchema(schema, visitor, stripResolvers) {
    var types = {};
    var resolveType = $h8S1f.createResolveType(function(name) {
        if (typeof types[name] === 'undefined') throw new Error("Can't find type " + name + ".");
        return types[name];
    });
    var queryType = schema.getQueryType();
    var mutationType = schema.getMutationType();
    var subscriptionType = schema.getSubscriptionType();
    var typeMap = schema.getTypeMap();
    Object.keys(typeMap).map(function(typeName) {
        var type = typeMap[typeName];
        if ($lXoEQ.isNamedType(type) && $lXoEQ.getNamedType(type).name.slice(0, 2) !== '__') {
            var specifiers = $a86267ec7e8e9726$var$getTypeSpecifiers(type, schema);
            var typeVisitor = $a86267ec7e8e9726$var$getVisitor(visitor, specifiers);
            if (typeVisitor) {
                var result = typeVisitor(type, schema);
                if (typeof result === 'undefined') types[typeName] = $h8S1f.recreateType(type, resolveType, !stripResolvers);
                else if (result === null) types[typeName] = null;
                else types[typeName] = $h8S1f.recreateType(result, resolveType, !stripResolvers);
            } else types[typeName] = $h8S1f.recreateType(type, resolveType, !stripResolvers);
        }
    });
    return new $6BdRO.GraphQLSchema({
        query: queryType ? types[queryType.name] : null,
        mutation: mutationType ? types[mutationType.name] : null,
        subscription: subscriptionType ? types[subscriptionType.name] : null,
        types: Object.keys(types).map(function(name) {
            return types[name];
        })
    });
}
module.exports.visitSchema = $a86267ec7e8e9726$var$visitSchema;
function $a86267ec7e8e9726$var$getTypeSpecifiers(type, schema) {
    var specifiers = [
        $a86267ec7e8e9726$var$VisitSchemaKind.TYPE
    ];
    if (type instanceof $lXoEQ.GraphQLObjectType) {
        specifiers.unshift($a86267ec7e8e9726$var$VisitSchemaKind.COMPOSITE_TYPE, $a86267ec7e8e9726$var$VisitSchemaKind.OBJECT_TYPE);
        var query = schema.getQueryType();
        var mutation = schema.getMutationType();
        var subscription = schema.getSubscriptionType();
        if (type === query) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.ROOT_OBJECT, $a86267ec7e8e9726$var$VisitSchemaKind.QUERY);
        else if (type === mutation) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.ROOT_OBJECT, $a86267ec7e8e9726$var$VisitSchemaKind.MUTATION);
        else if (type === subscription) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.ROOT_OBJECT, $a86267ec7e8e9726$var$VisitSchemaKind.SUBSCRIPTION);
    } else if (type instanceof $lXoEQ.GraphQLInputObjectType) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.INPUT_OBJECT_TYPE);
    else if (type instanceof $lXoEQ.GraphQLInterfaceType) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.COMPOSITE_TYPE, $a86267ec7e8e9726$var$VisitSchemaKind.ABSTRACT_TYPE, $a86267ec7e8e9726$var$VisitSchemaKind.INTERFACE_TYPE);
    else if (type instanceof $lXoEQ.GraphQLUnionType) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.COMPOSITE_TYPE, $a86267ec7e8e9726$var$VisitSchemaKind.ABSTRACT_TYPE, $a86267ec7e8e9726$var$VisitSchemaKind.UNION_TYPE);
    else if (type instanceof $lXoEQ.GraphQLEnumType) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.ENUM_TYPE);
    else if (type instanceof $lXoEQ.GraphQLScalarType) specifiers.push($a86267ec7e8e9726$var$VisitSchemaKind.SCALAR_TYPE);
    return specifiers;
}
function $a86267ec7e8e9726$var$getVisitor(visitor, specifiers) {
    var typeVisitor = null;
    var stack = $a86267ec7e8e9726$var$__spreadArrays(specifiers);
    while(!typeVisitor && stack.length > 0){
        var next = stack.pop();
        typeVisitor = visitor[next];
    }
    return typeVisitor;
}

});
parcelRegister("h8S1f", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");
var $bOniD = parcelRequire("bOniD");
var $1c4hI = parcelRequire("1c4hI");

var $kgFtY = parcelRequire("kgFtY");

var $j0Odg = parcelRequire("j0Odg");

var $8je8M = parcelRequire("8je8M");
function $c7ad1618233e9756$var$recreateType(type, resolveType, keepResolvers) {
    if (type instanceof $lXoEQ.GraphQLObjectType) {
        var fields_1 = type.getFields();
        var interfaces_1 = type.getInterfaces();
        return new $lXoEQ.GraphQLObjectType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            isTypeOf: keepResolvers ? type.isTypeOf : undefined,
            fields: function() {
                return $c7ad1618233e9756$var$fieldMapToFieldConfigMap(fields_1, resolveType, keepResolvers);
            },
            interfaces: function() {
                return interfaces_1.map(function(iface) {
                    return resolveType(iface);
                });
            }
        });
    } else if (type instanceof $lXoEQ.GraphQLInterfaceType) {
        var fields_2 = type.getFields();
        return new $lXoEQ.GraphQLInterfaceType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            fields: function() {
                return $c7ad1618233e9756$var$fieldMapToFieldConfigMap(fields_2, resolveType, keepResolvers);
            },
            resolveType: keepResolvers ? type.resolveType : function(parent, context, info) {
                return $j0Odg.default(parent, info.schema);
            }
        });
    } else if (type instanceof $lXoEQ.GraphQLUnionType) return new $lXoEQ.GraphQLUnionType({
        name: type.name,
        description: type.description,
        astNode: type.astNode,
        types: function() {
            return type.getTypes().map(function(unionMember) {
                return resolveType(unionMember);
            });
        },
        resolveType: keepResolvers ? type.resolveType : function(parent, context, info) {
            return $j0Odg.default(parent, info.schema);
        }
    });
    else if (type instanceof $lXoEQ.GraphQLInputObjectType) return new $lXoEQ.GraphQLInputObjectType({
        name: type.name,
        description: type.description,
        astNode: type.astNode,
        fields: function() {
            return $c7ad1618233e9756$var$inputFieldMapToFieldConfigMap(type.getFields(), resolveType);
        }
    });
    else if (type instanceof $lXoEQ.GraphQLEnumType) {
        var values = type.getValues();
        var newValues_1 = {};
        values.forEach(function(value) {
            newValues_1[value.name] = {
                value: value.value,
                deprecationReason: value.deprecationReason,
                description: value.description,
                astNode: value.astNode
            };
        });
        return new $lXoEQ.GraphQLEnumType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            values: newValues_1
        });
    } else if (type instanceof $lXoEQ.GraphQLScalarType) {
        if (keepResolvers || $kgFtY.default(type)) return type;
        else return new $lXoEQ.GraphQLScalarType({
            name: type.name,
            description: type.description,
            astNode: type.astNode,
            serialize: function(value) {
                return value;
            },
            parseValue: function(value) {
                return value;
            },
            parseLiteral: function(ast) {
                return $c7ad1618233e9756$var$parseLiteral(ast);
            }
        });
    } else throw new Error("Invalid type " + type);
}
module.exports.recreateType = $c7ad1618233e9756$var$recreateType;
function $c7ad1618233e9756$var$recreateDirective(directive, resolveType) {
    return new $bOniD.GraphQLDirective({
        name: directive.name,
        description: directive.description,
        locations: directive.locations,
        args: $c7ad1618233e9756$var$argsToFieldConfigArgumentMap(directive.args, resolveType),
        astNode: directive.astNode
    });
}
module.exports.recreateDirective = $c7ad1618233e9756$var$recreateDirective;
function $c7ad1618233e9756$var$parseLiteral(ast) {
    switch(ast.kind){
        case $1c4hI.Kind.STRING:
        case $1c4hI.Kind.BOOLEAN:
            return ast.value;
        case $1c4hI.Kind.INT:
        case $1c4hI.Kind.FLOAT:
            return parseFloat(ast.value);
        case $1c4hI.Kind.OBJECT:
            var value_1 = Object.create(null);
            ast.fields.forEach(function(field) {
                value_1[field.name.value] = $c7ad1618233e9756$var$parseLiteral(field.value);
            });
            return value_1;
        case $1c4hI.Kind.LIST:
            return ast.values.map($c7ad1618233e9756$var$parseLiteral);
        default:
            return null;
    }
}
function $c7ad1618233e9756$var$fieldMapToFieldConfigMap(fields, resolveType, keepResolvers) {
    var result = {};
    Object.keys(fields).forEach(function(name) {
        var field = fields[name];
        var type = resolveType(field.type);
        if (type !== null) result[name] = $c7ad1618233e9756$var$fieldToFieldConfig(fields[name], resolveType, keepResolvers);
    });
    return result;
}
module.exports.fieldMapToFieldConfigMap = $c7ad1618233e9756$var$fieldMapToFieldConfigMap;
function $c7ad1618233e9756$var$createResolveType(getType) {
    var resolveType = function(type) {
        if (type instanceof $lXoEQ.GraphQLList) {
            var innerType = resolveType(type.ofType);
            if (innerType === null) return null;
            else return new $lXoEQ.GraphQLList(innerType);
        } else if (type instanceof $lXoEQ.GraphQLNonNull) {
            var innerType = resolveType(type.ofType);
            if (innerType === null) return null;
            else return new $lXoEQ.GraphQLNonNull(innerType);
        } else if ($lXoEQ.isNamedType(type)) {
            var typeName = $lXoEQ.getNamedType(type).name;
            switch(typeName){
                case $auu22.GraphQLInt.name:
                    return $auu22.GraphQLInt;
                case $auu22.GraphQLFloat.name:
                    return $auu22.GraphQLFloat;
                case $auu22.GraphQLString.name:
                    return $auu22.GraphQLString;
                case $auu22.GraphQLBoolean.name:
                    return $auu22.GraphQLBoolean;
                case $auu22.GraphQLID.name:
                    return $auu22.GraphQLID;
                default:
                    return getType(typeName, type);
            }
        } else return type;
    };
    return resolveType;
}
module.exports.createResolveType = $c7ad1618233e9756$var$createResolveType;
function $c7ad1618233e9756$var$fieldToFieldConfig(field, resolveType, keepResolvers) {
    return {
        type: resolveType(field.type),
        args: $c7ad1618233e9756$var$argsToFieldConfigArgumentMap(field.args, resolveType),
        resolve: keepResolvers ? field.resolve : $8je8M.default,
        subscribe: keepResolvers ? field.subscribe : null,
        description: field.description,
        deprecationReason: field.deprecationReason,
        astNode: field.astNode
    };
}
module.exports.fieldToFieldConfig = $c7ad1618233e9756$var$fieldToFieldConfig;
function $c7ad1618233e9756$var$argsToFieldConfigArgumentMap(args, resolveType) {
    var result = {};
    args.forEach(function(arg) {
        var newArg = $c7ad1618233e9756$var$argumentToArgumentConfig(arg, resolveType);
        if (newArg) result[newArg[0]] = newArg[1];
    });
    return result;
}
module.exports.argsToFieldConfigArgumentMap = $c7ad1618233e9756$var$argsToFieldConfigArgumentMap;
function $c7ad1618233e9756$var$argumentToArgumentConfig(argument, resolveType) {
    var type = resolveType(argument.type);
    if (type === null) return null;
    else return [
        argument.name,
        {
            type: type,
            defaultValue: argument.defaultValue,
            description: argument.description
        }
    ];
}
module.exports.argumentToArgumentConfig = $c7ad1618233e9756$var$argumentToArgumentConfig;
function $c7ad1618233e9756$var$inputFieldMapToFieldConfigMap(fields, resolveType) {
    var result = {};
    Object.keys(fields).forEach(function(name) {
        var field = fields[name];
        var type = resolveType(field.type);
        if (type !== null) result[name] = $c7ad1618233e9756$var$inputFieldToFieldConfig(fields[name], resolveType);
    });
    return result;
}
module.exports.inputFieldMapToFieldConfigMap = $c7ad1618233e9756$var$inputFieldMapToFieldConfigMap;
function $c7ad1618233e9756$var$inputFieldToFieldConfig(field, resolveType) {
    return {
        type: resolveType(field.type),
        defaultValue: field.defaultValue,
        description: field.description,
        astNode: field.astNode
    };
}
module.exports.inputFieldToFieldConfig = $c7ad1618233e9756$var$inputFieldToFieldConfig;

});
parcelRegister("kgFtY", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");
// FIXME: Replace with https://github.com/graphql/graphql-js/blob/master/src/type/scalars.js#L139
module.exports.specifiedScalarTypes = [
    $auu22.GraphQLString,
    $auu22.GraphQLInt,
    $auu22.GraphQLFloat,
    $auu22.GraphQLBoolean,
    $auu22.GraphQLID
];
function $ec157ad38f1a9f87$var$isSpecifiedScalarType(type) {
    return $lXoEQ.isNamedType(type) && // Would prefer to use specifiedScalarTypes.some(), however %checks needs
    // a simple expression.
    (type.name === $auu22.GraphQLString.name || type.name === $auu22.GraphQLInt.name || type.name === $auu22.GraphQLFloat.name || type.name === $auu22.GraphQLBoolean.name || type.name === $auu22.GraphQLID.name);
}
module.exports.default = $ec157ad38f1a9f87$var$isSpecifiedScalarType;

});

parcelRegister("j0Odg", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
function $dd74f7a1403eef9b$var$resolveFromParentTypename(parent, schema) {
    var parentTypename = parent['__typename'];
    if (!parentTypename) throw new Error('Did not fetch typename for object, unable to resolve interface.');
    var resolvedType = schema.getType(parentTypename);
    if (!(resolvedType instanceof $lXoEQ.GraphQLObjectType)) throw new Error('__typename did not match an object type: ' + parentTypename);
    return resolvedType;
}
module.exports.default = $dd74f7a1403eef9b$var$resolveFromParentTypename;

});

parcelRegister("8je8M", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kZHaf = parcelRequire("kZHaf");

var $02KAV = parcelRequire("02KAV");

var $10LTa = parcelRequire("10LTa");

var $57Vxb = parcelRequire("57Vxb");
// Resolver that knows how to:
// a) handle aliases for proxied schemas
// b) handle errors from proxied schemas
var $60cb111eb226f1bd$var$defaultMergedResolver = function(parent, args, context, info) {
    if (!parent) return null;
    var responseKey = $57Vxb.getResponseKeyFromInfo(info);
    var errorResult = $10LTa.getErrorsFromParent(parent, responseKey);
    if (errorResult.kind === 'OWN') throw $02KAV.locatedError(new Error(errorResult.error.message), info.fieldNodes, $kZHaf.pathToArray(info.path));
    var result = parent[responseKey];
    if (result == null) result = parent[info.fieldName];
    // subscription result mapping
    if (!result && parent.data && parent.data[responseKey]) result = parent.data[responseKey];
    if (errorResult.errors) result = $10LTa.annotateWithChildrenErrors(result, errorResult.errors);
    return result;
};
module.exports.default = $60cb111eb226f1bd$var$defaultMergedResolver;

});
parcelRegister("10LTa", function(module, exports) {
var $0bcaf03a9acca47e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0bcaf03a9acca47e$var$__assign = module.exports && module.exports.__assign || function() {
    $0bcaf03a9acca47e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0bcaf03a9acca47e$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kZHaf = parcelRequire("kZHaf");

var $02KAV = parcelRequire("02KAV");

var $57Vxb = parcelRequire("57Vxb");
if (typeof $parcel$global !== 'undefined' && 'Symbol' in $parcel$global || typeof window !== 'undefined' && 'Symbol' in window) module.exports.ERROR_SYMBOL = Symbol('subSchemaErrors');
else module.exports.ERROR_SYMBOL = '@@__subSchemaErrors';
function $0bcaf03a9acca47e$var$annotateWithChildrenErrors(object, childrenErrors) {
    var _a;
    if (!childrenErrors || childrenErrors.length === 0) // Nothing to see here, move along
    return object;
    if (Array.isArray(object)) {
        var byIndex_1 = {};
        childrenErrors.forEach(function(error) {
            if (!error.path) return;
            var index = error.path[1];
            var current = byIndex_1[index] || [];
            current.push($0bcaf03a9acca47e$var$__assign($0bcaf03a9acca47e$var$__assign({}, error), {
                path: error.path.slice(1)
            }));
            byIndex_1[index] = current;
        });
        return object.map(function(item, index) {
            return $0bcaf03a9acca47e$var$annotateWithChildrenErrors(item, byIndex_1[index]);
        });
    }
    return $0bcaf03a9acca47e$var$__assign($0bcaf03a9acca47e$var$__assign({}, object), (_a = {}, _a[module.exports.ERROR_SYMBOL] = childrenErrors.map(function(error) {
        return $0bcaf03a9acca47e$var$__assign($0bcaf03a9acca47e$var$__assign({}, error), error.path ? {
            path: error.path.slice(1)
        } : {});
    }), _a));
}
module.exports.annotateWithChildrenErrors = $0bcaf03a9acca47e$var$annotateWithChildrenErrors;
function $0bcaf03a9acca47e$var$getErrorsFromParent(object, fieldName) {
    var errors = object && object[module.exports.ERROR_SYMBOL] || [];
    var childrenErrors = [];
    for(var _i = 0, errors_1 = errors; _i < errors_1.length; _i++){
        var error = errors_1[_i];
        if (!error.path || error.path.length === 1 && error.path[0] === fieldName) return {
            kind: 'OWN',
            error: error
        };
        else if (error.path[0] === fieldName) childrenErrors.push(error);
    }
    return {
        kind: 'CHILDREN',
        errors: childrenErrors
    };
}
module.exports.getErrorsFromParent = $0bcaf03a9acca47e$var$getErrorsFromParent;
var $0bcaf03a9acca47e$var$CombinedError = /** @class */ function(_super) {
    $0bcaf03a9acca47e$var$__extends(CombinedError, _super);
    function CombinedError(message, errors) {
        var _this = _super.call(this, message) || this;
        _this.errors = errors;
        return _this;
    }
    return CombinedError;
}(Error);
function $0bcaf03a9acca47e$var$checkResultAndHandleErrors(result, info, responseKey) {
    if (!responseKey) responseKey = $57Vxb.getResponseKeyFromInfo(info);
    if (result.errors && (!result.data || result.data[responseKey] == null)) {
        // apollo-link-http & http-link-dataloader need the
        // result property to be passed through for better error handling.
        // If there is only one error, which contains a result property, pass the error through
        var newError = result.errors.length === 1 && $0bcaf03a9acca47e$var$hasResult(result.errors[0]) ? result.errors[0] : new $0bcaf03a9acca47e$var$CombinedError($0bcaf03a9acca47e$var$concatErrors(result.errors), result.errors);
        throw $02KAV.locatedError(newError, info.fieldNodes, $kZHaf.pathToArray(info.path));
    }
    var resultObject = result.data[responseKey];
    if (result.errors) resultObject = $0bcaf03a9acca47e$var$annotateWithChildrenErrors(resultObject, result.errors);
    return resultObject;
}
module.exports.checkResultAndHandleErrors = $0bcaf03a9acca47e$var$checkResultAndHandleErrors;
function $0bcaf03a9acca47e$var$concatErrors(errors) {
    return errors.map(function(error) {
        return error.message;
    }).join('\n');
}
function $0bcaf03a9acca47e$var$hasResult(error) {
    return error.result || error.extensions || error.originalError && error.originalError.result;
}

});
parcelRegister("57Vxb", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Get the key under which the result of this resolver will be placed in the response JSON. Basically, just
 * resolves aliases.
 * @param info The info argument to the resolver.
 */ function $3bba3c508f8a2a51$var$getResponseKeyFromInfo(info) {
    return info.fieldNodes[0].alias ? info.fieldNodes[0].alias.value : info.fieldName;
}
module.exports.getResponseKeyFromInfo = $3bba3c508f8a2a51$var$getResponseKeyFromInfo;

});







parcelRegister("lQXQV", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");
// wraps all resolve functions of query, mutation or subscription fields
// with the provided function to simulate a root schema level resolve funciton
function $fe8ce1cef8f746df$var$addSchemaLevelResolveFunction(schema, fn) {
    // TODO test that schema is a schema, fn is a function
    var rootTypes = [
        schema.getQueryType(),
        schema.getMutationType(),
        schema.getSubscriptionType()
    ].filter(function(x) {
        return !!x;
    });
    rootTypes.forEach(function(type) {
        // XXX this should run at most once per request to simulate a true root resolver
        // for graphql-js this is an approximation that works with queries but not mutations
        var rootResolveFn = $fe8ce1cef8f746df$var$runAtMostOncePerRequest(fn);
        var fields = type.getFields();
        Object.keys(fields).forEach(function(fieldName) {
            // XXX if the type is a subscription, a same query AST will be ran multiple times so we
            // deactivate here the runOnce if it's a subscription. This may not be optimal though...
            if (type === schema.getSubscriptionType()) fields[fieldName].resolve = $fe8ce1cef8f746df$var$wrapResolver(fields[fieldName].resolve, fn);
            else fields[fieldName].resolve = $fe8ce1cef8f746df$var$wrapResolver(fields[fieldName].resolve, rootResolveFn);
        });
    });
}
// XXX badly named function. this doesn't really wrap, it just chains resolvers...
function $fe8ce1cef8f746df$var$wrapResolver(innerResolver, outerResolver) {
    return function(obj, args, ctx, info) {
        return Promise.resolve(outerResolver(obj, args, ctx, info)).then(function(root) {
            if (innerResolver) return innerResolver(root, args, ctx, info);
            return $3MP74.defaultFieldResolver(root, args, ctx, info);
        });
    };
}
// XXX this function only works for resolvers
// XXX very hacky way to remember if the function
// already ran for this request. This will only work
// if people don't actually cache the operation.
// if they do cache the operation, they will have to
// manually remove the __runAtMostOnce before every request.
function $fe8ce1cef8f746df$var$runAtMostOncePerRequest(fn) {
    var value;
    var randomNumber = Math.random();
    return function(root, args, ctx, info) {
        if (!info.operation['__runAtMostOnce']) info.operation['__runAtMostOnce'] = {};
        if (!info.operation['__runAtMostOnce'][randomNumber]) {
            info.operation['__runAtMostOnce'][randomNumber] = true;
            value = fn(root, args, ctx, info);
        }
        return value;
    };
}
module.exports.default = $fe8ce1cef8f746df$var$addSchemaLevelResolveFunction;

});

parcelRegister("7ZqjT", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");

var $cYGSS = parcelRequire("cYGSS");
function $5d12a578553eba05$var$assertResolveFunctionsPresent(schema, resolverValidationOptions) {
    if (resolverValidationOptions === void 0) resolverValidationOptions = {};
    var _a = resolverValidationOptions.requireResolversForArgs, requireResolversForArgs = _a === void 0 ? false : _a, _b = resolverValidationOptions.requireResolversForNonScalar, requireResolversForNonScalar = _b === void 0 ? false : _b, _c = resolverValidationOptions.requireResolversForAllFields, requireResolversForAllFields = _c === void 0 ? false : _c;
    if (requireResolversForAllFields && (requireResolversForArgs || requireResolversForNonScalar)) throw new TypeError("requireResolversForAllFields takes precedence over the more specific assertions. Please configure either requireResolversForAllFields or requireResolversForArgs / requireResolversForNonScalar, but not a combination of them.");
    $cYGSS.forEachField(schema, function(field, typeName, fieldName) {
        // requires a resolve function for *every* field.
        if (requireResolversForAllFields) $5d12a578553eba05$var$expectResolveFunction(field, typeName, fieldName);
        // requires a resolve function on every field that has arguments
        if (requireResolversForArgs && field.args.length > 0) $5d12a578553eba05$var$expectResolveFunction(field, typeName, fieldName);
        // requires a resolve function on every field that returns a non-scalar type
        if (requireResolversForNonScalar && !($lXoEQ.getNamedType(field.type) instanceof $lXoEQ.GraphQLScalarType)) $5d12a578553eba05$var$expectResolveFunction(field, typeName, fieldName);
    });
}
function $5d12a578553eba05$var$expectResolveFunction(field, typeName, fieldName) {
    if (!field.resolve) {
        console.warn(// tslint:disable-next-line: max-line-length
        "Resolve function missing for \"" + typeName + "." + fieldName + "\". To disable this warning check https://github.com/apollostack/graphql-tools/issues/131");
        return;
    }
    if (typeof field.resolve !== 'function') throw new $cYGSS.SchemaError("Resolver \"" + typeName + "." + fieldName + "\" must be a function");
}
module.exports.default = $5d12a578553eba05$var$assertResolveFunctionsPresent;

});

parcelRegister("glxQ5", function(module, exports) {
var $be68db39ae07a569$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $be68db39ae07a569$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $be68db39ae07a569$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");

var $gVW6u = parcelRequire("gVW6u");
function $be68db39ae07a569$var$attachDirectiveResolvers(schema, directiveResolvers) {
    if (typeof directiveResolvers !== 'object') throw new Error("Expected directiveResolvers to be of type object, got " + typeof directiveResolvers);
    if (Array.isArray(directiveResolvers)) throw new Error('Expected directiveResolvers to be of type object, got Array');
    var schemaDirectives = Object.create(null);
    Object.keys(directiveResolvers).forEach(function(directiveName) {
        schemaDirectives[directiveName] = /** @class */ function(_super) {
            $be68db39ae07a569$var$__extends(class_1, _super);
            function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            class_1.prototype.visitFieldDefinition = function(field) {
                var _this = this;
                var resolver = directiveResolvers[directiveName];
                var originalResolver = field.resolve || $3MP74.defaultFieldResolver;
                var directiveArgs = this.args;
                field.resolve = function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var source = args[0], context = args[2], info = args[3];
                    return resolver(function() {
                        return $be68db39ae07a569$var$__awaiter(_this, void 0, void 0, function() {
                            return $be68db39ae07a569$var$__generator(this, function(_a) {
                                return [
                                    2 /*return*/ ,
                                    originalResolver.apply(field, args)
                                ];
                            });
                        });
                    }, source, directiveArgs, context, info);
                };
            };
            return class_1;
        }($gVW6u.SchemaDirectiveVisitor);
    });
    $gVW6u.SchemaDirectiveVisitor.visitSchemaDirectives(schema, schemaDirectives);
}
module.exports.default = $be68db39ae07a569$var$attachDirectiveResolvers;

});

parcelRegister("4Vy0J", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6BdRO = parcelRequire("6BdRO");

var $ie50m = parcelRequire("ie50m");

var $cYGSS = parcelRequire("cYGSS");
// takes a GraphQL-JS schema and an object of connectors, then attaches
// the connectors to the context by wrapping each query or mutation resolve
// function with a function that attaches connectors if they don't exist.
// attaches connectors only once to make sure they are singletons
var $3966de2652c7f7e4$var$attachConnectorsToContext = $ie50m.deprecated({
    version: '0.7.0',
    url: 'https://github.com/apollostack/graphql-tools/issues/140'
}, function(schema, connectors) {
    if (!schema || !(schema instanceof $6BdRO.GraphQLSchema)) throw new Error("schema must be an instance of GraphQLSchema. This error could be caused by installing more than one version of GraphQL-JS");
    if (typeof connectors !== 'object') {
        var connectorType = typeof connectors;
        throw new Error("Expected connectors to be of type object, got " + connectorType);
    }
    if (Object.keys(connectors).length === 0) throw new Error('Expected connectors to not be an empty object');
    if (Array.isArray(connectors)) throw new Error('Expected connectors to be of type object, got Array');
    if (schema['_apolloConnectorsAttached']) throw new Error('Connectors already attached to context, cannot attach more than once');
    schema['_apolloConnectorsAttached'] = true;
    var attachconnectorFn = function(root, args, ctx) {
        if (typeof ctx !== 'object') {
            // if in any way possible, we should throw an error when the attachconnectors
            // function is called, not when a query is executed.
            var contextType = typeof ctx;
            throw new Error("Cannot attach connector because context is not an object: " + contextType);
        }
        if (typeof ctx.connectors === 'undefined') ctx.connectors = {};
        Object.keys(connectors).forEach(function(connectorName) {
            var connector = connectors[connectorName];
            if (!!connector.prototype) ctx.connectors[connectorName] = new connector(ctx);
            else throw new Error("Connector must be a function or an class");
        });
        return root;
    };
    $cYGSS.addSchemaLevelResolveFunction(schema, attachconnectorFn);
});
module.exports.default = $3966de2652c7f7e4$var$attachConnectorsToContext;

});
parcelRegister("ie50m", function(module, exports) {
/*
    Deprecated Decorator v0.1
    https://github.com/vilic/deprecated-decorator
*/ "use strict";
/** @internal */ module.exports.options = {
    getWarner: undefined
};
function $d44d6aab074f7c0d$var$createWarner(type, name, alternative, version, url) {
    var warnedPositions = {};
    return function() {
        var stack = new Error().stack || '';
        var at = (stack.match(/(?:\s+at\s.+){2}\s+at\s(.+)/) || [
            undefined,
            ''
        ])[1];
        if (/\)$/.test(at)) at = at.match(/[^(]+(?=\)$)/)[0];
        else at = at.trim();
        if (at in warnedPositions) return;
        warnedPositions[at] = true;
        var message;
        switch(type){
            case 'class':
                message = 'Class';
                break;
            case 'property':
                message = 'Property';
                break;
            case 'method':
                message = 'Method';
                break;
            case 'function':
                message = 'Function';
                break;
        }
        message += " `" + name + "` has been deprecated";
        if (version) message += " since version " + version;
        if (alternative) message += ", use `" + alternative + "` instead";
        message += '.';
        if (at) message += "\n    at " + at;
        if (url) message += "\nCheck out " + url + " for more information.";
        console.warn(message);
    };
}
function $d44d6aab074f7c0d$var$decorateProperty(type, name, descriptor, alternative, version, url) {
    var warner = (module.exports.options.getWarner || $d44d6aab074f7c0d$var$createWarner)(type, name, alternative, version, url);
    descriptor = descriptor || {
        writable: true,
        enumerable: false,
        configurable: true
    };
    var deprecatedDescriptor = {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable
    };
    if (descriptor.get || descriptor.set) {
        if (descriptor.get) deprecatedDescriptor.get = function() {
            warner();
            return descriptor.get.call(this);
        };
        if (descriptor.set) deprecatedDescriptor.set = function(value) {
            warner();
            return descriptor.set.call(this, value);
        };
    } else {
        var propertyValue_1 = descriptor.value;
        deprecatedDescriptor.get = function() {
            warner();
            return propertyValue_1;
        };
        if (descriptor.writable) deprecatedDescriptor.set = function(value) {
            warner();
            propertyValue_1 = value;
        };
    }
    return deprecatedDescriptor;
}
function $d44d6aab074f7c0d$var$decorateFunction(type, target, alternative, version, url) {
    var name = target.name;
    var warner = (module.exports.options.getWarner || $d44d6aab074f7c0d$var$createWarner)(type, name, alternative, version, url);
    var fn = function() {
        warner();
        return target.apply(this, arguments);
    };
    for(var _i = 0, _a = Object.getOwnPropertyNames(target); _i < _a.length; _i++){
        var propertyName = _a[_i];
        var descriptor = Object.getOwnPropertyDescriptor(target, propertyName);
        if (descriptor.writable) fn[propertyName] = target[propertyName];
        else if (descriptor.configurable) Object.defineProperty(fn, propertyName, descriptor);
    }
    return fn;
}
function $d44d6aab074f7c0d$var$deprecated() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
    var fn = args[args.length - 1];
    if (typeof fn === 'function') fn = args.pop();
    else fn = undefined;
    var options = args[0];
    var alternative;
    var version;
    var url;
    if (typeof options === 'string') {
        alternative = options;
        version = args[1];
        url = args[2];
    } else if (options) alternative = options.alternative, version = options.version, url = options.url, options;
    if (fn) return $d44d6aab074f7c0d$var$decorateFunction('function', fn, alternative, version, url);
    return function(target, name, descriptor) {
        if (typeof name === 'string') {
            var type = descriptor && typeof descriptor.value === 'function' ? 'method' : 'property';
            return $d44d6aab074f7c0d$var$decorateProperty(type, name, descriptor, alternative, version, url);
        } else if (typeof target === 'function') {
            var constructor = $d44d6aab074f7c0d$var$decorateFunction('class', target, alternative, version, url);
            var className = target.name;
            for(var _i = 0, _a = Object.getOwnPropertyNames(constructor); _i < _a.length; _i++){
                var propertyName = _a[_i];
                var descriptor_1 = Object.getOwnPropertyDescriptor(constructor, propertyName);
                descriptor_1 = $d44d6aab074f7c0d$var$decorateProperty('class', className, descriptor_1, alternative, version, url);
                if (descriptor_1.writable) constructor[propertyName] = target[propertyName];
                else if (descriptor_1.configurable) Object.defineProperty(constructor, propertyName, descriptor_1);
            }
            return constructor;
        }
    };
}
module.exports.deprecated = $d44d6aab074f7c0d$var$deprecated;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d44d6aab074f7c0d$var$deprecated;

});


parcelRegister("kYZ7H", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gUA8G = parcelRequire("gUA8G");
var $glHRe = parcelRequire("glHRe");
var $6ds0g = parcelRequire("6ds0g");

var $cYGSS = parcelRequire("cYGSS");

var $9Dtw4 = parcelRequire("9Dtw4");
function $f468d303274a5a69$var$buildSchemaFromTypeDefinitions(typeDefinitions, parseOptions) {
    // TODO: accept only array here, otherwise interfaces get confusing.
    var myDefinitions = typeDefinitions;
    var astDocument;
    if ($f468d303274a5a69$var$isDocumentNode(typeDefinitions)) astDocument = typeDefinitions;
    else if (typeof myDefinitions !== 'string') {
        if (!Array.isArray(myDefinitions)) {
            var type = typeof myDefinitions;
            throw new $cYGSS.SchemaError("typeDefs must be a string, array or schema AST, got " + type);
        }
        myDefinitions = $cYGSS.concatenateTypeDefs(myDefinitions);
    }
    if (typeof myDefinitions === 'string') astDocument = $6ds0g.parse(myDefinitions, parseOptions);
    var backcompatOptions = {
        commentDescriptions: true
    };
    var typesAst = $9Dtw4.default(astDocument);
    // TODO fix types https://github.com/apollographql/graphql-tools/issues/542
    var schema = $gUA8G.buildASTSchema(typesAst, backcompatOptions);
    var extensionsAst = $cYGSS.extractExtensionDefinitions(astDocument);
    if (extensionsAst.definitions.length > 0) // TODO fix types https://github.com/apollographql/graphql-tools/issues/542
    schema = $glHRe.extendSchema(schema, extensionsAst, backcompatOptions);
    return schema;
}
function $f468d303274a5a69$var$isDocumentNode(typeDefinitions) {
    return typeDefinitions.kind !== undefined;
}
module.exports.default = $f468d303274a5a69$var$buildSchemaFromTypeDefinitions;

});
parcelRegister("gUA8G", function(module, exports) {

$parcel$export(module.exports, "buildASTSchema", () => $7def873e387d0baa$export$25eeb85cb306d87);
$parcel$export(module.exports, "buildSchema", () => $7def873e387d0baa$export$f668ee82107a74bd);

var $fZdRY = parcelRequire("fZdRY");

var $1c4hI = parcelRequire("1c4hI");

var $6ds0g = parcelRequire("6ds0g");

var $dGflO = parcelRequire("dGflO");

var $6BdRO = parcelRequire("6BdRO");

var $bOniD = parcelRequire("bOniD");

var $glHRe = parcelRequire("glHRe");
function $7def873e387d0baa$export$25eeb85cb306d87(documentAST, options) {
    documentAST != null && documentAST.kind === (0, $1c4hI.Kind).DOCUMENT || (0, $fZdRY.default)(0, 'Must provide valid Document AST.');
    if ((options === null || options === void 0 ? void 0 : options.assumeValid) !== true && (options === null || options === void 0 ? void 0 : options.assumeValidSDL) !== true) (0, $dGflO.assertValidSDL)(documentAST);
    var emptySchemaConfig = {
        description: undefined,
        types: [],
        directives: [],
        extensions: undefined,
        extensionASTNodes: [],
        assumeValid: false
    };
    var config = (0, $glHRe.extendSchemaImpl)(emptySchemaConfig, documentAST, options);
    if (config.astNode == null) for(var _i2 = 0, _config$types2 = config.types; _i2 < _config$types2.length; _i2++){
        var type = _config$types2[_i2];
        switch(type.name){
            // Note: While this could make early assertions to get the correctly
            // typed values below, that would throw immediately while type system
            // validation with validateSchema() will produce more actionable results.
            case 'Query':
                config.query = type;
                break;
            case 'Mutation':
                config.mutation = type;
                break;
            case 'Subscription':
                config.subscription = type;
                break;
        }
    }
    var directives = config.directives; // If specified directives were not explicitly declared, add them.
    var _loop = function _loop(_i4) {
        var stdDirective = (0, $bOniD.specifiedDirectives)[_i4];
        if (directives.every(function(directive) {
            return directive.name !== stdDirective.name;
        })) directives.push(stdDirective);
    };
    for(var _i4 = 0; _i4 < (0, $bOniD.specifiedDirectives).length; _i4++)_loop(_i4);
    return new (0, $6BdRO.GraphQLSchema)(config);
}
function $7def873e387d0baa$export$f668ee82107a74bd(source, options) {
    var document = (0, $6ds0g.parse)(source, {
        noLocation: options === null || options === void 0 ? void 0 : options.noLocation,
        allowLegacySDLEmptyFields: options === null || options === void 0 ? void 0 : options.allowLegacySDLEmptyFields,
        allowLegacySDLImplementsInterfaces: options === null || options === void 0 ? void 0 : options.allowLegacySDLImplementsInterfaces,
        experimentalFragmentVariables: options === null || options === void 0 ? void 0 : options.experimentalFragmentVariables
    });
    return $7def873e387d0baa$export$25eeb85cb306d87(document, {
        commentDescriptions: options === null || options === void 0 ? void 0 : options.commentDescriptions,
        assumeValidSDL: options === null || options === void 0 ? void 0 : options.assumeValidSDL,
        assumeValid: options === null || options === void 0 ? void 0 : options.assumeValid
    });
}

});
parcelRegister("dGflO", function(module, exports) {

$parcel$export(module.exports, "validate", () => $2cc2c5fa39eae947$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "assertValidSDL", () => $2cc2c5fa39eae947$export$e53e4d7168bd6d92);
$parcel$export(module.exports, "assertValidSDLExtension", () => $2cc2c5fa39eae947$export$9917845776f624a4);

var $fZdRY = parcelRequire("fZdRY");

var $9fgMZ = parcelRequire("9fgMZ");

var $961BR = parcelRequire("961BR");

var $izaFt = parcelRequire("izaFt");

var $hMOry = parcelRequire("hMOry");

var $k6EZ2 = parcelRequire("k6EZ2");

var $5RV6E = parcelRequire("5RV6E");
function $2cc2c5fa39eae947$export$a22775fa5e2eebd9(schema, documentAST) {
    var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $k6EZ2.specifiedRules);
    var typeInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new (0, $hMOry.TypeInfo)(schema);
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        maxErrors: undefined
    };
    documentAST || (0, $fZdRY.default)(0, 'Must provide document.'); // If the schema used for validation is invalid, throw an error.
    (0, $izaFt.assertValidSchema)(schema);
    var abortObj = Object.freeze({});
    var errors = [];
    var context = new (0, $5RV6E.ValidationContext)(schema, documentAST, typeInfo, function(error) {
        if (options.maxErrors != null && errors.length >= options.maxErrors) {
            errors.push(new (0, $9fgMZ.GraphQLError)('Too many validation errors, error limit reached. Validation aborted.'));
            throw abortObj;
        }
        errors.push(error);
    }); // This uses a specialized visitor which runs multiple visitors in parallel,
    // while maintaining the visitor skip and break API.
    var visitor = (0, $961BR.visitInParallel)(rules.map(function(rule) {
        return rule(context);
    })); // Visit the whole document with each instance of all provided rules.
    try {
        (0, $961BR.visit)(documentAST, (0, $hMOry.visitWithTypeInfo)(typeInfo, visitor));
    } catch (e) {
        if (e !== abortObj) throw e;
    }
    return errors;
}
function $2cc2c5fa39eae947$export$664b3e1af4fc59b0(documentAST, schemaToExtend) {
    var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $k6EZ2.specifiedSDLRules);
    var errors = [];
    var context = new (0, $5RV6E.SDLValidationContext)(documentAST, schemaToExtend, function(error) {
        errors.push(error);
    });
    var visitors = rules.map(function(rule) {
        return rule(context);
    });
    (0, $961BR.visit)(documentAST, (0, $961BR.visitInParallel)(visitors));
    return errors;
}
function $2cc2c5fa39eae947$export$e53e4d7168bd6d92(documentAST) {
    var errors = $2cc2c5fa39eae947$export$664b3e1af4fc59b0(documentAST);
    if (errors.length !== 0) throw new Error(errors.map(function(error) {
        return error.message;
    }).join('\n\n'));
}
function $2cc2c5fa39eae947$export$9917845776f624a4(documentAST, schema) {
    var errors = $2cc2c5fa39eae947$export$664b3e1af4fc59b0(documentAST, schema);
    if (errors.length !== 0) throw new Error(errors.map(function(error) {
        return error.message;
    }).join('\n\n'));
}

});
parcelRegister("hMOry", function(module, exports) {

$parcel$export(module.exports, "TypeInfo", () => $3a9a642677abfb9d$export$f0c1fe746ce4bb1e);
$parcel$export(module.exports, "visitWithTypeInfo", () => $3a9a642677abfb9d$export$18ca434620348336);

var $bmIpK = parcelRequire("bmIpK");

var $1c4hI = parcelRequire("1c4hI");

var $c8MIO = parcelRequire("c8MIO");

var $961BR = parcelRequire("961BR");

var $lXoEQ = parcelRequire("lXoEQ");

var $h2iUh = parcelRequire("h2iUh");

var $3zSAT = parcelRequire("3zSAT");
var $3a9a642677abfb9d$export$f0c1fe746ce4bb1e = /*#__PURE__*/ function() {
    function TypeInfo(schema, // to support non-spec-compliant code bases. You should never need to use it.
    // It may disappear in the future.
    getFieldDefFn, // beginning somewhere other than documents.
    initialType) {
        this._schema = schema;
        this._typeStack = [];
        this._parentTypeStack = [];
        this._inputTypeStack = [];
        this._fieldDefStack = [];
        this._defaultValueStack = [];
        this._directive = null;
        this._argument = null;
        this._enumValue = null;
        this._getFieldDef = getFieldDefFn !== null && getFieldDefFn !== void 0 ? getFieldDefFn : $3a9a642677abfb9d$var$getFieldDef;
        if (initialType) {
            if ((0, $lXoEQ.isInputType)(initialType)) this._inputTypeStack.push(initialType);
            if ((0, $lXoEQ.isCompositeType)(initialType)) this._parentTypeStack.push(initialType);
            if ((0, $lXoEQ.isOutputType)(initialType)) this._typeStack.push(initialType);
        }
    }
    var _proto = TypeInfo.prototype;
    _proto.getType = function getType() {
        if (this._typeStack.length > 0) return this._typeStack[this._typeStack.length - 1];
    };
    _proto.getParentType = function getParentType() {
        if (this._parentTypeStack.length > 0) return this._parentTypeStack[this._parentTypeStack.length - 1];
    };
    _proto.getInputType = function getInputType() {
        if (this._inputTypeStack.length > 0) return this._inputTypeStack[this._inputTypeStack.length - 1];
    };
    _proto.getParentInputType = function getParentInputType() {
        if (this._inputTypeStack.length > 1) return this._inputTypeStack[this._inputTypeStack.length - 2];
    };
    _proto.getFieldDef = function getFieldDef() {
        if (this._fieldDefStack.length > 0) return this._fieldDefStack[this._fieldDefStack.length - 1];
    };
    _proto.getDefaultValue = function getDefaultValue() {
        if (this._defaultValueStack.length > 0) return this._defaultValueStack[this._defaultValueStack.length - 1];
    };
    _proto.getDirective = function getDirective() {
        return this._directive;
    };
    _proto.getArgument = function getArgument() {
        return this._argument;
    };
    _proto.getEnumValue = function getEnumValue() {
        return this._enumValue;
    };
    _proto.enter = function enter(node) {
        var schema = this._schema; // Note: many of the types below are explicitly typed as "mixed" to drop
        // any assumptions of a valid schema to ensure runtime types are properly
        // checked before continuing since TypeInfo is used as part of validation
        // which occurs before guarantees of schema and document validity.
        switch(node.kind){
            case (0, $1c4hI.Kind).SELECTION_SET:
                var namedType = (0, $lXoEQ.getNamedType)(this.getType());
                this._parentTypeStack.push((0, $lXoEQ.isCompositeType)(namedType) ? namedType : undefined);
                break;
            case (0, $1c4hI.Kind).FIELD:
                var parentType = this.getParentType();
                var fieldDef;
                var fieldType;
                if (parentType) {
                    fieldDef = this._getFieldDef(schema, parentType, node);
                    if (fieldDef) fieldType = fieldDef.type;
                }
                this._fieldDefStack.push(fieldDef);
                this._typeStack.push((0, $lXoEQ.isOutputType)(fieldType) ? fieldType : undefined);
                break;
            case (0, $1c4hI.Kind).DIRECTIVE:
                this._directive = schema.getDirective(node.name.value);
                break;
            case (0, $1c4hI.Kind).OPERATION_DEFINITION:
                var type;
                switch(node.operation){
                    case 'query':
                        type = schema.getQueryType();
                        break;
                    case 'mutation':
                        type = schema.getMutationType();
                        break;
                    case 'subscription':
                        type = schema.getSubscriptionType();
                        break;
                }
                this._typeStack.push((0, $lXoEQ.isObjectType)(type) ? type : undefined);
                break;
            case (0, $1c4hI.Kind).INLINE_FRAGMENT:
            case (0, $1c4hI.Kind).FRAGMENT_DEFINITION:
                var typeConditionAST = node.typeCondition;
                var outputType = typeConditionAST ? (0, $3zSAT.typeFromAST)(schema, typeConditionAST) : (0, $lXoEQ.getNamedType)(this.getType());
                this._typeStack.push((0, $lXoEQ.isOutputType)(outputType) ? outputType : undefined);
                break;
            case (0, $1c4hI.Kind).VARIABLE_DEFINITION:
                var inputType = (0, $3zSAT.typeFromAST)(schema, node.type);
                this._inputTypeStack.push((0, $lXoEQ.isInputType)(inputType) ? inputType : undefined);
                break;
            case (0, $1c4hI.Kind).ARGUMENT:
                var _this$getDirective;
                var argDef;
                var argType;
                var fieldOrDirective = (_this$getDirective = this.getDirective()) !== null && _this$getDirective !== void 0 ? _this$getDirective : this.getFieldDef();
                if (fieldOrDirective) {
                    argDef = (0, $bmIpK.default)(fieldOrDirective.args, function(arg) {
                        return arg.name === node.name.value;
                    });
                    if (argDef) argType = argDef.type;
                }
                this._argument = argDef;
                this._defaultValueStack.push(argDef ? argDef.defaultValue : undefined);
                this._inputTypeStack.push((0, $lXoEQ.isInputType)(argType) ? argType : undefined);
                break;
            case (0, $1c4hI.Kind).LIST:
                var listType = (0, $lXoEQ.getNullableType)(this.getInputType());
                var itemType = (0, $lXoEQ.isListType)(listType) ? listType.ofType : listType; // List positions never have a default value.
                this._defaultValueStack.push(undefined);
                this._inputTypeStack.push((0, $lXoEQ.isInputType)(itemType) ? itemType : undefined);
                break;
            case (0, $1c4hI.Kind).OBJECT_FIELD:
                var objectType = (0, $lXoEQ.getNamedType)(this.getInputType());
                var inputFieldType;
                var inputField;
                if ((0, $lXoEQ.isInputObjectType)(objectType)) {
                    inputField = objectType.getFields()[node.name.value];
                    if (inputField) inputFieldType = inputField.type;
                }
                this._defaultValueStack.push(inputField ? inputField.defaultValue : undefined);
                this._inputTypeStack.push((0, $lXoEQ.isInputType)(inputFieldType) ? inputFieldType : undefined);
                break;
            case (0, $1c4hI.Kind).ENUM:
                var enumType = (0, $lXoEQ.getNamedType)(this.getInputType());
                var enumValue;
                if ((0, $lXoEQ.isEnumType)(enumType)) enumValue = enumType.getValue(node.value);
                this._enumValue = enumValue;
                break;
        }
    };
    _proto.leave = function leave(node) {
        switch(node.kind){
            case (0, $1c4hI.Kind).SELECTION_SET:
                this._parentTypeStack.pop();
                break;
            case (0, $1c4hI.Kind).FIELD:
                this._fieldDefStack.pop();
                this._typeStack.pop();
                break;
            case (0, $1c4hI.Kind).DIRECTIVE:
                this._directive = null;
                break;
            case (0, $1c4hI.Kind).OPERATION_DEFINITION:
            case (0, $1c4hI.Kind).INLINE_FRAGMENT:
            case (0, $1c4hI.Kind).FRAGMENT_DEFINITION:
                this._typeStack.pop();
                break;
            case (0, $1c4hI.Kind).VARIABLE_DEFINITION:
                this._inputTypeStack.pop();
                break;
            case (0, $1c4hI.Kind).ARGUMENT:
                this._argument = null;
                this._defaultValueStack.pop();
                this._inputTypeStack.pop();
                break;
            case (0, $1c4hI.Kind).LIST:
            case (0, $1c4hI.Kind).OBJECT_FIELD:
                this._defaultValueStack.pop();
                this._inputTypeStack.pop();
                break;
            case (0, $1c4hI.Kind).ENUM:
                this._enumValue = null;
                break;
        }
    };
    return TypeInfo;
}();
/**
 * Not exactly the same as the executor's definition of getFieldDef, in this
 * statically evaluated environment we do not always have an Object type,
 * and need to handle Interface and Union types.
 */ function $3a9a642677abfb9d$var$getFieldDef(schema, parentType, fieldNode) {
    var name = fieldNode.name.value;
    if (name === (0, $h2iUh.SchemaMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $h2iUh.SchemaMetaFieldDef;
    if (name === (0, $h2iUh.TypeMetaFieldDef).name && schema.getQueryType() === parentType) return 0, $h2iUh.TypeMetaFieldDef;
    if (name === (0, $h2iUh.TypeNameMetaFieldDef).name && (0, $lXoEQ.isCompositeType)(parentType)) return 0, $h2iUh.TypeNameMetaFieldDef;
    if ((0, $lXoEQ.isObjectType)(parentType) || (0, $lXoEQ.isInterfaceType)(parentType)) return parentType.getFields()[name];
}
function $3a9a642677abfb9d$export$18ca434620348336(typeInfo, visitor) {
    return {
        enter: function enter(node) {
            typeInfo.enter(node);
            var fn = (0, $961BR.getVisitFn)(visitor, node.kind, /* isLeaving */ false);
            if (fn) {
                var result = fn.apply(visitor, arguments);
                if (result !== undefined) {
                    typeInfo.leave(node);
                    if ((0, $c8MIO.isNode)(result)) typeInfo.enter(result);
                }
                return result;
            }
        },
        leave: function leave(node) {
            var fn = (0, $961BR.getVisitFn)(visitor, node.kind, /* isLeaving */ true);
            var result;
            if (fn) result = fn.apply(visitor, arguments);
            typeInfo.leave(node);
            return result;
        }
    };
}

});

parcelRegister("k6EZ2", function(module, exports) {

$parcel$export(module.exports, "specifiedRules", () => $1607320a9964483f$export$ac8e8f03d4e8a76c);
$parcel$export(module.exports, "specifiedSDLRules", () => $1607320a9964483f$export$117d63808a280985);
// Spec Section: "Executable Definitions"

var $aqW0R = parcelRequire("aqW0R");

var $2GDYp = parcelRequire("2GDYp");

var $O3j40 = parcelRequire("O3j40");

var $ldBEm = parcelRequire("ldBEm");

var $6e5RT = parcelRequire("6e5RT");

var $czW5Z = parcelRequire("czW5Z");

var $3Rll6 = parcelRequire("3Rll6");

var $d8bud = parcelRequire("d8bud");

var $hRE8v = parcelRequire("hRE8v");

var $alcPf = parcelRequire("alcPf");

var $50e65 = parcelRequire("50e65");

var $lajJ7 = parcelRequire("lajJ7");

var $rkd39 = parcelRequire("rkd39");

var $bRsXY = parcelRequire("bRsXY");

var $b6uMB = parcelRequire("b6uMB");

var $8zYa7 = parcelRequire("8zYa7");

var $5k1Qg = parcelRequire("5k1Qg");

var $loWoH = parcelRequire("loWoH");

var $is7or = parcelRequire("is7or");

var $gGl3W = parcelRequire("gGl3W");

var $kXrJO = parcelRequire("kXrJO");

var $bhI3j = parcelRequire("bhI3j");

var $bN26g = parcelRequire("bN26g");

var $gnP1U = parcelRequire("gnP1U");

var $h0Hyz = parcelRequire("h0Hyz");

var $1W7Gt = parcelRequire("1W7Gt");

var $gawpj = parcelRequire("gawpj");

var $b8axV = parcelRequire("b8axV");

var $lOmVT = parcelRequire("lOmVT");

var $1H4NC = parcelRequire("1H4NC");

var $lVZ4j = parcelRequire("lVZ4j");

var $jCJ2v = parcelRequire("jCJ2v");

var $kJWSQ = parcelRequire("kJWSQ");
var $1607320a9964483f$export$ac8e8f03d4e8a76c = Object.freeze([
    (0, $aqW0R.ExecutableDefinitionsRule),
    (0, $2GDYp.UniqueOperationNamesRule),
    (0, $O3j40.LoneAnonymousOperationRule),
    (0, $ldBEm.SingleFieldSubscriptionsRule),
    (0, $6e5RT.KnownTypeNamesRule),
    (0, $czW5Z.FragmentsOnCompositeTypesRule),
    (0, $3Rll6.VariablesAreInputTypesRule),
    (0, $d8bud.ScalarLeafsRule),
    (0, $hRE8v.FieldsOnCorrectTypeRule),
    (0, $alcPf.UniqueFragmentNamesRule),
    (0, $50e65.KnownFragmentNamesRule),
    (0, $lajJ7.NoUnusedFragmentsRule),
    (0, $rkd39.PossibleFragmentSpreadsRule),
    (0, $bRsXY.NoFragmentCyclesRule),
    (0, $b6uMB.UniqueVariableNamesRule),
    (0, $8zYa7.NoUndefinedVariablesRule),
    (0, $5k1Qg.NoUnusedVariablesRule),
    (0, $loWoH.KnownDirectivesRule),
    (0, $is7or.UniqueDirectivesPerLocationRule),
    (0, $gGl3W.KnownArgumentNamesRule),
    (0, $kXrJO.UniqueArgumentNamesRule),
    (0, $bhI3j.ValuesOfCorrectTypeRule),
    (0, $bN26g.ProvidedRequiredArgumentsRule),
    (0, $gnP1U.VariablesInAllowedPositionRule),
    (0, $h0Hyz.OverlappingFieldsCanBeMergedRule),
    (0, $1W7Gt.UniqueInputFieldNamesRule)
]);
var $1607320a9964483f$export$117d63808a280985 = Object.freeze([
    (0, $gawpj.LoneSchemaDefinitionRule),
    (0, $b8axV.UniqueOperationTypesRule),
    (0, $lOmVT.UniqueTypeNamesRule),
    (0, $1H4NC.UniqueEnumValueNamesRule),
    (0, $lVZ4j.UniqueFieldDefinitionNamesRule),
    (0, $jCJ2v.UniqueDirectiveNamesRule),
    (0, $6e5RT.KnownTypeNamesRule),
    (0, $loWoH.KnownDirectivesRule),
    (0, $is7or.UniqueDirectivesPerLocationRule),
    (0, $kJWSQ.PossibleTypeExtensionsRule),
    (0, $gGl3W.KnownArgumentNamesOnDirectivesRule),
    (0, $kXrJO.UniqueArgumentNamesRule),
    (0, $1W7Gt.UniqueInputFieldNamesRule),
    (0, $bN26g.ProvidedRequiredArgumentsOnDirectivesRule)
]);

});
parcelRegister("aqW0R", function(module, exports) {

$parcel$export(module.exports, "ExecutableDefinitionsRule", () => $3f76dad52af02d86$export$c3d3637a3c3c605e);

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $9nArG = parcelRequire("9nArG");
function $3f76dad52af02d86$export$c3d3637a3c3c605e(context) {
    return {
        Document: function Document(node) {
            for(var _i2 = 0, _node$definitions2 = node.definitions; _i2 < _node$definitions2.length; _i2++){
                var definition = _node$definitions2[_i2];
                if (!(0, $9nArG.isExecutableDefinitionNode)(definition)) {
                    var defName = definition.kind === (0, $1c4hI.Kind).SCHEMA_DEFINITION || definition.kind === (0, $1c4hI.Kind).SCHEMA_EXTENSION ? 'schema' : '"' + definition.name.value + '"';
                    context.reportError(new (0, $9fgMZ.GraphQLError)("The ".concat(defName, " definition is not executable."), definition));
                }
            }
            return false;
        }
    };
}

});
parcelRegister("9nArG", function(module, exports) {

$parcel$export(module.exports, "isExecutableDefinitionNode", () => $6727414c23a41723$export$4cedd8740794bd78);
$parcel$export(module.exports, "isTypeSystemDefinitionNode", () => $6727414c23a41723$export$b05c7141ec7770ba);
$parcel$export(module.exports, "isTypeSystemExtensionNode", () => $6727414c23a41723$export$fbc18e88163d676d);
$parcel$export(module.exports, "isTypeDefinitionNode", () => $6727414c23a41723$export$a3584bba04f5bfe0);
$parcel$export(module.exports, "isTypeExtensionNode", () => $6727414c23a41723$export$d7907721b241e11f);

var $1c4hI = parcelRequire("1c4hI");
function $6727414c23a41723$export$e7ecd7c16613ccfd(node) {
    return $6727414c23a41723$export$4cedd8740794bd78(node) || $6727414c23a41723$export$b05c7141ec7770ba(node) || $6727414c23a41723$export$fbc18e88163d676d(node);
}
function $6727414c23a41723$export$4cedd8740794bd78(node) {
    return node.kind === (0, $1c4hI.Kind).OPERATION_DEFINITION || node.kind === (0, $1c4hI.Kind).FRAGMENT_DEFINITION;
}
function $6727414c23a41723$export$65772b71e1d017ba(node) {
    return node.kind === (0, $1c4hI.Kind).FIELD || node.kind === (0, $1c4hI.Kind).FRAGMENT_SPREAD || node.kind === (0, $1c4hI.Kind).INLINE_FRAGMENT;
}
function $6727414c23a41723$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $1c4hI.Kind).VARIABLE || node.kind === (0, $1c4hI.Kind).INT || node.kind === (0, $1c4hI.Kind).FLOAT || node.kind === (0, $1c4hI.Kind).STRING || node.kind === (0, $1c4hI.Kind).BOOLEAN || node.kind === (0, $1c4hI.Kind).NULL || node.kind === (0, $1c4hI.Kind).ENUM || node.kind === (0, $1c4hI.Kind).LIST || node.kind === (0, $1c4hI.Kind).OBJECT;
}
function $6727414c23a41723$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $1c4hI.Kind).NAMED_TYPE || node.kind === (0, $1c4hI.Kind).LIST_TYPE || node.kind === (0, $1c4hI.Kind).NON_NULL_TYPE;
}
function $6727414c23a41723$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $1c4hI.Kind).SCHEMA_DEFINITION || $6727414c23a41723$export$a3584bba04f5bfe0(node) || node.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION;
}
function $6727414c23a41723$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).UNION_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION;
}
function $6727414c23a41723$export$fbc18e88163d676d(node) {
    return node.kind === (0, $1c4hI.Kind).SCHEMA_EXTENSION || $6727414c23a41723$export$d7907721b241e11f(node);
}
function $6727414c23a41723$export$d7907721b241e11f(node) {
    return node.kind === (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).UNION_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION;
}

});


parcelRegister("2GDYp", function(module, exports) {

$parcel$export(module.exports, "UniqueOperationNamesRule", () => $88c36e73ececd949$export$a40a702cd7ad2eae);

var $9fgMZ = parcelRequire("9fgMZ");
function $88c36e73ececd949$export$a40a702cd7ad2eae(context) {
    var knownOperationNames = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition(node) {
            var operationName = node.name;
            if (operationName) {
                if (knownOperationNames[operationName.value]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one operation named \"".concat(operationName.value, "\"."), [
                    knownOperationNames[operationName.value],
                    operationName
                ]));
                else knownOperationNames[operationName.value] = operationName;
            }
            return false;
        },
        FragmentDefinition: function FragmentDefinition() {
            return false;
        }
    };
}

});

parcelRegister("O3j40", function(module, exports) {

$parcel$export(module.exports, "LoneAnonymousOperationRule", () => $6e91d6c02aeb4125$export$3a79c63c3de7a55f);

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");
function $6e91d6c02aeb4125$export$3a79c63c3de7a55f(context) {
    var operationCount = 0;
    return {
        Document: function Document(node) {
            operationCount = node.definitions.filter(function(definition) {
                return definition.kind === (0, $1c4hI.Kind).OPERATION_DEFINITION;
            }).length;
        },
        OperationDefinition: function OperationDefinition(node) {
            if (!node.name && operationCount > 1) context.reportError(new (0, $9fgMZ.GraphQLError)('This anonymous operation must be the only defined operation.', node));
        }
    };
}

});

parcelRegister("ldBEm", function(module, exports) {

$parcel$export(module.exports, "SingleFieldSubscriptionsRule", () => $870ac591d38eb8ac$export$477fa0c787c0222d);

var $9fgMZ = parcelRequire("9fgMZ");
function $870ac591d38eb8ac$export$477fa0c787c0222d(context) {
    return {
        OperationDefinition: function OperationDefinition(node) {
            if (node.operation === 'subscription') {
                if (node.selectionSet.selections.length !== 1) context.reportError(new (0, $9fgMZ.GraphQLError)(node.name ? "Subscription \"".concat(node.name.value, "\" must select only one top level field.") : 'Anonymous Subscription must select only one top level field.', node.selectionSet.selections.slice(1)));
            }
        }
    };
}

});

parcelRegister("6e5RT", function(module, exports) {

$parcel$export(module.exports, "KnownTypeNamesRule", () => $30acddca3c136894$export$2317edbae2efecbd);

var $8nBnZ = parcelRequire("8nBnZ");

var $bru1k = parcelRequire("bru1k");

var $9fgMZ = parcelRequire("9fgMZ");

var $9nArG = parcelRequire("9nArG");

var $auu22 = parcelRequire("auu22");

var $h2iUh = parcelRequire("h2iUh");
function $30acddca3c136894$export$2317edbae2efecbd(context) {
    var schema = context.getSchema();
    var existingTypesMap = schema ? schema.getTypeMap() : Object.create(null);
    var definedTypes = Object.create(null);
    for(var _i2 = 0, _context$getDocument$2 = context.getDocument().definitions; _i2 < _context$getDocument$2.length; _i2++){
        var def = _context$getDocument$2[_i2];
        if ((0, $9nArG.isTypeDefinitionNode)(def)) definedTypes[def.name.value] = true;
    }
    var typeNames = Object.keys(existingTypesMap).concat(Object.keys(definedTypes));
    return {
        NamedType: function NamedType(node, _1, parent, _2, ancestors) {
            var typeName = node.name.value;
            if (!existingTypesMap[typeName] && !definedTypes[typeName]) {
                var _ancestors$;
                var definitionNode = (_ancestors$ = ancestors[2]) !== null && _ancestors$ !== void 0 ? _ancestors$ : parent;
                var isSDL = definitionNode != null && $30acddca3c136894$var$isSDLNode(definitionNode);
                if (isSDL && $30acddca3c136894$var$isStandardTypeName(typeName)) return;
                var suggestedTypes = (0, $bru1k.default)(typeName, isSDL ? $30acddca3c136894$var$standardTypeNames.concat(typeNames) : typeNames);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Unknown type \"".concat(typeName, "\".") + (0, $8nBnZ.default)(suggestedTypes), node));
            }
        }
    };
}
var $30acddca3c136894$var$standardTypeNames = [].concat((0, $auu22.specifiedScalarTypes), (0, $h2iUh.introspectionTypes)).map(function(type) {
    return type.name;
});
function $30acddca3c136894$var$isStandardTypeName(typeName) {
    return $30acddca3c136894$var$standardTypeNames.indexOf(typeName) !== -1;
}
function $30acddca3c136894$var$isSDLNode(value) {
    return !Array.isArray(value) && ((0, $9nArG.isTypeSystemDefinitionNode)(value) || (0, $9nArG.isTypeSystemExtensionNode)(value));
}

});

parcelRegister("czW5Z", function(module, exports) {

$parcel$export(module.exports, "FragmentsOnCompositeTypesRule", () => $f80cba82208a6444$export$cb5241ba71fd55e0);

var $9fgMZ = parcelRequire("9fgMZ");

var $aKlnM = parcelRequire("aKlnM");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");
function $f80cba82208a6444$export$cb5241ba71fd55e0(context) {
    return {
        InlineFragment: function InlineFragment(node) {
            var typeCondition = node.typeCondition;
            if (typeCondition) {
                var type = (0, $3zSAT.typeFromAST)(context.getSchema(), typeCondition);
                if (type && !(0, $lXoEQ.isCompositeType)(type)) {
                    var typeStr = (0, $aKlnM.print)(typeCondition);
                    context.reportError(new (0, $9fgMZ.GraphQLError)("Fragment cannot condition on non composite type \"".concat(typeStr, "\"."), typeCondition));
                }
            }
        },
        FragmentDefinition: function FragmentDefinition(node) {
            var type = (0, $3zSAT.typeFromAST)(context.getSchema(), node.typeCondition);
            if (type && !(0, $lXoEQ.isCompositeType)(type)) {
                var typeStr = (0, $aKlnM.print)(node.typeCondition);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Fragment \"".concat(node.name.value, "\" cannot condition on non composite type \"").concat(typeStr, "\"."), node.typeCondition));
            }
        }
    };
}

});

parcelRegister("3Rll6", function(module, exports) {

$parcel$export(module.exports, "VariablesAreInputTypesRule", () => $ab1cf3b33f18ed8d$export$f20a29632b437591);

var $9fgMZ = parcelRequire("9fgMZ");

var $aKlnM = parcelRequire("aKlnM");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");
function $ab1cf3b33f18ed8d$export$f20a29632b437591(context) {
    return {
        VariableDefinition: function VariableDefinition(node) {
            var type = (0, $3zSAT.typeFromAST)(context.getSchema(), node.type);
            if (type && !(0, $lXoEQ.isInputType)(type)) {
                var variableName = node.variable.name.value;
                var typeName = (0, $aKlnM.print)(node.type);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Variable \"$".concat(variableName, "\" cannot be non-input type \"").concat(typeName, "\"."), node.type));
            }
        }
    };
}

});

parcelRegister("d8bud", function(module, exports) {

$parcel$export(module.exports, "ScalarLeafsRule", () => $df259c4803cc1d81$export$d779f66f65c88b9a);

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
function $df259c4803cc1d81$export$d779f66f65c88b9a(context) {
    return {
        Field: function Field(node) {
            var type = context.getType();
            var selectionSet = node.selectionSet;
            if (type) {
                if ((0, $lXoEQ.isLeafType)((0, $lXoEQ.getNamedType)(type))) {
                    if (selectionSet) {
                        var fieldName = node.name.value;
                        var typeStr = (0, $biK02.default)(type);
                        context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(fieldName, "\" must not have a selection since type \"").concat(typeStr, "\" has no subfields."), selectionSet));
                    }
                } else if (!selectionSet) {
                    var _fieldName = node.name.value;
                    var _typeStr = (0, $biK02.default)(type);
                    context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(_fieldName, "\" of type \"").concat(_typeStr, "\" must have a selection of subfields. Did you mean \"").concat(_fieldName, " { ... }\"?"), node));
                }
            }
        }
    };
}

});

parcelRegister("hRE8v", function(module, exports) {

$parcel$export(module.exports, "FieldsOnCorrectTypeRule", () => $ab2475b39bd43e66$export$595e5c0bf2d10a85);

var $96Cqc = parcelRequire("96Cqc");

var $8nBnZ = parcelRequire("8nBnZ");

var $bru1k = parcelRequire("bru1k");

var $daK4l = parcelRequire("daK4l");

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
function $ab2475b39bd43e66$export$595e5c0bf2d10a85(context) {
    return {
        Field: function Field(node) {
            var type = context.getParentType();
            if (type) {
                var fieldDef = context.getFieldDef();
                if (!fieldDef) {
                    // This field doesn't exist, lets look for suggestions.
                    var schema = context.getSchema();
                    var fieldName = node.name.value; // First determine if there are any suggested types to condition on.
                    var suggestion = (0, $8nBnZ.default)('to use an inline fragment on', $ab2475b39bd43e66$var$getSuggestedTypeNames(schema, type, fieldName)); // If there are no suggested types, then perhaps this was a typo?
                    if (suggestion === '') suggestion = (0, $8nBnZ.default)($ab2475b39bd43e66$var$getSuggestedFieldNames(type, fieldName));
                     // Report an error, including helpful suggestions.
                    context.reportError(new (0, $9fgMZ.GraphQLError)("Cannot query field \"".concat(fieldName, "\" on type \"").concat(type.name, "\".") + suggestion, node));
                }
            }
        }
    };
}
/**
 * Go through all of the implementations of type, as well as the interfaces that
 * they implement. If any of those types include the provided field, suggest them,
 * sorted by how often the type is referenced.
 */ function $ab2475b39bd43e66$var$getSuggestedTypeNames(schema, type, fieldName) {
    if (!(0, $lXoEQ.isAbstractType)(type)) // Must be an Object type, which does not have possible fields.
    return [];
    var suggestedTypes = new Set();
    var usageCount = Object.create(null);
    for(var _i2 = 0, _schema$getPossibleTy2 = schema.getPossibleTypes(type); _i2 < _schema$getPossibleTy2.length; _i2++){
        var possibleType = _schema$getPossibleTy2[_i2];
        if (!possibleType.getFields()[fieldName]) continue;
         // This object type defines this field.
        suggestedTypes.add(possibleType);
        usageCount[possibleType.name] = 1;
        for(var _i4 = 0, _possibleType$getInte2 = possibleType.getInterfaces(); _i4 < _possibleType$getInte2.length; _i4++){
            var _usageCount$possibleI;
            var possibleInterface = _possibleType$getInte2[_i4];
            if (!possibleInterface.getFields()[fieldName]) continue;
             // This interface type defines this field.
            suggestedTypes.add(possibleInterface);
            usageCount[possibleInterface.name] = ((_usageCount$possibleI = usageCount[possibleInterface.name]) !== null && _usageCount$possibleI !== void 0 ? _usageCount$possibleI : 0) + 1;
        }
    }
    return (0, $96Cqc.default)(suggestedTypes).sort(function(typeA, typeB) {
        // Suggest both interface and object types based on how common they are.
        var usageCountDiff = usageCount[typeB.name] - usageCount[typeA.name];
        if (usageCountDiff !== 0) return usageCountDiff;
         // Suggest super types first followed by subtypes
        if ((0, $lXoEQ.isInterfaceType)(typeA) && schema.isSubType(typeA, typeB)) return -1;
        if ((0, $lXoEQ.isInterfaceType)(typeB) && schema.isSubType(typeB, typeA)) return 1;
        return (0, $daK4l.default)(typeA.name, typeB.name);
    }).map(function(x) {
        return x.name;
    });
}
/**
 * For the field name provided, determine if there are any similar field names
 * that may be the result of a typo.
 */ function $ab2475b39bd43e66$var$getSuggestedFieldNames(type, fieldName) {
    if ((0, $lXoEQ.isObjectType)(type) || (0, $lXoEQ.isInterfaceType)(type)) {
        var possibleFieldNames = Object.keys(type.getFields());
        return (0, $bru1k.default)(fieldName, possibleFieldNames);
    } // Otherwise, must be a Union type, which does not define fields.
    return [];
}

});

parcelRegister("alcPf", function(module, exports) {

$parcel$export(module.exports, "UniqueFragmentNamesRule", () => $2a7b73aaa0b2b3c4$export$a920e0f1967f4b0a);

var $9fgMZ = parcelRequire("9fgMZ");
function $2a7b73aaa0b2b3c4$export$a920e0f1967f4b0a(context) {
    var knownFragmentNames = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition() {
            return false;
        },
        FragmentDefinition: function FragmentDefinition(node) {
            var fragmentName = node.name.value;
            if (knownFragmentNames[fragmentName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one fragment named \"".concat(fragmentName, "\"."), [
                knownFragmentNames[fragmentName],
                node.name
            ]));
            else knownFragmentNames[fragmentName] = node.name;
            return false;
        }
    };
}

});

parcelRegister("50e65", function(module, exports) {

$parcel$export(module.exports, "KnownFragmentNamesRule", () => $9260c47151c2fbfb$export$94c8dd81fb6d3111);

var $9fgMZ = parcelRequire("9fgMZ");
function $9260c47151c2fbfb$export$94c8dd81fb6d3111(context) {
    return {
        FragmentSpread: function FragmentSpread(node) {
            var fragmentName = node.name.value;
            var fragment = context.getFragment(fragmentName);
            if (!fragment) context.reportError(new (0, $9fgMZ.GraphQLError)("Unknown fragment \"".concat(fragmentName, "\"."), node.name));
        }
    };
}

});

parcelRegister("lajJ7", function(module, exports) {

$parcel$export(module.exports, "NoUnusedFragmentsRule", () => $7e58a6a99152422b$export$d29d2e5ed74717af);

var $9fgMZ = parcelRequire("9fgMZ");
function $7e58a6a99152422b$export$d29d2e5ed74717af(context) {
    var operationDefs = [];
    var fragmentDefs = [];
    return {
        OperationDefinition: function OperationDefinition(node) {
            operationDefs.push(node);
            return false;
        },
        FragmentDefinition: function FragmentDefinition(node) {
            fragmentDefs.push(node);
            return false;
        },
        Document: {
            leave: function leave() {
                var fragmentNameUsed = Object.create(null);
                for(var _i2 = 0; _i2 < operationDefs.length; _i2++){
                    var operation = operationDefs[_i2];
                    for(var _i4 = 0, _context$getRecursive2 = context.getRecursivelyReferencedFragments(operation); _i4 < _context$getRecursive2.length; _i4++){
                        var fragment = _context$getRecursive2[_i4];
                        fragmentNameUsed[fragment.name.value] = true;
                    }
                }
                for(var _i6 = 0; _i6 < fragmentDefs.length; _i6++){
                    var fragmentDef = fragmentDefs[_i6];
                    var fragName = fragmentDef.name.value;
                    if (fragmentNameUsed[fragName] !== true) context.reportError(new (0, $9fgMZ.GraphQLError)("Fragment \"".concat(fragName, "\" is never used."), fragmentDef));
                }
            }
        }
    };
}

});

parcelRegister("rkd39", function(module, exports) {

$parcel$export(module.exports, "PossibleFragmentSpreadsRule", () => $3ff113974e6929b5$export$aa7b39ab48da3359);

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");

var $f5cpS = parcelRequire("f5cpS");
function $3ff113974e6929b5$export$aa7b39ab48da3359(context) {
    return {
        InlineFragment: function InlineFragment(node) {
            var fragType = context.getType();
            var parentType = context.getParentType();
            if ((0, $lXoEQ.isCompositeType)(fragType) && (0, $lXoEQ.isCompositeType)(parentType) && !(0, $f5cpS.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
                var parentTypeStr = (0, $biK02.default)(parentType);
                var fragTypeStr = (0, $biK02.default)(fragType);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Fragment cannot be spread here as objects of type \"".concat(parentTypeStr, "\" can never be of type \"").concat(fragTypeStr, "\"."), node));
            }
        },
        FragmentSpread: function FragmentSpread(node) {
            var fragName = node.name.value;
            var fragType = $3ff113974e6929b5$var$getFragmentType(context, fragName);
            var parentType = context.getParentType();
            if (fragType && parentType && !(0, $f5cpS.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
                var parentTypeStr = (0, $biK02.default)(parentType);
                var fragTypeStr = (0, $biK02.default)(fragType);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Fragment \"".concat(fragName, "\" cannot be spread here as objects of type \"").concat(parentTypeStr, "\" can never be of type \"").concat(fragTypeStr, "\"."), node));
            }
        }
    };
}
function $3ff113974e6929b5$var$getFragmentType(context, name) {
    var frag = context.getFragment(name);
    if (frag) {
        var type = (0, $3zSAT.typeFromAST)(context.getSchema(), frag.typeCondition);
        if ((0, $lXoEQ.isCompositeType)(type)) return type;
    }
}

});

parcelRegister("bRsXY", function(module, exports) {

$parcel$export(module.exports, "NoFragmentCyclesRule", () => $a757a6928f091056$export$25eccb87f5a000e6);

var $9fgMZ = parcelRequire("9fgMZ");
function $a757a6928f091056$export$25eccb87f5a000e6(context) {
    // Tracks already visited fragments to maintain O(N) and to ensure that cycles
    // are not redundantly reported.
    var visitedFrags = Object.create(null); // Array of AST nodes used to produce meaningful errors
    var spreadPath = []; // Position in the spread path
    var spreadPathIndexByName = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition() {
            return false;
        },
        FragmentDefinition: function FragmentDefinition(node) {
            detectCycleRecursive(node);
            return false;
        }
    }; // This does a straight-forward DFS to find cycles.
    // It does not terminate when a cycle was found but continues to explore
    // the graph to find all possible cycles.
    function detectCycleRecursive(fragment) {
        if (visitedFrags[fragment.name.value]) return;
        var fragmentName = fragment.name.value;
        visitedFrags[fragmentName] = true;
        var spreadNodes = context.getFragmentSpreads(fragment.selectionSet);
        if (spreadNodes.length === 0) return;
        spreadPathIndexByName[fragmentName] = spreadPath.length;
        for(var _i2 = 0; _i2 < spreadNodes.length; _i2++){
            var spreadNode = spreadNodes[_i2];
            var spreadName = spreadNode.name.value;
            var cycleIndex = spreadPathIndexByName[spreadName];
            spreadPath.push(spreadNode);
            if (cycleIndex === undefined) {
                var spreadFragment = context.getFragment(spreadName);
                if (spreadFragment) detectCycleRecursive(spreadFragment);
            } else {
                var cyclePath = spreadPath.slice(cycleIndex);
                var viaPath = cyclePath.slice(0, -1).map(function(s) {
                    return '"' + s.name.value + '"';
                }).join(', ');
                context.reportError(new (0, $9fgMZ.GraphQLError)("Cannot spread fragment \"".concat(spreadName, "\" within itself") + (viaPath !== '' ? " via ".concat(viaPath, ".") : '.'), cyclePath));
            }
            spreadPath.pop();
        }
        spreadPathIndexByName[fragmentName] = undefined;
    }
}

});

parcelRegister("b6uMB", function(module, exports) {

$parcel$export(module.exports, "UniqueVariableNamesRule", () => $8cba4410d1ba8a7f$export$b9352e3a23ba4aa2);

var $9fgMZ = parcelRequire("9fgMZ");
function $8cba4410d1ba8a7f$export$b9352e3a23ba4aa2(context) {
    var knownVariableNames = Object.create(null);
    return {
        OperationDefinition: function OperationDefinition() {
            knownVariableNames = Object.create(null);
        },
        VariableDefinition: function VariableDefinition(node) {
            var variableName = node.variable.name.value;
            if (knownVariableNames[variableName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one variable named \"$".concat(variableName, "\"."), [
                knownVariableNames[variableName],
                node.variable.name
            ]));
            else knownVariableNames[variableName] = node.variable.name;
        }
    };
}

});

parcelRegister("8zYa7", function(module, exports) {

$parcel$export(module.exports, "NoUndefinedVariablesRule", () => $9f30efbbf7a4ad88$export$207476dbb3f797ab);

var $9fgMZ = parcelRequire("9fgMZ");
function $9f30efbbf7a4ad88$export$207476dbb3f797ab(context) {
    var variableNameDefined = Object.create(null);
    return {
        OperationDefinition: {
            enter: function enter() {
                variableNameDefined = Object.create(null);
            },
            leave: function leave(operation) {
                var usages = context.getRecursiveVariableUsages(operation);
                for(var _i2 = 0; _i2 < usages.length; _i2++){
                    var _ref2 = usages[_i2];
                    var node = _ref2.node;
                    var varName = node.name.value;
                    if (variableNameDefined[varName] !== true) context.reportError(new (0, $9fgMZ.GraphQLError)(operation.name ? "Variable \"$".concat(varName, "\" is not defined by operation \"").concat(operation.name.value, "\".") : "Variable \"$".concat(varName, "\" is not defined."), [
                        node,
                        operation
                    ]));
                }
            }
        },
        VariableDefinition: function VariableDefinition(node) {
            variableNameDefined[node.variable.name.value] = true;
        }
    };
}

});

parcelRegister("5k1Qg", function(module, exports) {

$parcel$export(module.exports, "NoUnusedVariablesRule", () => $73f3814f2ba8a2d1$export$300a3bc5a4f49273);

var $9fgMZ = parcelRequire("9fgMZ");
function $73f3814f2ba8a2d1$export$300a3bc5a4f49273(context) {
    var variableDefs = [];
    return {
        OperationDefinition: {
            enter: function enter() {
                variableDefs = [];
            },
            leave: function leave(operation) {
                var variableNameUsed = Object.create(null);
                var usages = context.getRecursiveVariableUsages(operation);
                for(var _i2 = 0; _i2 < usages.length; _i2++){
                    var _ref2 = usages[_i2];
                    var node = _ref2.node;
                    variableNameUsed[node.name.value] = true;
                }
                for(var _i4 = 0, _variableDefs2 = variableDefs; _i4 < _variableDefs2.length; _i4++){
                    var variableDef = _variableDefs2[_i4];
                    var variableName = variableDef.variable.name.value;
                    if (variableNameUsed[variableName] !== true) context.reportError(new (0, $9fgMZ.GraphQLError)(operation.name ? "Variable \"$".concat(variableName, "\" is never used in operation \"").concat(operation.name.value, "\".") : "Variable \"$".concat(variableName, "\" is never used."), variableDef));
                }
            }
        },
        VariableDefinition: function VariableDefinition(def) {
            variableDefs.push(def);
        }
    };
}

});

parcelRegister("loWoH", function(module, exports) {

$parcel$export(module.exports, "KnownDirectivesRule", () => $f639a2bd47be29e5$export$f4ca94d7d1cf5874);

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $5hGV7 = parcelRequire("5hGV7");

var $bOniD = parcelRequire("bOniD");
function $f639a2bd47be29e5$export$f4ca94d7d1cf5874(context) {
    var locationsMap = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, $bOniD.specifiedDirectives);
    for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
        var directive = definedDirectives[_i2];
        locationsMap[directive.name] = directive.locations;
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
        var def = astDefinitions[_i4];
        if (def.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION) locationsMap[def.name.value] = def.locations.map(function(name) {
            return name.value;
        });
    }
    return {
        Directive: function Directive(node, _key, _parent, _path, ancestors) {
            var name = node.name.value;
            var locations = locationsMap[name];
            if (!locations) {
                context.reportError(new (0, $9fgMZ.GraphQLError)("Unknown directive \"@".concat(name, "\"."), node));
                return;
            }
            var candidateLocation = $f639a2bd47be29e5$var$getDirectiveLocationForASTPath(ancestors);
            if (candidateLocation && locations.indexOf(candidateLocation) === -1) context.reportError(new (0, $9fgMZ.GraphQLError)("Directive \"@".concat(name, "\" may not be used on ").concat(candidateLocation, "."), node));
        }
    };
}
function $f639a2bd47be29e5$var$getDirectiveLocationForASTPath(ancestors) {
    var appliedTo = ancestors[ancestors.length - 1];
    !Array.isArray(appliedTo) || (0, $43MJl.default)(0);
    switch(appliedTo.kind){
        case (0, $1c4hI.Kind).OPERATION_DEFINITION:
            return $f639a2bd47be29e5$var$getDirectiveLocationForOperation(appliedTo.operation);
        case (0, $1c4hI.Kind).FIELD:
            return (0, $5hGV7.DirectiveLocation).FIELD;
        case (0, $1c4hI.Kind).FRAGMENT_SPREAD:
            return (0, $5hGV7.DirectiveLocation).FRAGMENT_SPREAD;
        case (0, $1c4hI.Kind).INLINE_FRAGMENT:
            return (0, $5hGV7.DirectiveLocation).INLINE_FRAGMENT;
        case (0, $1c4hI.Kind).FRAGMENT_DEFINITION:
            return (0, $5hGV7.DirectiveLocation).FRAGMENT_DEFINITION;
        case (0, $1c4hI.Kind).VARIABLE_DEFINITION:
            return (0, $5hGV7.DirectiveLocation).VARIABLE_DEFINITION;
        case (0, $1c4hI.Kind).SCHEMA_DEFINITION:
        case (0, $1c4hI.Kind).SCHEMA_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).SCHEMA;
        case (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).SCALAR;
        case (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).OBJECT;
        case (0, $1c4hI.Kind).FIELD_DEFINITION:
            return (0, $5hGV7.DirectiveLocation).FIELD_DEFINITION;
        case (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).INTERFACE;
        case (0, $1c4hI.Kind).UNION_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).UNION_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).UNION;
        case (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).ENUM;
        case (0, $1c4hI.Kind).ENUM_VALUE_DEFINITION:
            return (0, $5hGV7.DirectiveLocation).ENUM_VALUE;
        case (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION:
        case (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION:
            return (0, $5hGV7.DirectiveLocation).INPUT_OBJECT;
        case (0, $1c4hI.Kind).INPUT_VALUE_DEFINITION:
            var parentNode = ancestors[ancestors.length - 3];
            return parentNode.kind === (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION ? (0, $5hGV7.DirectiveLocation).INPUT_FIELD_DEFINITION : (0, $5hGV7.DirectiveLocation).ARGUMENT_DEFINITION;
    }
}
function $f639a2bd47be29e5$var$getDirectiveLocationForOperation(operation) {
    switch(operation){
        case 'query':
            return (0, $5hGV7.DirectiveLocation).QUERY;
        case 'mutation':
            return (0, $5hGV7.DirectiveLocation).MUTATION;
        case 'subscription':
            return (0, $5hGV7.DirectiveLocation).SUBSCRIPTION;
    } // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, $43MJl.default)(0, 'Unexpected operation: ' + (0, $biK02.default)(operation));
}

});

parcelRegister("is7or", function(module, exports) {

$parcel$export(module.exports, "UniqueDirectivesPerLocationRule", () => $d948a6cd5aabc74f$export$4a38f68ea408504c);

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $9nArG = parcelRequire("9nArG");

var $bOniD = parcelRequire("bOniD");
function $d948a6cd5aabc74f$export$4a38f68ea408504c(context) {
    var uniqueDirectiveMap = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, $bOniD.specifiedDirectives);
    for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
        var directive = definedDirectives[_i2];
        uniqueDirectiveMap[directive.name] = !directive.isRepeatable;
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
        var def = astDefinitions[_i4];
        if (def.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION) uniqueDirectiveMap[def.name.value] = !def.repeatable;
    }
    var schemaDirectives = Object.create(null);
    var typeDirectivesMap = Object.create(null);
    return {
        // Many different AST nodes may contain directives. Rather than listing
        // them all, just listen for entering any node, and check to see if it
        // defines any directives.
        enter: function enter(node) {
            if (node.directives == null) return;
            var seenDirectives;
            if (node.kind === (0, $1c4hI.Kind).SCHEMA_DEFINITION || node.kind === (0, $1c4hI.Kind).SCHEMA_EXTENSION) seenDirectives = schemaDirectives;
            else if ((0, $9nArG.isTypeDefinitionNode)(node) || (0, $9nArG.isTypeExtensionNode)(node)) {
                var typeName = node.name.value;
                seenDirectives = typeDirectivesMap[typeName];
                if (seenDirectives === undefined) typeDirectivesMap[typeName] = seenDirectives = Object.create(null);
            } else seenDirectives = Object.create(null);
            for(var _i6 = 0, _node$directives2 = node.directives; _i6 < _node$directives2.length; _i6++){
                var _directive = _node$directives2[_i6];
                var directiveName = _directive.name.value;
                if (uniqueDirectiveMap[directiveName]) {
                    if (seenDirectives[directiveName]) context.reportError(new (0, $9fgMZ.GraphQLError)("The directive \"@".concat(directiveName, "\" can only be used once at this location."), [
                        seenDirectives[directiveName],
                        _directive
                    ]));
                    else seenDirectives[directiveName] = _directive;
                }
            }
        }
    };
}

});

parcelRegister("gGl3W", function(module, exports) {

$parcel$export(module.exports, "KnownArgumentNamesRule", () => $f06ff2fed7190b23$export$5d7b3b4b6779c802);
$parcel$export(module.exports, "KnownArgumentNamesOnDirectivesRule", () => $f06ff2fed7190b23$export$6eb6eb4c5417f2c4);

var $8nBnZ = parcelRequire("8nBnZ");

var $bru1k = parcelRequire("bru1k");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $bOniD = parcelRequire("bOniD");
function $f06ff2fed7190b23$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f06ff2fed7190b23$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f06ff2fed7190b23$var$ownKeys(Object(source), true).forEach(function(key) {
            $f06ff2fed7190b23$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f06ff2fed7190b23$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f06ff2fed7190b23$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f06ff2fed7190b23$export$5d7b3b4b6779c802(context) {
    return $f06ff2fed7190b23$var$_objectSpread($f06ff2fed7190b23$var$_objectSpread({}, $f06ff2fed7190b23$export$6eb6eb4c5417f2c4(context)), {}, {
        Argument: function Argument(argNode) {
            var argDef = context.getArgument();
            var fieldDef = context.getFieldDef();
            var parentType = context.getParentType();
            if (!argDef && fieldDef && parentType) {
                var argName = argNode.name.value;
                var knownArgsNames = fieldDef.args.map(function(arg) {
                    return arg.name;
                });
                var suggestions = (0, $bru1k.default)(argName, knownArgsNames);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Unknown argument \"".concat(argName, "\" on field \"").concat(parentType.name, ".").concat(fieldDef.name, "\".") + (0, $8nBnZ.default)(suggestions), argNode));
            }
        }
    });
}
function $f06ff2fed7190b23$export$6eb6eb4c5417f2c4(context) {
    var directiveArgs = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, $bOniD.specifiedDirectives);
    for(var _i2 = 0; _i2 < definedDirectives.length; _i2++){
        var directive = definedDirectives[_i2];
        directiveArgs[directive.name] = directive.args.map(function(arg) {
            return arg.name;
        });
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i4 = 0; _i4 < astDefinitions.length; _i4++){
        var def = astDefinitions[_i4];
        if (def.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION) {
            var _def$arguments;
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var argsNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
            directiveArgs[def.name.value] = argsNodes.map(function(arg) {
                return arg.name.value;
            });
        }
    }
    return {
        Directive: function Directive(directiveNode) {
            var directiveName = directiveNode.name.value;
            var knownArgs = directiveArgs[directiveName];
            if (directiveNode.arguments && knownArgs) for(var _i6 = 0, _directiveNode$argume2 = directiveNode.arguments; _i6 < _directiveNode$argume2.length; _i6++){
                var argNode = _directiveNode$argume2[_i6];
                var argName = argNode.name.value;
                if (knownArgs.indexOf(argName) === -1) {
                    var suggestions = (0, $bru1k.default)(argName, knownArgs);
                    context.reportError(new (0, $9fgMZ.GraphQLError)("Unknown argument \"".concat(argName, "\" on directive \"@").concat(directiveName, "\".") + (0, $8nBnZ.default)(suggestions), argNode));
                }
            }
            return false;
        }
    };
}

});

parcelRegister("kXrJO", function(module, exports) {

$parcel$export(module.exports, "UniqueArgumentNamesRule", () => $bc8bcb3d805db150$export$8598b5acb1d855ca);

var $9fgMZ = parcelRequire("9fgMZ");
function $bc8bcb3d805db150$export$8598b5acb1d855ca(context) {
    var knownArgNames = Object.create(null);
    return {
        Field: function Field() {
            knownArgNames = Object.create(null);
        },
        Directive: function Directive() {
            knownArgNames = Object.create(null);
        },
        Argument: function Argument(node) {
            var argName = node.name.value;
            if (knownArgNames[argName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one argument named \"".concat(argName, "\"."), [
                knownArgNames[argName],
                node.name
            ]));
            else knownArgNames[argName] = node.name;
            return false;
        }
    };
}

});

parcelRegister("bhI3j", function(module, exports) {

$parcel$export(module.exports, "ValuesOfCorrectTypeRule", () => $7b4ecfc9076050ee$export$669bf87f50cfda9b);

var $dVq2R = parcelRequire("dVq2R");

var $hbiEd = parcelRequire("hbiEd");

var $biK02 = parcelRequire("biK02");

var $8nBnZ = parcelRequire("8nBnZ");

var $bru1k = parcelRequire("bru1k");

var $9fgMZ = parcelRequire("9fgMZ");

var $aKlnM = parcelRequire("aKlnM");

var $lXoEQ = parcelRequire("lXoEQ");
function $7b4ecfc9076050ee$export$669bf87f50cfda9b(context) {
    return {
        ListValue: function ListValue(node) {
            // Note: TypeInfo will traverse into a list's item type, so look to the
            // parent input type to check if it is a list.
            var type = (0, $lXoEQ.getNullableType)(context.getParentInputType());
            if (!(0, $lXoEQ.isListType)(type)) {
                $7b4ecfc9076050ee$var$isValidValueNode(context, node);
                return false; // Don't traverse further.
            }
        },
        ObjectValue: function ObjectValue(node) {
            var type = (0, $lXoEQ.getNamedType)(context.getInputType());
            if (!(0, $lXoEQ.isInputObjectType)(type)) {
                $7b4ecfc9076050ee$var$isValidValueNode(context, node);
                return false; // Don't traverse further.
            } // Ensure every required field exists.
            var fieldNodeMap = (0, $hbiEd.default)(node.fields, function(field) {
                return field.name.value;
            });
            for(var _i2 = 0, _objectValues2 = (0, $dVq2R.default)(type.getFields()); _i2 < _objectValues2.length; _i2++){
                var fieldDef = _objectValues2[_i2];
                var fieldNode = fieldNodeMap[fieldDef.name];
                if (!fieldNode && (0, $lXoEQ.isRequiredInputField)(fieldDef)) {
                    var typeStr = (0, $biK02.default)(fieldDef.type);
                    context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(type.name, ".").concat(fieldDef.name, "\" of required type \"").concat(typeStr, "\" was not provided."), node));
                }
            }
        },
        ObjectField: function ObjectField(node) {
            var parentType = (0, $lXoEQ.getNamedType)(context.getParentInputType());
            var fieldType = context.getInputType();
            if (!fieldType && (0, $lXoEQ.isInputObjectType)(parentType)) {
                var suggestions = (0, $bru1k.default)(node.name.value, Object.keys(parentType.getFields()));
                context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(node.name.value, "\" is not defined by type \"").concat(parentType.name, "\".") + (0, $8nBnZ.default)(suggestions), node));
            }
        },
        NullValue: function NullValue(node) {
            var type = context.getInputType();
            if ((0, $lXoEQ.isNonNullType)(type)) context.reportError(new (0, $9fgMZ.GraphQLError)("Expected value of type \"".concat((0, $biK02.default)(type), "\", found ").concat((0, $aKlnM.print)(node), "."), node));
        },
        EnumValue: function EnumValue(node) {
            return $7b4ecfc9076050ee$var$isValidValueNode(context, node);
        },
        IntValue: function IntValue(node) {
            return $7b4ecfc9076050ee$var$isValidValueNode(context, node);
        },
        FloatValue: function FloatValue(node) {
            return $7b4ecfc9076050ee$var$isValidValueNode(context, node);
        },
        StringValue: function StringValue(node) {
            return $7b4ecfc9076050ee$var$isValidValueNode(context, node);
        },
        BooleanValue: function BooleanValue(node) {
            return $7b4ecfc9076050ee$var$isValidValueNode(context, node);
        }
    };
}
/**
 * Any value literal may be a valid representation of a Scalar, depending on
 * that scalar type.
 */ function $7b4ecfc9076050ee$var$isValidValueNode(context, node) {
    // Report any error at the full type expected by the location.
    var locationType = context.getInputType();
    if (!locationType) return;
    var type = (0, $lXoEQ.getNamedType)(locationType);
    if (!(0, $lXoEQ.isLeafType)(type)) {
        var typeStr = (0, $biK02.default)(locationType);
        context.reportError(new (0, $9fgMZ.GraphQLError)("Expected value of type \"".concat(typeStr, "\", found ").concat((0, $aKlnM.print)(node), "."), node));
        return;
    } // Scalars and Enums determine if a literal value is valid via parseLiteral(),
    // which may throw or return an invalid value to indicate failure.
    try {
        var parseResult = type.parseLiteral(node, undefined);
        if (parseResult === undefined) {
            var _typeStr = (0, $biK02.default)(locationType);
            context.reportError(new (0, $9fgMZ.GraphQLError)("Expected value of type \"".concat(_typeStr, "\", found ").concat((0, $aKlnM.print)(node), "."), node));
        }
    } catch (error) {
        var _typeStr2 = (0, $biK02.default)(locationType);
        if (error instanceof (0, $9fgMZ.GraphQLError)) context.reportError(error);
        else context.reportError(new (0, $9fgMZ.GraphQLError)("Expected value of type \"".concat(_typeStr2, "\", found ").concat((0, $aKlnM.print)(node), "; ") + error.message, node, undefined, undefined, undefined, error));
    }
}

});

parcelRegister("bN26g", function(module, exports) {

$parcel$export(module.exports, "ProvidedRequiredArgumentsRule", () => $ab49904624b6b37c$export$4df169576372c8b2);
$parcel$export(module.exports, "ProvidedRequiredArgumentsOnDirectivesRule", () => $ab49904624b6b37c$export$5ff6a71c337c020f);

var $biK02 = parcelRequire("biK02");

var $hbiEd = parcelRequire("hbiEd");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $aKlnM = parcelRequire("aKlnM");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");
function $ab49904624b6b37c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ab49904624b6b37c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ab49904624b6b37c$var$ownKeys(Object(source), true).forEach(function(key) {
            $ab49904624b6b37c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ab49904624b6b37c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ab49904624b6b37c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ab49904624b6b37c$export$4df169576372c8b2(context) {
    return $ab49904624b6b37c$var$_objectSpread($ab49904624b6b37c$var$_objectSpread({}, $ab49904624b6b37c$export$5ff6a71c337c020f(context)), {}, {
        Field: {
            // Validate on leave to allow for deeper errors to appear first.
            leave: function leave(fieldNode) {
                var _fieldNode$arguments;
                var fieldDef = context.getFieldDef();
                if (!fieldDef) return false;
                 // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
                var argNodes = (_fieldNode$arguments = fieldNode.arguments) !== null && _fieldNode$arguments !== void 0 ? _fieldNode$arguments : [];
                var argNodeMap = (0, $hbiEd.default)(argNodes, function(arg) {
                    return arg.name.value;
                });
                for(var _i2 = 0, _fieldDef$args2 = fieldDef.args; _i2 < _fieldDef$args2.length; _i2++){
                    var argDef = _fieldDef$args2[_i2];
                    var argNode = argNodeMap[argDef.name];
                    if (!argNode && (0, $lXoEQ.isRequiredArgument)(argDef)) {
                        var argTypeStr = (0, $biK02.default)(argDef.type);
                        context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(fieldDef.name, "\" argument \"").concat(argDef.name, "\" of type \"").concat(argTypeStr, "\" is required, but it was not provided."), fieldNode));
                    }
                }
            }
        }
    });
}
function $ab49904624b6b37c$export$5ff6a71c337c020f(context) {
    var requiredArgsMap = Object.create(null);
    var schema = context.getSchema();
    var definedDirectives = schema ? schema.getDirectives() : (0, $bOniD.specifiedDirectives);
    for(var _i4 = 0; _i4 < definedDirectives.length; _i4++){
        var directive = definedDirectives[_i4];
        requiredArgsMap[directive.name] = (0, $hbiEd.default)(directive.args.filter((0, $lXoEQ.isRequiredArgument)), function(arg) {
            return arg.name;
        });
    }
    var astDefinitions = context.getDocument().definitions;
    for(var _i6 = 0; _i6 < astDefinitions.length; _i6++){
        var def = astDefinitions[_i6];
        if (def.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION) {
            var _def$arguments;
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var argNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
            requiredArgsMap[def.name.value] = (0, $hbiEd.default)(argNodes.filter($ab49904624b6b37c$var$isRequiredArgumentNode), function(arg) {
                return arg.name.value;
            });
        }
    }
    return {
        Directive: {
            // Validate on leave to allow for deeper errors to appear first.
            leave: function leave(directiveNode) {
                var directiveName = directiveNode.name.value;
                var requiredArgs = requiredArgsMap[directiveName];
                if (requiredArgs) {
                    var _directiveNode$argume;
                    // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
                    var _argNodes = (_directiveNode$argume = directiveNode.arguments) !== null && _directiveNode$argume !== void 0 ? _directiveNode$argume : [];
                    var argNodeMap = (0, $hbiEd.default)(_argNodes, function(arg) {
                        return arg.name.value;
                    });
                    for(var _i8 = 0, _Object$keys2 = Object.keys(requiredArgs); _i8 < _Object$keys2.length; _i8++){
                        var argName = _Object$keys2[_i8];
                        if (!argNodeMap[argName]) {
                            var argType = requiredArgs[argName].type;
                            var argTypeStr = (0, $lXoEQ.isType)(argType) ? (0, $biK02.default)(argType) : (0, $aKlnM.print)(argType);
                            context.reportError(new (0, $9fgMZ.GraphQLError)("Directive \"@".concat(directiveName, "\" argument \"").concat(argName, "\" of type \"").concat(argTypeStr, "\" is required, but it was not provided."), directiveNode));
                        }
                    }
                }
            }
        }
    };
}
function $ab49904624b6b37c$var$isRequiredArgumentNode(arg) {
    return arg.type.kind === (0, $1c4hI.Kind).NON_NULL_TYPE && arg.defaultValue == null;
}

});

parcelRegister("gnP1U", function(module, exports) {

$parcel$export(module.exports, "VariablesInAllowedPositionRule", () => $2271e9cfabe9e688$export$7251631d636f2f74);

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");

var $f5cpS = parcelRequire("f5cpS");
function $2271e9cfabe9e688$export$7251631d636f2f74(context) {
    var varDefMap = Object.create(null);
    return {
        OperationDefinition: {
            enter: function enter() {
                varDefMap = Object.create(null);
            },
            leave: function leave(operation) {
                var usages = context.getRecursiveVariableUsages(operation);
                for(var _i2 = 0; _i2 < usages.length; _i2++){
                    var _ref2 = usages[_i2];
                    var node = _ref2.node;
                    var type = _ref2.type;
                    var defaultValue = _ref2.defaultValue;
                    var varName = node.name.value;
                    var varDef = varDefMap[varName];
                    if (varDef && type) {
                        // A var type is allowed if it is the same or more strict (e.g. is
                        // a subtype of) than the expected type. It can be more strict if
                        // the variable type is non-null when the expected type is nullable.
                        // If both are list types, the variable item type can be more strict
                        // than the expected item type (contravariant).
                        var schema = context.getSchema();
                        var varType = (0, $3zSAT.typeFromAST)(schema, varDef.type);
                        if (varType && !$2271e9cfabe9e688$var$allowedVariableUsage(schema, varType, varDef.defaultValue, type, defaultValue)) {
                            var varTypeStr = (0, $biK02.default)(varType);
                            var typeStr = (0, $biK02.default)(type);
                            context.reportError(new (0, $9fgMZ.GraphQLError)("Variable \"$".concat(varName, "\" of type \"").concat(varTypeStr, "\" used in position expecting type \"").concat(typeStr, "\"."), [
                                varDef,
                                node
                            ]));
                        }
                    }
                }
            }
        },
        VariableDefinition: function VariableDefinition(node) {
            varDefMap[node.variable.name.value] = node;
        }
    };
}
/**
 * Returns true if the variable is allowed in the location it was found,
 * which includes considering if default values exist for either the variable
 * or the location at which it is located.
 */ function $2271e9cfabe9e688$var$allowedVariableUsage(schema, varType, varDefaultValue, locationType, locationDefaultValue) {
    if ((0, $lXoEQ.isNonNullType)(locationType) && !(0, $lXoEQ.isNonNullType)(varType)) {
        var hasNonNullVariableDefaultValue = varDefaultValue != null && varDefaultValue.kind !== (0, $1c4hI.Kind).NULL;
        var hasLocationDefaultValue = locationDefaultValue !== undefined;
        if (!hasNonNullVariableDefaultValue && !hasLocationDefaultValue) return false;
        var nullableLocationType = locationType.ofType;
        return (0, $f5cpS.isTypeSubTypeOf)(schema, varType, nullableLocationType);
    }
    return (0, $f5cpS.isTypeSubTypeOf)(schema, varType, locationType);
}

});

parcelRegister("h0Hyz", function(module, exports) {

$parcel$export(module.exports, "OverlappingFieldsCanBeMergedRule", () => $79d19cce53ef75b6$export$ca8652d62af5670);

var $bmIpK = parcelRequire("bmIpK");

var $apet0 = parcelRequire("apet0");

var $biK02 = parcelRequire("biK02");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $aKlnM = parcelRequire("aKlnM");

var $lXoEQ = parcelRequire("lXoEQ");

var $3zSAT = parcelRequire("3zSAT");
function $79d19cce53ef75b6$var$reasonMessage(reason) {
    if (Array.isArray(reason)) return reason.map(function(_ref) {
        var responseName = _ref[0], subReason = _ref[1];
        return "subfields \"".concat(responseName, "\" conflict because ") + $79d19cce53ef75b6$var$reasonMessage(subReason);
    }).join(' and ');
    return reason;
}
function $79d19cce53ef75b6$export$ca8652d62af5670(context) {
    // A memoization for when two fragments are compared "between" each other for
    // conflicts. Two fragments may be compared many times, so memoizing this can
    // dramatically improve the performance of this validator.
    var comparedFragmentPairs = new $79d19cce53ef75b6$var$PairSet(); // A cache for the "field map" and list of fragment names found in any given
    // selection set. Selection sets may be asked for this information multiple
    // times, so this improves the performance of this validator.
    var cachedFieldsAndFragmentNames = new Map();
    return {
        SelectionSet: function SelectionSet(selectionSet) {
            var conflicts = $79d19cce53ef75b6$var$findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, context.getParentType(), selectionSet);
            for(var _i2 = 0; _i2 < conflicts.length; _i2++){
                var _ref3 = conflicts[_i2];
                var _ref2$ = _ref3[0];
                var responseName = _ref2$[0];
                var reason = _ref2$[1];
                var fields1 = _ref3[1];
                var fields2 = _ref3[2];
                var reasonMsg = $79d19cce53ef75b6$var$reasonMessage(reason);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Fields \"".concat(responseName, "\" conflict because ").concat(reasonMsg, ". Use different aliases on the fields to fetch both if this was intentional."), fields1.concat(fields2)));
            }
        }
    };
}
/**
 * Algorithm:
 *
 * Conflicts occur when two fields exist in a query which will produce the same
 * response name, but represent differing values, thus creating a conflict.
 * The algorithm below finds all conflicts via making a series of comparisons
 * between fields. In order to compare as few fields as possible, this makes
 * a series of comparisons "within" sets of fields and "between" sets of fields.
 *
 * Given any selection set, a collection produces both a set of fields by
 * also including all inline fragments, as well as a list of fragments
 * referenced by fragment spreads.
 *
 * A) Each selection set represented in the document first compares "within" its
 * collected set of fields, finding any conflicts between every pair of
 * overlapping fields.
 * Note: This is the *only time* that a the fields "within" a set are compared
 * to each other. After this only fields "between" sets are compared.
 *
 * B) Also, if any fragment is referenced in a selection set, then a
 * comparison is made "between" the original set of fields and the
 * referenced fragment.
 *
 * C) Also, if multiple fragments are referenced, then comparisons
 * are made "between" each referenced fragment.
 *
 * D) When comparing "between" a set of fields and a referenced fragment, first
 * a comparison is made between each field in the original set of fields and
 * each field in the the referenced set of fields.
 *
 * E) Also, if any fragment is referenced in the referenced selection set,
 * then a comparison is made "between" the original set of fields and the
 * referenced fragment (recursively referring to step D).
 *
 * F) When comparing "between" two fragments, first a comparison is made between
 * each field in the first referenced set of fields and each field in the the
 * second referenced set of fields.
 *
 * G) Also, any fragments referenced by the first must be compared to the
 * second, and any fragments referenced by the second must be compared to the
 * first (recursively referring to step F).
 *
 * H) When comparing two fields, if both have selection sets, then a comparison
 * is made "between" both selection sets, first comparing the set of fields in
 * the first selection set with the set of fields in the second.
 *
 * I) Also, if any fragment is referenced in either selection set, then a
 * comparison is made "between" the other set of fields and the
 * referenced fragment.
 *
 * J) Also, if two fragments are referenced in both selection sets, then a
 * comparison is made "between" the two fragments.
 *
 */ // Find all conflicts found "within" a selection set, including those found
// via spreading in fragments. Called when visiting each SelectionSet in the
// GraphQL Document.
function $79d19cce53ef75b6$var$findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentType, selectionSet) {
    var conflicts = [];
    var _getFieldsAndFragment = $79d19cce53ef75b6$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet), fieldMap = _getFieldsAndFragment[0], fragmentNames = _getFieldsAndFragment[1]; // (A) Find find all conflicts "within" the fields of this selection set.
    // Note: this is the *only place* `collectConflictsWithin` is called.
    $79d19cce53ef75b6$var$collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap);
    if (fragmentNames.length !== 0) // (B) Then collect conflicts between these fields and those represented by
    // each spread fragment name found.
    for(var i = 0; i < fragmentNames.length; i++){
        $79d19cce53ef75b6$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fieldMap, fragmentNames[i]); // (C) Then compare this fragment with all other fragments found in this
        // selection set to collect conflicts between fragments spread together.
        // This compares each item in the list of fragment names to every other
        // item in that same list (except for itself).
        for(var j = i + 1; j < fragmentNames.length; j++)$79d19cce53ef75b6$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fragmentNames[i], fragmentNames[j]);
    }
    return conflicts;
} // Collect all conflicts found between a set of fields and a fragment reference
// including via spreading in any nested fragments.
function $79d19cce53ef75b6$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentName) {
    var fragment = context.getFragment(fragmentName);
    if (!fragment) return;
    var _getReferencedFieldsA = $79d19cce53ef75b6$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment), fieldMap2 = _getReferencedFieldsA[0], fragmentNames2 = _getReferencedFieldsA[1]; // Do not compare a fragment's fieldMap to itself.
    if (fieldMap === fieldMap2) return;
     // (D) First collect any conflicts between the provided collection of fields
    // and the collection of fields represented by the given fragment.
    $79d19cce53ef75b6$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fieldMap2); // (E) Then collect any conflicts between the provided collection of fields
    // and any fragment names found in the given fragment.
    for(var i = 0; i < fragmentNames2.length; i++)$79d19cce53ef75b6$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentNames2[i]);
} // Collect all conflicts found between two fragments, including via spreading in
// any nested fragments.
function $79d19cce53ef75b6$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentName2) {
    // No need to compare a fragment to itself.
    if (fragmentName1 === fragmentName2) return;
     // Memoize so two fragments are not compared for conflicts more than once.
    if (comparedFragmentPairs.has(fragmentName1, fragmentName2, areMutuallyExclusive)) return;
    comparedFragmentPairs.add(fragmentName1, fragmentName2, areMutuallyExclusive);
    var fragment1 = context.getFragment(fragmentName1);
    var fragment2 = context.getFragment(fragmentName2);
    if (!fragment1 || !fragment2) return;
    var _getReferencedFieldsA2 = $79d19cce53ef75b6$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment1), fieldMap1 = _getReferencedFieldsA2[0], fragmentNames1 = _getReferencedFieldsA2[1];
    var _getReferencedFieldsA3 = $79d19cce53ef75b6$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment2), fieldMap2 = _getReferencedFieldsA3[0], fragmentNames2 = _getReferencedFieldsA3[1]; // (F) First, collect all conflicts between these two collections of fields
    // (not including any nested fragments).
    $79d19cce53ef75b6$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (G) Then collect conflicts between the first fragment and any nested
    // fragments spread in the second fragment.
    for(var j = 0; j < fragmentNames2.length; j++)$79d19cce53ef75b6$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentNames2[j]);
     // (G) Then collect conflicts between the second fragment and any nested
    // fragments spread in the first fragment.
    for(var i = 0; i < fragmentNames1.length; i++)$79d19cce53ef75b6$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[i], fragmentName2);
} // Find all conflicts found between two selection sets, including those found
// via spreading in fragments. Called when determining if conflicts exist
// between the sub-fields of two overlapping fields.
function $79d19cce53ef75b6$var$findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, parentType1, selectionSet1, parentType2, selectionSet2) {
    var conflicts = [];
    var _getFieldsAndFragment2 = $79d19cce53ef75b6$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType1, selectionSet1), fieldMap1 = _getFieldsAndFragment2[0], fragmentNames1 = _getFieldsAndFragment2[1];
    var _getFieldsAndFragment3 = $79d19cce53ef75b6$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType2, selectionSet2), fieldMap2 = _getFieldsAndFragment3[0], fragmentNames2 = _getFieldsAndFragment3[1]; // (H) First, collect all conflicts between these two collections of field.
    $79d19cce53ef75b6$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (I) Then collect conflicts between the first collection of fields and
    // those referenced by each fragment name associated with the second.
    if (fragmentNames2.length !== 0) for(var j = 0; j < fragmentNames2.length; j++)$79d19cce53ef75b6$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fragmentNames2[j]);
     // (I) Then collect conflicts between the second collection of fields and
    // those referenced by each fragment name associated with the first.
    if (fragmentNames1.length !== 0) for(var i = 0; i < fragmentNames1.length; i++)$79d19cce53ef75b6$var$collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap2, fragmentNames1[i]);
     // (J) Also collect conflicts between any fragment names by the first and
    // fragment names by the second. This compares each item in the first set of
    // names to each item in the second set of names.
    for(var _i3 = 0; _i3 < fragmentNames1.length; _i3++)for(var _j = 0; _j < fragmentNames2.length; _j++)$79d19cce53ef75b6$var$collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[_i3], fragmentNames2[_j]);
    return conflicts;
} // Collect all Conflicts "within" one collection of fields.
function $79d19cce53ef75b6$var$collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap) {
    // A field map is a keyed collection, where each key represents a response
    // name and the value at that key is a list of all fields which provide that
    // response name. For every response name, if there are multiple fields, they
    // must be compared to find a potential conflict.
    for(var _i5 = 0, _objectEntries2 = (0, $apet0.default)(fieldMap); _i5 < _objectEntries2.length; _i5++){
        var _ref5 = _objectEntries2[_i5];
        var responseName = _ref5[0];
        var fields = _ref5[1];
        // This compares every field in the list to every other field in this list
        // (except to itself). If the list only has one item, nothing needs to
        // be compared.
        if (fields.length > 1) {
            for(var i = 0; i < fields.length; i++)for(var j = i + 1; j < fields.length; j++){
                var conflict = $79d19cce53ef75b6$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, responseName, fields[i], fields[j]);
                if (conflict) conflicts.push(conflict);
            }
        }
    }
} // Collect all Conflicts between two collections of fields. This is similar to,
// but different from the `collectConflictsWithin` function above. This check
// assumes that `collectConflictsWithin` has already been called on each
// provided collection of fields. This is true because this validator traverses
// each individual selection set.
function $79d19cce53ef75b6$var$collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, fieldMap1, fieldMap2) {
    // A field map is a keyed collection, where each key represents a response
    // name and the value at that key is a list of all fields which provide that
    // response name. For any response name which appears in both provided field
    // maps, each field from the first field map must be compared to every field
    // in the second field map to find potential conflicts.
    for(var _i7 = 0, _Object$keys2 = Object.keys(fieldMap1); _i7 < _Object$keys2.length; _i7++){
        var responseName = _Object$keys2[_i7];
        var fields2 = fieldMap2[responseName];
        if (fields2) {
            var fields1 = fieldMap1[responseName];
            for(var i = 0; i < fields1.length; i++)for(var j = 0; j < fields2.length; j++){
                var conflict = $79d19cce53ef75b6$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, fields1[i], fields2[j]);
                if (conflict) conflicts.push(conflict);
            }
        }
    }
} // Determines if there is a conflict between two particular fields, including
// comparing their sub-fields.
function $79d19cce53ef75b6$var$findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, field1, field2) {
    var parentType1 = field1[0], node1 = field1[1], def1 = field1[2];
    var parentType2 = field2[0], node2 = field2[1], def2 = field2[2]; // If it is known that two fields could not possibly apply at the same
    // time, due to the parent types, then it is safe to permit them to diverge
    // in aliased field or arguments used as they will not present any ambiguity
    // by differing.
    // It is known that two parent types could never overlap if they are
    // different Object types. Interface or Union types might overlap - if not
    // in the current state of the schema, then perhaps in some future version,
    // thus may not safely diverge.
    var areMutuallyExclusive = parentFieldsAreMutuallyExclusive || parentType1 !== parentType2 && (0, $lXoEQ.isObjectType)(parentType1) && (0, $lXoEQ.isObjectType)(parentType2);
    if (!areMutuallyExclusive) {
        var _node1$arguments, _node2$arguments;
        // Two aliases must refer to the same field.
        var name1 = node1.name.value;
        var name2 = node2.name.value;
        if (name1 !== name2) return [
            [
                responseName,
                "\"".concat(name1, "\" and \"").concat(name2, "\" are different fields")
            ],
            [
                node1
            ],
            [
                node2
            ]
        ];
         // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var args1 = (_node1$arguments = node1.arguments) !== null && _node1$arguments !== void 0 ? _node1$arguments : []; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var args2 = (_node2$arguments = node2.arguments) !== null && _node2$arguments !== void 0 ? _node2$arguments : []; // Two field calls must have the same arguments.
        if (!$79d19cce53ef75b6$var$sameArguments(args1, args2)) return [
            [
                responseName,
                'they have differing arguments'
            ],
            [
                node1
            ],
            [
                node2
            ]
        ];
    } // The return type for each field.
    var type1 = def1 === null || def1 === void 0 ? void 0 : def1.type;
    var type2 = def2 === null || def2 === void 0 ? void 0 : def2.type;
    if (type1 && type2 && $79d19cce53ef75b6$var$doTypesConflict(type1, type2)) return [
        [
            responseName,
            "they return conflicting types \"".concat((0, $biK02.default)(type1), "\" and \"").concat((0, $biK02.default)(type2), "\"")
        ],
        [
            node1
        ],
        [
            node2
        ]
    ];
     // Collect and compare sub-fields. Use the same "visited fragment names" list
    // for both collections so fields in a fragment reference are never
    // compared to themselves.
    var selectionSet1 = node1.selectionSet;
    var selectionSet2 = node2.selectionSet;
    if (selectionSet1 && selectionSet2) {
        var conflicts = $79d19cce53ef75b6$var$findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, (0, $lXoEQ.getNamedType)(type1), selectionSet1, (0, $lXoEQ.getNamedType)(type2), selectionSet2);
        return $79d19cce53ef75b6$var$subfieldConflicts(conflicts, responseName, node1, node2);
    }
}
function $79d19cce53ef75b6$var$sameArguments(arguments1, arguments2) {
    if (arguments1.length !== arguments2.length) return false;
    return arguments1.every(function(argument1) {
        var argument2 = (0, $bmIpK.default)(arguments2, function(argument) {
            return argument.name.value === argument1.name.value;
        });
        if (!argument2) return false;
        return $79d19cce53ef75b6$var$sameValue(argument1.value, argument2.value);
    });
}
function $79d19cce53ef75b6$var$sameValue(value1, value2) {
    return (0, $aKlnM.print)(value1) === (0, $aKlnM.print)(value2);
} // Two types conflict if both types could not apply to a value simultaneously.
// Composite types are ignored as their individual field types will be compared
// later recursively. However List and Non-Null types must match.
function $79d19cce53ef75b6$var$doTypesConflict(type1, type2) {
    if ((0, $lXoEQ.isListType)(type1)) return (0, $lXoEQ.isListType)(type2) ? $79d19cce53ef75b6$var$doTypesConflict(type1.ofType, type2.ofType) : true;
    if ((0, $lXoEQ.isListType)(type2)) return true;
    if ((0, $lXoEQ.isNonNullType)(type1)) return (0, $lXoEQ.isNonNullType)(type2) ? $79d19cce53ef75b6$var$doTypesConflict(type1.ofType, type2.ofType) : true;
    if ((0, $lXoEQ.isNonNullType)(type2)) return true;
    if ((0, $lXoEQ.isLeafType)(type1) || (0, $lXoEQ.isLeafType)(type2)) return type1 !== type2;
    return false;
} // Given a selection set, return the collection of fields (a mapping of response
// name to field nodes and definitions) as well as a list of fragment names
// referenced via fragment spreads.
function $79d19cce53ef75b6$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet) {
    var cached = cachedFieldsAndFragmentNames.get(selectionSet);
    if (!cached) {
        var nodeAndDefs = Object.create(null);
        var fragmentNames = Object.create(null);
        $79d19cce53ef75b6$var$_collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames);
        cached = [
            nodeAndDefs,
            Object.keys(fragmentNames)
        ];
        cachedFieldsAndFragmentNames.set(selectionSet, cached);
    }
    return cached;
} // Given a reference to a fragment, return the represented collection of fields
// as well as a list of nested fragment names referenced via fragment spreads.
function $79d19cce53ef75b6$var$getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment) {
    // Short-circuit building a type from the node if possible.
    var cached = cachedFieldsAndFragmentNames.get(fragment.selectionSet);
    if (cached) return cached;
    var fragmentType = (0, $3zSAT.typeFromAST)(context.getSchema(), fragment.typeCondition);
    return $79d19cce53ef75b6$var$getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragmentType, fragment.selectionSet);
}
function $79d19cce53ef75b6$var$_collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames) {
    for(var _i9 = 0, _selectionSet$selecti2 = selectionSet.selections; _i9 < _selectionSet$selecti2.length; _i9++){
        var selection = _selectionSet$selecti2[_i9];
        switch(selection.kind){
            case (0, $1c4hI.Kind).FIELD:
                var fieldName = selection.name.value;
                var fieldDef = void 0;
                if ((0, $lXoEQ.isObjectType)(parentType) || (0, $lXoEQ.isInterfaceType)(parentType)) fieldDef = parentType.getFields()[fieldName];
                var responseName = selection.alias ? selection.alias.value : fieldName;
                if (!nodeAndDefs[responseName]) nodeAndDefs[responseName] = [];
                nodeAndDefs[responseName].push([
                    parentType,
                    selection,
                    fieldDef
                ]);
                break;
            case (0, $1c4hI.Kind).FRAGMENT_SPREAD:
                fragmentNames[selection.name.value] = true;
                break;
            case (0, $1c4hI.Kind).INLINE_FRAGMENT:
                var typeCondition = selection.typeCondition;
                var inlineFragmentType = typeCondition ? (0, $3zSAT.typeFromAST)(context.getSchema(), typeCondition) : parentType;
                $79d19cce53ef75b6$var$_collectFieldsAndFragmentNames(context, inlineFragmentType, selection.selectionSet, nodeAndDefs, fragmentNames);
                break;
        }
    }
} // Given a series of Conflicts which occurred between two sub-fields, generate
// a single Conflict.
function $79d19cce53ef75b6$var$subfieldConflicts(conflicts, responseName, node1, node2) {
    if (conflicts.length > 0) return [
        [
            responseName,
            conflicts.map(function(_ref6) {
                var reason = _ref6[0];
                return reason;
            })
        ],
        conflicts.reduce(function(allFields, _ref7) {
            var fields1 = _ref7[1];
            return allFields.concat(fields1);
        }, [
            node1
        ]),
        conflicts.reduce(function(allFields, _ref8) {
            var fields2 = _ref8[2];
            return allFields.concat(fields2);
        }, [
            node2
        ])
    ];
}
/**
 * A way to keep track of pairs of things when the ordering of the pair does
 * not matter. We do this by maintaining a sort of double adjacency sets.
 */ var $79d19cce53ef75b6$var$PairSet = /*#__PURE__*/ function() {
    function PairSet() {
        this._data = Object.create(null);
    }
    var _proto = PairSet.prototype;
    _proto.has = function has(a, b, areMutuallyExclusive) {
        var first = this._data[a];
        var result = first && first[b];
        if (result === undefined) return false;
         // areMutuallyExclusive being false is a superset of being true,
        // hence if we want to know if this PairSet "has" these two with no
        // exclusivity, we have to ensure it was added as such.
        if (areMutuallyExclusive === false) return result === false;
        return true;
    };
    _proto.add = function add(a, b, areMutuallyExclusive) {
        this._pairSetAdd(a, b, areMutuallyExclusive);
        this._pairSetAdd(b, a, areMutuallyExclusive);
    };
    _proto._pairSetAdd = function _pairSetAdd(a, b, areMutuallyExclusive) {
        var map = this._data[a];
        if (!map) {
            map = Object.create(null);
            this._data[a] = map;
        }
        map[b] = areMutuallyExclusive;
    };
    return PairSet;
}();

});

parcelRegister("1W7Gt", function(module, exports) {

$parcel$export(module.exports, "UniqueInputFieldNamesRule", () => $eb92478c221189f8$export$de7865c052ebdd8c);

var $9fgMZ = parcelRequire("9fgMZ");
function $eb92478c221189f8$export$de7865c052ebdd8c(context) {
    var knownNameStack = [];
    var knownNames = Object.create(null);
    return {
        ObjectValue: {
            enter: function enter() {
                knownNameStack.push(knownNames);
                knownNames = Object.create(null);
            },
            leave: function leave() {
                knownNames = knownNameStack.pop();
            }
        },
        ObjectField: function ObjectField(node) {
            var fieldName = node.name.value;
            if (knownNames[fieldName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one input field named \"".concat(fieldName, "\"."), [
                knownNames[fieldName],
                node.name
            ]));
            else knownNames[fieldName] = node.name;
        }
    };
}

});

parcelRegister("gawpj", function(module, exports) {

$parcel$export(module.exports, "LoneSchemaDefinitionRule", () => $f71f83ba1740d4a2$export$9eae4c44f9d64405);

var $9fgMZ = parcelRequire("9fgMZ");
function $f71f83ba1740d4a2$export$9eae4c44f9d64405(context) {
    var _ref, _ref2, _oldSchema$astNode;
    var oldSchema = context.getSchema();
    var alreadyDefined = (_ref = (_ref2 = (_oldSchema$astNode = oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.astNode) !== null && _oldSchema$astNode !== void 0 ? _oldSchema$astNode : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getQueryType()) !== null && _ref2 !== void 0 ? _ref2 : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getMutationType()) !== null && _ref !== void 0 ? _ref : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getSubscriptionType();
    var schemaDefinitionsCount = 0;
    return {
        SchemaDefinition: function SchemaDefinition(node) {
            if (alreadyDefined) {
                context.reportError(new (0, $9fgMZ.GraphQLError)('Cannot define a new schema within a schema extension.', node));
                return;
            }
            if (schemaDefinitionsCount > 0) context.reportError(new (0, $9fgMZ.GraphQLError)('Must provide only one schema definition.', node));
            ++schemaDefinitionsCount;
        }
    };
}

});

parcelRegister("b8axV", function(module, exports) {

$parcel$export(module.exports, "UniqueOperationTypesRule", () => $892cef0dee83a4c5$export$d9750570c6d13894);

var $9fgMZ = parcelRequire("9fgMZ");
function $892cef0dee83a4c5$export$d9750570c6d13894(context) {
    var schema = context.getSchema();
    var definedOperationTypes = Object.create(null);
    var existingOperationTypes = schema ? {
        query: schema.getQueryType(),
        mutation: schema.getMutationType(),
        subscription: schema.getSubscriptionType()
    } : {};
    return {
        SchemaDefinition: checkOperationTypes,
        SchemaExtension: checkOperationTypes
    };
    function checkOperationTypes(node) {
        var _node$operationTypes;
        // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var operationTypesNodes = (_node$operationTypes = node.operationTypes) !== null && _node$operationTypes !== void 0 ? _node$operationTypes : [];
        for(var _i2 = 0; _i2 < operationTypesNodes.length; _i2++){
            var operationType = operationTypesNodes[_i2];
            var operation = operationType.operation;
            var alreadyDefinedOperationType = definedOperationTypes[operation];
            if (existingOperationTypes[operation]) context.reportError(new (0, $9fgMZ.GraphQLError)("Type for ".concat(operation, " already defined in the schema. It cannot be redefined."), operationType));
            else if (alreadyDefinedOperationType) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one ".concat(operation, " type in schema."), [
                alreadyDefinedOperationType,
                operationType
            ]));
            else definedOperationTypes[operation] = operationType;
        }
        return false;
    }
}

});

parcelRegister("lOmVT", function(module, exports) {

$parcel$export(module.exports, "UniqueTypeNamesRule", () => $2484c652452810b0$export$380307ee0123f80e);

var $9fgMZ = parcelRequire("9fgMZ");
function $2484c652452810b0$export$380307ee0123f80e(context) {
    var knownTypeNames = Object.create(null);
    var schema = context.getSchema();
    return {
        ScalarTypeDefinition: checkTypeName,
        ObjectTypeDefinition: checkTypeName,
        InterfaceTypeDefinition: checkTypeName,
        UnionTypeDefinition: checkTypeName,
        EnumTypeDefinition: checkTypeName,
        InputObjectTypeDefinition: checkTypeName
    };
    function checkTypeName(node) {
        var typeName = node.name.value;
        if (schema !== null && schema !== void 0 && schema.getType(typeName)) {
            context.reportError(new (0, $9fgMZ.GraphQLError)("Type \"".concat(typeName, "\" already exists in the schema. It cannot also be defined in this type definition."), node.name));
            return;
        }
        if (knownTypeNames[typeName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one type named \"".concat(typeName, "\"."), [
            knownTypeNames[typeName],
            node.name
        ]));
        else knownTypeNames[typeName] = node.name;
        return false;
    }
}

});

parcelRegister("1H4NC", function(module, exports) {

$parcel$export(module.exports, "UniqueEnumValueNamesRule", () => $2bea4695779a7344$export$f5a22bb45cdc635d);

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
function $2bea4695779a7344$export$f5a22bb45cdc635d(context) {
    var schema = context.getSchema();
    var existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
    var knownValueNames = Object.create(null);
    return {
        EnumTypeDefinition: checkValueUniqueness,
        EnumTypeExtension: checkValueUniqueness
    };
    function checkValueUniqueness(node) {
        var _node$values;
        var typeName = node.name.value;
        if (!knownValueNames[typeName]) knownValueNames[typeName] = Object.create(null);
         // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var valueNodes = (_node$values = node.values) !== null && _node$values !== void 0 ? _node$values : [];
        var valueNames = knownValueNames[typeName];
        for(var _i2 = 0; _i2 < valueNodes.length; _i2++){
            var valueDef = valueNodes[_i2];
            var valueName = valueDef.name.value;
            var existingType = existingTypeMap[typeName];
            if ((0, $lXoEQ.isEnumType)(existingType) && existingType.getValue(valueName)) context.reportError(new (0, $9fgMZ.GraphQLError)("Enum value \"".concat(typeName, ".").concat(valueName, "\" already exists in the schema. It cannot also be defined in this type extension."), valueDef.name));
            else if (valueNames[valueName]) context.reportError(new (0, $9fgMZ.GraphQLError)("Enum value \"".concat(typeName, ".").concat(valueName, "\" can only be defined once."), [
                valueNames[valueName],
                valueDef.name
            ]));
            else valueNames[valueName] = valueDef.name;
        }
        return false;
    }
}

});

parcelRegister("lVZ4j", function(module, exports) {

$parcel$export(module.exports, "UniqueFieldDefinitionNamesRule", () => $c30f67380d4d4d7a$export$b3dfc0de81924308);

var $9fgMZ = parcelRequire("9fgMZ");

var $lXoEQ = parcelRequire("lXoEQ");
function $c30f67380d4d4d7a$export$b3dfc0de81924308(context) {
    var schema = context.getSchema();
    var existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
    var knownFieldNames = Object.create(null);
    return {
        InputObjectTypeDefinition: checkFieldUniqueness,
        InputObjectTypeExtension: checkFieldUniqueness,
        InterfaceTypeDefinition: checkFieldUniqueness,
        InterfaceTypeExtension: checkFieldUniqueness,
        ObjectTypeDefinition: checkFieldUniqueness,
        ObjectTypeExtension: checkFieldUniqueness
    };
    function checkFieldUniqueness(node) {
        var _node$fields;
        var typeName = node.name.value;
        if (!knownFieldNames[typeName]) knownFieldNames[typeName] = Object.create(null);
         // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var fieldNodes = (_node$fields = node.fields) !== null && _node$fields !== void 0 ? _node$fields : [];
        var fieldNames = knownFieldNames[typeName];
        for(var _i2 = 0; _i2 < fieldNodes.length; _i2++){
            var fieldDef = fieldNodes[_i2];
            var fieldName = fieldDef.name.value;
            if ($c30f67380d4d4d7a$var$hasField(existingTypeMap[typeName], fieldName)) context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(typeName, ".").concat(fieldName, "\" already exists in the schema. It cannot also be defined in this type extension."), fieldDef.name));
            else if (fieldNames[fieldName]) context.reportError(new (0, $9fgMZ.GraphQLError)("Field \"".concat(typeName, ".").concat(fieldName, "\" can only be defined once."), [
                fieldNames[fieldName],
                fieldDef.name
            ]));
            else fieldNames[fieldName] = fieldDef.name;
        }
        return false;
    }
}
function $c30f67380d4d4d7a$var$hasField(type, fieldName) {
    if ((0, $lXoEQ.isObjectType)(type) || (0, $lXoEQ.isInterfaceType)(type) || (0, $lXoEQ.isInputObjectType)(type)) return type.getFields()[fieldName] != null;
    return false;
}

});

parcelRegister("jCJ2v", function(module, exports) {

$parcel$export(module.exports, "UniqueDirectiveNamesRule", () => $d3a75eab1a7085ce$export$b06952068b20c86f);

var $9fgMZ = parcelRequire("9fgMZ");
function $d3a75eab1a7085ce$export$b06952068b20c86f(context) {
    var knownDirectiveNames = Object.create(null);
    var schema = context.getSchema();
    return {
        DirectiveDefinition: function DirectiveDefinition(node) {
            var directiveName = node.name.value;
            if (schema !== null && schema !== void 0 && schema.getDirective(directiveName)) {
                context.reportError(new (0, $9fgMZ.GraphQLError)("Directive \"@".concat(directiveName, "\" already exists in the schema. It cannot be redefined."), node.name));
                return;
            }
            if (knownDirectiveNames[directiveName]) context.reportError(new (0, $9fgMZ.GraphQLError)("There can be only one directive named \"@".concat(directiveName, "\"."), [
                knownDirectiveNames[directiveName],
                node.name
            ]));
            else knownDirectiveNames[directiveName] = node.name;
            return false;
        }
    };
}

});

parcelRegister("kJWSQ", function(module, exports) {

$parcel$export(module.exports, "PossibleTypeExtensionsRule", () => $56e81335f8ee936c$export$50309357bc4f0e8b);

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $8nBnZ = parcelRequire("8nBnZ");

var $bru1k = parcelRequire("bru1k");

var $9fgMZ = parcelRequire("9fgMZ");

var $1c4hI = parcelRequire("1c4hI");

var $9nArG = parcelRequire("9nArG");

var $lXoEQ = parcelRequire("lXoEQ");
var $56e81335f8ee936c$var$_defKindToExtKind;
function $56e81335f8ee936c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $56e81335f8ee936c$export$50309357bc4f0e8b(context) {
    var schema = context.getSchema();
    var definedTypes = Object.create(null);
    for(var _i2 = 0, _context$getDocument$2 = context.getDocument().definitions; _i2 < _context$getDocument$2.length; _i2++){
        var def = _context$getDocument$2[_i2];
        if ((0, $9nArG.isTypeDefinitionNode)(def)) definedTypes[def.name.value] = def;
    }
    return {
        ScalarTypeExtension: checkExtension,
        ObjectTypeExtension: checkExtension,
        InterfaceTypeExtension: checkExtension,
        UnionTypeExtension: checkExtension,
        EnumTypeExtension: checkExtension,
        InputObjectTypeExtension: checkExtension
    };
    function checkExtension(node) {
        var typeName = node.name.value;
        var defNode = definedTypes[typeName];
        var existingType = schema === null || schema === void 0 ? void 0 : schema.getType(typeName);
        var expectedKind;
        if (defNode) expectedKind = $56e81335f8ee936c$var$defKindToExtKind[defNode.kind];
        else if (existingType) expectedKind = $56e81335f8ee936c$var$typeToExtKind(existingType);
        if (expectedKind) {
            if (expectedKind !== node.kind) {
                var kindStr = $56e81335f8ee936c$var$extensionKindToTypeName(node.kind);
                context.reportError(new (0, $9fgMZ.GraphQLError)("Cannot extend non-".concat(kindStr, " type \"").concat(typeName, "\"."), defNode ? [
                    defNode,
                    node
                ] : node));
            }
        } else {
            var allTypeNames = Object.keys(definedTypes);
            if (schema) allTypeNames = allTypeNames.concat(Object.keys(schema.getTypeMap()));
            var suggestedTypes = (0, $bru1k.default)(typeName, allTypeNames);
            context.reportError(new (0, $9fgMZ.GraphQLError)("Cannot extend type \"".concat(typeName, "\" because it is not defined.") + (0, $8nBnZ.default)(suggestedTypes), node.name));
        }
    }
}
var $56e81335f8ee936c$var$defKindToExtKind = ($56e81335f8ee936c$var$_defKindToExtKind = {}, $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION, (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION), $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION, (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION), $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION, (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION), $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).UNION_TYPE_DEFINITION, (0, $1c4hI.Kind).UNION_TYPE_EXTENSION), $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION, (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION), $56e81335f8ee936c$var$_defineProperty($56e81335f8ee936c$var$_defKindToExtKind, (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION, (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION), $56e81335f8ee936c$var$_defKindToExtKind);
function $56e81335f8ee936c$var$typeToExtKind(type) {
    if ((0, $lXoEQ.isScalarType)(type)) return (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION;
    if ((0, $lXoEQ.isObjectType)(type)) return (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION;
    if ((0, $lXoEQ.isInterfaceType)(type)) return (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION;
    if ((0, $lXoEQ.isUnionType)(type)) return (0, $1c4hI.Kind).UNION_TYPE_EXTENSION;
    if ((0, $lXoEQ.isEnumType)(type)) return (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION;
     // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isInputObjectType)(type)) return (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION;
     // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, $43MJl.default)(0, 'Unexpected type: ' + (0, $biK02.default)(type));
}
function $56e81335f8ee936c$var$extensionKindToTypeName(kind) {
    switch(kind){
        case (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION:
            return 'scalar';
        case (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION:
            return 'object';
        case (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION:
            return 'interface';
        case (0, $1c4hI.Kind).UNION_TYPE_EXTENSION:
            return 'union';
        case (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION:
            return 'enum';
        case (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION:
            return 'input object';
    } // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, $43MJl.default)(0, 'Unexpected kind: ' + (0, $biK02.default)(kind));
}

});


parcelRegister("5RV6E", function(module, exports) {

$parcel$export(module.exports, "SDLValidationContext", () => $4e98916749b0fed4$export$62ce401b55355c79);
$parcel$export(module.exports, "ValidationContext", () => $4e98916749b0fed4$export$d452675449e81987);

var $1c4hI = parcelRequire("1c4hI");

var $961BR = parcelRequire("961BR");

var $hMOry = parcelRequire("hMOry");
function $4e98916749b0fed4$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4e98916749b0fed4$export$ebdf7b7a2f7aef8b = /*#__PURE__*/ function() {
    function ASTValidationContext(ast, onError) {
        this._ast = ast;
        this._fragments = undefined;
        this._fragmentSpreads = new Map();
        this._recursivelyReferencedFragments = new Map();
        this._onError = onError;
    }
    var _proto = ASTValidationContext.prototype;
    _proto.reportError = function reportError(error) {
        this._onError(error);
    };
    _proto.getDocument = function getDocument() {
        return this._ast;
    };
    _proto.getFragment = function getFragment(name) {
        var fragments = this._fragments;
        if (!fragments) this._fragments = fragments = this.getDocument().definitions.reduce(function(frags, statement) {
            if (statement.kind === (0, $1c4hI.Kind).FRAGMENT_DEFINITION) frags[statement.name.value] = statement;
            return frags;
        }, Object.create(null));
        return fragments[name];
    };
    _proto.getFragmentSpreads = function getFragmentSpreads(node) {
        var spreads = this._fragmentSpreads.get(node);
        if (!spreads) {
            spreads = [];
            var setsToVisit = [
                node
            ];
            while(setsToVisit.length !== 0){
                var set = setsToVisit.pop();
                for(var _i2 = 0, _set$selections2 = set.selections; _i2 < _set$selections2.length; _i2++){
                    var selection = _set$selections2[_i2];
                    if (selection.kind === (0, $1c4hI.Kind).FRAGMENT_SPREAD) spreads.push(selection);
                    else if (selection.selectionSet) setsToVisit.push(selection.selectionSet);
                }
            }
            this._fragmentSpreads.set(node, spreads);
        }
        return spreads;
    };
    _proto.getRecursivelyReferencedFragments = function getRecursivelyReferencedFragments(operation) {
        var fragments = this._recursivelyReferencedFragments.get(operation);
        if (!fragments) {
            fragments = [];
            var collectedNames = Object.create(null);
            var nodesToVisit = [
                operation.selectionSet
            ];
            while(nodesToVisit.length !== 0){
                var node = nodesToVisit.pop();
                for(var _i4 = 0, _this$getFragmentSpre2 = this.getFragmentSpreads(node); _i4 < _this$getFragmentSpre2.length; _i4++){
                    var spread = _this$getFragmentSpre2[_i4];
                    var fragName = spread.name.value;
                    if (collectedNames[fragName] !== true) {
                        collectedNames[fragName] = true;
                        var fragment = this.getFragment(fragName);
                        if (fragment) {
                            fragments.push(fragment);
                            nodesToVisit.push(fragment.selectionSet);
                        }
                    }
                }
            }
            this._recursivelyReferencedFragments.set(operation, fragments);
        }
        return fragments;
    };
    return ASTValidationContext;
}();
var $4e98916749b0fed4$export$62ce401b55355c79 = /*#__PURE__*/ function(_ASTValidationContext) {
    $4e98916749b0fed4$var$_inheritsLoose(SDLValidationContext, _ASTValidationContext);
    function SDLValidationContext(ast, schema, onError) {
        var _this;
        _this = _ASTValidationContext.call(this, ast, onError) || this;
        _this._schema = schema;
        return _this;
    }
    var _proto2 = SDLValidationContext.prototype;
    _proto2.getSchema = function getSchema() {
        return this._schema;
    };
    return SDLValidationContext;
}($4e98916749b0fed4$export$ebdf7b7a2f7aef8b);
var $4e98916749b0fed4$export$d452675449e81987 = /*#__PURE__*/ function(_ASTValidationContext2) {
    $4e98916749b0fed4$var$_inheritsLoose(ValidationContext, _ASTValidationContext2);
    function ValidationContext(schema, ast, typeInfo, onError) {
        var _this2;
        _this2 = _ASTValidationContext2.call(this, ast, onError) || this;
        _this2._schema = schema;
        _this2._typeInfo = typeInfo;
        _this2._variableUsages = new Map();
        _this2._recursiveVariableUsages = new Map();
        return _this2;
    }
    var _proto3 = ValidationContext.prototype;
    _proto3.getSchema = function getSchema() {
        return this._schema;
    };
    _proto3.getVariableUsages = function getVariableUsages(node) {
        var usages = this._variableUsages.get(node);
        if (!usages) {
            var newUsages = [];
            var typeInfo = new (0, $hMOry.TypeInfo)(this._schema);
            (0, $961BR.visit)(node, (0, $hMOry.visitWithTypeInfo)(typeInfo, {
                VariableDefinition: function VariableDefinition() {
                    return false;
                },
                Variable: function Variable(variable) {
                    newUsages.push({
                        node: variable,
                        type: typeInfo.getInputType(),
                        defaultValue: typeInfo.getDefaultValue()
                    });
                }
            }));
            usages = newUsages;
            this._variableUsages.set(node, usages);
        }
        return usages;
    };
    _proto3.getRecursiveVariableUsages = function getRecursiveVariableUsages(operation) {
        var usages = this._recursiveVariableUsages.get(operation);
        if (!usages) {
            usages = this.getVariableUsages(operation);
            for(var _i6 = 0, _this$getRecursivelyR2 = this.getRecursivelyReferencedFragments(operation); _i6 < _this$getRecursivelyR2.length; _i6++){
                var frag = _this$getRecursivelyR2[_i6];
                usages = usages.concat(this.getVariableUsages(frag));
            }
            this._recursiveVariableUsages.set(operation, usages);
        }
        return usages;
    };
    _proto3.getType = function getType() {
        return this._typeInfo.getType();
    };
    _proto3.getParentType = function getParentType() {
        return this._typeInfo.getParentType();
    };
    _proto3.getInputType = function getInputType() {
        return this._typeInfo.getInputType();
    };
    _proto3.getParentInputType = function getParentInputType() {
        return this._typeInfo.getParentInputType();
    };
    _proto3.getFieldDef = function getFieldDef() {
        return this._typeInfo.getFieldDef();
    };
    _proto3.getDirective = function getDirective() {
        return this._typeInfo.getDirective();
    };
    _proto3.getArgument = function getArgument() {
        return this._typeInfo.getArgument();
    };
    _proto3.getEnumValue = function getEnumValue() {
        return this._typeInfo.getEnumValue();
    };
    return ValidationContext;
}($4e98916749b0fed4$export$ebdf7b7a2f7aef8b);

});


parcelRegister("glHRe", function(module, exports) {

$parcel$export(module.exports, "extendSchema", () => $6ade12bb8df37dc4$export$35f5fe5f3e862ea3);
$parcel$export(module.exports, "extendSchemaImpl", () => $6ade12bb8df37dc4$export$97eac8f938300c6f);
$parcel$export(module.exports, "getDescription", () => $6ade12bb8df37dc4$export$67580b1c13935958);

var $dVq2R = parcelRequire("dVq2R");

var $hbiEd = parcelRequire("hbiEd");

var $biK02 = parcelRequire("biK02");

var $6MWHL = parcelRequire("6MWHL");

var $43MJl = parcelRequire("43MJl");

var $fZdRY = parcelRequire("fZdRY");

var $1c4hI = parcelRequire("1c4hI");

var $hFu5F = parcelRequire("hFu5F");

var $flA0a = parcelRequire("flA0a");

var $9nArG = parcelRequire("9nArG");

var $dGflO = parcelRequire("dGflO");

var $gqGQB = parcelRequire("gqGQB");

var $6BdRO = parcelRequire("6BdRO");

var $auu22 = parcelRequire("auu22");

var $h2iUh = parcelRequire("h2iUh");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");

var $3E0nn = parcelRequire("3E0nn");
function $6ade12bb8df37dc4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6ade12bb8df37dc4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $6ade12bb8df37dc4$var$ownKeys(Object(source), true).forEach(function(key) {
            $6ade12bb8df37dc4$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $6ade12bb8df37dc4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6ade12bb8df37dc4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6ade12bb8df37dc4$export$35f5fe5f3e862ea3(schema, documentAST, options) {
    (0, $6BdRO.assertSchema)(schema);
    documentAST != null && documentAST.kind === (0, $1c4hI.Kind).DOCUMENT || (0, $fZdRY.default)(0, 'Must provide valid Document AST.');
    if ((options === null || options === void 0 ? void 0 : options.assumeValid) !== true && (options === null || options === void 0 ? void 0 : options.assumeValidSDL) !== true) (0, $dGflO.assertValidSDLExtension)(documentAST, schema);
    var schemaConfig = schema.toConfig();
    var extendedConfig = $6ade12bb8df37dc4$export$97eac8f938300c6f(schemaConfig, documentAST, options);
    return schemaConfig === extendedConfig ? schema : new (0, $6BdRO.GraphQLSchema)(extendedConfig);
}
function $6ade12bb8df37dc4$export$97eac8f938300c6f(schemaConfig, documentAST, options) {
    var _schemaDef, _schemaDef$descriptio, _schemaDef2, _options$assumeValid;
    // Collect the type definitions and extensions found in the document.
    var typeDefs = [];
    var typeExtensionsMap = Object.create(null); // New directives and types are separate because a directives and types can
    // have the same name. For example, a type named "skip".
    var directiveDefs = [];
    var schemaDef; // Schema extensions are collected which may add additional operation types.
    var schemaExtensions = [];
    for(var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++){
        var def = _documentAST$definiti2[_i2];
        if (def.kind === (0, $1c4hI.Kind).SCHEMA_DEFINITION) schemaDef = def;
        else if (def.kind === (0, $1c4hI.Kind).SCHEMA_EXTENSION) schemaExtensions.push(def);
        else if ((0, $9nArG.isTypeDefinitionNode)(def)) typeDefs.push(def);
        else if ((0, $9nArG.isTypeExtensionNode)(def)) {
            var extendedTypeName = def.name.value;
            var existingTypeExtensions = typeExtensionsMap[extendedTypeName];
            typeExtensionsMap[extendedTypeName] = existingTypeExtensions ? existingTypeExtensions.concat([
                def
            ]) : [
                def
            ];
        } else if (def.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION) directiveDefs.push(def);
    } // If this document contains no new types, extensions, or directives then
    // return the same unmodified GraphQLSchema instance.
    if (Object.keys(typeExtensionsMap).length === 0 && typeDefs.length === 0 && directiveDefs.length === 0 && schemaExtensions.length === 0 && schemaDef == null) return schemaConfig;
    var typeMap = Object.create(null);
    for(var _i4 = 0, _schemaConfig$types2 = schemaConfig.types; _i4 < _schemaConfig$types2.length; _i4++){
        var existingType = _schemaConfig$types2[_i4];
        typeMap[existingType.name] = extendNamedType(existingType);
    }
    for(var _i6 = 0; _i6 < typeDefs.length; _i6++){
        var _stdTypeMap$name;
        var typeNode = typeDefs[_i6];
        var name = typeNode.name.value;
        typeMap[name] = (_stdTypeMap$name = $6ade12bb8df37dc4$var$stdTypeMap[name]) !== null && _stdTypeMap$name !== void 0 ? _stdTypeMap$name : buildType(typeNode);
    }
    var operationTypes = $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({
        // Get the extended root operation types.
        query: schemaConfig.query && replaceNamedType(schemaConfig.query),
        mutation: schemaConfig.mutation && replaceNamedType(schemaConfig.mutation),
        subscription: schemaConfig.subscription && replaceNamedType(schemaConfig.subscription)
    }, schemaDef && getOperationTypes([
        schemaDef
    ])), getOperationTypes(schemaExtensions)); // Then produce and return a Schema config with these types.
    return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({
        description: (_schemaDef = schemaDef) === null || _schemaDef === void 0 ? void 0 : (_schemaDef$descriptio = _schemaDef.description) === null || _schemaDef$descriptio === void 0 ? void 0 : _schemaDef$descriptio.value
    }, operationTypes), {}, {
        types: (0, $dVq2R.default)(typeMap),
        directives: [].concat(schemaConfig.directives.map(replaceDirective), directiveDefs.map(buildDirective)),
        extensions: undefined,
        astNode: (_schemaDef2 = schemaDef) !== null && _schemaDef2 !== void 0 ? _schemaDef2 : schemaConfig.astNode,
        extensionASTNodes: schemaConfig.extensionASTNodes.concat(schemaExtensions),
        assumeValid: (_options$assumeValid = options === null || options === void 0 ? void 0 : options.assumeValid) !== null && _options$assumeValid !== void 0 ? _options$assumeValid : false
    }); // Below are functions used for producing this schema that have closed over
    // this scope and have access to the schema, cache, and newly defined types.
    function replaceType(type) {
        if ((0, $lXoEQ.isListType)(type)) // $FlowFixMe[incompatible-return]
        return new (0, $lXoEQ.GraphQLList)(replaceType(type.ofType));
        if ((0, $lXoEQ.isNonNullType)(type)) // $FlowFixMe[incompatible-return]
        return new (0, $lXoEQ.GraphQLNonNull)(replaceType(type.ofType));
        return replaceNamedType(type);
    }
    function replaceNamedType(type) {
        // Note: While this could make early assertions to get the correctly
        // typed values, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        return typeMap[type.name];
    }
    function replaceDirective(directive) {
        var config = directive.toConfig();
        return new (0, $bOniD.GraphQLDirective)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            args: (0, $6MWHL.default)(config.args, extendArg)
        }));
    }
    function extendNamedType(type) {
        if ((0, $h2iUh.isIntrospectionType)(type) || (0, $auu22.isSpecifiedScalarType)(type)) // Builtin types are not extended.
        return type;
        if ((0, $lXoEQ.isScalarType)(type)) return extendScalarType(type);
        if ((0, $lXoEQ.isObjectType)(type)) return extendObjectType(type);
        if ((0, $lXoEQ.isInterfaceType)(type)) return extendInterfaceType(type);
        if ((0, $lXoEQ.isUnionType)(type)) return extendUnionType(type);
        if ((0, $lXoEQ.isEnumType)(type)) return extendEnumType(type);
         // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
        if ((0, $lXoEQ.isInputObjectType)(type)) return extendInputObjectType(type);
         // istanbul ignore next (Not reachable. All possible types have been considered)
        (0, $43MJl.default)(0, 'Unexpected type: ' + (0, $biK02.default)(type));
    }
    function extendInputObjectType(type) {
        var _typeExtensionsMap$co;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co !== void 0 ? _typeExtensionsMap$co : [];
        return new (0, $lXoEQ.GraphQLInputObjectType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            fields: function fields() {
                return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, (0, $6MWHL.default)(config.fields, function(field) {
                    return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, field), {}, {
                        type: replaceType(field.type)
                    });
                })), buildInputFieldMap(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendEnumType(type) {
        var _typeExtensionsMap$ty;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$ty = typeExtensionsMap[type.name]) !== null && _typeExtensionsMap$ty !== void 0 ? _typeExtensionsMap$ty : [];
        return new (0, $lXoEQ.GraphQLEnumType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            values: $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config.values), buildEnumValueMap(extensions)),
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendScalarType(type) {
        var _typeExtensionsMap$co2;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co2 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co2 !== void 0 ? _typeExtensionsMap$co2 : [];
        var specifiedByUrl = config.specifiedByUrl;
        for(var _i8 = 0; _i8 < extensions.length; _i8++){
            var _getSpecifiedByUrl;
            var extensionNode = extensions[_i8];
            specifiedByUrl = (_getSpecifiedByUrl = $6ade12bb8df37dc4$var$getSpecifiedByUrl(extensionNode)) !== null && _getSpecifiedByUrl !== void 0 ? _getSpecifiedByUrl : specifiedByUrl;
        }
        return new (0, $lXoEQ.GraphQLScalarType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            specifiedByUrl: specifiedByUrl,
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendObjectType(type) {
        var _typeExtensionsMap$co3;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co3 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co3 !== void 0 ? _typeExtensionsMap$co3 : [];
        return new (0, $lXoEQ.GraphQLObjectType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            interfaces: function interfaces() {
                return [].concat(type.getInterfaces().map(replaceNamedType), buildInterfaces(extensions));
            },
            fields: function fields() {
                return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, (0, $6MWHL.default)(config.fields, extendField)), buildFieldMap(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendInterfaceType(type) {
        var _typeExtensionsMap$co4;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co4 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co4 !== void 0 ? _typeExtensionsMap$co4 : [];
        return new (0, $lXoEQ.GraphQLInterfaceType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            interfaces: function interfaces() {
                return [].concat(type.getInterfaces().map(replaceNamedType), buildInterfaces(extensions));
            },
            fields: function fields() {
                return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, (0, $6MWHL.default)(config.fields, extendField)), buildFieldMap(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendUnionType(type) {
        var _typeExtensionsMap$co5;
        var config = type.toConfig();
        var extensions = (_typeExtensionsMap$co5 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co5 !== void 0 ? _typeExtensionsMap$co5 : [];
        return new (0, $lXoEQ.GraphQLUnionType)($6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, config), {}, {
            types: function types() {
                return [].concat(type.getTypes().map(replaceNamedType), buildUnionTypes(extensions));
            },
            extensionASTNodes: config.extensionASTNodes.concat(extensions)
        }));
    }
    function extendField(field) {
        return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, field), {}, {
            type: replaceType(field.type),
            // $FlowFixMe[incompatible-call]
            args: (0, $6MWHL.default)(field.args, extendArg)
        });
    }
    function extendArg(arg) {
        return $6ade12bb8df37dc4$var$_objectSpread($6ade12bb8df37dc4$var$_objectSpread({}, arg), {}, {
            type: replaceType(arg.type)
        });
    }
    function getOperationTypes(nodes) {
        var opTypes = {};
        for(var _i10 = 0; _i10 < nodes.length; _i10++){
            var _node$operationTypes;
            var node = nodes[_i10];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var operationTypesNodes = (_node$operationTypes = node.operationTypes) !== null && _node$operationTypes !== void 0 ? _node$operationTypes : [];
            for(var _i12 = 0; _i12 < operationTypesNodes.length; _i12++){
                var operationType = operationTypesNodes[_i12];
                opTypes[operationType.operation] = getNamedType(operationType.type);
            }
        } // Note: While this could make early assertions to get the correctly
        // typed values below, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        return opTypes;
    }
    function getNamedType(node) {
        var _stdTypeMap$name2;
        var name = node.name.value;
        var type = (_stdTypeMap$name2 = $6ade12bb8df37dc4$var$stdTypeMap[name]) !== null && _stdTypeMap$name2 !== void 0 ? _stdTypeMap$name2 : typeMap[name];
        if (type === undefined) throw new Error("Unknown type: \"".concat(name, "\"."));
        return type;
    }
    function getWrappedType(node) {
        if (node.kind === (0, $1c4hI.Kind).LIST_TYPE) return new (0, $lXoEQ.GraphQLList)(getWrappedType(node.type));
        if (node.kind === (0, $1c4hI.Kind).NON_NULL_TYPE) return new (0, $lXoEQ.GraphQLNonNull)(getWrappedType(node.type));
        return getNamedType(node);
    }
    function buildDirective(node) {
        var locations = node.locations.map(function(_ref) {
            var value = _ref.value;
            return value;
        });
        return new (0, $bOniD.GraphQLDirective)({
            name: node.name.value,
            description: $6ade12bb8df37dc4$export$67580b1c13935958(node, options),
            locations: locations,
            isRepeatable: node.repeatable,
            args: buildArgumentMap(node.arguments),
            astNode: node
        });
    }
    function buildFieldMap(nodes) {
        var fieldConfigMap = Object.create(null);
        for(var _i14 = 0; _i14 < nodes.length; _i14++){
            var _node$fields;
            var node = nodes[_i14];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var nodeFields = (_node$fields = node.fields) !== null && _node$fields !== void 0 ? _node$fields : [];
            for(var _i16 = 0; _i16 < nodeFields.length; _i16++){
                var field = nodeFields[_i16];
                fieldConfigMap[field.name.value] = {
                    // Note: While this could make assertions to get the correctly typed
                    // value, that would throw immediately while type system validation
                    // with validateSchema() will produce more actionable results.
                    type: getWrappedType(field.type),
                    description: $6ade12bb8df37dc4$export$67580b1c13935958(field, options),
                    args: buildArgumentMap(field.arguments),
                    deprecationReason: $6ade12bb8df37dc4$var$getDeprecationReason(field),
                    astNode: field
                };
            }
        }
        return fieldConfigMap;
    }
    function buildArgumentMap(args) {
        // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
        var argsNodes = args !== null && args !== void 0 ? args : [];
        var argConfigMap = Object.create(null);
        for(var _i18 = 0; _i18 < argsNodes.length; _i18++){
            var arg = argsNodes[_i18];
            // Note: While this could make assertions to get the correctly typed
            // value, that would throw immediately while type system validation
            // with validateSchema() will produce more actionable results.
            var type = getWrappedType(arg.type);
            argConfigMap[arg.name.value] = {
                type: type,
                description: $6ade12bb8df37dc4$export$67580b1c13935958(arg, options),
                defaultValue: (0, $3E0nn.valueFromAST)(arg.defaultValue, type),
                deprecationReason: $6ade12bb8df37dc4$var$getDeprecationReason(arg),
                astNode: arg
            };
        }
        return argConfigMap;
    }
    function buildInputFieldMap(nodes) {
        var inputFieldMap = Object.create(null);
        for(var _i20 = 0; _i20 < nodes.length; _i20++){
            var _node$fields2;
            var node = nodes[_i20];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var fieldsNodes = (_node$fields2 = node.fields) !== null && _node$fields2 !== void 0 ? _node$fields2 : [];
            for(var _i22 = 0; _i22 < fieldsNodes.length; _i22++){
                var field = fieldsNodes[_i22];
                // Note: While this could make assertions to get the correctly typed
                // value, that would throw immediately while type system validation
                // with validateSchema() will produce more actionable results.
                var type = getWrappedType(field.type);
                inputFieldMap[field.name.value] = {
                    type: type,
                    description: $6ade12bb8df37dc4$export$67580b1c13935958(field, options),
                    defaultValue: (0, $3E0nn.valueFromAST)(field.defaultValue, type),
                    deprecationReason: $6ade12bb8df37dc4$var$getDeprecationReason(field),
                    astNode: field
                };
            }
        }
        return inputFieldMap;
    }
    function buildEnumValueMap(nodes) {
        var enumValueMap = Object.create(null);
        for(var _i24 = 0; _i24 < nodes.length; _i24++){
            var _node$values;
            var node = nodes[_i24];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var valuesNodes = (_node$values = node.values) !== null && _node$values !== void 0 ? _node$values : [];
            for(var _i26 = 0; _i26 < valuesNodes.length; _i26++){
                var value = valuesNodes[_i26];
                enumValueMap[value.name.value] = {
                    description: $6ade12bb8df37dc4$export$67580b1c13935958(value, options),
                    deprecationReason: $6ade12bb8df37dc4$var$getDeprecationReason(value),
                    astNode: value
                };
            }
        }
        return enumValueMap;
    }
    function buildInterfaces(nodes) {
        var interfaces = [];
        for(var _i28 = 0; _i28 < nodes.length; _i28++){
            var _node$interfaces;
            var node = nodes[_i28];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var interfacesNodes = (_node$interfaces = node.interfaces) !== null && _node$interfaces !== void 0 ? _node$interfaces : [];
            for(var _i30 = 0; _i30 < interfacesNodes.length; _i30++){
                var type = interfacesNodes[_i30];
                // Note: While this could make assertions to get the correctly typed
                // values below, that would throw immediately while type system
                // validation with validateSchema() will produce more actionable
                // results.
                interfaces.push(getNamedType(type));
            }
        }
        return interfaces;
    }
    function buildUnionTypes(nodes) {
        var types = [];
        for(var _i32 = 0; _i32 < nodes.length; _i32++){
            var _node$types;
            var node = nodes[_i32];
            // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
            var typeNodes = (_node$types = node.types) !== null && _node$types !== void 0 ? _node$types : [];
            for(var _i34 = 0; _i34 < typeNodes.length; _i34++){
                var type = typeNodes[_i34];
                // Note: While this could make assertions to get the correctly typed
                // values below, that would throw immediately while type system
                // validation with validateSchema() will produce more actionable
                // results.
                types.push(getNamedType(type));
            }
        }
        return types;
    }
    function buildType(astNode) {
        var _typeExtensionsMap$na;
        var name = astNode.name.value;
        var description = $6ade12bb8df37dc4$export$67580b1c13935958(astNode, options);
        var extensionNodes = (_typeExtensionsMap$na = typeExtensionsMap[name]) !== null && _typeExtensionsMap$na !== void 0 ? _typeExtensionsMap$na : [];
        switch(astNode.kind){
            case (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION:
                var extensionASTNodes = extensionNodes;
                var allNodes = [
                    astNode
                ].concat(extensionASTNodes);
                return new (0, $lXoEQ.GraphQLObjectType)({
                    name: name,
                    description: description,
                    interfaces: function interfaces() {
                        return buildInterfaces(allNodes);
                    },
                    fields: function fields() {
                        return buildFieldMap(allNodes);
                    },
                    astNode: astNode,
                    extensionASTNodes: extensionASTNodes
                });
            case (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION:
                var _extensionASTNodes = extensionNodes;
                var _allNodes = [
                    astNode
                ].concat(_extensionASTNodes);
                return new (0, $lXoEQ.GraphQLInterfaceType)({
                    name: name,
                    description: description,
                    interfaces: function interfaces() {
                        return buildInterfaces(_allNodes);
                    },
                    fields: function fields() {
                        return buildFieldMap(_allNodes);
                    },
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes
                });
            case (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION:
                var _extensionASTNodes2 = extensionNodes;
                var _allNodes2 = [
                    astNode
                ].concat(_extensionASTNodes2);
                return new (0, $lXoEQ.GraphQLEnumType)({
                    name: name,
                    description: description,
                    values: buildEnumValueMap(_allNodes2),
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes2
                });
            case (0, $1c4hI.Kind).UNION_TYPE_DEFINITION:
                var _extensionASTNodes3 = extensionNodes;
                var _allNodes3 = [
                    astNode
                ].concat(_extensionASTNodes3);
                return new (0, $lXoEQ.GraphQLUnionType)({
                    name: name,
                    description: description,
                    types: function types() {
                        return buildUnionTypes(_allNodes3);
                    },
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes3
                });
            case (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION:
                var _extensionASTNodes4 = extensionNodes;
                return new (0, $lXoEQ.GraphQLScalarType)({
                    name: name,
                    description: description,
                    specifiedByUrl: $6ade12bb8df37dc4$var$getSpecifiedByUrl(astNode),
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes4
                });
            case (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION:
                var _extensionASTNodes5 = extensionNodes;
                var _allNodes4 = [
                    astNode
                ].concat(_extensionASTNodes5);
                return new (0, $lXoEQ.GraphQLInputObjectType)({
                    name: name,
                    description: description,
                    fields: function fields() {
                        return buildInputFieldMap(_allNodes4);
                    },
                    astNode: astNode,
                    extensionASTNodes: _extensionASTNodes5
                });
        } // istanbul ignore next (Not reachable. All possible type definition nodes have been considered)
        (0, $43MJl.default)(0, 'Unexpected type definition node: ' + (0, $biK02.default)(astNode));
    }
}
var $6ade12bb8df37dc4$var$stdTypeMap = (0, $hbiEd.default)((0, $auu22.specifiedScalarTypes).concat((0, $h2iUh.introspectionTypes)), function(type) {
    return type.name;
});
/**
 * Given a field or enum value node, returns the string value for the
 * deprecation reason.
 */ function $6ade12bb8df37dc4$var$getDeprecationReason(node) {
    var deprecated = (0, $gqGQB.getDirectiveValues)((0, $bOniD.GraphQLDeprecatedDirective), node);
    return deprecated === null || deprecated === void 0 ? void 0 : deprecated.reason;
}
/**
 * Given a scalar node, returns the string value for the specifiedByUrl.
 */ function $6ade12bb8df37dc4$var$getSpecifiedByUrl(node) {
    var specifiedBy = (0, $gqGQB.getDirectiveValues)((0, $bOniD.GraphQLSpecifiedByDirective), node);
    return specifiedBy === null || specifiedBy === void 0 ? void 0 : specifiedBy.url;
}
function $6ade12bb8df37dc4$export$67580b1c13935958(node, options) {
    if (node.description) return node.description.value;
    if ((options === null || options === void 0 ? void 0 : options.commentDescriptions) === true) {
        var rawValue = $6ade12bb8df37dc4$var$getLeadingCommentBlock(node);
        if (rawValue !== undefined) return (0, $flA0a.dedentBlockStringValue)('\n' + rawValue);
    }
}
function $6ade12bb8df37dc4$var$getLeadingCommentBlock(node) {
    var loc = node.loc;
    if (!loc) return;
    var comments = [];
    var token = loc.startToken.prev;
    while(token != null && token.kind === (0, $hFu5F.TokenKind).COMMENT && token.next && token.prev && token.line + 1 === token.next.line && token.line !== token.prev.line){
        var value = String(token.value);
        comments.push(value);
        token = token.prev;
    }
    return comments.length > 0 ? comments.reverse().join('\n') : undefined;
}

});


parcelRegister("9Dtw4", function(module, exports) {
var $703ea6dd6d6923b7$var$__assign = module.exports && module.exports.__assign || function() {
    $703ea6dd6d6923b7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $703ea6dd6d6923b7$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1c4hI = parcelRequire("1c4hI");
function $703ea6dd6d6923b7$var$filterExtensionDefinitions(ast) {
    var extensionDefs = ast.definitions.filter(function(def) {
        return def.kind !== $1c4hI.Kind.OBJECT_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.INTERFACE_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.INPUT_OBJECT_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.UNION_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.ENUM_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.SCALAR_TYPE_EXTENSION && def.kind !== $1c4hI.Kind.SCHEMA_EXTENSION;
    });
    return $703ea6dd6d6923b7$var$__assign($703ea6dd6d6923b7$var$__assign({}, ast), {
        definitions: extensionDefs
    });
}
module.exports.default = $703ea6dd6d6923b7$var$filterExtensionDefinitions;

});


parcelRegister("zi3Qo", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");
function $06a14789b0ee6806$var$chainResolvers(resolvers) {
    return function(root, args, ctx, info) {
        return resolvers.reduce(function(prev, curResolver) {
            if (curResolver) return curResolver(prev, args, ctx, info);
            return $3MP74.defaultFieldResolver(prev, args, ctx, info);
        }, root);
    };
}
module.exports.chainResolvers = $06a14789b0ee6806$var$chainResolvers;

});

parcelRegister("3zHIx", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");

var $cYGSS = parcelRequire("cYGSS");
// If we have any union or interface types throw if no there is no resolveType or isTypeOf resolvers
function $29a68d5bffacbb58$var$checkForResolveTypeResolver(schema, requireResolversForResolveType) {
    Object.keys(schema.getTypeMap()).map(function(typeName) {
        return schema.getType(typeName);
    }).forEach(function(type) {
        if (!(type instanceof $lXoEQ.GraphQLUnionType || type instanceof $lXoEQ.GraphQLInterfaceType)) return;
        if (!type.resolveType) {
            if (requireResolversForResolveType === false) return;
            if (requireResolversForResolveType === true) throw new $cYGSS.SchemaError("Type \"" + type.name + "\" is missing a \"resolveType\" resolver");
            // tslint:disable-next-line:max-line-length
            console.warn("Type \"" + type.name + "\" is missing a \"__resolveType\" resolver. Pass false into " + "\"resolverValidationOptions.requireResolversForResolveType\" to disable this warning.");
        }
    });
}
module.exports.default = $29a68d5bffacbb58$var$checkForResolveTypeResolver;

});

parcelRegister("fzT6r", function(module, exports) {
var $b574de2b55f17580$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aKlnM = parcelRequire("aKlnM");

var $cYGSS = parcelRequire("cYGSS");
function $b574de2b55f17580$var$concatenateTypeDefs(typeDefinitionsAry, calledFunctionRefs) {
    if (calledFunctionRefs === void 0) calledFunctionRefs = [];
    var resolvedTypeDefinitions = [];
    typeDefinitionsAry.forEach(function(typeDef) {
        if (typeDef.kind !== undefined) typeDef = $aKlnM.print(typeDef);
        if (typeof typeDef === 'function') {
            if (calledFunctionRefs.indexOf(typeDef) === -1) {
                calledFunctionRefs.push(typeDef);
                resolvedTypeDefinitions = resolvedTypeDefinitions.concat($b574de2b55f17580$var$concatenateTypeDefs(typeDef(), calledFunctionRefs));
            }
        } else if (typeof typeDef === 'string') resolvedTypeDefinitions.push(typeDef.trim());
        else {
            var type = typeof typeDef;
            throw new $cYGSS.SchemaError("typeDef array must contain only strings and functions, got " + type);
        }
    });
    return $b574de2b55f17580$var$uniq(resolvedTypeDefinitions.map(function(x) {
        return x.trim();
    })).join('\n');
}
function $b574de2b55f17580$var$uniq(array) {
    return array.reduce(function(accumulator, currentValue) {
        return accumulator.indexOf(currentValue) === -1 ? $b574de2b55f17580$var$__spreadArrays(accumulator, [
            currentValue
        ]) : accumulator;
    }, []);
}
module.exports.default = $b574de2b55f17580$var$concatenateTypeDefs;

});

parcelRegister("jhVll", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");
/*
 * fn: The function to decorate with the logger
 * logger: an object instance of type Logger
 * hint: an optional hint to add to the error's message
 */ function $e0ac160d29c86bae$var$decorateWithLogger(fn, logger, hint) {
    if (typeof fn === 'undefined') fn = $3MP74.defaultFieldResolver;
    var logError = function(e) {
        // TODO: clone the error properly
        var newE = new Error();
        newE.stack = e.stack;
        /* istanbul ignore else: always get the hint from addErrorLoggingToSchema */ if (hint) {
            newE['originalMessage'] = e.message;
            newE['message'] = "Error in resolver " + hint + "\n" + e.message;
        }
        logger.log(newE);
    };
    return function(root, args, ctx, info) {
        try {
            var result = fn(root, args, ctx, info);
            // If the resolve function returns a Promise log any Promise rejects.
            if (result && typeof result.then === 'function' && typeof result.catch === 'function') result.catch(function(reason) {
                // make sure that it's an error we're logging.
                var error = reason instanceof Error ? reason : new Error(reason);
                logError(error);
                // We don't want to leave an unhandled exception so pass on error.
                return reason;
            });
            return result;
        } catch (e) {
            logError(e);
            // we want to pass on the error, just in case.
            throw e;
        }
    };
}
module.exports.default = $e0ac160d29c86bae$var$decorateWithLogger;

});

parcelRegister("anY4o", function(module, exports) {
var $78faa5f901c93c41$var$__assign = module.exports && module.exports.__assign || function() {
    $78faa5f901c93c41$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $78faa5f901c93c41$var$__assign.apply(this, arguments);
};
var $78faa5f901c93c41$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
function $78faa5f901c93c41$var$extendResolversFromInterfaces(schema, resolvers) {
    var typeNames = Object.keys($78faa5f901c93c41$var$__assign($78faa5f901c93c41$var$__assign({}, schema.getTypeMap()), resolvers));
    var extendedResolvers = {};
    typeNames.forEach(function(typeName) {
        var typeResolvers = resolvers[typeName];
        var type = schema.getType(typeName);
        if (type instanceof $lXoEQ.GraphQLObjectType) {
            var interfaceResolvers = type.getInterfaces().map(function(iFace) {
                return resolvers[iFace.name];
            });
            extendedResolvers[typeName] = Object.assign.apply(Object, $78faa5f901c93c41$var$__spreadArrays([
                {}
            ], interfaceResolvers, [
                typeResolvers
            ]));
        } else if (typeResolvers) extendedResolvers[typeName] = typeResolvers;
    });
    return extendedResolvers;
}
module.exports.default = $78faa5f901c93c41$var$extendResolversFromInterfaces;

});

parcelRegister("4YHnC", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $39fe6a5e79c5f7d4$var$newExtensionDefinitionKind = 'ObjectTypeExtension';
var $39fe6a5e79c5f7d4$var$interfaceExtensionDefinitionKind = 'InterfaceTypeExtension';
var $39fe6a5e79c5f7d4$var$inputObjectExtensionDefinitionKind = 'InputObjectTypeExtension';
var $39fe6a5e79c5f7d4$var$unionExtensionDefinitionKind = 'UnionTypeExtension';
var $39fe6a5e79c5f7d4$var$enumExtensionDefinitionKind = 'EnumTypeExtension';
function $39fe6a5e79c5f7d4$var$extractExtensionDefinitions(ast) {
    var extensionDefs = ast.definitions.filter(function(def) {
        return def.kind === $39fe6a5e79c5f7d4$var$newExtensionDefinitionKind || def.kind === $39fe6a5e79c5f7d4$var$interfaceExtensionDefinitionKind || def.kind === $39fe6a5e79c5f7d4$var$inputObjectExtensionDefinitionKind || def.kind === $39fe6a5e79c5f7d4$var$unionExtensionDefinitionKind || def.kind === $39fe6a5e79c5f7d4$var$enumExtensionDefinitionKind;
    });
    return Object.assign({}, ast, {
        definitions: extensionDefs
    });
}
module.exports.default = $39fe6a5e79c5f7d4$var$extractExtensionDefinitions;

});

parcelRegister("bKZOs", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
function $88f3f05290386e89$var$forEachField(schema, fn) {
    var typeMap = schema.getTypeMap();
    Object.keys(typeMap).forEach(function(typeName) {
        var type = typeMap[typeName];
        // TODO: maybe have an option to include these?
        if (!$lXoEQ.getNamedType(type).name.startsWith('__') && type instanceof $lXoEQ.GraphQLObjectType) {
            var fields_1 = type.getFields();
            Object.keys(fields_1).forEach(function(fieldName) {
                var field = fields_1[fieldName];
                fn(field, typeName, fieldName);
            });
        }
    });
}
module.exports.default = $88f3f05290386e89$var$forEachField;

});

parcelRegister("69KMn", function(module, exports) {
var $47b7debb288af193$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// @schemaDefinition: A GraphQL type schema in shorthand
// @resolvers: Definitions for resolvers to be merged with schema
var $47b7debb288af193$var$SchemaError = /** @class */ function(_super) {
    $47b7debb288af193$var$__extends(SchemaError, _super);
    function SchemaError(message) {
        var _this = _super.call(this, message) || this;
        _this.message = message;
        Error.captureStackTrace(_this, _this.constructor);
        return _this;
    }
    return SchemaError;
}(Error);
module.exports.default = $47b7debb288af193$var$SchemaError;

});



parcelRegister("hbdmQ", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $9CBYi = parcelRequire("9CBYi");
var $6BdRO = parcelRequire("6BdRO");

var $hompL = parcelRequire("hompL");

var $crrCr = parcelRequire("crrCr");
// This function wraps addMockFunctionsToSchema for more convenience
function $c81dd5440f0cf1c4$var$mockServer(schema, mocks, preserveResolvers) {
    if (preserveResolvers === void 0) preserveResolvers = false;
    var mySchema;
    if (!(schema instanceof $6BdRO.GraphQLSchema)) // TODO: provide useful error messages here if this fails
    mySchema = $crrCr.buildSchemaFromTypeDefinitions(schema);
    else mySchema = schema;
    $c81dd5440f0cf1c4$var$addMockFunctionsToSchema({
        schema: mySchema,
        mocks: mocks,
        preserveResolvers: preserveResolvers
    });
    return {
        query: function(query, vars) {
            return $9CBYi.graphql(mySchema, query, {}, {}, vars);
        }
    };
}
module.exports.mockServer = $c81dd5440f0cf1c4$var$mockServer;
var $c81dd5440f0cf1c4$var$defaultMockMap = new Map();
$c81dd5440f0cf1c4$var$defaultMockMap.set('Int', function() {
    return Math.round(Math.random() * 200) - 100;
});
$c81dd5440f0cf1c4$var$defaultMockMap.set('Float', function() {
    return Math.random() * 200 - 100;
});
$c81dd5440f0cf1c4$var$defaultMockMap.set('String', function() {
    return 'Hello World';
});
$c81dd5440f0cf1c4$var$defaultMockMap.set('Boolean', function() {
    return Math.random() > 0.5;
});
$c81dd5440f0cf1c4$var$defaultMockMap.set('ID', function() {
    return $hompL.v4();
});
// TODO allow providing a seed such that lengths of list could be deterministic
// this could be done by using casual to get a random list length if the casual
// object is global.
function $c81dd5440f0cf1c4$var$addMockFunctionsToSchema(_a) {
    var schema = _a.schema, _b = _a.mocks, mocks = _b === void 0 ? {} : _b, _c = _a.preserveResolvers, preserveResolvers = _c === void 0 ? false : _c;
    if (!schema) throw new Error('Must provide schema to mock');
    if (!(schema instanceof $6BdRO.GraphQLSchema)) throw new Error('Value at "schema" must be of type GraphQLSchema');
    if (!$c81dd5440f0cf1c4$var$isObject(mocks)) throw new Error('mocks must be of type Object');
    // use Map internally, because that API is nicer.
    var mockFunctionMap = new Map();
    Object.keys(mocks).forEach(function(typeName) {
        mockFunctionMap.set(typeName, mocks[typeName]);
    });
    mockFunctionMap.forEach(function(mockFunction, mockTypeName) {
        if (typeof mockFunction !== 'function') throw new Error("mockFunctionMap[" + mockTypeName + "] must be a function");
    });
    var mockType = function(type, typeName, fieldName) {
        // order of precendence for mocking:
        // 1. if the object passed in already has fieldName, just use that
        // --> if it's a function, that becomes your resolver
        // --> if it's a value, the mock resolver will return that
        // 2. if the nullableType is a list, recurse
        // 2. if there's a mock defined for this typeName, that will be used
        // 3. if there's no mock defined, use the default mocks for this type
        return function(root, args, context, info) {
            // nullability doesn't matter for the purpose of mocking.
            var fieldType = $lXoEQ.getNullableType(type);
            var namedFieldType = $lXoEQ.getNamedType(fieldType);
            if (root && typeof root[fieldName] !== 'undefined') {
                var result = void 0;
                // if we're here, the field is already defined
                if (typeof root[fieldName] === 'function') {
                    result = root[fieldName](root, args, context, info);
                    if (result instanceof $c81dd5440f0cf1c4$var$MockList) result = result.mock(root, args, context, info, fieldType, mockType);
                } else result = root[fieldName];
                // Now we merge the result with the default mock for this type.
                // This allows overriding defaults while writing very little code.
                if (mockFunctionMap.has(namedFieldType.name)) result = $c81dd5440f0cf1c4$var$mergeMocks(mockFunctionMap.get(namedFieldType.name).bind(null, root, args, context, info), result);
                return result;
            }
            if (fieldType instanceof $lXoEQ.GraphQLList || fieldType instanceof $lXoEQ.GraphQLNonNull) return [
                mockType(fieldType.ofType)(root, args, context, info),
                mockType(fieldType.ofType)(root, args, context, info)
            ];
            if (mockFunctionMap.has(fieldType.name) && !(fieldType instanceof $lXoEQ.GraphQLUnionType || fieldType instanceof $lXoEQ.GraphQLInterfaceType)) // the object passed doesn't have this field, so we apply the default mock
            return mockFunctionMap.get(fieldType.name)(root, args, context, info);
            if (fieldType instanceof $lXoEQ.GraphQLObjectType) // objects don't return actual data, we only need to mock scalars!
            return {};
            // if a mock function is provided for unionType or interfaceType, execute it to resolve the concrete type
            // otherwise randomly pick a type from all implementation types
            if (fieldType instanceof $lXoEQ.GraphQLUnionType || fieldType instanceof $lXoEQ.GraphQLInterfaceType) {
                var implementationType = void 0;
                if (mockFunctionMap.has(fieldType.name)) {
                    var interfaceMockObj = mockFunctionMap.get(fieldType.name)(root, args, context, info);
                    if (!interfaceMockObj || !interfaceMockObj.__typename) return Error("Please return a __typename in \"" + fieldType.name + "\"");
                    implementationType = schema.getType(interfaceMockObj.__typename);
                } else {
                    var possibleTypes = schema.getPossibleTypes(fieldType);
                    implementationType = $c81dd5440f0cf1c4$var$getRandomElement(possibleTypes);
                }
                return Object.assign({
                    __typename: implementationType
                }, mockType(implementationType)(root, args, context, info));
            }
            if (fieldType instanceof $lXoEQ.GraphQLEnumType) return $c81dd5440f0cf1c4$var$getRandomElement(fieldType.getValues()).value;
            if ($c81dd5440f0cf1c4$var$defaultMockMap.has(fieldType.name)) return $c81dd5440f0cf1c4$var$defaultMockMap.get(fieldType.name)(root, args, context, info);
            // if we get to here, we don't have a value, and we don't have a mock for this type,
            // we could return undefined, but that would be hard to debug, so we throw instead.
            // however, we returning it instead of throwing it, so preserveResolvers can handle the failures.
            return Error("No mock defined for type \"" + fieldType.name + "\"");
        };
    };
    $crrCr.forEachField(schema, function(field, typeName, fieldName) {
        $c81dd5440f0cf1c4$var$assignResolveType(field.type, preserveResolvers);
        var mockResolver;
        // we have to handle the root mutation and root query types differently,
        // because no resolver is called at the root.
        /* istanbul ignore next: Must provide schema DefinitionNode with query type or a type named Query. */ var isOnQueryType = schema.getQueryType() && schema.getQueryType().name === typeName;
        var isOnMutationType = schema.getMutationType() && schema.getMutationType().name === typeName;
        if (isOnQueryType || isOnMutationType) {
            if (mockFunctionMap.has(typeName)) {
                var rootMock_1 = mockFunctionMap.get(typeName);
                // XXX: BUG in here, need to provide proper signature for rootMock.
                if (typeof rootMock_1(undefined, {}, {}, {})[fieldName] === 'function') mockResolver = function(root, args, context, info) {
                    var updatedRoot = root || {}; // TODO: should we clone instead?
                    updatedRoot[fieldName] = rootMock_1(root, args, context, info)[fieldName];
                    // XXX this is a bit of a hack to still use mockType, which
                    // lets you mock lists etc. as well
                    // otherwise we could just set field.resolve to rootMock()[fieldName]
                    // it's like pretending there was a resolve function that ran before
                    // the root resolve function.
                    return mockType(field.type, typeName, fieldName)(updatedRoot, args, context, info);
                };
            }
        }
        if (!mockResolver) mockResolver = mockType(field.type, typeName, fieldName);
        if (!preserveResolvers || !field.resolve) field.resolve = mockResolver;
        else {
            var oldResolver_1 = field.resolve;
            field.resolve = function(rootObject, args, context, info) {
                return Promise.all([
                    mockResolver(rootObject, args, context, info),
                    oldResolver_1(rootObject, args, context, info)
                ]).then(function(values) {
                    var mockedValue = values[0], resolvedValue = values[1];
                    // In case we couldn't mock
                    if (mockedValue instanceof Error) {
                        // only if value was not resolved, populate the error.
                        if (undefined === resolvedValue) throw mockedValue;
                        return resolvedValue;
                    }
                    if (resolvedValue instanceof Date && mockedValue instanceof Date) return undefined !== resolvedValue ? resolvedValue : mockedValue;
                    if ($c81dd5440f0cf1c4$var$isObject(mockedValue) && $c81dd5440f0cf1c4$var$isObject(resolvedValue)) {
                        // Object.assign() won't do here, as we need to all properties, including
                        // the non-enumerable ones and defined using Object.defineProperty
                        var emptyObject = Object.create(Object.getPrototypeOf(resolvedValue));
                        return $c81dd5440f0cf1c4$var$copyOwnProps(emptyObject, resolvedValue, mockedValue);
                    }
                    return undefined !== resolvedValue ? resolvedValue : mockedValue;
                });
            };
        }
    });
}
module.exports.addMockFunctionsToSchema = $c81dd5440f0cf1c4$var$addMockFunctionsToSchema;
function $c81dd5440f0cf1c4$var$isObject(thing) {
    return thing === Object(thing) && !Array.isArray(thing);
}
// returns a random element from that ary
function $c81dd5440f0cf1c4$var$getRandomElement(ary) {
    var sample = Math.floor(Math.random() * ary.length);
    return ary[sample];
}
function $c81dd5440f0cf1c4$var$mergeObjects(a, b) {
    return Object.assign(a, b);
}
function $c81dd5440f0cf1c4$var$copyOwnPropsIfNotPresent(target, source) {
    Object.getOwnPropertyNames(source).forEach(function(prop) {
        if (!Object.getOwnPropertyDescriptor(target, prop)) Object.defineProperty(target, prop, Object.getOwnPropertyDescriptor(source, prop));
    });
}
function $c81dd5440f0cf1c4$var$copyOwnProps(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        var chain = source;
        while(chain){
            $c81dd5440f0cf1c4$var$copyOwnPropsIfNotPresent(target, chain);
            chain = Object.getPrototypeOf(chain);
        }
    });
    return target;
}
// takes either an object or a (possibly nested) array
// and completes the customMock object with any fields
// defined on genericMock
// only merges objects or arrays. Scalars are returned as is
function $c81dd5440f0cf1c4$var$mergeMocks(genericMockFunction, customMock) {
    if (Array.isArray(customMock)) return customMock.map(function(el) {
        return $c81dd5440f0cf1c4$var$mergeMocks(genericMockFunction, el);
    });
    if ($c81dd5440f0cf1c4$var$isObject(customMock)) return $c81dd5440f0cf1c4$var$mergeObjects(genericMockFunction(), customMock);
    return customMock;
}
function $c81dd5440f0cf1c4$var$getResolveType(namedFieldType) {
    if (namedFieldType instanceof $lXoEQ.GraphQLInterfaceType || namedFieldType instanceof $lXoEQ.GraphQLUnionType) return namedFieldType.resolveType;
    else return undefined;
}
function $c81dd5440f0cf1c4$var$assignResolveType(type, preserveResolvers) {
    var fieldType = $lXoEQ.getNullableType(type);
    var namedFieldType = $lXoEQ.getNamedType(fieldType);
    var oldResolveType = $c81dd5440f0cf1c4$var$getResolveType(namedFieldType);
    if (preserveResolvers && oldResolveType && oldResolveType.length) return;
    if (namedFieldType instanceof $lXoEQ.GraphQLUnionType || namedFieldType instanceof $lXoEQ.GraphQLInterfaceType) // the default `resolveType` always returns null. We add a fallback
    // resolution that works with how unions and interface are mocked
    namedFieldType.resolveType = function(data, context, info) {
        return info.schema.getType(data.__typename);
    };
}
var $c81dd5440f0cf1c4$var$MockList = /** @class */ function() {
    // wrappedFunction can return another MockList or a value
    function MockList(len, wrappedFunction) {
        this.len = len;
        if (typeof wrappedFunction !== 'undefined') {
            if (typeof wrappedFunction !== 'function') throw new Error('Second argument to MockList must be a function or undefined');
            this.wrappedFunction = wrappedFunction;
        }
    }
    MockList.prototype.mock = function(root, args, context, info, fieldType, mockTypeFunc) {
        var arr;
        if (Array.isArray(this.len)) arr = new Array(this.randint(this.len[0], this.len[1]));
        else arr = new Array(this.len);
        for(var i = 0; i < arr.length; i++)if (typeof this.wrappedFunction === 'function') {
            var res = this.wrappedFunction(root, args, context, info);
            if (res instanceof MockList) {
                var nullableType = $lXoEQ.getNullableType(fieldType.ofType);
                arr[i] = res.mock(root, args, context, info, nullableType, mockTypeFunc);
            } else arr[i] = res;
        } else arr[i] = mockTypeFunc(fieldType.ofType)(root, args, context, info);
        return arr;
    };
    MockList.prototype.randint = function(low, high) {
        return Math.floor(Math.random() * (high - low + 1) + low);
    };
    return MockList;
}();
module.exports.MockList = $c81dd5440f0cf1c4$var$MockList;

});
parcelRegister("9CBYi", function(module, exports) {

$parcel$export(module.exports, "graphql", () => $c4e440e580a0befe$export$1eb4e7c0ed67b035);

var $cvCbM = parcelRequire("cvCbM");

var $6ds0g = parcelRequire("6ds0g");

var $dGflO = parcelRequire("dGflO");

var $izaFt = parcelRequire("izaFt");

var $3MP74 = parcelRequire("3MP74");
function $c4e440e580a0befe$export$1eb4e7c0ed67b035(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
    var _arguments = arguments;
    /* eslint-enable no-redeclare */ // Always return a Promise for a consistent API.
    return new Promise(function(resolve) {
        return resolve(_arguments.length === 1 ? $c4e440e580a0befe$var$graphqlImpl(argsOrSchema) : $c4e440e580a0befe$var$graphqlImpl({
            schema: argsOrSchema,
            source: source,
            rootValue: rootValue,
            contextValue: contextValue,
            variableValues: variableValues,
            operationName: operationName,
            fieldResolver: fieldResolver,
            typeResolver: typeResolver
        }));
    });
}
function $c4e440e580a0befe$export$51b1816fb8b0711e(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
    /* eslint-enable no-redeclare */ // Extract arguments from object args if provided.
    var result = arguments.length === 1 ? $c4e440e580a0befe$var$graphqlImpl(argsOrSchema) : $c4e440e580a0befe$var$graphqlImpl({
        schema: argsOrSchema,
        source: source,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        typeResolver: typeResolver
    }); // Assert that the execution was synchronous.
    if ((0, $cvCbM.default)(result)) throw new Error('GraphQL execution failed to complete synchronously.');
    return result;
}
function $c4e440e580a0befe$var$graphqlImpl(args) {
    var schema = args.schema, source = args.source, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, typeResolver = args.typeResolver; // Validate Schema
    var schemaValidationErrors = (0, $izaFt.validateSchema)(schema);
    if (schemaValidationErrors.length > 0) return {
        errors: schemaValidationErrors
    };
     // Parse
    var document;
    try {
        document = (0, $6ds0g.parse)(source);
    } catch (syntaxError) {
        return {
            errors: [
                syntaxError
            ]
        };
    } // Validate
    var validationErrors = (0, $dGflO.validate)(schema, document);
    if (validationErrors.length > 0) return {
        errors: validationErrors
    };
     // Execute
    return (0, $3MP74.execute)({
        schema: schema,
        document: document,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        typeResolver: typeResolver
    });
}

});


parcelRegister("akAyp", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1kTmX = parcelRequire("1kTmX");
module.exports.makeRemoteExecutableSchema = $1kTmX.default;
module.exports.defaultCreateRemoteResolver = $1kTmX.createResolver;

var $cns77 = parcelRequire("cns77");
module.exports.introspectSchema = $cns77.default;

var $2KwZj = parcelRequire("2KwZj");
module.exports.mergeSchemas = $2KwZj.default;

var $7UWAA = parcelRequire("7UWAA");
module.exports.delegateToSchema = $7UWAA.default;

var $8je8M = parcelRequire("8je8M");
module.exports.defaultMergedResolver = $8je8M.default;

});
parcelRegister("1kTmX", function(module, exports) {
var $0f929bdd6e89143d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0f929bdd6e89143d$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0f929bdd6e89143d$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gUA8G = parcelRequire("gUA8G");
var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $gQVH8 = parcelRequire("gQVH8");

var $i07ri = parcelRequire("i07ri");

var $hRrcw = parcelRequire("hRrcw");

var $crrCr = parcelRequire("crrCr");

var $h8S1f = parcelRequire("h8S1f");

var $j0Odg = parcelRequire("j0Odg");

var $8je8M = parcelRequire("8je8M");

var $10LTa = parcelRequire("10LTa");

var $583I3 = parcelRequire("583I3");
function $0f929bdd6e89143d$var$makeRemoteExecutableSchema(_a) {
    var _b;
    var schema = _a.schema, link = _a.link, fetcher = _a.fetcher, _c = _a.createResolver, customCreateResolver = _c === void 0 ? $0f929bdd6e89143d$var$createResolver : _c, buildSchemaOptions = _a.buildSchemaOptions, _d = _a.printSchemaOptions, printSchemaOptions = _d === void 0 ? {
        commentDescriptions: true
    } : _d;
    if (!fetcher && link) fetcher = $i07ri.default(link);
    var typeDefs;
    if (typeof schema === 'string') {
        typeDefs = schema;
        schema = $gUA8G.buildSchema(typeDefs, buildSchemaOptions);
    } else typeDefs = $gQVH8.printSchema(schema, printSchemaOptions);
    // prepare query resolvers
    var queryResolvers = {};
    var queryType = schema.getQueryType();
    var queries = queryType.getFields();
    Object.keys(queries).forEach(function(key) {
        queryResolvers[key] = customCreateResolver(fetcher);
    });
    // prepare mutation resolvers
    var mutationResolvers = {};
    var mutationType = schema.getMutationType();
    if (mutationType) {
        var mutations = mutationType.getFields();
        Object.keys(mutations).forEach(function(key) {
            mutationResolvers[key] = customCreateResolver(fetcher);
        });
    }
    // prepare subscription resolvers
    var subscriptionResolvers = {};
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType) {
        var subscriptions = subscriptionType.getFields();
        Object.keys(subscriptions).forEach(function(key) {
            subscriptionResolvers[key] = {
                subscribe: $0f929bdd6e89143d$var$createSubscriptionResolver(key, link)
            };
        });
    }
    // merge resolvers into resolver map
    var resolvers = (_b = {}, _b[queryType.name] = queryResolvers, _b);
    if (!$hRrcw.default(mutationResolvers)) resolvers[mutationType.name] = mutationResolvers;
    if (!$hRrcw.default(subscriptionResolvers)) resolvers[subscriptionType.name] = subscriptionResolvers;
    // add missing abstract resolvers (scalar, unions, interfaces)
    var typeMap = schema.getTypeMap();
    var types = Object.keys(typeMap).map(function(name) {
        return typeMap[name];
    });
    var _loop_1 = function(type) {
        if (type instanceof $lXoEQ.GraphQLInterfaceType || type instanceof $lXoEQ.GraphQLUnionType) resolvers[type.name] = {
            __resolveType: function(parent, context, info) {
                return $j0Odg.default(parent, info.schema);
            }
        };
        else if (type instanceof $lXoEQ.GraphQLScalarType) {
            if (!(type === $auu22.GraphQLID || type === $auu22.GraphQLString || type === $auu22.GraphQLFloat || type === $auu22.GraphQLBoolean || type === $auu22.GraphQLInt)) resolvers[type.name] = $h8S1f.recreateType(type, function(name) {
                return null;
            }, false);
        } else if (type instanceof $lXoEQ.GraphQLObjectType && type.name.slice(0, 2) !== '__' && type !== queryType && type !== mutationType && type !== subscriptionType) {
            var resolver_1 = {};
            Object.keys(type.getFields()).forEach(function(field) {
                resolver_1[field] = $8je8M.default;
            });
            resolvers[type.name] = resolver_1;
        }
    };
    for(var _i = 0, types_1 = types; _i < types_1.length; _i++){
        var type = types_1[_i];
        _loop_1(type);
    }
    return $crrCr.makeExecutableSchema({
        typeDefs: typeDefs,
        resolvers: resolvers
    });
}
module.exports.default = $0f929bdd6e89143d$var$makeRemoteExecutableSchema;
function $0f929bdd6e89143d$var$createResolver(fetcher) {
    var _this = this;
    return function(root, args, context, info) {
        return $0f929bdd6e89143d$var$__awaiter(_this, void 0, void 0, function() {
            var fragments, document, result;
            return $0f929bdd6e89143d$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        fragments = Object.keys(info.fragments).map(function(fragment) {
                            return info.fragments[fragment];
                        });
                        document = {
                            kind: $1c4hI.Kind.DOCUMENT,
                            definitions: $0f929bdd6e89143d$var$__spreadArrays([
                                info.operation
                            ], fragments)
                        };
                        return [
                            4 /*yield*/ ,
                            fetcher({
                                query: document,
                                variables: info.variableValues,
                                context: {
                                    graphqlContext: context
                                }
                            })
                        ];
                    case 1:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            $10LTa.checkResultAndHandleErrors(result, info)
                        ];
                }
            });
        });
    };
}
module.exports.createResolver = $0f929bdd6e89143d$var$createResolver;
function $0f929bdd6e89143d$var$createSubscriptionResolver(name, link) {
    return function(root, args, context, info) {
        var fragments = Object.keys(info.fragments).map(function(fragment) {
            return info.fragments[fragment];
        });
        var document = {
            kind: $1c4hI.Kind.DOCUMENT,
            definitions: $0f929bdd6e89143d$var$__spreadArrays([
                info.operation
            ], fragments)
        };
        var operation = {
            query: document,
            variables: info.variableValues,
            context: {
                graphqlContext: context
            }
        };
        var observable = $i07ri.execute(link, operation);
        return $583I3.observableToAsyncIterable(observable);
    };
}

});
parcelRegister("gQVH8", function(module, exports) {

$parcel$export(module.exports, "printSchema", () => $ad02b274e585f6bd$export$f7c984b74d0fc2e7);

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $43MJl = parcelRequire("43MJl");

var $aKlnM = parcelRequire("aKlnM");

var $flA0a = parcelRequire("flA0a");

var $h2iUh = parcelRequire("h2iUh");

var $auu22 = parcelRequire("auu22");

var $bOniD = parcelRequire("bOniD");

var $lXoEQ = parcelRequire("lXoEQ");

var $cMIyS = parcelRequire("cMIyS");
function $ad02b274e585f6bd$export$f7c984b74d0fc2e7(schema, options) {
    return $ad02b274e585f6bd$var$printFilteredSchema(schema, function(n) {
        return !(0, $bOniD.isSpecifiedDirective)(n);
    }, $ad02b274e585f6bd$var$isDefinedType, options);
}
function $ad02b274e585f6bd$export$436bfe9e87d1be55(schema, options) {
    return $ad02b274e585f6bd$var$printFilteredSchema(schema, (0, $bOniD.isSpecifiedDirective), (0, $h2iUh.isIntrospectionType), options);
}
function $ad02b274e585f6bd$var$isDefinedType(type) {
    return !(0, $auu22.isSpecifiedScalarType)(type) && !(0, $h2iUh.isIntrospectionType)(type);
}
function $ad02b274e585f6bd$var$printFilteredSchema(schema, directiveFilter, typeFilter, options) {
    var directives = schema.getDirectives().filter(directiveFilter);
    var types = (0, $dVq2R.default)(schema.getTypeMap()).filter(typeFilter);
    return [
        $ad02b274e585f6bd$var$printSchemaDefinition(schema)
    ].concat(directives.map(function(directive) {
        return $ad02b274e585f6bd$var$printDirective(directive, options);
    }), types.map(function(type) {
        return $ad02b274e585f6bd$export$199528f8b0f9bf49(type, options);
    })).filter(Boolean).join('\n\n') + '\n';
}
function $ad02b274e585f6bd$var$printSchemaDefinition(schema) {
    if (schema.description == null && $ad02b274e585f6bd$var$isSchemaOfCommonNames(schema)) return;
    var operationTypes = [];
    var queryType = schema.getQueryType();
    if (queryType) operationTypes.push("  query: ".concat(queryType.name));
    var mutationType = schema.getMutationType();
    if (mutationType) operationTypes.push("  mutation: ".concat(mutationType.name));
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType) operationTypes.push("  subscription: ".concat(subscriptionType.name));
    return $ad02b274e585f6bd$var$printDescription({}, schema) + "schema {\n".concat(operationTypes.join('\n'), "\n}");
}
/**
 * GraphQL schema define root types for each type of operation. These types are
 * the same as any other type and can be named in any manner, however there is
 * a common naming convention:
 *
 *   schema {
 *     query: Query
 *     mutation: Mutation
 *   }
 *
 * When using this naming convention, the schema description can be omitted.
 */ function $ad02b274e585f6bd$var$isSchemaOfCommonNames(schema) {
    var queryType = schema.getQueryType();
    if (queryType && queryType.name !== 'Query') return false;
    var mutationType = schema.getMutationType();
    if (mutationType && mutationType.name !== 'Mutation') return false;
    var subscriptionType = schema.getSubscriptionType();
    if (subscriptionType && subscriptionType.name !== 'Subscription') return false;
    return true;
}
function $ad02b274e585f6bd$export$199528f8b0f9bf49(type, options) {
    if ((0, $lXoEQ.isScalarType)(type)) return $ad02b274e585f6bd$var$printScalar(type, options);
    if ((0, $lXoEQ.isObjectType)(type)) return $ad02b274e585f6bd$var$printObject(type, options);
    if ((0, $lXoEQ.isInterfaceType)(type)) return $ad02b274e585f6bd$var$printInterface(type, options);
    if ((0, $lXoEQ.isUnionType)(type)) return $ad02b274e585f6bd$var$printUnion(type, options);
    if ((0, $lXoEQ.isEnumType)(type)) return $ad02b274e585f6bd$var$printEnum(type, options);
     // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')
    if ((0, $lXoEQ.isInputObjectType)(type)) return $ad02b274e585f6bd$var$printInputObject(type, options);
     // istanbul ignore next (Not reachable. All possible types have been considered)
    (0, $43MJl.default)(0, 'Unexpected type: ' + (0, $biK02.default)(type));
}
function $ad02b274e585f6bd$var$printScalar(type, options) {
    return $ad02b274e585f6bd$var$printDescription(options, type) + "scalar ".concat(type.name) + $ad02b274e585f6bd$var$printSpecifiedByUrl(type);
}
function $ad02b274e585f6bd$var$printImplementedInterfaces(type) {
    var interfaces = type.getInterfaces();
    return interfaces.length ? ' implements ' + interfaces.map(function(i) {
        return i.name;
    }).join(' & ') : '';
}
function $ad02b274e585f6bd$var$printObject(type, options) {
    return $ad02b274e585f6bd$var$printDescription(options, type) + "type ".concat(type.name) + $ad02b274e585f6bd$var$printImplementedInterfaces(type) + $ad02b274e585f6bd$var$printFields(options, type);
}
function $ad02b274e585f6bd$var$printInterface(type, options) {
    return $ad02b274e585f6bd$var$printDescription(options, type) + "interface ".concat(type.name) + $ad02b274e585f6bd$var$printImplementedInterfaces(type) + $ad02b274e585f6bd$var$printFields(options, type);
}
function $ad02b274e585f6bd$var$printUnion(type, options) {
    var types = type.getTypes();
    var possibleTypes = types.length ? ' = ' + types.join(' | ') : '';
    return $ad02b274e585f6bd$var$printDescription(options, type) + 'union ' + type.name + possibleTypes;
}
function $ad02b274e585f6bd$var$printEnum(type, options) {
    var values = type.getValues().map(function(value, i) {
        return $ad02b274e585f6bd$var$printDescription(options, value, '  ', !i) + '  ' + value.name + $ad02b274e585f6bd$var$printDeprecated(value.deprecationReason);
    });
    return $ad02b274e585f6bd$var$printDescription(options, type) + "enum ".concat(type.name) + $ad02b274e585f6bd$var$printBlock(values);
}
function $ad02b274e585f6bd$var$printInputObject(type, options) {
    var fields = (0, $dVq2R.default)(type.getFields()).map(function(f, i) {
        return $ad02b274e585f6bd$var$printDescription(options, f, '  ', !i) + '  ' + $ad02b274e585f6bd$var$printInputValue(f);
    });
    return $ad02b274e585f6bd$var$printDescription(options, type) + "input ".concat(type.name) + $ad02b274e585f6bd$var$printBlock(fields);
}
function $ad02b274e585f6bd$var$printFields(options, type) {
    var fields = (0, $dVq2R.default)(type.getFields()).map(function(f, i) {
        return $ad02b274e585f6bd$var$printDescription(options, f, '  ', !i) + '  ' + f.name + $ad02b274e585f6bd$var$printArgs(options, f.args, '  ') + ': ' + String(f.type) + $ad02b274e585f6bd$var$printDeprecated(f.deprecationReason);
    });
    return $ad02b274e585f6bd$var$printBlock(fields);
}
function $ad02b274e585f6bd$var$printBlock(items) {
    return items.length !== 0 ? ' {\n' + items.join('\n') + '\n}' : '';
}
function $ad02b274e585f6bd$var$printArgs(options, args) {
    var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    if (args.length === 0) return '';
     // If every arg does not have a description, print them on one line.
    if (args.every(function(arg) {
        return !arg.description;
    })) return '(' + args.map($ad02b274e585f6bd$var$printInputValue).join(', ') + ')';
    return '(\n' + args.map(function(arg, i) {
        return $ad02b274e585f6bd$var$printDescription(options, arg, '  ' + indentation, !i) + '  ' + indentation + $ad02b274e585f6bd$var$printInputValue(arg);
    }).join('\n') + '\n' + indentation + ')';
}
function $ad02b274e585f6bd$var$printInputValue(arg) {
    var defaultAST = (0, $cMIyS.astFromValue)(arg.defaultValue, arg.type);
    var argDecl = arg.name + ': ' + String(arg.type);
    if (defaultAST) argDecl += " = ".concat((0, $aKlnM.print)(defaultAST));
    return argDecl + $ad02b274e585f6bd$var$printDeprecated(arg.deprecationReason);
}
function $ad02b274e585f6bd$var$printDirective(directive, options) {
    return $ad02b274e585f6bd$var$printDescription(options, directive) + 'directive @' + directive.name + $ad02b274e585f6bd$var$printArgs(options, directive.args) + (directive.isRepeatable ? ' repeatable' : '') + ' on ' + directive.locations.join(' | ');
}
function $ad02b274e585f6bd$var$printDeprecated(reason) {
    if (reason == null) return '';
    var reasonAST = (0, $cMIyS.astFromValue)(reason, (0, $auu22.GraphQLString));
    if (reasonAST && reason !== (0, $bOniD.DEFAULT_DEPRECATION_REASON)) return ' @deprecated(reason: ' + (0, $aKlnM.print)(reasonAST) + ')';
    return ' @deprecated';
}
function $ad02b274e585f6bd$var$printSpecifiedByUrl(scalar) {
    if (scalar.specifiedByUrl == null) return '';
    var url = scalar.specifiedByUrl;
    var urlAST = (0, $cMIyS.astFromValue)(url, (0, $auu22.GraphQLString));
    urlAST || (0, $43MJl.default)(0, 'Unexpected null value returned from `astFromValue` for specifiedByUrl');
    return ' @specifiedBy(url: ' + (0, $aKlnM.print)(urlAST) + ')';
}
function $ad02b274e585f6bd$var$printDescription(options, def) {
    var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var firstInBlock = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var description = def.description;
    if (description == null) return '';
    if ((options === null || options === void 0 ? void 0 : options.commentDescriptions) === true) return $ad02b274e585f6bd$var$printDescriptionWithComments(description, indentation, firstInBlock);
    var preferMultipleLines = description.length > 70;
    var blockString = (0, $flA0a.printBlockString)(description, '', preferMultipleLines);
    var prefix = indentation && !firstInBlock ? '\n' + indentation : indentation;
    return prefix + blockString.replace(/\n/g, '\n' + indentation) + '\n';
}
function $ad02b274e585f6bd$var$printDescriptionWithComments(description, indentation, firstInBlock) {
    var prefix = indentation && !firstInBlock ? '\n' : '';
    var comment = description.split('\n').map(function(line) {
        return indentation + (line !== '' ? '# ' + line : '#');
    }).join('\n');
    return prefix + comment + '\n';
}

});

parcelRegister("i07ri", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bvQX6 = parcelRequire("bvQX6");

var $bvQX6 = parcelRequire("bvQX6");
module.exports.execute = $bvQX6.execute;
function $0361c62ee1cf4ad3$var$linkToFetcher(link) {
    return function(fetcherOperation) {
        return $bvQX6.makePromise($bvQX6.execute(link, fetcherOperation));
    };
}
module.exports.default = $0361c62ee1cf4ad3$var$linkToFetcher;

});

parcelRegister("hRrcw", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $d00c7c79d0194f7f$var$isEmptyObject(obj) {
    if (!obj) return true;
    for(var key in obj){
        if (Object.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
module.exports.default = $d00c7c79d0194f7f$var$isEmptyObject;

});

parcelRegister("583I3", function(module, exports) {
var $3bc093be1df103cf$var$__assign = module.exports && module.exports.__assign || function() {
    $3bc093be1df103cf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3bc093be1df103cf$var$__assign.apply(this, arguments);
};
var $3bc093be1df103cf$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3bc093be1df103cf$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cRJgL = parcelRequire("cRJgL");
function $3bc093be1df103cf$var$observableToAsyncIterable(observable) {
    var _a;
    var pullQueue = [];
    var pushQueue = [];
    var listening = true;
    var pushValue = function(_a) {
        var data = _a.data;
        if (pullQueue.length !== 0) pullQueue.shift()({
            value: data,
            done: false
        });
        else pushQueue.push({
            value: data
        });
    };
    var pushError = function(error) {
        if (pullQueue.length !== 0) pullQueue.shift()({
            value: {
                errors: [
                    error
                ]
            },
            done: false
        });
        else pushQueue.push({
            value: {
                errors: [
                    error
                ]
            }
        });
    };
    var pullValue = function() {
        return new Promise(function(resolve) {
            if (pushQueue.length !== 0) {
                var element = pushQueue.shift();
                // either {value: {errors: [...]}} or {value: ...}
                resolve($3bc093be1df103cf$var$__assign($3bc093be1df103cf$var$__assign({}, element), {
                    done: false
                }));
            } else pullQueue.push(resolve);
        });
    };
    var subscription = observable.subscribe({
        next: function(value) {
            pushValue(value);
        },
        error: function(err) {
            pushError(err);
        }
    });
    var emptyQueue = function() {
        if (listening) {
            listening = false;
            subscription.unsubscribe();
            pullQueue.forEach(function(resolve) {
                return resolve({
                    value: undefined,
                    done: true
                });
            });
            pullQueue.length = 0;
            pushQueue.length = 0;
        }
    };
    return _a = {
        next: function() {
            return $3bc093be1df103cf$var$__awaiter(this, void 0, void 0, function() {
                return $3bc093be1df103cf$var$__generator(this, function(_a) {
                    return [
                        2 /*return*/ ,
                        listening ? pullValue() : this.return()
                    ];
                });
            });
        },
        return: function() {
            emptyQueue();
            return Promise.resolve({
                value: undefined,
                done: true
            });
        },
        throw: function(error) {
            emptyQueue();
            return Promise.reject(error);
        }
    }, _a[$cRJgL.$$asyncIterator] = function() {
        return this;
    }, _a;
}
module.exports.observableToAsyncIterable = $3bc093be1df103cf$var$observableToAsyncIterable;

});
parcelRegister("cRJgL", function(module, exports) {

$parcel$export(module.exports, "$$asyncIterator", () => $367ded6c6908ab1f$export$5ee754c34122a0ae);
/**
 * Copyright (c) 2016, Lee Byron
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 * @ignore
 */ /**
 * [Iterator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator)
 * is a *protocol* which describes a standard way to produce a sequence of
 * values, typically the values of the Iterable represented by this Iterator.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterator-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterator
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator|MDN Iteration protocols}
 */ /**
 * [Iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * their iteration behavior, such as what values are looped over in a
 * [`for...of`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/for...of)
 * loop or `iterall`'s `forEach` function. Many [built-in types](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#Builtin_iterables)
 * implement the Iterable protocol, including `Array` and `Map`.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterable-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterable
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable|MDN Iteration protocols}
 */ // In ES2015 environments, Symbol exists
var $367ded6c6908ab1f$var$SYMBOL /*: any */  = typeof Symbol === 'function' ? Symbol : void 0;
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
var $367ded6c6908ab1f$var$SYMBOL_ITERATOR = $367ded6c6908ab1f$var$SYMBOL && $367ded6c6908ab1f$var$SYMBOL.iterator;
var $367ded6c6908ab1f$export$9785f547d3164dac = $367ded6c6908ab1f$var$SYMBOL_ITERATOR || '@@iterator';
function $367ded6c6908ab1f$export$9652023d9040757(obj) {
    return !!$367ded6c6908ab1f$export$23f5ee39f998bf6f(obj);
}
function $367ded6c6908ab1f$export$1e2f57719e155213(obj) {
    var length = obj != null && obj.length;
    return typeof length === 'number' && length >= 0 && length % 1 === 0;
}
function $367ded6c6908ab1f$export$cea7aa84e978eba5(obj) {
    return Object(obj) === obj && ($367ded6c6908ab1f$export$1e2f57719e155213(obj) || $367ded6c6908ab1f$export$9652023d9040757(obj));
}
function $367ded6c6908ab1f$export$6731da38428a8625(iterable) {
    var method = $367ded6c6908ab1f$export$23f5ee39f998bf6f(iterable);
    if (method) return method.call(iterable);
}
function $367ded6c6908ab1f$export$23f5ee39f998bf6f(iterable) {
    if (iterable != null) {
        var method = $367ded6c6908ab1f$var$SYMBOL_ITERATOR && iterable[$367ded6c6908ab1f$var$SYMBOL_ITERATOR] || iterable['@@iterator'];
        if (typeof method === 'function') return method;
    }
}
function $367ded6c6908ab1f$export$7342c78d7e13e778(collection) {
    if (collection != null) {
        var iterator = $367ded6c6908ab1f$export$6731da38428a8625(collection);
        if (iterator) return iterator;
        if ($367ded6c6908ab1f$export$1e2f57719e155213(collection)) return new $367ded6c6908ab1f$var$ArrayLikeIterator(collection);
    }
}
// When the object provided to `createIterator` is not Iterable but is
// Array-like, this simple Iterator is created.
function $367ded6c6908ab1f$var$ArrayLikeIterator(obj) {
    this._o = obj;
    this._i = 0;
}
// Note: all Iterators are themselves Iterable.
$367ded6c6908ab1f$var$ArrayLikeIterator.prototype[$367ded6c6908ab1f$export$9785f547d3164dac] = function() {
    return this;
};
// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
$367ded6c6908ab1f$var$ArrayLikeIterator.prototype.next = function() {
    if (this._o === void 0 || this._i >= this._o.length) {
        this._o = void 0;
        return {
            value: void 0,
            done: true
        };
    }
    return {
        value: this._o[this._i++],
        done: false
    };
};
function $367ded6c6908ab1f$export$4b80e395e36b5a56(collection, callback, thisArg) {
    if (collection != null) {
        if (typeof collection.forEach === 'function') return collection.forEach(callback, thisArg);
        var i = 0;
        var iterator = $367ded6c6908ab1f$export$6731da38428a8625(collection);
        if (iterator) {
            var step;
            while(!(step = iterator.next()).done){
                callback.call(thisArg, step.value, i++, collection);
                // Infinite Iterators could cause forEach to run forever.
                // After a very large number of iterations, produce an error.
                /* istanbul ignore if */ if (i > 9999999) throw new TypeError('Near-infinite iteration.');
            }
        } else if ($367ded6c6908ab1f$export$1e2f57719e155213(collection)) {
            for(; i < collection.length; i++)if (collection.hasOwnProperty(i)) callback.call(thisArg, collection[i], i, collection);
        }
    }
}
/////////////////////////////////////////////////////
//                                                 //
//                 ASYNC ITERATORS                 //
//                                                 //
/////////////////////////////////////////////////////
/**
 * [AsyncIterable](https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * an asynchronous iteration behavior, such as what values are looped over in
 * a [`for-await-of`](https://tc39.github.io/proposal-async-iteration/#sec-for-in-and-for-of-statements)
 * loop or `iterall`'s {@link forAwaitEach} function.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterable
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface|Async Iteration Proposal}
 * @template T The type of each iterated value
 * @property {function (): AsyncIterator<T>} Symbol.asyncIterator
 *   A method which produces an AsyncIterator for this AsyncIterable.
 */ /**
 * [AsyncIterator](https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface)
 * is a *protocol* which describes a standard way to produce and consume an
 * asynchronous sequence of values, typically the values of the
 * {@link AsyncIterable} represented by this {@link AsyncIterator}.
 *
 * AsyncIterator is similar to Observable or Stream. Like an {@link Iterator} it
 * also as a `next()` method, however instead of an IteratorResult,
 * calling this method returns a {@link Promise} for a IteratorResult.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterator
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface|Async Iteration Proposal}
 */ // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $367ded6c6908ab1f$var$SYMBOL_ASYNC_ITERATOR = $367ded6c6908ab1f$var$SYMBOL && $367ded6c6908ab1f$var$SYMBOL.asyncIterator;
var $367ded6c6908ab1f$export$5ee754c34122a0ae = $367ded6c6908ab1f$var$SYMBOL_ASYNC_ITERATOR || '@@asyncIterator';
function $367ded6c6908ab1f$export$edb10ab8dd75a915(obj) {
    return !!$367ded6c6908ab1f$export$b39a85787ec1202f(obj);
}
function $367ded6c6908ab1f$export$d5127502cdffbf83(asyncIterable) {
    var method = $367ded6c6908ab1f$export$b39a85787ec1202f(asyncIterable);
    if (method) return method.call(asyncIterable);
}
function $367ded6c6908ab1f$export$b39a85787ec1202f(asyncIterable) {
    if (asyncIterable != null) {
        var method = $367ded6c6908ab1f$var$SYMBOL_ASYNC_ITERATOR && asyncIterable[$367ded6c6908ab1f$var$SYMBOL_ASYNC_ITERATOR] || asyncIterable['@@asyncIterator'];
        if (typeof method === 'function') return method;
    }
}
function $367ded6c6908ab1f$export$86c18c6347f4a8c4(source) {
    if (source != null) {
        var asyncIterator = $367ded6c6908ab1f$export$d5127502cdffbf83(source);
        if (asyncIterator) return asyncIterator;
        var iterator = $367ded6c6908ab1f$export$7342c78d7e13e778(source);
        if (iterator) return new $367ded6c6908ab1f$var$AsyncFromSyncIterator(iterator);
    }
}
// When the object provided to `createAsyncIterator` is not AsyncIterable but is
// sync Iterable, this simple wrapper is created.
function $367ded6c6908ab1f$var$AsyncFromSyncIterator(iterator) {
    this._i = iterator;
}
// Note: all AsyncIterators are themselves AsyncIterable.
$367ded6c6908ab1f$var$AsyncFromSyncIterator.prototype[$367ded6c6908ab1f$export$5ee754c34122a0ae] = function() {
    return this;
};
// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
$367ded6c6908ab1f$var$AsyncFromSyncIterator.prototype.next = function(value) {
    return $367ded6c6908ab1f$var$unwrapAsyncFromSync(this._i, 'next', value);
};
$367ded6c6908ab1f$var$AsyncFromSyncIterator.prototype.return = function(value) {
    return this._i.return ? $367ded6c6908ab1f$var$unwrapAsyncFromSync(this._i, 'return', value) : Promise.resolve({
        value: value,
        done: true
    });
};
$367ded6c6908ab1f$var$AsyncFromSyncIterator.prototype.throw = function(value) {
    return this._i.throw ? $367ded6c6908ab1f$var$unwrapAsyncFromSync(this._i, 'throw', value) : Promise.reject(value);
};
function $367ded6c6908ab1f$var$unwrapAsyncFromSync(iterator, fn, value) {
    var step;
    return new Promise(function(resolve) {
        step = iterator[fn](value);
        resolve(step.value);
    }).then(function(value) {
        return {
            value: value,
            done: step.done
        };
    });
}
function $367ded6c6908ab1f$export$186aebae43ba1fda(source, callback, thisArg) {
    var asyncIterator = $367ded6c6908ab1f$export$86c18c6347f4a8c4(source);
    if (asyncIterator) {
        var i = 0;
        return new Promise(function(resolve, reject) {
            function next() {
                asyncIterator.next().then(function(step) {
                    if (!step.done) Promise.resolve(callback.call(thisArg, step.value, i++, source)).then(next).catch(reject);
                    else resolve();
                    // Explicitly return null, silencing bluebird-style warnings.
                    return null;
                }).catch(reject);
                // Explicitly return null, silencing bluebird-style warnings.
                return null;
            }
            next();
        });
    }
}

});



parcelRegister("cns77", function(module, exports) {
var $902d70db2f1b5675$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $902d70db2f1b5675$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kYuQD = parcelRequire("kYuQD");
var $6ds0g = parcelRequire("6ds0g");

var $iZRls = parcelRequire("iZRls");

var $i07ri = parcelRequire("i07ri");
var $902d70db2f1b5675$var$parsedIntrospectionQuery = $6ds0g.parse($iZRls.getIntrospectionQuery());
function $902d70db2f1b5675$var$introspectSchema(fetcher, linkContext) {
    return $902d70db2f1b5675$var$__awaiter(this, void 0, void 0, function() {
        var introspectionResult, schema;
        return $902d70db2f1b5675$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    // Convert link to fetcher
                    if (fetcher.request) fetcher = $i07ri.default(fetcher);
                    return [
                        4 /*yield*/ ,
                        fetcher({
                            query: $902d70db2f1b5675$var$parsedIntrospectionQuery,
                            context: linkContext
                        })
                    ];
                case 1:
                    introspectionResult = _a.sent();
                    if (introspectionResult.errors && introspectionResult.errors.length || !introspectionResult.data.__schema) throw introspectionResult.errors;
                    else {
                        schema = $kYuQD.buildClientSchema(introspectionResult.data);
                        return [
                            2 /*return*/ ,
                            schema
                        ];
                    }
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.default = $902d70db2f1b5675$var$introspectSchema;

});
parcelRegister("kYuQD", function(module, exports) {

$parcel$export(module.exports, "buildClientSchema", () => $b48bf1e0077cad25$export$de8c236cf09c987c);

var $dVq2R = parcelRequire("dVq2R");

var $biK02 = parcelRequire("biK02");

var $fZdRY = parcelRequire("fZdRY");

var $2AFgT = parcelRequire("2AFgT");

var $fbtyx = parcelRequire("fbtyx");

var $6ds0g = parcelRequire("6ds0g");

var $6BdRO = parcelRequire("6BdRO");

var $bOniD = parcelRequire("bOniD");

var $auu22 = parcelRequire("auu22");

var $h2iUh = parcelRequire("h2iUh");

var $lXoEQ = parcelRequire("lXoEQ");

var $3E0nn = parcelRequire("3E0nn");
function $b48bf1e0077cad25$export$de8c236cf09c987c(introspection, options) {
    (0, $fbtyx.default)(introspection) && (0, $fbtyx.default)(introspection.__schema) || (0, $fZdRY.default)(0, "Invalid or incomplete introspection result. Ensure that you are passing \"data\" property of introspection response and no \"errors\" was returned alongside: ".concat((0, $biK02.default)(introspection), ".")); // Get the schema from the introspection result.
    var schemaIntrospection = introspection.__schema; // Iterate through all types, getting the type definition for each.
    var typeMap = (0, $2AFgT.default)(schemaIntrospection.types, function(typeIntrospection) {
        return typeIntrospection.name;
    }, function(typeIntrospection) {
        return buildType(typeIntrospection);
    }); // Include standard types only if they are used.
    for(var _i2 = 0, _ref2 = [].concat((0, $auu22.specifiedScalarTypes), (0, $h2iUh.introspectionTypes)); _i2 < _ref2.length; _i2++){
        var stdType = _ref2[_i2];
        if (typeMap[stdType.name]) typeMap[stdType.name] = stdType;
    } // Get the root Query, Mutation, and Subscription types.
    var queryType = schemaIntrospection.queryType ? getObjectType(schemaIntrospection.queryType) : null;
    var mutationType = schemaIntrospection.mutationType ? getObjectType(schemaIntrospection.mutationType) : null;
    var subscriptionType = schemaIntrospection.subscriptionType ? getObjectType(schemaIntrospection.subscriptionType) : null; // Get the directives supported by Introspection, assuming empty-set if
    // directives were not queried for.
    var directives = schemaIntrospection.directives ? schemaIntrospection.directives.map(buildDirective) : []; // Then produce and return a Schema with these types.
    return new (0, $6BdRO.GraphQLSchema)({
        description: schemaIntrospection.description,
        query: queryType,
        mutation: mutationType,
        subscription: subscriptionType,
        types: (0, $dVq2R.default)(typeMap),
        directives: directives,
        assumeValid: options === null || options === void 0 ? void 0 : options.assumeValid
    }); // Given a type reference in introspection, return the GraphQLType instance.
    // preferring cached instances before building new instances.
    function getType(typeRef) {
        if (typeRef.kind === (0, $h2iUh.TypeKind).LIST) {
            var itemRef = typeRef.ofType;
            if (!itemRef) throw new Error('Decorated type deeper than introspection query.');
            return new (0, $lXoEQ.GraphQLList)(getType(itemRef));
        }
        if (typeRef.kind === (0, $h2iUh.TypeKind).NON_NULL) {
            var nullableRef = typeRef.ofType;
            if (!nullableRef) throw new Error('Decorated type deeper than introspection query.');
            var nullableType = getType(nullableRef);
            return new (0, $lXoEQ.GraphQLNonNull)((0, $lXoEQ.assertNullableType)(nullableType));
        }
        return getNamedType(typeRef);
    }
    function getNamedType(typeRef) {
        var typeName = typeRef.name;
        if (!typeName) throw new Error("Unknown type reference: ".concat((0, $biK02.default)(typeRef), "."));
        var type = typeMap[typeName];
        if (!type) throw new Error("Invalid or incomplete schema, unknown type: ".concat(typeName, ". Ensure that a full introspection query is used in order to build a client schema."));
        return type;
    }
    function getObjectType(typeRef) {
        return (0, $lXoEQ.assertObjectType)(getNamedType(typeRef));
    }
    function getInterfaceType(typeRef) {
        return (0, $lXoEQ.assertInterfaceType)(getNamedType(typeRef));
    } // Given a type's introspection result, construct the correct
    // GraphQLType instance.
    function buildType(type) {
        if (type != null && type.name != null && type.kind != null) switch(type.kind){
            case (0, $h2iUh.TypeKind).SCALAR:
                return buildScalarDef(type);
            case (0, $h2iUh.TypeKind).OBJECT:
                return buildObjectDef(type);
            case (0, $h2iUh.TypeKind).INTERFACE:
                return buildInterfaceDef(type);
            case (0, $h2iUh.TypeKind).UNION:
                return buildUnionDef(type);
            case (0, $h2iUh.TypeKind).ENUM:
                return buildEnumDef(type);
            case (0, $h2iUh.TypeKind).INPUT_OBJECT:
                return buildInputObjectDef(type);
        }
        var typeStr = (0, $biK02.default)(type);
        throw new Error("Invalid or incomplete introspection result. Ensure that a full introspection query is used in order to build a client schema: ".concat(typeStr, "."));
    }
    function buildScalarDef(scalarIntrospection) {
        return new (0, $lXoEQ.GraphQLScalarType)({
            name: scalarIntrospection.name,
            description: scalarIntrospection.description,
            specifiedByUrl: scalarIntrospection.specifiedByUrl
        });
    }
    function buildImplementationsList(implementingIntrospection) {
        // TODO: Temporary workaround until GraphQL ecosystem will fully support
        // 'interfaces' on interface types.
        if (implementingIntrospection.interfaces === null && implementingIntrospection.kind === (0, $h2iUh.TypeKind).INTERFACE) return [];
        if (!implementingIntrospection.interfaces) {
            var implementingIntrospectionStr = (0, $biK02.default)(implementingIntrospection);
            throw new Error("Introspection result missing interfaces: ".concat(implementingIntrospectionStr, "."));
        }
        return implementingIntrospection.interfaces.map(getInterfaceType);
    }
    function buildObjectDef(objectIntrospection) {
        return new (0, $lXoEQ.GraphQLObjectType)({
            name: objectIntrospection.name,
            description: objectIntrospection.description,
            interfaces: function interfaces() {
                return buildImplementationsList(objectIntrospection);
            },
            fields: function fields() {
                return buildFieldDefMap(objectIntrospection);
            }
        });
    }
    function buildInterfaceDef(interfaceIntrospection) {
        return new (0, $lXoEQ.GraphQLInterfaceType)({
            name: interfaceIntrospection.name,
            description: interfaceIntrospection.description,
            interfaces: function interfaces() {
                return buildImplementationsList(interfaceIntrospection);
            },
            fields: function fields() {
                return buildFieldDefMap(interfaceIntrospection);
            }
        });
    }
    function buildUnionDef(unionIntrospection) {
        if (!unionIntrospection.possibleTypes) {
            var unionIntrospectionStr = (0, $biK02.default)(unionIntrospection);
            throw new Error("Introspection result missing possibleTypes: ".concat(unionIntrospectionStr, "."));
        }
        return new (0, $lXoEQ.GraphQLUnionType)({
            name: unionIntrospection.name,
            description: unionIntrospection.description,
            types: function types() {
                return unionIntrospection.possibleTypes.map(getObjectType);
            }
        });
    }
    function buildEnumDef(enumIntrospection) {
        if (!enumIntrospection.enumValues) {
            var enumIntrospectionStr = (0, $biK02.default)(enumIntrospection);
            throw new Error("Introspection result missing enumValues: ".concat(enumIntrospectionStr, "."));
        }
        return new (0, $lXoEQ.GraphQLEnumType)({
            name: enumIntrospection.name,
            description: enumIntrospection.description,
            values: (0, $2AFgT.default)(enumIntrospection.enumValues, function(valueIntrospection) {
                return valueIntrospection.name;
            }, function(valueIntrospection) {
                return {
                    description: valueIntrospection.description,
                    deprecationReason: valueIntrospection.deprecationReason
                };
            })
        });
    }
    function buildInputObjectDef(inputObjectIntrospection) {
        if (!inputObjectIntrospection.inputFields) {
            var inputObjectIntrospectionStr = (0, $biK02.default)(inputObjectIntrospection);
            throw new Error("Introspection result missing inputFields: ".concat(inputObjectIntrospectionStr, "."));
        }
        return new (0, $lXoEQ.GraphQLInputObjectType)({
            name: inputObjectIntrospection.name,
            description: inputObjectIntrospection.description,
            fields: function fields() {
                return buildInputValueDefMap(inputObjectIntrospection.inputFields);
            }
        });
    }
    function buildFieldDefMap(typeIntrospection) {
        if (!typeIntrospection.fields) throw new Error("Introspection result missing fields: ".concat((0, $biK02.default)(typeIntrospection), "."));
        return (0, $2AFgT.default)(typeIntrospection.fields, function(fieldIntrospection) {
            return fieldIntrospection.name;
        }, buildField);
    }
    function buildField(fieldIntrospection) {
        var type = getType(fieldIntrospection.type);
        if (!(0, $lXoEQ.isOutputType)(type)) {
            var typeStr = (0, $biK02.default)(type);
            throw new Error("Introspection must provide output type for fields, but received: ".concat(typeStr, "."));
        }
        if (!fieldIntrospection.args) {
            var fieldIntrospectionStr = (0, $biK02.default)(fieldIntrospection);
            throw new Error("Introspection result missing field args: ".concat(fieldIntrospectionStr, "."));
        }
        return {
            description: fieldIntrospection.description,
            deprecationReason: fieldIntrospection.deprecationReason,
            type: type,
            args: buildInputValueDefMap(fieldIntrospection.args)
        };
    }
    function buildInputValueDefMap(inputValueIntrospections) {
        return (0, $2AFgT.default)(inputValueIntrospections, function(inputValue) {
            return inputValue.name;
        }, buildInputValue);
    }
    function buildInputValue(inputValueIntrospection) {
        var type = getType(inputValueIntrospection.type);
        if (!(0, $lXoEQ.isInputType)(type)) {
            var typeStr = (0, $biK02.default)(type);
            throw new Error("Introspection must provide input type for arguments, but received: ".concat(typeStr, "."));
        }
        var defaultValue = inputValueIntrospection.defaultValue != null ? (0, $3E0nn.valueFromAST)((0, $6ds0g.parseValue)(inputValueIntrospection.defaultValue), type) : undefined;
        return {
            description: inputValueIntrospection.description,
            type: type,
            defaultValue: defaultValue,
            deprecationReason: inputValueIntrospection.deprecationReason
        };
    }
    function buildDirective(directiveIntrospection) {
        if (!directiveIntrospection.args) {
            var directiveIntrospectionStr = (0, $biK02.default)(directiveIntrospection);
            throw new Error("Introspection result missing directive args: ".concat(directiveIntrospectionStr, "."));
        }
        if (!directiveIntrospection.locations) {
            var _directiveIntrospectionStr = (0, $biK02.default)(directiveIntrospection);
            throw new Error("Introspection result missing directive locations: ".concat(_directiveIntrospectionStr, "."));
        }
        return new (0, $bOniD.GraphQLDirective)({
            name: directiveIntrospection.name,
            description: directiveIntrospection.description,
            isRepeatable: directiveIntrospection.isRepeatable,
            locations: directiveIntrospection.locations.slice(),
            args: buildInputValueDefMap(directiveIntrospection.args)
        });
    }
}

});

parcelRegister("iZRls", function(module, exports) {

$parcel$export(module.exports, "getIntrospectionQuery", () => $1669bb0e2cec0c6e$export$67a66015194c88d7);
function $1669bb0e2cec0c6e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1669bb0e2cec0c6e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1669bb0e2cec0c6e$var$ownKeys(Object(source), true).forEach(function(key) {
            $1669bb0e2cec0c6e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1669bb0e2cec0c6e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1669bb0e2cec0c6e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1669bb0e2cec0c6e$export$67a66015194c88d7(options) {
    var optionsWithDefault = $1669bb0e2cec0c6e$var$_objectSpread({
        descriptions: true,
        specifiedByUrl: false,
        directiveIsRepeatable: false,
        schemaDescription: false,
        inputValueDeprecation: false
    }, options);
    var descriptions = optionsWithDefault.descriptions ? 'description' : '';
    var specifiedByUrl = optionsWithDefault.specifiedByUrl ? 'specifiedByUrl' : '';
    var directiveIsRepeatable = optionsWithDefault.directiveIsRepeatable ? 'isRepeatable' : '';
    var schemaDescription = optionsWithDefault.schemaDescription ? descriptions : '';
    function inputDeprecation(str) {
        return optionsWithDefault.inputValueDeprecation ? str : '';
    }
    return "\n    query IntrospectionQuery {\n      __schema {\n        ".concat(schemaDescription, "\n        queryType { name }\n        mutationType { name }\n        subscriptionType { name }\n        types {\n          ...FullType\n        }\n        directives {\n          name\n          ").concat(descriptions, "\n          ").concat(directiveIsRepeatable, "\n          locations\n          args").concat(inputDeprecation('(includeDeprecated: true)'), " {\n            ...InputValue\n          }\n        }\n      }\n    }\n\n    fragment FullType on __Type {\n      kind\n      name\n      ").concat(descriptions, "\n      ").concat(specifiedByUrl, "\n      fields(includeDeprecated: true) {\n        name\n        ").concat(descriptions, "\n        args").concat(inputDeprecation('(includeDeprecated: true)'), " {\n          ...InputValue\n        }\n        type {\n          ...TypeRef\n        }\n        isDeprecated\n        deprecationReason\n      }\n      inputFields").concat(inputDeprecation('(includeDeprecated: true)'), " {\n        ...InputValue\n      }\n      interfaces {\n        ...TypeRef\n      }\n      enumValues(includeDeprecated: true) {\n        name\n        ").concat(descriptions, "\n        isDeprecated\n        deprecationReason\n      }\n      possibleTypes {\n        ...TypeRef\n      }\n    }\n\n    fragment InputValue on __InputValue {\n      name\n      ").concat(descriptions, "\n      type { ...TypeRef }\n      defaultValue\n      ").concat(inputDeprecation('isDeprecated'), "\n      ").concat(inputDeprecation('deprecationReason'), "\n    }\n\n    fragment TypeRef on __Type {\n      kind\n      name\n      ofType {\n        kind\n        name\n        ofType {\n          kind\n          name\n          ofType {\n            kind\n            name\n            ofType {\n              kind\n              name\n              ofType {\n                kind\n                name\n                ofType {\n                  kind\n                  name\n                  ofType {\n                    kind\n                    name\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  ");
}

});


parcelRegister("2KwZj", function(module, exports) {
var $2009775a7df124d7$var$__assign = module.exports && module.exports.__assign || function() {
    $2009775a7df124d7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2009775a7df124d7$var$__assign.apply(this, arguments);
};
var $2009775a7df124d7$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $glHRe = parcelRequire("glHRe");
var $lXoEQ = parcelRequire("lXoEQ");
var $bOniD = parcelRequire("bOniD");
var $6BdRO = parcelRequire("6BdRO");
var $1c4hI = parcelRequire("1c4hI");
var $6ds0g = parcelRequire("6ds0g");

var $crrCr = parcelRequire("crrCr");

var $h8S1f = parcelRequire("h8S1f");

var $7UWAA = parcelRequire("7UWAA");

var $dkK13 = parcelRequire("dkK13");

var $16dWW = parcelRequire("16dWW");

var $b3EaX = parcelRequire("b3EaX");

var $gVW6u = parcelRequire("gVW6u");
function $2009775a7df124d7$var$mergeSchemas(_a) {
    var schemas = _a.schemas, onTypeConflict = _a.onTypeConflict, resolvers = _a.resolvers, schemaDirectives = _a.schemaDirectives, inheritResolversFromInterfaces = _a.inheritResolversFromInterfaces, mergeDirectives = _a.mergeDirectives;
    return $2009775a7df124d7$var$mergeSchemasImplementation({
        schemas: schemas,
        resolvers: resolvers,
        schemaDirectives: schemaDirectives,
        inheritResolversFromInterfaces: inheritResolversFromInterfaces,
        mergeDirectives: mergeDirectives
    });
}
module.exports.default = $2009775a7df124d7$var$mergeSchemas;
function $2009775a7df124d7$var$mergeSchemasImplementation(_a) {
    var schemas = _a.schemas, resolvers = _a.resolvers, schemaDirectives = _a.schemaDirectives, inheritResolversFromInterfaces = _a.inheritResolversFromInterfaces, mergeDirectives = _a.mergeDirectives;
    var allSchemas = [];
    var typeCandidates = {};
    var types = {};
    var extensions = [];
    var directives = [];
    var fragments = [];
    var resolveType = $h8S1f.createResolveType(function(name) {
        if (types[name] === undefined) throw new Error("Can't find type " + name + ".");
        return types[name];
    });
    schemas.forEach(function(schema) {
        if (schema instanceof $6BdRO.GraphQLSchema) {
            allSchemas.push(schema);
            var queryType_1 = schema.getQueryType();
            var mutationType_1 = schema.getMutationType();
            var subscriptionType_1 = schema.getSubscriptionType();
            if (queryType_1) $2009775a7df124d7$var$addTypeCandidate(typeCandidates, 'Query', {
                schema: schema,
                type: queryType_1
            });
            if (mutationType_1) $2009775a7df124d7$var$addTypeCandidate(typeCandidates, 'Mutation', {
                schema: schema,
                type: mutationType_1
            });
            if (subscriptionType_1) $2009775a7df124d7$var$addTypeCandidate(typeCandidates, 'Subscription', {
                schema: schema,
                type: subscriptionType_1
            });
            if (mergeDirectives) {
                var directiveInstances = schema.getDirectives();
                directiveInstances.forEach(function(directive) {
                    directives.push(directive);
                });
            }
            var typeMap_1 = schema.getTypeMap();
            Object.keys(typeMap_1).forEach(function(typeName) {
                var type = typeMap_1[typeName];
                if ($lXoEQ.isNamedType(type) && $lXoEQ.getNamedType(type).name.slice(0, 2) !== '__' && type !== queryType_1 && type !== mutationType_1 && type !== subscriptionType_1) $2009775a7df124d7$var$addTypeCandidate(typeCandidates, type.name, {
                    schema: schema,
                    type: type
                });
            });
        } else if (typeof schema === 'string' || schema && schema.kind === $1c4hI.Kind.DOCUMENT) {
            var parsedSchemaDocument = typeof schema === 'string' ? $6ds0g.parse(schema) : schema;
            parsedSchemaDocument.definitions.forEach(function(def) {
                var type = $dkK13.default(def);
                if (type instanceof $bOniD.GraphQLDirective && mergeDirectives) directives.push(type);
                else if (type && !(type instanceof $bOniD.GraphQLDirective)) $2009775a7df124d7$var$addTypeCandidate(typeCandidates, type.name, {
                    type: type
                });
            });
            var extensionsDocument = $crrCr.extractExtensionDefinitions(parsedSchemaDocument);
            if (extensionsDocument.definitions.length > 0) extensions.push(extensionsDocument);
        } else if (Array.isArray(schema)) schema.forEach(function(type) {
            $2009775a7df124d7$var$addTypeCandidate(typeCandidates, type.name, {
                type: type
            });
        });
        else throw new Error("Invalid schema passed");
    });
    var mergeInfo = $2009775a7df124d7$var$createMergeInfo(allSchemas, fragments);
    if (!resolvers) resolvers = {};
    else if (typeof resolvers === 'function') {
        console.warn('Passing functions as resolver parameter is deprecated. Use `info.mergeInfo` instead.');
        resolvers = resolvers(mergeInfo);
    } else if (Array.isArray(resolvers)) resolvers = resolvers.reduce(function(left, right) {
        if (typeof right === 'function') {
            console.warn('Passing functions as resolver parameter is deprecated. Use `info.mergeInfo` instead.');
            right = right(mergeInfo);
        }
        return $b3EaX.default(left, right);
    }, {});
    var generatedResolvers = {};
    Object.keys(typeCandidates).forEach(function(typeName) {
        var resultType = $2009775a7df124d7$var$defaultVisitType(typeName, typeCandidates[typeName]);
        if (resultType === null) types[typeName] = null;
        else {
            var type = void 0;
            var typeResolvers = void 0;
            if ($lXoEQ.isNamedType(resultType)) type = resultType;
            else if (resultType.type) {
                type = resultType.type;
                typeResolvers = resultType.resolvers;
            } else throw new Error("Invalid visitType result for type " + typeName);
            types[typeName] = $h8S1f.recreateType(type, resolveType, false);
            if (typeResolvers) generatedResolvers[typeName] = typeResolvers;
        }
    });
    var mergedSchema = new $6BdRO.GraphQLSchema({
        query: types.Query,
        mutation: types.Mutation,
        subscription: types.Subscription,
        types: Object.keys(types).map(function(key) {
            return types[key];
        }),
        directives: directives.map(function(directive) {
            return $h8S1f.recreateDirective(directive, resolveType);
        })
    });
    extensions.forEach(function(extension) {
        mergedSchema = $glHRe.extendSchema(mergedSchema, extension, {
            commentDescriptions: true
        });
    });
    if (!resolvers) resolvers = {};
    else if (Array.isArray(resolvers)) resolvers = resolvers.reduce($b3EaX.default, {});
    Object.keys(resolvers).forEach(function(typeName) {
        var type = resolvers[typeName];
        if (type instanceof $lXoEQ.GraphQLScalarType) return;
        Object.keys(type).forEach(function(fieldName) {
            var field = type[fieldName];
            if (field.fragment) fragments.push({
                field: fieldName,
                fragment: field.fragment
            });
        });
    });
    mergedSchema = $crrCr.addResolveFunctionsToSchema({
        schema: mergedSchema,
        resolvers: $b3EaX.default(generatedResolvers, resolvers),
        inheritResolversFromInterfaces: inheritResolversFromInterfaces
    });
    $2009775a7df124d7$var$forEachField(mergedSchema, function(field) {
        if (field.resolve) {
            var fieldResolver_1 = field.resolve;
            field.resolve = function(parent, args, context, info) {
                var newInfo = $2009775a7df124d7$var$__assign($2009775a7df124d7$var$__assign({}, info), {
                    mergeInfo: mergeInfo
                });
                return fieldResolver_1(parent, args, context, newInfo);
            };
        }
        if (field.subscribe) {
            var fieldResolver_2 = field.subscribe;
            field.subscribe = function(parent, args, context, info) {
                var newInfo = $2009775a7df124d7$var$__assign($2009775a7df124d7$var$__assign({}, info), {
                    mergeInfo: mergeInfo
                });
                return fieldResolver_2(parent, args, context, newInfo);
            };
        }
    });
    if (schemaDirectives) $gVW6u.SchemaDirectiveVisitor.visitSchemaDirectives(mergedSchema, schemaDirectives);
    return mergedSchema;
}
function $2009775a7df124d7$var$createMergeInfo(allSchemas, fragments) {
    return {
        delegate: function(operation, fieldName, args, context, info, transforms) {
            console.warn("`mergeInfo.delegate` is deprecated. Use `mergeInfo.delegateToSchema and pass explicit schema instances.");
            var schema = $2009775a7df124d7$var$guessSchemaByRootField(allSchemas, operation, fieldName);
            var expandTransforms = new $16dWW.ExpandAbstractTypes(info.schema, schema);
            var fragmentTransform = new $16dWW.ReplaceFieldWithFragment(schema, fragments);
            return $7UWAA.default({
                schema: schema,
                operation: operation,
                fieldName: fieldName,
                args: args,
                context: context,
                info: info,
                transforms: $2009775a7df124d7$var$__spreadArrays(transforms || [], [
                    expandTransforms,
                    fragmentTransform
                ])
            });
        },
        delegateToSchema: function(options) {
            return $7UWAA.default($2009775a7df124d7$var$__assign($2009775a7df124d7$var$__assign({}, options), {
                transforms: options.transforms
            }));
        },
        fragments: fragments
    };
}
function $2009775a7df124d7$var$guessSchemaByRootField(schemas, operation, fieldName) {
    for(var _i = 0, schemas_1 = schemas; _i < schemas_1.length; _i++){
        var schema = schemas_1[_i];
        var rootObject = void 0;
        if (operation === 'subscription') rootObject = schema.getSubscriptionType();
        else if (operation === 'mutation') rootObject = schema.getMutationType();
        else rootObject = schema.getQueryType();
        if (rootObject) {
            var fields = rootObject.getFields();
            if (fields[fieldName]) return schema;
        }
    }
    throw new Error("Could not find subschema with field `" + operation + "." + fieldName + "`");
}
function $2009775a7df124d7$var$createDelegatingResolver(schema, operation, fieldName) {
    return function(root, args, context, info) {
        return info.mergeInfo.delegateToSchema({
            schema: schema,
            operation: operation,
            fieldName: fieldName,
            args: args,
            context: context,
            info: info
        });
    };
}
function $2009775a7df124d7$var$forEachField(schema, fn) {
    var typeMap = schema.getTypeMap();
    Object.keys(typeMap).forEach(function(typeName) {
        var type = typeMap[typeName];
        if (!$lXoEQ.getNamedType(type).name.startsWith('__') && type instanceof $lXoEQ.GraphQLObjectType) {
            var fields_1 = type.getFields();
            Object.keys(fields_1).forEach(function(fieldName) {
                var field = fields_1[fieldName];
                fn(field, typeName, fieldName);
            });
        }
    });
}
function $2009775a7df124d7$var$addTypeCandidate(typeCandidates, name, typeCandidate) {
    if (!typeCandidates[name]) typeCandidates[name] = [];
    typeCandidates[name].push(typeCandidate);
}
function $2009775a7df124d7$var$defaultVisitType(name, candidates, candidateSelector) {
    if (!candidateSelector) candidateSelector = function(cands) {
        return cands[cands.length - 1];
    };
    var resolveType = $h8S1f.createResolveType(function(_, type) {
        return type;
    });
    if (name === 'Query' || name === 'Mutation' || name === 'Subscription') {
        var fields_2 = {};
        var operationName_1;
        switch(name){
            case 'Query':
                operationName_1 = 'query';
                break;
            case 'Mutation':
                operationName_1 = 'mutation';
                break;
            case 'Subscription':
                operationName_1 = 'subscription';
                break;
            default:
                break;
        }
        var resolvers_1 = {};
        var resolverKey_1 = operationName_1 === 'subscription' ? 'subscribe' : 'resolve';
        candidates.forEach(function(_a) {
            var candidateType = _a.type, schema = _a.schema;
            var candidateFields = candidateType.getFields();
            fields_2 = $2009775a7df124d7$var$__assign($2009775a7df124d7$var$__assign({}, fields_2), candidateFields);
            Object.keys(candidateFields).forEach(function(fieldName) {
                var _a;
                resolvers_1[fieldName] = (_a = {}, _a[resolverKey_1] = $2009775a7df124d7$var$createDelegatingResolver(schema, operationName_1, fieldName), _a);
            });
        });
        var type = new $lXoEQ.GraphQLObjectType({
            name: name,
            fields: $h8S1f.fieldMapToFieldConfigMap(fields_2, resolveType, false)
        });
        return {
            type: type,
            resolvers: resolvers_1
        };
    } else {
        var candidate = candidateSelector(candidates);
        return candidate.type;
    }
}

});
parcelRegister("7UWAA", function(module, exports) {
var $5c3b35ed0de98ad1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5c3b35ed0de98ad1$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5c3b35ed0de98ad1$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3MP74 = parcelRequire("3MP74");
var $6BdRO = parcelRequire("6BdRO");
var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $2vhbx = parcelRequire("2vhbx");
var $dGflO = parcelRequire("dGflO");

var $esVhq = parcelRequire("esVhq");

var $iijzq = parcelRequire("iijzq");

var $8Vthi = parcelRequire("8Vthi");

var $aYyML = parcelRequire("aYyML");

var $gvWNr = parcelRequire("gvWNr");

var $fB7Hv = parcelRequire("fB7Hv");

var $kYtVo = parcelRequire("kYtVo");

var $4trzE = parcelRequire("4trzE");

var $goXjX = parcelRequire("goXjX");
function $5c3b35ed0de98ad1$var$delegateToSchema(options) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (options instanceof $6BdRO.GraphQLSchema) throw new Error("Passing positional arguments to delegateToSchema is a deprecated. Please pass named parameters instead.");
    return $5c3b35ed0de98ad1$var$delegateToSchemaImplementation(options);
}
module.exports.default = $5c3b35ed0de98ad1$var$delegateToSchema;
function $5c3b35ed0de98ad1$var$delegateToSchemaImplementation(options) {
    return $5c3b35ed0de98ad1$var$__awaiter(this, void 0, void 0, function() {
        var info, _a, args, operation, rawDocument, rawRequest, transforms, processedRequest, errors, _b, executionResult;
        return $5c3b35ed0de98ad1$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    info = options.info, _a = options.args, args = _a === void 0 ? {} : _a;
                    operation = options.operation || info.operation.operation;
                    rawDocument = $5c3b35ed0de98ad1$var$createDocument(options.fieldName, operation, info.fieldNodes, Object.keys(info.fragments).map(function(fragmentName) {
                        return info.fragments[fragmentName];
                    }), info.operation.variableDefinitions, info.operation.name);
                    rawRequest = {
                        document: rawDocument,
                        variables: info.variableValues
                    };
                    transforms = $5c3b35ed0de98ad1$var$__spreadArrays(options.transforms || [], [
                        new $kYtVo.default(info.schema, options.schema)
                    ]);
                    if (info.mergeInfo && info.mergeInfo.fragments) transforms.push(new $4trzE.default(options.schema, info.mergeInfo.fragments));
                    transforms = transforms.concat([
                        new $iijzq.default(options.schema, args),
                        new $8Vthi.default(options.schema),
                        new $aYyML.default(options.schema),
                        new $gvWNr.default(info, options.fieldName)
                    ]);
                    if ($lXoEQ.isEnumType(options.info.returnType)) transforms = transforms.concat(new $goXjX.default(options.info.returnType));
                    processedRequest = $esVhq.applyRequestTransforms(rawRequest, transforms);
                    if (!options.skipValidation) {
                        errors = $dGflO.validate(options.schema, processedRequest.document);
                        if (errors.length > 0) throw errors;
                    }
                    if (!(operation === 'query' || operation === 'mutation')) return [
                        3 /*break*/ ,
                        2
                    ];
                    _b = $esVhq.applyResultTransforms;
                    return [
                        4 /*yield*/ ,
                        $3MP74.execute(options.schema, processedRequest.document, info.rootValue, options.context, processedRequest.variables)
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _b.apply(void 0, [
                            _c.sent(),
                            transforms
                        ])
                    ];
                case 2:
                    if (!(operation === 'subscription')) return [
                        3 /*break*/ ,
                        4
                    ];
                    return [
                        4 /*yield*/ ,
                        $2vhbx.subscribe(options.schema, processedRequest.document, info.rootValue, options.context, processedRequest.variables)
                    ];
                case 3:
                    executionResult = _c.sent();
                    // "subscribe" to the subscription result and map the result through the transforms
                    return [
                        2 /*return*/ ,
                        $fB7Hv.default(executionResult, function(result) {
                            var _a;
                            var transformedResult = $esVhq.applyResultTransforms(result, transforms);
                            var subscriptionKey = Object.keys(result.data)[0];
                            // for some reason the returned transformedResult needs to be nested inside the root subscription field
                            // does not work otherwise...
                            return _a = {}, _a[subscriptionKey] = transformedResult, _a;
                        })
                    ];
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $5c3b35ed0de98ad1$var$createDocument(targetField, targetOperation, originalSelections, fragments, variables, operationName) {
    var selections = [];
    var args = [];
    originalSelections.forEach(function(field) {
        var fieldSelections = field.selectionSet ? field.selectionSet.selections : [];
        selections = selections.concat(fieldSelections);
        args = args.concat(field.arguments || []);
    });
    var selectionSet = null;
    if (selections.length > 0) selectionSet = {
        kind: $1c4hI.Kind.SELECTION_SET,
        selections: selections
    };
    var rootField = {
        kind: $1c4hI.Kind.FIELD,
        alias: null,
        arguments: args,
        selectionSet: selectionSet,
        name: {
            kind: $1c4hI.Kind.NAME,
            value: targetField
        }
    };
    var rootSelectionSet = {
        kind: $1c4hI.Kind.SELECTION_SET,
        selections: [
            rootField
        ]
    };
    var operationDefinition = {
        kind: $1c4hI.Kind.OPERATION_DEFINITION,
        operation: targetOperation,
        variableDefinitions: variables,
        selectionSet: rootSelectionSet,
        name: operationName
    };
    return {
        kind: $1c4hI.Kind.DOCUMENT,
        definitions: $5c3b35ed0de98ad1$var$__spreadArrays([
            operationDefinition
        ], fragments)
    };
}

});
parcelRegister("2vhbx", function(module, exports) {

$parcel$export(module.exports, "subscribe", () => $0952dea42f1ba206$export$ec068583843480e7);

var $biK02 = parcelRequire("biK02");

var $lVzNK = parcelRequire("lVzNK");

var $kZHaf = parcelRequire("kZHaf");

var $9fgMZ = parcelRequire("9fgMZ");

var $02KAV = parcelRequire("02KAV");

var $gqGQB = parcelRequire("gqGQB");

var $3MP74 = parcelRequire("3MP74");

var $bis9F = parcelRequire("bis9F");

var $b1Z8M = parcelRequire("b1Z8M");
function $0952dea42f1ba206$export$ec068583843480e7(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver) {
    /* eslint-enable no-redeclare */ // Extract arguments from object args if provided.
    return arguments.length === 1 ? $0952dea42f1ba206$var$subscribeImpl(argsOrSchema) : $0952dea42f1ba206$var$subscribeImpl({
        schema: argsOrSchema,
        document: document,
        rootValue: rootValue,
        contextValue: contextValue,
        variableValues: variableValues,
        operationName: operationName,
        fieldResolver: fieldResolver,
        subscribeFieldResolver: subscribeFieldResolver
    });
}
/**
 * This function checks if the error is a GraphQLError. If it is, report it as
 * an ExecutionResult, containing only errors and no data. Otherwise treat the
 * error as a system-class error and re-throw it.
 */ function $0952dea42f1ba206$var$reportGraphQLError(error) {
    if (error instanceof (0, $9fgMZ.GraphQLError)) return {
        errors: [
            error
        ]
    };
    throw error;
}
function $0952dea42f1ba206$var$subscribeImpl(args) {
    var schema = args.schema, document = args.document, rootValue = args.rootValue, contextValue = args.contextValue, variableValues = args.variableValues, operationName = args.operationName, fieldResolver = args.fieldResolver, subscribeFieldResolver = args.subscribeFieldResolver;
    var sourcePromise = $0952dea42f1ba206$export$640ee730a9007071(schema, document, rootValue, contextValue, variableValues, operationName, subscribeFieldResolver); // For each payload yielded from a subscription, map it over the normal
    // GraphQL `execute` function, with `payload` as the rootValue.
    // This implements the "MapSourceToResponseEvent" algorithm described in
    // the GraphQL specification. The `execute` function provides the
    // "ExecuteSubscriptionEvent" algorithm, as it is nearly identical to the
    // "ExecuteQuery" algorithm, for which `execute` is also used.
    var mapSourceToResponse = function mapSourceToResponse(payload) {
        return (0, $3MP74.execute)({
            schema: schema,
            document: document,
            rootValue: payload,
            contextValue: contextValue,
            variableValues: variableValues,
            operationName: operationName,
            fieldResolver: fieldResolver
        });
    }; // Resolve the Source Stream, then map every source value to a
    // ExecutionResult value as described above.
    return sourcePromise.then(function(resultOrStream) {
        return (0, $lVzNK.default)(resultOrStream) ? (0, $b1Z8M.default)(resultOrStream, mapSourceToResponse, $0952dea42f1ba206$var$reportGraphQLError) : resultOrStream;
    });
}
function $0952dea42f1ba206$export$640ee730a9007071(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
    // If arguments are missing or incorrectly typed, this is an internal
    // developer mistake which should throw an early error.
    (0, $3MP74.assertValidExecutionArguments)(schema, document, variableValues);
    return new Promise(function(resolve) {
        // If a valid context cannot be created due to incorrect arguments,
        // this will throw an error.
        var exeContext = (0, $3MP74.buildExecutionContext)(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);
        resolve(Array.isArray(exeContext) ? {
            errors: exeContext
        } : $0952dea42f1ba206$var$executeSubscription(exeContext));
    }).catch($0952dea42f1ba206$var$reportGraphQLError);
}
function $0952dea42f1ba206$var$executeSubscription(exeContext) {
    var schema = exeContext.schema, operation = exeContext.operation, variableValues = exeContext.variableValues, rootValue = exeContext.rootValue;
    var type = (0, $bis9F.getOperationRootType)(schema, operation);
    var fields = (0, $3MP74.collectFields)(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
    var responseNames = Object.keys(fields);
    var responseName = responseNames[0];
    var fieldNodes = fields[responseName];
    var fieldNode = fieldNodes[0];
    var fieldName = fieldNode.name.value;
    var fieldDef = (0, $3MP74.getFieldDef)(schema, type, fieldName);
    if (!fieldDef) throw new (0, $9fgMZ.GraphQLError)("The subscription field \"".concat(fieldName, "\" is not defined."), fieldNodes);
    var path = (0, $kZHaf.addPath)(undefined, responseName, type.name);
    var info = (0, $3MP74.buildResolveInfo)(exeContext, fieldDef, fieldNodes, type, path); // Coerce to Promise for easier error handling and consistent return type.
    return new Promise(function(resolveResult) {
        var _fieldDef$subscribe;
        // Implements the "ResolveFieldEventStream" algorithm from GraphQL specification.
        // It differs from "ResolveFieldValue" due to providing a different `resolveFn`.
        // Build a JS object of arguments from the field.arguments AST, using the
        // variables scope to fulfill any variable references.
        var args = (0, $gqGQB.getArgumentValues)(fieldDef, fieldNodes[0], variableValues); // The resolve function's optional third argument is a context value that
        // is provided to every resolve function within an execution. It is commonly
        // used to represent an authenticated user, or request-specific caches.
        var contextValue = exeContext.contextValue; // Call the `subscribe()` resolver or the default resolver to produce an
        // AsyncIterable yielding raw payloads.
        var resolveFn = (_fieldDef$subscribe = fieldDef.subscribe) !== null && _fieldDef$subscribe !== void 0 ? _fieldDef$subscribe : exeContext.fieldResolver;
        resolveResult(resolveFn(rootValue, args, contextValue, info));
    }).then(function(eventStream) {
        if (eventStream instanceof Error) throw (0, $02KAV.locatedError)(eventStream, fieldNodes, (0, $kZHaf.pathToArray)(path));
         // Assert field returned an event stream, otherwise yield an error.
        if (!(0, $lVzNK.default)(eventStream)) throw new Error('Subscription field must return Async Iterable. ' + "Received: ".concat((0, $biK02.default)(eventStream), "."));
        return eventStream;
    }, function(error) {
        throw (0, $02KAV.locatedError)(error, fieldNodes, (0, $kZHaf.pathToArray)(path));
    });
}

});
parcelRegister("lVzNK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0c2a0b88b975b05$export$2e2bcd8739ae039);

var $gwa3m = parcelRequire("gwa3m");
function $f0c2a0b88b975b05$export$2e2bcd8739ae039(maybeAsyncIterable) {
    return typeof (maybeAsyncIterable === null || maybeAsyncIterable === void 0 ? void 0 : maybeAsyncIterable[0, $gwa3m.SYMBOL_ASYNC_ITERATOR]) === 'function';
}

});

parcelRegister("b1Z8M", function(module, exports) {

$parcel$export(module.exports, "default", () => $e70a078baba341ab$export$2e2bcd8739ae039);

var $gwa3m = parcelRequire("gwa3m");
function $e70a078baba341ab$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e70a078baba341ab$export$2e2bcd8739ae039(iterable, callback, rejectCallback) {
    // $FlowFixMe[prop-missing]
    var iteratorMethod = iterable[0, $gwa3m.SYMBOL_ASYNC_ITERATOR];
    var iterator = iteratorMethod.call(iterable);
    var $return;
    var abruptClose;
    if (typeof iterator.return === 'function') {
        $return = iterator.return;
        abruptClose = function abruptClose(error) {
            var rethrow = function rethrow() {
                return Promise.reject(error);
            };
            return $return.call(iterator).then(rethrow, rethrow);
        };
    }
    function mapResult(result) {
        return result.done ? result : $e70a078baba341ab$var$asyncMapValue(result.value, callback).then($e70a078baba341ab$var$iteratorResult, abruptClose);
    }
    var mapReject;
    if (rejectCallback) {
        // Capture rejectCallback to ensure it cannot be null.
        var reject = rejectCallback;
        mapReject = function mapReject(error) {
            return $e70a078baba341ab$var$asyncMapValue(error, reject).then($e70a078baba341ab$var$iteratorResult, abruptClose);
        };
    }
    /* TODO: Flow doesn't support symbols as keys:
     https://github.com/facebook/flow/issues/3258 */ return $e70a078baba341ab$var$_defineProperty({
        next: function next() {
            return iterator.next().then(mapResult, mapReject);
        },
        return: function _return() {
            return $return ? $return.call(iterator).then(mapResult, mapReject) : Promise.resolve({
                value: undefined,
                done: true
            });
        },
        throw: function _throw(error) {
            if (typeof iterator.throw === 'function') return iterator.throw(error).then(mapResult, mapReject);
            return Promise.reject(error).catch(abruptClose);
        }
    }, (0, $gwa3m.SYMBOL_ASYNC_ITERATOR), function() {
        return this;
    });
}
function $e70a078baba341ab$var$asyncMapValue(value, callback) {
    return new Promise(function(resolve) {
        return resolve(callback(value));
    });
}
function $e70a078baba341ab$var$iteratorResult(value) {
    return {
        value: value,
        done: false
    };
}

});


parcelRegister("iijzq", function(module, exports) {
var $d51916b58a73dae6$var$__assign = module.exports && module.exports.__assign || function() {
    $d51916b58a73dae6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d51916b58a73dae6$var$__assign.apply(this, arguments);
};
var $d51916b58a73dae6$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $d51916b58a73dae6$var$AddArgumentsAsVariablesTransform = /** @class */ function() {
    function AddArgumentsAsVariablesTransform(schema, args) {
        this.schema = schema;
        this.args = args;
    }
    AddArgumentsAsVariablesTransform.prototype.transformRequest = function(originalRequest) {
        var _a = $d51916b58a73dae6$var$addVariablesToRootField(this.schema, originalRequest.document, this.args), document = _a.document, newVariables = _a.newVariables;
        var variables = $d51916b58a73dae6$var$__assign($d51916b58a73dae6$var$__assign({}, originalRequest.variables), newVariables);
        return {
            document: document,
            variables: variables
        };
    };
    return AddArgumentsAsVariablesTransform;
}();
module.exports.default = $d51916b58a73dae6$var$AddArgumentsAsVariablesTransform;
function $d51916b58a73dae6$var$addVariablesToRootField(targetSchema, document, args) {
    var operations = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.OPERATION_DEFINITION;
    });
    var fragments = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.FRAGMENT_DEFINITION;
    });
    var variableNames = {};
    var newOperations = operations.map(function(operation) {
        var existingVariables = operation.variableDefinitions.map(function(variableDefinition) {
            return variableDefinition.variable.name.value;
        });
        var variableCounter = 0;
        var variables = {};
        var generateVariableName = function(argName) {
            var varName;
            do {
                varName = "_v" + variableCounter + "_" + argName;
                variableCounter++;
            }while (existingVariables.indexOf(varName) !== -1);
            return varName;
        };
        var type;
        if (operation.operation === 'subscription') type = targetSchema.getSubscriptionType();
        else if (operation.operation === 'mutation') type = targetSchema.getMutationType();
        else type = targetSchema.getQueryType();
        var newSelectionSet = [];
        operation.selectionSet.selections.forEach(function(selection) {
            if (selection.kind === $1c4hI.Kind.FIELD) {
                var newArgs_1 = {};
                selection.arguments.forEach(function(argument) {
                    newArgs_1[argument.name.value] = argument;
                });
                var name_1 = selection.name.value;
                var field = type.getFields()[name_1];
                field.args.forEach(function(argument) {
                    if (argument.name in args) {
                        var variableName = generateVariableName(argument.name);
                        variableNames[argument.name] = variableName;
                        newArgs_1[argument.name] = {
                            kind: $1c4hI.Kind.ARGUMENT,
                            name: {
                                kind: $1c4hI.Kind.NAME,
                                value: argument.name
                            },
                            value: {
                                kind: $1c4hI.Kind.VARIABLE,
                                name: {
                                    kind: $1c4hI.Kind.NAME,
                                    value: variableName
                                }
                            }
                        };
                        existingVariables.push(variableName);
                        variables[variableName] = {
                            kind: $1c4hI.Kind.VARIABLE_DEFINITION,
                            variable: {
                                kind: $1c4hI.Kind.VARIABLE,
                                name: {
                                    kind: $1c4hI.Kind.NAME,
                                    value: variableName
                                }
                            },
                            type: $d51916b58a73dae6$var$typeToAst(argument.type)
                        };
                    }
                });
                newSelectionSet.push($d51916b58a73dae6$var$__assign($d51916b58a73dae6$var$__assign({}, selection), {
                    arguments: Object.keys(newArgs_1).map(function(argName) {
                        return newArgs_1[argName];
                    })
                }));
            } else newSelectionSet.push(selection);
        });
        return $d51916b58a73dae6$var$__assign($d51916b58a73dae6$var$__assign({}, operation), {
            variableDefinitions: operation.variableDefinitions.concat(Object.keys(variables).map(function(varName) {
                return variables[varName];
            })),
            selectionSet: {
                kind: $1c4hI.Kind.SELECTION_SET,
                selections: newSelectionSet
            }
        });
    });
    var newVariables = {};
    Object.keys(variableNames).forEach(function(name) {
        newVariables[variableNames[name]] = args[name];
    });
    return {
        document: $d51916b58a73dae6$var$__assign($d51916b58a73dae6$var$__assign({}, document), {
            definitions: $d51916b58a73dae6$var$__spreadArrays(newOperations, fragments)
        }),
        newVariables: newVariables
    };
}
function $d51916b58a73dae6$var$typeToAst(type) {
    if (type instanceof $lXoEQ.GraphQLNonNull) {
        var innerType = $d51916b58a73dae6$var$typeToAst(type.ofType);
        if (innerType.kind === $1c4hI.Kind.LIST_TYPE || innerType.kind === $1c4hI.Kind.NAMED_TYPE) return {
            kind: $1c4hI.Kind.NON_NULL_TYPE,
            type: innerType
        };
        else throw new Error('Incorrent inner non-null type');
    } else if (type instanceof $lXoEQ.GraphQLList) return {
        kind: $1c4hI.Kind.LIST_TYPE,
        type: $d51916b58a73dae6$var$typeToAst(type.ofType)
    };
    else return {
        kind: $1c4hI.Kind.NAMED_TYPE,
        name: {
            kind: $1c4hI.Kind.NAME,
            value: type.toString()
        }
    };
}

});

parcelRegister("8Vthi", function(module, exports) {
var $67fa5b975bcbc2ac$var$__assign = module.exports && module.exports.__assign || function() {
    $67fa5b975bcbc2ac$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $67fa5b975bcbc2ac$var$__assign.apply(this, arguments);
};
var $67fa5b975bcbc2ac$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $h2iUh = parcelRequire("h2iUh");
var $961BR = parcelRequire("961BR");

var $eYOZQ = parcelRequire("eYOZQ");
var $67fa5b975bcbc2ac$var$FilterToSchema = /** @class */ function() {
    function FilterToSchema(targetSchema) {
        this.targetSchema = targetSchema;
    }
    FilterToSchema.prototype.transformRequest = function(originalRequest) {
        var document = $67fa5b975bcbc2ac$var$filterDocumentToSchema(this.targetSchema, originalRequest.document);
        return $67fa5b975bcbc2ac$var$__assign($67fa5b975bcbc2ac$var$__assign({}, originalRequest), {
            document: document
        });
    };
    return FilterToSchema;
}();
module.exports.default = $67fa5b975bcbc2ac$var$FilterToSchema;
function $67fa5b975bcbc2ac$var$filterDocumentToSchema(targetSchema, document) {
    var operations = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.OPERATION_DEFINITION;
    });
    var fragments = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.FRAGMENT_DEFINITION;
    });
    var usedFragments = [];
    var newOperations = [];
    var newFragments = [];
    var validFragments = fragments.filter(function(fragment) {
        var typeName = fragment.typeCondition.name.value;
        return Boolean(targetSchema.getType(typeName));
    });
    var validFragmentsWithType = {};
    validFragments.forEach(function(fragment) {
        var typeName = fragment.typeCondition.name.value;
        var type = targetSchema.getType(typeName);
        validFragmentsWithType[fragment.name.value] = type;
    });
    var fragmentSet = Object.create(null);
    operations.forEach(function(operation) {
        var type;
        if (operation.operation === 'subscription') type = targetSchema.getSubscriptionType();
        else if (operation.operation === 'mutation') type = targetSchema.getMutationType();
        else type = targetSchema.getQueryType();
        var _a = $67fa5b975bcbc2ac$var$filterSelectionSet(targetSchema, type, validFragmentsWithType, operation.selectionSet), selectionSet = _a.selectionSet, operationUsedFragments = _a.usedFragments, operationUsedVariables = _a.usedVariables;
        usedFragments = $67fa5b975bcbc2ac$var$union(usedFragments, operationUsedFragments);
        var _b = $67fa5b975bcbc2ac$var$collectFragmentVariables(targetSchema, fragmentSet, validFragments, validFragmentsWithType, usedFragments), collectedUsedVariables = _b.usedVariables, collectedNewFragments = _b.newFragments, collectedFragmentSet = _b.fragmentSet;
        var fullUsedVariables = $67fa5b975bcbc2ac$var$union(operationUsedVariables, collectedUsedVariables);
        newFragments = collectedNewFragments;
        fragmentSet = collectedFragmentSet;
        var variableDefinitions = operation.variableDefinitions.filter(function(variable) {
            return fullUsedVariables.indexOf(variable.variable.name.value) !== -1;
        });
        newOperations.push({
            kind: $1c4hI.Kind.OPERATION_DEFINITION,
            operation: operation.operation,
            name: operation.name,
            directives: operation.directives,
            variableDefinitions: variableDefinitions,
            selectionSet: selectionSet
        });
    });
    return {
        kind: $1c4hI.Kind.DOCUMENT,
        definitions: $67fa5b975bcbc2ac$var$__spreadArrays(newOperations, newFragments)
    };
}
function $67fa5b975bcbc2ac$var$collectFragmentVariables(targetSchema, fragmentSet, validFragments, validFragmentsWithType, usedFragments) {
    var usedVariables = [];
    var newFragments = [];
    var _loop_1 = function() {
        var nextFragmentName = usedFragments.pop();
        var fragment = validFragments.find(function(fr) {
            return fr.name.value === nextFragmentName;
        });
        if (fragment) {
            var name_1 = nextFragmentName;
            var typeName = fragment.typeCondition.name.value;
            var type = targetSchema.getType(typeName);
            var _a = $67fa5b975bcbc2ac$var$filterSelectionSet(targetSchema, type, validFragmentsWithType, fragment.selectionSet), selectionSet = _a.selectionSet, fragmentUsedFragments = _a.usedFragments, fragmentUsedVariables = _a.usedVariables;
            usedFragments = $67fa5b975bcbc2ac$var$union(usedFragments, fragmentUsedFragments);
            usedVariables = $67fa5b975bcbc2ac$var$union(usedVariables, fragmentUsedVariables);
            if (!fragmentSet[name_1]) {
                fragmentSet[name_1] = true;
                newFragments.push({
                    kind: $1c4hI.Kind.FRAGMENT_DEFINITION,
                    name: {
                        kind: $1c4hI.Kind.NAME,
                        value: name_1
                    },
                    typeCondition: fragment.typeCondition,
                    selectionSet: selectionSet
                });
            }
        }
    };
    while(usedFragments.length !== 0)_loop_1();
    return {
        usedVariables: usedVariables,
        newFragments: newFragments,
        fragmentSet: fragmentSet
    };
}
function $67fa5b975bcbc2ac$var$filterSelectionSet(schema, type, validFragments, selectionSet) {
    var _a;
    var usedFragments = [];
    var usedVariables = [];
    var typeStack = [
        type
    ];
    // Should be rewritten using visitWithSchema
    var filteredSelectionSet = $961BR.visit(selectionSet, (_a = {}, _a[$1c4hI.Kind.FIELD] = {
        enter: function(node) {
            var parentType = $67fa5b975bcbc2ac$var$resolveType(typeStack[typeStack.length - 1]);
            if (parentType instanceof $lXoEQ.GraphQLObjectType || parentType instanceof $lXoEQ.GraphQLInterfaceType) {
                var fields = parentType.getFields();
                var field = node.name.value === '__typename' ? $h2iUh.TypeNameMetaFieldDef : fields[node.name.value];
                if (!field) return null;
                else typeStack.push(field.type);
                var argNames_1 = (field.args || []).map(function(arg) {
                    return arg.name;
                });
                if (node.arguments) {
                    var args = node.arguments.filter(function(arg) {
                        return argNames_1.indexOf(arg.name.value) !== -1;
                    });
                    if (args.length !== node.arguments.length) return $67fa5b975bcbc2ac$var$__assign($67fa5b975bcbc2ac$var$__assign({}, node), {
                        arguments: args
                    });
                }
            } else if (parentType instanceof $lXoEQ.GraphQLUnionType && node.name.value === '__typename') typeStack.push($h2iUh.TypeNameMetaFieldDef.type);
        },
        leave: function(node) {
            var _a;
            var currentType = typeStack.pop();
            var resolvedType = $67fa5b975bcbc2ac$var$resolveType(currentType);
            if (resolvedType instanceof $lXoEQ.GraphQLObjectType || resolvedType instanceof $lXoEQ.GraphQLInterfaceType) {
                var selections = node.selectionSet && node.selectionSet.selections || null;
                if (!selections || selections.length === 0) {
                    // need to remove any added variables. Is there a better way to do this?
                    $961BR.visit(node, (_a = {}, _a[$1c4hI.Kind.VARIABLE] = function(variableNode) {
                        var index = usedVariables.indexOf(variableNode.name.value);
                        if (index !== -1) usedVariables.splice(index, 1);
                    }, _a));
                    return null;
                }
            }
        }
    }, _a[$1c4hI.Kind.FRAGMENT_SPREAD] = function(node) {
        if (node.name.value in validFragments) {
            var parentType = $67fa5b975bcbc2ac$var$resolveType(typeStack[typeStack.length - 1]);
            var innerType = validFragments[node.name.value];
            if (!$eYOZQ.default(schema, parentType, innerType)) return null;
            else {
                usedFragments.push(node.name.value);
                return;
            }
        } else return null;
    }, _a[$1c4hI.Kind.INLINE_FRAGMENT] = {
        enter: function(node) {
            if (node.typeCondition) {
                var innerType = schema.getType(node.typeCondition.name.value);
                var parentType = $67fa5b975bcbc2ac$var$resolveType(typeStack[typeStack.length - 1]);
                if ($eYOZQ.default(schema, parentType, innerType)) typeStack.push(innerType);
                else return null;
            }
        },
        leave: function(node) {
            typeStack.pop();
        }
    }, _a[$1c4hI.Kind.VARIABLE] = function(node) {
        usedVariables.push(node.name.value);
    }, _a));
    return {
        selectionSet: filteredSelectionSet,
        usedFragments: usedFragments,
        usedVariables: usedVariables
    };
}
function $67fa5b975bcbc2ac$var$resolveType(type) {
    var lastType = type;
    while(lastType instanceof $lXoEQ.GraphQLNonNull || lastType instanceof $lXoEQ.GraphQLList)lastType = lastType.ofType;
    return lastType;
}
function $67fa5b975bcbc2ac$var$union() {
    var arrays = [];
    for(var _i = 0; _i < arguments.length; _i++)arrays[_i] = arguments[_i];
    var cache = {};
    var result = [];
    arrays.forEach(function(array) {
        array.forEach(function(item) {
            if (!cache[item]) {
                cache[item] = true;
                result.push(item);
            }
        });
    });
    return result;
}

});
parcelRegister("eYOZQ", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $f5cpS = parcelRequire("f5cpS");
var $lXoEQ = parcelRequire("lXoEQ");
function $ae7e3a242f220513$var$implementsAbstractType(schema, typeA, typeB) {
    if (typeA === typeB) return true;
    else if ($lXoEQ.isCompositeType(typeA) && $lXoEQ.isCompositeType(typeB)) return $f5cpS.doTypesOverlap(schema, typeA, typeB);
    else return false;
}
module.exports.default = $ae7e3a242f220513$var$implementsAbstractType;

});


parcelRegister("aYyML", function(module, exports) {
var $7fda7dad3e357eae$var$__assign = module.exports && module.exports.__assign || function() {
    $7fda7dad3e357eae$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7fda7dad3e357eae$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $hMOry = parcelRequire("hMOry");
var $961BR = parcelRequire("961BR");
var $7fda7dad3e357eae$var$AddTypenameToAbstract = /** @class */ function() {
    function AddTypenameToAbstract(targetSchema) {
        this.targetSchema = targetSchema;
    }
    AddTypenameToAbstract.prototype.transformRequest = function(originalRequest) {
        var document = $7fda7dad3e357eae$var$addTypenameToAbstract(this.targetSchema, originalRequest.document);
        return $7fda7dad3e357eae$var$__assign($7fda7dad3e357eae$var$__assign({}, originalRequest), {
            document: document
        });
    };
    return AddTypenameToAbstract;
}();
module.exports.default = $7fda7dad3e357eae$var$AddTypenameToAbstract;
function $7fda7dad3e357eae$var$addTypenameToAbstract(targetSchema, document) {
    var _a;
    var typeInfo = new $hMOry.TypeInfo(targetSchema);
    return $961BR.visit(document, $hMOry.visitWithTypeInfo(typeInfo, (_a = {}, _a[$1c4hI.Kind.SELECTION_SET] = function(node) {
        var parentType = typeInfo.getParentType();
        var selections = node.selections;
        if (parentType && (parentType instanceof $lXoEQ.GraphQLInterfaceType || parentType instanceof $lXoEQ.GraphQLUnionType) && !selections.find(function(_) {
            return _.kind === $1c4hI.Kind.FIELD && _.name.value === '__typename';
        })) selections = selections.concat({
            kind: $1c4hI.Kind.FIELD,
            name: {
                kind: $1c4hI.Kind.NAME,
                value: '__typename'
            }
        });
        if (selections !== node.selections) return $7fda7dad3e357eae$var$__assign($7fda7dad3e357eae$var$__assign({}, node), {
            selections: selections
        });
    }, _a)));
}

});

parcelRegister("gvWNr", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $10LTa = parcelRequire("10LTa");
var $c05d26599fa40d22$var$CheckResultAndHandleErrors = /** @class */ function() {
    function CheckResultAndHandleErrors(info, fieldName) {
        this.info = info;
        this.fieldName = fieldName;
    }
    CheckResultAndHandleErrors.prototype.transformResult = function(result) {
        return $10LTa.checkResultAndHandleErrors(result, this.info, this.fieldName);
    };
    return CheckResultAndHandleErrors;
}();
module.exports.default = $c05d26599fa40d22$var$CheckResultAndHandleErrors;

});

parcelRegister("fB7Hv", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cRJgL = parcelRequire("cRJgL");
/**
 * Given an AsyncIterable and a callback function, return an AsyncIterator
 * which produces values mapped via calling the callback function.
 */ function $b5b048e835d5ba5c$var$mapAsyncIterator(iterator, callback, rejectCallback) {
    var _a;
    var $return;
    var abruptClose;
    if (typeof iterator.return === 'function') {
        $return = iterator.return;
        abruptClose = function(error) {
            var rethrow = function() {
                return Promise.reject(error);
            };
            return $return.call(iterator).then(rethrow, rethrow);
        };
    }
    function mapResult(result) {
        return result.done ? result : $b5b048e835d5ba5c$var$asyncMapValue(result.value, callback).then($b5b048e835d5ba5c$var$iteratorResult, abruptClose);
    }
    var mapReject;
    if (rejectCallback) {
        // Capture rejectCallback to ensure it cannot be null.
        var reject_1 = rejectCallback;
        mapReject = function(error) {
            return $b5b048e835d5ba5c$var$asyncMapValue(error, reject_1).then($b5b048e835d5ba5c$var$iteratorResult, abruptClose);
        };
    }
    return _a = {
        next: function() {
            return iterator.next().then(mapResult, mapReject);
        },
        return: function() {
            return $return ? $return.call(iterator).then(mapResult, mapReject) : Promise.resolve({
                value: undefined,
                done: true
            });
        },
        throw: function(error) {
            if (typeof iterator.throw === 'function') return iterator.throw(error).then(mapResult, mapReject);
            return Promise.reject(error).catch(abruptClose);
        }
    }, _a[$cRJgL.$$asyncIterator] = function() {
        return this;
    }, _a;
}
module.exports.default = $b5b048e835d5ba5c$var$mapAsyncIterator;
function $b5b048e835d5ba5c$var$asyncMapValue(value, callback) {
    return new Promise(function(resolve) {
        return resolve(callback(value));
    });
}
function $b5b048e835d5ba5c$var$iteratorResult(value) {
    return {
        value: value,
        done: false
    };
}

});

parcelRegister("kYtVo", function(module, exports) {
var $f4509fae9d1b991a$var$__assign = module.exports && module.exports.__assign || function() {
    $f4509fae9d1b991a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f4509fae9d1b991a$var$__assign.apply(this, arguments);
};
var $f4509fae9d1b991a$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $hMOry = parcelRequire("hMOry");
var $961BR = parcelRequire("961BR");

var $eYOZQ = parcelRequire("eYOZQ");
var $f4509fae9d1b991a$var$ExpandAbstractTypes = /** @class */ function() {
    function ExpandAbstractTypes(transformedSchema, targetSchema) {
        this.targetSchema = targetSchema;
        this.mapping = $f4509fae9d1b991a$var$extractPossibleTypes(transformedSchema, targetSchema);
        this.reverseMapping = $f4509fae9d1b991a$var$flipMapping(this.mapping);
    }
    ExpandAbstractTypes.prototype.transformRequest = function(originalRequest) {
        var document = $f4509fae9d1b991a$var$expandAbstractTypes(this.targetSchema, this.mapping, this.reverseMapping, originalRequest.document);
        return $f4509fae9d1b991a$var$__assign($f4509fae9d1b991a$var$__assign({}, originalRequest), {
            document: document
        });
    };
    return ExpandAbstractTypes;
}();
module.exports.default = $f4509fae9d1b991a$var$ExpandAbstractTypes;
function $f4509fae9d1b991a$var$extractPossibleTypes(transformedSchema, targetSchema) {
    var typeMap = transformedSchema.getTypeMap();
    var mapping = {};
    Object.keys(typeMap).forEach(function(typeName) {
        var type = typeMap[typeName];
        if ($lXoEQ.isAbstractType(type)) {
            var targetType = targetSchema.getType(typeName);
            if (!$lXoEQ.isAbstractType(targetType)) {
                var implementations = transformedSchema.getPossibleTypes(type) || [];
                mapping[typeName] = implementations.filter(function(impl) {
                    return targetSchema.getType(impl.name);
                }).map(function(impl) {
                    return impl.name;
                });
            }
        }
    });
    return mapping;
}
function $f4509fae9d1b991a$var$flipMapping(mapping) {
    var result = {};
    Object.keys(mapping).forEach(function(typeName) {
        var toTypeNames = mapping[typeName];
        toTypeNames.forEach(function(toTypeName) {
            if (!result[toTypeName]) result[toTypeName] = [];
            result[toTypeName].push(typeName);
        });
    });
    return result;
}
function $f4509fae9d1b991a$var$expandAbstractTypes(targetSchema, mapping, reverseMapping, document) {
    var _a;
    var operations = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.OPERATION_DEFINITION;
    });
    var fragments = document.definitions.filter(function(def) {
        return def.kind === $1c4hI.Kind.FRAGMENT_DEFINITION;
    });
    var existingFragmentNames = fragments.map(function(fragment) {
        return fragment.name.value;
    });
    var fragmentCounter = 0;
    var generateFragmentName = function(typeName) {
        var fragmentName;
        do {
            fragmentName = "_" + typeName + "_Fragment" + fragmentCounter;
            fragmentCounter++;
        }while (existingFragmentNames.indexOf(fragmentName) !== -1);
        return fragmentName;
    };
    var newFragments = [];
    var fragmentReplacements = {};
    fragments.forEach(function(fragment) {
        newFragments.push(fragment);
        var possibleTypes = mapping[fragment.typeCondition.name.value];
        if (possibleTypes) {
            fragmentReplacements[fragment.name.value] = [];
            possibleTypes.forEach(function(possibleTypeName) {
                var name = generateFragmentName(possibleTypeName);
                existingFragmentNames.push(name);
                var newFragment = {
                    kind: $1c4hI.Kind.FRAGMENT_DEFINITION,
                    name: {
                        kind: $1c4hI.Kind.NAME,
                        value: name
                    },
                    typeCondition: {
                        kind: $1c4hI.Kind.NAMED_TYPE,
                        name: {
                            kind: $1c4hI.Kind.NAME,
                            value: possibleTypeName
                        }
                    },
                    selectionSet: fragment.selectionSet
                };
                newFragments.push(newFragment);
                fragmentReplacements[fragment.name.value].push({
                    fragmentName: name,
                    typeName: possibleTypeName
                });
            });
        }
    });
    var newDocument = $f4509fae9d1b991a$var$__assign($f4509fae9d1b991a$var$__assign({}, document), {
        definitions: $f4509fae9d1b991a$var$__spreadArrays(operations, newFragments)
    });
    var typeInfo = new $hMOry.TypeInfo(targetSchema);
    return $961BR.visit(newDocument, $hMOry.visitWithTypeInfo(typeInfo, (_a = {}, _a[$1c4hI.Kind.SELECTION_SET] = function(node) {
        var newSelections = $f4509fae9d1b991a$var$__spreadArrays(node.selections);
        var parentType = $lXoEQ.getNamedType(typeInfo.getParentType());
        node.selections.forEach(function(selection) {
            if (selection.kind === $1c4hI.Kind.INLINE_FRAGMENT) {
                var possibleTypes = mapping[selection.typeCondition.name.value];
                if (possibleTypes) possibleTypes.forEach(function(possibleType) {
                    if ($eYOZQ.default(targetSchema, parentType, targetSchema.getType(possibleType))) newSelections.push({
                        kind: $1c4hI.Kind.INLINE_FRAGMENT,
                        typeCondition: {
                            kind: $1c4hI.Kind.NAMED_TYPE,
                            name: {
                                kind: $1c4hI.Kind.NAME,
                                value: possibleType
                            }
                        },
                        selectionSet: selection.selectionSet
                    });
                });
            } else if (selection.kind === $1c4hI.Kind.FRAGMENT_SPREAD) {
                var fragmentName = selection.name.value;
                var replacements = fragmentReplacements[fragmentName];
                if (replacements) replacements.forEach(function(replacement) {
                    var typeName = replacement.typeName;
                    if ($eYOZQ.default(targetSchema, parentType, targetSchema.getType(typeName))) newSelections.push({
                        kind: $1c4hI.Kind.FRAGMENT_SPREAD,
                        name: {
                            kind: $1c4hI.Kind.NAME,
                            value: replacement.fragmentName
                        }
                    });
                });
            }
        });
        if (parentType && reverseMapping[parentType.name]) newSelections.push({
            kind: $1c4hI.Kind.FIELD,
            name: {
                kind: $1c4hI.Kind.NAME,
                value: '__typename'
            }
        });
        if (newSelections.length !== node.selections.length) return $f4509fae9d1b991a$var$__assign($f4509fae9d1b991a$var$__assign({}, node), {
            selections: newSelections
        });
    }, _a)));
}

});

parcelRegister("4trzE", function(module, exports) {
var $341f4279b3bb4e24$var$__assign = module.exports && module.exports.__assign || function() {
    $341f4279b3bb4e24$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $341f4279b3bb4e24$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1c4hI = parcelRequire("1c4hI");
var $6ds0g = parcelRequire("6ds0g");
var $hMOry = parcelRequire("hMOry");
var $961BR = parcelRequire("961BR");
var $341f4279b3bb4e24$var$ReplaceFieldWithFragment = /** @class */ function() {
    function ReplaceFieldWithFragment(targetSchema, fragments) {
        this.targetSchema = targetSchema;
        this.mapping = {};
        for(var _i = 0, fragments_1 = fragments; _i < fragments_1.length; _i++){
            var _a = fragments_1[_i], field = _a.field, fragment = _a.fragment;
            var parsedFragment = $341f4279b3bb4e24$var$parseFragmentToInlineFragment(fragment);
            var actualTypeName = parsedFragment.typeCondition.name.value;
            this.mapping[actualTypeName] = this.mapping[actualTypeName] || {};
            if (this.mapping[actualTypeName][field]) this.mapping[actualTypeName][field].push(parsedFragment);
            else this.mapping[actualTypeName][field] = [
                parsedFragment
            ];
        }
    }
    ReplaceFieldWithFragment.prototype.transformRequest = function(originalRequest) {
        var document = $341f4279b3bb4e24$var$replaceFieldsWithFragments(this.targetSchema, originalRequest.document, this.mapping);
        return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, originalRequest), {
            document: document
        });
    };
    return ReplaceFieldWithFragment;
}();
module.exports.default = $341f4279b3bb4e24$var$ReplaceFieldWithFragment;
function $341f4279b3bb4e24$var$replaceFieldsWithFragments(targetSchema, document, mapping) {
    var _a;
    var typeInfo = new $hMOry.TypeInfo(targetSchema);
    return $961BR.visit(document, $hMOry.visitWithTypeInfo(typeInfo, (_a = {}, _a[$1c4hI.Kind.SELECTION_SET] = function(node) {
        var parentType = typeInfo.getParentType();
        if (parentType) {
            var parentTypeName_1 = parentType.name;
            var selections_1 = node.selections;
            if (mapping[parentTypeName_1]) node.selections.forEach(function(selection) {
                if (selection.kind === $1c4hI.Kind.FIELD) {
                    var name_1 = selection.name.value;
                    var fragments = mapping[parentTypeName_1][name_1];
                    if (fragments && fragments.length > 0) {
                        var fragment = $341f4279b3bb4e24$var$concatInlineFragments(parentTypeName_1, fragments);
                        selections_1 = selections_1.concat(fragment);
                    }
                }
            });
            if (selections_1 !== node.selections) return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, node), {
                selections: selections_1
            });
        }
    }, _a)));
}
function $341f4279b3bb4e24$var$parseFragmentToInlineFragment(definitions) {
    if (definitions.trim().startsWith('fragment')) {
        var document_1 = $6ds0g.parse(definitions);
        for(var _i = 0, _a = document_1.definitions; _i < _a.length; _i++){
            var definition = _a[_i];
            if (definition.kind === $1c4hI.Kind.FRAGMENT_DEFINITION) return {
                kind: $1c4hI.Kind.INLINE_FRAGMENT,
                typeCondition: definition.typeCondition,
                selectionSet: definition.selectionSet
            };
        }
    }
    var query = $6ds0g.parse("{" + definitions + "}").definitions[0];
    for(var _b = 0, _c = query.selectionSet.selections; _b < _c.length; _b++){
        var selection = _c[_b];
        if (selection.kind === $1c4hI.Kind.INLINE_FRAGMENT) return selection;
    }
    throw new Error('Could not parse fragment');
}
function $341f4279b3bb4e24$var$concatInlineFragments(type, fragments) {
    var fragmentSelections = fragments.reduce(function(selections, fragment) {
        return selections.concat(fragment.selectionSet.selections);
    }, []);
    var deduplicatedFragmentSelection = $341f4279b3bb4e24$var$deduplicateSelection(fragmentSelections);
    return {
        kind: $1c4hI.Kind.INLINE_FRAGMENT,
        typeCondition: {
            kind: $1c4hI.Kind.NAMED_TYPE,
            name: {
                kind: $1c4hI.Kind.NAME,
                value: type
            }
        },
        selectionSet: {
            kind: $1c4hI.Kind.SELECTION_SET,
            selections: deduplicatedFragmentSelection
        }
    };
}
function $341f4279b3bb4e24$var$deduplicateSelection(nodes) {
    var selectionMap = nodes.reduce(function(map, node) {
        var _a, _b, _c;
        switch(node.kind){
            case 'Field':
                if (node.alias) {
                    if (map.hasOwnProperty(node.alias.value)) return map;
                    else return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, map), (_a = {}, _a[node.alias.value] = node, _a));
                } else {
                    if (map.hasOwnProperty(node.name.value)) return map;
                    else return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, map), (_b = {}, _b[node.name.value] = node, _b));
                }
            case 'FragmentSpread':
                if (map.hasOwnProperty(node.name.value)) return map;
                else return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, map), (_c = {}, _c[node.name.value] = node, _c));
            case 'InlineFragment':
                if (map.__fragment) {
                    var fragment = map.__fragment;
                    return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, map), {
                        __fragment: $341f4279b3bb4e24$var$concatInlineFragments(fragment.typeCondition.name.value, [
                            fragment,
                            node
                        ])
                    });
                } else return $341f4279b3bb4e24$var$__assign($341f4279b3bb4e24$var$__assign({}, map), {
                    __fragment: node
                });
            default:
                return map;
        }
    }, {});
    var selection = Object.keys(selectionMap).reduce(function(selectionList, node) {
        return selectionList.concat(selectionMap[node]);
    }, []);
    return selection;
}

});

parcelRegister("goXjX", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bf0ce71a50359f69$var$ConvertEnumResponse = /** @class */ function() {
    function ConvertEnumResponse(enumNode) {
        this.enumNode = enumNode;
    }
    ConvertEnumResponse.prototype.transformResult = function(result) {
        var value = this.enumNode.getValue(result);
        if (value) return value.value;
        return result;
    };
    return ConvertEnumResponse;
}();
module.exports.default = $bf0ce71a50359f69$var$ConvertEnumResponse;

});


parcelRegister("dkK13", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5hGV7 = parcelRequire("5hGV7");
var $glHRe = parcelRequire("glHRe");
var $bOniD = parcelRequire("bOniD");
var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");
var $1c4hI = parcelRequire("1c4hI");
var $3E0nn = parcelRequire("3E0nn");

var $j0Odg = parcelRequire("j0Odg");
var $9b50d66fb2ab7736$var$backcompatOptions = {
    commentDescriptions: true
};
function $9b50d66fb2ab7736$var$typeFromAST(node) {
    switch(node.kind){
        case $1c4hI.Kind.OBJECT_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeObjectType(node);
        case $1c4hI.Kind.INTERFACE_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeInterfaceType(node);
        case $1c4hI.Kind.ENUM_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeEnumType(node);
        case $1c4hI.Kind.UNION_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeUnionType(node);
        case $1c4hI.Kind.SCALAR_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeScalarType(node);
        case $1c4hI.Kind.INPUT_OBJECT_TYPE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeInputObjectType(node);
        case $1c4hI.Kind.DIRECTIVE_DEFINITION:
            return $9b50d66fb2ab7736$var$makeDirective(node);
        default:
            return null;
    }
}
module.exports.default = $9b50d66fb2ab7736$var$typeFromAST;
function $9b50d66fb2ab7736$var$makeObjectType(node) {
    return new $lXoEQ.GraphQLObjectType({
        name: node.name.value,
        fields: function() {
            return $9b50d66fb2ab7736$var$makeFields(node.fields);
        },
        interfaces: function() {
            return node.interfaces.map(function(iface) {
                return $9b50d66fb2ab7736$var$createNamedStub(iface.name.value, 'interface');
            });
        },
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions)
    });
}
function $9b50d66fb2ab7736$var$makeInterfaceType(node) {
    return new $lXoEQ.GraphQLInterfaceType({
        name: node.name.value,
        fields: function() {
            return $9b50d66fb2ab7736$var$makeFields(node.fields);
        },
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions),
        resolveType: function(parent, context, info) {
            return $j0Odg.default(parent, info.schema);
        }
    });
}
function $9b50d66fb2ab7736$var$makeEnumType(node) {
    var values = {};
    node.values.forEach(function(value) {
        values[value.name.value] = {
            description: $glHRe.getDescription(value, $9b50d66fb2ab7736$var$backcompatOptions)
        };
    });
    return new $lXoEQ.GraphQLEnumType({
        name: node.name.value,
        values: values,
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions)
    });
}
function $9b50d66fb2ab7736$var$makeUnionType(node) {
    return new $lXoEQ.GraphQLUnionType({
        name: node.name.value,
        types: function() {
            return node.types.map(function(type) {
                return $9b50d66fb2ab7736$var$resolveType(type, 'object');
            });
        },
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions),
        resolveType: function(parent, context, info) {
            return $j0Odg.default(parent, info.schema);
        }
    });
}
function $9b50d66fb2ab7736$var$makeScalarType(node) {
    return new $lXoEQ.GraphQLScalarType({
        name: node.name.value,
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions),
        serialize: function() {
            return null;
        },
        // Note: validation calls the parse functions to determine if a
        // literal value is correct. Returning null would cause use of custom
        // scalars to always fail validation. Returning false causes them to
        // always pass validation.
        parseValue: function() {
            return false;
        },
        parseLiteral: function() {
            return false;
        }
    });
}
function $9b50d66fb2ab7736$var$makeInputObjectType(node) {
    return new $lXoEQ.GraphQLInputObjectType({
        name: node.name.value,
        fields: function() {
            return $9b50d66fb2ab7736$var$makeValues(node.fields);
        },
        description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions)
    });
}
function $9b50d66fb2ab7736$var$makeFields(nodes) {
    var result = {};
    nodes.forEach(function(node) {
        var deprecatedDirective = node.directives.find(function(directive) {
            return directive && directive.name && directive.name.value === 'deprecated';
        });
        var deprecatedArgument = deprecatedDirective && deprecatedDirective.arguments && deprecatedDirective.arguments.find(function(arg) {
            return arg && arg.name && arg.name.value === 'reason';
        });
        var deprecationReason = deprecatedArgument && deprecatedArgument.value && deprecatedArgument.value.value;
        result[node.name.value] = {
            type: $9b50d66fb2ab7736$var$resolveType(node.type, 'object'),
            args: $9b50d66fb2ab7736$var$makeValues(node.arguments),
            description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions),
            deprecationReason: deprecationReason
        };
    });
    return result;
}
function $9b50d66fb2ab7736$var$makeValues(nodes) {
    var result = {};
    nodes.forEach(function(node) {
        var type = $9b50d66fb2ab7736$var$resolveType(node.type, 'input');
        result[node.name.value] = {
            type: type,
            defaultValue: $3E0nn.valueFromAST(node.defaultValue, type),
            description: $glHRe.getDescription(node, $9b50d66fb2ab7736$var$backcompatOptions)
        };
    });
    return result;
}
function $9b50d66fb2ab7736$var$resolveType(node, type) {
    switch(node.kind){
        case $1c4hI.Kind.LIST_TYPE:
            return new $lXoEQ.GraphQLList($9b50d66fb2ab7736$var$resolveType(node.type, type));
        case $1c4hI.Kind.NON_NULL_TYPE:
            return new $lXoEQ.GraphQLNonNull($9b50d66fb2ab7736$var$resolveType(node.type, type));
        default:
            return $9b50d66fb2ab7736$var$createNamedStub(node.name.value, type);
    }
}
function $9b50d66fb2ab7736$var$createNamedStub(name, type) {
    var constructor;
    if (type === 'object') constructor = $lXoEQ.GraphQLObjectType;
    else if (type === 'interface') constructor = $lXoEQ.GraphQLInterfaceType;
    else constructor = $lXoEQ.GraphQLInputObjectType;
    return new constructor({
        name: name,
        fields: {
            __fake: {
                type: $auu22.GraphQLString
            }
        }
    });
}
function $9b50d66fb2ab7736$var$makeDirective(node) {
    var locations = [];
    node.locations.forEach(function(location) {
        if (location.value in $5hGV7.DirectiveLocation) locations.push(location.value);
    });
    return new $bOniD.GraphQLDirective({
        name: node.name.value,
        description: node.description ? node.description.value : null,
        args: $9b50d66fb2ab7736$var$makeValues(node.arguments),
        locations: locations
    });
}

});

parcelRegister("16dWW", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5HvdU = parcelRequire("5HvdU");
module.exports.transformSchema = $5HvdU.default;

var $iijzq = parcelRequire("iijzq");
module.exports.AddArgumentsAsVariables = $iijzq.default;

var $gvWNr = parcelRequire("gvWNr");
module.exports.CheckResultAndHandleErrors = $gvWNr.default;

var $4trzE = parcelRequire("4trzE");
module.exports.ReplaceFieldWithFragment = $4trzE.default;

var $aYyML = parcelRequire("aYyML");
module.exports.AddTypenameToAbstract = $aYyML.default;

var $8Vthi = parcelRequire("8Vthi");
module.exports.FilterToSchema = $8Vthi.default;

var $irkOK = parcelRequire("irkOK");
module.exports.RenameTypes = $irkOK.default;

var $dhAZO = parcelRequire("dhAZO");
module.exports.FilterTypes = $dhAZO.default;

var $kXMIm = parcelRequire("kXMIm");
module.exports.TransformRootFields = $kXMIm.default;

var $loOHi = parcelRequire("loOHi");
module.exports.RenameRootFields = $loOHi.default;

var $2PHcZ = parcelRequire("2PHcZ");
module.exports.FilterRootFields = $2PHcZ.default;

var $kYtVo = parcelRequire("kYtVo");
module.exports.ExpandAbstractTypes = $kYtVo.default;

var $1t5NR = parcelRequire("1t5NR");
module.exports.ExtractField = $1t5NR.default;

var $6rbaH = parcelRequire("6rbaH");
module.exports.WrapQuery = $6rbaH.default;

});
parcelRegister("5HvdU", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $crrCr = parcelRequire("crrCr");

var $esiZ2 = parcelRequire("esiZ2");

var $esVhq = parcelRequire("esVhq");

var $cLqiN = parcelRequire("cLqiN");
function $4269303177f37031$var$transformSchema(targetSchema, transforms) {
    var schema = $esiZ2.visitSchema(targetSchema, {}, true);
    var mapping = $cLqiN.generateSimpleMapping(targetSchema);
    var resolvers = $cLqiN.generateProxyingResolvers(targetSchema, transforms, mapping);
    schema = $crrCr.addResolveFunctionsToSchema({
        schema: schema,
        resolvers: resolvers,
        resolverValidationOptions: {
            allowResolversNotInSchema: true
        }
    });
    schema = $esVhq.applySchemaTransforms(schema, transforms);
    schema.transforms = transforms;
    return schema;
}
module.exports.default = $4269303177f37031$var$transformSchema;

});
parcelRegister("cLqiN", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7UWAA = parcelRequire("7UWAA");
function $94ae46e8a1e4c305$var$generateProxyingResolvers(targetSchema, transforms, mapping) {
    var result = {};
    Object.keys(mapping).forEach(function(name) {
        result[name] = {};
        var innerMapping = mapping[name];
        Object.keys(innerMapping).forEach(function(from) {
            var _a;
            var to = innerMapping[from];
            var resolverType = to.operation === 'subscription' ? 'subscribe' : 'resolve';
            result[name][from] = (_a = {}, _a[resolverType] = $94ae46e8a1e4c305$var$createProxyingResolver(targetSchema, to.operation, to.name, transforms), _a);
        });
    });
    return result;
}
module.exports.generateProxyingResolvers = $94ae46e8a1e4c305$var$generateProxyingResolvers;
function $94ae46e8a1e4c305$var$generateSimpleMapping(targetSchema) {
    var query = targetSchema.getQueryType();
    var mutation = targetSchema.getMutationType();
    var subscription = targetSchema.getSubscriptionType();
    var result = {};
    if (query) result[query.name] = $94ae46e8a1e4c305$var$generateMappingFromObjectType(query, 'query');
    if (mutation) result[mutation.name] = $94ae46e8a1e4c305$var$generateMappingFromObjectType(mutation, 'mutation');
    if (subscription) result[subscription.name] = $94ae46e8a1e4c305$var$generateMappingFromObjectType(subscription, 'subscription');
    return result;
}
module.exports.generateSimpleMapping = $94ae46e8a1e4c305$var$generateSimpleMapping;
function $94ae46e8a1e4c305$var$generateMappingFromObjectType(type, operation) {
    var result = {};
    var fields = type.getFields();
    Object.keys(fields).forEach(function(fieldName) {
        result[fieldName] = {
            name: fieldName,
            operation: operation
        };
    });
    return result;
}
module.exports.generateMappingFromObjectType = $94ae46e8a1e4c305$var$generateMappingFromObjectType;
function $94ae46e8a1e4c305$var$createProxyingResolver(schema, operation, fieldName, transforms) {
    return function(parent, args, context, info) {
        return $7UWAA.default({
            schema: schema,
            operation: operation,
            fieldName: fieldName,
            args: {},
            context: context,
            info: info,
            transforms: transforms
        });
    };
}

});


parcelRegister("irkOK", function(module, exports) {
var $d6cae588b371003a$var$__assign = module.exports && module.exports.__assign || function() {
    $d6cae588b371003a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d6cae588b371003a$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");
var $1c4hI = parcelRequire("1c4hI");
var $961BR = parcelRequire("961BR");

var $kgFtY = parcelRequire("kgFtY");

var $esiZ2 = parcelRequire("esiZ2");
var $d6cae588b371003a$var$RenameTypes = /** @class */ function() {
    function RenameTypes(renamer, options) {
        this.renamer = renamer;
        this.reverseMap = {};
        var _a = options || {}, _b = _a.renameBuiltins, renameBuiltins = _b === void 0 ? false : _b, _c = _a.renameScalars, renameScalars = _c === void 0 ? true : _c;
        this.renameBuiltins = renameBuiltins;
        this.renameScalars = renameScalars;
    }
    RenameTypes.prototype.transformSchema = function(originalSchema) {
        var _a;
        var _this = this;
        return $esiZ2.visitSchema(originalSchema, (_a = {}, _a[$esiZ2.VisitSchemaKind.TYPE] = function(type) {
            if ($kgFtY.default(type) && !_this.renameBuiltins) return undefined;
            if (type instanceof $lXoEQ.GraphQLScalarType && !_this.renameScalars) return undefined;
            var newName = _this.renamer(type.name);
            if (newName && newName !== type.name) {
                _this.reverseMap[newName] = type.name;
                var newType = Object.assign(Object.create(type), type);
                newType.name = newName;
                return newType;
            }
        }, _a[$esiZ2.VisitSchemaKind.ROOT_OBJECT] = function(type) {
            return undefined;
        }, _a));
    };
    RenameTypes.prototype.transformRequest = function(originalRequest) {
        var _a;
        var _this = this;
        var newDocument = $961BR.visit(originalRequest.document, (_a = {}, _a[$1c4hI.Kind.NAMED_TYPE] = function(node) {
            var name = node.name.value;
            if (name in _this.reverseMap) return $d6cae588b371003a$var$__assign($d6cae588b371003a$var$__assign({}, node), {
                name: {
                    kind: $1c4hI.Kind.NAME,
                    value: _this.reverseMap[name]
                }
            });
        }, _a));
        return {
            document: newDocument,
            variables: originalRequest.variables
        };
    };
    RenameTypes.prototype.transformResult = function(result) {
        if (result.data) {
            var data = this.renameTypes(result.data, 'data');
            if (data !== result.data) return $d6cae588b371003a$var$__assign($d6cae588b371003a$var$__assign({}, result), {
                data: data
            });
        }
        return result;
    };
    RenameTypes.prototype.renameTypes = function(value, name) {
        var _this = this;
        if (name === '__typename') return this.renamer(value);
        if (value && typeof value === 'object') {
            var newValue_1 = Array.isArray(value) ? [] : Object.create(Object.getPrototypeOf(value));
            var returnNewValue_1 = false;
            Object.keys(value).forEach(function(key) {
                var oldChild = value[key];
                var newChild = _this.renameTypes(oldChild, key);
                newValue_1[key] = newChild;
                if (newChild !== oldChild) returnNewValue_1 = true;
            });
            if (returnNewValue_1) return newValue_1;
        }
        return value;
    };
    return RenameTypes;
}();
module.exports.default = $d6cae588b371003a$var$RenameTypes;

});

parcelRegister("dhAZO", function(module, exports) {
/* tslint:disable:no-unused-expression */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $esiZ2 = parcelRequire("esiZ2");
var $9ab98f817eaa02e6$var$FilterTypes = /** @class */ function() {
    function FilterTypes(filter) {
        this.filter = filter;
    }
    FilterTypes.prototype.transformSchema = function(schema) {
        var _a;
        var _this = this;
        return $esiZ2.visitSchema(schema, (_a = {}, _a[$esiZ2.VisitSchemaKind.TYPE] = function(type) {
            if (_this.filter(type)) return undefined;
            else return null;
        }, _a));
    };
    return FilterTypes;
}();
module.exports.default = $9ab98f817eaa02e6$var$FilterTypes;

});

parcelRegister("kXMIm", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lXoEQ = parcelRequire("lXoEQ");

var $hRrcw = parcelRequire("hRrcw");

var $esiZ2 = parcelRequire("esiZ2");

var $h8S1f = parcelRequire("h8S1f");
var $f42f1b0b8b143d7f$var$TransformRootFields = /** @class */ function() {
    function TransformRootFields(transform) {
        this.transform = transform;
    }
    TransformRootFields.prototype.transformSchema = function(originalSchema) {
        var _a;
        var _this = this;
        return $esiZ2.visitSchema(originalSchema, (_a = {}, _a[$esiZ2.VisitSchemaKind.QUERY] = function(type) {
            return $f42f1b0b8b143d7f$var$transformFields(type, function(fieldName, field) {
                return _this.transform('Query', fieldName, field);
            });
        }, _a[$esiZ2.VisitSchemaKind.MUTATION] = function(type) {
            return $f42f1b0b8b143d7f$var$transformFields(type, function(fieldName, field) {
                return _this.transform('Mutation', fieldName, field);
            });
        }, _a[$esiZ2.VisitSchemaKind.SUBSCRIPTION] = function(type) {
            return $f42f1b0b8b143d7f$var$transformFields(type, function(fieldName, field) {
                return _this.transform('Subscription', fieldName, field);
            });
        }, _a));
    };
    return TransformRootFields;
}();
module.exports.default = $f42f1b0b8b143d7f$var$TransformRootFields;
function $f42f1b0b8b143d7f$var$transformFields(type, transformer) {
    var resolveType = $h8S1f.createResolveType(function(name, originalType) {
        return originalType;
    });
    var fields = type.getFields();
    var newFields = {};
    Object.keys(fields).forEach(function(fieldName) {
        var field = fields[fieldName];
        var newField = transformer(fieldName, field);
        if (typeof newField === 'undefined') newFields[fieldName] = $h8S1f.fieldToFieldConfig(field, resolveType, true);
        else if (newField !== null) {
            if (newField.name) newFields[newField.name] = newField.field;
            else newFields[fieldName] = newField;
        }
    });
    if ($hRrcw.default(newFields)) return null;
    else return new $lXoEQ.GraphQLObjectType({
        name: type.name,
        description: type.description,
        astNode: type.astNode,
        fields: newFields
    });
}

});

parcelRegister("loOHi", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $h8S1f = parcelRequire("h8S1f");

var $kXMIm = parcelRequire("kXMIm");
var $0405365c21702eb7$var$RenameRootFields = /** @class */ function() {
    function RenameRootFields(renamer) {
        var resolveType = $h8S1f.createResolveType(function(name, type) {
            return type;
        });
        this.transformer = new $kXMIm.default(function(operation, fieldName, field) {
            return {
                name: renamer(operation, fieldName, field),
                field: $h8S1f.fieldToFieldConfig(field, resolveType, true)
            };
        });
    }
    RenameRootFields.prototype.transformSchema = function(originalSchema) {
        return this.transformer.transformSchema(originalSchema);
    };
    return RenameRootFields;
}();
module.exports.default = $0405365c21702eb7$var$RenameRootFields;

});

parcelRegister("2PHcZ", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kXMIm = parcelRequire("kXMIm");
var $2101dc7cb7293aa4$var$FilterRootFields = /** @class */ function() {
    function FilterRootFields(filter) {
        this.transformer = new $kXMIm.default(function(operation, fieldName, field) {
            if (filter(operation, fieldName, field)) return undefined;
            else return null;
        });
    }
    FilterRootFields.prototype.transformSchema = function(originalSchema) {
        return this.transformer.transformSchema(originalSchema);
    };
    return FilterRootFields;
}();
module.exports.default = $2101dc7cb7293aa4$var$FilterRootFields;

});

parcelRegister("1t5NR", function(module, exports) {
var $111d00430a4fd662$var$__assign = module.exports && module.exports.__assign || function() {
    $111d00430a4fd662$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $111d00430a4fd662$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $961BR = parcelRequire("961BR");
var $1c4hI = parcelRequire("1c4hI");
var $111d00430a4fd662$var$ExtractField = /** @class */ function() {
    function ExtractField(_a) {
        var from = _a.from, to = _a.to;
        this.from = from;
        this.to = to;
    }
    ExtractField.prototype.transformRequest = function(originalRequest) {
        var _a, _b;
        var fromSelection;
        var ourPathFrom = JSON.stringify(this.from);
        var ourPathTo = JSON.stringify(this.to);
        var fieldPath = [];
        $961BR.visit(originalRequest.document, (_a = {}, _a[$1c4hI.Kind.FIELD] = {
            enter: function(node) {
                fieldPath.push(node.name.value);
                if (ourPathFrom === JSON.stringify(fieldPath)) {
                    fromSelection = node.selectionSet;
                    return $961BR.BREAK;
                }
            },
            leave: function(node) {
                fieldPath.pop();
            }
        }, _a));
        fieldPath = [];
        var newDocument = $961BR.visit(originalRequest.document, (_b = {}, _b[$1c4hI.Kind.FIELD] = {
            enter: function(node) {
                fieldPath.push(node.name.value);
                if (ourPathTo === JSON.stringify(fieldPath) && fromSelection) return $111d00430a4fd662$var$__assign($111d00430a4fd662$var$__assign({}, node), {
                    selectionSet: fromSelection
                });
            },
            leave: function(node) {
                fieldPath.pop();
            }
        }, _b));
        return $111d00430a4fd662$var$__assign($111d00430a4fd662$var$__assign({}, originalRequest), {
            document: newDocument
        });
    };
    return ExtractField;
}();
module.exports.default = $111d00430a4fd662$var$ExtractField;

});

parcelRegister("6rbaH", function(module, exports) {
var $4afdee23e45449aa$var$__assign = module.exports && module.exports.__assign || function() {
    $4afdee23e45449aa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4afdee23e45449aa$var$__assign.apply(this, arguments);
};
var $4afdee23e45449aa$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $1c4hI = parcelRequire("1c4hI");
var $961BR = parcelRequire("961BR");
var $4afdee23e45449aa$var$WrapQuery = /** @class */ function() {
    function WrapQuery(path, wrapper, extractor) {
        this.path = path;
        this.wrapper = wrapper;
        this.extractor = extractor;
    }
    WrapQuery.prototype.transformRequest = function(originalRequest) {
        var _a;
        var _this = this;
        var document = originalRequest.document;
        var fieldPath = [];
        var ourPath = JSON.stringify(this.path);
        var newDocument = $961BR.visit(document, (_a = {}, _a[$1c4hI.Kind.FIELD] = {
            enter: function(node) {
                fieldPath.push(node.name.value);
                if (ourPath === JSON.stringify(fieldPath)) {
                    var wrapResult = _this.wrapper(node.selectionSet);
                    // Selection can be either a single selection or a selection set. If it's just one selection,
                    // let's wrap it in a selection set. Otherwise, keep it as is.
                    var selectionSet = wrapResult.kind === $1c4hI.Kind.SELECTION_SET ? wrapResult : {
                        kind: $1c4hI.Kind.SELECTION_SET,
                        selections: [
                            wrapResult
                        ]
                    };
                    return $4afdee23e45449aa$var$__assign($4afdee23e45449aa$var$__assign({}, node), {
                        selectionSet: selectionSet
                    });
                }
            },
            leave: function(node) {
                fieldPath.pop();
            }
        }, _a));
        return $4afdee23e45449aa$var$__assign($4afdee23e45449aa$var$__assign({}, originalRequest), {
            document: newDocument
        });
    };
    WrapQuery.prototype.transformResult = function(originalResult) {
        var rootData = originalResult.data;
        if (rootData) {
            var data = rootData;
            var path = $4afdee23e45449aa$var$__spreadArrays(this.path);
            while(path.length > 1){
                var next = path.shift();
                if (data[next]) data = data[next];
            }
            data[path[0]] = this.extractor(data[path[0]]);
        }
        return {
            data: rootData,
            errors: originalResult.errors
        };
    };
    return WrapQuery;
}();
module.exports.default = $4afdee23e45449aa$var$WrapQuery;

});





parcelRegister("9rafI", function(module, exports) {

$parcel$export(module.exports, "getCustomResolversFetch", () => $ecaa18f4df472130$export$18b0a4b86a372cdb);
class $ecaa18f4df472130$export$26e841bcf1aeb894 extends Error {
    constructor(response, resBody){
        super(`[FetchError] Request failed with status ${response.status} and statusMessage=${response.statusText}`);
        this.status = response.status;
        this.response = response;
        this.responseBody = resBody;
        this.name = this.constructor.name;
    }
}
function $ecaa18f4df472130$var$removeEmptyProp(obj) {
    const result = {
        ...obj
    };
    Object.entries(result).forEach(([key, val])=>{
        if (val === undefined || val === null) // @ts-ignore (TS7053)
        delete result[key];
    });
    return result;
}
// In docs of fetch API, https://developer.mozilla.org/en/docs/Web/API/Fetch_API,
// fetch just throw error for network error, it does not throw error for server error like 400,...
async function $ecaa18f4df472130$var$handleFetchCommonResponse(res) {
    if (!res.ok) {
        let resBody;
        try {
            resBody = await res.json();
        } catch (e) {
        // ignore parsing body error
        }
        throw new $ecaa18f4df472130$export$26e841bcf1aeb894(res, resBody);
    }
    return res;
}
const $ecaa18f4df472130$export$18b0a4b86a372cdb = ({ fetch: fetch, statusCodeHandlers: statusCodeHandlers = {} })=>(url, fetchOptions = {})=>{
        const headers = {
            'Content-Type': 'application/json',
            ...fetchOptions.headers
        };
        return fetch(url, {
            credentials: 'include',
            ...fetchOptions,
            headers: $ecaa18f4df472130$var$removeEmptyProp(headers)
        }).then((response)=>{
            const { status: status } = response;
            const handler = statusCodeHandlers[status];
            if (typeof handler === 'function') handler(response);
            return response;
        }).then($ecaa18f4df472130$var$handleFetchCommonResponse);
    };

});

parcelRegister("2fzHI", function(module, exports) {

$parcel$export(module.exports, "isCustomQuery", () => $e7371a3132f5fe12$export$e722a3789f7fabfb);

var $faVZP = parcelRequire("faVZP");
const $e7371a3132f5fe12$var$isDefinitionObjectHasDirective = (def, directiveName)=>{
    if (!def) return false;
    for (const node of def){
        const { operation: type, directives: directives } = node;
        if (type === 'query' || type === 'mutation') return directives && directives.some((directive)=>directive.name.value === directiveName);
    }
};
const $e7371a3132f5fe12$var$isQueryContainDirective = (opt, directiveName)=>{
    const globalDef = opt.query && opt.query.definitions;
    const childDef = opt.query && // @ts-ignore (TS7053)
    opt.query[opt.operationName] && // @ts-ignore (TS7053)
    opt.query[opt.operationName].definitions;
    return !!($e7371a3132f5fe12$var$isDefinitionObjectHasDirective(globalDef, directiveName) || $e7371a3132f5fe12$var$isDefinitionObjectHasDirective(childDef, directiveName));
};
const $e7371a3132f5fe12$export$e722a3789f7fabfb = (opt)=>{
    return $e7371a3132f5fe12$var$isQueryContainDirective(opt, (0, $faVZP.Directives).CUSTOM);
};

});
parcelRegister("faVZP", function(module, exports) {

$parcel$export(module.exports, "Directives", () => $7d8045d4bd8f732b$export$129646a0e1af8d85);
$parcel$export(module.exports, "CustomDirective", () => $7d8045d4bd8f732b$export$97a7ea7443254e53);

var $5hGV7 = parcelRequire("5hGV7");
var $bOniD = parcelRequire("bOniD");
var $7d8045d4bd8f732b$export$129646a0e1af8d85;
(function(Directives) {
    Directives["CUSTOM"] = "custom";
})($7d8045d4bd8f732b$export$129646a0e1af8d85 || ($7d8045d4bd8f732b$export$129646a0e1af8d85 = {}));
const $7d8045d4bd8f732b$export$97a7ea7443254e53 = new (0, $bOniD.GraphQLDirective)({
    name: "custom",
    locations: [
        (0, $5hGV7.DirectiveLocation).QUERY,
        (0, $5hGV7.DirectiveLocation).MUTATION
    ]
});

});


parcelRegister("kc4ri", function(module, exports) {

$parcel$export(module.exports, "createDirectoryHttpLink", () => $c62c18ac2fce61ec$export$bacc55ff336c5f9d);
/*
 * Apollo link that does the fetching
 * Docs: https://www.apollographql.com/docs/link/links/http.html
 */ 
var $35Kb7 = parcelRequire("35Kb7");
const $c62c18ac2fce61ec$export$bacc55ff336c5f9d = ({ url: url, getCloudId: getCloudId })=>{
    const customFetch = async (uri, options)=>{
        const body = JSON.parse(options.body);
        const uriWithOps = body.operationName ? `${uri}?q=${body.operationName}` : uri;
        if (body.variables && body.variables._withCloudId && getCloudId) {
            delete body.variables._withCloudId;
            body.variables.cloudId = getCloudId();
            options.body = JSON.stringify(body);
        }
        return fetch(uriWithOps, options);
    };
    return new (0, $35Kb7.HttpLink)({
        uri: url,
        credentials: 'include',
        fetch: customFetch
    });
};

});
parcelRegister("35Kb7", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $2405a8c9bbd1579c$export$f4bbf1aec241cc1);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $cp9eN = parcelRequire("cp9eN");
var $2405a8c9bbd1579c$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $fKE23.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $cp9eN.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $bvQX6.ApolloLink)(function(operation) {
        var chosenURI = (0, $cp9eN.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $fKE23.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $cp9eN.selectHttpOptionsAndBody)(operation, (0, $cp9eN.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $cp9eN.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $bvQX6.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $cp9eN.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $bvQX6.fromError)(parseError);
        }
        return new (0, $5ECju.default)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $cp9eN.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $cp9eN.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $cp9eN.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $2405a8c9bbd1579c$export$f4bbf1aec241cc1 = function(_super) {
    (0, $fKE23.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $2405a8c9bbd1579c$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $bvQX6.ApolloLink));

});
parcelRegister("cp9eN", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $907efc3a22e8ac51$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $907efc3a22e8ac51$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $907efc3a22e8ac51$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $907efc3a22e8ac51$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $907efc3a22e8ac51$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $907efc3a22e8ac51$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $907efc3a22e8ac51$export$63ccc2571850f81a);

var $fKE23 = parcelRequire("fKE23");

var $aKlnM = parcelRequire("aKlnM");

var $8j2fP = parcelRequire("8j2fP");
var $907efc3a22e8ac51$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $907efc3a22e8ac51$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $907efc3a22e8ac51$var$defaultOptions = {
    method: 'POST'
};
var $907efc3a22e8ac51$export$dd86f00dc866e75d = {
    http: $907efc3a22e8ac51$var$defaultHttpOptions,
    headers: $907efc3a22e8ac51$var$defaultHeaders,
    options: $907efc3a22e8ac51$var$defaultOptions
};
var $907efc3a22e8ac51$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $907efc3a22e8ac51$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $907efc3a22e8ac51$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $8j2fP.InvariantError)(1);
    }
};
var $907efc3a22e8ac51$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $907efc3a22e8ac51$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $fKE23.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $fKE23.__assign)({}, options, config.options, {
            headers: (0, $fKE23.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $fKE23.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $aKlnM.print)(query);
    return {
        options: options,
        body: body
    };
};
var $907efc3a22e8ac51$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $8j2fP.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $907efc3a22e8ac51$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});



parcelRegister("dc8YU", function(module, exports) {

$parcel$export(module.exports, "createErrorLink", () => $e1b63d7cef8a14b5$export$d0106730d0f8f3b5);
/*
 * Apollo Link for additional requests error handling
 * Docs: https://www.apollographql.com/docs/link/links/error.html
 */ 
var $aqG9W = parcelRequire("aqG9W");

var $7a5mw = parcelRequire("7a5mw");
const $e1b63d7cef8a14b5$export$d0106730d0f8f3b5 = ({ statusCodeHandlers: statusCodeHandlers })=>(0, $aqG9W.onError)((errorResponse)=>{
        const networkError = errorResponse.networkError;
        const graphQLErrors = errorResponse.graphQLErrors;
        if (graphQLErrors) // Our existing GraphQLError has its own type, and graphql one is not exposing the type information correctly
        // So in here we gonna go with `any` type for now
        // eslint-disable-next-line no-console
        console.error((0, $7a5mw.GraphQLError).from(errorResponse.graphQLErrors));
        if (networkError) {
            const statusCode = networkError.statusCode;
            const handler = statusCodeHandlers[statusCode];
            if (typeof handler === 'function') {
                /**
				 * these functions are expecting a Response object, which is not present here.
				 * It appears statusCodeHandlers are never passed to createErrorLink, so we should investigate removal
				 */ // @ts-ignore
                handler();
                return;
            }
        }
    });

});
parcelRegister("aqG9W", function(module, exports) {

$parcel$export(module.exports, "onError", () => $797d090cd04ee84b$export$2288787135a8f66e);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");
function $797d090cd04ee84b$export$2288787135a8f66e(errorHandler) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        return new (0, $5ECju.default)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $797d090cd04ee84b$export$d2c8415987899609 = function(_super) {
    (0, $fKE23.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $797d090cd04ee84b$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("7a5mw", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $8b8d4bdb5078c4ba$export$92d6ed0888e7cb7f);
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $8b8d4bdb5078c4ba$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message;
        this.stack = new Error(message).stack || '';
    }
}
class $8b8d4bdb5078c4ba$export$c73ca302efeda3b4 extends $8b8d4bdb5078c4ba$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $8b8d4bdb5078c4ba$export$c73ca302efeda3b4.prototype);
    }
}
class $8b8d4bdb5078c4ba$export$20de9a0e470e95aa extends $8b8d4bdb5078c4ba$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $8b8d4bdb5078c4ba$export$20de9a0e470e95aa.prototype);
    }
}
class $8b8d4bdb5078c4ba$export$65bd6083489bd8bb extends $8b8d4bdb5078c4ba$var$CommonError {
    constructor({ message: message, status: status }){
        super(message);
        Object.setPrototypeOf(this, $8b8d4bdb5078c4ba$export$65bd6083489bd8bb.prototype);
        this.status = status;
    }
}
class $8b8d4bdb5078c4ba$export$92d6ed0888e7cb7f extends $8b8d4bdb5078c4ba$var$CommonError {
    constructor({ message: message = 'unknown', category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $8b8d4bdb5078c4ba$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $8b8d4bdb5078c4ba$export$92d6ed0888e7cb7f(errorData);
        };
    }
}

});


parcelRegister("IBBFX", function(module, exports) {

$parcel$export(module.exports, "createRetryLink", () => $b7cd4a766e7d180f$export$91ceafe7c6f4a732);
/*
 * Apollo Link to make sure our requests have re-try functionality in case of request failure
 * Docs: https://www.apollographql.com/docs/link/links/retry.html
 */ 
var $kcwGc = parcelRequire("kcwGc");
const $b7cd4a766e7d180f$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $b7cd4a766e7d180f$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
const $b7cd4a766e7d180f$export$91ceafe7c6f4a732 = (retryOptions)=>new (0, $kcwGc.RetryLink)({
        delay: {
            initial: $b7cd4a766e7d180f$export$8f4286bf21155381.INITIAL_DELAY,
            max: Infinity,
            jitter: $b7cd4a766e7d180f$export$8f4286bf21155381.JITTER,
            ...retryOptions.delay
        },
        attempts: {
            max: $b7cd4a766e7d180f$export$8f4286bf21155381.MAX_RETRIES,
            retryIf: (error, operation)=>{
                const context = operation.getContext();
                const response = context.response;
                const noRetry = context.noRetry;
                return $b7cd4a766e7d180f$export$55b2fbd5d4a32495(response && response.status) && !noRetry;
            },
            ...retryOptions.attempts
        }
    });

});
parcelRegister("kcwGc", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $eb4e47225b0a9c93$export$943d544ad120494a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");
function $eb4e47225b0a9c93$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $eb4e47225b0a9c93$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $eb4e47225b0a9c93$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $fKE23.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $eb4e47225b0a9c93$export$943d544ad120494a = function(_super) {
    (0, $fKE23.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $eb4e47225b0a9c93$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $eb4e47225b0a9c93$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $eb4e47225b0a9c93$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $5ECju.default)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $bvQX6.ApolloLink));

});


parcelRegister("aF0EL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9958bdb038f54fc$export$2e2bcd8739ae039);
// queries

var $gtDgu = parcelRequire("gtDgu");

var $a2KjS = parcelRequire("a2KjS");

var $kb4lE = parcelRequire("kb4lE");

var $hpxt4 = parcelRequire("hpxt4");

var $6Qg8I = parcelRequire("6Qg8I");

var $fHNXj = parcelRequire("fHNXj");

var $7yX2V = parcelRequire("7yX2V");

var $ftcMs = parcelRequire("ftcMs");

var $lOzcg = parcelRequire("lOzcg");

var $8r1hQ = parcelRequire("8r1hQ");

var $2QHLp = parcelRequire("2QHLp");

var $b4OYd = parcelRequire("b4OYd");

var $5Xb3F = parcelRequire("5Xb3F");

var $1JiO5 = parcelRequire("1JiO5");

var $nZOkC = parcelRequire("nZOkC");

var $9p4em = parcelRequire("9p4em");
// mutations
const $a9958bdb038f54fc$var$resolvers = {
    Query: {
        User: $2QHLp.default,
        MyAvatar: $hpxt4.default,
        UserOrganization: $9p4em.default,
        UserManageConfig: $b4OYd.default,
        UserManagePrivacySettings: $1JiO5.default,
        UserManageLinkedAccounts: $5Xb3F.default,
        UserManagePrivacySettingsAllowed: $nZOkC.default,
        TeamInSlack: $6Qg8I.default,
        Containers: $gtDgu.default,
        TeamLinkIcons: $fHNXj.default
    },
    Mutation: {
        updateUser: $ftcMs.default,
        deleteUserAvatar: $a2KjS.default,
        updateUserAvatar: $lOzcg.default,
        updateUserPrivacySettings: $8r1hQ.default,
        updateTeamInSlack: $7yX2V.default,
        disconnectTeamInSlack: $kb4lE.default
    }
};
var $a9958bdb038f54fc$export$2e2bcd8739ae039 = $a9958bdb038f54fc$var$resolvers;

});
parcelRegister("gtDgu", function(module, exports) {

$parcel$export(module.exports, "default", () => $72318d20def4b021$export$2e2bcd8739ae039);
const $72318d20def4b021$var$Containers = async (_, args, context, info)=>{
    const { userId: userId, maxNumberOfResults: maxNumberOfResults, principalId: principalId, siteId: siteId, sessionId: sessionId } = args;
    return await context.fetch(`${context.url.collaborationGraph}/v1/collaborationgraph/user/container`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            context: {
                contextType: 'atlassianDirectory',
                principalId: principalId,
                siteId: siteId,
                sessionId: sessionId
            },
            containerTypes: [
                'confluenceSpace',
                'jiraProject'
            ],
            maxNumberOfResults: maxNumberOfResults,
            userId: userId,
            expanded: true
        })
    }).then((res)=>{
        // Matches type of QueryData['Containers'] in
        // packages/embeddable-directory/src/components/CGContainers/ContainersQuery.tsx
        return res.json();
    });
};
var $72318d20def4b021$export$2e2bcd8739ae039 = $72318d20def4b021$var$Containers;

});

parcelRegister("a2KjS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1177cd2879ccae9b$export$2e2bcd8739ae039);
const $1177cd2879ccae9b$var$deleteUserAvatar = async (_, args, context)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
    return context.fetch(url, {
        method: 'DELETE'
    }).then(()=>true);
};
var $1177cd2879ccae9b$export$2e2bcd8739ae039 = $1177cd2879ccae9b$var$deleteUserAvatar;

});

parcelRegister("kb4lE", function(module, exports) {

$parcel$export(module.exports, "default", () => $24c541ba469c7e24$export$2e2bcd8739ae039);
const $24c541ba469c7e24$var$disconnectTeamInSlack = async (_, args, context)=>{
    const { teamId: teamId } = args;
    const url = `${context.url.stargateRoot}/teamsslack/api/team/${teamId}`;
    return context.fetch(url, {
        method: 'DELETE'
    }).then((data)=>data.json()).then((data)=>({
            id: teamId,
            ...data
        }));
};
var $24c541ba469c7e24$export$2e2bcd8739ae039 = $24c541ba469c7e24$var$disconnectTeamInSlack;

});

parcelRegister("hpxt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $30feb055f36caac4$export$2e2bcd8739ae039);
const $30feb055f36caac4$var$myAvatar = async (root, args, context)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
    return context.fetch(url).then((data)=>data.json());
};
var $30feb055f36caac4$export$2e2bcd8739ae039 = $30feb055f36caac4$var$myAvatar;

});

parcelRegister("6Qg8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe8035ed807b5575$export$2e2bcd8739ae039);
const $fe8035ed807b5575$var$teamInSlack = async (root, args, context)=>{
    const { teamId: teamId, teamName: teamName } = args;
    const url = `${context.url.stargateRoot}/teamsslack/api/team/${teamId}?teamName=${encodeURIComponent(teamName)}`;
    return context.fetch(url).then((data)=>data.json()).then((data)=>({
            id: teamId,
            ...data
        }));
};
var $fe8035ed807b5575$export$2e2bcd8739ae039 = $fe8035ed807b5575$var$teamInSlack;

});

parcelRegister("fHNXj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aef831b14b7f6ef$export$2e2bcd8739ae039);

var $38Hap = parcelRequire("38Hap");
const $8aef831b14b7f6ef$var$TeamLinkIcons = async (_, args, context, info)=>{
    const requestBody = args.teamLinkUrls.map((url)=>({
            resourceUrl: url
        }));
    const options = {
        method: 'POST',
        body: JSON.stringify(requestBody)
    };
    return context.fetch(`${context.url.stargateRoot}/object-resolver/resolve/batch`, options).then((res)=>res.json()).then((0, $38Hap.transformIconData));
};
var $8aef831b14b7f6ef$export$2e2bcd8739ae039 = $8aef831b14b7f6ef$var$TeamLinkIcons;

});
parcelRegister("38Hap", function(module, exports) {

$parcel$export(module.exports, "transformIconData", () => $c2ed405c568dc9b8$export$39f4468adf4cb57c);
/**
 * This type matches the props for the TeamLinkIcon component in embeddable-directory
 */ var $c2ed405c568dc9b8$var$ProviderNames;
/**
 * These names match the Provider Name in the JSON-LD response from respective resolvers
 */ (function(ProviderNames) {
    ProviderNames["CONFLUENCE"] = "Confluence";
    ProviderNames["JIRA"] = "Jira";
})($c2ed405c568dc9b8$var$ProviderNames || ($c2ed405c568dc9b8$var$ProviderNames = {}));
const $c2ed405c568dc9b8$export$c64ca1c808335e8b = (jsonLd)=>{
    const { url: url, generator: { name: name, icon: icon } } = jsonLd;
    switch(name){
        case "Confluence":
            return {
                linkUrl: url,
                iconUrl: $c2ed405c568dc9b8$var$getConfluenceFavicon(url),
                productName: name
            };
        case "Jira":
            return {
                linkUrl: url,
                iconUrl: $c2ed405c568dc9b8$var$getJiraFavicon(url),
                productName: name
            };
        default:
            return {
                linkUrl: url,
                iconUrl: typeof icon === 'object' ? icon['url'] : icon,
                productName: name
            };
    }
};
const $c2ed405c568dc9b8$var$isIconItemSuccess = (response)=>{
    return response.status === 200;
};
const $c2ed405c568dc9b8$export$39f4468adf4cb57c = (batchResp)=>batchResp.filter($c2ed405c568dc9b8$var$isIconItemSuccess).map((resp)=>resp.body.data).map($c2ed405c568dc9b8$export$c64ca1c808335e8b).filter((linkIconData)=>linkIconData.iconUrl !== undefined);
const $c2ed405c568dc9b8$var$getConfluenceFavicon = (url)=>`https://${new URL(url).hostname}/wiki/favicon.ico`;
const $c2ed405c568dc9b8$var$getJiraFavicon = (url)=>`https://${new URL(url).hostname}/favicon.ico`;

});


parcelRegister("7yX2V", function(module, exports) {

$parcel$export(module.exports, "default", () => $528df15cf8bcf4a5$export$2e2bcd8739ae039);
const $528df15cf8bcf4a5$var$updateTeamInSlack = async (_, args, context)=>{
    const { teamId: teamId, channelId: channelId, usergroupHandle: usergroupHandle } = args;
    const url = `${context.url.stargateRoot}/teamsslack/api/team/${teamId}?channel=${channelId}&groupName=${usergroupHandle}`;
    return context.fetch(url, {
        method: 'POST'
    }).then((data)=>data.json()).then((data)=>({
            id: teamId,
            ...data
        }));
};
var $528df15cf8bcf4a5$export$2e2bcd8739ae039 = $528df15cf8bcf4a5$var$updateTeamInSlack;

});

parcelRegister("ftcMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $619d99325a777068$export$2e2bcd8739ae039);

var $ksnu5 = parcelRequire("ksnu5");
const $619d99325a777068$var$updateUser = async (_, args, context, info)=>{
    const { id: id, input: input } = args;
    const url = `${context.url.stargateRoot}/users/${id}/manage/profile`;
    const body = JSON.stringify($ksnu5.toManageAPIInput(input));
    return context.fetch(url, {
        method: 'PATCH',
        body: body
    }).then((data)=>data.json()).then((res)=>$ksnu5.fromManageAPIResponse(res));
};
var $619d99325a777068$export$2e2bcd8739ae039 = $619d99325a777068$var$updateUser;

});
parcelRegister("ksnu5", function(module, exports) {

$parcel$export(module.exports, "fromManageAPIResponse", () => $e0e79894baf9dcb9$export$5299664357e4f3dd);
$parcel$export(module.exports, "toManageAPIInput", () => $e0e79894baf9dcb9$export$7b103107c889cb67);
parcelRequire("6Y9ZA");
var $8db47 = parcelRequire("8db47");
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $e0e79894baf9dcb9$var$PROFILE_PROPS_MAP = new Map([
    [
        'id',
        'account_id'
    ],
    [
        'fullName',
        'name'
    ],
    [
        'nickname',
        'nickname'
    ],
    [
        'timezone',
        'zoneinfo'
    ],
    [
        'locale',
        'locale'
    ],
    [
        'avatarUrl',
        'picture'
    ],
    [
        'email',
        'email'
    ]
]);
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $e0e79894baf9dcb9$var$EXTENDED_PROFILE_PROPS_MAP = new Map([
    [
        'title',
        'job_title'
    ],
    [
        'department',
        'department'
    ],
    [
        'companyName',
        'organization'
    ],
    [
        'location',
        'location'
    ],
    [
        'phoneNumber',
        'phone_number'
    ]
]);
const $e0e79894baf9dcb9$export$5299664357e4f3dd = (res)=>{
    const data = res.account;
    const extendedData = data && data.extended_profile || {};
    if (!data) return null;
    const timeZone = data.zoneinfo;
    const localTime = ({ format: format })=>{
        if (!timeZone) return null;
        try {
            return (0, $8db47.default)(new Date(), timeZone, format);
        } catch (error) {
            // TODO: PTC-4908 send error to sentry for reporting
            return null;
        }
    };
    const profileProps = Array.from($e0e79894baf9dcb9$var$PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($e0e79894baf9dcb9$var$PROFILE_PROPS_MAP.has(key)) acc[key] = data[$e0e79894baf9dcb9$var$PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    const extendedProfileProps = Array.from($e0e79894baf9dcb9$var$EXTENDED_PROFILE_PROPS_MAP.keys()).reduce((acc, key)=>{
        if ($e0e79894baf9dcb9$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) acc[key] = extendedData[$e0e79894baf9dcb9$var$EXTENDED_PROFILE_PROPS_MAP.get(key)];
        return acc;
    }, {});
    return {
        ...profileProps,
        ...extendedProfileProps,
        localTime: localTime
    };
};
const $e0e79894baf9dcb9$export$7b103107c889cb67 = (input)=>{
    const output = {
        extended_profile: {}
    };
    Object.keys(input).forEach((key)=>{
        if ($e0e79894baf9dcb9$var$PROFILE_PROPS_MAP.has(key)) output[$e0e79894baf9dcb9$var$PROFILE_PROPS_MAP.get(key)] = input[key];
        if ($e0e79894baf9dcb9$var$EXTENDED_PROFILE_PROPS_MAP.has(key)) output.extended_profile[$e0e79894baf9dcb9$var$EXTENDED_PROFILE_PROPS_MAP.get(key)] = input[key];
    });
    return output;
};

});
parcelRegister("6Y9ZA", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("8db47")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $8db47 = parcelRequire("8db47");





});
parcelRegister("8db47", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fa81efa1c4ca6aa$export$2e2bcd8739ae039);

var $1WmNj = parcelRequire("1WmNj");

var $bmMNO = parcelRequire("bmMNO");

var $gONQq = parcelRequire("gONQq");
function $5fa81efa1c4ca6aa$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1WmNj)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $bmMNO.default)((0, $gONQq.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("bmMNO", function(module, exports) {

$parcel$export(module.exports, "default", () => $84679af07277c994$export$2e2bcd8739ae039);

var $Yg8hb = parcelRequire("Yg8hb");

var $8EHc3 = parcelRequire("8EHc3");

var $8skeH = parcelRequire("8skeH");
var $84679af07277c994$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $84679af07277c994$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($84679af07277c994$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $8skeH.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $8EHc3.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($Yg8hb)))(dirtyDate, formatStr, options);
}

});
parcelRegister("8EHc3", function(module, exports) {

$parcel$export(module.exports, "default", () => $64d39075a143f763$export$2e2bcd8739ae039);

var $g5dTR = parcelRequire("g5dTR");

var $gAmrF = parcelRequire("gAmrF");
var $64d39075a143f763$var$MILLISECONDS_IN_MINUTE = 60000;
var $64d39075a143f763$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $64d39075a143f763$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $64d39075a143f763$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $64d39075a143f763$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $64d39075a143f763$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $64d39075a143f763$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $64d39075a143f763$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $64d39075a143f763$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $64d39075a143f763$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $64d39075a143f763$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $64d39075a143f763$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $64d39075a143f763$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $g5dTR.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $g5dTR.default)('long', date, options);
        }
    }
};
function $64d39075a143f763$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $gAmrF.default)(timeZone, originalDate, true) / $64d39075a143f763$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $64d39075a143f763$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $64d39075a143f763$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $64d39075a143f763$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $64d39075a143f763$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $64d39075a143f763$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $64d39075a143f763$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $64d39075a143f763$var$formatTimezone(offset, dirtyDelimeter);
}
function $64d39075a143f763$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $64d39075a143f763$var$addLeadingZeros(minutes, 2);
}
var $64d39075a143f763$export$2e2bcd8739ae039 = $64d39075a143f763$var$formatters;

});
parcelRegister("g5dTR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb57e53ae9fd2536$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $bb57e53ae9fd2536$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $bb57e53ae9fd2536$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $bb57e53ae9fd2536$var$partsTimeZone(dtf, date) : $bb57e53ae9fd2536$var$hackyTimeZone(dtf, date);
}
function $bb57e53ae9fd2536$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $bb57e53ae9fd2536$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $bb57e53ae9fd2536$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("gAmrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1316b4e02cb5348$export$2e2bcd8739ae039);

var $2QyCk = parcelRequire("2QyCk");

var $gKnpJ = parcelRequire("gKnpJ");
var $c1316b4e02cb5348$var$MILLISECONDS_IN_HOUR = 3600000;
var $c1316b4e02cb5348$var$MILLISECONDS_IN_MINUTE = 60000;
var $c1316b4e02cb5348$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $c1316b4e02cb5348$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $c1316b4e02cb5348$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $c1316b4e02cb5348$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$c1316b4e02cb5348$var$validateTimezone(hours)) return NaN;
        return -(hours * $c1316b4e02cb5348$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $c1316b4e02cb5348$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$c1316b4e02cb5348$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $c1316b4e02cb5348$var$MILLISECONDS_IN_HOUR + minutes * $c1316b4e02cb5348$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($c1316b4e02cb5348$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $c1316b4e02cb5348$var$toUtcDate(date);
        var offset = $c1316b4e02cb5348$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $c1316b4e02cb5348$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $c1316b4e02cb5348$var$toUtcDate(date) {
    return (0, $gKnpJ.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $c1316b4e02cb5348$var$calcOffset(date, timezoneString) {
    var tokens = (0, $2QyCk.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $gKnpJ.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $c1316b4e02cb5348$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $c1316b4e02cb5348$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $c1316b4e02cb5348$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $c1316b4e02cb5348$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $c1316b4e02cb5348$var$validIANATimezoneCache = {};
function $c1316b4e02cb5348$var$isValidTimezoneIANAString(timeZoneString) {
    if ($c1316b4e02cb5348$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $c1316b4e02cb5348$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("2QyCk", function(module, exports) {

$parcel$export(module.exports, "default", () => $212b4a583181c1a2$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $212b4a583181c1a2$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $212b4a583181c1a2$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $212b4a583181c1a2$var$partsOffset(dtf, date) : $212b4a583181c1a2$var$hackyOffset(dtf, date);
}
var $212b4a583181c1a2$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $212b4a583181c1a2$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $212b4a583181c1a2$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $212b4a583181c1a2$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $212b4a583181c1a2$var$dtfCache = {};
function $212b4a583181c1a2$var$getDateTimeFormat(timeZone) {
    if (!$212b4a583181c1a2$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $212b4a583181c1a2$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $212b4a583181c1a2$var$dtfCache[timeZone];
}

});

parcelRegister("gKnpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3131abe4c6832f7$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $c3131abe4c6832f7$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("8skeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6280a2b303703ea0$export$2e2bcd8739ae039);

var $4Zzm9 = parcelRequire("4Zzm9");

var $YdpzT = parcelRequire("YdpzT");

var $gAmrF = parcelRequire("gAmrF");

var $dmkNl = parcelRequire("dmkNl");
var $6280a2b303703ea0$var$MILLISECONDS_IN_HOUR = 3600000;
var $6280a2b303703ea0$var$MILLISECONDS_IN_MINUTE = 60000;
var $6280a2b303703ea0$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $6280a2b303703ea0$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $dmkNl.default)
};
function $6280a2b303703ea0$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $6280a2b303703ea0$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($4Zzm9)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $6280a2b303703ea0$var$splitDateString(argument);
    var parseYearResult = $6280a2b303703ea0$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $6280a2b303703ea0$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $6280a2b303703ea0$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $gAmrF.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($YdpzT)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($YdpzT)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $6280a2b303703ea0$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $6280a2b303703ea0$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $6280a2b303703ea0$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $6280a2b303703ea0$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $6280a2b303703ea0$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $6280a2b303703ea0$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $6280a2b303703ea0$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $6280a2b303703ea0$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $6280a2b303703ea0$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $6280a2b303703ea0$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $6280a2b303703ea0$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$6280a2b303703ea0$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $6280a2b303703ea0$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$6280a2b303703ea0$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $6280a2b303703ea0$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$6280a2b303703ea0$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $6280a2b303703ea0$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$6280a2b303703ea0$var$validateWeekDate(year, week)) return new Date(NaN);
        return $6280a2b303703ea0$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $6280a2b303703ea0$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$6280a2b303703ea0$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $6280a2b303703ea0$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $6280a2b303703ea0$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $6280a2b303703ea0$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$6280a2b303703ea0$var$validateTime(hours)) return NaN;
        return hours % 24 * $6280a2b303703ea0$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $6280a2b303703ea0$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$6280a2b303703ea0$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $6280a2b303703ea0$var$MILLISECONDS_IN_HOUR + minutes * $6280a2b303703ea0$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $6280a2b303703ea0$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$6280a2b303703ea0$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $6280a2b303703ea0$var$MILLISECONDS_IN_HOUR + minutes * $6280a2b303703ea0$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $6280a2b303703ea0$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $6280a2b303703ea0$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $6280a2b303703ea0$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $6280a2b303703ea0$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $6280a2b303703ea0$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $6280a2b303703ea0$var$isLeapYearIndex(year);
        if (isLeapYear && date > $6280a2b303703ea0$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $6280a2b303703ea0$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $6280a2b303703ea0$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $6280a2b303703ea0$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $6280a2b303703ea0$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $6280a2b303703ea0$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("dmkNl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b9d75d8b5656164$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $9b9d75d8b5656164$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $9b9d75d8b5656164$export$2e2bcd8739ae039 = $9b9d75d8b5656164$var$tzPattern;

});



parcelRegister("gONQq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3e7faf876a592b4$export$2e2bcd8739ae039);

var $gAmrF = parcelRequire("gAmrF");

var $8skeH = parcelRequire("8skeH");
function $c3e7faf876a592b4$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $8skeH.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $gAmrF.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});





parcelRegister("lOzcg", function(module, exports) {

$parcel$export(module.exports, "default", () => $a68acc39fe2e5cfc$export$2e2bcd8739ae039);

var $9j18L = parcelRequire("9j18L");
const $a68acc39fe2e5cfc$var$updateUserAvatar = async (_, args, context)=>{
    const { userId: userId, fileURI: fileURI } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
    const fileObject = (0, $9j18L.dataURItoFile)(fileURI);
    const formData = new FormData();
    formData.append('file', fileObject);
    const fetchOptions = {
        method: 'PUT',
        body: formData,
        headers: {
            'Content-Type': undefined
        }
    };
    return context// @ts-ignore: we want to not pass 'Content-Type' header explicitly
    .fetch(url, fetchOptions)// Although current API in id-public-api-facade does not return new uploaded avatar,
    // we still want to have it in client-side
    .then(()=>({
            url: fileURI
        }));
};
var $a68acc39fe2e5cfc$export$2e2bcd8739ae039 = $a68acc39fe2e5cfc$var$updateUserAvatar;

});
parcelRegister("9j18L", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $3e0626c6f1dbcda6$export$80d19edb7b1ae293);
function $3e0626c6f1dbcda6$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const byteString = dataURI.split(',')[0].includes('base64') ? atob(dataURI.split(',')[1]) : decodeURIComponent(dataURI.split(',')[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        mimeString = 'unknown';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 and Safari does not support the File constructor.
        return blob;
    }
}

});


parcelRegister("8r1hQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15dfeed0d83cf95$export$2e2bcd8739ae039);

var $bH1Tn = parcelRequire("bH1Tn");
const $e15dfeed0d83cf95$var$updateUserPrivacySettings = async (_, args, context, info)=>{
    const { id: id, input: input } = args;
    const url = `${context.url.stargateRoot}/users/${id}/manage/privacy-settings`;
    const body = JSON.stringify((0, $bH1Tn.transformPrivacySettingsFormatFromSchemaToApi)(input));
    return context.fetch(url, {
        method: 'PATCH',
        body: body
    }).then((data)=>data.json()).then((data)=>(0, $bH1Tn.transformPrivacySettingsFormatFromApiToSchema)(data)).then((data)=>({
            ...data,
            id: id
        }));
};
var $e15dfeed0d83cf95$export$2e2bcd8739ae039 = $e15dfeed0d83cf95$var$updateUserPrivacySettings;

});
parcelRegister("bH1Tn", function(module, exports) {

$parcel$export(module.exports, "PRIVACY_SETTINGS_SCHEMA_TO_API_MAP", () => $4a3cb05849ec1dea$export$4154b9b275895abf);
$parcel$export(module.exports, "transformPrivacySettingsFormatFromApiToSchema", () => $4a3cb05849ec1dea$export$bfc3808f21c9d49d);
$parcel$export(module.exports, "transformPrivacySettingsFormatFromSchemaToApi", () => $4a3cb05849ec1dea$export$f5a6643bba95b2d0);

var $98tnj = parcelRequire("98tnj");
const $4a3cb05849ec1dea$var$manageUserPrivacySettingsKeys = [
    'name',
    'nickname',
    'zoneinfo',
    'picture',
    'email',
    'phoneNumber',
    'jobTitle',
    'organization',
    'department',
    'location'
];
const $4a3cb05849ec1dea$var$schemaKeys = {
    name: 'name',
    nickname: 'nickname',
    zoneinfo: 'zoneinfo',
    picture: 'picture',
    email: 'email',
    phoneNumber: 'phoneNumber',
    jobTitle: 'jobTitle',
    organization: 'organization',
    department: 'department',
    location: 'location'
};
const $4a3cb05849ec1dea$var$apiKeys = {
    name: 'name',
    nickname: 'nickname',
    zoneinfo: 'zoneinfo',
    picture: 'picture',
    email: 'email',
    phoneNumber: 'extended_profile.phone_number',
    jobTitle: 'extended_profile.job_title',
    organization: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $4a3cb05849ec1dea$export$4154b9b275895abf = {
    [$4a3cb05849ec1dea$var$schemaKeys.name]: $4a3cb05849ec1dea$var$apiKeys.name,
    [$4a3cb05849ec1dea$var$schemaKeys.nickname]: $4a3cb05849ec1dea$var$apiKeys.nickname,
    [$4a3cb05849ec1dea$var$schemaKeys.zoneinfo]: $4a3cb05849ec1dea$var$apiKeys.zoneinfo,
    [$4a3cb05849ec1dea$var$schemaKeys.picture]: $4a3cb05849ec1dea$var$apiKeys.picture,
    [$4a3cb05849ec1dea$var$schemaKeys.email]: $4a3cb05849ec1dea$var$apiKeys.email,
    [$4a3cb05849ec1dea$var$schemaKeys.phoneNumber]: $4a3cb05849ec1dea$var$apiKeys.phoneNumber,
    // extended profile
    [$4a3cb05849ec1dea$var$schemaKeys.jobTitle]: $4a3cb05849ec1dea$var$apiKeys.jobTitle,
    [$4a3cb05849ec1dea$var$schemaKeys.organization]: $4a3cb05849ec1dea$var$apiKeys.organization,
    [$4a3cb05849ec1dea$var$schemaKeys.department]: $4a3cb05849ec1dea$var$apiKeys.department,
    [$4a3cb05849ec1dea$var$schemaKeys.location]: $4a3cb05849ec1dea$var$apiKeys.location
};
const $4a3cb05849ec1dea$export$bfc3808f21c9d49d = (data)=>Object.keys($4a3cb05849ec1dea$export$4154b9b275895abf).reduce((memo, schemaValue)=>{
        const apiResponseKey = $4a3cb05849ec1dea$export$4154b9b275895abf[schemaValue];
        const privacySetting = data[apiResponseKey];
        memo[schemaValue] = (0, $98tnj.toUpperCase)(privacySetting);
        return memo;
    }, {});
const $4a3cb05849ec1dea$export$64774399daaaf8ff = {
    [$4a3cb05849ec1dea$var$apiKeys.name]: $4a3cb05849ec1dea$var$schemaKeys.name,
    [$4a3cb05849ec1dea$var$apiKeys.nickname]: $4a3cb05849ec1dea$var$schemaKeys.nickname,
    [$4a3cb05849ec1dea$var$apiKeys.zoneinfo]: $4a3cb05849ec1dea$var$schemaKeys.zoneinfo,
    [$4a3cb05849ec1dea$var$apiKeys.picture]: $4a3cb05849ec1dea$var$schemaKeys.picture,
    [$4a3cb05849ec1dea$var$apiKeys.email]: $4a3cb05849ec1dea$var$schemaKeys.email,
    [$4a3cb05849ec1dea$var$apiKeys.phoneNumber]: $4a3cb05849ec1dea$var$schemaKeys.phoneNumber,
    // extended profile
    [$4a3cb05849ec1dea$var$apiKeys.jobTitle]: $4a3cb05849ec1dea$var$schemaKeys.jobTitle,
    [$4a3cb05849ec1dea$var$apiKeys.organization]: $4a3cb05849ec1dea$var$schemaKeys.organization,
    [$4a3cb05849ec1dea$var$apiKeys.department]: $4a3cb05849ec1dea$var$schemaKeys.department,
    [$4a3cb05849ec1dea$var$apiKeys.location]: $4a3cb05849ec1dea$var$schemaKeys.location
};
const $4a3cb05849ec1dea$export$f5a6643bba95b2d0 = (data)=>Object.keys($4a3cb05849ec1dea$export$64774399daaaf8ff).reduce((memo, apiValue)=>{
        const apiResponseKey = $4a3cb05849ec1dea$export$64774399daaaf8ff[apiValue];
        const privacySetting = data[apiResponseKey];
        if (privacySetting) memo[apiValue] = privacySetting.toLowerCase();
        return memo;
    }, {});

});
parcelRegister("98tnj", function(module, exports) {

$parcel$export(module.exports, "toUpperCase", () => $7c7442d98f50f4dd$export$d80c591a9e16646);
const $7c7442d98f50f4dd$export$d80c591a9e16646 = (input)=>{
    if (typeof input === 'string') return input.toUpperCase();
    return null;
};

});



parcelRegister("2QHLp", function(module, exports) {

$parcel$export(module.exports, "default", () => $42e6c4959e7ee502$export$2e2bcd8739ae039);
// https://developer.atlassian.com/cloud/admin/user-management/rest/#api-users-account-id-manage-profile-get

var $ksnu5 = parcelRequire("ksnu5");
const $42e6c4959e7ee502$var$User = async (_, args, context, info)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/profile`;
    return context.fetch(url).then((data)=>data.json()).then((res)=>$ksnu5.fromManageAPIResponse(res));
};
var $42e6c4959e7ee502$export$2e2bcd8739ae039 = $42e6c4959e7ee502$var$User;

});

parcelRegister("b4OYd", function(module, exports) {

$parcel$export(module.exports, "default", () => $04693d6a16f65a74$export$2e2bcd8739ae039);
// https://developer.atlassian.com/cloud/admin/user-management/rest/#api-users-account-id-manage-profile-get

var $cI9hn = parcelRequire("cI9hn");
const $04693d6a16f65a74$var$UserManageConfig = async (_, args, context)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage`;
    return context.fetch(url).then((data)=>data.json()).then((data)=>(0, $cI9hn.transformUserManageConfig)(data));
};
var $04693d6a16f65a74$export$2e2bcd8739ae039 = $04693d6a16f65a74$var$UserManageConfig;

});
parcelRegister("cI9hn", function(module, exports) {

$parcel$export(module.exports, "transformUserManageConfig", () => $28c546e4b7c9451c$export$d7725d3d27b80a68);
const $28c546e4b7c9451c$var$MUTABILITY_DETAILS_MAP = {
    fullName: 'name',
    nickname: 'nickname',
    timezone: 'zoneinfo',
    locale: 'locale',
    email: 'email',
    // extended profile
    title: 'extended_profile.job_title',
    phoneNumber: 'extended_profile.phone_number',
    companyName: 'extended_profile.organization',
    department: 'extended_profile.department',
    location: 'extended_profile.location'
};
const $28c546e4b7c9451c$var$CUSTOM_FIELD_PLACE = {
    email: 'email.initiateChange',
    picture: 'avatar'
};
const $28c546e4b7c9451c$var$getFieldConfig = (data, field)=>{
    if ((field === 'email' || field === 'picture') && $28c546e4b7c9451c$var$CUSTOM_FIELD_PLACE[field]) return data[$28c546e4b7c9451c$var$CUSTOM_FIELD_PLACE[field]];
    const mappedFieldKey = $28c546e4b7c9451c$var$MUTABILITY_DETAILS_MAP[field];
    // @ts-ignore
    return data['profile.write'][mappedFieldKey];
};
const $28c546e4b7c9451c$var$getMutabilityConstraintFor = (data, field)=>{
    const fieldConfig = $28c546e4b7c9451c$var$getFieldConfig(data, field);
    if (!fieldConfig || fieldConfig.allowed) return null;
    const reason = fieldConfig.reason;
    return {
        field: field,
        reason: reason && reason.key || null
    };
};
const $28c546e4b7c9451c$export$d7725d3d27b80a68 = (data)=>({
        mutabilityConstraints: Object.keys($28c546e4b7c9451c$var$MUTABILITY_DETAILS_MAP)// @ts-ignore
        .map((field)=>$28c546e4b7c9451c$var$getMutabilityConstraintFor(data, field)).filter((truthy)=>truthy)
    });

});


parcelRegister("5Xb3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e7094f361c129dd$export$2e2bcd8739ae039);
const $5e7094f361c129dd$var$UserManageLinkedAccounts = (_, args, context, info)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/linked-accounts`;
    return context.fetch(url).then((res)=>res.json()).then((data)=>{
        return {
            google: Boolean(data && data.google && data.google.linked),
            microsoft: Boolean(data && data.microsoft && data.microsoft.linked),
            apple: Boolean(data && data.apple && data.apple.linked),
            saml: Boolean(data && data.saml && data.saml.linked)
        };
    });
};
var $5e7094f361c129dd$export$2e2bcd8739ae039 = $5e7094f361c129dd$var$UserManageLinkedAccounts;

});

parcelRegister("1JiO5", function(module, exports) {

$parcel$export(module.exports, "default", () => $46faeceb3386542d$export$2e2bcd8739ae039);

var $bH1Tn = parcelRequire("bH1Tn");
const $46faeceb3386542d$var$UserManagePrivacySettings = async (_, args, context, info)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/privacy-settings`;
    return context.fetch(url).then((data)=>data.json()).then((data)=>(0, $bH1Tn.transformPrivacySettingsFormatFromApiToSchema)(data)).then((data)=>({
            ...data,
            id: userId
        }));
};
var $46faeceb3386542d$export$2e2bcd8739ae039 = $46faeceb3386542d$var$UserManagePrivacySettings;

});

parcelRegister("nZOkC", function(module, exports) {

$parcel$export(module.exports, "default", () => $710823b41f059521$export$2e2bcd8739ae039);

var $6TMC6 = parcelRequire("6TMC6");
const $710823b41f059521$var$UserManagePrivacySettingsAllowed = async (_, args, context, info)=>{
    const { userId: userId } = args;
    const url = `${context.url.stargateRoot}/users/${userId}/manage/privacy-settings/allowed`;
    return context.fetch(url).then((data)=>data.json()).then((data)=>(0, $6TMC6.transformUserManagePrivacySettingsAllowed)(data));
};
var $710823b41f059521$export$2e2bcd8739ae039 = $710823b41f059521$var$UserManagePrivacySettingsAllowed;

});
parcelRegister("6TMC6", function(module, exports) {

$parcel$export(module.exports, "transformUserManagePrivacySettingsAllowed", () => $3f74b8bf27517af7$export$3f9c63641eb8459e);

var $98tnj = parcelRequire("98tnj");

var $bH1Tn = parcelRequire("bH1Tn");
const $3f74b8bf27517af7$var$getAllowedPrivacySettingsFor = (data, schemaValue)=>{
    const apiResponseKey = (0, $bH1Tn.PRIVACY_SETTINGS_SCHEMA_TO_API_MAP)[schemaValue];
    const allowedPrivacySettings = data[apiResponseKey];
    if (!allowedPrivacySettings || !allowedPrivacySettings.length) return null;
    return allowedPrivacySettings.map((0, $98tnj.toUpperCase));
};
const $3f74b8bf27517af7$export$3f9c63641eb8459e = (data)=>Object.keys((0, $bH1Tn.PRIVACY_SETTINGS_SCHEMA_TO_API_MAP)).reduce((memo, schemaValue)=>{
        memo[schemaValue] = $3f74b8bf27517af7$var$getAllowedPrivacySettingsFor(data, schemaValue);
        return memo;
    }, {});

});


parcelRegister("9p4em", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d10328063ea67ac$export$2e2bcd8739ae039);
const $5d10328063ea67ac$var$UserOrganization = async (_, args, context, info)=>{
    const url = `${context.url.stargateRoot}/my-orgs`;
    return context.fetch(url).then((data)=>data.json()).then((res)=>({
            cloudId: res.managedBy && res.managedBy.id || null,
            name: res.managedBy && res.managedBy.name || null
        }));
};
var $5d10328063ea67ac$export$2e2bcd8739ae039 = $5d10328063ea67ac$var$UserOrganization;

});


parcelRegister("5vw7Q", function(module, exports) {

$parcel$export(module.exports, "schema", () => $b784d66e9747d667$export$4902baddc787debb);

var $6BdRO = parcelRequire("6BdRO");

var $faVZP = parcelRequire("faVZP");

var $heEzi = parcelRequire("heEzi");

var $lGJzb = parcelRequire("lGJzb");
const $b784d66e9747d667$export$4902baddc787debb = new (0, $6BdRO.GraphQLSchema)({
    directives: [
        (0, $faVZP.CustomDirective)
    ],
    query: (0, $lGJzb.default),
    mutation: (0, $heEzi.default)
});

});
parcelRegister("heEzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $84467a5a29396f2a$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $b8KHw = parcelRequire("b8KHw");

var $juXua = parcelRequire("juXua");

var $duQex = parcelRequire("duQex");

var $hEdbw = parcelRequire("hEdbw");
const $84467a5a29396f2a$var$MutationRoot = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        updateUser: {
            type: (0, $duQex.default),
            args: {
                id: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                input: {
                    type: (0, $duQex.UserInput)
                }
            }
        },
        deleteUserAvatar: {
            description: "Delete user's Atlassian account avatar. In the absence of an Atlassian account avatar, the user's gravatar will be used",
            type: (0, $auu22.GraphQLBoolean),
            args: {
                userId: {
                    description: "User's Atlassian account ID",
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        updateUserAvatar: {
            description: 'Upload an Atlassian account avatar.',
            type: new (0, $lXoEQ.GraphQLObjectType)({
                fields: {
                    url: {
                        type: (0, $auu22.GraphQLString)
                    }
                },
                name: (0, $b8KHw.TypeNames).AVATAR,
                description: 'New avatar URL after uploading successfully'
            }),
            args: {
                userId: {
                    description: "User's Atlassian account ID",
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                fileURI: {
                    description: `Encoded string of image file will be uploaded.
            The avatar has a file size limit of 1MB.`,
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        updateUserPrivacySettings: {
            description: "Updates a user\u2019s privacy settings.",
            type: (0, $hEdbw.default),
            args: {
                id: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                input: {
                    type: (0, $hEdbw.UserPrivacySettingsInput)
                }
            }
        },
        updateTeamInSlack: {
            type: (0, $juXua.default),
            args: {
                teamId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                channelId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                usergroupHandle: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        disconnectTeamInSlack: {
            type: (0, $juXua.default),
            args: {
                teamId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        }
    },
    name: 'Mutation'
});
var $84467a5a29396f2a$export$2e2bcd8739ae039 = $84467a5a29396f2a$var$MutationRoot;

});
parcelRegister("b8KHw", function(module, exports) {

$parcel$export(module.exports, "TypeNames", () => $ad9d9fc5de5dcf19$export$df40df59413bc65c);
var $ad9d9fc5de5dcf19$export$df40df59413bc65c;
(function(TypeNames) {
    TypeNames["USER"] = "_custom_User";
    TypeNames["USER_INPUT"] = "_custom_UserInput";
    TypeNames["USER_MANAGE_CONFIG"] = "_custom_UserManageConfig";
    TypeNames["USER_DETAILS_MUTABILITY_CONSTRAINTS"] = "_custom_UserDetailsMutabilityConstraints";
    TypeNames["USER_MANAGE_LINKED_ACCOUNTS"] = "_custom_UserManageLinkedAccounts";
    TypeNames["PRIVACY_VALUE"] = "_custom_PrivacyValue";
    TypeNames["PRIVACY_VALUE_INPUT"] = "_custom_PrivacyValueInput";
    TypeNames["PRIVACY_SETTINGS"] = "_custom_PrivacySettings";
    TypeNames["PRIVACY_SETTINGS_INPUT"] = "_custom_PrivacySettingsInput";
    TypeNames["PRIVACY_VALUES_CONFIG"] = "_custom_PrivacyValuesConfig";
    TypeNames["USER_PLACE"] = "_custom_UserPlace";
    TypeNames["USER_ORGANIZATION"] = "_custom_UserOrganization";
    TypeNames["PERMISSION_VALUE"] = "_custom_PermissionValue";
    TypeNames["AVATAR"] = "_custom_Avatar";
    TypeNames["MY_AVATAR"] = "_custom_MyAvatar";
    // Whether a team is active in slack
    TypeNames["TeamSlackStatus"] = "_custom_TeamSlackStatus";
    TypeNames["CLASSIC_APP"] = "_custom_ClassicApp";
    TypeNames["CLASSIC_APPS"] = "_custom_ClassicApps";
    TypeNames["MARKETPLACE_APP"] = "_custom_MarketplaceApp";
    TypeNames["CLASSIC_APP_INSTALLATION"] = "_custom_ClassicAppInstallation";
    TypeNames["MARKETPLACE_APP_PERMISSION"] = "_custom_MarketplaceAppPermission";
    TypeNames["MARKETPLACE_APP_PERMISSIONS"] = "_custom_MarketplaceAppPermissions";
    TypeNames["API_TOKEN"] = "_custom_ApiToken";
    TypeNames["SESSIONS_AND_DEVICES"] = "_custom_SessionsAndDevices";
    TypeNames["SESSION"] = "_custom_Session";
    TypeNames["DEVICE"] = "_custom_Device";
    TypeNames["ELEVATED_SESSION"] = "_custom_ElevatedSession";
    TypeNames["TSV_ENROLLMENT_DETAILS"] = "_custom_TsvEnrollmentDetails";
    TypeNames["CONTAINERS"] = "_custom_Containers";
    TypeNames["CONTAINER"] = "_custom_Container";
    TypeNames["CONTAINER_DETAILS"] = "_custom_ContainerDetails";
    TypeNames["COLOUR_SETTING"] = "_custom_ColourSetting";
    TypeNames["TEAM_LINK_ICON"] = "_custom_TeamLinkIcon";
})($ad9d9fc5de5dcf19$export$df40df59413bc65c || ($ad9d9fc5de5dcf19$export$df40df59413bc65c = {}));

});

parcelRegister("juXua", function(module, exports) {

$parcel$export(module.exports, "default", () => $63b1b2debc32ad0f$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $b8KHw = parcelRequire("b8KHw");
const $63b1b2debc32ad0f$var$TeamInSlackStatusType = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        id: {
            type: (0, $auu22.GraphQLString)
        },
        connected: {
            type: (0, $auu22.GraphQLBoolean)
        },
        slackChannelId: {
            type: (0, $auu22.GraphQLString)
        },
        slackChannelName: {
            type: (0, $auu22.GraphQLString)
        },
        usergroupHandle: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $b8KHw.TypeNames).TeamSlackStatus,
    description: 'Whether the team has opted in to being synced with slack'
});
var $63b1b2debc32ad0f$export$2e2bcd8739ae039 = $63b1b2debc32ad0f$var$TeamInSlackStatusType;

});

parcelRegister("duQex", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d3ff161f9c136e3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "UserInput", () => $0d3ff161f9c136e3$export$3ac5e585cf392ee0);

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");

var $b8KHw = parcelRequire("b8KHw");
const $0d3ff161f9c136e3$var$User = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        id: {
            type: (0, $auu22.GraphQLString)
        },
        fullName: {
            type: (0, $auu22.GraphQLString)
        },
        nickname: {
            type: (0, $auu22.GraphQLString)
        },
        timezone: {
            type: (0, $auu22.GraphQLString)
        },
        locale: {
            type: (0, $auu22.GraphQLString)
        },
        avatarUrl: {
            type: (0, $auu22.GraphQLString)
        },
        email: {
            type: (0, $auu22.GraphQLString)
        },
        status: {
            type: (0, $auu22.GraphQLString)
        },
        // extended profile
        title: {
            type: (0, $auu22.GraphQLString)
        },
        companyName: {
            type: (0, $auu22.GraphQLString)
        },
        department: {
            type: (0, $auu22.GraphQLString)
        },
        location: {
            type: (0, $auu22.GraphQLString)
        },
        phoneNumber: {
            type: (0, $auu22.GraphQLString)
        },
        // This should be considered to move to component level that uses timezone
        localTime: {
            type: (0, $auu22.GraphQLString),
            args: {
                format: {
                    description: 'moment.js format string',
                    type: (0, $auu22.GraphQLString),
                    defaultValue: ''
                },
                locale: {
                    description: 'locale for output',
                    type: (0, $auu22.GraphQLString),
                    defaultValue: 'en'
                }
            }
        }
    },
    name: (0, $b8KHw.TypeNames).USER,
    description: 'All User related data will be behind this GraphQL section'
});
var $0d3ff161f9c136e3$export$2e2bcd8739ae039 = $0d3ff161f9c136e3$var$User;
const $0d3ff161f9c136e3$export$3ac5e585cf392ee0 = new (0, $lXoEQ.GraphQLInputObjectType)({
    fields: {
        fullName: {
            type: (0, $auu22.GraphQLString)
        },
        nickname: {
            type: (0, $auu22.GraphQLString)
        },
        timezone: {
            type: (0, $auu22.GraphQLString)
        },
        locale: {
            type: (0, $auu22.GraphQLString)
        },
        email: {
            type: (0, $auu22.GraphQLString)
        },
        status: {
            type: (0, $auu22.GraphQLString)
        },
        // extended profile
        title: {
            type: (0, $auu22.GraphQLString)
        },
        companyName: {
            type: (0, $auu22.GraphQLString)
        },
        department: {
            type: (0, $auu22.GraphQLString)
        },
        location: {
            type: (0, $auu22.GraphQLString)
        },
        phoneNumber: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $b8KHw.TypeNames).USER_INPUT
});

});

parcelRegister("hEdbw", function(module, exports) {

$parcel$export(module.exports, "UserPrivacySettingsInput", () => $b3d38d46463d4f1d$export$5d92383dfb6e3588);
$parcel$export(module.exports, "PrivacyValue", () => $b3d38d46463d4f1d$export$8d71fec0dbffb7e5);
$parcel$export(module.exports, "default", () => $b3d38d46463d4f1d$export$2e2bcd8739ae039);

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");

var $b8KHw = parcelRequire("b8KHw");
const $b3d38d46463d4f1d$export$5c97c5d10d84e13c = new (0, $lXoEQ.GraphQLEnumType)({
    name: (0, $b8KHw.TypeNames).PRIVACY_VALUE_INPUT,
    values: {
        PUBLIC: {
            value: 'public'
        },
        COLLABORATOR: {
            value: 'collaborator'
        },
        PRIVATE: {
            value: 'private'
        }
    }
});
const $b3d38d46463d4f1d$export$5d92383dfb6e3588 = new (0, $lXoEQ.GraphQLInputObjectType)({
    fields: {
        name: {
            type: (0, $auu22.GraphQLString)
        },
        nickname: {
            type: (0, $auu22.GraphQLString)
        },
        jobTitle: {
            type: (0, $auu22.GraphQLString)
        },
        department: {
            type: (0, $auu22.GraphQLString)
        },
        organization: {
            type: (0, $auu22.GraphQLString)
        },
        location: {
            type: (0, $auu22.GraphQLString)
        },
        zoneinfo: {
            type: (0, $auu22.GraphQLString)
        },
        email: {
            type: (0, $auu22.GraphQLString)
        },
        phoneNumber: {
            type: (0, $auu22.GraphQLString)
        },
        picture: {
            type: (0, $auu22.GraphQLString)
        },
        teamType: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $b8KHw.TypeNames).PRIVACY_SETTINGS_INPUT,
    description: 'User privacy settings values to be set'
});
const $b3d38d46463d4f1d$var$DefaultPrivacyValue = new (0, $lXoEQ.GraphQLEnumType)({
    name: (0, $b8KHw.TypeNames).PRIVACY_VALUE,
    values: {
        PUBLIC: {
            value: 'PUBLIC'
        },
        COLLABORATOR: {
            value: 'COLLABORATOR'
        },
        PRIVATE: {
            value: 'PRIVATE'
        }
    }
});
const $b3d38d46463d4f1d$export$8d71fec0dbffb7e5 = new (0, $lXoEQ.GraphQLNonNull)($b3d38d46463d4f1d$var$DefaultPrivacyValue);
const $b3d38d46463d4f1d$var$UserManagePrivacySettings = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        id: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
        },
        name: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        nickname: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        jobTitle: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        department: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        organization: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        location: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        zoneinfo: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        email: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        phoneNumber: {
            type: $b3d38d46463d4f1d$var$DefaultPrivacyValue
        },
        picture: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        },
        teamType: {
            type: $b3d38d46463d4f1d$export$8d71fec0dbffb7e5
        }
    },
    name: (0, $b8KHw.TypeNames).PRIVACY_SETTINGS,
    description: 'User privacy settings values'
});
var $b3d38d46463d4f1d$export$2e2bcd8739ae039 = $b3d38d46463d4f1d$var$UserManagePrivacySettings;

});


parcelRegister("lGJzb", function(module, exports) {

$parcel$export(module.exports, "default", () => $045d90912ea1834b$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $gkM5H = parcelRequire("gkM5H");
var $juXua = parcelRequire("juXua");
var $cM0OU = parcelRequire("cM0OU");
var $duQex = parcelRequire("duQex");
var $3uo0Q = parcelRequire("3uo0Q");
var $8aln8 = parcelRequire("8aln8");
var $hEdbw = parcelRequire("hEdbw");
var $91dgD = parcelRequire("91dgD");
var $bLCVI = parcelRequire("bLCVI");

var $iskZh = parcelRequire("iskZh");
const $045d90912ea1834b$var$QueryRoot = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        UserOrganization: {
            type: (0, $bLCVI.default)
        },
        User: {
            type: (0, $duQex.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        MyAvatar: {
            type: (0, $gkM5H.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        UserManageConfig: {
            type: (0, $3uo0Q.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        UserManagePrivacySettings: {
            type: (0, $hEdbw.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        UserManagePrivacySettingsAllowed: {
            type: (0, $91dgD.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        UserManageLinkedAccounts: {
            type: (0, $8aln8.default),
            args: {
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        TeamInSlack: {
            type: (0, $juXua.default),
            args: {
                teamId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                teamName: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        Containers: {
            type: (0, $iskZh.default),
            args: {
                principalId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                siteId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                userId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                },
                maxNumberOfResults: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLInt))
                },
                sessionId: {
                    type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
                }
            }
        },
        TeamLinkIcons: {
            type: new (0, $lXoEQ.GraphQLList)((0, $cM0OU.default)),
            args: {
                teamLinkUrls: {
                    type: new (0, $lXoEQ.GraphQLList)((0, $auu22.GraphQLString))
                }
            }
        }
    },
    name: 'Query'
});
var $045d90912ea1834b$export$2e2bcd8739ae039 = $045d90912ea1834b$var$QueryRoot;

});
parcelRegister("gkM5H", function(module, exports) {

$parcel$export(module.exports, "default", () => $34c897dbbe8caaae$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $b8KHw = parcelRequire("b8KHw");
const $34c897dbbe8caaae$var$MyAvatar = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        url: {
            type: (0, $auu22.GraphQLString)
        },
        uploaded: {
            type: (0, $auu22.GraphQLBoolean)
        }
    },
    name: (0, $b8KHw.TypeNames).MY_AVATAR,
    description: "Get meta-data about current user\u2019s avatar"
});
var $34c897dbbe8caaae$export$2e2bcd8739ae039 = $34c897dbbe8caaae$var$MyAvatar;

});

parcelRegister("cM0OU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9b4f4cf16dceeb$export$2e2bcd8739ae039);

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");

var $b8KHw = parcelRequire("b8KHw");
const $4b9b4f4cf16dceeb$var$TeamLinkIcon = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        linkUrl: {
            type: (0, $auu22.GraphQLString)
        },
        iconUrl: {
            type: (0, $auu22.GraphQLString)
        },
        productName: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $b8KHw.TypeNames).TEAM_LINK_ICON,
    description: 'Icon URL to use for a link'
});
var $4b9b4f4cf16dceeb$export$2e2bcd8739ae039 = $4b9b4f4cf16dceeb$var$TeamLinkIcon;

});

parcelRegister("3uo0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $2677d4762e1cbae0$export$2e2bcd8739ae039);

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");

var $b8KHw = parcelRequire("b8KHw");
const $2677d4762e1cbae0$var$MutabilityConstraints = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        field: {
            type: (0, $auu22.GraphQLString)
        },
        reason: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $b8KHw.TypeNames).USER_DETAILS_MUTABILITY_CONSTRAINTS
});
const $2677d4762e1cbae0$var$UserManageConfig = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        mutabilityConstraints: {
            type: new (0, $lXoEQ.GraphQLList)($2677d4762e1cbae0$var$MutabilityConstraints)
        }
    },
    name: (0, $b8KHw.TypeNames).USER_MANAGE_CONFIG,
    description: 'User mutability constraints values'
});
var $2677d4762e1cbae0$export$2e2bcd8739ae039 = $2677d4762e1cbae0$var$UserManageConfig;

});

parcelRegister("8aln8", function(module, exports) {

$parcel$export(module.exports, "default", () => $034870d16281027d$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $b8KHw = parcelRequire("b8KHw");
const $034870d16281027d$var$LinkedAccounts = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        google: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean))
        },
        microsoft: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean))
        },
        apple: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean))
        },
        saml: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLBoolean))
        }
    },
    name: (0, $b8KHw.TypeNames).USER_MANAGE_LINKED_ACCOUNTS
});
var $034870d16281027d$export$2e2bcd8739ae039 = $034870d16281027d$var$LinkedAccounts;

});

parcelRegister("91dgD", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcf106d3cd037b98$export$2e2bcd8739ae039);

var $lXoEQ = parcelRequire("lXoEQ");

var $b8KHw = parcelRequire("b8KHw");

var $hEdbw = parcelRequire("hEdbw");
const $fcf106d3cd037b98$var$AllowedPrivacyValue = new (0, $lXoEQ.GraphQLList)((0, $hEdbw.PrivacyValue));
const $fcf106d3cd037b98$var$UserManagePrivacySettingsAllowed = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        name: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        nickname: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        jobTitle: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        department: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        organization: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        location: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        zoneinfo: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        email: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        phoneNumber: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        picture: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        },
        teamType: {
            type: $fcf106d3cd037b98$var$AllowedPrivacyValue
        }
    },
    name: (0, $b8KHw.TypeNames).PRIVACY_VALUES_CONFIG,
    description: 'User privacy settings allowed values'
});
var $fcf106d3cd037b98$export$2e2bcd8739ae039 = $fcf106d3cd037b98$var$UserManagePrivacySettingsAllowed;

});

parcelRegister("bLCVI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c23ee84c3314354$export$2e2bcd8739ae039);

var $lXoEQ = parcelRequire("lXoEQ");
var $auu22 = parcelRequire("auu22");

var $b8KHw = parcelRequire("b8KHw");
const $6c23ee84c3314354$var$UserPlace = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        cloudId: {
            type: (0, $auu22.GraphQLString)
        },
        name: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $b8KHw.TypeNames).USER_ORGANIZATION,
    description: 'Organization a user belongs to'
});
var $6c23ee84c3314354$export$2e2bcd8739ae039 = $6c23ee84c3314354$var$UserPlace;

});

parcelRegister("iskZh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cf5506f7004febb$export$2e2bcd8739ae039);

var $auu22 = parcelRequire("auu22");
var $lXoEQ = parcelRequire("lXoEQ");

var $b8KHw = parcelRequire("b8KHw");
const $4cf5506f7004febb$var$ContainerDetails = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        id: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
        },
        key: {
            type: (0, $auu22.GraphQLString)
        },
        name: {
            type: (0, $auu22.GraphQLString)
        },
        url: {
            type: (0, $auu22.GraphQLString)
        },
        iconUrl: {
            type: (0, $auu22.GraphQLString)
        }
    },
    name: (0, $b8KHw.TypeNames).CONTAINER_DETAILS
});
const $4cf5506f7004febb$var$Container = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        id: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
        },
        entityType: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
        },
        containerType: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLString))
        },
        score: {
            type: new (0, $lXoEQ.GraphQLNonNull)((0, $auu22.GraphQLFloat))
        },
        containerDetails: {
            type: $4cf5506f7004febb$var$ContainerDetails
        }
    },
    name: (0, $b8KHw.TypeNames).CONTAINER
});
const $4cf5506f7004febb$var$Containers = new (0, $lXoEQ.GraphQLObjectType)({
    fields: {
        collaborationGraphEntities: {
            type: new (0, $lXoEQ.GraphQLNonNull)(new (0, $lXoEQ.GraphQLList)(new (0, $lXoEQ.GraphQLNonNull)($4cf5506f7004febb$var$Container)))
        }
    },
    name: (0, $b8KHw.TypeNames).CONTAINERS,
    description: 'A list of Places Spaces/Projects'
});
var $4cf5506f7004febb$export$2e2bcd8739ae039 = $4cf5506f7004febb$var$Containers;

});




parcelRegister("lhBhN", function(module, exports) {

$parcel$export(module.exports, "withDefaultExponentialBackoff", () => $ae7ba0d1a49c4623$export$455df4c93665fa4a);
const $ae7ba0d1a49c4623$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $ae7ba0d1a49c4623$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
// tslint:disable-next-line no-any
const $ae7ba0d1a49c4623$var$defaultRetryIfCallback = (a)=>!a;
const $ae7ba0d1a49c4623$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $ae7ba0d1a49c4623$var$defaultRetryIfCallback
};
function $ae7ba0d1a49c4623$export$20eaa22f2295996f(toTry, hofOptions = $ae7ba0d1a49c4623$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
function $ae7ba0d1a49c4623$export$455df4c93665fa4a(fetchOp) {
    return $ae7ba0d1a49c4623$export$20eaa22f2295996f(fetchOp, {
        initial: $ae7ba0d1a49c4623$export$8f4286bf21155381.INITIAL_DELAY,
        jitter: $ae7ba0d1a49c4623$export$8f4286bf21155381.JITTER,
        max: $ae7ba0d1a49c4623$export$8f4286bf21155381.MAX_RETRIES,
        retryIf: (response)=>$ae7ba0d1a49c4623$export$55b2fbd5d4a32495(response.status)
    });
}

});



parcelRegister("lxT0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $986af4a2a75dece7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4ErPU = parcelRequire("4ErPU");

var $1xrmr = parcelRequire("1xrmr");

var $2nfCW = parcelRequire("2nfCW");
var $fHuyz = parcelRequire("fHuyz");
var $aVqnF = parcelRequire("aVqnF");
var $g6xgY = parcelRequire("g6xgY");
var $cWYE1 = parcelRequire("cWYE1");
var $fcdA0 = parcelRequire("fcdA0");
var $6XUHL = parcelRequire("6XUHL");
var $5bjdJ = parcelRequire("5bjdJ");

var $1wQUJ = parcelRequire("1wQUJ");

var $lnHnV = parcelRequire("lnHnV");

var $jnlyS = parcelRequire("jnlyS");

var $avLBj = parcelRequire("avLBj");
var $37mOt = parcelRequire("37mOt");

var $ictQ5 = parcelRequire("ictQ5");

var $gi0VS = parcelRequire("gi0VS");

var $jmrxX = parcelRequire("jmrxX");

var $YnDGC = parcelRequire("YnDGC");

var $4vhsL = parcelRequire("4vhsL");

var $aILpI = parcelRequire("aILpI");
function $986af4a2a75dece7$export$2e2bcd8739ae039(props) {
    const { appName: appName, analytics: analytics, apolloClient: apolloClient, contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, replace: replace, push: push, locale: locale, skipI18nProvider: skipI18nProvider, addFlag: addFlag, docTitle: docTitle, env: env, history: history, statusCodeHandlers: statusCodeHandlers, cloudId: cloudId, orgId: orgId, teamCentralHandlers: teamCentralHandlers, productFeatureFlags: productFeatureFlags, invitePeopleHandlers: invitePeopleHandlers, isSentryEnabled: isSentryEnabled } = props;
    const sentryClient = (0, $fcdA0.useTeamsSentryClientSetup)(isSentryEnabled, {
        appName: appName,
        env: (0, $37mOt.getEnv)()
    });
    const [, { setCloudId: setCloudId }] = (0, $6XUHL.useSite)();
    const [, { setOrgId: setOrgId }] = (0, $cWYE1.useOrg)();
    const [, { initTeamCentral: initTeamCentral }] = (0, $5bjdJ.useTeamCentralStoreApi)();
    const { isJiraAvailable: isJiraAvailable } = (0, $1wQUJ.useJiraCheckService)(cloudId);
    const expTracker = analytics.expTracker();
    const analyticsClient = analytics.getAnalyticsWebClient();
    (0, $eUqFw.useEffect)(()=>{
        if (orgId) // @ts-expect-error - Property 'setOrgInfo' does not exist on type 'Promise<AnalyticsWebClient>'
        analyticsClient?.setOrgInfo(orgId);
    }, [
        analyticsClient,
        orgId
    ]);
    const appConfig = (0, $eUqFw.useMemo)(()=>({
            env: env,
            appName: appName,
            contextSpaPaths: contextSpaPaths,
            contextEntryPoint: contextEntryPoint,
            push: push,
            replace: replace,
            addFlag: addFlag,
            locale: locale,
            docTitle: docTitle,
            cloudId: cloudId,
            orgId: orgId,
            productFeatureFlags: productFeatureFlags,
            stargateRoot: (0, $avLBj.getConfig)().stargateRoot,
            isJiraAvailable: isJiraAvailable
        }), [
        env,
        appName,
        contextSpaPaths,
        contextEntryPoint,
        isJiraAvailable,
        push,
        replace,
        addFlag,
        locale,
        docTitle,
        cloudId,
        orgId,
        productFeatureFlags
    ]);
    // init statusCodeHandlersProvider
    (0, $eUqFw.useEffect)(()=>{
        if (statusCodeHandlers) (0, $g6xgY.statusCodeHandlersProvider).setHandlers(statusCodeHandlers);
    }, [
        statusCodeHandlers
    ]);
    // save cloud id passed from consumers to a remote state management.
    (0, $eUqFw.useEffect)(()=>{
        setCloudId(cloudId);
    }, [
        cloudId,
        setCloudId
    ]);
    // save org id passed from consumers to a remote state management.
    (0, $eUqFw.useEffect)(()=>{
        setOrgId(orgId);
    }, [
        orgId,
        setOrgId
    ]);
    // Init and save various team central related data and preconditions
    (0, $eUqFw.useEffect)(()=>{
        initTeamCentral(appName, cloudId, teamCentralHandlers);
    }, [
        appName,
        cloudId,
        teamCentralHandlers,
        initTeamCentral
    ]);
    const handleTransition = (0, $eUqFw.useCallback)((pathname)=>{
        if (expTracker) expTracker.abort({
            reason: 'Route changes.'
        });
        (0, $jnlyS.addBreadcrumb)(pathname);
    }, [
        expTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aVqnF.default), {
        messagesConfig: (0, $ictQ5.default),
        skip: typeof skipI18nProvider !== 'undefined' ? skipI18nProvider : !locale,
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $YnDGC.default), {
        analytics: analytics,
        appName: appName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lnHnV.TeamsWrapper), {
        sentryClient: sentryClient,
        appConfig: appConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jmrxX.default), {
        env: env,
        contextSpaPaths: contextSpaPaths,
        contextEntryPoint: contextEntryPoint,
        docTitle: docTitle,
        appName: appName,
        addFlag: addFlag,
        push: push,
        locale: locale,
        replace: replace,
        history: history,
        cloudId: cloudId,
        orgId: orgId,
        isJiraAvailable: isJiraAvailable,
        teamCentralHandlers: teamCentralHandlers,
        productFeatureFlags: productFeatureFlags,
        invitePeopleHandlers: invitePeopleHandlers
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2nfCW.default), {
        analytics: analytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1xrmr.ExperienceTrackerContext).Provider, {
        value: analytics.expTracker()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4vhsL.RelativeWrapperOfHeaderImage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ErPU.ApolloProvider), {
        client: apolloClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fHuyz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aILpI.default), {
        appName: appName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gi0VS.default), {
        contextEntryPoint: contextEntryPoint,
        history: history,
        onTransition: handleTransition
    })))))))))));
}

});
parcelRegister("4ErPU", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $36307d91b5e24fba$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $36307d91b5e24fba$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $36307d91b5e24fba$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $36307d91b5e24fba$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $36307d91b5e24fba$export$8f49e4af10703ce3);

var $eUqFw = parcelRequire("eUqFw");

var $8j2fP = parcelRequire("8j2fP");
var $36307d91b5e24fba$var$apolloContext;
function $36307d91b5e24fba$export$a47505d961ee3a1() {
    if (!$36307d91b5e24fba$var$apolloContext) $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
    return $36307d91b5e24fba$var$apolloContext;
}
function $36307d91b5e24fba$export$c2ee824bcc89ca6a() {
    $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
}
var $36307d91b5e24fba$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $8j2fP.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $36307d91b5e24fba$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $8j2fP.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $36307d91b5e24fba$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($36307d91b5e24fba$export$d1d99cf900472499 || ($36307d91b5e24fba$export$d1d99cf900472499 = {}));
var $36307d91b5e24fba$var$cache = new Map();
function $36307d91b5e24fba$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $36307d91b5e24fba$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $36307d91b5e24fba$export$8f49e4af10703ce3(document) {
    var cached = $36307d91b5e24fba$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $8j2fP.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $8j2fP.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $8j2fP.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $36307d91b5e24fba$export$d1d99cf900472499.Query : $36307d91b5e24fba$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $36307d91b5e24fba$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $8j2fP.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $36307d91b5e24fba$var$cache.set(document, payload);
    return payload;
}

});

parcelRegister("2nfCW", function(module, exports) {

$parcel$export(module.exports, "default", () => $29d63922d1b7ecbc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $J9LlC = parcelRequire("J9LlC");
class $29d63922d1b7ecbc$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $J9LlC.AnalyticsContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            analytics: this.props.analytics
        };
    }
}

});
parcelRegister("J9LlC", function(module, exports) {

$parcel$export(module.exports, "defaultAnalyticsClient", () => $2575254e26e9efc9$export$7fa70eb12a96b7d1);
$parcel$export(module.exports, "AnalyticsContext", () => $2575254e26e9efc9$export$83cd6c3eba7d8d9e);

var $eUqFw = parcelRequire("eUqFw");

var $fECJU = parcelRequire("fECJU");
const $2575254e26e9efc9$var$defaultAnalyticsMethod = ()=>{
    // tslint:disable-next-line no-console
    // eslint-disable-next-line no-console
    console.warn('No analytics client has been provided.');
    (0, $fECJU.logInfoMessage)('Analytics Context accessed before AnalyticsClient was loaded');
};
const $2575254e26e9efc9$export$7fa70eb12a96b7d1 = {
    getAnalyticsWebClient: ()=>{
        $2575254e26e9efc9$var$defaultAnalyticsMethod();
        return;
    },
    pushTrackEvent: $2575254e26e9efc9$var$defaultAnalyticsMethod,
    pushScreenEvent: $2575254e26e9efc9$var$defaultAnalyticsMethod,
    pushUIEvent: $2575254e26e9efc9$var$defaultAnalyticsMethod,
    pushOperationalEvent: $2575254e26e9efc9$var$defaultAnalyticsMethod,
    startUIViewedEvent: $2575254e26e9efc9$var$defaultAnalyticsMethod,
    expTracker: ()=>{
        throw new Error('No analytics client has been provided');
    },
    setTeamId: ()=>{
        throw new Error('No analytics client has been provided');
    }
};
const $2575254e26e9efc9$var$AnalyticsContextState = {
    analytics: $2575254e26e9efc9$export$7fa70eb12a96b7d1
};
const $2575254e26e9efc9$export$83cd6c3eba7d8d9e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($2575254e26e9efc9$var$AnalyticsContextState);

});


parcelRegister("fHuyz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c36d4b8ef3efbbc1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2quw6 = parcelRequire("2quw6");

var $73k7H = parcelRequire("73k7H");
const $c36d4b8ef3efbbc1$var$initialStates = {
    DialogComponent: null,
    dialogProps: null,
    isOpen: false
};
function $c36d4b8ef3efbbc1$var$dialogReducer(state, action) {
    switch(action.type){
        case 'open':
            return {
                ...state,
                DialogComponent: action.payload?.DialogComponent || null,
                dialogProps: action.payload?.dialogProps || null,
                isOpen: true
            };
        case 'close':
            return {
                ...state,
                DialogComponent: null,
                dialogProps: null,
                isOpen: false
            };
        default:
            throw new Error();
    }
}
function $c36d4b8ef3efbbc1$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const [stateDialogProvider, dispatch] = (0, $eUqFw.useReducer)($c36d4b8ef3efbbc1$var$dialogReducer, $c36d4b8ef3efbbc1$var$initialStates);
    const valueProvider = (0, $eUqFw.useMemo)(()=>({
            openDialog: (DialogComponent, dialogProps = null)=>dispatch({
                    type: 'open',
                    payload: {
                        DialogComponent: DialogComponent,
                        dialogProps: dialogProps
                    }
                }),
            closeDialog: ()=>dispatch({
                    type: 'close'
                })
        }), []);
    return(// @ts-ignore
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $73k7H.DialogsContext).Provider, {
        value: valueProvider
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2quw6.default), stateDialogProvider)));
}

});
parcelRegister("2quw6", function(module, exports) {

$parcel$export(module.exports, "default", () => $50035a600ad5fc7d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $73k7H = parcelRequire("73k7H");
function $50035a600ad5fc7d$export$2e2bcd8739ae039(props) {
    const { DialogComponent: DialogComponent, isOpen: isOpen, onClose: onClose, dialogProps: dialogProps } = props;
    const { closeDialog: closeDialog } = (0, $eUqFw.useContext)((0, $73k7H.DialogsContext));
    if (!DialogComponent) return null;
    const handleCloseDialog = ()=>{
        closeDialog();
        if (onClose) onClose();
        if (dialogProps?.onClose) dialogProps.onClose();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DialogComponent, {
        ...dialogProps,
        onClose: handleCloseDialog
    }));
}

});
parcelRegister("73k7H", function(module, exports) {

$parcel$export(module.exports, "DialogsContext", () => $c75792d8e8b4ab19$export$412f7f691e39b0da);

var $eUqFw = parcelRequire("eUqFw");
const $c75792d8e8b4ab19$var$dialogsContextState = {
    openDialog: ()=>null,
    closeDialog: ()=>null
};
const $c75792d8e8b4ab19$export$412f7f691e39b0da = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($c75792d8e8b4ab19$var$dialogsContextState);

});



parcelRegister("aVqnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $13b41a06c5285c94$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");

var $fECJU = parcelRequire("fECJU");

var $1Zw99 = parcelRequire("1Zw99");
/**
 * Sets up the react-intl IntlProvider for its children, blocking until translations are loaded
 */ const $13b41a06c5285c94$var$NO_MESSAGES = {};
class $13b41a06c5285c94$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    componentDidMount() {
        if (this.props.skip !== true) this.loadData();
    }
    async loadData() {
        const { messagesConfig: messagesConfig, locale: predefinedLocale } = this.props;
        const locale = await (0, $1Zw99.getEffectiveLocale)(predefinedLocale);
        if (locale === (0, $1Zw99.DEFAULT_LOCALE)) {
            // Everything is already loaded for English
            this.setState({
                locale: (0, $1Zw99.DEFAULT_LOCALE),
                messages: {}
            });
            return;
        }
        try {
            const messages = await (0, $1Zw99.loadIntlData)(messagesConfig, locale);
            this.setState({
                locale: locale,
                messages: messages || $13b41a06c5285c94$var$NO_MESSAGES
            });
        } catch (error) {
            // @ts-ignore
            (0, $fECJU.logException)(error, 'Error loading translations.', {
                locale: locale
            });
            // show english on error
            this.setState({
                locale: (0, $1Zw99.DEFAULT_LOCALE),
                messages: $13b41a06c5285c94$var$NO_MESSAGES
            });
        }
    }
    render() {
        const { skip: skip } = this.props;
        // TODO: [PTC-4968] Long term 'skip' prop to be removed in favour being skipped by
        //       default and `embeddable-directory` to rely on parent product i18n provider.
        //       The idea is to merge package i18n files into product ones, and ship that
        //       one global product i18n translation rather than packages fetching their own.
        if (skip) return this.props.children;
        const { locale: locale, messages: messages } = this.state;
        // Idea for improvement we should not block rendering UI while fetching messages
        // https://product-fabric.atlassian.net/browse/PTC-2176
        if (!messages) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
            key: `intl-provider-5-${locale}`,
            "data-test-language": locale,
            locale: locale,
            defaultLocale: (0, $1Zw99.DEFAULT_LOCALE),
            messages: messages
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            locale: (0, $1Zw99.DEFAULT_LOCALE),
            messages: undefined
        };
    }
}

});
parcelRegister("1Zw99", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $a97407a716811b1a$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "getEffectiveLocale", () => $a97407a716811b1a$export$5211f28df9ef284a);
$parcel$export(module.exports, "loadIntlData", () => $a97407a716811b1a$export$d225990554fb28f7);

var $9qyRi = parcelRequire("9qyRi");

var $1Zvbf = parcelRequire("1Zvbf");

var $6GHn9 = parcelRequire("6GHn9");
const $a97407a716811b1a$export$1af4c7e47ad72f44 = 'en';
const $a97407a716811b1a$export$b6a046f0eef1bb2 = [
    'cs',
    'cs-CZ',
    'da',
    'da-DK',
    'de',
    'de-DE',
    'en-GB',
    'es',
    'es-ES',
    'et',
    'et-EE',
    'fi',
    'fi-FI',
    'fr',
    'fr-FR',
    'hu',
    'hu-HU',
    'is',
    'is-IS',
    'it',
    'it-IT',
    'ja',
    'ja-JP',
    'ko',
    'ko-KR',
    'nb',
    'nb-NO',
    'nl',
    'nl-NL',
    'pl',
    'pl-PL',
    'pt',
    'pt-BR',
    'pt-PT',
    'ro',
    'ro-RO',
    'ru',
    'ru-RU',
    'sk',
    'sk-SK',
    'sv',
    'sv-SE',
    'tr',
    'tr-TR',
    'th',
    'th-TH',
    'uk',
    'uk-UA',
    'vi',
    'vi-VN',
    'zh',
    'zh-TW',
    'zh-HK',
    'zh-ZH',
    'zh-CN'
];
// In URL, a tester can pass lang code or locale into URL, e.g `?locale=fr` or `?locale=cs-CZ`
const $a97407a716811b1a$var$getLocaleFromUrl = ()=>{
    const { locale: locale } = (0, (/*@__PURE__*/$parcel$interopDefault($9qyRi))).parse((0, (/*@__PURE__*/$parcel$interopDefault($1Zvbf))).location.search);
    const localeFromUrl = Array.isArray(locale) ? locale[0] : locale;
    return localeFromUrl;
};
function $a97407a716811b1a$var$getSupportedLocale(locale) {
    if (typeof locale !== 'string') return null;
    locale = locale.replace('_', '-');
    if ($a97407a716811b1a$export$b6a046f0eef1bb2.includes(locale)) return locale;
    // If we don't have the exact locale available, attempt to match just the language
    const languageCode = locale.substring(0, 2);
    if ($a97407a716811b1a$export$b6a046f0eef1bb2.includes(languageCode)) return languageCode;
}
const $a97407a716811b1a$export$5211f28df9ef284a = async (predefinedLocale)=>{
    // locale that we can manually pass to intl provider
    const receivedLocale = $a97407a716811b1a$var$getSupportedLocale(predefinedLocale);
    if (receivedLocale) return receivedLocale;
    // locale that we can pass to intl provider via `locale` GET param
    const localeInUrl = $a97407a716811b1a$var$getSupportedLocale($a97407a716811b1a$var$getLocaleFromUrl());
    if (localeInUrl) return localeInUrl;
    let userLocale;
    try {
        userLocale = (await (0, $6GHn9.userInfoProvider).get()).locale;
    } catch (e) {
        userLocale = $a97407a716811b1a$export$1af4c7e47ad72f44;
    }
    return $a97407a716811b1a$var$getSupportedLocale(userLocale) || $a97407a716811b1a$export$1af4c7e47ad72f44;
};
const $a97407a716811b1a$export$d225990554fb28f7 = (localesConfig, locale)=>{
    const pickedConfig = localesConfig.find((config)=>config.locales.includes(locale));
    const loader = pickedConfig?.loader;
    if (!loader) return Promise.resolve(null);
    return new Promise((resolve, reject)=>{
        // Fails if we haven't loaded/resolved after 30 seconds
        const rejectTimer = setTimeout(reject, 30000);
        loader().then((res)=>{
            clearTimeout(rejectTimer);
            // depending on a builder and config used in a project the result of dynamic imports could be behind `default`
            // this way we'll cover both cases
            resolve(res && res.default || res);
        });
    });
};

});
parcelRegister("9qyRi", function(module, exports) {

$parcel$export(module.exports, "extract", () => $6dd194fbfa826ed8$export$f9380c9a627682d3, (v) => $6dd194fbfa826ed8$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $6dd194fbfa826ed8$export$98e6a39c04603d36, (v) => $6dd194fbfa826ed8$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $6dd194fbfa826ed8$export$fac44ee5b035f737, (v) => $6dd194fbfa826ed8$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $6dd194fbfa826ed8$export$7a5253c0f62e0150, (v) => $6dd194fbfa826ed8$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $6dd194fbfa826ed8$export$a8c1621ea79325d3, (v) => $6dd194fbfa826ed8$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $6dd194fbfa826ed8$export$357523c63a2253b9, (v) => $6dd194fbfa826ed8$export$357523c63a2253b9 = v);
$parcel$export(module.exports, "exclude", () => $6dd194fbfa826ed8$export$44c361b8ec72ef7f, (v) => $6dd194fbfa826ed8$export$44c361b8ec72ef7f = v);
var $6dd194fbfa826ed8$export$f9380c9a627682d3;
var $6dd194fbfa826ed8$export$98e6a39c04603d36;
var $6dd194fbfa826ed8$export$fac44ee5b035f737;
var $6dd194fbfa826ed8$export$7a5253c0f62e0150;
var $6dd194fbfa826ed8$export$a8c1621ea79325d3;
var $6dd194fbfa826ed8$export$357523c63a2253b9;
var $6dd194fbfa826ed8$export$44c361b8ec72ef7f;
'use strict';

var $hXDaG = parcelRequire("hXDaG");

var $bJEvY = parcelRequire("bJEvY");

var $9CHQr = parcelRequire("9CHQr");

var $aARfw = parcelRequire("aARfw");
const $6dd194fbfa826ed8$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $6dd194fbfa826ed8$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $6dd194fbfa826ed8$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $6dd194fbfa826ed8$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $6dd194fbfa826ed8$var$encode(key, options),
                            '[',
                            $6dd194fbfa826ed8$var$encode(index, options),
                            ']=',
                            $6dd194fbfa826ed8$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $6dd194fbfa826ed8$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $6dd194fbfa826ed8$var$encode(key, options),
                            '[]=',
                            $6dd194fbfa826ed8$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $6dd194fbfa826ed8$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $6dd194fbfa826ed8$var$encode(key, options),
                            ':list=',
                            $6dd194fbfa826ed8$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $6dd194fbfa826ed8$var$encode(key, options),
                                keyValueSep,
                                $6dd194fbfa826ed8$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $6dd194fbfa826ed8$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $6dd194fbfa826ed8$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $6dd194fbfa826ed8$var$encode(key, options),
                            '=',
                            $6dd194fbfa826ed8$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $6dd194fbfa826ed8$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $6dd194fbfa826ed8$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $6dd194fbfa826ed8$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$6dd194fbfa826ed8$var$decode(item, options)) : value === null ? value : $6dd194fbfa826ed8$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $6dd194fbfa826ed8$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$6dd194fbfa826ed8$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $6dd194fbfa826ed8$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $6dd194fbfa826ed8$var$encode(value, options) {
    if (options.encode) return options.strict ? $hXDaG(value) : encodeURIComponent(value);
    return value;
}
function $6dd194fbfa826ed8$var$decode(value, options) {
    if (options.decode) return $bJEvY(value);
    return value;
}
function $6dd194fbfa826ed8$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $6dd194fbfa826ed8$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $6dd194fbfa826ed8$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $6dd194fbfa826ed8$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $6dd194fbfa826ed8$var$extract(input) {
    input = $6dd194fbfa826ed8$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $6dd194fbfa826ed8$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $6dd194fbfa826ed8$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $6dd194fbfa826ed8$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $6dd194fbfa826ed8$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $9CHQr(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $6dd194fbfa826ed8$var$decode(value, options);
        formatter($6dd194fbfa826ed8$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $6dd194fbfa826ed8$var$parseValue(value[k], options);
        else ret[key] = $6dd194fbfa826ed8$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $6dd194fbfa826ed8$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$6dd194fbfa826ed8$export$f9380c9a627682d3 = $6dd194fbfa826ed8$var$extract;
$6dd194fbfa826ed8$export$98e6a39c04603d36 = $6dd194fbfa826ed8$var$parse;
$6dd194fbfa826ed8$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $6dd194fbfa826ed8$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $6dd194fbfa826ed8$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $6dd194fbfa826ed8$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $6dd194fbfa826ed8$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $6dd194fbfa826ed8$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $6dd194fbfa826ed8$var$encode(key, options) + '=' + $6dd194fbfa826ed8$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$6dd194fbfa826ed8$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $9CHQr(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $6dd194fbfa826ed8$var$parse($6dd194fbfa826ed8$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $6dd194fbfa826ed8$var$decode(hash, options)
    } : {});
};
$6dd194fbfa826ed8$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$6dd194fbfa826ed8$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $6dd194fbfa826ed8$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $6dd194fbfa826ed8$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $6dd194fbfa826ed8$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $6dd194fbfa826ed8$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $6dd194fbfa826ed8$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$6dd194fbfa826ed8$var$encodeFragmentIdentifier] ? $6dd194fbfa826ed8$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$6dd194fbfa826ed8$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$6dd194fbfa826ed8$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $6dd194fbfa826ed8$export$7a5253c0f62e0150(input, options);
    return $6dd194fbfa826ed8$export$a8c1621ea79325d3({
        url: url,
        query: $aARfw(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$6dd194fbfa826ed8$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $6dd194fbfa826ed8$export$357523c63a2253b9(input, exclusionFilter, options);
};

});

parcelRegister("6GHn9", function(module, exports) {

$parcel$export(module.exports, "userInfoProvider", () => $e61adc51fb035db3$export$30a852ca4cb27370);

var $avLBj = parcelRequire("avLBj");
// Needs to be declared here to avoid blowing up this earlyInit bundle
class $e61adc51fb035db3$var$FetchError extends Error {
    constructor(response){
        super(`Request failed with status ${response.status}`);
        this.response = response;
        this.name = this.constructor.name;
    }
}
class $e61adc51fb035db3$export$dc10e400a1189789 {
    get(fetchOp = fetch) {
        if (this.promise) return this.promise;
        const getJson = (url)=>fetchOp(url, {
                method: 'GET',
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response)=>{
                if (!response.ok) throw new $e61adc51fb035db3$var$FetchError(response);
                return response.json();
            });
        this.promise = getJson(`${(0, $avLBj.getConfig)().stargateRoot}/me`).then((me)=>{
            return {
                userId: me.account_id,
                locale: me.locale,
                fullName: me.name,
                avatarUrl: me.picture,
                email: me.email,
                title: me.extended_profile?.job_title
            };
        });
        return this.promise;
    }
}
const $e61adc51fb035db3$export$30a852ca4cb27370 = new $e61adc51fb035db3$export$dc10e400a1189789();

});



parcelRegister("g6xgY", function(module, exports) {

$parcel$export(module.exports, "statusCodeHandlersProvider", () => $b389f1e4009c9291$export$8c005e458e12d501);
$parcel$export(module.exports, "handleResponse", () => $b389f1e4009c9291$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $b389f1e4009c9291$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $b389f1e4009c9291$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $b389f1e4009c9291$export$8c005e458e12d501.handlers = handlers;
    }
};
function $b389f1e4009c9291$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $b389f1e4009c9291$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});

parcelRegister("cWYE1", function(module, exports) {

$parcel$export(module.exports, "useOrg", () => $56a182d0938d5096$export$7f785727a26e156);

var $WBLbN = parcelRequire("WBLbN");

var $huuRB = parcelRequire("huuRB");
const $56a182d0938d5096$export$7f785727a26e156 = (0, $WBLbN.createHook)((0, $huuRB.Store));

});
parcelRegister("huuRB", function(module, exports) {

$parcel$export(module.exports, "Store", () => $702cfadf35231ae4$export$390f32400eaf98c9);

var $WBLbN = parcelRequire("WBLbN");
const $702cfadf35231ae4$var$actions = {
    setOrgId: (orgId)=>({ setState: setState })=>{
            setState({
                orgId: orgId
            });
        }
};
const $702cfadf35231ae4$var$initialState = {
    orgId: undefined
};
const $702cfadf35231ae4$export$390f32400eaf98c9 = (0, $WBLbN.createStore)({
    initialState: $702cfadf35231ae4$var$initialState,
    actions: $702cfadf35231ae4$var$actions,
    name: 'Org'
});

});


parcelRegister("6XUHL", function(module, exports) {

$parcel$export(module.exports, "useSite", () => $597a5e5609a64ad3$export$7870fa8e7cdd59f8);

var $WBLbN = parcelRequire("WBLbN");

var $huxiY = parcelRequire("huxiY");
const $597a5e5609a64ad3$export$7870fa8e7cdd59f8 = (0, $WBLbN.createHook)((0, $huxiY.Store));
const $597a5e5609a64ad3$export$9da0f7c65f28ed16 = ()=>$597a5e5609a64ad3$export$7870fa8e7cdd59f8()[0].cloudId;

});
parcelRegister("huxiY", function(module, exports) {

$parcel$export(module.exports, "Store", () => $62a61f0c605d4bb7$export$390f32400eaf98c9);

var $WBLbN = parcelRequire("WBLbN");
const $62a61f0c605d4bb7$var$actions = {
    // This action is used by EmbeddedDirectory to get Cloud Id in a remote store.
    setCloudId: (cloudId)=>({ setState: setState })=>{
            setState({
                cloudId: cloudId
            });
        }
};
const $62a61f0c605d4bb7$var$initialState = {
    cloudId: ''
};
const $62a61f0c605d4bb7$export$390f32400eaf98c9 = (0, $WBLbN.createStore)({
    initialState: $62a61f0c605d4bb7$var$initialState,
    actions: $62a61f0c605d4bb7$var$actions,
    name: 'Site'
});

});


parcelRegister("5bjdJ", function(module, exports) {

$parcel$export(module.exports, "useTeamCentralStore", () => $b12059845066d221$export$39314e672c06693f);
$parcel$export(module.exports, "useTeamCentralStoreApi", () => $b12059845066d221$export$7c58a39ba496932b);
$parcel$export(module.exports, "useIsTeamCentral", () => $b12059845066d221$export$9da989c55553d02d);
$parcel$export(module.exports, "useTeamCentralPresent", () => $b12059845066d221$export$20f07b26e9a56b9);

var $WBLbN = parcelRequire("WBLbN");

var $4QbXv = parcelRequire("4QbXv");
const $b12059845066d221$var$initialState = {
    isTeamCentral: false,
    hasWorkspace: false,
    orgHasWorkspace: false,
    teamCentralHandlers: {}
};
const $b12059845066d221$var$actions = {
    initTeamCentral: (appName, cloudId, teamCentralHandlers = {})=>({ setState: setState })=>{
            const isTeamCentral = appName === 'teamcentral-directory';
            if (isTeamCentral) // Assume site already has a TC workspace if directory is running in TC mode
            setState({
                isTeamCentral: isTeamCentral,
                hasWorkspace: true,
                orgHasWorkspace: true,
                teamCentralHandlers: teamCentralHandlers
            });
            else {
                // Otherwise, fetch for workspace information
                const requests = [
                    (0, $4QbXv.default).hasWorkspaceForCloudId(cloudId),
                    (0, $4QbXv.default).doesOrgContainAnyWorkspace(cloudId)
                ];
                Promise.all(requests).then(([hasWorkspace, orgHasWorkspace])=>{
                    setState({
                        isTeamCentral: false,
                        hasWorkspace: hasWorkspace,
                        orgHasWorkspace: orgHasWorkspace,
                        teamCentralHandlers: teamCentralHandlers
                    });
                });
            }
        }
};
/**
 * Manage states of searching People and Teams in search home page.
 */ const $b12059845066d221$var$Store = (0, $WBLbN.createStore)({
    initialState: $b12059845066d221$var$initialState,
    actions: $b12059845066d221$var$actions,
    name: 'SearchHomePage'
});
const $b12059845066d221$export$39314e672c06693f = (0, $WBLbN.createHook)($b12059845066d221$var$Store);
const $b12059845066d221$export$7c58a39ba496932b = (0, $WBLbN.createHook)($b12059845066d221$var$Store, {
    selector: null
});
const $b12059845066d221$export$9da989c55553d02d = (0, $WBLbN.createHook)($b12059845066d221$var$Store, {
    selector: (s)=>s.isTeamCentral
});
const $b12059845066d221$export$20f07b26e9a56b9 = (0, $WBLbN.createHook)($b12059845066d221$var$Store, {
    selector: (s)=>s.isTeamCentral || s.hasWorkspace || s.orgHasWorkspace
});

});
parcelRegister("4QbXv", function(module, exports) {

$parcel$export(module.exports, "default", () => $914340ae6ba5af49$export$2e2bcd8739ae039);

var $avLBj = parcelRequire("avLBj");

var $7YRKk = parcelRequire("7YRKk");
class $914340ae6ba5af49$var$TeamCentralRestClient extends (0, $7YRKk.default) {
    constructor(){
        super({
            serviceUrl: `${(0, $avLBj.getConfig)().stargateRoot}/watermelon`
        });
    }
    async hasWorkspaceForCloudId(cloudId) {
        try {
            await this.getResource(`/workspace/exists?cloudId=${cloudId}`);
            return true;
        } catch (err) {
            return false;
        }
    }
    async doesOrgContainAnyWorkspace(cloudId) {
        try {
            await this.getResource(`/organization/containsAnyWorkspace?cloudId=${cloudId}`);
            return true;
        } catch (err) {
            return false;
        }
    }
}
var /**
 * REST Client to make calls to resources on the team central service.
 *
 * Note: You probably don't want to use this directly. Use the centralised store instead where these values
 * have already been fetched. See useTeamCentralStore().
 *
 * @type {RestClient}
 */ // eslint-disable-next-line import/no-anonymous-default-export
$914340ae6ba5af49$export$2e2bcd8739ae039 = new $914340ae6ba5af49$var$TeamCentralRestClient();

});
parcelRegister("7YRKk", function(module, exports) {

$parcel$export(module.exports, "default", () => $24f1f619e88e4d0d$export$2e2bcd8739ae039);

var $2vzCR = parcelRequire("2vzCR");

var $6l6Xk = parcelRequire("6l6Xk");

var $bIP89 = parcelRequire("bIP89");

var $5s2sH = parcelRequire("5s2sH");

var $3W7Kz = parcelRequire("3W7Kz");

var $lhBhN = parcelRequire("lhBhN");

var $g6xgY = parcelRequire("g6xgY");
const $24f1f619e88e4d0d$var$defaultFetchOptions = {
    credentials: 'include',
    headers: {
        Accept: 'application/json'
    },
    mode: 'cors'
};
const $24f1f619e88e4d0d$var$fetchWithExponentialBackoff = (0, $lhBhN.withDefaultExponentialBackoff)(fetch);
// tslint:disable-next-line no-any
function $24f1f619e88e4d0d$var$parseResponse(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get('content-type');
    if (!contentType || contentType.includes('text/html') || contentType.includes('text/plain')) return response.text();
    if (contentType.includes('application/json')) return response.json();
    return null;
}
async function $24f1f619e88e4d0d$export$91c32f1b22d29b2d(response) {
    let json;
    const text = await response.text();
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp; // to dedupe sentry, scrub non-unique 'timestamp' field from the error body
    if (json.errors) {
        const errs = json.errors.map((error)=>typeof error === 'string' ? error : error.code || error.message || (0, $3W7Kz.DirectoryErrorCode).MISSING_ERROR_MESSAGE);
        return errs.join('\n - ');
    }
    return JSON.stringify(json);
}
let $24f1f619e88e4d0d$var$incrementRedirectCount;
let $24f1f619e88e4d0d$var$clearRedirectCount;
$24f1f619e88e4d0d$export$7a0fc52d8c359feb();
function $24f1f619e88e4d0d$export$7a0fc52d8c359feb() {
    $24f1f619e88e4d0d$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(()=>(0, $5s2sH.setCookie)((0, $5s2sH.REDIRECT_COUNT), (0, $5s2sH.getCookieAsInteger)((0, $5s2sH.REDIRECT_COUNT)) + 1));
    $24f1f619e88e4d0d$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(()=>(0, $5s2sH.clearCookie)((0, $5s2sH.REDIRECT_COUNT)));
}
class $24f1f619e88e4d0d$var$RestClient {
    constructor({ serviceUrl: serviceUrl = '' } = {}){
        /**
	 * This function is necessary for if `statusCodeHandler` prescribes a login
	 * redirect upon a 401 response.
	 * While the default redirect behaviour may be overriden, this function has
	 * been kept separate to ensure it cannot be overriden, lest a host
	 * application supply embeddable-directory with a custom handler that suffers
	 * the infinite redirect bug.
	 */ this.preventInfiniteRedirectLoop = (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $24f1f619e88e4d0d$var$incrementRedirectCount();
            } else $24f1f619e88e4d0d$var$clearRedirectCount();
        };
        this.serviceUrl = serviceUrl;
    }
    async getResource(path) {
        return this.makeRequest(path);
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: 'post',
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                'Content-Type': 'application/json',
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
			 * PATCH must be uppercase as per fetch spec only
			 * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
			 * are normalised to uppercase.
			 *
			 * https://github.com/github/fetch/issues/37
			 * https://fetch.spec.whatwg.org/#methods
			 */ method: 'PATCH'
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        const fetchOptions = {
            method: 'put'
        };
        if (data) Object.assign(fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: 'delete'
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {}) {
        const url = this.serviceUrl + path;
        const options = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, $24f1f619e88e4d0d$var$defaultFetchOptions, additionalFetchOptions);
        const response = await $24f1f619e88e4d0d$var$fetchWithExponentialBackoff(url, options);
        this.preventInfiniteRedirectLoop(response);
        (0, $g6xgY.handleResponse)(response);
        const responseStatusCode = response.status;
        const traceId = response.headers.get('atl-traceid');
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $bIP89.SentryIgnoreError)({
                message: 'Unauthorized Request - incrementing redirect count'
            });
            else {
                const message = await $24f1f619e88e4d0d$export$91c32f1b22d29b2d(response);
                throw new (0, $bIP89.HttpError)({
                    message: message,
                    status: responseStatusCode,
                    traceId: traceId ?? undefined
                });
            }
        }
        return additionalFetchOptions.ignoreResponse ? null : $24f1f619e88e4d0d$var$parseResponse(response);
    }
}
var $24f1f619e88e4d0d$export$2e2bcd8739ae039 = $24f1f619e88e4d0d$var$RestClient;

});
parcelRegister("bIP89", function(module, exports) {

$parcel$export(module.exports, "SentryIgnoreError", () => $0d8d304f06bbe3da$export$20de9a0e470e95aa);
$parcel$export(module.exports, "HttpError", () => $0d8d304f06bbe3da$export$65bd6083489bd8bb);
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $0d8d304f06bbe3da$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message;
        this.stack = new Error(message).stack || '';
    }
}
class $0d8d304f06bbe3da$export$c73ca302efeda3b4 extends $0d8d304f06bbe3da$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $0d8d304f06bbe3da$export$c73ca302efeda3b4.prototype);
    }
}
class $0d8d304f06bbe3da$export$20de9a0e470e95aa extends $0d8d304f06bbe3da$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $0d8d304f06bbe3da$export$20de9a0e470e95aa.prototype);
    }
}
class $0d8d304f06bbe3da$export$65bd6083489bd8bb extends $0d8d304f06bbe3da$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId }){
        super(message);
        Object.setPrototypeOf(this, $0d8d304f06bbe3da$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
    }
}
class $0d8d304f06bbe3da$export$92d6ed0888e7cb7f extends $0d8d304f06bbe3da$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $0d8d304f06bbe3da$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static{
        this.from = (rawErrors)=>{
            const firstError = rawErrors[0];
            const errorData = {
                category: firstError.category,
                message: firstError.message
            };
            if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
                obj[item.field] = item.message;
                return obj;
            }, {});
            return new $0d8d304f06bbe3da$export$92d6ed0888e7cb7f(errorData);
        };
    }
}

});

parcelRegister("5s2sH", function(module, exports) {

$parcel$export(module.exports, "REDIRECT_COUNT", () => $fdd1818a133899fa$export$f6101897f0230549);
$parcel$export(module.exports, "setCookie", () => $fdd1818a133899fa$export$110700823644f4a6);
$parcel$export(module.exports, "getCookieAsInteger", () => $fdd1818a133899fa$export$6a289e5003f59269);
$parcel$export(module.exports, "clearCookie", () => $fdd1818a133899fa$export$ad3506281d5a5e5d);
const $fdd1818a133899fa$export$f6101897f0230549 = 'redirectCount';
const $fdd1818a133899fa$export$5a7d8afb87170e45 = 'avatar.csrf.token';
function $fdd1818a133899fa$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $fdd1818a133899fa$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $fdd1818a133899fa$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}

});




parcelRegister("1wQUJ", function(module, exports) {

$parcel$export(module.exports, "useJiraCheckService", () => $0940e0779d722170$export$b998d6ed276aaffa);

var $eUqFw = parcelRequire("eUqFw");

var $9w676 = parcelRequire("9w676");

var $coKBF = parcelRequire("coKBF");
const $0940e0779d722170$export$3847702755d66eb8 = (cloudId, options)=>{
    const [request, controller] = (0, $eUqFw.useMemo)(()=>(0, $coKBF.defaultRequestAbort)(cloudId), [
        cloudId
    ]);
    const [getJiraCheck, result] = (0, $9w676.useLazyService)(request, controller, {
        initialState: {
            ...options?.initialState
        }
    });
    return [
        getJiraCheck,
        {
            ...result,
            isJiraAvailable: Boolean(result.data?.permitted)
        }
    ];
};
const $0940e0779d722170$export$b998d6ed276aaffa = (...[cloudId, options])=>{
    const [getJiraCheck, result] = $0940e0779d722170$export$3847702755d66eb8(cloudId, options);
    (0, $eUqFw.useEffect)(()=>{
        if (cloudId) getJiraCheck();
    }, [
        cloudId,
        getJiraCheck
    ]);
    return result;
};

});
parcelRegister("coKBF", function(module, exports) {

$parcel$export(module.exports, "defaultRequestAbort", () => $6a29c6a3e09196bb$export$46f584bffbc74fe);

var $boS14 = parcelRequire("boS14");
const $6a29c6a3e09196bb$export$5cf469f83bcf3f9e = '/gateway/api/permissions/permitted';
const $6a29c6a3e09196bb$export$fcd6a587480f569c = (cloudId)=>({
        permissionId: 'write',
        resourceId: `ari:cloud:jira-software::site/${cloudId}`
    });
const $6a29c6a3e09196bb$export$46f584bffbc74fe = (cloudId)=>cloudId ? (0, $boS14.requestWithAbort)($6a29c6a3e09196bb$export$5cf469f83bcf3f9e, {
        body: JSON.stringify($6a29c6a3e09196bb$export$fcd6a587480f569c(cloudId))
    }) : [
        ()=>Promise.resolve(new Response()),
        new AbortController()
    ];

});


parcelRegister("lnHnV", function(module, exports) {

$parcel$export(module.exports, "TeamsWrapper", () => $686fad245ce3537f$export$7d5cea3023a4360c);

var $eUqFw = parcelRequire("eUqFw");

var $4MkQ9 = parcelRequire("4MkQ9");

var $hbP2g = parcelRequire("hbP2g");

var $fcdA0 = parcelRequire("fcdA0");

var $aupWM = parcelRequire("aupWM");

var $jvxHp = parcelRequire("jvxHp");

var $nagX1 = parcelRequire("nagX1");
const $686fad245ce3537f$var$IS_LOCAL = false;
function $686fad245ce3537f$export$7d5cea3023a4360c({ children: children, appConfig: appConfig }) {
    (0, $fcdA0.useTeamsSentryClientSetup)(!$686fad245ce3537f$var$IS_LOCAL, {
        env: appConfig.env,
        appName: appConfig.appName ? `${appConfig.appName}` : undefined
    });
    (0, $aupWM.useSetAppConfig)(appConfig);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvxHp.AppConfigProvider), appConfig, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $nagX1.ProfileCardClientConfigProvider), appConfig, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4MkQ9.WrappedPeopleTeamsAnalyticsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hbP2g.DialogProvider), null, children))));
}

});
parcelRegister("4MkQ9", function(module, exports) {

$parcel$export(module.exports, "WrappedPeopleTeamsAnalyticsProvider", () => $e4002ee4296d3b4e$export$b73a44d03ba9da78);
$parcel$export(module.exports, "usePeopleTeamAnalyticsEvents", () => $e4002ee4296d3b4e$export$48acf7e27d4331f);
$parcel$export(module.exports, "useTeamsExperienceTracker", () => $e4002ee4296d3b4e$export$5792e6ebc464482e);

var $eUqFw = parcelRequire("eUqFw");

var $dcbVh = parcelRequire("dcbVh");

var $fcW8A = parcelRequire("fcW8A");

var $dIJIS = parcelRequire("dIJIS");

var $hoy9g = parcelRequire("hoy9g");

var $eibJo = parcelRequire("eibJo");
const $e4002ee4296d3b4e$var$defaultAnalyticsContextData = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $e4002ee4296d3b4e$export$b73a44d03ba9da78({ analyticsContextData: analyticsContextData, children: children }) {
    const data = (0, $eUqFw.useMemo)(()=>{
        if (typeof analyticsContextData === 'object') return {
            ...$e4002ee4296d3b4e$var$defaultAnalyticsContextData,
            ...analyticsContextData
        };
        return $e4002ee4296d3b4e$var$defaultAnalyticsContextData;
    }, [
        analyticsContextData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dcbVh.PeopleTeamsAnalyticsContext), {
        data: data
    }, children);
}
const $e4002ee4296d3b4e$export$48acf7e27d4331f = ()=>{
    const [{ eventAttributes: injectedEventAttributes }, { setEventAttributes: setEventAttributes }] = (0, $fcW8A.usePeopleTeamsAnalyticsSubcontext)();
    const { fireEvent: fireEvent } = (0, $hoy9g.useAnalyticsEvents)();
    const fireEventWithSubcontextAttributesInjected = (0, $eUqFw.useCallback)((...params)=>{
        const [event, attributes] = params;
        const eventWithSubcontextAttributes = {
            ...attributes,
            ...injectedEventAttributes
        };
        // @ts-ignore allow injecting subcontext attributes
        fireEvent(event, eventWithSubcontextAttributes);
    }, [
        fireEvent,
        injectedEventAttributes
    ]);
    return {
        fireEvent: fireEventWithSubcontextAttributesInjected,
        setInjectedEventAttributes: setEventAttributes
    };
};
const $e4002ee4296d3b4e$export$b72f2eb2a11f7b8 = ()=>(0, $eibJo.useAnalyticsEventsWithTags)();
const $e4002ee4296d3b4e$export$5792e6ebc464482e = ()=>{
    const { fireEvent: fireEvent } = $e4002ee4296d3b4e$export$48acf7e27d4331f();
    const fireExperienceEvent = (0, $eUqFw.useCallback)((action, subject, attributes)=>{
        // @ts-ignore TODO: we may need to declare the keys to a const in the types file so we can do a check here
        fireEvent(`operational.${subject.replace(/[\/-]/g, '_')}.${action}`, {
            ...attributes,
            source: 'clientMetrics'
        });
    }, [
        fireEvent
    ]);
    const experienceTracker = (0, $eUqFw.useMemo)(()=>(0, $dIJIS.createTeamsExperienceTracker)(fireExperienceEvent), [
        fireExperienceEvent
    ]);
    return experienceTracker;
};

});
parcelRegister("fcW8A", function(module, exports) {

$parcel$export(module.exports, "usePeopleTeamsAnalyticsSubcontext", () => $853557399d2da6aa$export$86448e866930ba8d);
$parcel$export(module.exports, "useInjectedEventAttribute", () => $853557399d2da6aa$export$831917a198e22e70);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");
const $853557399d2da6aa$var$initialState = {
    eventAttributes: {}
};
const $853557399d2da6aa$var$actions = {
    setEventAttributes: (eventAttributes)=>({ setState: setState, getState: getState })=>{
            const existingEventAttributes = getState().eventAttributes;
            const newEventAttributes = {
                ...existingEventAttributes,
                ...eventAttributes
            };
            Object.keys(newEventAttributes).forEach((keyString)=>{
                const key = keyString;
                if (newEventAttributes[key] === undefined) delete newEventAttributes[key];
            });
            setState({
                eventAttributes: newEventAttributes
            });
        }
};
const $853557399d2da6aa$var$AnalyticsSubcontextStore = (0, $WBLbN.createStore)({
    initialState: $853557399d2da6aa$var$initialState,
    actions: $853557399d2da6aa$var$actions
});
const $853557399d2da6aa$export$86448e866930ba8d = (0, $WBLbN.createHook)($853557399d2da6aa$var$AnalyticsSubcontextStore);
const $853557399d2da6aa$export$831917a198e22e70 = (key, value)=>{
    const { setEventAttributes: setEventAttributes } = $853557399d2da6aa$export$86448e866930ba8d()[1];
    (0, $eUqFw.useEffect)(()=>{
        setEventAttributes({
            [key]: value
        });
        return ()=>setEventAttributes({
                [key]: undefined
            });
    }, [
        key,
        value,
        setEventAttributes
    ]);
};

});

parcelRegister("dIJIS", function(module, exports) {

$parcel$export(module.exports, "createTeamsExperienceTracker", () => $bbae83430c0c67db$export$c0c885a04612b38d);

var $74BVL = parcelRequire("74BVL");

var $c4v9k = parcelRequire("c4v9k");

var $iDMVZ = parcelRequire("iDMVZ");
function $bbae83430c0c67db$export$c0c885a04612b38d(fireExperienceEvent, options) {
    const tracker = new (0, $c4v9k.TeamsExperienceTracker)({
        isNetworkOfflineError: (0, $iDMVZ.isNetworkError)
    });
    tracker.subscribe((event)=>{
        if (event.action === 'taskStart' || event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail') {
            const performanceAttributes = (0, $iDMVZ.computePerformanceAttributes)(event);
            const errorAttributes = (0, $iDMVZ.computeErrorAttributes)(event);
            const finalErrorDetails = Object.assign(errorAttributes, performanceAttributes, event.attributes, {
                // Because standalone app is deployed to prod quickly,
                // we will use this attribute to query in Splunk sooner.
                isStandalone: !!options?.isStandalone,
                hasBrowseUsersPermission: !!options?.hasBrowseUsersPermission
            });
            fireExperienceEvent(event.action, event.name, finalErrorDetails);
            if (event.action === 'taskFail' && options?.logErrorMessage) options.logErrorMessage(`taskFail:${event.name}`, finalErrorDetails);
        }
    });
    (0, $74BVL.bindAll)(window, [
        {
            type: 'unload',
            listener: ()=>tracker.abort({
                    reason: 'Abort due to Window unloading',
                    attributes: {
                        cause: 'WINDOW_UNLOAD'
                    }
                })
        },
        {
            type: 'pagehide',
            listener: ()=>{
                tracker.abort({
                    reason: 'Window unloading',
                    attributes: {
                        cause: 'PAGE_HIDE'
                    }
                });
            }
        }
    ]);
    return tracker;
}

});
parcelRegister("c4v9k", function(module, exports) {

$parcel$export(module.exports, "TeamsExperienceTracker", () => $422f184a6cf2157a$export$9e9a48cf2c297bd1);

var $hUYqC = parcelRequire("hUYqC");

var $dgmsd = parcelRequire("dgmsd");
class $422f184a6cf2157a$export$9e9a48cf2c297bd1 extends (0, $hUYqC.ExperienceTracker) {
    _errorNameInIgnoredList(error) {
        const name = error && error.constructor.name;
        return this._ignoredErrors.includes(name) ? name : undefined;
    }
    constructor(options){
        super(options);
        // error names here will also be sent in the attribute `cause`
        this._ignoredErrors = [
            'SentryIgnoreError'
        ];
    }
    stopOnError({ name: name, error: error }) {
        if ((0, $dgmsd.isAuthError)(error)) {
            this.abort({
                name: name,
                reason: 'Abort due to user unauthenticated',
                attributes: {
                    cause: 'USER_UNAUTHENTICATED',
                    error: error
                },
                checkForTimeout: false
            });
            return;
        }
        if ((0, $dgmsd.isErrorStatusCode)((0, $dgmsd.StatusCode).GONE, error)) {
            this.abort({
                name: name,
                reason: 'Abort due to unavailable resource',
                attributes: {
                    cause: 'GONE',
                    error: error
                },
                checkForTimeout: false
            });
            return;
        }
        const ignoredErrorName = this._errorNameInIgnoredList(error);
        if (ignoredErrorName) {
            this.abort({
                name: name,
                reason: 'Abort due to an error in ignore list',
                attributes: {
                    cause: ignoredErrorName
                },
                checkForTimeout: false
            });
            return;
        }
        super.stopOnError({
            name: name,
            error: error
        });
    }
}

});
parcelRegister("dgmsd", function(module, exports) {

$parcel$export(module.exports, "StatusCode", () => $79950f660a5fd4ec$export$f66f92b8741acd5b);
$parcel$export(module.exports, "isAuthError", () => $79950f660a5fd4ec$export$cde1786a482f9a1c);
$parcel$export(module.exports, "isErrorStatusCode", () => $79950f660a5fd4ec$export$9677d7c364ada66c);
var $79950f660a5fd4ec$export$f66f92b8741acd5b;
(function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
})($79950f660a5fd4ec$export$f66f92b8741acd5b || ($79950f660a5fd4ec$export$f66f92b8741acd5b = {}));
function $79950f660a5fd4ec$export$cde1786a482f9a1c(error) {
    return $79950f660a5fd4ec$export$9677d7c364ada66c(401, error) || $79950f660a5fd4ec$export$9677d7c364ada66c(403, error);
}
function $79950f660a5fd4ec$export$9677d7c364ada66c(statusCode, error) {
    if (!error) return false;
    if (error['status'] === statusCode || error['statusCode'] === statusCode) return true;
    const reg = new RegExp(`status (code)?.*(${statusCode})`);
    return !!error?.message?.match(reg);
}

});


parcelRegister("iDMVZ", function(module, exports) {

$parcel$export(module.exports, "isNetworkError", () => $62eac4a9fff37424$export$476aa014e2fd89d5);
$parcel$export(module.exports, "computeErrorAttributes", () => $62eac4a9fff37424$export$5e7501d1cb9a5aa0);
$parcel$export(module.exports, "computePerformanceAttributes", () => $62eac4a9fff37424$export$b978343735080139);

var $leHv2 = parcelRequire("leHv2");
function $62eac4a9fff37424$export$476aa014e2fd89d5(error) {
    return error && !!error.message && // Firefox
    (error.message.includes('NetworkError') || // Chrome
    error.message.startsWith('Failed to fetch') || error.message.includes('GraphQL error: Failed to fetch') || // cancel by users or unknown reason
    error.message.includes('GraphQL error: The operation was aborted') || error.message.includes('GraphQL error: cancelled') || error.message.includes('Abgebrochen') || error.message.includes("\u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E") || error.message.includes("\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0442\u0435\u0440\u044F\u043D\u043E.") || error.message.includes('anulowane') || error.message.includes("annul\xe9") || error.message.includes("\u5DF2\u53D6\u6D88") || error.message.includes('cancelado') || error.message.includes("\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F") || error.message.includes('cancelled') || error.message.includes('Network error') || // GraphQL-wrapping network error
    !!(error['graphQLErrors'] && error['networkError']));
}
function $62eac4a9fff37424$export$5e7501d1cb9a5aa0(event) {
    const attributes = {};
    if ($62eac4a9fff37424$var$isFailEvent(event)) attributes.failError = event.error;
    if ($62eac4a9fff37424$var$isAbortEvent(event)) attributes.abortReason = event.reason;
    return attributes;
}
function $62eac4a9fff37424$export$b978343735080139(event) {
    if ($62eac4a9fff37424$var$isStopEvent(event)) {
        const duration = event.duration;
        const latencySlo = event.attributes && $62eac4a9fff37424$var$hasLatencySLO(event.attributes) && event.attributes['latencySlo'];
        if (typeof duration !== 'number' || typeof latencySlo !== 'number') return {};
        return {
            sloSatisfied: duration <= latencySlo,
            taskDuration: duration,
            latencySlo: latencySlo
        };
    }
    return {};
}
function $62eac4a9fff37424$var$isStopEvent(e) {
    return (0, $leHv2.isStop)(e);
}
function $62eac4a9fff37424$var$isFailEvent(e) {
    return e.action === 'taskFail';
}
function $62eac4a9fff37424$var$isAbortEvent(e) {
    return e.action === 'taskAbort';
}
function $62eac4a9fff37424$var$hasLatencySLO(attributes) {
    return Object(attributes).hasOwnProperty('latencySlo');
}

});
parcelRegister("leHv2", function(module, exports) {

$parcel$export(module.exports, "isStop", () => $eab71776b63487cc$export$16e3f1b03b231b35);
$parcel$export(module.exports, "hasName", () => $eab71776b63487cc$export$57069f5b2ecc9128);
const $eab71776b63487cc$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $eab71776b63487cc$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);

});



parcelRegister("hoy9g", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $302edda2643b42d1$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::e5658fd58feb1dc44871f04f2de92d8a>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen people-teams-ui
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $8Ng9u = parcelRequire("8Ng9u");

var $4oQpM = parcelRequire("4oQpM");
const $302edda2643b42d1$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireEvent = (0, $eUqFw.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $4oQpM.default)(...params));
        event.fire((0, $8Ng9u.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("8Ng9u", function(module, exports) {

$parcel$export(module.exports, "EVENT_CHANNEL", () => $da3f6a3574c672d1$export$3f072f06b90c3985);

var $88sYM = parcelRequire("88sYM");
const $da3f6a3574c672d1$export$3f072f06b90c3985 = (0, $88sYM.FabricChannel).peopleTeams;

});

parcelRegister("4oQpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8130caa2eeb8088f$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::0d40b99453dc3bdb802ab78b4560ab56>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen people-teams-ui
 */ const $8130caa2eeb8088f$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $8130caa2eeb8088f$export$2e2bcd8739ae039 = $8130caa2eeb8088f$var$createEventPayload;

});


parcelRegister("eibJo", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEventsWithTags", () => $f7bc74d7f38ff9e8$export$e8e0cef07f76dd91);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $8Ng9u = parcelRequire("8Ng9u");

var $4oQpM = parcelRequire("4oQpM");
const $f7bc74d7f38ff9e8$export$e8e0cef07f76dd91 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireEventWithTags = (0, $eUqFw.useCallback)((tags, ...params)=>{
        const event = createAnalyticsEvent((0, $4oQpM.default)(...params));
        if (event.payload) event.payload.tags = tags;
        event.fire((0, $8Ng9u.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEventWithTags: fireEventWithTags
    };
};

});


parcelRegister("hbP2g", function(module, exports) {

$parcel$export(module.exports, "DialogProvider", () => $26363409c20a3039$export$7ab5cfe96fae86d3);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $4pz2s = parcelRequire("4pz2s");
const $26363409c20a3039$var$dialogProviderReducer = (state, action)=>{
    switch(action.type){
        case 'open':
            return {
                ...state,
                DialogComponent: action.payload?.DialogComponent || null,
                isOpen: true
            };
        case 'close':
            return {
                ...state,
                DialogComponent: null,
                dialogProps: null,
                isOpen: false
            };
        default:
            throw new Error(`Unhandled type for dialogReducer: ${action.type}`);
    }
};
const $26363409c20a3039$export$b52337b35cd3c980 = (props)=>{
    const { DialogComponent: DialogComponent, isOpen: isOpen, onClose: onClose } = props;
    const { closeDialog: closeDialog } = (0, $eUqFw.useContext)((0, $4pz2s.DialogContext));
    if (!DialogComponent) return null;
    const handleCloseDialog = ()=>{
        closeDialog();
        if (onClose) onClose();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(DialogComponent, {
        onClose: handleCloseDialog
    }));
};
const $26363409c20a3039$export$7ab5cfe96fae86d3 = ({ children: children })=>{
    const [dialogProviderState, dispatch] = (0, $eUqFw.useReducer)($26363409c20a3039$var$dialogProviderReducer, {
        DialogComponent: null,
        isOpen: false
    });
    const value = (0, $eUqFw.useMemo)(()=>({
            openDialog: (DialogComponent)=>dispatch({
                    type: 'open',
                    payload: {
                        DialogComponent: DialogComponent
                    }
                }),
            closeDialog: ()=>dispatch({
                    type: 'close'
                })
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4pz2s.DialogContext).Provider, {
        value: value
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($26363409c20a3039$export$b52337b35cd3c980, dialogProviderState));
};

});
parcelRegister("4pz2s", function(module, exports) {

$parcel$export(module.exports, "DialogContext", () => $50c7b3c04fb05296$export$8b93a07348a7730c);

var $eUqFw = parcelRequire("eUqFw");
const $50c7b3c04fb05296$export$8b93a07348a7730c = (0, $eUqFw.createContext)({
    openDialog: ()=>null,
    closeDialog: ()=>null
});

});


parcelRegister("aupWM", function(module, exports) {

$parcel$export(module.exports, "useSetAppConfig", () => $66b8a5d544869c17$export$338e93cfada2e9d7);

var $1DnXE = parcelRequire("1DnXE");

var $8YnxP = parcelRequire("8YnxP");

var $fvJih = parcelRequire("fvJih");
const $66b8a5d544869c17$export$338e93cfada2e9d7 = (appConfig)=>{
    (0, $1DnXE.useSetClientConfig)({
        cloudId: appConfig.cloudId,
        stargateRoot: appConfig.stargateRoot,
        env: appConfig.env,
        orgId: appConfig.orgId,
        principalUserId: appConfig.principalUserId
    });
    (0, $fvJih.useSetTeamsProductConfig)({
        appName: appConfig.appName,
        productName: appConfig.productName,
        isJiraAvailable: appConfig.isJiraAvailable,
        subProduct: appConfig.subProduct,
        locale: appConfig.locale,
        productFeatureFlags: appConfig.productFeatureFlags
    });
    (0, $8YnxP.useSetTeamsNavigationConfig)({
        contextSpaPaths: appConfig.contextSpaPaths,
        contextEntryPoint: appConfig.contextEntryPoint
    });
};

});
parcelRegister("1DnXE", function(module, exports) {

$parcel$export(module.exports, "useSetClientConfig", () => $77c55830228dffdc$export$2f68760d90a1443f);

var $eUqFw = parcelRequire("eUqFw");

var $2M4K2 = parcelRequire("2M4K2");

var $7QGbN = parcelRequire("7QGbN");
const $77c55830228dffdc$export$2f68760d90a1443f = (clientConfig)=>{
    const { setClientConfig: setClientConfig } = (0, $7QGbN.useSetTeamsConfigActions)();
    (0, $2M4K2.useTeamsClientSetup)(clientConfig.stargateRoot, clientConfig.cloudId, clientConfig.orgId);
    (0, $eUqFw.useEffect)(()=>{
        setClientConfig(clientConfig);
    }, [
        setClientConfig,
        clientConfig
    ]);
};

});
parcelRegister("2M4K2", function(module, exports) {

$parcel$export(module.exports, "useTeamsClientSetup", () => $bdff1aa08c1d4521$export$50a3d4f5c944b117);

var $eUqFw = parcelRequire("eUqFw");

var $cAxhS = parcelRequire("cAxhS");

var $jnlyS = parcelRequire("jnlyS");
const $bdff1aa08c1d4521$export$50a3d4f5c944b117 = (stargateRoot, cloudId, orgId)=>{
    (0, $eUqFw.useEffect)(()=>{
        if (!stargateRoot) return;
        (0, $cAxhS.teamsClient).setBaseUrl(stargateRoot);
    }, [
        stargateRoot
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cAxhS.teamsClient).setContext({
            cloudId: cloudId,
            orgId: orgId
        });
        if (!orgId) (0, $jnlyS.logErrorMessage)(`No orgId set - useTeamsClientSetup`, {
            cloudId: cloudId
        });
    }, [
        cloudId,
        orgId
    ]);
};

});

parcelRegister("7QGbN", function(module, exports) {

$parcel$export(module.exports, "useAppConfigStoreState", () => $5cc85e4b54ee5ac2$export$ace1f350f4f044c0);
$parcel$export(module.exports, "useSetTeamsConfigActions", () => $5cc85e4b54ee5ac2$export$b652cf4936246835);
$parcel$export(module.exports, "useNavigationState", () => $5cc85e4b54ee5ac2$export$e482f4662aebc4a0);

var $WBLbN = parcelRequire("WBLbN");
const $5cc85e4b54ee5ac2$var$defaultNavigationState = {
    contextSpaPaths: [],
    contextEntryPoint: null
};
const $5cc85e4b54ee5ac2$var$defaultClientConfigState = {
    cloudId: null,
    stargateRoot: '',
    env: undefined
};
const $5cc85e4b54ee5ac2$var$defaultTeamsProductConfigState = {
    appName: null,
    productName: null,
    isJiraAvailable: false
};
const $5cc85e4b54ee5ac2$var$defaultState = {
    ...$5cc85e4b54ee5ac2$var$defaultNavigationState,
    ...$5cc85e4b54ee5ac2$var$defaultClientConfigState,
    ...$5cc85e4b54ee5ac2$var$defaultTeamsProductConfigState,
    docTitle: {}
};
const $5cc85e4b54ee5ac2$var$actions = {
    setNavigationConfig: (navigationConfig)=>({ setState: setState })=>{
            setState({
                ...navigationConfig
            });
        },
    setClientConfig: (clientConfig)=>({ setState: setState })=>{
            setState({
                ...clientConfig
            });
        },
    setTeamsProductConfig: (teamsProductConfig)=>({ setState: setState })=>{
            setState({
                ...teamsProductConfig
            });
        },
    // Set all config at once
    setAppConfig: (appConfig)=>({ setState: setState })=>{
            setState({
                ...appConfig
            });
        }
};
const $5cc85e4b54ee5ac2$var$AppConfigStore = (0, $WBLbN.createStore)({
    initialState: $5cc85e4b54ee5ac2$var$defaultState,
    actions: $5cc85e4b54ee5ac2$var$actions
});
const $5cc85e4b54ee5ac2$export$61884cfbde7fd829 = (0, $WBLbN.createHook)($5cc85e4b54ee5ac2$var$AppConfigStore);
const $5cc85e4b54ee5ac2$var$useAppConfigActions = (0, $WBLbN.createHook)($5cc85e4b54ee5ac2$var$AppConfigStore, {
    selector: null
});
const $5cc85e4b54ee5ac2$export$ace1f350f4f044c0 = ()=>$5cc85e4b54ee5ac2$export$61884cfbde7fd829()[0];
const $5cc85e4b54ee5ac2$export$b652cf4936246835 = ()=>{
    return $5cc85e4b54ee5ac2$var$useAppConfigActions()[1];
};
const $5cc85e4b54ee5ac2$export$7b278989f04c1040 = ()=>$5cc85e4b54ee5ac2$export$ace1f350f4f044c0().appName;
const $5cc85e4b54ee5ac2$export$e482f4662aebc4a0 = ()=>{
    const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint } = $5cc85e4b54ee5ac2$export$ace1f350f4f044c0();
    return {
        contextSpaPaths: contextSpaPaths,
        contextEntryPoint: contextEntryPoint
    };
};

});


parcelRegister("8YnxP", function(module, exports) {

$parcel$export(module.exports, "useSetTeamsNavigationConfig", () => $eb0231108fd8c267$export$254030771a907fca);

var $eUqFw = parcelRequire("eUqFw");

var $7QGbN = parcelRequire("7QGbN");
const $eb0231108fd8c267$export$254030771a907fca = (config)=>{
    const { setNavigationConfig: setNavigationConfig } = (0, $7QGbN.useSetTeamsConfigActions)();
    (0, $eUqFw.useEffect)(()=>{
        setNavigationConfig(config);
    }, [
        setNavigationConfig,
        config
    ]);
};

});

parcelRegister("fvJih", function(module, exports) {

$parcel$export(module.exports, "useSetTeamsProductConfig", () => $cdd34fd473eebb6d$export$f8296902b02e4ba1);

var $eUqFw = parcelRequire("eUqFw");

var $7QGbN = parcelRequire("7QGbN");
const $cdd34fd473eebb6d$export$f8296902b02e4ba1 = (teamsProductConfig)=>{
    const { setTeamsProductConfig: setTeamsProductConfig } = (0, $7QGbN.useSetTeamsConfigActions)();
    (0, $eUqFw.useEffect)(()=>{
        setTeamsProductConfig(teamsProductConfig);
    }, [
        setTeamsProductConfig,
        teamsProductConfig
    ]);
};

});


parcelRegister("jvxHp", function(module, exports) {

$parcel$export(module.exports, "AppConfigProvider", () => $aa3d7b0453d67589$export$42f491f31057ae78);
$parcel$export(module.exports, "useNavigationActions", () => $aa3d7b0453d67589$export$d52b0df9de5d0e40);
$parcel$export(module.exports, "useAddFlag", () => $aa3d7b0453d67589$export$6d75236f0e3dc17e);

var $eUqFw = parcelRequire("eUqFw");

var $369AT = parcelRequire("369AT");

var $3mCjh = parcelRequire("3mCjh");

var $7QGbN = parcelRequire("7QGbN");
const $aa3d7b0453d67589$var$error = new Error('AppConfig is not setup in RSS');
const $aa3d7b0453d67589$var$defaultValue = {
    push: ()=>{
        throw $aa3d7b0453d67589$var$error;
    },
    replace: ()=>{
        throw $aa3d7b0453d67589$var$error;
    },
    addFlag: ()=>{
        throw $aa3d7b0453d67589$var$error;
    }
};
const $aa3d7b0453d67589$var$AppConfigContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($aa3d7b0453d67589$var$defaultValue);
function $aa3d7b0453d67589$export$42f491f31057ae78({ children: children, push: pushProp, replace: replaceProp, addFlag: addFlagProp }) {
    const { contextEntryPoint: contextEntryPoint } = (0, $7QGbN.useNavigationState)();
    const addFlag = (0, $eUqFw.useCallback)((props)=>{
        const { type: type, ...rest } = props;
        addFlagProp({
            ...rest,
            id: rest.id ? `${rest.id}.${Date.now()}` : Date.now(),
            type: type,
            appearance: 'normal',
            icon: (0, $369AT.getTypeIcon)(type)
        });
    }, [
        addFlagProp
    ]);
    const push = (0, $eUqFw.useCallback)((path)=>{
        const finalPath = (0, $3mCjh.prefixWithContextEntryPoint)(path, contextEntryPoint);
        return pushProp(finalPath);
    }, [
        pushProp,
        contextEntryPoint
    ]);
    const replace = (0, $eUqFw.useCallback)((path)=>{
        const finalPath = (0, $3mCjh.prefixWithContextEntryPoint)(path, contextEntryPoint);
        return replaceProp(finalPath);
    }, [
        contextEntryPoint,
        replaceProp
    ]);
    const configValue = (0, $eUqFw.useMemo)(()=>({
            addFlag: addFlag,
            push: push,
            replace: replace
        }), [
        addFlag,
        push,
        replace
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa3d7b0453d67589$var$AppConfigContext.Provider, {
        value: configValue
    }, children);
}
const $aa3d7b0453d67589$var$useAppConfigProvider = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($aa3d7b0453d67589$var$AppConfigContext);
const $aa3d7b0453d67589$export$d52b0df9de5d0e40 = ()=>{
    const { push: push, replace: replace } = $aa3d7b0453d67589$var$useAppConfigProvider();
    return {
        push: push,
        replace: replace
    };
};
const $aa3d7b0453d67589$export$6d75236f0e3dc17e = ()=>{
    const { addFlag: addFlag } = $aa3d7b0453d67589$var$useAppConfigProvider();
    return addFlag;
};

});
parcelRegister("369AT", function(module, exports) {

$parcel$export(module.exports, "getTypeIcon", () => $acd49c5dcdacb2d3$export$672f92b0d52b7cfe);

var $eUqFw = parcelRequire("eUqFw");

var $cHccS = parcelRequire("cHccS");

var $gw74N = parcelRequire("gw74N");

var $1Qu2i = parcelRequire("1Qu2i");

const $acd49c5dcdacb2d3$var$flagIconByType = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gw74N))), {
        spacing: "spacious",
        label: "",
        color: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Qu2i))), {
        spacing: "spacious",
        label: "",
        color: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$export$c6930421db9fa514)})`
    })
};
const $acd49c5dcdacb2d3$var$DefaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cHccS))), {
    spacing: "spacious",
    label: "",
    color: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`
});
const $acd49c5dcdacb2d3$export$672f92b0d52b7cfe = (type = 'normal')=>$acd49c5dcdacb2d3$var$flagIconByType[type] || $acd49c5dcdacb2d3$var$DefaultIcon;

});
parcelRegister("cHccS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::677aca11d503d1f7ee44040643ebf960>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93e2f82bc79b3261$var$_react = $93e2f82bc79b3261$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $93e2f82bc79b3261$var$_checkCircle = $93e2f82bc79b3261$var$_interopRequireDefault((parcelRequire("9pzt9")));

var $93e2f82bc79b3261$var$_checkCircle2 = $93e2f82bc79b3261$var$_interopRequireDefault((parcelRequire("aWvIp")));
function $93e2f82bc79b3261$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckCircleIcon.
 * This component is CheckCircleIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: success section messages or a list of done items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $93e2f82bc79b3261$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $93e2f82bc79b3261$var$_react.default.createElement($93e2f82bc79b3261$var$_checkCircle.default, Object.assign({
        LEGACY_fallbackIcon: $93e2f82bc79b3261$var$_checkCircle2.default
    }, props));
$93e2f82bc79b3261$var$CheckCircleIcon.Name = 'CheckCircleIconMigration';
var $93e2f82bc79b3261$var$_default = module.exports.default = $93e2f82bc79b3261$var$CheckCircleIcon;

});

var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';


parcelRegister("3mCjh", function(module, exports) {

$parcel$export(module.exports, "isAbsoluteLink", () => $c59df311e83496b4$export$895d6838d29edd02);
$parcel$export(module.exports, "prefixWithContextEntryPoint", () => $c59df311e83496b4$export$715c8f9057ac0c01);
$parcel$export(module.exports, "getRelativeUrl", () => $c59df311e83496b4$export$d614758658023fd);
$parcel$export(module.exports, "EXTERNAL_LINKS", () => $c59df311e83496b4$export$4cf71c31cd7fa836);

var $bAnhx = parcelRequire("bAnhx");

var $chxpa = parcelRequire("chxpa");
const $c59df311e83496b4$export$895d6838d29edd02 = (url)=>{
    return url.startsWith('http') || url.startsWith('www');
};
const $c59df311e83496b4$export$715c8f9057ac0c01 = (path, contextEntryPoint = null)=>{
    if ($c59df311e83496b4$export$895d6838d29edd02(path) || // do not prefix for absolute URL
    contextEntryPoint && path.startsWith(contextEntryPoint) || // do not prefix if the link already has product context path
    path.startsWith('/')) return path;
    return `${contextEntryPoint}/${path}`;
};
const $c59df311e83496b4$export$d614758658023fd = (url)=>{
    if (!$c59df311e83496b4$export$895d6838d29edd02(url)) return url;
    try {
        const { pathname: pathname, search: search, hash: hash } = new URL(url);
        return `${pathname}${search}${hash}`;
    } catch (error) {
        (0, $chxpa.logException)(error, 'Cannot parse URL in getRelativeUrl', {
            url: url
        });
    }
    return url;
};
const $c59df311e83496b4$export$4cf71c31cd7fa836 = {
    TEAM_INVITE_LEARN_MORE: `${(0, $bAnhx.getAtlassianContextUrl)('support')}/atlassian-account/docs/start-an-atlassian-team/#Add-or-remove-members-of-a-team`
};

});
parcelRegister("bAnhx", function(module, exports) {

$parcel$export(module.exports, "getAtlassianContextUrl", () => $299d3bc44f0f7017$export$9986ff99701c314f);
$parcel$export(module.exports, "getAtlassianContextDomain", () => $299d3bc44f0f7017$export$50f0d77e468746eb);

var $bW292 = parcelRequire("bW292");

var $avLBj = parcelRequire("avLBj");
function $299d3bc44f0f7017$export$9986ff99701c314f(domainKey) {
    if ((0, $avLBj.isFedramp)()) return (0, $bW292.getATLContextUrl)(domainKey);
    else return `https://${domainKey}.atlassian.com`;
}
function $299d3bc44f0f7017$export$50f0d77e468746eb(domainKey) {
    if ((0, $avLBj.isFedramp)()) return (0, $bW292.getATLContextDomain)(domainKey);
    else return `${domainKey}.atlassian.com`;
}

});



parcelRegister("nagX1", function(module, exports) {

$parcel$export(module.exports, "ProfileCardClientConfigProvider", () => $a87a24aa67c2e32c$export$47bd48f80e3bc7b3);

var $eUqFw = parcelRequire("eUqFw");

var $9dvKM = parcelRequire("9dvKM");

var $bCEZR = parcelRequire("bCEZR");
function $a87a24aa67c2e32c$export$47bd48f80e3bc7b3({ children: children, ...props }) {
    const profileCardClient = (0, $bCEZR.useProfileClient)();
    const config = (0, $eUqFw.useMemo)(()=>({
            ...props,
            profileCardClient: profileCardClient
        }), [
        props,
        profileCardClient
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9dvKM.ProfileCardClientConfigContext).Provider, {
        value: config
    }, children);
}

});
parcelRegister("9dvKM", function(module, exports) {

$parcel$export(module.exports, "ProfileCardClientConfigContext", () => $b7078bb491c002ec$export$c804cb3b184b670f);
$parcel$export(module.exports, "useProfileCardClientConfig", () => $b7078bb491c002ec$export$a3c560c84e5d436d);

var $eUqFw = parcelRequire("eUqFw");
const $b7078bb491c002ec$var$error = new Error('ProfileCardClientConfigProvider is not found in higher components');
const $b7078bb491c002ec$var$defaultState = {
    addFlag: ()=>{
        // eslint-disable-next-line no-console
        console.error($b7078bb491c002ec$var$error);
    },
    push: ()=>{
        // eslint-disable-next-line no-console
        console.error($b7078bb491c002ec$var$error);
    },
    contextEntryPoint: null,
    cloudId: null
};
const $b7078bb491c002ec$export$c804cb3b184b670f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($b7078bb491c002ec$var$defaultState);
const $b7078bb491c002ec$export$a3c560c84e5d436d = ()=>(0, $eUqFw.useContext)($b7078bb491c002ec$export$c804cb3b184b670f);

});

parcelRegister("bCEZR", function(module, exports) {

$parcel$export(module.exports, "useProfileClient", () => $5cbeb46e44fe9407$export$d43dc22a8337ee9f);

var $eUqFw = parcelRequire("eUqFw");

var $WBLbN = parcelRequire("WBLbN");

var $8PYmV = parcelRequire("8PYmV");

var $WQNHl = parcelRequire("WQNHl");
const $5cbeb46e44fe9407$var$CACHE_MAX_AGE = 60000;
const $5cbeb46e44fe9407$var$actions = {
    createClient: (stargateRoot, enableTeamCentral = false)=>({ setState: setState })=>{
            const profileClient = new (0, $8PYmV.default)({
                gatewayGraphqlUrl: `${stargateRoot}/graphql`,
                url: `${stargateRoot}/directory/graphql`,
                teamCentralUrl: enableTeamCentral ? `${stargateRoot}/watermelon/graphql` : undefined,
                // teamCentralBaseUrl: enableTeamCentral
                //   ? getConfig().teamCentralUrl
                //   : undefined,
                cacheSize: 20,
                cacheMaxAge: $5cbeb46e44fe9407$var$CACHE_MAX_AGE
            });
            setState({
                profileClient: profileClient
            });
            return profileClient;
        }
};
const $5cbeb46e44fe9407$var$ProfileClientStore = (0, $WBLbN.createStore)({
    initialState: {},
    actions: $5cbeb46e44fe9407$var$actions
});
const $5cbeb46e44fe9407$var$useProfileClientState = (0, $WBLbN.createHook)($5cbeb46e44fe9407$var$ProfileClientStore);
const $5cbeb46e44fe9407$export$d43dc22a8337ee9f = ()=>{
    // const [teamCentralStore] = useTeamCentralStore();
    const [{ profileClient: profileClient }, { createClient: createClient }] = $5cbeb46e44fe9407$var$useProfileClientState();
    const { stargateRoot: stargateRoot } = (0, $WQNHl.useAppConfig)();
    (0, $eUqFw.useEffect)(()=>{
        createClient(stargateRoot);
    }, [
        createClient,
        stargateRoot
    ]);
    // TODO: enable team central
    // useEffect(() => {
    //   if (teamCentralStore.hasWorkspace || teamCentralStore.orgHasWorkspace) {
    //     // re-create the client and enable team central features
    //     createClient(true);
    //   }
    // }, [teamCentralStore.hasWorkspace, teamCentralStore.orgHasWorkspace]);
    return profileClient;
};

});
parcelRegister("8PYmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac2720ab38ce9772$export$2e2bcd8739ae039);

var $4eGN1 = parcelRequire("4eGN1");

var $lsiAJ = parcelRequire("lsiAJ");

var $kWhjG = parcelRequire("kWhjG");

var $b4hs7 = parcelRequire("b4hs7");
var $ac2720ab38ce9772$export$2e2bcd8739ae039 = (0, $lsiAJ.default);

});
parcelRegister("4eGN1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3adc3d48b40454$export$2e2bcd8739ae039);

var $6roQF = parcelRequire("6roQF");
class $7c3adc3d48b40454$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $6roQF.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});
parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("lsiAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $84b7dde52ef02eed$export$2e2bcd8739ae039);

var $dfBCt = parcelRequire("dfBCt");

var $9KeXL = parcelRequire("9KeXL");

var $kmpkL = parcelRequire("kmpkL");

var $kWhjG = parcelRequire("kWhjG");

var $b4hs7 = parcelRequire("b4hs7");
class $84b7dde52ef02eed$var$ProfileCardClient {
    constructor(config, clients){
        this.userClient = clients?.userClient || new (0, $b4hs7.default)(config);
        this.teamClient = clients?.teamClient || new (0, $kWhjG.default)(config);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $9KeXL.default)(config);
        this.tcClient = $84b7dde52ef02eed$var$maybeCreateTeamCentralClient(config, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    getTeamCentralBaseUrl() {
        return this.tcClient?.options.teamCentralBaseUrl;
    }
    shouldShowGiveKudos() {
        if (!this.tcClient || !this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics) {
        return this.rovoAgentClient?.getProfile(id, analytics);
    }
}
function $84b7dde52ef02eed$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $dfBCt.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralUrl = config.teamCentralUrl;
    return teamCentralUrl ? new (0, $kmpkL.default)({
        ...config,
        teamCentralUrl: teamCentralUrl
    }) : undefined;
}
var $84b7dde52ef02eed$export$2e2bcd8739ae039 = $84b7dde52ef02eed$var$ProfileCardClient;

});
parcelRegister("9KeXL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a501e1692a6dcaf$export$2e2bcd8739ae039);

var $3vXh8 = parcelRequire("3vXh8");

var $cEOpo = parcelRequire("cEOpo");

var $4eGN1 = parcelRequire("4eGN1");

var $bl3OJ = parcelRequire("bl3OJ");

var $lBUiV = parcelRequire("lBUiV");
class $4a501e1692a6dcaf$export$2e2bcd8739ae039 extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(id, cloudId) {
        if (id.type === 'identity') return (0, $lBUiV.getAgentDetailsByUserId)(id.value, this.options.productIdentifier || 'rovo', cloudId);
        return (0, $lBUiV.getAgentDetailsByAgentId)(id.value, this.options.productIdentifier || 'rovo', cloudId);
    }
    getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('IF is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('triggered'));
            this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                if (this.cache) this.setCachedProfile(id.value, data);
                if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('succeeded', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.agentRequestAnalytics)('failed', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("3vXh8", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $3825798267526520$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $3825798267526520$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $3825798267526520$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $3825798267526520$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $3825798267526520$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $3825798267526520$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $3825798267526520$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $3825798267526520$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $3825798267526520$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $3825798267526520$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $3825798267526520$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $3825798267526520$export$a9f8c9f412cf5664);

var $cEOpo = parcelRequire("cEOpo");
/** Below lines are copied from teams common analytics */ const $3825798267526520$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $3825798267526520$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $3825798267526520$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $3825798267526520$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($3825798267526520$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $3825798267526520$var$TEAM_SUBJECT = 'teamProfileCard';
const $3825798267526520$var$USER_SUBJECT = 'profilecard';
const $3825798267526520$var$AGENT_SUBJECT = 'rovoAgenrProfilecard';
const $3825798267526520$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $cEOpo.getPageTime)())
        }
    });
const $3825798267526520$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $3825798267526520$var$USER_SUBJECT;
        case 'team':
            return $3825798267526520$var$TEAM_SUBJECT;
        case 'agent':
            return $3825798267526520$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $3825798267526520$export$d50ab8a3b6975c = (type, method)=>{
    return $3825798267526520$var$createEvent('ui', 'triggered', $3825798267526520$var$getActionSubject(type), undefined, {
        method: method
    });
};
const $3825798267526520$export$c9b0e37b229a297b = (action, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$TEAM_SUBJECT, 'request', attributes);
const $3825798267526520$export$12dae48763368ac9 = (action, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$USER_SUBJECT, 'request', attributes);
const $3825798267526520$export$41816a317479160b = (type, actionSubjectId, attributes)=>$3825798267526520$var$createEvent('ui', 'rendered', $3825798267526520$var$getActionSubject(type), actionSubjectId, attributes);
const $3825798267526520$export$fdcd134fbeb1f921 = (type, attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$getActionSubject(type), 'action', attributes);
const $3825798267526520$export$93260987012593be = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$USER_SUBJECT, 'reportingLines', attributes);
const $3825798267526520$export$79befd155063a6a7 = (type, attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$getActionSubject(type), 'moreActions', attributes);
const $3825798267526520$export$2703289b35687fde = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'avatar', attributes);
const $3825798267526520$export$b4411a7661cf2d3f = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $3825798267526520$export$c86679da702d560e = (attributes)=>$3825798267526520$var$createEvent('ui', 'clicked', $3825798267526520$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $3825798267526520$export$a9f8c9f412cf5664 = (action, attributes)=>$3825798267526520$var$createEvent('operational', action, $3825798267526520$var$AGENT_SUBJECT, 'request', attributes);

});
parcelRegister("cEOpo", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $77671953c6d01f45$export$e9faea7c41053334);
const $77671953c6d01f45$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $77671953c6d01f45$var$performanceAvailable = $77671953c6d01f45$var$isPerformanceAvailable();
const $77671953c6d01f45$var$initialPageTime = Date.now();
const $77671953c6d01f45$export$e9faea7c41053334 = ()=>{
    if ($77671953c6d01f45$var$performanceAvailable) return performance.now();
    return Date.now() - $77671953c6d01f45$var$initialPageTime;
};

});


parcelRegister("bl3OJ", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $d2cc0f3532818141$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $d2cc0f3532818141$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $d2cc0f3532818141$export$d9ad65d422ee3f8c);

var $j4C9S = parcelRequire("j4C9S");
const $d2cc0f3532818141$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $d2cc0f3532818141$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $d2cc0f3532818141$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $d2cc0f3532818141$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $j4C9S.DirectoryGraphQLError)) return !!error && $d2cc0f3532818141$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $j4C9S.AGGError)) return !!error.errorType && $d2cc0f3532818141$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $d2cc0f3532818141$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $d2cc0f3532818141$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $j4C9S.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($d2cc0f3532818141$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($d2cc0f3532818141$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $j4C9S.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$d2cc0f3532818141$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $j4C9S.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($d2cc0f3532818141$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($d2cc0f3532818141$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $j4C9S.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$d2cc0f3532818141$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $j4C9S.DirectoryGraphQLErrors) || causeError instanceof (0, $j4C9S.AGGErrors)) return $d2cc0f3532818141$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $d2cc0f3532818141$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $j4C9S.DirectoryGraphQLErrors)(errors, traceId);
};
const $d2cc0f3532818141$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $j4C9S.AGGErrors)(errors, traceId);
};

});
parcelRegister("j4C9S", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $343a8316fe4e3587$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $343a8316fe4e3587$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $343a8316fe4e3587$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $343a8316fe4e3587$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $343a8316fe4e3587$export$60d8267243755b9c);
class $343a8316fe4e3587$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $343a8316fe4e3587$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $343a8316fe4e3587$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $343a8316fe4e3587$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $343a8316fe4e3587$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $343a8316fe4e3587$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $343a8316fe4e3587$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});


parcelRegister("lBUiV", function(module, exports) {

$parcel$export(module.exports, "getAgentDetailsByAgentId", () => $809c396fa2b42ce6$export$c9fa23b298652f7f);
$parcel$export(module.exports, "getAgentDetailsByUserId", () => $809c396fa2b42ce6$export$7446f7cf554ee3f9);

var $6oOPK = parcelRequire("6oOPK");
async function $809c396fa2b42ce6$export$c9fa23b298652f7f(agentId, product, cloudId) {
    const headers = (0, $6oOPK.createHeaders)(product, cloudId);
    return await fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}`, {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: headers
    })).then((response)=>response.json());
}
async function $809c396fa2b42ce6$export$7446f7cf554ee3f9(userId, product, cloudId) {
    const headers = (0, $6oOPK.createHeaders)(product, cloudId);
    return fetch(new Request(`/gateway/api/assist/agents/v1/accountid/${userId}`, {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: headers
    })).then((response)=>{
        return response.json();
    });
}

});
parcelRegister("6oOPK", function(module, exports) {

$parcel$export(module.exports, "createHeaders", () => $d85581b87885252e$export$197579c449ddabf4);
$parcel$export(module.exports, "getAAIDFromARI", () => $d85581b87885252e$export$3761e66a04602cbd);
const $d85581b87885252e$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $d85581b87885252e$export$197579c449ddabf4 = (product, cloudId)=>{
    const config = {
        headers: {
            'X-Product': product,
            'X-Experience-Id': 'profile-card',
            'X-Cloudid': cloudId
        }
    };
    return new Headers({
        ...config.headers || {}
    });
};
const $d85581b87885252e$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($d85581b87885252e$export$470b0d72e4fdc43a, '');
};

});



parcelRegister("kmpkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8fb2ad4171564c$export$2e2bcd8739ae039);

var $4eGN1 = parcelRequire("4eGN1");

var $6WG70 = parcelRequire("6WG70");
const $ab8fb2ad4171564c$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $ab8fb2ad4171564c$export$f8c05b360e45cd0 = (featureKey, context)=>({
        query: `
    query isFeatureKeyEnabled($featureKey: String!, $context: [IsFeatureEnabledContextInput]) {
      isFeatureEnabled(featureKey: $featureKey, context: $context) {
        enabled
      }
    }
  `,
        variables: {
            featureKey: featureKey,
            context: context || []
        }
    });
function $ab8fb2ad4171564c$var$hasTCWorkspace(config) {
    return config.cloudId ? fetch(`/gateway/api/watermelon/organization/containsAnyWorkspace?cloudId=${config.cloudId}`).then((res)=>{
        return !res || res && res.ok;
    }) : Promise.resolve(false);
}
let $ab8fb2ad4171564c$var$isTCReadyPromiseMap = new Map();
class $ab8fb2ad4171564c$var$TeamCentralCardClient extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.featureFlagKeys = new Map();
        this.isTCReadyPromise = this.createTcReadyPromise(options);
    }
    createTcReadyPromise(config) {
        if (config.cloudId) {
            let promise = $ab8fb2ad4171564c$var$isTCReadyPromiseMap.get(config.cloudId);
            if (!promise) {
                promise = $ab8fb2ad4171564c$var$hasTCWorkspace(config);
                $ab8fb2ad4171564c$var$isTCReadyPromiseMap.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    async makeFeatureFlagCheckRequest(featureKey, context) {
        if (!this.options.teamCentralUrl) throw new Error('options.teamCentralUrl is a required parameter for retrieving Team Central data');
        const query = $ab8fb2ad4171564c$export$f8c05b360e45cd0(featureKey, context);
        const response = await (0, $6WG70.directoryGraphqlQuery)(`${this.options.teamCentralUrl}?operationName=isFeatureKeyEnabled`, query);
        return response.isFeatureEnabled.enabled;
    }
    async makeRequest(userId) {
        if (!this.options.teamCentralUrl) throw new Error('options.teamCentralUrl is a required parameter for retrieving Team Central data');
        const query = $ab8fb2ad4171564c$export$1862ef0c3880ca8d(userId);
        const response = await (0, $6WG70.directoryGraphqlQuery)(`${this.options.teamCentralUrl}?operationName=ReportingLines`, query);
        return response.reportingLines;
    }
    getReportingLines(userId) {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    getFlagEnabled(featureKey, productIdentifier) {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) {
                if (!featureKey) return Promise.reject(new Error('featureKey missing'));
                if (this.featureFlagKeys.has(featureKey)) return Promise.resolve(this.featureFlagKeys.get(featureKey));
                if (this.bypassOnFailure) return Promise.resolve(false);
                const context = [
                    {
                        key: 'productIdentifier',
                        value: productIdentifier || 'unset'
                    }
                ];
                return new Promise((resolve)=>{
                    this.makeFeatureFlagCheckRequest(featureKey, context).then((enabled)=>{
                        this.featureFlagKeys.set(featureKey, enabled);
                        resolve(enabled);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        resolve(false);
                    });
                });
            }
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    checkWorkspaceExists() {
        return this.isTCReadyPromise.then((workSpaceExists)=>{
            if (workSpaceExists) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $ab8fb2ad4171564c$export$2e2bcd8739ae039 = $ab8fb2ad4171564c$var$TeamCentralCardClient;

});
parcelRegister("6WG70", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $415b57eeeceb8e81$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $415b57eeeceb8e81$export$a14afb5f82fe705);

var $j4C9S = parcelRequire("j4C9S");

var $bl3OJ = parcelRequire("bl3OJ");
const $415b57eeeceb8e81$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $415b57eeeceb8e81$var$id = (headers)=>headers;
async function $415b57eeeceb8e81$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id) {
    return $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bl3OJ.handleDirectoryGraphQLErrors));
}
async function $415b57eeeceb8e81$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id) {
    return $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bl3OJ.handleAGGErrors));
}
async function $415b57eeeceb8e81$var$graphQLQuery(serviceUrl, query, processHeaders = $415b57eeeceb8e81$var$id, handleErrors) {
    const headers = processHeaders($415b57eeeceb8e81$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $j4C9S.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});


parcelRegister("kWhjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $26e65ba6df7e3eef$export$2e2bcd8739ae039);

var $3vXh8 = parcelRequire("3vXh8");

var $cEOpo = parcelRequire("cEOpo");

var $4eGN1 = parcelRequire("4eGN1");

var $bl3OJ = parcelRequire("bl3OJ");

var $k39sp = parcelRequire("k39sp");
class $26e65ba6df7e3eef$export$2e2bcd8739ae039 extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $k39sp.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('succeeded', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.teamRequestAnalytics)('failed', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("k39sp", function(module, exports) {

$parcel$export(module.exports, "getTeamFromAGG", () => $b92dd34bfd4aec4a$export$26a8aad0c7182dd6);

var $6WG70 = parcelRequire("6WG70");
const $b92dd34bfd4aec4a$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $b92dd34bfd4aec4a$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $b92dd34bfd4aec4a$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $b92dd34bfd4aec4a$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $b92dd34bfd4aec4a$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $b92dd34bfd4aec4a$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$b92dd34bfd4aec4a$var$TEAM_FRAGMENT}
    }
  }
}`;
const $b92dd34bfd4aec4a$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $b92dd34bfd4aec4a$export$4968f4e0119a5d9c,
        variables: {
            teamId: $b92dd34bfd4aec4a$export$681597d03c8a0fd2(teamId),
            siteId: siteId || 'None'
        }
    });
const $b92dd34bfd4aec4a$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $b92dd34bfd4aec4a$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $b92dd34bfd4aec4a$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $6WG70.AGGQuery)(url, query, $b92dd34bfd4aec4a$export$1229c72526c01df2);
    return $b92dd34bfd4aec4a$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("b4hs7", function(module, exports) {

$parcel$export(module.exports, "default", () => $80b3ff2ca38ed950$export$2e2bcd8739ae039);

var $3vXh8 = parcelRequire("3vXh8");

var $cEOpo = parcelRequire("cEOpo");

var $4eGN1 = parcelRequire("4eGN1");

var $bl3OJ = parcelRequire("bl3OJ");

var $6WG70 = parcelRequire("6WG70");
const $80b3ff2ca38ed950$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $80b3ff2ca38ed950$export$bfbf383663068c37 = (cloudId, userId)=>({
        query: `query User($userId: String!, $cloudId: String!) {
    User: CloudUser(userId: $userId, cloudId: $cloudId) {
      id
      isCurrentUser
      status
      statusModifiedDate
      isBot
      isNotMentionable
      fullName
      nickname
      email
      meta: title
      location
      companyName
      avatarUrl(size: 192)
      remoteWeekdayIndex: localTime(format: "d")
      remoteWeekdayString: localTime(format: "ddd")
      remoteTimeString: localTime(format: "h:mma")
    }
  }`,
        variables: {
            cloudId: cloudId,
            userId: userId
        }
    });
class $80b3ff2ca38ed950$export$2e2bcd8739ae039 extends (0, $4eGN1.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        if (!this.options.url) throw new Error('options.url is a required parameter');
        const query = $80b3ff2ca38ed950$export$bfbf383663068c37(cloudId, userId);
        const response = await (0, $6WG70.directoryGraphqlQuery)(this.options.url, query);
        return $80b3ff2ca38ed950$export$b26b7f9bcf400835(response);
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $cEOpo.getPageTime)();
            if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('succeeded', {
                    duration: (0, $cEOpo.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $3vXh8.userRequestAnalytics)('failed', {
                    duration: (0, $cEOpo.getPageTime)() - startTime,
                    ...(0, $bl3OJ.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});



parcelRegister("WQNHl", function(module, exports) {

$parcel$export(module.exports, "useNavigation", () => $d6d1f66cab2625be$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useAppConfig", () => $d6d1f66cab2625be$export$a3e0ece8c3f698d7);

var $jvxHp = parcelRequire("jvxHp");

var $7QGbN = parcelRequire("7QGbN");

var $7QGbN = parcelRequire("7QGbN");
const $d6d1f66cab2625be$export$d0fd4b7106de2769 = ()=>{
    const state = (0, $7QGbN.useNavigationState)();
    const actions = (0, $jvxHp.useNavigationActions)();
    return {
        ...actions,
        ...state
    };
};
const $d6d1f66cab2625be$export$a3e0ece8c3f698d7 = ()=>{
    const storeState = (0, $7QGbN.useAppConfigStoreState)();
    const navigation = $d6d1f66cab2625be$export$d0fd4b7106de2769();
    const addFlag = (0, $jvxHp.useAddFlag)();
    return {
        ...storeState,
        ...navigation,
        addFlag: addFlag
    };
};

});




parcelRegister("ictQ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $80ab5d07faa3a76b$export$2e2bcd8739ae039);
// TODO: PTC-2088 - simplify list of locales

























const $80ab5d07faa3a76b$var$messagesConfig = [
    // Czech
    {
        locales: [
            'cs',
            'cs-CZ'
        ],
        loader: ()=>(parcelRequire("5TBQr"))
    },
    // Danish
    {
        locales: [
            'da',
            'da-DK'
        ],
        loader: ()=>(parcelRequire("knKLq"))
    },
    // German
    {
        locales: [
            'de',
            'de-DE'
        ],
        loader: ()=>(parcelRequire("q2R0O"))
    },
    // Spain
    {
        locales: [
            'es',
            'es-ES'
        ],
        loader: ()=>(parcelRequire("3fd4b"))
    },
    // Finnish
    {
        locales: [
            'fi',
            'fi-FI'
        ],
        loader: ()=>(parcelRequire("jb4Fo"))
    },
    // French
    {
        locales: [
            'fr',
            'fr-FR'
        ],
        loader: ()=>(parcelRequire("lwyRk"))
    },
    // Hungarian
    {
        locales: [
            'hu',
            'hu-HU'
        ],
        loader: ()=>(parcelRequire("6Xtuw"))
    },
    // Icelandic
    {
        locales: [
            'is',
            'is-IS'
        ],
        loader: ()=>(parcelRequire("lnV1W"))
    },
    // Italian
    {
        locales: [
            'it',
            'it-IT'
        ],
        loader: ()=>(parcelRequire("5s4GJ"))
    },
    // Japanese
    {
        locales: [
            'ja',
            'ja-JP'
        ],
        loader: ()=>(parcelRequire("3KoRt"))
    },
    // Korean
    {
        locales: [
            'ko',
            'ko-KR'
        ],
        loader: ()=>(parcelRequire("ex1AP"))
    },
    // Dutch
    {
        locales: [
            'nl',
            'nl-NL'
        ],
        loader: ()=>(parcelRequire("lDUu7"))
    },
    // Norwegian (Norway)
    {
        locales: [
            'nb',
            'nb-NO'
        ],
        loader: ()=>(parcelRequire("bfnW4"))
    },
    // Polish
    {
        locales: [
            'pl',
            'pl-PL'
        ],
        loader: ()=>(parcelRequire("1HBdK"))
    },
    // Portuguese -
    {
        locales: [
            'pt-BR'
        ],
        loader: ()=>(parcelRequire("6r12l"))
    },
    // Romanian
    {
        locales: [
            'ro',
            'ro-RO'
        ],
        loader: ()=>(parcelRequire("547Uv"))
    },
    // Russian
    {
        locales: [
            'ru',
            'ru-RU'
        ],
        loader: ()=>(parcelRequire("bxXEy"))
    },
    // Swedish
    {
        locales: [
            'sv',
            'sv-SE'
        ],
        loader: ()=>(parcelRequire("4lomc"))
    },
    // China uses Chinese (Simplified)
    {
        locales: [
            'zh',
            'zh-CN',
            'zh-Hans'
        ],
        loader: ()=>(parcelRequire("4fEQy"))
    },
    // Taiwan or Hong Kong uses Chinese (Traditional)
    {
        locales: [
            'zh-TW',
            'zh-HK',
            'zh-Hant'
        ],
        loader: ()=>(parcelRequire("gtYJz"))
    },
    // Turkish
    {
        locales: [
            'tr',
            'tr-TR'
        ],
        loader: ()=>(parcelRequire("cE8by"))
    },
    // Thai
    {
        locales: [
            'th',
            'th-TH'
        ],
        loader: ()=>(parcelRequire("9jMYP"))
    },
    // Ukrainian
    {
        locales: [
            'uk',
            'uk-UA'
        ],
        loader: ()=>(parcelRequire("mM8qI"))
    },
    // Vietnamese
    {
        locales: [
            'vi',
            'vi-VN'
        ],
        loader: ()=>(parcelRequire("3qAS2"))
    },
    // English (UK)
    {
        locales: [
            'en-GB'
        ],
        loader: ()=>(parcelRequire("rd8Et"))
    }
];
var $80ab5d07faa3a76b$export$2e2bcd8739ae039 = $80ab5d07faa3a76b$var$messagesConfig;

});
parcelRegister("5TBQr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('89x0z');
        const value = parcelRequire('foPRb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("89x0z").then(()=>parcelRequire('foPRb'));
}

});

parcelRegister("knKLq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3Tk96');
        const value = parcelRequire('jlwFL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3Tk96").then(()=>parcelRequire('jlwFL'));
}

});

parcelRegister("q2R0O", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hiJlJ');
        const value = parcelRequire('8E7Ro');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hiJlJ").then(()=>parcelRequire('8E7Ro'));
}

});

parcelRegister("3fd4b", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('NTwa6');
        const value = parcelRequire('l8bnP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("NTwa6").then(()=>parcelRequire('l8bnP'));
}

});

parcelRegister("jb4Fo", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5J8s7');
        const value = parcelRequire('f2MQa');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5J8s7").then(()=>parcelRequire('f2MQa'));
}

});

parcelRegister("lwyRk", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7Aduf');
        const value = parcelRequire('e7MFP');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7Aduf").then(()=>parcelRequire('e7MFP'));
}

});

parcelRegister("6Xtuw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kbqAI');
        const value = parcelRequire('4VCvg');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kbqAI").then(()=>parcelRequire('4VCvg'));
}

});

parcelRegister("lnV1W", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('eXZ2t');
        const value = parcelRequire('i2oUb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("eXZ2t").then(()=>parcelRequire('i2oUb'));
}

});

parcelRegister("5s4GJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jsBQk');
        const value = parcelRequire('4PLPT');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jsBQk").then(()=>parcelRequire('4PLPT'));
}

});

parcelRegister("3KoRt", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cKWYa');
        const value = parcelRequire('j5UvR');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cKWYa").then(()=>parcelRequire('j5UvR'));
}

});

parcelRegister("ex1AP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cJyfb');
        const value = parcelRequire('5afLJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cJyfb").then(()=>parcelRequire('5afLJ'));
}

});

parcelRegister("lDUu7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('83hzl');
        const value = parcelRequire('3oH0y');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("83hzl").then(()=>parcelRequire('3oH0y'));
}

});

parcelRegister("bfnW4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bGLMC');
        const value = parcelRequire('cJIaj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bGLMC").then(()=>parcelRequire('cJIaj'));
}

});

parcelRegister("1HBdK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hGT66');
        const value = parcelRequire('5BrBc');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hGT66").then(()=>parcelRequire('5BrBc'));
}

});

parcelRegister("6r12l", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bQpzg');
        const value = parcelRequire('7Jyoa');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bQpzg").then(()=>parcelRequire('7Jyoa'));
}

});

parcelRegister("547Uv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kywHi');
        const value = parcelRequire('22X6B');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kywHi").then(()=>parcelRequire('22X6B'));
}

});

parcelRegister("bxXEy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7Unnn');
        const value = parcelRequire('gVYgL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7Unnn").then(()=>parcelRequire('gVYgL'));
}

});

parcelRegister("4lomc", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('d6XXp');
        const value = parcelRequire('9yC4X');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("d6XXp").then(()=>parcelRequire('9yC4X'));
}

});

parcelRegister("4fEQy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hYoWl');
        const value = parcelRequire('c89VR');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hYoWl").then(()=>parcelRequire('c89VR'));
}

});

parcelRegister("gtYJz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gxLin');
        const value = parcelRequire('95pUJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gxLin").then(()=>parcelRequire('95pUJ'));
}

});

parcelRegister("cE8by", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dZ68S');
        const value = parcelRequire('d5eEb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dZ68S").then(()=>parcelRequire('d5eEb'));
}

});

parcelRegister("9jMYP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('82F5W');
        const value = parcelRequire('jaAWf');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("82F5W").then(()=>parcelRequire('jaAWf'));
}

});

parcelRegister("mM8qI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2JEDr');
        const value = parcelRequire('2XPpC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2JEDr").then(()=>parcelRequire('2XPpC'));
}

});

parcelRegister("3qAS2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2qEq2');
        const value = parcelRequire('lQNCV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2qEq2").then(()=>parcelRequire('lQNCV'));
}

});

parcelRegister("rd8Et", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5uIQ7');
        const value = parcelRequire('3ftDY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5uIQ7").then(()=>parcelRequire('3ftDY'));
}

});


parcelRegister("gi0VS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e0f31a05bf5bdff$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7QNSj = parcelRequire("7QNSj");
var $bqSCJ = parcelRequire("bqSCJ");
var $9MQbY = parcelRequire("9MQbY");

var $XHGTv = parcelRequire("XHGTv");

var $2sEko = parcelRequire("2sEko");

var $QAW5b = parcelRequire("QAW5b");

var $ghjoM = parcelRequire("ghjoM");

var $4ckcM = parcelRequire("4ckcM");

var $p3lye = parcelRequire("p3lye");

var $3RsMI = parcelRequire("3RsMI");

var $bo3ra = parcelRequire("bo3ra");

var $8ziB5 = parcelRequire("8ziB5");

var $jmvGy = parcelRequire("jmvGy");

var $eurvo = parcelRequire("eurvo");

var $9j0B5 = parcelRequire("9j0B5");

var $eMmYZ = parcelRequire("eMmYZ");

var $jIuH4 = parcelRequire("jIuH4");
// Team Profile
// Kudos
const $7e0f31a05bf5bdff$var$renderRoutes = (contextEntryPoint, canViewTeams)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9MQbY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        exact: true,
        path: `${contextEntryPoint}/`,
        render: (0, $p3lye.default)
    }), !canViewTeams && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/search/teams`,
        render: (0, $8ziB5.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/search`,
        render: (0, $bo3ra.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/kudos/:uuid`,
        render: (0, $ghjoM.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        exact: true,
        path: `${contextEntryPoint}/team`,
        render: (0, $eurvo.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3RsMI.RouteWithOrgIdLoading), {
        path: `${contextEntryPoint}/team/:teamId`,
        render: (0, $jmvGy.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/:userId/work`,
        render: (0, $jIuH4.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/:userId/*`,
        render: (0, $eMmYZ.default)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/me`,
        render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ckcM.default), {
                ...props,
                contextEntryPoint: contextEntryPoint
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/:userId`,
        render: (0, $9j0B5.default)
    }), (0, $XHGTv.fg)('rovo_agent_profile_page') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), {
        path: `${contextEntryPoint}/agent/:agentId`,
        render: (0, $QAW5b.default)
    }));
};
function $7e0f31a05bf5bdff$var$AppRoutes(props) {
    const { contextEntryPoint: contextEntryPoint, history: history, onTransition: onTransition } = props;
    const { permissions: { canViewTeams: canViewTeams } } = (0, $2sEko.useTeamVisibility)();
    (0, $eUqFw.useEffect)(()=>{
        if (!onTransition) return;
        let unsubscribeBlockingHistory = ()=>{};
        let unsubscribeListeningHistory = ()=>{};
        if (history) {
            let lastHistoryLocation;
            unsubscribeListeningHistory = history.listen(({ pathname: pathname })=>{
                lastHistoryLocation = pathname;
            });
            // We're using history.block() here instead of history.listen()
            // because we want this to run BEFORE transition happens.
            unsubscribeBlockingHistory = history.block(({ pathname: pathname })=>{
                if (lastHistoryLocation !== pathname) onTransition(pathname);
            });
        }
        return ()=>{
            unsubscribeBlockingHistory();
            unsubscribeListeningHistory();
        };
    }, [
        onTransition,
        history
    ]);
    const routes = $7e0f31a05bf5bdff$var$renderRoutes(contextEntryPoint, canViewTeams);
    // If `history` object is not passed to `EmbeddableDirectory`, `EmbeddableDirectory` will use `Router` component from product in higher component tree.
    // If `history` object is passed to `EmbeddableDirectory`, `EmbeddableDirectory` will render its own `Router` component.
    // @ts-ignore - Property 'children' does not exist on type 'IntrinsicAttributes & IntrinsicClassAttributes<Router> & Readonly<RouterProps>'
    // This was added when enrolling `@atlassian/ptc-embeddable-directory` into JFE local consumption
    return history ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bqSCJ.default), {
        history: history
    }, routes) : routes;
}
var $7e0f31a05bf5bdff$export$2e2bcd8739ae039 = $7e0f31a05bf5bdff$var$AppRoutes;

});
parcelRegister("7QNSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b7413dcddcdf29e$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $k43p8 = parcelRequire("k43p8");
var $5b7413dcddcdf29e$export$2e2bcd8739ae039 = (0, $k43p8.default);

});
parcelRegister("k43p8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9b6d266f4833098$export$2e2bcd8739ae039);

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $1d3eD = parcelRequire("1d3eD");
var $e9b6d266f4833098$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $e9b6d266f4833098$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e9b6d266f4833098$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e9b6d266f4833098$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e9b6d266f4833098$var$isEmptyChildren = function isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.count(children) === 0;
};
/**
 * The public API for matching a single path and rendering.
 */ var $e9b6d266f4833098$var$Route = function(_React$Component) {
    $e9b6d266f4833098$var$_inherits(Route, _React$Component);
    function Route() {
        var _temp, _this, _ret;
        $e9b6d266f4833098$var$_classCallCheck(this, Route);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $e9b6d266f4833098$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props, _this.context.router)
        }, _temp), $e9b6d266f4833098$var$_possibleConstructorReturn(_this, _ret);
    }
    Route.prototype.getChildContext = function getChildContext() {
        return {
            router: $e9b6d266f4833098$var$_extends({}, this.context.router, {
                route: {
                    location: this.props.location || this.context.router.route.location,
                    match: this.state.match
                }
            })
        };
    };
    Route.prototype.computeMatch = function computeMatch(_ref, router) {
        var computedMatch = _ref.computedMatch, location = _ref.location, path = _ref.path, strict = _ref.strict, exact = _ref.exact, sensitive = _ref.sensitive;
        if (computedMatch) return computedMatch; // <Switch> already computed the match for us
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(router, "You should not use <Route> or withRouter() outside a <Router>");
        var route = router.route;
        var pathname = (location || route.location).pathname;
        return (0, $1d3eD.default)(pathname, {
            path: path,
            strict: strict,
            exact: exact,
            sensitive: sensitive
        }, route.match);
    };
    Route.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(this.props.component && this.props.children && !$e9b6d266f4833098$var$isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(this.props.render && this.props.children && !$e9b6d266f4833098$var$isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
    };
    Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
        this.setState({
            match: this.computeMatch(nextProps, nextContext.router)
        });
    };
    Route.prototype.render = function render() {
        var match = this.state.match;
        var _props = this.props, children = _props.children, component = _props.component, render = _props.render;
        var _context$router = this.context.router, history = _context$router.history, route = _context$router.route, staticContext = _context$router.staticContext;
        var location = this.props.location || route.location;
        var props = {
            match: match,
            location: location,
            history: history,
            staticContext: staticContext
        };
        if (component) return match ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(component, props) : null;
        if (render) return match ? render(props) : null;
        if (typeof children === "function") return children(props);
        if (children && !$e9b6d266f4833098$var$isEmptyChildren(children)) return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(children);
        return null;
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$e9b6d266f4833098$var$Route.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    path: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    exact: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    strict: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    sensitive: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    component: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node
    ]),
    location: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
$e9b6d266f4833098$var$Route.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        route: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
    })
};
$e9b6d266f4833098$var$Route.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired
};
var $e9b6d266f4833098$export$2e2bcd8739ae039 = $e9b6d266f4833098$var$Route;

});
parcelRegister("1d3eD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e1983bddd0ee331$export$2e2bcd8739ae039);

var $43pB1 = parcelRequire("43pB1");
var $0e1983bddd0ee331$var$patternCache = {};
var $0e1983bddd0ee331$var$cacheLimit = 10000;
var $0e1983bddd0ee331$var$cacheCount = 0;
var $0e1983bddd0ee331$var$compilePath = function compilePath(pattern, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var cache = $0e1983bddd0ee331$var$patternCache[cacheKey] || ($0e1983bddd0ee331$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var keys = [];
    var re = (0, (/*@__PURE__*/$parcel$interopDefault($43pB1)))(pattern, keys, options);
    var compiledPattern = {
        re: re,
        keys: keys
    };
    if ($0e1983bddd0ee331$var$cacheCount < $0e1983bddd0ee331$var$cacheLimit) {
        cache[pattern] = compiledPattern;
        $0e1983bddd0ee331$var$cacheCount++;
    }
    return compiledPattern;
};
/**
 * Public API for matching a URL pathname to a path pattern.
 */ var $0e1983bddd0ee331$var$matchPath = function matchPath(pathname) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parent = arguments[2];
    if (typeof options === "string") options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
    if (path == null) return parent;
    var _compilePath = $0e1983bddd0ee331$var$compilePath(path, {
        end: exact,
        strict: strict,
        sensitive: sensitive
    }), re = _compilePath.re, keys = _compilePath.keys;
    var match = re.exec(pathname);
    if (!match) return null;
    var url = match[0], values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
        path: path,
        url: path === "/" && url === "" ? "/" : url,
        isExact: isExact,
        params: keys.reduce(function(memo, key, index) {
            memo[key.name] = values[index];
            return memo;
        }, {})
    };
};
var $0e1983bddd0ee331$export$2e2bcd8739ae039 = $0e1983bddd0ee331$var$matchPath;

});
parcelRegister("43pB1", function(module, exports) {

var $e4Chz = parcelRequire("e4Chz");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $2f3b4c1d8f9b78ef$var$pathToRegexp;
module.exports.parse = $2f3b4c1d8f9b78ef$var$parse;
module.exports.compile = $2f3b4c1d8f9b78ef$var$compile;
module.exports.tokensToFunction = $2f3b4c1d8f9b78ef$var$tokensToFunction;
module.exports.tokensToRegExp = $2f3b4c1d8f9b78ef$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $2f3b4c1d8f9b78ef$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $2f3b4c1d8f9b78ef$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $2f3b4c1d8f9b78ef$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $2f3b4c1d8f9b78ef$var$escapeGroup(pattern) : asterisk ? '.*' : '[^' + $2f3b4c1d8f9b78ef$var$escapeString(delimiter) + ']+?'
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $2f3b4c1d8f9b78ef$var$compile(str, options) {
    return $2f3b4c1d8f9b78ef$var$tokensToFunction($2f3b4c1d8f9b78ef$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $2f3b4c1d8f9b78ef$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $2f3b4c1d8f9b78ef$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $2f3b4c1d8f9b78ef$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $2f3b4c1d8f9b78ef$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $2f3b4c1d8f9b78ef$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($e4Chz(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $2f3b4c1d8f9b78ef$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $2f3b4c1d8f9b78ef$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $2f3b4c1d8f9b78ef$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $2f3b4c1d8f9b78ef$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $2f3b4c1d8f9b78ef$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $2f3b4c1d8f9b78ef$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $2f3b4c1d8f9b78ef$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $2f3b4c1d8f9b78ef$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($2f3b4c1d8f9b78ef$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $2f3b4c1d8f9b78ef$var$flags(options));
    return $2f3b4c1d8f9b78ef$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $2f3b4c1d8f9b78ef$var$stringToRegexp(path, keys, options) {
    return $2f3b4c1d8f9b78ef$var$tokensToRegExp($2f3b4c1d8f9b78ef$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $2f3b4c1d8f9b78ef$var$tokensToRegExp(tokens, keys, options) {
    if (!$e4Chz(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $2f3b4c1d8f9b78ef$var$escapeString(token);
        else {
            var prefix = $2f3b4c1d8f9b78ef$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $2f3b4c1d8f9b78ef$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $2f3b4c1d8f9b78ef$var$attachKeys(new RegExp('^' + route, $2f3b4c1d8f9b78ef$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $2f3b4c1d8f9b78ef$var$pathToRegexp(path, keys, options) {
    if (!$e4Chz(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $2f3b4c1d8f9b78ef$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($e4Chz(path)) return $2f3b4c1d8f9b78ef$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $2f3b4c1d8f9b78ef$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("e4Chz", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

});





parcelRegister("bqSCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $852c7e8f766e6629$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $aTrRe = parcelRequire("aTrRe");
var $852c7e8f766e6629$export$2e2bcd8739ae039 = (0, $aTrRe.default);

});
parcelRegister("aTrRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ee4a658adeb8d1a$export$2e2bcd8739ae039);

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");
var $7ee4a658adeb8d1a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $7ee4a658adeb8d1a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7ee4a658adeb8d1a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7ee4a658adeb8d1a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for putting history on context.
 */ var $7ee4a658adeb8d1a$var$Router = function(_React$Component) {
    $7ee4a658adeb8d1a$var$_inherits(Router, _React$Component);
    function Router() {
        var _temp, _this, _ret;
        $7ee4a658adeb8d1a$var$_classCallCheck(this, Router);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $7ee4a658adeb8d1a$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props.history.location.pathname)
        }, _temp), $7ee4a658adeb8d1a$var$_possibleConstructorReturn(_this, _ret);
    }
    Router.prototype.getChildContext = function getChildContext() {
        return {
            router: $7ee4a658adeb8d1a$var$_extends({}, this.context.router, {
                history: this.props.history,
                route: {
                    location: this.props.history.location,
                    match: this.state.match
                }
            })
        };
    };
    Router.prototype.computeMatch = function computeMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    Router.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var _props = this.props, children = _props.children, history = _props.history;
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(children == null || (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.count(children) === 1, "A <Router> may have only one child element");
        // Do this here so we can setState when a <Redirect> changes the
        // location in componentWillMount. This happens e.g. when doing
        // server rendering using a <StaticRouter>.
        this.unlisten = history.listen(function() {
            _this2.setState({
                match: _this2.computeMatch(history.location.pathname)
            });
        });
    };
    Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(this.props.history === nextProps.history, "You cannot change <Router history>");
    };
    Router.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unlisten();
    };
    Router.prototype.render = function render() {
        var children = this.props.children;
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(children) : null;
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$7ee4a658adeb8d1a$var$Router.propTypes = {
    history: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node
};
$7ee4a658adeb8d1a$var$Router.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
$7ee4a658adeb8d1a$var$Router.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired
};
var $7ee4a658adeb8d1a$export$2e2bcd8739ae039 = $7ee4a658adeb8d1a$var$Router;

});


parcelRegister("9MQbY", function(module, exports) {

$parcel$export(module.exports, "default", () => $72011505e90bfe2d$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $e8LPn = parcelRequire("e8LPn");
var $72011505e90bfe2d$export$2e2bcd8739ae039 = (0, $e8LPn.default);

});
parcelRegister("e8LPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4b6e9a2b5461b16$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $1d3eD = parcelRequire("1d3eD");
function $a4b6e9a2b5461b16$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a4b6e9a2b5461b16$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a4b6e9a2b5461b16$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for rendering the first <Route> that matches.
 */ var $a4b6e9a2b5461b16$var$Switch = function(_React$Component) {
    $a4b6e9a2b5461b16$var$_inherits(Switch, _React$Component);
    function Switch() {
        $a4b6e9a2b5461b16$var$_classCallCheck(this, Switch);
        return $a4b6e9a2b5461b16$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Switch.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(this.context.router, "You should not use <Switch> outside a <Router>");
    };
    Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
    };
    Switch.prototype.render = function render() {
        var route = this.context.router.route;
        var children = this.props.children;
        var location = this.props.location || route.location;
        var match = void 0, child = void 0;
        (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.forEach(children, function(element) {
            if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(element)) {
                var _element$props = element.props, pathProp = _element$props.path, exact = _element$props.exact, strict = _element$props.strict, sensitive = _element$props.sensitive, from = _element$props.from;
                var path = pathProp || from;
                child = element;
                match = (0, $1d3eD.default)(location.pathname, {
                    path: path,
                    exact: exact,
                    strict: strict,
                    sensitive: sensitive
                }, route.match);
            }
        });
        return match ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
            location: location,
            computedMatch: match
        }) : null;
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$a4b6e9a2b5461b16$var$Switch.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        route: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired
    }).isRequired
};
$a4b6e9a2b5461b16$var$Switch.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
var $a4b6e9a2b5461b16$export$2e2bcd8739ae039 = $a4b6e9a2b5461b16$var$Switch;

});


parcelRegister("2sEko", function(module, exports) {

$parcel$export(module.exports, "useTeamVisibility", () => $5aebb31ceecfc80b$export$acf57ff2f92f51c1);

var $eUqFw = parcelRequire("eUqFw");

var $4MkQ9 = parcelRequire("4MkQ9");

var $eFsBo = parcelRequire("eFsBo");

var $chxpa = parcelRequire("chxpa");

var $5tIUP = parcelRequire("5tIUP");

var $6XUHL = parcelRequire("6XUHL");
const $5aebb31ceecfc80b$export$7d97a022bd09a6fb = ()=>{
    return {
        isTeamsVisiblityEnabled: true,
        failOpenSites: false
    };
};
const $5aebb31ceecfc80b$var$useTeamPermissionsAnalytics = ({ data: data, error: error, permissions: permissions })=>{
    const { fireEvent: fireEvent } = (0, $4MkQ9.usePeopleTeamAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (error) {
            (0, $chxpa.logException)(error, 'Error loading team permissions in useTeamsPermissionsService');
            fireEvent('operational.teamsPermissionsRequest.failed', {
                message: error.message,
                status: error.status,
                path: error.path
            });
        }
    }, [
        error,
        fireEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (data && permissions) fireEvent('operational.teamsPermissionsRequest.succeeded', {
            canCreateTeams: permissions.canCreateTeams,
            canViewTeams: permissions.canViewTeams,
            canAdminTeams: !!permissions.canAdminTeams
        });
    }, [
        data,
        fireEvent,
        permissions
    ]);
};
const $5aebb31ceecfc80b$export$acf57ff2f92f51c1 = ()=>{
    const { orgId: orgId } = (0, $5tIUP.useV3OrgIdStatus)();
    const [{ cloudId: cloudId }] = (0, $6XUHL.useSite)();
    const result = (0, $eFsBo.useTeamsPermissionsService)({
        orgId: orgId,
        cloudId: cloudId
    }, {
        enabled: true
    });
    $5aebb31ceecfc80b$var$useTeamPermissionsAnalytics(result);
    return {
        isLoading: result.isLoading,
        permissions: result.permissions
    };
};

});
parcelRegister("5tIUP", function(module, exports) {

$parcel$export(module.exports, "useV3OrgIdStatus", () => $f873947ce1669c4b$export$52558c271a487a01);

var $cWYE1 = parcelRequire("cWYE1");
function $f873947ce1669c4b$export$52558c271a487a01() {
    const [{ orgId: orgId }] = (0, $cWYE1.useOrg)();
    return {
        orgId: orgId,
        isOrgLoading: !orgId
    };
}

});


parcelRegister("QAW5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $edcc4ae3113f9523$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $7qMvm = parcelRequire("7qMvm");

var $gjneQ = parcelRequire("gjneQ");

var $4RubW = parcelRequire("4RubW");
const $edcc4ae3113f9523$var$AgentProfileRoute = ({ match: match })=>{
    const { agentId: agentId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RubW.default), {
        name: (0, $1io2n.AnalyticsKeys).AGENT_PROFILE_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qMvm.default), {
        name: (0, $1io2n.AnalyticsKeys).AGENT_PROFILE_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gjneQ.default), {
        agentId: decodeURIComponent(agentId)
    }));
};
var $edcc4ae3113f9523$export$2e2bcd8739ae039 = $edcc4ae3113f9523$var$AgentProfileRoute;

});
parcelRegister("7qMvm", function(module, exports) {

$parcel$export(module.exports, "default", () => $080311b12c26624d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $74Hyh = parcelRequire("74Hyh");
const $080311b12c26624d$export$430619e48d4c20bb = (props)=>{
    const analytics = (0, $74Hyh.default)();
    const { name: name } = props;
    (0, $eUqFw.useEffect)(()=>{
        analytics.pushOperationalEvent({
            source: (0, $1io2n.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: name,
            action: (0, $1io2n.AnalyticsEventActions).MOUNTED
        });
    }, [
        analytics,
        name
    ]);
    return null;
};
var $080311b12c26624d$export$2e2bcd8739ae039 = $080311b12c26624d$export$430619e48d4c20bb;

});
parcelRegister("74Hyh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c682e676c991a7a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $J9LlC = parcelRequire("J9LlC");
const $8c682e676c991a7a$var$useAnalytics = ()=>(0, $eUqFw.useContext)((0, $J9LlC.AnalyticsContext)).analytics;
var $8c682e676c991a7a$export$2e2bcd8739ae039 = $8c682e676c991a7a$var$useAnalytics;

});


parcelRegister("gjneQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7408c0876dba071$export$2e2bcd8739ae039);

var $bYKiA = parcelRequire("bYKiA");

var $6N6gd = parcelRequire("6N6gd");

const $c7408c0876dba071$var$LazyAgentProfile = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("c50mH")),
    loading: ()=>null
});
$c7408c0876dba071$var$LazyAgentProfile.displayName = 'lazy(AgentProfile)';
var $c7408c0876dba071$export$2e2bcd8739ae039 = (0, $6N6gd.AgentProfilePageComponent);

});
parcelRegister("6N6gd", function(module, exports) {

$parcel$export(module.exports, "AgentProfilePageComponent", () => $9ee032f59205ed68$export$555f6d88454da0bb);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $fM5iV = parcelRequire("fM5iV");
var $1n3pn = parcelRequire("1n3pn");
var $920hm = parcelRequire("920hm");

var $4Bees = parcelRequire("4Bees");

var $18uvb = parcelRequire("18uvb");

var $6XUHL = parcelRequire("6XUHL");

var $5OFKT = parcelRequire("5OFKT");

var $4vhsL = parcelRequire("4vhsL");

var $kZURK = parcelRequire("kZURK");

var $UsOwV = parcelRequire("UsOwV");

var $h9to7 = parcelRequire("h9to7");
var $92Jzo = parcelRequire("92Jzo");
var $3fooa = parcelRequire("3fooa");
var $biE4w = parcelRequire("biE4w");

var $91PIt = parcelRequire("91PIt");

var $91BVc = parcelRequire("91BVc");

var $5BUhr = parcelRequire("5BUhr");

var $jvkFO = parcelRequire("jvkFO");

var $1g5v7 = parcelRequire("1g5v7");

var $78YIS = parcelRequire("78YIS");

var $1V5FM = parcelRequire("1V5FM");
const $9ee032f59205ed68$var$mainColumnStyle = (0, $1ZAYh.xcss)({});
const $9ee032f59205ed68$var$bannerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.500',
    marginInline: 'space.negative.400'
});
const $9ee032f59205ed68$var$avatarStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.300'
});
const $9ee032f59205ed68$export$555f6d88454da0bb = (props)=>{
    const { agentId: agentId } = props;
    const { productName: productName } = (0, $kZURK.useAppConfig)();
    const [{ cloudId: cloudId }] = (0, $6XUHL.useSite)();
    const { agentInfo: agentInfo, setAgentInfo: setAgentInfo } = (0, $5OFKT.useRovoAgentData)();
    const { data: data, error: error, isFetching: isFetching } = (0, $18uvb.useAgentDetailsController)({
        agentId: agentId,
        experienceId: 'profile-page',
        product: productName,
        enabled: agentInfo?.id !== agentId
    });
    (0, $eUqFw.useEffect)(()=>{
        if (data) setAgentInfo(data);
    }, [
        data,
        setAgentInfo
    ]);
    const { setFavouriteAgent: setFavouriteAgent, editAgent: editAgent, copyAgent: copyAgent, duplicateAgent: duplicateAgent, deleteAgent: deleteAgent } = (0, $1V5FM.useAgentActions)({
        agentId: data?.id,
        product: productName,
        cloudId: cloudId
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $91PIt.ErrorScreen), {
        error: error,
        key: agentId
    });
    if (isFetching) /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4vhsL.App), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "medium"
    }));
    if (!data) return null;
    const handleFavouriteAgent = async ()=>{
        setFavouriteAgent(!data.favourite);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $UsOwV.default), {
        title: data.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4vhsL.App), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9ee032f59205ed68$var$bannerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1n3pn.AgentBanner), {
        agentId: data.id,
        agentNamedId: data.named_id,
        height: 192
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $92Jzo.Body), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $biE4w.ResponsiveSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h9to7.AsideColumn), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9ee032f59205ed68$var$avatarStyles,
        style: {
            marginTop: '-105px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fM5iV.AgentAvatar), {
        agentId: data.id,
        agentNamedId: data.named_id,
        size: "xxlarge"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $920hm.AgentProfileInfo), {
        agentName: data?.name,
        isStarred: data.favourite,
        onStarToggle: ()=>handleFavouriteAgent(),
        creatorRender: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1g5v7.AgentCreator), {
            create_type: data.creator_type,
            creator: data.creator || undefined
        }),
        starCountRender: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $920hm.AgentStarCount), {
            isLoading: isFetching,
            starCount: data?.favourite_count
        }),
        agentDescription: data.description,
        isHidden: data.visibility === 'PRIVATE'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BUhr.AgentActions), {
        isAgentCreatedByUser: false,
        onEditAgent: editAgent,
        onCopyAgent: copyAgent,
        onDuplicateAgent: duplicateAgent,
        onDeleteAgent: deleteAgent,
        onChatClick: function() {
            throw new Error('Function not implemented.');
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $91BVc.AgentAboutPanel), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3fooa.MainColumn), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.500",
        xcss: $9ee032f59205ed68$var$mainColumnStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvkFO.AgentConversationStartersSection), {
        isAgentDefault: data.is_default,
        userDefinedConversationStarters: data.user_defined_conversation_starters,
        onConversationStarterClick: function(conversationStarter) {
            throw new Error(`Function not implemented. Input : ${conversationStarter}`);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78YIS.AgentInstructions), {
        promptTemplate: data.system_prompt_template,
        onCopy: function(promptTemplate) {
            throw new Error(`Function not implemented. Input : ${promptTemplate}`);
        }
    }))))))));
};

});
parcelRegister("fM5iV", function(module, exports) {

$parcel$export(module.exports, "AgentAvatar", () => $c46244c3a4e4701a$export$38b71b080e1832c8);

var $eUqFw = parcelRequire("eUqFw");

var $eri7S = parcelRequire("eri7S");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1n3pn = parcelRequire("1n3pn");
/**
 * This solution has been derived from this codepen: https://codepen.io/anyen-ltovn/pen/qBYYzea
 */ const $c46244c3a4e4701a$var$agentAvatarStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    clipPath: `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`
});
const $c46244c3a4e4701a$var$innerShapeStyles = (0, $1ZAYh.xcss)({
    height: '95%',
    width: '95%',
    clipPath: `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`
});
const $c46244c3a4e4701a$var$imageStyles = (0, $1ZAYh.xcss)({
    objectFit: 'cover',
    height: '100%',
    width: '100%'
});
const $c46244c3a4e4701a$var$avatarContentContainer = (0, $1ZAYh.xcss)({
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $c46244c3a4e4701a$export$38b71b080e1832c8 = ({ imageUrl: imageUrl, size: size = 'medium', label: label, name: name, agentId: agentId, agentNamedId: agentNamedId, showBorder: showBorder = true })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        "aria-label": label,
        xcss: $c46244c3a4e4701a$var$agentAvatarStyles,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            height: (0, $eri7S.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            width: (0, $eri7S.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/ensure-design-token-usage
            ...showBorder ? {
                backgroundColor: '#fff'
            } : {}
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c46244c3a4e4701a$var$innerShapeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $c46244c3a4e4701a$var$avatarContentContainer
    }, imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "img",
        xcss: $c46244c3a4e4701a$var$imageStyles,
        src: imageUrl,
        alt: name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1n3pn.GeneratedAvatar), {
        agentId: agentId,
        agentNamedId: agentNamedId,
        size: size
    }))));
};

});
parcelRegister("1n3pn", function(module, exports) {

$parcel$export(module.exports, "AgentBanner", () => $301f5eef7defe046$export$6efaefb8ad2fba40);
$parcel$export(module.exports, "GeneratedAvatar", () => $301f5eef7defe046$export$96bb253b7de22616);

var $eUqFw = parcelRequire("eUqFw");

var $eri7S = parcelRequire("eri7S");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5TKhN = parcelRequire("5TKhN");

var $gintv = parcelRequire("gintv");

var $dLzpK = parcelRequire("dLzpK");

var $4MSOB = parcelRequire("4MSOB");

var $7bSsT = parcelRequire("7bSsT");

var $7NM53 = parcelRequire("7NM53");

var $19LR2 = parcelRequire("19LR2");

var $a4vlK = parcelRequire("a4vlK");

var $6Je5I = parcelRequire("6Je5I");

var $fksEs = parcelRequire("fksEs");

var $fGiBX = parcelRequire("fGiBX");

var $54k0x = parcelRequire("54k0x");

var $bTTug = parcelRequire("bTTug");

var $8zvm7 = parcelRequire("8zvm7");

var $8zaiw = parcelRequire("8zaiw");

var $3oTAZ = parcelRequire("3oTAZ");

var $3ptGp = parcelRequire("3ptGp");

var $7zNkv = parcelRequire("7zNkv");

var $lLzmU = parcelRequire("lLzmU");

var $89yuV = parcelRequire("89yuV");

var $pHJ36 = parcelRequire("pHJ36");
const $301f5eef7defe046$var$yellowColor = {
    primary: '#FCA700',
    secondary: '#FFC716'
};
const $301f5eef7defe046$var$purpleColor = {
    primary: '#BF63F3',
    secondary: '#D8A0F7'
};
const $301f5eef7defe046$var$greenColor = {
    primary: '#82B536',
    secondary: '#B3DF72'
};
const $301f5eef7defe046$var$blueColor = {
    primary: '#357DE8',
    secondary: '#669DF1'
};
const $301f5eef7defe046$var$colorList = [
    $301f5eef7defe046$var$yellowColor,
    $301f5eef7defe046$var$purpleColor,
    $301f5eef7defe046$var$greenColor,
    $301f5eef7defe046$var$blueColor
];
const $301f5eef7defe046$var$avatarList = [
    (0, $19LR2.CustomerInsightAvatar),
    (0, $4MSOB.BacklogBuddyAvatar),
    (0, $a4vlK.DecisionDirectorAvatar),
    (0, $7bSsT.CommsCrafterAvatar),
    (0, $5TKhN.AutoDevAvatar),
    (0, $8zvm7.OkrOracleAvatar),
    (0, $7NM53.CultureAvatar),
    (0, $89yuV.SocialMediaScribeAvatar),
    (0, $pHJ36.TeamConnectionAvatar),
    (0, $fGiBX.HireWriterAvatar),
    (0, $8zaiw.OpsAgentAvatar),
    (0, $lLzmU.ResearchScoutAvatar),
    (0, $7zNkv.ReleaseNotesAvatar),
    (0, $bTTug.MyUserManualAvatar),
    (0, $3oTAZ.PitchPerfectorAvatar),
    (0, $5TKhN.AutoDevAvatar),
    (0, $gintv.AutoFixAvatar),
    (0, $dLzpK.AutoReviewAvatar),
    (0, $54k0x.MarketingMessageMaestroAvatar),
    (0, $6Je5I.FeatureFlagAvatar),
    (0, $3ptGp.ProductRequirementAvatar)
];
const $301f5eef7defe046$export$a834793a4d0d739e = $301f5eef7defe046$var$avatarList.length * $301f5eef7defe046$var$colorList.length;
const $301f5eef7defe046$var$imageStyles = (0, $1ZAYh.xcss)({
    objectFit: 'cover',
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $301f5eef7defe046$var$outOfTheBoxAgentAvatar = {
    decision_director_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a4vlK.DecisionDirectorAvatar), {
                size: (0, $eri7S.AVATAR_SIZES)[size],
                primaryColor: $301f5eef7defe046$var$greenColor.primary,
                secondaryColor: $301f5eef7defe046$var$greenColor.secondary
            }),
        color: $301f5eef7defe046$var$greenColor
    },
    user_manual_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bTTug.MyUserManualAvatar), {
                size: (0, $eri7S.AVATAR_SIZES)[size],
                primaryColor: $301f5eef7defe046$var$yellowColor.primary,
                secondaryColor: $301f5eef7defe046$var$yellowColor.secondary
            }),
        color: $301f5eef7defe046$var$yellowColor
    },
    product_requirements_expert_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ptGp.ProductRequirementAvatar), {
                size: (0, $eri7S.AVATAR_SIZES)[size],
                primaryColor: $301f5eef7defe046$var$yellowColor.primary,
                secondaryColor: $301f5eef7defe046$var$yellowColor.secondary
            }),
        color: $301f5eef7defe046$var$yellowColor
    }
};
const $301f5eef7defe046$var$getAvatarRender = ({ agentNamedId: agentNamedId, agentId: agentId, size: size })=>{
    if (typeof agentNamedId === 'string' && $301f5eef7defe046$var$outOfTheBoxAgentAvatar[agentNamedId]) {
        const ootbAvatarResult = $301f5eef7defe046$var$outOfTheBoxAgentAvatar[agentNamedId];
        return {
            render: ootbAvatarResult.getRender(size),
            color: ootbAvatarResult.color
        };
    }
    if (agentId) {
        // Take the last 8 characters of the agentId because JS can't handle 16 digit numbers
        const agentIdSubset = agentId.slice(-8).replace(/-/g, '');
        let agentIdNumber = parseInt(agentIdSubset, 16);
        if (isNaN(agentIdNumber)) agentIdNumber = 0;
        /**
		 * this create all possible combinations of avatars and colors
		 * e.g. [[avatar1, color1], [avatar1, color2], [avatar2, color1], [avatar2, color2]]
		 * then choose 1 based on agentId
		 */ const totalCombinations = $301f5eef7defe046$var$avatarList.length * $301f5eef7defe046$var$colorList.length;
        const combinationIndex = agentIdNumber % totalCombinations;
        const avatarIndex = Math.floor(combinationIndex / $301f5eef7defe046$var$colorList.length);
        const colorIndex = combinationIndex % $301f5eef7defe046$var$colorList.length;
        const Avatar = $301f5eef7defe046$var$avatarList[avatarIndex];
        const color = $301f5eef7defe046$var$colorList[colorIndex];
        return {
            render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Avatar, {
                size: (0, $eri7S.AVATAR_SIZES)[size],
                primaryColor: color.primary,
                secondaryColor: color.secondary
            }),
            color: color
        };
    }
    return {
        render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fksEs.GenericAvatar), {
            size: (0, $eri7S.AVATAR_SIZES)[size],
            primaryColor: $301f5eef7defe046$var$blueColor.primary,
            secondaryColor: $301f5eef7defe046$var$blueColor.secondary
        }),
        color: $301f5eef7defe046$var$blueColor
    };
};
const $301f5eef7defe046$var$bannerStyles = (0, $1ZAYh.xcss)({
    width: '100%'
});
const $301f5eef7defe046$export$6efaefb8ad2fba40 = ({ agentNamedId: agentNamedId, agentId: agentId, height: height })=>{
    const { color: color } = $301f5eef7defe046$var$getAvatarRender({
        agentNamedId: agentNamedId,
        agentId: agentId,
        size: 'medium'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $301f5eef7defe046$var$bannerStyles,
        style: {
            backgroundColor: color.primary,
            height: `${height}px`
        }
    });
};
const $301f5eef7defe046$export$96bb253b7de22616 = ({ agentNamedId: agentNamedId, agentId: agentId, size: size })=>{
    const { render: render, color: color } = $301f5eef7defe046$var$getAvatarRender({
        agentNamedId: agentNamedId,
        agentId: agentId,
        size: size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $301f5eef7defe046$var$imageStyles,
        style: {
            backgroundColor: color.primary
        }
    }, render);
};

});
parcelRegister("5TKhN", function(module, exports) {

$parcel$export(module.exports, "AutoDevAvatar", () => $3444d93806696fba$export$924fd2eb3b80e770);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $3444d93806696fba$export$924fd2eb3b80e770 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_38723",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_38723)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M28.1825 42.0567C27.4637 41.2946 26.8066 40.3889 26.0573 39.5292L26.41 39.6078C26.6455 39.6557 26.8801 39.717 27.116 39.7836L27.3024 39.8348L27.4918 39.8679L27.876 39.9295C28.0059 39.9463 28.1355 39.9698 28.2648 39.9713C28.3959 39.9714 28.5274 39.9647 28.6592 39.9547C28.6403 39.8853 28.6692 39.8293 28.7039 39.8633L28.7015 39.9507C28.8733 39.8943 29.0302 39.8852 29.1782 39.8583C29.3245 39.833 29.4631 39.8203 29.602 39.8043C29.7393 39.7865 29.8765 39.772 30.0076 39.7214C30.1389 39.6676 30.2685 39.5899 30.3972 39.4751C30.3972 39.4751 30.3617 39.6029 30.3615 39.6063C31.399 39.297 32.5486 38.7195 33.509 37.878C34.4804 37.0494 35.2286 35.9634 35.6719 34.9133L35.6548 34.9183L35.6455 34.9072C35.6027 34.9433 35.5384 35.026 35.4613 35.1225C35.3794 35.2169 35.2845 35.3285 35.1968 35.4341C35.1106 35.5415 35.0282 35.6426 34.9677 35.7189C34.9055 35.7935 34.8623 35.8362 34.8623 35.8362C34.8847 35.6277 34.9215 35.4292 35.007 35.256C35.0876 35.0806 35.2007 34.922 35.3061 34.7541C35.4163 34.5885 35.5415 34.4261 35.6519 34.2571C35.7526 34.0838 35.8486 33.9049 35.9148 33.7195L36.0176 33.7655C35.8886 34.086 35.8359 34.3959 35.8172 34.5254C36.1337 33.99 36.5204 33.1077 36.6709 32.1623C36.838 31.2219 36.8003 30.252 36.6576 29.6456C36.5746 29.6808 36.7833 30.0547 36.5128 30.1533C36.4913 29.8459 36.4445 29.5409 36.3929 29.2558C36.5723 29.2372 36.5371 29.4123 36.5738 29.4414C36.5883 29.3754 36.5811 29.1572 36.5545 28.8257C36.5454 28.6595 36.4958 28.4706 36.4563 28.2575C36.4332 28.1506 36.4121 28.0388 36.3863 27.9215C36.3554 27.8054 36.3145 27.6882 36.2759 27.5628C36.1965 27.3169 36.1185 27.0509 35.9879 26.7913C35.8676 26.5294 35.75 26.2525 35.5807 25.994C35.5004 25.8626 35.4201 25.7312 35.3383 25.598C35.2582 25.4633 35.1516 25.3478 35.0591 25.2236C34.9614 25.1006 34.8671 24.9778 34.771 24.8566C34.6713 24.7384 34.5574 24.6323 34.4504 24.5235C33.5943 23.6528 32.6226 23.0787 32.0206 22.8816C31.4184 22.6626 31.2239 22.7066 31.6728 23.1559L31.58 23.2121C31.709 23.2928 31.8334 23.368 31.956 23.4448C32.0771 23.5197 32.1946 23.5975 32.2991 23.6926C32.5101 23.8813 32.7297 24.0659 32.9188 24.3299C32.9949 24.3731 32.9917 24.3947 33.0472 24.3195C33.0739 24.3222 33.1206 24.3271 33.1349 24.2898C33.2614 24.1073 33.3641 24.305 33.4364 24.3547C33.3042 24.4725 33.3302 24.6117 33.4416 24.7548C33.5511 24.9026 33.7242 25.0789 33.9335 25.2405C33.9863 25.2814 34.039 25.3222 34.0951 25.3634C34.1442 25.4073 34.195 25.453 34.2424 25.4983C34.3441 25.5864 34.4393 25.6704 34.5265 25.7485C34.7098 25.8973 34.8315 26.038 34.8627 26.1002C34.7375 26.212 34.8038 26.3268 34.8988 26.4394C34.9938 26.5521 35.1204 26.6697 35.0881 26.7759C35.0716 26.7709 34.9761 26.7407 34.9594 26.739C34.9287 26.7965 35.0005 26.954 35.1184 27.1516C35.1738 27.2534 35.2559 27.358 35.3133 27.4803C35.3758 27.6014 35.4398 27.7243 35.5008 27.8436C35.6347 28.0783 35.71 28.3086 35.7369 28.4344C35.7636 28.5636 35.7282 28.5903 35.588 28.4494C35.581 28.629 35.6061 28.807 35.5967 28.9982C35.5924 29.1883 35.5946 29.3824 35.6032 29.5805C35.5866 29.98 35.5904 30.4002 35.5461 30.8356C35.4762 31.7068 35.3111 32.6423 34.9972 33.5421C34.685 34.4405 34.2226 35.298 33.649 35.984C33.4985 36.1488 33.3625 36.3236 33.2017 36.4655C33.041 36.6073 32.8854 36.748 32.7257 36.8732C32.5568 36.9872 32.39 37.0931 32.2288 37.1911C32.0661 37.2872 31.8872 37.3497 31.7264 37.4157L31.7669 37.4384C31.7416 37.4408 31.6959 37.4951 31.6561 37.4623C31.5877 37.6053 31.3922 37.7638 31.223 37.9065C31.1378 37.9753 31.0578 38.0395 30.9962 38.082C30.9332 38.1193 30.8946 38.1423 30.8946 38.1423L30.5607 38.3607L30.3904 38.4696L30.2112 38.5606C30.2112 38.5606 30.1244 38.577 29.99 38.6019C29.8553 38.6301 29.669 38.6766 29.4625 38.6991C29.359 38.7137 29.2534 38.7332 29.1477 38.7559C29.042 38.7787 28.9376 38.8068 28.8343 38.818C28.6287 38.8524 28.4404 38.9038 28.3008 38.9804C28.1223 38.9856 27.9436 38.9435 27.7664 38.9286C27.5884 38.9017 27.4103 38.9002 27.2356 38.8485C26.9908 38.7895 26.0919 38.6595 25.4612 38.5404C25.8807 37.9717 27.4374 37.3385 27.57 36.7621L28.3342 36.4179C28.7605 36.1501 28.5417 35.0485 27.8834 35.493C26.7498 36.3099 24.9778 36.8215 24.2746 38.2645L24.2881 38.2624C24.2881 38.2624 24.0737 38.5286 24.0564 38.4863C23.9855 38.6662 23.9727 38.9329 23.9727 38.9329C24.1136 39.5914 25.0757 40.3601 25.5582 40.4589C25.4193 40.5254 28.2934 43.2146 28.181 42.0549L28.1825 42.0567Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17.0077 6.00108C17.6634 6.93211 18.2306 8.00818 18.9041 9.04887L18.5367 8.90986C18.2907 8.82193 18.0478 8.71975 17.8043 8.61175L17.6115 8.52777L17.4128 8.46294L17.009 8.33736C16.8718 8.29921 16.736 8.25395 16.5971 8.23231C16.4561 8.212 16.3135 8.19884 16.1702 8.18924C16.1798 8.26682 16.14 8.32261 16.1079 8.28074L16.1241 8.18706C15.9304 8.22124 15.7602 8.20679 15.5968 8.21283C15.4355 8.21753 15.2844 8.20974 15.1325 8.20551C14.9819 8.20351 14.8321 8.19792 14.6833 8.23204C14.5336 8.26972 14.3822 8.33327 14.226 8.43696C14.226 8.43696 14.2839 8.30486 14.2846 8.30129C13.1205 8.47383 11.7944 8.91777 10.631 9.67493C9.45782 10.4165 8.48502 11.4695 7.84587 12.5309L7.86508 12.5282L7.8734 12.5415C7.92496 12.5093 8.00699 12.4303 8.1048 12.3383C8.20754 12.2494 8.32684 12.144 8.43754 12.0439C8.54686 11.9416 8.65111 11.8456 8.72807 11.7728C8.80642 11.7022 8.85952 11.6629 8.85952 11.6629C8.8033 11.8837 8.73305 12.0917 8.61426 12.2649C8.5004 12.4412 8.3542 12.5944 8.21493 12.7587C8.07074 12.9199 7.911 13.0753 7.76605 13.24C7.63096 13.411 7.50004 13.5887 7.40021 13.7779L7.29671 13.7126C7.48499 13.3876 7.58946 13.0624 7.62964 12.9259C7.20643 13.4531 6.65411 14.3428 6.34608 15.3368C6.02111 16.3228 5.91189 17.3722 5.97174 18.0468C6.06652 18.0217 5.89975 17.5871 6.20598 17.5229C6.18162 17.857 6.18496 18.1923 6.19636 18.5072C6.00046 18.4994 6.0654 18.3165 6.03039 18.2795C6.00461 18.3482 5.97872 18.5842 5.95614 18.945C5.94023 19.1251 5.9644 19.336 5.97403 19.5715C5.98238 19.6901 5.98783 19.8136 5.99744 19.9438C6.01275 20.0736 6.03866 20.2059 6.06092 20.3468C6.10834 20.6237 6.15121 20.9219 6.25159 21.2215C6.34059 21.5219 6.42443 21.838 6.56665 22.1423C6.63276 22.2961 6.69886 22.4498 6.76637 22.6058C6.83172 22.7631 6.92854 22.9038 7.00894 23.0518C7.09502 23.1992 7.17759 23.3459 7.26228 23.4911C7.35127 23.6337 7.45743 23.7655 7.55577 23.8991C8.3425 24.9682 9.29943 25.736 9.91673 26.041C10.5309 26.3696 10.747 26.3523 10.3333 25.7996L10.4418 25.7535C10.3155 25.6466 10.1932 25.5465 10.0732 25.445C9.95447 25.3457 9.84009 25.2438 9.74225 25.1253C9.54444 24.8897 9.33661 24.6572 9.17392 24.344C9.09872 24.2857 9.10544 24.263 9.03417 24.3353C9.00586 24.3282 8.95629 24.3158 8.93519 24.3537C8.77091 24.5305 8.69088 24.3019 8.62073 24.2373C8.78123 24.131 8.77476 23.9771 8.67693 23.806C8.58199 23.63 8.423 23.4136 8.22266 23.2074C8.17222 23.1553 8.12178 23.1032 8.06781 23.0502C8.02167 22.9954 7.97414 22.9384 7.93015 22.8823C7.83434 22.7718 7.74484 22.6667 7.66306 22.5692C7.48876 22.3808 7.37954 22.2106 7.35565 22.1389C7.50755 22.0379 7.45396 21.9042 7.36915 21.7683C7.28433 21.6324 7.16626 21.4863 7.21744 21.377C7.23437 21.385 7.33248 21.4321 7.35017 21.4366C7.39213 21.3794 7.33916 21.1989 7.24283 20.9681C7.19896 20.8499 7.12678 20.7247 7.08392 20.5843C7.03537 20.4444 6.98542 20.3022 6.93826 20.1644C6.83043 19.8912 6.7849 19.6318 6.77541 19.4922C6.76668 19.3491 6.8089 19.3259 6.93796 19.4991C6.9732 19.3069 6.97368 19.1116 7.01335 18.9073C7.04733 18.7034 7.07497 18.4942 7.09631 18.2797C7.17589 17.8523 7.23666 17.3997 7.3515 16.9379C7.56134 16.0114 7.88338 15.0303 8.36015 14.1105C8.83476 13.1921 9.46472 12.3407 10.1878 11.6913C10.3753 11.5371 10.5486 11.3701 10.7435 11.2422C10.9384 11.1144 11.1276 10.987 11.3186 10.877C11.5181 10.7804 11.7138 10.6923 11.9024 10.6117C12.0924 10.5334 12.2945 10.4938 12.4777 10.4476L12.4376 10.4169C12.4653 10.4182 12.5228 10.3669 12.5606 10.4083C12.6562 10.265 12.8911 10.1246 13.0952 9.99721C13.1975 9.93641 13.2935 9.87964 13.3664 9.84341C13.4399 9.81298 13.4849 9.7942 13.4849 9.7942L13.878 9.61076L14.078 9.51991L14.2849 9.44963C14.2849 9.44963 14.3808 9.44546 14.5293 9.43944C14.6786 9.42985 14.8862 9.40854 15.112 9.41623C15.2256 9.41651 15.3421 9.41191 15.4594 9.4037C15.5767 9.3955 15.6933 9.38148 15.8062 9.38532C16.0328 9.38008 16.2433 9.35388 16.4054 9.29299C16.5982 9.31499 16.784 9.38787 16.9724 9.43129C17.1598 9.48764 17.3511 9.51676 17.5311 9.59944C17.7854 9.70073 18.7326 9.9794 19.3929 10.2049C18.8536 10.752 17.0809 11.193 16.8491 11.7927L15.9736 12.0451C15.4736 12.2675 15.5389 13.4866 16.3159 13.1099C17.6618 12.406 19.6476 12.1292 20.627 10.6851L20.6121 10.6852C20.6121 10.6852 20.884 10.4319 20.8961 10.48C21.0001 10.2975 21.0551 10.0125 21.0551 10.0125C21.0052 9.2821 20.0887 8.30642 19.5847 8.12568C19.7445 8.07549 17.0672 4.7381 17.009 6.00331L17.0077 6.00108Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.7263 17.4769H19.2806L20.7156 21.3007L24.745 20.6313L27.0244 24.5776L24.43 27.7319L27.0244 30.8863L24.745 34.8326L20.7156 34.1632L19.2806 37.9869H14.7263L13.2913 34.1632L9.26189 34.8326L6.98251 30.8863L9.57689 27.7319L6.98251 24.5776L9.26189 20.6313L13.2913 21.3007L14.7263 17.4769ZM17.0056 31.5732C19.1275 31.5732 20.8513 29.8538 20.8513 27.7276C20.8513 25.6013 19.1319 23.8819 17.0056 23.8819C14.8794 23.8819 13.16 25.6013 13.16 27.7276C13.16 29.8538 14.8794 31.5732 17.0056 31.5732Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.41 10.0875H28.9669L30.0869 13.0713L33.2281 12.5463L35.0044 15.6263L32.9787 18.0894L35.0044 20.5482L33.2281 23.6282L30.0869 23.1075L28.9669 26.0913H25.41L24.29 23.1075L21.1487 23.6282L19.3725 20.5482L21.3981 18.0894L19.3725 15.6307L21.1487 12.5506L24.29 13.0756L25.41 10.0919V10.0875ZM27.1862 21.0906C28.8444 21.0906 30.1875 19.7475 30.1875 18.0894C30.1875 16.4313 28.8444 15.0881 27.1862 15.0881C25.5281 15.0881 24.185 16.4313 24.185 18.0894C24.185 19.7475 25.5281 21.0906 27.1862 21.0906Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.7406 20.6269L20.7113 21.3007L20.0988 19.66L19.3681 20.5482L21.1488 23.6282L24.29 23.1032L25.41 26.0869H25.7731L27.02 24.5732L24.7406 20.6269Z",
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.7406 20.6269L20.7113 21.3007L20.0988 19.66L19.3681 20.5482L21.1488 23.6282L24.29 23.1032L25.41 26.0869H25.7731L27.02 24.5732L24.7406 20.6269Z",
        fill: primaryColor
    }));

});

parcelRegister("gintv", function(module, exports) {

$parcel$export(module.exports, "AutoFixAvatar", () => $bc38cce80b930a55$export$e83caff46c768c68);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $bc38cce80b930a55$export$e83caff46c768c68 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_38827",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_38827)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M22.4348 41.2002C22.0455 40.0423 21.7917 38.7624 21.4178 37.4864L21.7529 37.7418C21.9789 37.9074 22.1974 38.0868 22.4147 38.2724L22.5872 38.4177L22.7716 38.5452L23.1484 38.7978C23.2778 38.8791 23.4035 38.9671 23.5397 39.0319C23.6785 39.0959 23.821 39.1531 23.9654 39.2068C23.9793 39.1241 24.0373 39.0789 24.0575 39.1318L24.0122 39.2232C24.2217 39.2473 24.3923 39.3142 24.5622 39.358C24.7294 39.4025 24.8824 39.4568 25.0373 39.5076C25.1915 39.5558 25.3438 39.6073 25.5073 39.6178C25.6726 39.6249 25.8477 39.6059 26.0401 39.5471C26.0401 39.5471 25.9402 39.6652 25.9383 39.6686C27.1879 39.8475 28.6872 39.7969 30.115 39.3744C31.5481 38.971 32.8704 38.1861 33.8523 37.2905L33.8318 37.2874L33.8273 37.2711C33.7644 37.2884 33.6559 37.3446 33.5272 37.4093C33.3944 37.4692 33.2395 37.5411 33.095 37.6101C32.9513 37.6818 32.8148 37.7486 32.7134 37.7999C32.6112 37.8485 32.5446 37.8727 32.5446 37.8727C32.67 37.6628 32.8058 37.4706 32.9809 37.3289C33.152 37.1824 33.3491 37.0697 33.5426 36.9434C33.7402 36.8218 33.952 36.7109 34.1514 36.5858C34.3426 36.4514 34.5316 36.3088 34.6921 36.1448L34.7785 36.2437C34.4855 36.5201 34.2786 36.8225 34.1955 36.9506C34.792 36.538 35.6321 35.7924 36.2529 34.8647C36.8888 33.9504 37.3222 32.9049 37.4671 32.193C37.362 32.1898 37.4004 32.6877 37.066 32.66C37.1932 32.324 37.2924 31.9782 37.377 31.651C37.5761 31.7189 37.4533 31.8872 37.478 31.9359C37.5255 31.8731 37.6243 31.6385 37.758 31.2744C37.8295 31.0941 37.8692 30.8698 37.9313 30.6248C37.959 30.5003 37.9912 30.3717 38.0212 30.2349C38.0451 30.0968 38.059 29.9528 38.0792 29.8011C38.1152 29.502 38.1624 29.1822 38.1509 28.8435C38.1513 28.5074 38.1618 28.1568 38.1087 27.8004C38.0878 27.6221 38.0669 27.4438 38.0452 27.2628C38.0262 27.0811 37.9697 26.9067 37.9323 26.73C37.889 26.5521 37.8489 26.376 37.8063 26.2008C37.7584 26.027 37.6896 25.859 37.6294 25.6915C37.1477 24.3516 36.3989 23.2694 35.8575 22.767C35.3267 22.2412 35.0992 22.1928 35.3554 22.8877L35.2297 22.9019C35.3269 23.0504 35.422 23.1907 35.5143 23.3318C35.606 23.4702 35.6924 23.61 35.7567 23.7618C35.888 24.0645 36.0305 24.3672 36.1019 24.739C36.1614 24.8219 36.1475 24.8432 36.243 24.7907C36.2699 24.8066 36.317 24.8346 36.3503 24.802C36.5734 24.6705 36.5857 24.9301 36.638 25.0179C36.4405 25.0782 36.4 25.2383 36.4483 25.4441C36.492 25.6541 36.5892 25.9253 36.7321 26.1986C36.768 26.2676 36.8039 26.3366 36.8432 26.4076C36.8739 26.478 36.9053 26.5512 36.9334 26.6224C36.9981 26.7652 37.0579 26.9007 37.1121 27.026C37.2337 27.273 37.2939 27.4814 37.2965 27.5625C37.1094 27.6199 37.1236 27.7737 37.1692 27.9394C37.2149 28.105 37.2915 28.2914 37.2055 28.3881C37.1905 28.3747 37.1041 28.2962 37.0872 28.2862C37.0266 28.3321 37.0258 28.5339 37.0542 28.8007C37.0632 28.9356 37.0991 29.0864 37.1002 29.2439C37.1073 29.4026 37.1151 29.5641 37.1214 29.7201C37.1487 30.034 37.1161 30.3147 37.0831 30.4611C37.0483 30.6109 36.9978 30.6219 36.9181 30.4042C36.8231 30.5911 36.7628 30.7918 36.6595 30.9897C36.5622 31.1889 36.4698 31.3955 36.3822 31.6095C36.1696 32.0245 35.9686 32.4713 35.7092 32.9109C35.21 33.7992 34.5786 34.7094 33.807 35.5091C33.038 36.3081 32.1298 36.9906 31.1876 37.437C30.9478 37.5382 30.7184 37.6569 30.4789 37.7286C30.2395 37.8004 30.006 37.8735 29.7759 37.9281C29.5413 37.9664 29.313 37.9971 29.0945 38.0222C28.8753 38.0446 28.6553 38.0234 28.4528 38.0149L28.4846 38.0587C28.4566 38.0489 28.3817 38.0841 28.3556 38.03C28.2134 38.148 27.929 38.2205 27.6802 38.289C27.5563 38.3202 27.4403 38.3492 27.3543 38.3642C27.2693 38.3729 27.2173 38.3785 27.2173 38.3785L26.7571 38.4468L26.5236 38.479L26.2894 38.4879C26.2894 38.4879 26.1895 38.4629 26.035 38.4236C25.8786 38.3878 25.6586 38.3462 25.4289 38.2692C25.3122 38.2341 25.1909 38.2032 25.0679 38.1757C24.9448 38.1483 24.8206 38.127 24.7057 38.0885C24.4711 38.0246 24.2466 37.9871 24.0614 38.0001C23.8699 37.9184 23.7011 37.7867 23.5208 37.6844C23.3454 37.5691 23.1576 37.4806 22.9978 37.3405C22.7674 37.1586 21.8788 36.5822 21.269 36.1483C21.9908 35.7508 23.9484 35.8399 24.3702 35.2943L25.3475 35.3028C25.9296 35.2272 26.2355 33.9538 25.3214 34.1032C23.7223 34.4151 21.596 34.092 20.1471 35.277L20.1624 35.2814C20.1624 35.2814 19.8055 35.4586 19.8077 35.4054C19.6449 35.5613 19.5012 35.8375 19.5012 35.8375C19.329 36.6037 19.9727 37.8872 20.4355 38.2273C20.2559 38.23 21.9871 42.4805 22.4341 41.1975L22.4348 41.2002Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M21.204 3.96983C21.8102 5.11251 22.2958 6.40601 22.9063 7.67481L22.5121 7.46575C22.2475 7.33159 21.9884 7.18179 21.7293 7.02535L21.5241 6.90323L21.3094 6.80183L20.8723 6.60271C20.7231 6.54015 20.5766 6.46979 20.4231 6.42559C20.2671 6.38259 20.1083 6.34742 19.9482 6.31617C19.9479 6.40496 19.8951 6.46214 19.8649 6.41038L19.8965 6.30713C19.6734 6.31803 19.4836 6.27746 19.2986 6.26096C19.1162 6.24325 18.947 6.21291 18.7764 6.18648C18.6071 6.16275 18.4391 6.13509 18.2665 6.1523C18.0925 6.17342 17.9128 6.22343 17.722 6.318C17.722 6.318 17.806 6.1774 17.8074 6.17348C16.471 6.20187 14.9133 6.51298 13.4942 7.20026C12.0665 7.86859 10.82 8.91644 9.94841 10.0213L9.97044 10.021L9.97791 10.0372C10.0406 10.0083 10.1443 9.93096 10.2677 9.84122C10.3961 9.7557 10.5456 9.65392 10.6846 9.55695C10.8224 9.45729 10.9536 9.36393 11.0507 9.29287C11.149 9.22451 11.2145 9.18781 11.2145 9.18781C11.1196 9.42863 11.0108 9.65289 10.8522 9.83113C10.6988 10.0136 10.5122 10.1653 10.3318 10.3306C10.1463 10.4917 9.94415 10.6441 9.75731 10.8091C9.58069 10.9825 9.40782 11.164 9.26833 11.363L9.16102 11.2746C9.41954 10.9353 9.58366 10.5837 9.64841 10.4355C9.09629 10.9694 8.34701 11.8931 7.85811 12.9693C7.35128 14.034 7.07851 15.2011 7.04972 15.9698C7.16012 15.955 7.03417 15.4415 7.38841 15.4128C7.31332 15.7858 7.26924 16.1642 7.23719 16.5205C7.01754 16.4839 7.11681 16.287 7.08263 16.2404C7.04378 16.3141 6.98096 16.5763 6.90404 16.9796C6.86042 17.1804 6.85757 17.4215 6.83484 17.6882C6.82733 17.8231 6.81585 17.963 6.80812 18.1111C6.80686 18.2595 6.81718 18.4124 6.82216 18.5743C6.83611 18.8931 6.84188 19.2353 6.91227 19.5871C6.96972 19.9384 7.01911 20.3065 7.13595 20.6697C7.18853 20.8524 7.24109 21.0351 7.29491 21.2205C7.34612 21.4071 7.43514 21.5795 7.50464 21.7577C7.58061 21.9361 7.65274 22.1131 7.72746 22.2889C7.8074 22.4622 7.90824 22.6259 7.99999 22.7905C8.73405 24.1075 9.70288 25.1092 10.355 25.5409C11.0002 25.9988 11.2462 26.0102 10.8588 25.3283L10.9877 25.2918C10.8606 25.1534 10.7371 25.0231 10.6163 24.8916C10.4967 24.7628 10.3823 24.6316 10.289 24.4842C10.0997 24.1905 9.89865 23.8988 9.76 23.5226C9.68357 23.4462 9.69438 23.4216 9.60375 23.4929C9.57286 23.4809 9.51878 23.4598 9.48959 23.4995C9.27924 23.6754 9.22167 23.4063 9.15183 23.3236C9.34786 23.2266 9.36252 23.0523 9.27667 22.8455C9.1948 22.6337 9.04651 22.3671 8.85015 22.1062C8.80075 22.0403 8.75134 21.9743 8.69808 21.9069C8.65391 21.8386 8.60847 21.7676 8.56691 21.6981C8.4747 21.5599 8.38884 21.4287 8.31059 21.3071C8.14104 21.07 8.04224 20.8627 8.02555 20.7784C8.21114 20.6862 8.16982 20.5279 8.09362 20.3627C8.01742 20.1975 7.90522 20.016 7.97848 19.9001C7.99642 19.9115 8.10025 19.9787 8.11956 19.9862C8.17499 19.9278 8.14104 19.7168 8.06542 19.4429C8.03283 19.3036 7.96935 19.1522 7.94108 18.9879C7.90634 18.8232 7.87033 18.6559 7.83683 18.4939C7.75428 18.1707 7.73999 17.8718 7.7492 17.7132C7.75978 17.5506 7.81067 17.5305 7.93139 17.7442C7.99852 17.5325 8.02693 17.3125 8.10077 17.0879C8.16813 16.8631 8.22912 16.6313 8.28377 16.3926C8.4344 15.9224 8.56745 15.4209 8.76271 14.917C9.13133 13.9029 9.63418 12.8432 10.3026 11.8747C10.9685 10.9074 11.7998 10.0379 12.7073 9.4092C12.9405 9.26225 13.1597 9.09873 13.3975 8.98247C13.6353 8.86622 13.8667 8.74966 14.0977 8.65297C14.3362 8.57254 14.5694 8.50115 14.7934 8.43728C15.0186 8.37611 15.2521 8.36035 15.465 8.33441L15.4243 8.2941C15.4553 8.29951 15.5274 8.24982 15.5641 8.30188C15.6923 8.15406 15.9769 8.02936 16.2251 7.91491C16.3491 7.861 16.4653 7.81071 16.5527 7.78028C16.6399 7.75648 16.6933 7.74173 16.6933 7.74173L17.1623 7.59108L17.4007 7.51723L17.6439 7.46755C17.6439 7.46755 17.7526 7.47653 17.9208 7.49093C18.0904 7.50142 18.3274 7.50702 18.5806 7.54788C18.7086 7.5644 18.8406 7.57584 18.974 7.58333C19.1073 7.59081 19.2407 7.59165 19.3674 7.61208C19.6235 7.63849 19.8645 7.63899 20.0557 7.59349C20.2699 7.6458 20.4689 7.75442 20.6749 7.83021C20.8781 7.92044 21.0896 7.98056 21.2806 8.09939C21.5527 8.24981 22.5803 8.69894 23.2922 9.04727C22.6065 9.58685 20.5459 9.83097 20.1992 10.4737L19.1767 10.6332C18.5814 10.8124 18.4812 12.1956 19.4105 11.8819C21.0276 11.2807 23.3047 11.252 24.6145 9.76439L24.5977 9.76234C24.5977 9.76234 24.9401 9.5157 24.9469 9.57169C25.0902 9.38082 25.1927 9.06747 25.1927 9.06747C25.2407 8.23732 24.3471 7.00712 23.805 6.73157C23.9922 6.6978 21.4512 2.5551 21.2052 3.97254L21.204 3.96983Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M31.8032 26.46C31.93 25.7425 32 24.9769 32 24.1719C32 23.3669 31.93 22.5794 31.8032 21.8531C31.0244 17.5263 28.0188 14.8619 23.8057 14.175C23.0882 14.0569 22.3313 14 21.5482 14C20.765 14 19.9469 14.0656 19.1988 14.1881C14.9813 14.8925 11.98 17.5525 11.2013 21.8531C11.07 22.5794 11 23.3538 11 24.1719C11 24.99 11.0657 25.7425 11.1969 26.46C11.9713 30.7563 14.9725 33.4206 19.1944 34.125C19.9425 34.2519 20.7257 34.3131 21.5438 34.3131C22.3619 34.3131 23.0838 34.2519 23.8013 34.1381C28.0232 33.4513 31.0288 30.7825 31.8032 26.46Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M27.9 24.4798C27.9 28.2808 24.8225 31.3633 21.0165 31.3633C20.4713 31.3633 19.9411 31.2989 19.4356 31.1799L11.6204 39.0001L6.49121 33.8709L14.3163 26.0507C14.1974 25.5502 14.1329 25.0199 14.1329 24.4798C14.1329 20.6738 17.2105 17.5913 21.0165 17.5913C21.7796 17.5913 22.5081 17.7152 23.192 17.9481L18.4791 22.6214L19.4108 26.0854L22.8749 27.0122L27.5481 22.3042C27.781 22.9831 27.9 23.7166 27.9 24.4798Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.5481 22.3042L22.8748 27.0122L19.4108 26.0854L18.4791 22.6214L23.192 17.9481C22.5081 17.7152 21.7796 17.5913 21.0164 17.5913C17.2104 17.5913 14.1329 20.6738 14.1329 24.4798C14.1329 25.0199 14.1973 25.5502 14.3163 26.0507L11.7492 28.6178C12.9088 30.8628 14.8069 32.4783 17.2253 33.3902L19.4355 31.1799C19.941 31.2989 20.4713 31.3633 21.0164 31.3633C24.8224 31.3633 27.8999 28.2808 27.8999 24.4798C27.8999 23.7166 27.781 22.9831 27.5481 22.3042Z",
        fill: primaryColor
    }));

});

parcelRegister("dLzpK", function(module, exports) {

$parcel$export(module.exports, "AutoReviewAvatar", () => $9e0a11fdc6fc0cc9$export$2dca6220da4c947);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $9e0a11fdc6fc0cc9$export$2dca6220da4c947 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_38927",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_38927)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.3494 12.0826C19.2594 10.3624 18.8974 8.06745 18.8395 7.24049C19.3044 8.23412 19.1223 5.65708 19.0216 5.23398C18.9788 5.66776 18.786 5.33229 18.8267 5.03741C19.5165 5.45196 19.0473 -1.57829 18.4432 2.03726C18.2868 3.74247 17.9911 7.47769 17.9483 10.1936C18.3082 11.5206 18.9809 17.0956 19.3494 12.0847V12.0826Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.5884 15.0207C12.1557 14.2044 11.6908 13.4971 10.7889 12.6317C10.8638 13.3476 10.4804 12.8561 10.4461 12.5185C11.0888 12.6531 10.2254 11.7236 9.92121 11.5953C10.009 11.7257 9.85265 11.8432 9.70698 11.6445C10.249 11.6017 8.31662 9.32388 8.13239 10.3474C8.38089 10.7064 8.11096 10.8688 8.55656 10.7128C8.07025 11.1274 8.8522 11.121 8.88434 11.1915C8.58441 11.6488 9.50346 11.7193 9.11784 11.8389C9.26566 12.7108 12.6698 16.9311 12.5884 15.0229V15.0207Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.347 22.677C8.35511 21.8864 7.25825 21.3586 5.67937 21.0808C6.33706 21.6877 5.57224 21.4398 5.23804 21.1898C6.71623 20.6492 -1.3667 20.256 1.70108 21.489C1.83819 20.8095 1.74393 21.692 2.1574 21.4419C2.47446 21.2197 2.77652 21.2924 2.77009 21.4676C2.76795 21.6621 3.61845 21.1471 3.38708 21.5146C4.09618 21.6215 10.9794 24.316 9.347 22.677Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.33589 29.6389C7.1919 30.0107 6.13576 30.5983 5.11388 31.7309C5.96009 31.5065 5.33666 32.0236 4.96604 32.139C5.33881 30.5706 0.71358 36.9298 3.35291 35.1328C2.82804 34.6498 3.57141 35.2033 3.55641 34.7438C3.7685 33.763 4.76897 33.8293 5.57448 32.6882C6.03079 31.9381 10.1654 29.8676 8.33589 29.6411V29.6389Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16.3074 37.3124C15.2127 30.8463 14.8613 36.1243 15.0627 39.1202C15.474 38.2142 15.4376 39.1757 15.2534 39.5732C14.8527 38.5774 14.7906 41.6139 15.2169 40.9408C15.2212 41.054 15.2576 41.1694 15.2555 41.2763C14.6599 40.8852 15.0241 46.4346 15.8254 43.6033C15.1762 43.4195 16.2388 43.5477 15.594 42.5904C16.3352 41.6502 15.7654 38.8039 16.3074 37.3145V37.3124Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.8716 42.3639C29.0113 40.975 26.0271 31.9682 26.3827 36.8936C26.5156 37.5368 26.6869 38.9685 26.9419 39.9878C27.2375 39.0732 27.3296 39.9942 27.1775 40.3981C26.7084 39.5006 26.869 42.3618 27.2354 41.7122C27.2332 42.1161 26.9226 42.5135 27.0126 43.8298C26.8797 45.4923 27.7238 45.1397 27.7281 44.2722C27.2546 44.1675 28.2058 44.1675 27.6253 43.3084C28.1094 43.2914 27.5417 42.1503 27.8695 42.3639H27.8716Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M38.3733 32.1839C37.2614 31.8143 36.1752 31.5899 34.6863 31.5707C35.3933 32.0536 34.6071 31.9425 34.29 31.7203C34.9734 31.3677 33.3645 31.2929 33.0282 31.3848C33.251 31.4361 33.1375 31.6198 32.8804 31.5643C33.4267 31.2245 29.774 30.6775 30.3889 31.4532C30.3353 31.6391 30.7467 31.6006 30.8795 31.8378C30.9545 31.8378 30.9566 31.4403 31.053 31.575C30.9352 32.2032 31.67 31.7181 31.7535 31.7502C31.5029 32.3314 40.2799 33.7609 38.3754 32.1882L38.3733 32.1839Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M39.5772 21.7326C38.3732 21.6279 37.3127 21.6365 35.7724 21.7753C36.6593 22.1878 35.4918 22.2369 35.3868 21.8822C36.1045 21.6899 34.2385 21.6108 34.05 21.7967C34.2899 21.8224 34.185 22.019 33.9193 21.9912C34.1185 21.4911 29.399 21.5083 31.8991 22.5083C31.9762 22.4955 31.9227 22.1066 32.0405 22.2241C32.0062 22.863 32.6896 22.2839 32.7818 22.3074C32.8546 22.8032 33.8422 22.2219 33.6108 22.5638C34.1078 23.1515 41.8758 22.7775 39.575 21.7326H39.5772Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M30.6759 8.78116C30.5881 7.64649 31.7449 6.85587 31.9613 5.71692C31.5028 3.88137 27.8631 10.9415 29.0563 9.61668C29.4141 9.19572 25.2066 15.4845 26.7105 15.4887C26.7641 15.6041 27.2847 14.8904 27.1861 14.8392C27.0897 14.7451 26.944 14.7237 27.0447 14.6361C27.6253 14.9011 27.4025 13.8669 27.4732 13.7622C28.5807 13.0399 29.2984 10.0996 30.6781 8.77691L30.6759 8.78116Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.4469 18.9163C22.0894 18.9163 18.6681 22.3025 17.3688 23.9913C18.235 25.6844 22.0894 29.0663 26.4469 29.0663C30.8044 29.0663 34.6588 25.68 35.525 23.9913C34.23 22.2981 30.8044 18.9163 26.4469 18.9163ZM26.4469 20.3163C28.4769 20.3163 30.1219 21.9613 30.1219 23.9913C30.1219 26.0213 28.4769 27.6663 26.4469 27.6663C24.4169 27.6663 22.7719 26.0213 22.7719 23.9913C22.7719 21.9613 24.4169 20.3163 26.4469 20.3163Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.1931 23.9999L28.8225 27.1981L26.5125 31.2056L22.4218 30.5231L20.9737 34.4037H16.3493L14.8925 30.5231L10.8018 31.2056L8.49622 27.1981L11.1212 23.9999L8.49622 20.8018L10.8018 16.7943L14.8925 17.4724L16.3493 13.5962H20.9737L22.4218 17.4724L26.5125 16.7943L28.8268 20.8018L26.1931 23.9999Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.4469 27.6706C24.4169 27.6706 22.7719 26.0213 22.7719 23.9913C22.7719 21.9613 24.4169 20.3163 26.4469 20.3163C27.265 20.3163 28.0219 20.5831 28.6344 21.0381L28.8269 20.8019L27.8032 19.0256C27.3657 18.9556 26.9107 18.9163 26.4469 18.9163C22.0894 18.9163 18.6682 22.2981 17.3732 23.9913C18.235 25.6844 22.0894 29.0663 26.4469 29.0663C26.9063 29.0663 27.3613 29.0269 27.8075 28.9569L28.8225 27.1981L28.6257 26.9575C28.0132 27.4038 27.2607 27.6706 26.4469 27.6706Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.1931 23.9999L28.6256 26.9574C28.0131 27.4037 27.2606 27.6705 26.4469 27.6705C24.4169 27.6705 22.7719 26.0212 22.7719 23.9912C22.7719 21.9612 24.4169 20.3162 26.4469 20.3162C27.265 20.3162 28.0218 20.583 28.6343 21.038L26.1931 23.9999Z",
        fill: "#101214"
    }));

});

parcelRegister("4MSOB", function(module, exports) {

$parcel$export(module.exports, "BacklogBuddyAvatar", () => $1b71e6da520e7599$export$6690ebe55ef79618);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $1b71e6da520e7599$export$6690ebe55ef79618 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_34615",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_34615)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        style: {
            mixBlendMode: 'lighten'
        },
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M35.2 33.9524C35.7545 34.5991 36.2809 35.2645 36.7841 35.9439C36.7841 35.9439 36.9425 36.1735 37.1662 36.5483C37.4038 36.9185 37.7066 37.4433 38.0048 38.0244C38.303 38.6054 38.5872 39.2567 38.7223 39.8705C38.8015 40.1798 38.8062 40.4703 38.7782 40.7233C38.7503 40.9811 38.6245 41.1638 38.5033 41.3137C38.112 41.6089 37.5482 41.6324 37.0217 41.5808C36.4859 41.5293 35.9548 41.3793 35.4376 41.2153C34.3987 40.8686 33.3876 40.4094 32.4046 39.9127C32.4046 39.9127 32.2462 39.8377 31.9992 39.7253C31.7523 39.6034 31.4215 39.4394 31.0627 39.2614C30.3499 38.9006 29.5485 38.4789 29.1618 38.3102C28.6819 38.0993 28.3511 37.9916 28.2486 38.0197C28.0529 38.0572 28.7565 38.7178 31.1652 39.9643C31.1885 39.9877 31.2817 40.0486 31.2864 40.0627C32.5816 40.6765 33.8442 41.3044 35.2094 41.7776C35.8942 42.0072 36.6024 42.2134 37.3991 42.2368C37.7905 42.2556 38.2378 42.1947 38.6664 41.9604C38.8807 41.8432 39.0811 41.6605 39.2162 41.4403C39.356 41.2153 39.4258 40.9764 39.4631 40.7421C39.4165 40.7796 39.3932 40.6577 39.4258 40.5547L39.4771 40.5968C39.4864 39.9924 39.342 39.5332 39.2162 39.1068C39.0718 38.6897 38.9227 38.3102 38.7503 37.9541C38.4102 37.2371 38.0141 36.5811 37.4457 35.883C37.4457 35.883 37.6181 36.0142 37.6228 36.0189C34.2076 30.9067 28.3092 25.1011 23.2587 20.912L23.2774 20.9401H23.2634C23.7107 21.3619 25.8166 23.358 25.8166 23.358C24.0182 22.1022 22.3222 20.2748 20.5005 18.8316L20.5564 18.7847C21.3392 19.4173 22.0473 19.9608 22.3409 20.167C20.9897 18.9721 18.8931 17.2478 16.7173 15.6546C14.5508 14.0521 12.2958 12.5995 10.7863 11.7514C10.8375 11.8451 11.8113 12.3043 11.9417 12.6042C11.1963 12.131 10.4275 11.6905 9.70535 11.2735C9.76126 11.1704 10.1619 11.4468 10.2505 11.4796C9.94762 11.2875 8.18648 10.1114 5.54476 8.95871C4.8785 8.67756 4.15634 8.4011 3.35963 8.20899C2.95429 8.12465 2.54429 8.03093 2.09235 8.02625C1.64974 8.02625 1.14189 8.05905 0.671322 8.37768C0.433707 8.52293 0.238025 8.77128 0.135524 9.03368C0.0423417 9.29608 -0.00424946 9.56785 0.000409659 9.8162C0.000409659 10.3223 0.121547 10.7674 0.265979 11.1985C0.559504 12.0513 0.978824 12.8151 1.41678 13.5414C2.29735 14.9893 3.28509 16.2591 4.17964 17.3509C5.07885 18.438 5.90351 19.3329 6.52317 19.9796C7.77647 21.2635 8.1958 21.5774 7.09158 20.2092L7.25465 20.2982C6.0526 18.9534 5.07885 17.8054 4.01191 16.2544C3.83952 16.0529 3.83486 16.0201 3.78361 16.0576C3.73236 16.0061 3.6485 15.9264 3.6485 15.9639C3.55066 16.0763 3.2385 15.5703 3.08474 15.3641C3.36429 15.3501 2.48372 14.1927 1.6544 12.8291C1.23973 12.1497 0.848369 11.414 0.634049 10.7674C0.52689 10.4441 0.461662 10.1442 0.443026 9.90054C0.433707 9.65688 0.452344 9.46945 0.489617 9.37574C0.601436 9.3242 0.717914 8.96339 1.07667 8.75253C1.4261 8.53231 1.92462 8.50419 2.15758 8.56042C2.12031 8.56042 1.91065 8.60728 1.88735 8.62602C1.98985 8.64476 2.4977 8.64945 3.17793 8.79471C3.85816 8.93059 4.69214 9.19768 5.4376 9.4882C6.92852 10.0739 8.07932 10.6784 7.1009 10.3223C10.8189 12.4262 15.8041 15.8046 20.5657 19.6281C25.3274 23.447 29.8653 27.711 32.7773 31.305L32.7493 31.2347C32.7913 31.2956 32.9497 31.4549 32.9637 31.5205C33.2991 31.8298 33.8675 32.4296 34.3428 32.9638C34.818 33.4979 35.2 33.9571 35.2 33.9571V33.9524ZM20.1977 18.9721C20.1977 18.9721 20.1837 18.9721 20.1837 18.9815C20.193 18.9581 19.2565 18.2318 19.2193 18.199L19.2705 18.1474C20.3095 18.7753 22.1498 20.9214 20.2396 19.094C20.1604 19.0518 20.1977 19.0049 20.1977 18.9721ZM11.6249 12.7776C11.4525 12.6651 11.2662 12.5386 11.0612 12.4027C13.5212 13.6491 16.3958 16.0248 18.8279 17.796C17.8262 17.4165 15.9719 15.8139 14.9142 15.0642C13.81 14.3707 12.5754 13.4383 11.6249 12.7823V12.7776ZM2.25076 14.0193L2.28804 14.0052L2.33929 14.0849C2.33929 14.0849 2.31599 14.0849 2.29735 14.0709C2.28338 14.0615 2.26008 14.038 2.25076 14.0193ZM34.4173 32.7154C34.2449 32.5983 33.779 31.9891 34.189 32.3031C34.2589 32.4155 34.5431 32.6732 34.4173 32.7154ZM9.01114 11.1095C8.95523 11.2125 8.06534 10.7487 8.13989 10.6081C8.44739 10.7627 8.73159 10.9408 9.01114 11.1095ZM38.6338 38.8725C38.8435 39.0786 38.6851 39.0552 38.6385 39.163C38.6338 39.0974 38.5593 38.8678 38.6291 38.8959V38.8725H38.6338ZM36.6956 41.7542C36.6211 41.8011 36.3462 41.787 36.2204 41.7683C35.9129 41.6605 36.5652 41.6745 36.6956 41.7542ZM29.5951 38.685C29.5485 38.7413 29.3761 38.6663 29.3715 38.582C29.4134 38.5492 29.6277 38.6241 29.6138 38.7132C29.6138 38.7132 29.6138 38.6991 29.5951 38.6897V38.685ZM4.91112 8.85094C5.24657 8.74785 6.04794 9.26797 6.51851 9.42728C6.33681 9.56317 5.58203 9.06648 5.2093 8.95871C5.08816 8.90716 4.98566 8.87436 4.91112 8.84625V8.85094ZM29.5159 26.8535C29.637 26.713 30.2707 27.547 30.5363 27.7673L30.4803 27.8141C30.1076 27.4627 29.8607 27.28 29.5299 26.8676L29.5159 26.8535ZM13.2137 13.3305C13.4187 13.3774 13.6516 13.6163 13.8147 13.7288C13.7541 13.8131 13.0459 13.3539 13.2137 13.3305ZM20.1371 18.438C20.0998 18.5551 19.8063 18.2458 19.7038 18.1802C19.7877 18.213 19.9507 18.2552 20.03 18.3208C20.0812 18.3677 20.0905 18.3864 20.1418 18.438H20.1371ZM29.1944 26.638C28.9102 26.3615 28.6027 26.0617 28.3092 25.7758L28.3698 25.7337C28.668 26.0242 28.9615 26.3147 29.255 26.5958L29.1991 26.638H29.1944ZM26.3431 23.7844L26.3896 23.7328C26.8695 24.0749 26.795 24.2576 26.3524 23.7938L26.3431 23.7844ZM32.8658 30.3257C32.8285 30.2788 32.7633 30.2039 32.726 30.1617C32.1576 29.5525 33.1407 30.2367 32.8658 30.3257ZM35.7405 33.6104C35.8011 33.6713 35.8849 33.7416 35.9362 33.8166C36.2903 34.2898 35.7545 33.8775 35.7405 33.6104Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        style: {
            mixBlendMode: 'lighten'
        },
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11.5644 38.0009C10.8469 38.4601 10.1201 38.9006 9.38396 39.3223C9.38396 39.3223 9.13703 39.4441 8.73634 39.6316C8.33566 39.819 7.78588 40.072 7.17554 40.3204C5.96417 40.8358 4.48723 41.2763 3.64393 41.2622C3.12211 41.2294 2.63756 40.9436 2.53972 40.4469C2.43256 39.9596 2.56301 39.4113 2.73074 38.9006C3.09881 37.8744 3.66722 36.9138 4.28223 35.9908C4.28223 35.9908 4.6503 35.4004 5.09757 34.7397C5.54485 34.0743 6.07599 33.3386 6.29497 32.9731C6.57451 32.5233 6.7236 32.2094 6.71429 32.1063C6.70031 31.9985 6.52326 32.1063 6.13656 32.5139C5.74985 32.9169 5.15814 33.6245 4.38939 34.7537C4.36143 34.7771 4.29155 34.8615 4.27291 34.8615C3.88154 35.4706 3.49484 36.0751 3.13608 36.6983C2.77267 37.3168 2.43722 37.9588 2.17631 38.6616C2.04585 39.0131 1.94335 39.3879 1.8921 39.7862C1.86415 40.1939 1.87346 40.6624 2.14369 41.1123C2.4279 41.5574 2.92177 41.787 3.34109 41.8573C3.76972 41.937 4.17973 41.9229 4.56643 41.862C4.51984 41.8245 4.61768 41.773 4.71553 41.7823L4.69223 41.8432C5.70326 41.623 6.45338 41.3512 7.18952 41.0795C7.921 40.7983 8.60589 40.4797 9.36066 39.9924C9.36066 39.9924 9.21157 40.147 9.20691 40.1517C14.6721 37.3871 21.3206 32.4577 26.208 28.0578L26.1754 28.0719V28.0578C25.6955 28.4373 23.4032 30.232 23.4032 30.232C24.9175 28.6388 26.9768 27.2237 28.6774 25.6306L28.7146 25.6962C27.9738 26.3756 27.3262 26.9988 27.0793 27.2612C28.463 26.0992 30.4851 24.2764 32.3814 22.3506C34.2869 20.4341 36.0574 18.4005 37.101 17.0088C37.0032 17.0463 36.4068 17.9507 36.0947 18.0397C36.6677 17.3603 37.2129 16.6621 37.7254 15.9967C37.8185 16.067 37.4878 16.4278 37.4458 16.5168C37.567 16.3809 37.9676 15.9077 38.536 15.1626C39.0951 14.4129 39.8313 13.3914 40.5115 12.0935C40.8423 11.4375 41.1778 10.7159 41.3082 9.83964C41.3548 9.40386 41.3548 8.865 41.0194 8.38706C40.8423 8.16683 40.6233 7.97471 40.3764 7.87163C40.1341 7.76854 39.8825 7.70762 39.6496 7.69357C38.6945 7.6186 37.8372 7.86694 37.0079 8.12466C36.1785 8.39643 35.3865 8.73849 34.6317 9.09929C31.6033 10.5566 29.0594 12.2903 27.6011 13.3305C26.1521 14.3895 25.7794 14.7597 27.2889 13.86L27.1771 14.0099C28.682 13.0072 29.954 12.2059 31.6266 11.3531C31.8502 11.2126 31.8828 11.2079 31.8549 11.1516C31.9108 11.1095 32.004 11.0345 31.9667 11.0251C31.8689 10.9127 32.4093 10.669 32.6376 10.5425C32.6143 10.819 33.8816 10.102 35.3119 9.40386C36.0294 9.05243 36.7889 8.71506 37.4365 8.49014C38.0795 8.26054 38.6106 8.14808 38.8156 8.13403C38.9088 8.23243 39.3001 8.18088 39.7195 8.22306C39.9291 8.25117 40.1434 8.29803 40.3158 8.39643C40.4789 8.49483 40.5907 8.6354 40.6327 8.73849C40.6187 8.70569 40.4416 8.60729 40.4277 8.59323C40.4416 8.64477 40.5441 8.7338 40.6187 8.91655C40.6839 9.09929 40.7538 9.37106 40.7165 9.70375C40.6653 10.3738 40.3484 11.2079 40.0083 11.9248C39.2955 13.368 38.536 14.4317 39.0159 13.5039C36.4907 16.9666 32.3907 21.4087 27.8946 25.565C23.4079 29.7259 18.5019 33.5823 14.5323 35.958L14.6068 35.9392C14.5416 35.972 14.3599 36.1079 14.2947 36.1126C13.9406 36.3984 13.265 36.881 12.6686 37.2793C12.0769 37.6776 11.5691 37.9963 11.5691 37.9963L11.5644 38.0009ZM28.5935 25.3073C28.5935 25.3073 28.5935 25.2932 28.5888 25.2932C28.5935 25.2932 28.6494 25.2464 28.7333 25.1714C28.8171 25.0964 28.929 24.9933 29.0408 24.8902C29.2644 24.6794 29.488 24.4685 29.5067 24.4545L29.5486 24.5107C28.7705 25.4478 26.3758 26.9566 28.4677 25.3307C28.5189 25.2557 28.5609 25.3026 28.5935 25.3073ZM35.9829 17.6929C36.118 17.5383 36.2671 17.3696 36.4348 17.1822C34.86 19.4595 32.0785 21.9663 29.9679 24.1218C30.4944 23.1846 32.3534 21.5774 33.2526 20.6403C34.1006 19.6422 35.2001 18.5504 35.9829 17.6929ZM34.068 9.88181L34.0773 9.91929L33.9934 9.96147C33.9934 9.96147 33.9934 9.93804 34.0074 9.92398C34.0167 9.90992 34.0447 9.89118 34.068 9.88181ZM12.8969 37.3918C13.0367 37.2372 13.703 36.8576 13.3349 37.2231C13.2138 37.2746 12.9202 37.523 12.8969 37.3918ZM37.9909 15.3173C37.9024 15.247 38.4708 14.4223 38.6013 14.5113C38.4056 14.7972 38.2006 15.0642 37.9909 15.3173ZM6.29031 40.8967C6.07599 41.0982 6.10394 40.9389 5.99678 40.8967C6.06667 40.8967 6.29962 40.8264 6.26701 40.8967H6.29031ZM2.29278 40.1798C2.23688 40.1189 2.18097 39.8284 2.20892 39.7019C2.25551 39.5379 2.28347 39.6269 2.28813 39.7675C2.28813 39.908 2.32074 40.1048 2.28813 40.1845L2.29278 40.1798ZM5.86633 33.3433C5.81974 33.2918 5.91292 33.1278 6.00144 33.1325C6.0294 33.1793 5.92224 33.3855 5.83837 33.3574C5.83837 33.3574 5.85235 33.3574 5.86633 33.3433ZM40.6746 11.4422C40.7631 11.7936 40.1761 12.5714 39.9571 13.0213C39.8406 12.8245 40.4183 12.1122 40.5441 11.742C40.6047 11.6202 40.642 11.5218 40.6746 11.4468V11.4422ZM19.4057 33.3761C19.5269 33.5167 18.6044 34.0227 18.3528 34.257L18.3155 34.1961C18.7162 33.8775 18.9398 33.6619 19.3917 33.3902L19.4104 33.3761H19.4057ZM35.2048 19.1971C35.1302 19.3939 34.8553 19.5907 34.7249 19.7406C34.6503 19.6703 35.2048 19.0284 35.2094 19.1971H35.2048ZM29.1293 25.326C29.0221 25.2698 29.3716 25.0261 29.4508 24.9324C29.4042 25.0074 29.339 25.1667 29.2644 25.2323C29.2132 25.2792 29.1899 25.2838 29.134 25.326H29.1293ZM19.6666 33.0903C19.9834 32.8513 20.3236 32.5889 20.6544 32.3406L20.687 32.4062C20.3562 32.6592 20.0254 32.9075 19.7039 33.1559L19.6713 33.0903H19.6666ZM22.9094 30.6865L22.956 30.7427C22.5413 31.1644 22.3782 31.0614 22.9001 30.6959L22.9094 30.6865ZM15.4734 36.1922C15.5247 36.1594 15.6085 36.1079 15.6551 36.0798C16.34 35.6018 15.52 36.4828 15.4734 36.1922ZM11.8207 38.5867C11.7555 38.6382 11.6669 38.7132 11.5877 38.7553C11.0706 39.0459 11.5504 38.5632 11.8207 38.5867Z",
        fill: secondaryColor
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M34.9388 22.845H13.6282V33.2575H34.9388V22.845Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M28.315 16.3788H7.00439V26.7913H28.315V16.3788Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M28.315 22.845H13.6282V26.7913H28.315V22.845Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M33.6132 26.6076L29.0238 31.1969L26.6526 28.7601L27.6763 27.7669L29.0413 29.1669L32.6069 25.6013L33.6176 26.6119L33.6132 26.6076Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.1069 13.2367C18.8661 13.1873 18.7335 12.9498 18.4436 13.0909C17.574 13.5164 16.4612 14.9083 16.1099 15.4866C15.2673 15.9168 13.7639 17.84 13.1621 18.8345C12.801 19.4763 11.7864 21.1408 11.7864 21.1408L11.6612 21.1314C11.6612 21.1314 9.71067 18.6252 8.71823 18.1127C8.54136 18.0563 8.3473 18.1103 8.1778 18.3619C8.08691 18.4512 8.75754 19.2458 8.91476 19.2552C9.06706 19.1753 9.76717 20.2004 10.1946 20.7176C11.5334 22.3445 11.7938 22.4855 12.4251 21.9636C13.4765 21.0937 18.0186 14.8847 19.1069 13.2343V13.2367Z",
        fill: "#101214"
    }));

});

parcelRegister("7bSsT", function(module, exports) {

$parcel$export(module.exports, "CommsCrafterAvatar", () => $81bb84765de22578$export$57726a005ac84f9e);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $81bb84765de22578$export$57726a005ac84f9e = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_35679",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_35679)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M31.7267 15.5879C30.4756 15.4232 28.6104 16.1079 27.605 15.6052C27.9106 15.6341 28.0791 11.5316 27.0708 12.2712C26.7795 12.5168 26.6424 12.9733 27.0851 13.0917C26.2625 13.4789 27.5364 15.585 25.6227 16.4633C25.5941 15.351 20.6441 17.0815 23.529 17.1335C23.5975 16.6915 23.6147 17.8356 24.4259 16.9949C27.3393 17.2953 26.1968 18.7081 27.2051 20.924C27.0623 23.9691 29.2216 21.6 28.1077 20.0948C28.8846 18.1447 26.1111 16.6251 29.433 17.4629C29.7672 16.7522 33.6004 16.706 31.7238 15.5879H31.7267Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M42.7436 22.2675C41.9524 21.8919 40.9584 22.5333 40.4871 21.7417C41.0897 21.9901 41.0098 18.7948 40.0158 19.5517C39.8958 20.0486 39.6073 19.988 40.1157 20.1584C39.2617 20.1642 40.0558 20.7131 40.0272 20.7911C39.5616 20.8027 40.17 21.0685 39.7273 20.976C39.4702 21.0281 40.2214 21.6868 39.713 21.5105C39.5502 22.227 38.7561 22.2212 38.9332 22.6575C38.9246 22.3599 36.2854 22.2906 37.0166 23.4289C37.4793 23.4058 37.4194 23.9316 37.4879 23.2469C37.6279 24.0962 37.9392 23.2468 38.0135 23.2671C38.082 23.7438 38.2191 23.0851 38.1991 23.5502C38.2677 23.8016 38.7133 22.9984 38.6247 23.5242C40.1643 23.9316 38.9018 24.3707 39.7901 25.2548C39.8787 25.665 39.6616 26.9969 40.6127 26.8727C41.8638 26.5086 40.4042 24.2349 41.1469 23.8391C41.4782 23.5387 41.9495 23.1602 42.575 23.4173C42.8835 23.4231 43.2806 22.149 42.7464 22.2646L42.7436 22.2675Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M36.7396 8.62231C37.0281 8.93433 39.3902 8.95745 39.3902 8.95745C39.3902 8.95745 39.8844 9.49479 39.7044 9.90215C40.1415 10.1939 40.1557 10.9162 40.0586 11.6558C40.09 12.0343 41.444 12.2192 41.2126 11.6212C41.5011 11.0694 40.5813 9.35036 41.2669 9.48903C41.2611 8.72632 42.5494 9.047 42.158 8.00694C42.0438 7.33378 41.5182 7.72381 41.4668 7.57647C39.8501 8.96033 41.3468 3.86401 39.6587 4.69607C39.5788 5.20454 39.693 6.29951 39.5131 6.68375C39.2132 7.05066 39.2303 7.48691 39.3131 7.94338C38.799 7.80182 36.631 7.93471 36.7367 8.61942L36.7396 8.62231Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M22.4064 5.66103C21.4724 5.42412 21.1953 6.50751 21.0497 4.67295C20.9126 3.82934 20.2956 4.06335 20.0842 4.34359C19.9557 4.51116 20.3556 5.30857 20.1985 5.38369C20.1985 5.38369 20.2156 6.04237 20.2585 6.40061C20.2128 6.01925 18.7789 6.22727 18.1162 6.5104C18.1162 6.5104 17.6449 7.0911 18.3133 7.44646C18.3533 7.4349 19.6386 7.27022 20.0043 7.41179C20.6041 7.83937 20.1414 7.94918 20.2499 8.41143C20.3584 8.8708 20.347 10.9018 21.6381 9.7173C21.6866 8.7928 21.6781 8.61365 21.5124 7.34245C21.7181 6.99288 22.0323 6.74155 22.5064 6.82244C22.7578 6.74733 22.8063 5.4559 22.4093 5.66103H22.4064Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.3165 27.4389C26.3824 27.202 26.1054 28.2854 25.9597 26.4508C25.8226 25.6072 25.2056 25.8412 24.9943 26.1215C24.8657 26.2891 25.2656 27.0865 25.1085 27.1616C25.1085 27.1616 25.1257 27.8203 25.1685 28.1785C25.1228 27.7971 23.6889 28.0052 23.0262 28.2883C23.0262 28.2883 22.555 28.869 23.2233 29.2243C23.2633 29.2128 24.5487 29.0481 24.9143 29.1897C25.5141 29.6173 25.0514 29.7271 25.1599 30.1893C25.2685 30.6487 25.257 32.6797 26.5481 31.4952C26.5967 30.5707 26.5881 30.3915 26.4224 29.1203C26.6281 28.7708 26.9423 28.5194 27.4164 28.6003C27.6678 28.5252 27.7164 27.2338 27.3193 27.4389H27.3165Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.8249 0.541599C27.8592 0.547378 29.5302 0.209329 29.3502 0.694694C29.7015 1.1945 29.3988 2.36172 29.9843 2.49751C31.5325 2.58418 30.5185 1.61342 30.7755 0.951825C31.3754 1.16851 32.0809 0.116891 31.4239 -0.339583C31.2925 -0.134458 30.9698 -0.556268 31.0012 -0.307807L30.9983 -0.414701C30.767 -0.229801 30.6299 -0.186467 30.3614 -0.562047C30.1214 -0.018901 30.9298 -2.32728 29.6558 -1.87081C29.4245 -1.68013 29.8329 -0.596698 29.3188 -0.65159C28.9103 -0.408908 28.3391 -0.58516 27.9506 -0.417593C27.6307 -0.278918 27.4422 0.0533457 27.8306 0.541599H27.8249Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11.6666 17.5467C11.7009 17.5525 13.3718 17.2145 13.1919 17.6998C13.5432 18.1996 13.2404 19.3668 13.826 19.5026C15.3741 19.5893 14.3601 18.6185 14.6172 17.9569C15.217 18.1736 15.9225 17.122 15.2656 16.6655C15.1342 16.8706 14.8114 16.4488 14.8429 16.6973L14.84 16.5904C14.6086 16.7753 14.4715 16.8186 14.203 16.443C13.9631 16.9862 14.7714 14.6778 13.4975 15.1343C13.2662 15.325 13.6746 16.4084 13.1605 16.3535C12.752 16.5962 12.1807 16.4199 11.7923 16.5875C11.4724 16.7262 11.2839 17.0584 11.6723 17.5467H11.6666Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M37.6164 23.7293C38.4077 24.1049 39.4017 23.4635 39.873 24.2551C39.2703 24.0067 39.3502 27.202 40.3443 26.445C40.4642 25.9481 40.7527 26.0088 40.2443 25.8383C41.0983 25.8325 40.3043 25.2836 40.3328 25.2056C40.7984 25.1941 40.19 24.9283 40.6327 25.0207C40.8898 24.9687 40.1386 24.31 40.647 24.4863C40.8098 23.7698 41.6039 23.7755 41.4268 23.3393C41.4354 23.6368 44.0746 23.7062 43.3434 22.5679C42.8807 22.591 42.9407 22.0652 42.8721 22.7499C42.7321 21.9005 42.4208 22.7499 42.3465 22.7297C42.278 22.253 42.1409 22.9117 42.1609 22.4465C42.0923 22.1952 41.6467 22.9984 41.7353 22.4725C40.1957 22.0652 41.4582 21.626 40.5699 20.742C40.4814 20.3317 40.6984 18.9999 39.7473 19.1241C38.4962 19.4881 39.9558 21.7618 39.2131 22.1576C38.8818 22.4581 38.4105 22.8366 37.785 22.5794C37.4765 22.5737 37.0795 23.8478 37.6136 23.7322L37.6164 23.7293Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.6722 14.4948V32.9922H29.1697V14.4948H10.6722ZM18.5997 18.4673H25.206V20.4491H18.5997V18.4673ZM18.5997 22.7504H25.206V24.7322H18.5997V22.7504ZM15.301 18.126C16.0272 18.126 16.6222 18.721 16.6222 19.4473C16.6222 20.1735 16.0272 20.7685 15.301 20.7685C14.5747 20.7685 13.9797 20.1779 13.9797 19.4473C13.9797 18.7166 14.5703 18.126 15.301 18.126ZM15.301 22.4222C16.0272 22.4222 16.6222 23.0129 16.6222 23.7435C16.6222 24.4741 16.0272 25.0647 15.301 25.0647C14.5747 25.0647 13.9797 24.4741 13.9797 23.7435C13.9797 23.0129 14.5703 22.4222 15.301 22.4222Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M31.681 25.9047V28.9716H18.5997V35.206H31.681V38.8897L38.1691 32.3928L31.681 25.9047Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.5997 28.9716V32.9922H29.1697V28.9716H18.5997Z",
        fill: primaryColor
    }));

});

parcelRegister("7NM53", function(module, exports) {

$parcel$export(module.exports, "CultureAvatar", () => $da2a5b26902f2127$export$4408f9b5d5d155d9);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $da2a5b26902f2127$export$4408f9b5d5d155d9 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_36071",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: "#FFA900"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_36071)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M49 21.8675C47.0544 11.2058 42.8575 26.879 41.1102 29.6295C40.0557 25.9886 40.38 22.2032 39.8294 18.3921C39.7735 18.4993 39.6895 18.2522 39.6918 18.0121C38.1054 9.86083 34.4172 22.4363 34.1442 25.28C34.1442 25.273 34.1722 24.7485 34.1722 24.7369C30.0803 41.3168 32.3386 19.7067 30.1386 14.8117C27.9061 11.1708 26.4294 18.5832 25.9978 20.2778C25.0343 23.8721 22.2185 39.9905 21.8523 27.6389L21.8429 27.7251L21.8289 27.6878C21.7776 29.2752 21.8779 36.1281 23.6906 30.8998C20.7138 38.8437 21.6143 20.6577 21.4184 18.6601C21.8383 21.0074 21.5817 23.7439 21.7543 24.5761C21.0614 -2.83573 16.0784 26.2496 13.1483 32.2378C12.6281 30.8882 12.628 29.2099 12.5137 27.802C12.4298 28.2449 12.7727 30.9488 12.6724 31.4523C12.2781 30.1283 12.1335 22.5318 12.4111 26.2636C12.1055 25.0772 13.7432 10.982 9.46466 14.9959C6.89149 19.8442 6.98015 25.914 4.1177 30.6365C2.02278 28.7811 5.49644 13.7255 0.65338 16.7371C-1.12894 18.4503 -4.81722 33.1259 -5.65939 25.2893C-6.03499 21.8954 -6.02566 25.0982 -5.83903 26.5037C-5.89735 26.3569 -5.94868 26.21 -6 26.0608C-4.32266 34.6643 -0.317097 17.1846 1.79183 16.6718C3.05858 21.5155 1.80582 41.5336 7.21344 24.7252C7.20177 24.8161 7.12479 25.3895 7.11313 25.4641C8.18625 24.0282 8.43587 15.4901 11.016 15.1964C11.5129 15.6859 11.8302 20.4852 11.4033 17.6089C11.1793 46.0882 15.4438 30.7576 19.7177 14.8607C22.4611 19.7067 18.3833 29.3894 22.4285 34C27.1129 29.7251 25.6712 20.9375 28.8159 15.4178C30.106 17.2453 29.6418 21.5528 29.9147 24.0795L29.945 23.8954C30.1713 34.8531 32.4039 37.247 35.299 24.5178C35.7819 23.1682 38.1124 12.637 38.8076 18.7767C40.457 37.1631 40.8092 31.5665 47.0124 19.0471C48.5777 18.9562 49.0187 27.3195 48.9953 21.8698L49 21.8675Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15.4219 32.2245C15.4219 32.2245 10.2316 27.624 8.93398 25.6752C7.63638 23.7265 7.63638 23.0328 7.63638 21.9193C7.63638 21.2257 7.74491 20.5887 7.96668 20.013C8.19317 19.4326 8.50459 18.9325 8.90095 18.5078C9.2973 18.0831 9.75972 17.7575 10.2882 17.5263C10.8167 17.2951 11.3876 17.1819 12.0057 17.1819C12.7749 17.1819 13.4496 17.3801 14.03 17.7717C14.6104 18.1633 15.0775 18.6824 15.4267 19.3241C15.7806 18.6777 16.2477 18.1586 16.8281 17.7717C17.4084 17.3801 18.0785 17.1819 18.8429 17.1819C19.461 17.1819 20.0319 17.2951 20.5604 17.5263C21.0936 17.7575 21.556 18.0831 21.9477 18.5078C22.344 18.9325 22.6554 19.4326 22.8725 20.013C23.099 20.5887 23.2075 21.2209 23.2075 21.9193C23.2075 23.0328 23.1698 23.7312 21.9099 25.6752C20.5793 27.6193 15.4219 32.2245 15.4219 32.2245Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M26.0246 32.2245C26.0246 32.2245 20.8342 27.624 19.5366 25.6752C18.239 23.7265 18.239 23.0328 18.239 21.9193C18.239 21.2257 18.3476 20.5887 18.5693 20.013C18.7958 19.4326 19.1073 18.9325 19.5036 18.5078C19.9 18.0831 20.3624 17.7575 20.8909 17.5263C21.4193 17.2951 21.9903 17.1819 22.6084 17.1819C23.3775 17.1819 24.0523 17.3801 24.6326 17.7717C25.213 18.1633 25.6802 18.6824 26.0293 19.3241C26.3832 18.6777 26.8503 18.1586 27.4307 17.7717C28.0111 17.3801 28.6811 17.1819 29.4455 17.1819C30.0637 17.1819 30.6346 17.2951 31.1631 17.5263C31.6963 17.7575 32.1587 18.0831 32.5503 18.5078C32.9467 18.9325 33.2581 19.4326 33.4751 20.013C33.7016 20.5887 33.8102 21.2209 33.8102 21.9193C33.8102 23.0328 33.7724 23.7312 32.5126 25.6752C31.1819 27.6193 26.0246 32.2245 26.0246 32.2245Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M23.2074 21.9193C23.2074 23.0329 23.1697 23.7312 21.9099 25.6752C21.6409 26.0669 21.2209 26.5623 20.7208 27.1097C20.2206 26.5623 19.8007 26.0669 19.5412 25.6752C18.2436 23.7312 18.2436 23.0329 18.2436 21.9193C18.2436 21.2257 18.3521 20.5887 18.5739 20.013C18.7956 19.4326 19.107 18.9325 19.5034 18.5078C19.862 18.1303 20.2678 17.8283 20.7255 17.6066C21.1879 17.8283 21.5984 18.1303 21.9476 18.5078C22.344 18.9325 22.6507 19.4326 22.8724 20.013C23.0942 20.5887 23.2074 21.2257 23.2074 21.9193Z",
        fill: primaryColor
    }));

});

parcelRegister("19LR2", function(module, exports) {

$parcel$export(module.exports, "CustomerInsightAvatar", () => $c879352380461f10$export$58350b915e9fb39e);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $c879352380461f10$export$58350b915e9fb39e = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_34180",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: "#FFA900"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_34180)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.28763 33.302C9.73969 33.2628 15.7885 31.7918 14.2018 31.4727C13.6133 31.6385 13.1559 31.4709 12.8616 31.9202C12.7765 31.3907 11.6224 32.2358 11.4451 32.2679C11.3654 31.8667 9.5571 32.899 9.82125 32.5264C9.00044 32.5371 7.98108 32.8259 6.92094 33.1647C6.40151 32.8099 8.62814 30.2781 7.6921 30.8255C7.7577 30.6828 8.00944 30.066 7.97575 30.4742C8.27181 30.1248 11.4948 24.776 10.1545 25.6817C9.2504 26.7854 8.57142 28.6343 7.80557 29.5471C7.06099 29.8556 6.5451 32.505 5.71543 32.2411C5.23145 31.6456 3.9834 24.3534 3.097 25.0006C3.25123 25.5676 3.11118 26.0757 3.54197 26.3485C3.01545 26.4341 3.85575 27.5948 3.88766 27.7731C3.49765 27.848 4.50815 29.6737 4.14472 29.4063C4.15181 29.9215 4.26705 30.517 4.43369 31.15C4.21209 30.9806 3.96922 30.5937 3.82916 30.5366C2.33646 29.9287 1.20541 28.5308 -0.349339 27.7731C-1.6559 29.4473 9.89748 33.671 2.73357 34.3022C1.38624 35.1865 -0.404297 35.322 -1.90764 36.1725C-2.03705 38.0143 6.53269 32.9329 4.05963 35.8516C3.67493 37.0854 3.10409 38.4707 2.31519 39.6867C1.81171 44.3241 6.09304 31.7259 5.91575 36.5327C6.5061 37.6809 7.07694 39.0644 7.36946 40.489C9.46314 43.5771 6.60538 35.4076 6.30577 34.2505C7.44037 33.7638 11.8263 39.2837 12.6205 38.4137C12.6577 38.2906 12.0266 37.6078 11.8352 37.5347C11.7057 37.6006 11.6401 37.6541 11.5639 37.5329C11.9486 37.1603 10.5995 36.6896 10.4719 36.5612C10.7555 36.2777 8.87811 35.3559 9.33372 35.3702C8.98271 34.8763 8.44555 34.3789 7.83393 33.8779C8.91889 33.6675 9.39045 32.8973 9.29118 33.2984L9.28763 33.302Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M37.0413 11.3023C37.0466 11.2934 37.0466 11.2773 37.0572 11.2648C36.747 11.1079 36.7116 10.7228 36.4722 10.4928L36.4634 10.4839C36.2205 10.4055 36.2861 10.1612 35.9847 10.1594C35.9847 10.1594 36.0627 10.1202 36.0645 10.1202C35.5752 9.63166 34.3661 8.43175 34.3661 8.43175C34.3395 8.54051 34.5594 8.35152 34.781 8.38361C34.781 8.38361 34.7969 8.34261 34.8129 8.37471C35.3784 7.82021 36.0148 7.60804 36.7382 7.34417C37.0998 7.2461 37.1548 6.21734 36.5361 6.64346C36.529 6.63633 36.513 6.631 36.5059 6.61852C36.2896 6.8717 35.9297 6.77896 35.6567 6.9109L35.6461 6.91626L35.1923 7.13912C34.9458 7.24075 34.6533 7.321 34.3466 7.39945C34.3555 7.39053 34.3644 7.38161 34.3732 7.3727C34.3732 7.3727 34.4051 6.87882 34.3963 6.63456C34.3963 6.63456 34.7065 6.24232 34.6037 5.9731C34.7792 5.65752 35.4032 4.9675 34.8359 4.77138C34.6498 4.77138 34.5044 4.60914 34.4406 4.91045C34.4299 4.90867 34.4158 4.91223 34.4016 4.90688C34.3679 5.2189 34.0009 5.43999 33.8999 5.73595L33.8963 5.74845C33.9212 6.00162 33.7262 6.25122 33.7244 6.25122C33.6322 6.48301 33.5116 6.73617 33.384 7.00005C33.3308 6.85741 33.2723 6.73084 33.2138 6.63991C33.0011 6.40813 33.0915 3.24164 32.3044 3.94055C32.3416 4.53783 32.5295 5.16007 32.377 5.69138C32.3026 5.73239 32.416 5.94456 32.5082 6.1175C32.5011 6.33681 32.4568 6.45448 32.4444 6.76828C32.0544 6.48479 30.3525 5.04954 30.4571 6.01589C30.6397 6.11395 30.7726 6.22627 30.8684 6.45448C30.957 6.55254 31.7388 6.99472 31.7637 7.10526C31.7122 7.25859 32.6359 7.3816 32.2618 7.49571C32.3168 7.61695 32.3912 7.73286 32.4781 7.84518C32.0739 7.88797 31.5899 8.00741 31.3364 8.16253C31.2921 8.23919 29.6788 8.34261 29.0938 8.72237C28.7446 8.92028 28.4361 9.01835 28.7995 9.3161C28.9307 9.20913 29.4235 9.36245 29.4129 9.2216C29.5335 9.27152 30.349 8.95772 30.4394 9.01121C30.4837 9.08252 31.1254 8.70455 31.0492 8.88284C31.4942 9.00943 32.0367 8.90601 32.6004 8.76159C32.377 9.11818 32.1572 9.62631 32.1289 9.94189C31.9374 10.3466 31.4321 11.2417 31.2708 11.7908C31.0403 12.1902 31.1201 12.2223 31.4109 12.4273L31.4162 12.4327C31.4765 12.4737 31.4091 12.4327 31.6378 12.4416C31.6147 12.4202 31.581 12.3275 31.5367 12.3435C31.5669 12.2811 31.9143 12.192 31.769 12.1082C31.7637 12.0957 31.9906 11.921 32.0136 11.732C32.2157 11.058 32.6997 10.7175 33.0578 9.94903C33.0489 10.0293 33.6517 11.5394 33.6233 12.2918C33.579 12.6627 34.4725 13.2154 34.3431 12.3881C34.3537 12.3845 34.3626 12.3703 34.3785 12.3685C34.2349 12.0279 34.4246 11.6767 34.3502 11.3308L34.3466 11.3166C34.1853 11.1062 34.3715 10.9314 34.1162 10.7603C34.1162 10.7603 34.203 10.7692 34.2048 10.771C34.0913 10.2807 34.0204 9.68159 33.9141 9.14493C34.2952 9.4926 34.6303 9.86701 34.7685 10.2789L34.7863 10.2521C34.7863 10.2646 34.8129 10.2735 34.7898 10.302C35.1107 10.3698 35.2206 10.5053 35.4529 10.5962C35.4529 10.5962 35.701 11.0473 35.99 11.0634L36.4297 11.6892C36.6194 12.0119 37.6423 11.8265 37.0484 11.3094L37.0413 11.3023Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M29.47 21.4136C29.47 24.5332 27.8031 27.2568 25.3181 28.7396L24.3031 34.0328H17.7012L16.6862 28.7396C14.2012 27.2612 12.5344 24.5332 12.5344 21.4136C12.5344 16.71 16.3231 12.8952 21 12.8952C25.6769 12.8952 29.47 16.71 29.47 21.4136Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M25.8694 31.2652L25.0687 37.1832H16.9356L16.1306 31.2652H25.8694Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M24.8369 31.2652L24.3031 34.0284H17.7012L17.1675 31.2652H24.8369Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M24.8369 31.2652L24.3031 34.0284H17.7012L17.1675 31.2652H24.8369Z",
        fill: primaryColor
    }));

});

parcelRegister("a4vlK", function(module, exports) {

$parcel$export(module.exports, "DecisionDirectorAvatar", () => $b1e44362ee99359d$export$5b0c8178b6b02cb4);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $b1e44362ee99359d$export$5b0c8178b6b02cb4 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_4147_15812",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_4147_15812)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M30.8727 8.7469C31.1115 8.70494 33.0242 6.03171 32.013 6.33386C31.6322 6.39681 31.4429 6.61504 31.6107 6.91089C31.0836 6.5353 31.2535 7.55717 30.8921 7.62012C30.6468 7.23823 30.6791 8.5035 30.4682 8.06286C27.6089 10.1884 25.6575 18.1305 29.9605 10.2933C29.2032 10.755 29.655 10.0667 30.0014 9.86531C30.0164 10.6459 30.8125 9.17706 30.8835 8.83294C30.5349 9.18965 30.8211 8.32305 30.8706 8.7469H30.8727Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M22.4539 9.44771C22.7616 9.10779 21.8924 5.59104 21.8515 5.21544C21.6105 4.42858 20.8145 5.12521 21.1393 5.67916C21.1544 5.81345 21.5782 6.64018 21.1523 6.52478C20.651 7.28856 21.7009 8.4804 21.2297 9.07841C21.4664 9.13926 21.4535 9.50015 21.5976 9.5547C21.419 9.69529 21.546 9.99324 21.6041 9.97436C21.4771 11.1914 22.9939 11.0004 22.5572 9.85687C22.6196 9.86316 22.6648 9.54211 22.4561 9.44979L22.4539 9.44771Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.89582 13.5226C9.97328 14.171 9.60108 13.7702 9.56665 13.4534C10.1648 13.5184 9.38593 12.763 9.09763 12.656C9.16217 12.7505 9.03523 12.8994 8.89108 12.7127C9.38162 12.5364 7.53133 10.1968 7.64106 11.8985C7.67548 11.9363 7.99391 11.716 7.93797 11.8356C7.413 12.1189 8.03694 12.2259 8.15742 12.2993C7.91646 12.484 8.21982 12.4063 8.14236 12.5092C7.71636 12.6372 8.74693 12.7987 8.31017 12.9078C8.26284 13.8122 9.7818 14.341 9.67423 15.0879C10.4445 14.9432 11.0533 17.2429 11.5353 15.7951C11.1588 14.8928 10.7908 14.2004 9.89582 13.5226Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11.7204 4.88812C10.8297 5.2847 12.3163 6.72834 12.3744 7.3914C12.3787 8.2454 15.5694 14.962 15.8039 12.3853C14.8207 10.3605 14.3775 8.53286 12.8671 6.22473C12.6498 5.83235 12.198 4.43909 11.7204 4.88812Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M32.3961 16.4875C32.4671 17.4003 31.2494 17.1547 31.2537 17.9479C31.4279 19.3391 37.1337 15.3523 36.1612 14.5508C35.2296 13.9717 33.076 16.5253 32.3961 16.4875Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M30.8656 15.2719L21.3193 19.0913V29.2763L30.8656 33.0957V15.2719Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M23.7649 19.7256V28.6244H18.773V34.3644H14.9537V28.6244H11.1343V19.7256H23.7649Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M23.765 19.7256H21.3193V28.62H23.765V19.7256Z",
        fill: primaryColor
    }));

});

parcelRegister("6Je5I", function(module, exports) {

$parcel$export(module.exports, "FeatureFlagAvatar", () => $cc6035f067b1cb38$export$2d7efea536028358);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $cc6035f067b1cb38$export$2d7efea536028358 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_7126_44811)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M18.4674 12.327C18.3867 10.7241 18.0617 8.58558 18.0098 7.815C18.427 8.74089 18.2636 6.33955 18.1732 5.9453C18.1348 6.3495 17.9618 6.03691 17.9983 5.76213C18.6174 6.14841 18.1963 -0.402498 17.6542 2.96654C17.5138 4.55548 17.2485 8.03603 17.21 10.5668C17.533 11.8033 18.1367 16.9982 18.4674 12.329V12.327Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.3998 15.0647C12.0115 14.3041 11.5943 13.645 10.7849 12.8386C10.8521 13.5056 10.508 13.0477 10.4772 12.7331C11.054 12.8585 10.2792 11.9923 10.0062 11.8729C10.085 11.9943 9.94468 12.1038 9.81394 11.9187C10.3004 11.8788 8.56619 9.75627 8.40085 10.71C8.62387 11.0445 8.38162 11.1959 8.78152 11.0505C8.34509 11.4368 9.04684 11.4308 9.07568 11.4965C8.80652 11.9226 9.6313 11.9884 9.28523 12.0999C9.41789 12.9122 12.4729 16.8448 12.3998 15.0667V15.0647Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.4909 22.1992C8.60074 21.4624 7.61638 20.9706 6.19943 20.7118C6.78967 21.2773 6.10329 21.0463 5.80337 20.8133C7.12995 20.3096 -0.123965 19.9432 2.62918 21.0921C2.75222 20.4589 2.66763 21.2812 3.03869 21.0483C3.32323 20.8412 3.59431 20.9089 3.58855 21.0722C3.58662 21.2534 4.34989 20.7735 4.14225 21.116C4.77863 21.2155 10.9559 23.7264 9.4909 22.1992Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.58349 28.6863C7.55683 29.0327 6.60901 29.5803 5.69193 30.6356C6.45136 30.4265 5.89187 30.9084 5.55926 31.0159C5.89379 29.5544 1.74295 35.4801 4.11157 33.8055C3.64054 33.3555 4.30767 33.8712 4.29421 33.4431C4.48455 32.5292 5.3824 32.5909 6.10529 31.5276C6.51481 30.8287 10.2254 28.8993 8.58349 28.6883V28.6863Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M38.6205 20.3191C37.54 20.2215 36.5883 20.2295 35.206 20.3589C36.0019 20.7432 34.9541 20.789 34.8599 20.4585C35.504 20.2793 33.8294 20.2056 33.6602 20.3788C33.8755 20.4027 33.7813 20.5859 33.5429 20.56C33.7217 20.0941 29.4863 20.11 31.73 21.0419C31.7992 21.0299 31.7511 20.6675 31.8568 20.777C31.8261 21.3724 32.4394 20.8328 32.5221 20.8547C32.5874 21.3166 33.4737 20.775 33.2661 21.0936C33.7121 21.6412 40.6834 21.2928 38.6186 20.3191H38.6205Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M28.6322 9.25067C28.5534 8.19337 29.5916 7.45664 29.7858 6.39536C29.3743 4.68495 26.1079 11.2637 27.1788 10.0292C27.4998 9.63696 23.7239 15.4969 25.0735 15.5009C25.1216 15.6084 25.5888 14.9434 25.5003 14.8956C25.4138 14.808 25.2831 14.7881 25.3734 14.7064C25.8945 14.9533 25.6945 13.9896 25.758 13.8921C26.7519 13.2191 27.396 10.4792 28.6341 9.24671L28.6322 9.25067Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17.5431 28.7838L15.8442 14.8184L33.301 12.6947L28.9134 20.3145L34.9999 26.6602L17.5431 28.7838Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.226 15.1368L9.73462 15.5615L12.3891 37.3825L15.8805 36.9578L13.226 15.1368Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M25.4516 36.575C24.5175 36.3381 24.2405 37.4215 24.0948 35.5869C23.9577 34.7433 23.3407 34.9773 23.1294 35.2575C23.0008 35.4251 23.4007 36.2225 23.2436 36.2976C23.2436 36.2976 23.2608 36.9563 23.3036 37.3146C23.2579 36.9332 21.824 37.1412 21.1613 37.4243C21.1613 37.4243 20.6901 38.005 21.3584 38.3604C21.3984 38.3488 22.6838 38.1842 23.0494 38.3257C23.6492 38.7533 23.1865 38.8631 23.295 39.3254C23.4036 39.7847 23.3921 41.8158 24.6832 40.6312C24.7318 39.7067 24.7232 39.5276 24.5575 38.2564C24.7632 37.9068 25.0774 37.6555 25.5515 37.7364C25.8029 37.6613 25.8515 36.3698 25.4544 36.575H25.4516Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M29.2653 33.6133C30.0565 33.9889 31.0505 33.3475 31.5218 34.1391C30.9191 33.8907 30.9991 37.086 31.9931 36.3291C32.1131 35.8321 32.4015 35.8928 31.8931 35.7224C32.7472 35.7166 31.9531 35.1677 31.9817 35.0897C32.4472 35.0781 31.8388 34.8123 32.2816 34.9048C32.5386 34.8528 31.7874 34.1941 32.2959 34.3703C32.4587 33.6538 33.2527 33.6595 33.0756 33.2233C33.0842 33.5209 35.7235 33.5902 34.9922 32.4519C34.5295 32.475 34.5895 31.9492 34.5209 32.6339C34.381 31.7846 34.0696 32.6339 33.9954 32.6137C33.9268 32.137 33.7897 32.7957 33.8097 32.3306C33.7412 32.0792 33.2956 32.8824 33.3841 32.3566C31.8446 31.9492 33.1071 31.5101 32.2187 30.626C32.1302 30.2158 32.3473 28.8839 31.3961 29.0081C30.145 29.3722 31.6046 31.6459 30.862 32.0417C30.5306 32.3421 30.0593 32.7206 29.4338 32.4635C29.1253 32.4577 28.7283 33.7318 29.2624 33.6162L29.2653 33.6133Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_7126_44811"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "42",
        height: "42",
        fill: "white",
        transform: "translate(0 3)"
    }))));

});

parcelRegister("fksEs", function(module, exports) {

$parcel$export(module.exports, "GenericAvatar", () => $e682c5ed99f8be99$export$dd2d04596094525e);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $e682c5ed99f8be99$export$dd2d04596094525e = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M29.2653 16.6133C30.0565 16.9889 31.0505 16.3475 31.5218 17.1391C30.9191 16.8907 30.9991 20.086 31.9931 19.3291C32.1131 18.8321 32.4015 18.8928 31.8931 18.7224C32.7472 18.7166 31.9531 18.1677 31.9817 18.0897C32.4472 18.0781 31.8388 17.8123 32.2816 17.9048C32.5386 17.8528 31.7874 17.1941 32.2959 17.3703C32.4587 16.6538 33.2527 16.6595 33.0756 16.2233C33.0842 16.5209 35.7235 16.5902 34.9922 15.4519C34.5295 15.475 34.5895 14.9492 34.5209 15.6339C34.381 14.7846 34.0696 15.6339 33.9954 15.6137C33.9268 15.137 33.7897 15.7957 33.8097 15.3306C33.7412 15.0792 33.2956 15.8824 33.3841 15.3566C31.8446 14.9492 33.1071 14.5101 32.2187 13.626C32.1302 13.2158 32.3473 11.8839 31.3961 12.0081C30.145 12.3722 31.6046 14.6459 30.862 15.0417C30.5306 15.3421 30.0593 15.7206 29.4338 15.4635C29.1253 15.4577 28.7283 16.7318 29.2624 16.6162L29.2653 16.6133Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.7902 28.7278L27.201 27.1386C24.0002 29.572 21.081 32.2138 18.4782 35.0894C14.793 32.0629 11.4735 28.5422 8.47053 24.5922L21.0314 12.0314C24.0681 17.5482 28.2305 21.4951 33.1965 24.3214L28.7902 28.7278ZM19.6147 24.8358L19.6147 28.5444L19.6151 28.5444L21.5003 28.5444L21.5003 24.8358H24.9944L20.5575 20.3988L16.1206 24.8358L19.6147 24.8358ZM27.2009 27.1393L28.79 28.7284L20.698 36.8205C19.9435 36.2635 19.2038 35.6863 18.478 35.0901C21.0806 32.2146 23.9998 29.5729 27.2009 27.1393Z",
        fill: "#CCE0FF"
    }));

});

parcelRegister("fGiBX", function(module, exports) {

$parcel$export(module.exports, "HireWriterAvatar", () => $ea06274cb55976f0$export$4dca011d184814ed);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $ea06274cb55976f0$export$4dca011d184814ed = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_36283",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_36283)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M31.3398 21.2886C34.0588 21.4667 36.7798 21.6989 39.4643 22.0919C39.4643 22.0919 40.3092 22.1867 41.2736 22.3299C42.24 22.4674 43.3159 22.6899 43.8062 22.8254C44.1161 22.9029 44.3653 22.9841 44.5538 23.0867C44.649 23.1351 44.7219 23.2009 44.7827 23.2629C44.8394 23.3287 44.8739 23.3906 44.9002 23.4255C44.9286 23.4603 44.9529 23.4661 44.9752 23.4274C44.9975 23.3887 45.0137 23.2996 44.9833 23.1758C44.9509 23.0577 44.8739 22.9222 44.7625 22.8042C44.651 22.6841 44.5112 22.5796 44.3431 22.479C43.6704 22.0822 42.5581 21.7686 40.9048 21.5228C40.8663 21.5054 40.7367 21.4706 40.7225 21.4512C38.9679 21.2402 37.264 21.037 35.5439 20.8473C33.8258 20.6615 32.0955 20.4989 30.3126 20.4312C30.3551 20.4892 30.2356 20.5299 30.1282 20.495L30.1687 20.4273C29.644 20.435 29.1638 20.4273 28.71 20.4157C29.727 19.3666 30.7401 18.2943 31.7025 17.2317C34.3728 14.2838 36.6744 11.4289 37.6996 9.49336C37.9549 9.00754 38.1311 8.57977 38.198 8.20621C38.2304 8.0204 38.2365 7.84426 38.198 7.68941C38.1615 7.53457 38.0785 7.41264 38.0136 7.36619C37.9528 7.3178 37.9346 7.32167 37.9569 7.36813C37.9772 7.41265 38.042 7.51329 38.0542 7.65459C38.0846 7.93524 37.9529 8.28752 37.6976 8.74818C37.7037 8.67463 37.7077 8.59914 37.7077 8.52558C37.493 9.01528 37.2194 9.45077 36.9439 9.87078C36.6643 10.2889 36.3725 10.6876 36.0666 11.0786C35.4547 11.8625 34.7942 12.6231 34.0203 13.44C33.8278 13.6916 33.7913 13.709 33.8541 13.7574C33.8096 13.829 33.7366 13.9509 33.7873 13.9432C33.9595 14.0342 33.4469 14.5238 33.2483 14.76C33.1349 14.4367 31.9942 15.7471 30.7401 17.1891C29.6359 18.4685 28.4486 19.8544 27.9441 20.3944C26.6758 20.3421 25.5533 20.2763 24.1351 20.4137C24.1391 20.4137 24.3823 20.3247 24.3884 20.3228C23.659 20.317 22.9033 20.3112 22.1273 20.3112C21.9247 20.137 21.7261 19.9608 21.5235 19.7866C21.9004 19.4498 22.6156 18.8072 23.424 18.0853C24.6092 17.0149 25.995 15.7723 26.7264 14.9981C28.7809 13.287 30.8758 11.6128 33.066 10.0779C33.066 10.0779 33.7346 9.57464 34.5227 9.02301C35.3088 8.46557 36.2327 7.89847 36.6785 7.66234C36.954 7.50749 37.1911 7.39522 37.3997 7.34297C37.5031 7.31393 37.6044 7.31005 37.6915 7.31199C37.7806 7.32167 37.8495 7.34103 37.8941 7.34684C37.9407 7.35265 37.963 7.3391 37.9488 7.29845C37.9346 7.25587 37.8819 7.1823 37.7685 7.11456C37.6591 7.05262 37.5031 7.01005 37.3369 7.00231C37.1688 6.99263 36.9925 7.01393 36.8 7.05651C36.0301 7.23071 35.013 7.75911 33.6617 8.70366C33.6211 8.71721 33.5036 8.78109 33.4793 8.77722C32.0833 9.81274 30.7259 10.8212 29.3705 11.8489C28.0171 12.8767 26.6738 13.9316 25.3629 15.0871C25.4379 15.0987 25.3811 15.209 25.2798 15.2574L25.2575 15.18C23.6043 16.8136 22.3623 17.6207 20.9785 19.2389C20.9785 19.235 21.0879 19.0085 21.0899 19.0047C21.0231 19.0685 20.9542 19.1324 20.8853 19.1963C20.4943 18.8227 19.8804 18.242 19.1834 17.6111C17.9982 16.5349 16.5678 15.3232 15.6763 14.7155C13.6543 12.9561 11.5938 11.2354 9.41374 9.63853C9.41374 9.63853 8.71878 9.15464 7.87797 8.6514C7.45655 8.39978 6.99867 8.14428 6.57725 7.94298C6.15583 7.73975 5.76885 7.59458 5.51154 7.53458C5.19345 7.45716 4.91386 7.43974 4.73354 7.48813C4.64236 7.50749 4.58561 7.552 4.55725 7.58491C4.53293 7.62362 4.53497 7.65265 4.54713 7.67587C4.55726 7.69717 4.57752 7.71265 4.59575 7.72814C4.61399 7.74362 4.62614 7.76298 4.63627 7.7804C4.6545 7.79976 4.68085 7.80944 4.74771 7.83073C4.81457 7.85008 4.91789 7.88685 5.04756 7.94104C5.57637 8.15395 6.52052 8.67461 7.86785 9.534C7.89419 9.56497 7.99347 9.64628 7.99549 9.6695C9.44008 10.5618 10.755 11.6012 12.0415 12.6773C13.3281 13.7554 14.5842 14.88 15.9052 16.0007C15.9113 15.9291 16.0288 15.9716 16.0876 16.0626L16.0106 16.0916C17.7854 17.4504 18.6911 18.5517 20.2977 19.7518C20.3606 19.8002 20.4234 19.8466 20.4902 19.895C20.4862 19.895 20.2795 19.8118 20.2491 19.7982C20.0668 19.9705 19.8824 20.1447 19.696 20.3208C18.1582 20.3324 16.5617 20.3576 14.9348 20.4041C13.7029 19.1382 12.4569 17.8279 11.2818 16.5407C8.61952 13.6374 6.28752 10.8424 5.20966 9.10237C4.94222 8.67075 4.75581 8.30492 4.67275 8.05523C4.6302 7.93136 4.616 7.84039 4.60993 7.79394C4.60587 7.74942 4.59575 7.73782 4.58967 7.72814C4.57954 7.71652 4.57143 7.70103 4.55725 7.69716C4.54306 7.69523 4.51067 7.68942 4.48028 7.74749C4.40734 7.85975 4.42557 8.21589 4.60589 8.68816C4.55119 8.6359 4.50053 8.58172 4.44786 8.52752C4.64641 9.02109 4.90573 9.46625 5.16507 9.89595C5.42845 10.3237 5.70198 10.736 5.9836 11.1463C6.54685 11.9651 7.13645 12.7819 7.79492 13.6935C8.00765 13.9296 8.01979 13.9684 8.0826 13.918C8.14744 13.9761 8.25482 14.069 8.25887 14.0206C8.38651 13.8793 8.78161 14.46 8.98827 14.6903C8.63168 14.7329 9.76019 16.0684 11.1055 17.4427C12.2928 18.664 13.6442 19.9105 14.1709 20.4292C13.401 20.4544 12.6251 20.4854 11.8491 20.5202C9.62243 20.6247 7.37955 20.7737 5.19141 21.0002C4.09733 21.1144 3.01745 21.248 1.96187 21.4164C0.906293 21.5867 -0.124969 21.7802 -1.12382 22.0803H-1.07925L-1.09342 22.0938C-0.708471 22.0106 0.369384 21.8073 1.35203 21.6854C2.33467 21.5557 3.22613 21.4744 3.22613 21.4744C1.92135 21.8209 0.511198 22.0183 -0.913125 22.3551C-1.26971 22.4441 -1.62628 22.5409 -1.97881 22.6899C-2.02338 22.7074 -2.06594 22.7287 -2.11051 22.7499C-2.16116 22.7712 -2.21384 22.8061 -2.26652 22.8332C-2.36985 22.8932 -2.46711 22.9629 -2.55018 23.0422C-2.63324 23.1235 -2.70011 23.2164 -2.73658 23.3229C-2.77508 23.4293 -2.77102 23.5474 -2.73658 23.6539C-2.65959 23.8648 -2.47723 24.0332 -2.26449 24.1648C-2.14901 24.2403 -2.06796 24.279 -1.98287 24.3216C-1.89575 24.3642 -1.80864 24.401 -1.72152 24.4397C-1.37304 24.581 -1.02049 24.6874 -0.669982 24.7745L-0.71455 24.8578C-1.01846 24.7784 -1.31629 24.6952 -1.59791 24.5984C-1.73973 24.5481 -1.87549 24.4997 -2.00921 24.4416C-2.07607 24.4145 -2.1409 24.3836 -2.20776 24.3507C-2.29083 24.3081 -2.382 24.2539 -2.46102 24.2036C-2.78519 23.9926 -2.96552 23.7042 -2.95742 23.4313C-2.95134 23.1584 -2.80142 22.9706 -2.68593 22.8448C-2.84599 22.9958 -2.97766 23.1816 -2.9959 23.4061C-3.02021 23.6306 -2.93512 23.8532 -2.77507 24.0371C-2.73049 24.0816 -2.68794 24.1281 -2.63931 24.1706C-2.58663 24.2113 -2.536 24.2539 -2.4813 24.2926L-2.30703 24.4029L-2.16725 24.4784C-2.00111 24.5616 -1.83498 24.6333 -1.66681 24.6971C-0.992135 24.9487 -0.270856 25.1229 0.486892 25.2797C2.00036 25.5855 3.6516 25.8004 5.30082 25.9649C8.36625 26.2688 12.465 26.3597 12.2502 26.1991C12.7345 26.2184 13.2167 26.2301 13.6948 26.2417C13.6502 26.2881 13.5307 26.4101 13.5307 26.4101C13.1437 26.8088 12.7567 27.2114 12.3718 27.6179C10.8745 29.1953 9.39753 30.8154 8.01981 32.4548C7.33095 33.2755 6.6664 34.0981 6.04439 34.9304C5.42442 35.7646 4.83889 36.5969 4.35264 37.4853L4.38301 37.4543V37.4756C4.59372 37.1582 5.2056 36.2833 5.81139 35.5343C6.41111 34.7794 6.98043 34.1194 6.98043 34.1194C6.31386 35.2459 5.46292 36.3375 4.70517 37.5395C4.5208 37.8434 4.33845 38.1531 4.19865 38.4957C4.18042 38.5383 4.16624 38.5828 4.15003 38.6273C4.12977 38.6757 4.11759 38.7356 4.10138 38.7918C4.07099 38.904 4.05479 39.0182 4.05479 39.1324C4.05479 39.2447 4.0791 39.357 4.13178 39.4576C4.18243 39.5583 4.27362 39.6396 4.37695 39.6918C4.58766 39.7906 4.84092 39.7847 5.0881 39.7364C5.22384 39.7112 5.31095 39.6841 5.40415 39.657C5.49735 39.6299 5.58649 39.597 5.67564 39.5641C6.02615 39.4286 6.35437 39.266 6.66638 39.0918L6.69678 39.1808C6.42326 39.3299 6.14974 39.4712 5.88027 39.5951C5.74452 39.6551 5.6108 39.7131 5.47303 39.7634C5.40617 39.7886 5.33728 39.8118 5.26637 39.8331C5.17722 39.8602 5.07188 39.8835 4.97868 39.9009C4.59373 39.9706 4.25131 39.8893 4.05479 39.6899C3.85826 39.4925 3.82383 39.2583 3.81167 39.0918C3.80964 39.3066 3.85421 39.5273 4.00819 39.6976C4.15609 39.8718 4.381 39.9725 4.63223 39.9957C4.69707 39.9957 4.75987 40.0015 4.82673 39.9996C4.89359 39.9919 4.96045 39.988 5.02934 39.9783C5.09822 39.9647 5.16508 39.9512 5.23397 39.9377L5.38795 39.897C5.56625 39.8448 5.73642 39.7828 5.90458 39.7131C6.56913 39.4344 7.20735 39.0725 7.85771 38.6718C9.15439 37.8666 10.4815 36.9008 11.768 35.9059C14.3411 33.9103 16.7481 31.7774 18.2474 30.347C18.1157 30.3683 17.2627 31.3303 16.8575 31.3767C17.6578 30.678 18.4257 29.9483 19.1712 29.2805C19.2786 29.3889 18.8126 29.7373 18.7458 29.8341C18.9767 29.6618 19.8966 28.8779 21.2074 27.6934C22.8769 29.3928 24.903 31.2838 27.1823 33.2232C28.4749 34.3226 29.8486 35.4394 31.3013 36.5272C32.0266 37.0711 32.7742 37.6092 33.5462 38.126C34.3242 38.6408 35.1143 39.144 35.9997 39.5679C36.2226 39.6725 36.4536 39.7712 36.7068 39.8525C36.7372 39.8641 36.7696 39.8738 36.8041 39.8815L36.9155 39.9125C37.0148 39.9299 37.1141 39.9609 37.2133 39.9667C37.4119 39.9957 37.6064 39.9822 37.7807 39.926C37.9529 39.8699 38.1089 39.7557 38.2041 39.6047C38.3054 39.4576 38.3419 39.2795 38.3419 39.0957C38.3479 39.0047 38.3277 38.9079 38.3155 38.815L38.2831 38.6737C38.273 38.6273 38.2588 38.575 38.2487 38.546C38.2102 38.4183 38.1616 38.304 38.1129 38.1898C37.9144 37.7389 37.6753 37.3343 37.4261 36.9414C37.1769 36.5485 36.9155 36.171 36.646 35.7994C35.5702 34.3207 34.4153 32.9464 33.2808 31.6302C31.6822 29.7857 30.114 28.0669 28.6715 26.4914C30.1849 26.4372 31.7146 26.3617 33.1997 26.2591C37.2701 25.9784 41.0102 25.5159 43.17 24.8384C43.7089 24.6662 44.1506 24.4823 44.4748 24.2655C44.6348 24.1571 44.7706 24.0351 44.8577 23.8997C44.9468 23.7642 44.9772 23.6229 44.9671 23.5474C44.961 23.4719 44.9448 23.4622 44.9246 23.5106C44.9063 23.5551 44.8759 23.6713 44.7807 23.7777C44.5943 23.9965 44.2397 24.1571 43.719 24.31C43.7778 24.2616 43.8365 24.2113 43.8912 24.159C43.3786 24.3603 42.862 24.4842 42.3555 24.5945C41.849 24.701 41.3465 24.7861 40.842 24.8558C39.829 24.9971 38.7998 25.09 37.6469 25.1423C37.3248 25.1887 37.2863 25.1791 37.2964 25.2545C37.2113 25.2758 37.0715 25.3126 37.112 25.3397C37.1667 25.5197 36.4414 25.5197 36.1254 25.5526C36.2854 25.2468 34.5086 25.4036 32.5554 25.5758C30.8069 25.7365 28.9186 25.9165 28.1812 25.9552C27.7435 25.4772 27.316 25.0087 26.9088 24.5597L26.9432 24.6429C26.8885 24.5732 26.6839 24.3894 26.6657 24.3158C26.4185 24.1145 26.0659 23.8068 25.6891 23.4738C26.4023 22.777 27.1357 22.0473 27.8732 21.3002C29.18 21.3331 30.501 21.3583 31.3418 21.3157L31.3398 21.2886ZM43.2105 22.4732C43.251 22.3919 43.482 22.4306 43.5124 22.5351C43.4658 22.5874 43.1882 22.5564 43.1821 22.448C43.1821 22.4519 43.1902 22.4635 43.2105 22.4732ZM34.3525 21.1067C34.7436 21.1957 33.9514 21.2789 33.7792 21.1976C33.8683 21.126 34.1986 21.0989 34.3525 21.1067ZM10.1107 16.1807L10.0337 16.0955C10.0418 16.0839 10.0661 16.0878 10.0864 16.1013C10.1066 16.1091 10.1391 16.1323 10.1553 16.1555L10.1127 16.1807H10.1107ZM24.358 23.6655C23.896 24.1416 23.3936 24.6603 22.9195 25.1423C22.6723 25.3939 22.4312 25.6359 22.2103 25.8585C21.8477 25.872 21.481 25.8836 21.1284 25.8933C20.9157 25.8991 20.707 25.9049 20.5064 25.9107C20.1539 25.572 19.7831 25.2139 19.3982 24.8384C18.9382 24.3913 18.456 23.919 17.9597 23.4293C17.9799 23.408 18.0022 23.3848 18.0225 23.3635C18.61 22.7403 19.1145 22.2274 19.1145 22.2274C19.4184 21.9099 19.7284 21.5964 20.0343 21.2809C20.3768 21.2673 20.5956 21.2615 20.5956 21.2615C20.9967 21.2441 21.3979 21.2286 21.8011 21.215C22.6318 21.9951 23.4888 22.8158 24.36 23.6674L24.358 23.6655ZM15.9093 25.632C15.9984 25.5488 16.0896 25.4636 16.1767 25.3823L16.0937 25.4191C16.1646 25.363 16.3429 25.1597 16.4199 25.1404C16.6508 24.8539 17.0317 24.4281 17.4349 23.9887C17.9252 24.4436 18.4641 24.9333 18.9727 25.3881C19.1814 25.5759 19.384 25.7559 19.5745 25.9281C18.4723 25.9436 17.9273 25.9165 18.8329 25.8062C17.9192 25.7462 16.9406 25.6901 15.9093 25.632ZM16.0957 21.4783C16.1869 21.486 16.4644 21.4648 16.5333 21.5015C17.0155 21.4415 17.8361 21.3854 18.6161 21.3428C18.1562 21.7841 17.6902 22.2351 17.2201 22.6938C16.8311 22.3067 16.4381 21.9099 16.039 21.5054C16.0856 21.5054 16.1362 21.5054 16.1828 21.5054L16.0957 21.4744V21.4783ZM4.06087 21.306H4.04264L4.0325 21.217C4.73555 21.0505 4.84496 21.2751 4.06087 21.306ZM0.140443 25.0745C0.0553484 25.0552 0.0371048 25.0339 -0.0459638 25.0049C-0.0641983 24.8539 0.432182 25.03 0.582111 25.0436C0.472703 25.0513 0.264035 25.1036 0.142471 25.0745H0.140443ZM9.61635 25.2584C7.9023 25.1403 6.12138 25.001 4.3121 24.8016C3.40848 24.7029 2.49676 24.5868 1.58908 24.4436C0.685459 24.2965 -0.228301 24.13 -1.07519 23.8687C-1.28388 23.8029 -1.48853 23.7293 -1.6729 23.6461C-1.69721 23.6364 -1.71949 23.6248 -1.73975 23.6151L-1.79243 23.59C-1.80661 23.5822 -1.81876 23.5764 -1.83294 23.5667C-1.85928 23.5513 -1.88359 23.5319 -1.90385 23.5068C-1.95045 23.4564 -1.91602 23.3848 -1.86536 23.35C-1.85321 23.3403 -1.84104 23.3306 -1.82686 23.3229L-1.8066 23.3113C-1.8066 23.3113 -1.79649 23.3055 -1.7742 23.2938C-1.69113 23.2493 -1.59386 23.2067 -1.49864 23.1661C-1.10558 23.0074 -0.669973 22.8835 -0.230318 22.7771C0.209338 22.6687 0.659121 22.5777 1.10891 22.4964C2.9121 22.1731 4.72947 21.9777 6.49215 21.8267C9.56771 21.5731 12.4873 21.4783 15.0644 21.4957C15.4393 21.848 15.8485 22.2138 16.0086 22.4519C15.9721 22.4286 15.7371 22.2874 15.7067 22.2699C15.7594 22.3822 16.1301 22.7577 16.6488 23.2551C15.8911 24.0003 15.1232 24.7648 14.3553 25.5468C12.856 25.4636 11.2656 25.3726 9.61229 25.2584H9.61635ZM7.45858 33.4284L7.44844 33.4419L7.37348 33.3839C7.7483 32.7916 7.99144 32.8767 7.45858 33.4284ZM15.0989 26.3946C15.9133 26.4488 20.5753 26.5611 20.2775 26.5572C20.4841 26.7449 20.7718 27.0178 20.7718 27.0178L20.6948 27.0817C20.6948 27.0817 20.6786 27.0953 20.6685 27.103C18.8066 28.6669 16.667 30.5173 14.3087 32.4703C13.01 33.5445 11.6465 34.6497 10.2201 35.7317C9.50693 36.2717 8.77754 36.8059 8.02992 37.3169C7.2823 37.824 6.5124 38.3215 5.72223 38.7105C5.5257 38.8053 5.32717 38.8924 5.13469 38.9563C5.11038 38.966 5.08605 38.9718 5.06376 38.9796L5.00705 38.997C4.99287 39.0008 4.97664 39.0047 4.96246 39.0086C4.93207 39.0144 4.89966 39.0183 4.86927 39.0144C4.79836 39.0105 4.77 38.937 4.78013 38.877C4.78013 38.8615 4.78417 38.846 4.78619 38.8325L4.79228 38.8092C4.79228 38.8092 4.79431 38.7976 4.80242 38.7744C4.82876 38.6854 4.86522 38.5925 4.90372 38.4976C5.06378 38.1202 5.28057 37.7369 5.51357 37.3653C5.74454 36.9917 5.99578 36.624 6.25309 36.262C7.2884 34.8143 8.42907 33.4478 9.56367 32.1529C11.4499 30.0102 13.3402 28.0688 15.0989 26.3965V26.3946ZM34.152 33.8349L34.1621 33.8484L34.0851 33.9045C33.5725 33.4264 33.7143 33.2194 34.1499 33.8349H34.152ZM31.1331 30.1437C31.4532 30.4902 31.7956 30.8735 32.1178 31.2412L32.0327 31.2877C31.7004 30.918 31.3742 30.5541 31.0521 30.1941L31.1331 30.1437ZM34.8996 37.7698C33.6718 36.9685 32.3771 36.0046 31.1088 35.0194C28.5702 33.0471 26.1368 30.9741 24.5423 29.6579C24.5727 29.7837 25.6385 30.5135 25.7256 30.8909C24.9253 30.198 24.1108 29.5224 23.3733 28.8508C23.4787 28.7444 23.8697 29.1644 23.9751 29.2205C23.7907 29.0192 22.9782 28.2605 21.7889 27.1282C21.9855 26.9482 22.1901 26.7604 22.3988 26.5669C23.8981 26.5669 25.527 26.5494 27.2026 26.503C27.784 27.0991 28.3675 27.703 28.947 28.3147C30.4321 29.8825 31.897 31.489 33.2727 33.0955C33.9595 33.8987 34.624 34.702 35.246 35.5033C35.864 36.3046 36.4536 37.1059 36.9236 37.9053L36.9155 37.8686L36.9337 37.8782C36.8061 37.5608 36.2976 36.6762 35.7606 35.9001C35.2318 35.12 34.7091 34.433 34.7091 34.433C35.6533 35.3369 36.5083 36.444 37.1667 37.6595C37.3268 37.9634 37.4747 38.277 37.574 38.5925C37.5882 38.6312 37.5963 38.6699 37.6064 38.7105C37.6165 38.7434 37.6186 38.7686 37.6246 38.7995C37.6348 38.8557 37.6408 38.9137 37.6388 38.9679C37.6388 39.0763 37.5861 39.1964 37.4686 39.2254C37.3572 39.2544 37.2417 39.2292 37.1404 39.2002C37.0999 39.1886 37.0148 39.1615 36.9358 39.1324C36.8588 39.1053 36.7798 39.0724 36.7028 39.0395C36.3908 38.904 36.0848 38.7454 35.783 38.5808L35.8478 38.5111C36.1071 38.6544 36.3624 38.7802 36.6055 38.8828C36.7271 38.9312 36.8446 38.9776 36.956 39.0125C37.0107 39.0318 37.0675 39.0454 37.1161 39.057C37.1465 39.0647 37.1647 39.0647 37.187 39.0686C37.2721 39.0783 37.3511 39.0647 37.3815 39.0105C37.4099 38.9563 37.3896 38.9041 37.3775 38.875C37.3775 38.9099 37.3714 38.9467 37.345 38.9718C37.3187 38.9989 37.2741 39.0008 37.2377 38.995C37.2194 38.9911 37.2012 38.9873 37.1829 38.9815C37.1485 38.9699 37.1161 38.9602 37.0816 38.9486C36.954 38.904 36.8183 38.8499 36.6785 38.786M26.5745 25.8623C26.1125 25.8933 25.6526 25.9223 25.3994 25.8778C25.4419 25.8662 25.7094 25.7965 25.7438 25.7888C25.5635 25.7365 24.4876 25.7733 23.2112 25.8197C23.3085 25.7288 23.4057 25.6378 23.505 25.543C23.9588 25.1171 24.4289 24.6681 24.9151 24.2016C25.4662 24.7455 26.0193 25.2991 26.5765 25.8623H26.5745ZM25.9322 22.2525C25.9545 22.2157 26.0923 21.9873 26.1085 21.9564C25.995 22.0144 25.6101 22.3919 25.0975 22.9106C25.0144 22.8351 24.9313 22.7616 24.8503 22.6899C24.208 22.1131 23.6711 21.6273 23.6711 21.6273C23.4949 21.4725 23.3146 21.3196 23.1383 21.1647C23.3389 21.1589 23.5394 21.1512 23.738 21.1454C23.738 21.1454 25.0975 21.1879 26.7264 21.2383C26.7953 21.2383 26.8662 21.2421 26.9372 21.2441C26.5745 21.637 26.1875 22.0841 25.9322 22.2525Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M31 14.1206H11V37.1206H31V14.1206Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17.5175 32.4831C17.5175 30.4837 19.1362 28.865 21.1356 28.865C23.135 28.865 24.7537 30.4837 24.7537 32.4831V37.1337H17.5175V32.4831Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M24.2374 24.2144C24.2374 25.925 22.8506 27.3163 21.1356 27.3163C19.4206 27.3163 18.0337 25.9294 18.0337 24.2144C18.0337 22.4994 19.4206 21.1125 21.1356 21.1125C22.8506 21.1125 24.2374 22.4994 24.2374 24.2144Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.2037 11.5725V16.9581H14.7306V11.5725H18.3968C18.3968 10.1506 19.5475 9 20.9693 9C22.3912 9 23.5375 10.1506 23.5375 11.5725H27.2037Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.2037 14.4537H14.7306V17.9581H27.2037V14.4537Z",
        fill: primaryColor
    }));

});

parcelRegister("54k0x", function(module, exports) {

$parcel$export(module.exports, "MarketingMessageMaestroAvatar", () => $8e8aba828f528df3$export$981f8dc258625637);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $8e8aba828f528df3$export$981f8dc258625637 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_41146",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_41146)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M38.8146 33.2372C42.8863 26.2593 41.6736 20.7329 40.7508 17.0853C41.2687 15.0932 35.744 6.57273 37.391 11.9803C39.4893 14.2246 40.9099 22.1599 39.2797 26.6694C40.3775 27.8999 35.5039 36.4685 38.8144 33.2338L38.8146 33.2372Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M35.4493 29.7688C37.6984 27.0185 37.2267 23.1905 36.9474 21.6173C37.7975 22.8484 37.2465 19.476 36.8197 18.9481C36.8839 19.4831 36.5196 19.221 36.4571 18.7768C37.3824 18.5829 34.8601 12.8143 33.8218 14.4824C34.2377 15.1759 33.9231 15.5506 34.6706 15.5721C33.8085 15.9813 35.1115 16.6446 35.2234 16.884C35.0807 17.4173 34.8669 17.416 35.4162 18.0683C35.468 18.9811 35.2885 20.3008 35.6629 21.8181C35.8553 23.9518 35.255 25.1507 35.183 26.929C34.948 27.6898 33.3874 31.5119 35.443 29.7759L35.4493 29.7688Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M31.8448 26.7481C32.6747 25.6506 33.1238 24.2986 32.9003 22.4529C32.2919 23.2685 32.2675 22.5394 32.5537 22.0249C33.3266 22.9708 32.9746 19.8767 32.4045 20.7103C32.2439 20.5107 32.3221 20.2739 32.5001 20.4221C32.9653 19.2342 30.1673 15.8412 30.8921 18.6887C31.3443 18.5283 30.2507 19.1021 31.3712 19.419C31.092 19.8792 30.9183 19.7476 31.363 20.1129C31.3592 20.5238 30.8977 21.358 31.269 22.1618C31.6128 23.3172 30.6023 23.8022 31.2574 24.6471C30.834 25.1963 30.499 27.72 31.8479 26.7412L31.8448 26.7481Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.920702 17.5408C-1.78535 25.153 0.431775 30.3585 2.01544 33.7715C1.87621 35.8251 8.88604 43.1724 6.26425 38.1643C3.7859 36.3484 0.917413 28.8145 1.68244 24.0808C0.375448 23.0754 3.57425 13.7513 0.921512 17.5441L0.920702 17.5408Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.87117 20.3245C3.17154 23.4444 4.34544 27.1183 4.91179 28.6124C3.848 27.5605 5.01524 30.7721 5.53265 31.2116C5.3702 30.6978 5.7768 30.8877 5.92067 31.3126C5.04745 31.6749 8.59637 36.8753 9.30712 35.0434C8.76974 34.4391 9.00934 34.0125 8.27079 34.1301C9.04207 33.568 7.6386 33.158 7.48415 32.9436C7.52545 32.393 7.73577 32.3547 7.07501 31.8157C6.85471 30.9284 6.78621 29.5982 6.13668 28.1767C5.55174 26.1158 5.91907 24.8263 5.65989 23.0655C5.74963 22.2744 6.57387 18.229 4.87613 20.3163L4.87117 20.3245Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.9736 22.6239C8.36179 23.8563 8.17141 25.2681 8.73353 27.0403C9.18004 26.1259 9.33932 26.8379 9.15349 27.3966C8.21851 26.6105 9.13863 29.5855 9.54412 28.6606C9.73897 28.827 9.70608 29.0741 9.50366 28.9616C9.26701 30.2152 12.646 33.03 11.4054 30.3665C10.9908 30.608 11.959 29.8412 10.7991 29.7378C10.9881 29.2337 11.1832 29.3308 10.6783 29.0544C10.6058 28.6499 10.9045 27.7446 10.3905 27.0237C9.83831 25.9521 10.7413 25.288 9.94069 24.5794C10.2548 23.9612 10.1157 21.4191 8.97193 22.6312L8.9736 22.6239Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M26.7573 33.1935C26.7668 32.8779 26.7428 32.5452 26.6902 32.1992C26.6376 31.8532 26.556 31.5204 26.4524 31.2175C25.8372 29.4126 24.3747 28.4667 22.522 28.4475C22.207 28.4423 21.8787 28.4656 21.5413 28.5169C21.2039 28.5682 20.8575 28.6475 20.546 28.7524C18.784 29.33 17.6724 30.6629 17.6158 32.5611C17.607 32.8811 17.6273 33.2187 17.6806 33.5691C17.7339 33.9194 17.8135 34.2392 17.9121 34.5384C18.5253 36.3303 19.9835 37.2769 21.8418 37.3041C22.1698 37.3073 22.5118 37.2863 22.8621 37.2331C23.2125 37.1798 23.5156 37.1071 23.8191 37.0079C25.5824 36.4389 26.7014 35.096 26.7486 33.1948L26.7573 33.1935Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M29.83 23.2208L31.0927 31.5253L13.2725 34.2348L12.0098 25.9302C11.1733 20.4285 12.7616 17.1955 15.8738 15.6027C15.8639 15.5378 15.8541 15.4729 15.8436 15.4037C15.8008 15.1226 15.7866 14.8548 15.7917 14.5974C15.835 13.0773 16.7257 12.0082 18.1421 11.545C18.3907 11.4629 18.655 11.3962 18.9404 11.3528C19.2086 11.312 19.4714 11.2942 19.7245 11.3C21.209 11.3132 22.3822 12.073 22.8766 13.5201C22.958 13.7644 23.0197 14.025 23.0625 14.3061C23.0723 14.371 23.0822 14.4359 23.0834 14.5021C26.7044 15.0623 29.1948 17.6751 29.8343 23.2201L29.83 23.2208Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M26.6938 32.1942L17.6928 33.5627C17.6396 33.2124 17.6162 32.884 17.6294 32.5634C17.6816 30.6659 18.7976 29.3323 20.5552 28.7553C20.8674 28.6548 21.2002 28.5732 21.5505 28.5199C21.9009 28.4666 22.2119 28.4459 22.5312 28.4505C24.3839 28.4697 25.8421 29.4162 26.4573 31.2212C26.5652 31.5234 26.6405 31.8438 26.6938 32.1942Z",
        fill: primaryColor
    }));

});

parcelRegister("bTTug", function(module, exports) {

$parcel$export(module.exports, "MyUserManualAvatar", () => $7b3bc412acf3f8c5$export$b7a39f103e11c638);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $7b3bc412acf3f8c5$export$b7a39f103e11c638 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_38527",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_38527)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M57 26.9465C52.3092 27.9804 46.9066 27.0919 42.7987 24.3569C49.4591 12.2437 30.5884 14.1409 40.5928 24.3095C35.7026 27.8982 27.4469 29.0997 22.5597 24.9608C33.6931 11.6809 15.4207 11.7663 20.4643 24.6984C19.8722 25.4984 13.7793 28.9132 10.6562 28.4863C11.3189 28.6539 12.4018 28.2998 13.0645 28.5685C11.5919 28.8152 10.061 28.831 8.66207 28.5495C8.72957 28.3156 9.52415 28.5338 9.65607 28.499C8.45959 28.382 4.93457 27.2595 3.73195 25.7355C5.38862 24.2684 9.67755 21.0559 7.70489 18.5169C6.29365 17.3597 4.62778 17.6126 3.19813 18.6244C3.23188 18.5706 3.52026 18.245 3.56628 18.2039C1.14877 19.3516 0.593479 23.2882 2.18265 25.4193C-1.47122 27.9583 -5.98411 30.7724 -10 30.3139C-9.99386 30.6617 -9.16553 30.7945 -8.34947 30.8704L-8.65932 31C-4.75388 30.7629 -1.01717 29.2009 1.75008 26.6461C1.75928 26.8928 2.21027 26.741 2.89748 26.3109C3.14904 26.7283 5.56962 28.2935 3.87921 27.4303C8.21416 31.8474 18.3751 29.3274 21.4736 26.0327C25.9835 30.2665 33.3066 29.5803 38.5435 27.7053H38.4023C39.6019 27.2722 40.6665 26.4785 41.9427 25.3118C45.1364 27.6041 54.7788 30.6364 57 26.9402V26.9465ZM3.01099 24.7838C1.03833 22.0424 4.17373 17.1257 7.24163 19.3516C7.3214 21.5997 4.46825 23.3799 3.01099 24.7838ZM21.2558 23.9205C21.2558 23.9205 21.2681 23.9048 21.2742 23.8984C19.1328 21.5049 21.1607 14.7827 24.6489 16.4206C24.0722 15.94 22.7468 16.6988 22.4462 17.0403C27.318 14.3812 22.7928 22.6684 21.2558 23.9205ZM42.6729 21.2804C42.4888 22.0361 42.0685 22.8013 41.5316 23.4052C40.6511 22.678 39.786 21.7262 39.3595 20.6575C39.2982 20.7429 39.1693 20.6385 39.1847 20.4962L39.3013 20.5026C38.1723 18.3051 40.8107 15.9463 42.4213 18.0363C42.4213 18.0236 42.1759 17.8909 42.1636 17.8972C42.7496 18.8805 42.9459 20.1516 42.6729 21.2804Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M34.9869 15.9675V33.7388C30.52 34.4607 25.5937 36.0882 21 38.7219C16.4106 36.0882 11.48 34.4607 7.01312 33.7388V15.9675C12.6919 16.5582 17.4694 18.4744 21 20.8719C24.535 18.4788 29.3081 16.5582 34.9869 15.9675Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.0444 10.0525H22.9513L24.1806 13.3337L27.6369 12.7606L29.5925 16.1469L27.3656 18.8506L29.5925 21.5544L27.6369 24.9406L24.1806 24.3675L22.9513 27.6487H19.0444L17.815 24.3675L14.3588 24.9406L12.4031 21.5544L14.63 18.8506L12.4031 16.1469L14.3588 12.7606L17.815 13.3337L19.0444 10.0525ZM21 22.145C22.82 22.145 24.2988 20.6706 24.2988 18.8462C24.2988 17.0219 22.8244 15.5475 21 15.5475C19.1756 15.5475 17.7013 17.0219 17.7013 18.8462C17.7013 20.6706 19.1756 22.145 21 22.145Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M27.37 18.8462L28.6869 17.245C27.1119 17.7262 25.6419 18.3125 24.29 18.9731C24.2288 20.7362 22.7806 22.1406 21 22.1406C19.2194 22.1406 17.7756 20.7362 17.7144 18.9775C16.3625 18.3125 14.8969 17.7262 13.3175 17.245L14.6344 18.8462L12.4075 21.55L14.3631 24.9319L17.8194 24.3587L19.0488 27.64H22.9556L24.185 24.3587L27.6413 24.9362L29.5925 21.55L27.37 18.8462Z",
        fill: primaryColor
    }));

});

parcelRegister("8zvm7", function(module, exports) {

$parcel$export(module.exports, "OkrOracleAvatar", () => $d4339908d67ae7d0$export$b39cc14a70af21b3);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $d4339908d67ae7d0$export$b39cc14a70af21b3 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_35871",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_35871)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M31.0672 6.71876C25.3431 2.95696 20.5959 3.71388 17.4568 4.31657C15.7916 3.78529 8.29655 8.02982 12.9638 6.90157C14.969 5.24204 21.7699 4.42513 25.5174 6.01325C26.6142 5.14778 33.6494 9.66079 31.0644 6.71876H31.0672Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.9625 9.38656C25.7374 7.36142 22.4669 7.57567 21.1187 7.73562C22.2041 7.07866 19.3163 7.38142 18.8479 7.71561C19.3049 7.68704 19.065 7.98126 18.6851 8.01268C18.5651 7.22433 13.5494 9.07236 14.9148 10.0264C15.5232 9.70932 15.8259 9.99212 15.8802 9.36372C16.1858 10.1092 16.8113 9.0438 17.0198 8.96097C17.4654 9.10664 17.454 9.28659 18.0339 8.85528C18.8108 8.85528 19.9219 9.06952 21.2272 8.82673C23.0467 8.76674 24.035 9.32945 25.5403 9.47512C26.1744 9.70934 29.3421 11.2061 27.9682 9.39228L27.9625 9.38656Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M25.2261 12.2772C24.3349 11.526 23.2095 11.0833 21.6328 11.1832C22.2955 11.7345 21.6757 11.7202 21.253 11.4546C22.0927 10.849 19.4506 10.9976 20.1305 11.5174C19.9534 11.6431 19.7562 11.566 19.8905 11.4232C18.9051 10.9747 15.8916 13.1684 18.3424 12.6943C18.2281 12.3058 18.6623 13.2541 18.9851 12.3258C19.3621 12.5828 19.2421 12.7228 19.5734 12.3658C19.9219 12.3886 20.6074 12.8171 21.3072 12.5429C22.3041 12.3086 22.6669 13.1827 23.4152 12.6714C23.8608 13.0541 25.9859 13.4569 25.2204 12.2743L25.2261 12.2772Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M33.2237 14.725H8.77625V30.7332H33.2237V14.725Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.5669 32.925V35.6463H14.4331V32.925H18.8081V28.0425H23.1919V32.925H27.5669Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M23.1919 28.0425H18.8081V30.7375H23.1919V28.0425Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M21 26.5288C23.0973 26.5288 24.7975 24.8286 24.7975 22.7313C24.7975 20.634 23.0973 18.9338 21 18.9338C18.9027 18.9338 17.2025 20.634 17.2025 22.7313C17.2025 24.8286 18.9027 26.5288 21 26.5288Z",
        fill: primaryColor
    }));

});

parcelRegister("8zaiw", function(module, exports) {

$parcel$export(module.exports, "OpsAgentAvatar", () => $ffd70be6cbe5d6d1$export$957c6b1be4b93dae);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $ffd70be6cbe5d6d1$export$957c6b1be4b93dae = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_36391",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_36391)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M25.025 10.3877C25.9578 10.8278 26.7509 11.4073 27.3127 12.0251L27.3208 11.9732C29.4821 12.9519 31.2187 14.8436 32.251 17.0333C31.7886 16.9895 30.8021 16.2979 30.4096 16.4647C27.517 15.2974 31.6112 17.9955 32.8155 17.9026L32.8075 17.8944C32.8075 17.8944 33.0682 17.9163 33.0521 17.9436C34.1435 16.6341 34.1489 10.6063 32.88 15.9671C32.5306 15.2372 31.8263 14.0207 31.5413 13.6954C30.9203 13.258 30.837 12.6812 30.1004 12.4188C30.1004 12.4188 30.2456 12.3833 30.2482 12.3805C28.517 10.6583 25.7643 8.83491 23.283 8.42759C23.3314 8.55607 24.4094 9.00988 24.5061 9.08915C23.7669 9.21764 20.6673 8.11595 22.8287 8.35924C22.0545 7.71683 16.3984 8.03121 17.8931 8.55882C17.635 8.62716 16.5678 9.05908 17.1055 8.63809C15.2479 8.27177 8.4896 14.1246 10.4789 14.6577C10.7773 14.0289 11.6429 13.638 11.8284 13.1214C11.7343 12.9163 11.6752 12.7988 11.8768 12.6785C12.5569 13.1542 13.4064 11.1476 13.7478 11.041C13.8715 11.5112 16.6699 9.15476 16.2398 9.92019C18.9899 9.33791 22.361 9.0208 25.0304 10.3795L25.025 10.3877Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M37.891 25.7265C37.9582 24.9829 35.9286 21.5029 35.9636 23.0256C35.9582 23.2497 36.4663 24.4799 36.6571 24.7943C36.8749 24.8025 37.0039 24.7997 37.0093 25.0294C36.2996 25.434 37.4018 26.7871 37.3346 27.394C36.8749 30.6881 33.7834 37.1041 28.8746 36.7843C28.6381 36.7624 27.9069 37.0795 27.6838 37.0412C25.6434 37.2791 20.6218 35.9477 24.6649 34.8406C26.0036 33.471 21.5815 35.3436 21.1433 35.8548C21.5788 38.1292 25.0574 41.0762 22.517 36.8799C23.888 37.6672 25.009 38.3397 26.5547 38.173C28.294 38.9822 32.2591 37.9433 33.856 36.2949C33.7511 36.2785 32.743 36.7979 32.6382 36.8225C33.0844 36.109 35.4985 34.5672 34.1974 35.9888C37.4259 33.0801 38.3507 30.248 37.8883 25.721L37.891 25.7265Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16.4496 34.3539C16.2695 34.2911 15.0356 34.3376 14.7507 34.4114C14.6781 34.6137 14.6485 34.7476 14.4496 34.6738C14.0759 33.7771 12.3474 34.6738 11.7533 33.9849C9.4817 33.0308 4.0219 29.3267 5.65635 25.3273C5.56764 23.3809 6.5784 21.3962 7.9279 19.9856C8.34189 19.3268 8.05963 21.5794 8.43329 21.6668C8.75857 24.8434 9.21289 19.8161 8.5704 18.8429C8.5704 18.8429 8.46824 18.5996 8.5005 18.5996C6.51389 18.2661 2.38206 20.8085 6.78809 19.6822C5.85258 20.7401 5.10256 21.5028 4.90901 22.897C3.77457 24.1572 3.61327 28.1457 4.9332 29.8707C4.93857 29.6875 4.66708 28.646 4.68321 28.6542C5.2558 29.1873 6.25584 31.6202 5.15903 30.2343C5.54345 33.0418 15.9093 37.4813 16.4496 34.3512V34.3539Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.9559 13.5099H24.9163C28.3336 13.5099 31.1058 16.282 31.1058 19.6993C31.1058 23.1166 28.3336 25.8887 24.9163 25.8887H17.489C15.8966 25.8887 14.6006 27.1789 14.6006 28.7771C14.6006 30.3753 15.8908 31.6655 17.489 31.6655H29.4494V34.9665H17.489C14.0718 34.9665 11.2996 32.1944 11.2996 28.7771C11.2996 25.3599 14.0718 22.5877 17.489 22.5877H24.9163C26.5087 22.5877 27.8047 21.2975 27.8047 19.6993C27.8047 18.1011 26.5146 16.8109 24.9163 16.8109H12.9559V13.5099Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.956 20.0713C15.6906 20.0713 17.9075 17.8544 17.9075 15.1197C17.9075 12.3851 15.6906 10.1682 12.956 10.1682C10.2213 10.1682 8.00443 12.3851 8.00443 15.1197C8.00443 17.8544 10.2213 20.0713 12.956 20.0713Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M34 28.7539H24.9222V37.8317H34V28.7539Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17.6344 13.5099C17.8088 14.0155 17.9017 14.5502 17.9017 15.1139C17.9017 15.7125 17.7971 16.2821 17.5995 16.8109H12.956V13.5099H17.6344Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17.9017 15.1139C17.9017 15.7125 17.7971 16.2821 17.5995 16.8109H12.956V13.5099H17.6344C17.8088 14.0155 17.9017 14.5502 17.9017 15.1139Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M28.5836 37.1227V34.9608H24.9223V31.6597H28.5836V29.4978L32.3903 33.3103L28.5836 37.1227Z",
        fill: primaryColor
    }));

});

parcelRegister("3oTAZ", function(module, exports) {

$parcel$export(module.exports, "PitchPerfectorAvatar", () => $82686e5f6ebe08b5$export$89900ca53820ce0b);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $82686e5f6ebe08b5$export$89900ca53820ce0b = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_38623",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_38623)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.66037 32.0813C9.6521 32.0728 9.63839 32.0653 9.62931 32.0514C9.42188 32.3069 9.06094 32.2027 8.80197 32.3575C8.82774 32.4079 8.79189 32.3648 8.79189 32.3648C8.66918 32.5797 8.37737 32.6279 8.37621 32.6295C7.8259 32.9375 7.01741 33.2111 6.44789 33.6049L6.45732 33.6117L6.45897 33.6227C6.5459 33.6615 6.33192 33.7347 6.34904 33.6814C5.95847 33.7235 5.26998 34.0235 5.0066 34.3066C5.04377 34.3676 4.97309 34.4087 4.97286 34.3794C4.77124 34.2936 1.94854 35.4363 2.86634 35.7021L2.88103 35.7809C3.06517 35.7323 3.21698 35.6918 3.45381 35.7424C3.47274 35.7196 3.48301 35.732 3.45005 35.6618C3.45229 35.6488 4.38093 35.3287 4.38258 35.3397C4.49765 35.4817 4.92461 35.1157 4.92461 35.1157C5.97063 35.2679 7.14661 33.9377 8.22811 33.9916L8.2072 33.9643C8.21662 33.9711 8.23242 33.9461 8.25571 33.9801C8.29707 33.8374 8.4891 33.6558 8.4891 33.6558C8.4891 33.6558 9.14669 33.3455 9.22082 33.0587L9.88582 32.8438C9.88582 32.8438 10.1227 32.6632 10.1424 32.4975C10.156 32.393 10.145 32.2828 10.1103 32.1919C10.0433 32.0068 9.88868 31.8993 9.66467 32.082L9.66037 32.0813Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5.01187 24.6324C5.0075 24.6219 4.99766 24.6123 4.99245 24.5964C4.92929 24.6964 4.8336 24.6828 4.74253 24.6629C4.65188 24.6456 4.55868 24.6022 4.47306 24.6275C4.48172 24.6849 4.48128 24.7284 4.47286 24.7004L4.46644 24.63C4.36243 24.7929 4.272 24.5641 4.17185 24.8173L4.18121 24.7219C3.79832 24.7964 3.26318 24.6676 2.79831 24.736L2.79996 24.7469L2.79732 24.7572C2.83109 24.8329 3.02012 24.9557 3.02012 24.9557C2.83011 25.2896 2.69752 24.9109 2.53522 24.9097L2.54773 24.8166C2.61764 24.8261 2.68366 24.7914 2.71458 24.7554C2.48315 24.6018 1.96875 24.527 1.7041 24.6534C1.7035 24.7235 1.79593 24.5766 1.79272 24.8054C1.73066 24.8017 1.66379 24.8309 1.60405 24.824C1.61649 24.6749 1.64696 24.7287 1.65689 24.7018C1.61485 24.6177 1.05706 24.4871 0.54749 24.5278C0.420798 24.5404 0.300397 24.5574 0.19527 24.5832C0.0893982 24.6133 0.00153942 24.6516 -0.0632643 24.6945C-0.191302 24.7815 -0.207962 24.8935 -0.0636331 25.035L-0.0672793 25.1126C0.0627909 25.1318 0.172114 25.1431 0.310164 25.28C0.327605 25.2659 0.330074 25.2823 0.32671 25.2044C0.330515 25.1926 0.338138 25.1689 0.33476 25.1373C0.321927 24.9503 0.367765 25.0226 0.386444 25.0167C0.389988 25.3088 0.489151 25.3177 0.5971 25.255C0.70546 25.1951 0.829285 25.071 0.858619 25.0801C0.864399 25.3593 0.970279 25.0883 1.00206 25.2064C0.999411 25.2166 0.982355 25.2796 0.979707 25.2899C0.997915 25.4662 1.53324 24.994 1.36628 25.3325C1.89714 25.9424 3.03462 25.3945 3.71335 25.91L3.7084 25.8772C3.71278 25.8876 3.73137 25.872 3.73442 25.9107C3.80957 25.7974 3.99109 25.7128 3.99109 25.7128C4.05474 25.6715 4.11872 25.6231 4.18154 25.5763C4.18154 25.5763 4.26524 25.6031 4.36664 25.599C4.46647 25.5937 4.58276 25.5493 4.63287 25.4275C4.79956 25.4392 4.96758 25.4227 5.1384 25.4155C5.1384 25.4155 5.32661 25.292 5.3398 25.1385C5.34917 25.0431 5.33738 24.9372 5.31204 24.8433C5.25591 24.6565 5.151 24.517 5.0146 24.6319L5.01187 24.6324Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5.78216 17.4541C5.78324 17.4427 5.26329 17.1181 4.96465 17.047C4.94909 17.1014 4.95176 17.0449 4.95176 17.0449C4.712 17.1139 4.46519 16.9418 4.46404 16.9434C3.84941 16.7787 3.06767 16.405 2.37774 16.2878L2.37667 16.2992L2.37088 16.3072C2.40829 16.3976 2.20187 16.2987 2.25121 16.2737C1.93751 16.0286 1.22764 15.7606 0.836083 15.7776C0.821433 15.8473 0.741695 15.8283 0.75947 15.8071C0.672761 15.6029 -2.17964 14.4366 -1.70076 15.2763L-1.74507 15.3439C-1.57734 15.4366 -1.4382 15.5159 -1.30232 15.7218C-1.27191 15.7196 -1.27372 15.7353 -1.24701 15.6622C-1.23577 15.6534 -0.33734 16.0779 -0.344285 16.0874C-0.359962 16.2707 0.529727 16.0538 0.206027 16.3075C0.859777 17.1576 3.40002 17.7928 3.40002 17.7928C3.40324 17.8049 3.8196 17.767 3.8196 17.767L4.11663 17.7347C4.11663 17.7347 4.51403 18.0066 4.7687 17.8511L5.40172 18.1654C5.40172 18.1654 5.69929 18.2017 5.83147 18.0958C5.91364 18.029 5.98274 17.9406 6.0226 17.8528C6.10422 17.6712 6.06644 17.4855 5.77439 17.4581L5.78216 17.4541Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.0711814 25.4932C0.0755581 25.5037 0.0853788 25.5133 0.0905801 25.5292C0.153749 25.4292 0.249438 25.4428 0.340501 25.4628C0.431153 25.48 0.524374 25.5234 0.609998 25.4981C0.601338 25.4407 0.601751 25.3972 0.610172 25.4252L0.616593 25.4956C0.720607 25.3327 0.811031 25.5615 0.911188 25.3083L0.90182 25.4037C1.28472 25.3292 1.81985 25.458 2.28473 25.3896L2.28309 25.3787L2.28574 25.3684C2.25196 25.2928 2.06291 25.1699 2.06291 25.1699C2.25293 24.836 2.38553 25.2147 2.54784 25.2159L2.53533 25.309C2.46542 25.2995 2.39937 25.3343 2.36846 25.3702C2.59988 25.5238 3.1143 25.5986 3.37896 25.4722C3.37956 25.4021 3.28712 25.549 3.29034 25.3202C3.3524 25.3239 3.41926 25.2947 3.47901 25.3016C3.46657 25.4508 3.43609 25.397 3.42617 25.4238C3.4682 25.5079 4.02597 25.6385 4.53554 25.5978C4.66224 25.5853 4.78266 25.5682 4.88779 25.5424C4.99366 25.5123 5.08151 25.474 5.14632 25.4311C5.27436 25.3441 5.291 25.2321 5.14667 25.0907L5.15033 25.013C5.02026 24.9939 4.91094 24.9825 4.77289 24.8456C4.75545 24.8597 4.75296 24.8433 4.75632 24.9212C4.75252 24.933 4.74492 24.9567 4.7483 24.9884C4.76113 25.1753 4.71529 25.1031 4.69661 25.109C4.69307 24.8168 4.5939 24.808 4.48596 24.8706C4.3776 24.9305 4.25375 25.0546 4.22442 25.0455C4.21864 24.7663 4.11278 25.0373 4.081 24.9193C4.08364 24.909 4.10068 24.846 4.10333 24.8357C4.08512 24.6595 3.54979 25.1317 3.71675 24.7931C3.71675 24.7931 0.962768 24.5014 0.901517 24.5493C0.901517 24.5493 0.817815 24.5225 0.716413 24.5267C0.616582 24.5319 0.500279 24.5763 0.45016 24.6981C0.283478 24.6864 0.115473 24.7029 -0.0553473 24.7101C-0.0553473 24.7101 -0.243559 24.8337 -0.256747 24.9871C-0.266116 25.0825 -0.254329 25.1884 -0.228988 25.2823C-0.172851 25.4691 -0.0679416 25.6087 0.0684515 25.4937L0.0711814 25.4932Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M32.1917 32.0813C32.1999 32.0728 32.2137 32.0653 32.2227 32.0514C32.4302 32.3069 32.7911 32.2027 33.0501 32.3575C33.0243 32.4079 33.0602 32.3648 33.0602 32.3648C33.1829 32.5797 33.4747 32.6279 33.4758 32.6295C34.0262 32.9375 34.8346 33.2111 35.4042 33.6049L35.3947 33.6117L35.3931 33.6227C35.3062 33.6615 35.5201 33.7347 35.503 33.6814C35.8936 33.7235 36.5821 34.0235 36.8454 34.3066C36.8083 34.3676 36.879 34.4087 36.8792 34.3794C37.0808 34.2936 39.9035 35.4363 38.9857 35.7021L38.971 35.7809C38.7869 35.7323 38.6351 35.6918 38.3982 35.7424C38.3793 35.7196 38.369 35.732 38.402 35.6618C38.3998 35.6488 37.4711 35.3287 37.4695 35.3397C37.3544 35.4817 36.9274 35.1157 36.9274 35.1157C35.8814 35.2679 34.7054 33.9377 33.6239 33.9916L33.6448 33.9643C33.6354 33.9711 33.6196 33.9461 33.5963 33.9801C33.555 33.8374 33.3629 33.6558 33.3629 33.6558C33.3629 33.6558 32.7054 33.3455 32.6312 33.0587L31.9662 32.8438C31.9662 32.8438 31.7293 32.6632 31.7096 32.4975C31.696 32.393 31.707 32.2828 31.7417 32.1919C31.8088 32.0068 31.9634 31.8993 32.1874 32.082L32.1917 32.0813Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M36.8402 24.6324C36.8446 24.6219 36.8544 24.6123 36.8596 24.5964C36.9228 24.6964 37.0185 24.6828 37.1095 24.6629C37.2002 24.6456 37.2934 24.6022 37.379 24.6275C37.3703 24.6849 37.3708 24.7284 37.3792 24.7004L37.3856 24.63C37.4896 24.7929 37.58 24.5641 37.6802 24.8173L37.6708 24.7219C38.0537 24.7964 38.5889 24.6676 39.0537 24.736L39.0521 24.7469L39.0547 24.7572C39.021 24.8329 38.8319 24.9557 38.8319 24.9557C39.0219 25.2896 39.1545 24.9109 39.3168 24.9097L39.3043 24.8166C39.2344 24.8261 39.1684 24.7914 39.1375 24.7554C39.3689 24.6018 39.8833 24.527 40.148 24.6534C40.1486 24.7235 40.0561 24.5766 40.0593 24.8054C40.1214 24.8017 40.1883 24.8309 40.248 24.824C40.2356 24.6749 40.2051 24.7287 40.1952 24.7018C40.2372 24.6177 40.795 24.4871 41.3046 24.5278C41.4313 24.5404 41.5517 24.5574 41.6568 24.5832C41.7627 24.6133 41.8505 24.6516 41.9153 24.6945C42.0434 24.7815 42.06 24.8935 41.9157 25.035L41.9193 25.1126C41.7893 25.1318 41.6799 25.1431 41.5419 25.28C41.5244 25.2659 41.522 25.2823 41.5253 25.2044C41.5215 25.1926 41.5139 25.1689 41.5173 25.1373C41.5301 24.9503 41.4843 25.0226 41.4656 25.0167C41.4621 25.3088 41.3629 25.3177 41.255 25.255C41.1466 25.1951 41.0228 25.071 40.9934 25.0801C40.9877 25.3593 40.8818 25.0883 40.85 25.2064C40.8526 25.2166 40.8697 25.2796 40.8723 25.2899C40.8541 25.4662 40.3188 24.994 40.4858 25.3325C39.9549 25.9424 38.8174 25.3945 38.1387 25.91L38.1437 25.8772C38.1393 25.8876 38.1207 25.872 38.1176 25.9107C38.0425 25.7974 37.861 25.7128 37.861 25.7128C37.7973 25.6715 37.7333 25.6231 37.6705 25.5763C37.6705 25.5763 37.5868 25.6031 37.4854 25.599C37.3856 25.5937 37.2693 25.5493 37.2192 25.4275C37.0525 25.4392 36.8845 25.4227 36.7136 25.4155C36.7136 25.4155 36.5254 25.292 36.5122 25.1385C36.5029 25.0431 36.5147 24.9372 36.54 24.8433C36.5961 24.6565 36.7011 24.517 36.8374 24.6319L36.8402 24.6324Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M36.0699 17.4541C36.0688 17.4427 36.5888 17.1181 36.8874 17.047C36.903 17.1014 36.9003 17.0449 36.9003 17.0449C37.14 17.1139 37.3869 16.9418 37.388 16.9434C38.0026 16.7787 38.7844 16.405 39.4743 16.2878L39.4754 16.2992L39.4812 16.3072C39.4438 16.3976 39.6502 16.2987 39.6008 16.2737C39.9145 16.0286 40.6244 15.7606 41.016 15.7776C41.0306 15.8473 41.1104 15.8283 41.0926 15.8071C41.1793 15.6029 44.0317 14.4366 43.5528 15.2763L43.5971 15.3439C43.4294 15.4366 43.2902 15.5159 43.1544 15.7218C43.124 15.7196 43.1258 15.7353 43.0991 15.6622C43.0878 15.6534 42.1894 16.0779 42.1963 16.0874C42.212 16.2707 41.3223 16.0538 41.646 16.3075C40.9923 17.1576 38.452 17.7928 38.452 17.7928C38.4488 17.8049 38.0324 17.767 38.0324 17.767L37.7354 17.7347C37.7354 17.7347 37.338 18.0066 37.0834 17.8511L36.4503 18.1654C36.4503 18.1654 36.1528 18.2017 36.0206 18.0958C35.9384 18.029 35.8693 17.9406 35.8295 17.8528C35.7478 17.6712 35.7856 17.4855 36.0777 17.4581L36.0699 17.4541Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M41.7809 25.4932C41.7765 25.5037 41.7667 25.5133 41.7615 25.5292C41.6983 25.4292 41.6026 25.4428 41.5116 25.4628C41.4209 25.48 41.3277 25.5234 41.2421 25.4981C41.2507 25.4407 41.2503 25.3972 41.2419 25.4252L41.2355 25.4956C41.1315 25.3327 41.041 25.5615 40.9409 25.3083L40.9502 25.4037C40.5673 25.3292 40.0322 25.458 39.5673 25.3896L39.569 25.3787L39.5663 25.3684C39.6001 25.2928 39.7892 25.1699 39.7892 25.1699C39.5991 24.836 39.4665 25.2147 39.3042 25.2159L39.3167 25.309C39.3866 25.2995 39.4527 25.3343 39.4836 25.3702C39.2522 25.5238 38.7378 25.5986 38.4731 25.4722C38.4725 25.4021 38.5649 25.549 38.5617 25.3202C38.4997 25.3239 38.4328 25.2947 38.3731 25.3016C38.3855 25.4508 38.416 25.397 38.4259 25.4238C38.3839 25.5079 37.8261 25.6385 37.3165 25.5978C37.1898 25.5853 37.0694 25.5682 36.9643 25.5424C36.8584 25.5123 36.7706 25.474 36.7057 25.4311C36.5777 25.3441 36.5611 25.2321 36.7054 25.0907L36.7017 25.013C36.8318 24.9939 36.9411 24.9825 37.0792 24.8456C37.0966 24.8597 37.0991 24.8433 37.0957 24.9212C37.0995 24.933 37.1071 24.9567 37.1038 24.9884C37.0909 25.1753 37.1368 25.1031 37.1555 25.109C37.159 24.8168 37.2582 24.808 37.3661 24.8706C37.4745 24.9305 37.5983 25.0546 37.6276 25.0455C37.6334 24.7663 37.7393 25.0373 37.7711 24.9193C37.7684 24.909 37.7514 24.846 37.7487 24.8357C37.7669 24.6595 38.3023 25.1317 38.1353 24.7931C38.1353 24.7931 40.8893 24.5014 40.9505 24.5493C40.9505 24.5493 41.0343 24.5225 41.1357 24.5267C41.2355 24.5319 41.3518 24.5763 41.4019 24.6981C41.5686 24.6864 41.7366 24.7029 41.9074 24.7101C41.9074 24.7101 42.0956 24.8337 42.1088 24.9871C42.1182 25.0825 42.1064 25.1884 42.0811 25.2823C42.0249 25.4691 41.92 25.6087 41.7836 25.4937L41.7809 25.4932Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M33.2675 11.7762H8.72812V26.8525H33.2675V11.7762Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M31.2419 36.9981L22.75 23.1381H19.25L10.7581 36.9981L13.7419 38.8268L19.25 29.8362V37.9124H22.75V29.8362L28.2581 38.8268L31.2419 36.9981Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M25.025 26.8568H16.975L19.25 23.1425H22.75L25.025 26.8568Z",
        fill: primaryColor
    }));

});

parcelRegister("3ptGp", function(module, exports) {

$parcel$export(module.exports, "ProductRequirementAvatar", () => $cb8d32210f2d7769$export$96348a0fd479c23f);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $cb8d32210f2d7769$export$96348a0fd479c23f = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_602_29348",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_602_29348)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M37 35.9716C35.7885 34.4863 32.8225 32.1398 31.2873 30.7577C31.3918 30.2472 27.5902 29.0198 29.0053 28.9476C27.4596 26.6424 24.1646 24.5486 21.1412 22.3774C22.3892 20.263 23.8827 17.6742 24.196 16.0652C25.021 15.467 34.3682 -0.721128 30.739 2.39891L30.6137 2.20294C29.0158 4.0337 27.538 7.0042 26.5301 9.51055C25.8252 9.25269 23.867 14.9771 23.6947 13.3835C21.9976 15.1111 20.4676 17.8289 18.9585 20.7324C16.2483 18.2002 15.6426 17.3596 12.9376 16.3488C12.9376 16.3488 11.4024 14.6316 10.3058 14.4975C8.82801 13.2649 8.21714 11.79 6.0814 11.2536C4.50962 11.3568 4.79155 12.2335 6.02913 13.399C7.38681 14.0901 8.03439 15.4979 9.23019 16.4159C9.45473 16.1426 9.44943 16.3488 9.27711 16.452C10.2954 16.8078 10.3737 17.6794 11.5016 17.767C11.5016 17.767 11.2614 17.8908 11.2562 17.8908C13.1622 19.3606 15.4807 21.3718 17.7626 23.0479C16.1073 26.2865 14.4311 29.4994 12.5565 31.619H12.6556C12.6086 31.6499 12.5774 31.7995 12.4677 31.7789C12.2275 33.3982 11.7314 34.2388 11.4286 35.4816C11.4286 35.4816 9.77328 37.8075 9.76806 39.0916L7.51741 42.7222C6.47304 44.2074 6.89075 48.3022 9.17792 44.2796C9.71055 42.5107 11.1309 41.2885 11.9455 39.6279C11.6322 39.4784 11.8359 39.401 11.9769 39.5609C12.2275 38.3026 13.1413 37.9157 13.1048 36.6213C14.9846 34.4863 17.6425 28.5712 19.4702 25.1417C19.2926 25.2139 19.794 24.4506 19.7679 24.4454C19.7679 24.4454 19.7731 24.4352 19.7783 24.43C19.794 24.4403 19.8097 24.4506 19.8254 24.4609C19.8254 24.4403 19.8305 24.4197 19.8514 24.4094C19.8514 24.3991 20.5668 24.8013 20.3579 24.7703C21.6372 26.1628 24.598 28.4422 26.2534 29.2003C26.3317 29.025 26.666 29.2467 26.5824 29.2776C26.1229 29.1796 37.8459 39.2876 36.8015 36.0799L37 35.9767V35.9716Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.41632 37H29.3148V11H19.2549L9.41632 20.6911V37Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.259 11V20.6624H9.44501L19.259 11Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M35 21.313L23.133 33.7411L16.9966 27.1391L19.6412 24.4436L23.1684 28.2389L32.3908 18.5804L35 21.313Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.3147 21.8019L23.1684 28.2389L19.6412 24.4436L16.9966 27.1391L23.133 33.7411L29.3147 27.2671V21.8019Z",
        fill: "#101214"
    }));

});

parcelRegister("7zNkv", function(module, exports) {

$parcel$export(module.exports, "ReleaseNotesAvatar", () => $1c4302bcb883b38a$export$c581761a1d98823f);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $1c4302bcb883b38a$export$c581761a1d98823f = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_36603",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_36603)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M57.9155 20.7534C54.2909 19.0242 56.2884 14.5907 48.2281 18.687C48.3336 18.7485 48.1249 18.9193 48.1343 18.7439C46.737 19.719 45.75 20.0676 44.2167 20.5962C44.2167 20.5962 44.3691 20.4594 44.3714 20.4572C42.4536 21.0085 41.8839 19.7099 41.2931 18.1972C37.0754 14.1647 32.2551 22.0884 27.8405 20.284C28.3164 20.9402 29.8052 20.7989 30.5788 20.6463C27.2427 22.2069 27.6131 19.3431 26.0142 17.7506C26.7222 17.6549 27.1606 19.1836 27.3997 19.6165C25.5476 13.5655 18.8072 20.038 15.2413 20.6189C15.4288 20.6918 16.2775 20.3478 16.5002 20.5232C16.0313 20.8171 13.4759 20.9493 14.7349 20.7101C13.8627 20.644 13.1899 20.5004 12.9812 19.4228C10.4609 12.8911 3.33366 21.9836 -0.881711 20.3524C-1.71869 19.1426 -2.06567 16.7892 -4.20853 17.4088C-4.1757 17.6048 -3.44423 17.6025 -3.2004 17.7757C-3.26605 17.7893 -3.32935 17.8007 -3.39031 17.8167C-1.48425 18.2199 -2.55332 21.1384 -0.412816 21.3639C0.126414 21.3662 0.199091 20.9515 0.815689 21.0746C3.30084 21.8423 5.93133 18.3885 8.44227 18.1561C8.41414 18.1766 8.243 18.2951 8.2219 18.3179C9.48323 17.9625 12.1723 17.5934 12.2872 19.6598C12.4115 20.0699 12.3458 20.0402 12.1302 19.6484C14.6786 25.4146 21.0814 17.4385 25.1772 18.3657C29.355 26.2553 33.8259 17.5342 39.6356 18.5822C39.6285 18.5639 39.6168 18.548 39.6051 18.5321C40.8289 18.9353 40.6742 20.9083 41.9847 21.3206C46.6385 23.2184 50.7015 15.7435 54.8536 18.753C55.3154 19.5345 55.85 21.2477 57.1066 21.1657C57.6693 21.1498 58.2202 21.0154 57.9108 20.7534H57.9155Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M57.0011 25.8543C53.3765 24.1251 55.3741 19.6916 47.3137 23.7879C47.4192 23.8494 47.2106 24.0203 47.2199 23.8449C45.8226 24.82 44.8356 25.1686 43.3023 25.6971C43.3023 25.6971 43.4547 25.5604 43.4571 25.5581C41.5393 26.1095 40.9696 24.8109 40.3788 23.2981C36.1611 19.2656 31.3408 27.1893 26.9262 25.385C27.4021 26.0411 28.8908 25.8999 29.6645 25.7472C26.3283 27.3078 26.6987 24.4441 25.0998 22.8516C25.8078 22.7559 26.2463 24.2846 26.4854 24.7175C24.6333 18.6664 17.8929 25.139 14.3269 25.7199C14.5145 25.7928 15.3632 25.4488 15.5859 25.6242C15.117 25.9181 12.5615 26.0502 13.8205 25.811C12.9484 25.745 12.2755 25.6015 12.0669 24.5238C9.54654 17.9921 2.41932 27.0846 -1.79605 25.4533C-2.63303 24.2436 -2.98001 21.8902 -5.12286 22.5098C-5.09004 22.7058 -4.35857 22.7035 -4.11474 22.8766C-4.18039 22.8903 -4.24369 22.9017 -4.30464 22.9177C-2.39858 23.3209 -3.46766 26.2393 -1.32715 26.4649C-0.787923 26.4671 -0.715246 26.0525 -0.0986485 26.1756C2.3865 26.9411 5.01701 23.4895 7.52795 23.2571C7.49981 23.2776 7.32865 23.3961 7.30755 23.4189C8.56654 23.0635 11.258 22.6944 11.3729 24.7607C11.4971 25.1708 11.4315 25.1412 11.2158 24.7494C13.7643 30.5156 20.167 22.5395 24.2628 23.4667C28.4407 31.3563 32.9116 22.6351 38.7212 23.6831C38.7142 23.6649 38.7025 23.649 38.6907 23.633C39.9146 24.0363 39.7598 26.0092 41.0704 26.4216C45.7242 28.3194 49.7872 20.8444 53.9392 23.854C54.4011 24.6354 54.9356 26.3487 56.1923 26.2667C56.7549 26.2507 57.3059 26.1163 56.9964 25.8543H57.0011Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M26.9941 30.9052C24.1995 30.1853 26.3518 25.5034 20.1553 27.9617C20.1553 27.9617 20.2209 27.8227 20.2209 27.8204C17.5951 28.57 14.0456 32.279 11.3471 30.2468C11.2346 30.5703 11.9684 31.0738 12.3224 31.092C10.7563 31.4041 11.0306 29.7045 10.5218 28.7158C10.8805 28.7317 10.9251 29.5929 11.1384 29.7911C10.7586 25.3303 3.56813 28.4675 5.06391 28.4561C4.7521 28.5973 3.46732 29.381 4.06516 28.8274C0.45701 30.3379 -2.22742 32.8235 -4.15927 28.0004C-4.68678 27.4332 -7.00079 27.5379 -5.50267 27.9594L-5.60581 28.0392C-3.85917 28.2852 -4.47812 29.3127 -3.59894 30.2741C-4.19912 32.1104 -0.609741 31.5249 0.344461 31.3198C-0.295581 32.181 3.60798 29.5519 2.93745 30.3037C13.6494 24.6377 6.86212 35.7761 17.7452 30.5748L17.6936 30.5589C19.8482 28.8138 24.3824 26.515 25.0225 30.7776C25.2194 31.6958 28.0984 31.7596 26.9895 30.9052H26.9941Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.4518 34.4737V13.4956H12.715V34.4737H28.4518ZM16.6525 19.4106H24.5187V17.4419H16.6525V19.4106ZM16.6525 24.3106H20.5856V22.3419H16.6525V24.3106ZM20.5856 29.2719H16.6525V27.3031H20.5856V29.2719Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M38.3644 24.0044L32.2831 17.91V21.3707H23V27.2113H32.2831V30.0857L38.3644 24.0044Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.8125 21.375V27.2156H28.4518V21.375H22.8125Z",
        fill: "#164B35"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M22.8125 21.375V27.2156H28.4518V21.375H22.8125Z",
        fill: primaryColor
    }));

});

parcelRegister("lLzmU", function(module, exports) {

$parcel$export(module.exports, "ResearchScoutAvatar", () => $727ce7a9982a2700$export$5b23e1bc88738494);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $727ce7a9982a2700$export$5b23e1bc88738494 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_36507",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_36507)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M24.4463 11.0851C24.2842 11.0342 24.8953 6.66708 25.6794 5.05429C25.214 4.53564 24.9686 3.51338 25.2376 2.60969C23.3643 0.0930822 23.604 5.10354 23.7107 6.67045C24.36 5.84105 23.402 8.14889 23.6078 8.61284C23.6433 8.40279 22.9772 12.6138 24.0463 11.7228C24.1108 11.8796 24.6752 11.0305 24.4486 11.0876L24.4463 11.0851Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M34.7749 9.62623C34.8599 8.67744 35.4555 8.03786 36.282 7.51077C36.7283 4.27819 32.9755 8.45022 32.0793 9.47383C32.0793 9.47383 30.4663 11.2367 30.5232 10.9755C30.0737 11.0089 27.0189 13.2024 28.5477 13.6027C29.1004 13.2848 29.7974 12.2938 30.2622 12.4522C31.3683 12.5512 33.3234 10.0611 34.7751 9.62147L34.7749 9.62623Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M40.0248 20.0843C41.0507 18.2865 36.9152 18.5769 35.4287 18.1889C35.4287 18.1889 33.9085 17.7033 33.4188 17.8368C33.6396 17.9081 28.1592 16.5002 30.714 18.428C30.7975 18.4262 32.694 18.9166 32.694 18.9166C34.9809 20.2763 37.7615 20.3387 40.0272 20.0821L40.0248 20.0843Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M25.0381 28.0381C21.3544 31.7218 15.3562 31.7218 11.6681 28.0381C7.98437 24.3543 7.98437 18.3562 11.6681 14.6681C15.3519 10.9843 21.35 10.9843 25.0381 14.6681C28.7262 18.3518 28.7219 24.35 25.0381 28.0381ZM14.0744 17.0743C11.7162 19.4325 11.7162 23.2737 14.0744 25.6318C16.4325 27.99 20.2737 27.99 22.6319 25.6318C24.99 23.2737 24.99 19.4325 22.6319 17.0743C20.2737 14.7162 16.4325 14.7162 14.0744 17.0743Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M24.9119 24.3962L21.4007 27.9075L29.5832 36.09L33.0944 32.5788L24.9119 24.3962Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M21.3981 27.9068L23.0519 29.5606C23.765 29.1537 24.4344 28.6462 25.0425 28.0381C25.6506 27.4299 26.1581 26.7606 26.565 26.0474L24.9112 24.3937L21.3981 27.9068Z",
        fill: primaryColor
    }));

});

parcelRegister("89yuV", function(module, exports) {

$parcel$export(module.exports, "SocialMediaScribeAvatar", () => $1721a74f1671a422$export$538286cb30d86972);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $1721a74f1671a422$export$538286cb30d86972 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_36095",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_36095)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M48.6709 34.1188C42.9117 36.4894 35.3817 38.733 29.4937 35.0081C32.969 32.6026 35.7299 28.9433 37.9132 25.4171L37.7643 25.6035C41.4508 20.1473 42.8835 8.15902 33.8403 7.81275C38.3076 -5.34542 33.8665 -13.1067 22.493 -0.886975C14.3654 8.61183 7.40888 22.2781 7.84353 35.1781C-8.66328 40.8598 -0.618129 15.5433 1.67387 8.36391C1.35794 8.68149 0.943409 10.0768 0.367895 11.593L0.472513 11.005C-1.30635 16.8485 -3.3307 22.8272 -2.9544 28.8429C-2.92623 29.0785 -2.8699 29.4699 -2.84374 29.3654C-2.59622 29.6235 -2.4634 31.5741 -2.22796 32.0125C-1.82148 36.9341 3.9538 37.7209 7.94014 35.9158C9.92023 47.5905 23.2094 39.5997 28.7935 35.506C33.6069 38.7699 39.9758 38.1593 45.1615 36.1227C46.1676 35.801 50.168 33.7398 48.6669 34.1168L48.6709 34.1188ZM8.74506 32.029C8.81549 30.6582 8.99457 29.3059 9.23604 27.9864L9.20585 28.0909V28.0417C8.79937 29.7731 8.42108 32.7748 8.61627 34.8749C8.55389 34.9015 8.48948 34.9282 8.42509 34.9528C7.90994 28.8142 10.1577 22.6859 12.3873 17.0821L12.4537 17.1702C11.4918 19.467 10.5621 22.2433 10.0913 24.2021C12.0452 17.4201 15.9148 9.28182 20.5572 3.1453C23.7326 -1.37872 35.0819 -12.783 34.5828 -0.23747C34.6915 -0.923859 34.4561 -3.76981 34.1643 -4.7451C35.098 -2.14092 34.7941 0.920172 34.3394 3.57967C34.2025 3.43215 34.5305 1.88726 34.5004 1.69671C34.4923 2.03069 33.8886 5.46264 32.9609 7.82709C24.6723 8.0115 20.8993 17.4488 22.2656 24.5893C18.4221 28.6585 13.9408 32.5105 8.78328 34.8012C8.69876 33.8812 8.69475 32.9489 8.74103 32.029H8.74506ZM23.155 18.3647C23.155 18.3647 23.2074 18.4753 23.2074 18.4794C24.2376 12.9945 27.3567 9.48262 32.639 8.69584C30.4697 14.1747 27.0971 19.2048 23.0162 23.7779C22.8411 22.1491 22.8774 20.4853 23.143 18.8441C23.0665 18.9548 23.0625 18.6372 23.155 18.3647ZM22.324 38.3704C17.6032 41.1753 9.66868 43.3738 8.87382 35.5367C13.8723 33.1518 17.6333 30.1521 21.2937 26.6095C21.2192 26.6976 20.7483 27.257 20.688 27.3287C20.8892 27.175 21.5533 26.5522 22.4487 25.6056C23.1752 29.1851 25.0124 32.6047 27.89 34.8483C26.093 36.1248 24.2417 37.3234 22.324 38.3704ZM28.5621 34.3627C25.5839 32.1027 23.7688 28.5499 23.155 24.8413C26.5719 21.2352 30.3832 15.2852 32.2687 11.2221C32.1922 11.5356 32.0292 11.8778 31.82 12.3818C32.4196 11.2324 32.9911 10.0112 33.5023 8.71427C36.7058 8.44176 39.3379 11.1853 39.5693 14.359C40.3883 21.6143 34.1884 30.3017 28.5621 34.3627Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.4419 16.5931H10.5306V34.5H28.4375V16.5931H28.4419ZM14.3719 22.3506H24.605V20.43H14.3719V22.3506ZM14.3719 26.5069H24.605V24.5863H14.3719V26.5069ZM20.7681 30.6631H14.3719V28.7425H20.7681V30.6631Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M24.9156 22.9018L21 24L22.0981 20.0843L31.8631 10.3193L34.6806 13.1368L24.9156 22.9018Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.5894 16.5931L22.0981 20.0844L22.0019 20.43H24.605V22.3506H21.4638L21 24L24.9156 22.9019L28.4419 19.3756V16.5931H25.5894Z",
        fill: primaryColor
    }));

});

parcelRegister("pHJ36", function(module, exports) {

$parcel$export(module.exports, "TeamConnectionAvatar", () => $88b5807114c63803$export$f08846c34de290e3);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $eUqFw = parcelRequire("eUqFw");
const $88b5807114c63803$export$f08846c34de290e3 = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 42 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_7095_36191",
        style: {
            maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "42",
        height: "48"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
        fill: primaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_7095_36191)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M25.025 10.3877C25.9578 10.8278 26.7509 11.4073 27.3127 12.0251L27.3208 11.9732C29.4821 12.9519 31.2187 14.8436 32.251 17.0333C31.7886 16.9895 30.8021 16.2979 30.4096 16.4647C27.517 15.2974 31.6112 17.9955 32.8155 17.9026L32.8075 17.8944C32.8075 17.8944 33.0682 17.9163 33.0521 17.9436C34.1435 16.6341 34.1489 10.6063 32.88 15.9671C32.5306 15.2372 31.8263 14.0207 31.5413 13.6954C30.9203 13.258 30.837 12.6812 30.1004 12.4188C30.1004 12.4188 30.2456 12.3833 30.2482 12.3805C28.517 10.6583 25.7643 8.83491 23.283 8.42759C23.3314 8.55607 24.4094 9.00988 24.5061 9.08915C23.7669 9.21764 20.6673 8.11595 22.8287 8.35924C22.0545 7.71683 16.3984 8.03121 17.8931 8.55882C17.635 8.62716 16.5678 9.05908 17.1055 8.63809C15.2479 8.27177 8.4896 14.1246 10.4789 14.6577C10.7773 14.0289 11.6429 13.638 11.8284 13.1214C11.7343 12.9163 11.6752 12.7988 11.8768 12.6785C12.5569 13.1542 13.4064 11.1476 13.7478 11.041C13.8715 11.5112 16.6699 9.15476 16.2398 9.92019C18.9899 9.33791 22.361 9.0208 25.0304 10.3795L25.025 10.3877Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M37.891 25.7265C37.9582 24.9829 35.9286 21.5029 35.9636 23.0256C35.9582 23.2497 36.4663 24.4799 36.6571 24.7943C36.8749 24.8025 37.0039 24.7997 37.0093 25.0294C36.2996 25.434 37.4018 26.7871 37.3346 27.394C36.8749 30.6881 33.7834 37.1041 28.8746 36.7843C28.6381 36.7624 27.9069 37.0795 27.6838 37.0412C25.6434 37.2791 20.6218 35.9477 24.6649 34.8406C26.0036 33.471 21.5815 35.3436 21.1433 35.8548C21.5788 38.1292 25.0574 41.0762 22.517 36.8799C23.888 37.6672 25.009 38.3397 26.5547 38.173C28.294 38.9822 32.2591 37.9433 33.856 36.2949C33.7511 36.2785 32.743 36.7979 32.6382 36.8225C33.0844 36.109 35.4985 34.5672 34.1974 35.9888C37.4259 33.0801 38.3507 30.248 37.8883 25.721L37.891 25.7265Z",
        fill: secondaryColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16.4496 34.3539C16.2695 34.2911 15.0356 34.3376 14.7507 34.4114C14.6781 34.6137 14.6485 34.7476 14.4496 34.6738C14.0759 33.7771 12.3474 34.6738 11.7533 33.9849C9.4817 33.0308 4.0219 29.3267 5.65635 25.3273C5.56764 23.3809 6.5784 21.3962 7.9279 19.9856C8.34189 19.3268 8.05963 21.5794 8.43329 21.6668C8.75857 24.8434 9.21289 19.8161 8.5704 18.8429C8.5704 18.8429 8.46824 18.5996 8.5005 18.5996C6.51389 18.2661 2.38206 20.8085 6.78809 19.6822C5.85258 20.7401 5.10256 21.5028 4.90901 22.897C3.77457 24.1572 3.61327 28.1457 4.9332 29.8707C4.93857 29.6875 4.66708 28.646 4.68321 28.6542C5.2558 29.1873 6.25584 31.6202 5.15903 30.2343C5.54345 33.0418 15.9093 37.4813 16.4496 34.3512V34.3539Z",
        fill: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14.9575 15.6919C10.276 15.6919 6.4791 19.4888 6.4791 24.1703C6.4791 27.6996 8.63385 30.7253 11.7004 32V29.9541C11.7004 28.1577 13.1566 26.697 14.9575 26.697C16.7584 26.697 18.21 28.1532 18.21 29.9541V32C21.2766 30.7298 23.4359 27.6996 23.4359 24.1703C23.4359 19.4888 19.639 15.6919 14.9575 15.6919ZM14.9575 25.7852C13.4151 25.7852 12.1677 24.5332 12.1677 22.9954C12.1677 21.4576 13.4151 20.2055 14.9575 20.2055C16.4998 20.2055 17.7428 21.453 17.7428 22.9954C17.7428 24.5377 16.4953 25.7852 14.9575 25.7852Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27.0469 15.6919C22.3654 15.6919 18.5685 19.4888 18.5685 24.1703C18.5685 27.6996 20.7232 30.7253 23.7898 32V29.9541C23.7898 28.1577 25.2459 26.697 27.0469 26.697C28.8478 26.697 30.2994 28.1532 30.2994 29.9541V32C33.366 30.7298 35.5253 27.6996 35.5253 24.1703C35.5253 19.4888 31.7283 15.6919 27.0469 15.6919ZM27.0469 25.7852C25.5045 25.7852 24.257 24.5332 24.257 22.9954C24.257 21.4576 25.5045 20.2055 27.0469 20.2055C28.5892 20.2055 29.8322 21.453 29.8322 22.9954C29.8322 24.5377 28.5847 25.7852 27.0469 25.7852Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M20.9954 18.2322C19.4893 19.7609 18.5639 21.8567 18.5639 24.1702C18.5639 26.4838 19.4939 28.5886 20.9954 30.1174C22.5014 28.5886 23.4314 26.4883 23.4314 24.1702C23.4314 21.8522 22.506 19.7609 20.9954 18.2322Z",
        fill: primaryColor
    }));

});



parcelRegister("920hm", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCreator", () => $f487095b9eea36be$export$f35b2eeaa7e3db15);
$parcel$export(module.exports, "AgentStarCount", () => $f487095b9eea36be$export$65f8fe094f79ae2);
$parcel$export(module.exports, "AgentProfileInfo", () => $f487095b9eea36be$export$e02348ba0b01a210);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hI5oG = parcelRequire("hI5oG");

var $daM3L = parcelRequire("daM3L");

var $45uQ5 = parcelRequire("45uQ5");
var $aFHo6 = parcelRequire("aFHo6");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $hFxJG = parcelRequire("hFxJG");

var $8cU5f = parcelRequire("8cU5f");

var $kfZqf = parcelRequire("kfZqf");

var $cfzU9 = parcelRequire("cfzU9");

var $aj3Jh = parcelRequire("aj3Jh");
const $f487095b9eea36be$var$clickableItemStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050'
});
const $f487095b9eea36be$var$countStyles = (0, $1ZAYh.xcss)({
    fontSize: '11px',
    display: 'flex',
    alignItems: 'center',
    gap: 'space.025'
});
const $f487095b9eea36be$var$nameStyles = (0, $1ZAYh.xcss)({
    justifyContent: 'space-between',
    alignItems: 'flex-start'
});
const $f487095b9eea36be$var$descriptionStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.0',
    marginBottom: 'space.100'
});
const $f487095b9eea36be$export$f35b2eeaa7e3db15 = ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $aj3Jh.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100,
                borderRadius: 3
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM') return formatMessage((0, $aj3Jh.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $45uQ5.AtlassianIcon), {
                size: "small",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, "Atlassian"))
        });
        if (creator.type === 'CUSTOMER') return formatMessage((0, $aj3Jh.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: creator.profileLink,
                onClick: ()=>onCreatorLinkClick(),
                target: "_blank"
            }, creator.name, ' ', creator.status === 'inactive' && formatMessage((0, $aj3Jh.messages).agentDeactivated))
        });
        if (creator.type === 'THIRD_PARTY') return formatMessage((0, $aj3Jh.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f487095b9eea36be$var$clickableItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aFHo6.RovoIcon), {
        appearance: "brand",
        size: "small"
    }), creatorRender) : null;
};
const $f487095b9eea36be$export$65f8fe094f79ae2 = ({ starCount: starCount, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if ((starCount === null || starCount === undefined) && !isLoading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f487095b9eea36be$var$countStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($daM3L))), {
        label: "",
        size: "small"
    }), isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFxJG.default), {
        testId: "agent-profile-info-star-count-skeleton",
        isShimmering: true,
        height: 16,
        width: 75,
        borderRadius: 3
    }) : formatMessage((0, $aj3Jh.messages).starredCount, {
        count: starCount
    }));
};
const $f487095b9eea36be$var$wrapperStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.100'
});
const $f487095b9eea36be$var$tooltipWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    marginInline: 'space.100',
    position: 'relative',
    bottom: 'space.025'
});
const $f487095b9eea36be$var$headingWrapperStyles = (0, $1ZAYh.xcss)({
    position: 'relative'
});
const $f487095b9eea36be$export$e02348ba0b01a210 = ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        xcss: $f487095b9eea36be$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $f487095b9eea36be$var$nameStyles,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f487095b9eea36be$var$headingWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "span",
        size: "xlarge"
    }, agentName), isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f487095b9eea36be$var$tooltipWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $aj3Jh.messages).hiddenTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kfZqf.HiddenIcon), {
        label: formatMessage((0, $aj3Jh.messages).hiddenIcon)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cfzU9.StarIconButton), {
        isStarred: isStarred,
        handleToggle: onStarToggle
    })), creatorRender, !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f487095b9eea36be$var$descriptionStyles,
        as: "p"
    }, agentDescription), starCountRender);
};

});
parcelRegister("45uQ5", function(module, exports) {

$parcel$export(module.exports, "AtlassianIcon", () => $12a88b946c693080$export$8a485e2e7ed91e8f);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $12a88b946c693080$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
};
const $12a88b946c693080$export$8a485e2e7ed91e8f = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $lpzFL.defaultLogoParams).size, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $12a88b946c693080$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});

parcelRegister("hFxJG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6854df9b98f4b182$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");
const $6854df9b98f4b182$var$shimmer = (0, $lcnyw.skeletonShimmer)();
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $6854df9b98f4b182$var$shimmerKeyframes = (0, $byn9U.keyframes)($6854df9b98f4b182$var$shimmer.keyframes);
const $6854df9b98f4b182$var$skeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...$6854df9b98f4b182$var$shimmer.css
});
const $6854df9b98f4b182$var$activeShimmerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animationName: `${$6854df9b98f4b182$var$shimmerKeyframes}`
});
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ const $6854df9b98f4b182$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = '100px', isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: [
            $6854df9b98f4b182$var$skeletonStyles,
            isShimmering && $6854df9b98f4b182$var$activeShimmerStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                width: width,
                height: height,
                borderRadius: borderRadius
            }
        ],
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        }
    });
};
var $6854df9b98f4b182$export$2e2bcd8739ae039 = $6854df9b98f4b182$var$Skeleton;

});

parcelRegister("kfZqf", function(module, exports) {

$parcel$export(module.exports, "HiddenIcon", () => $a21c86407f311f09$export$bce21421c351deb1);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $a21c86407f311f09$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.75961 3.82038L0.469614 1.53039L1.53027 0.469727L15.5303 14.4697L14.4696 15.5304L11.9569 13.0177C10.7749 13.6441 9.42396 14.0001 7.99985 14.0001C4.43327 14.0001 1.31894 11.7676 0.167087 8.61989C0.0206752 8.21978 0.0206129 7.78052 0.167056 7.38031C0.683493 5.96897 1.59401 4.74336 2.75961 3.82038ZM3.82896 4.88973C2.80461 5.65938 2.01287 6.70107 1.57571 7.89577C1.5511 7.96303 1.55109 8.03706 1.57574 8.10442C2.50926 10.6555 5.05721 12.5001 7.99985 12.5001C9.00694 12.5001 9.96863 12.284 10.8358 11.8965L9.52381 10.5846C9.07723 10.8483 8.55598 11.0001 7.99994 11.0001C6.34309 11.0001 4.99994 9.65691 4.99994 8.00006C4.99994 7.44402 5.15166 6.92277 5.41542 6.47619L3.82896 4.88973ZM6.55063 7.6114C6.51755 7.7353 6.49994 7.86555 6.49994 8.00006C6.49994 8.82848 7.17152 9.50006 7.99994 9.50006C8.13445 9.50006 8.2647 9.48246 8.3886 9.44937L6.55063 7.6114ZM7.99985 3.50006C7.50971 3.50006 7.03064 3.55121 6.56817 3.64826L6.26011 2.18024C6.82282 2.06215 7.40511 2.00006 7.99985 2.00006C11.5664 2.00006 14.6809 4.23249 15.8328 7.38022C15.9792 7.78032 15.9793 8.21955 15.8328 8.61977C15.5258 9.45892 15.0793 10.2324 14.5232 10.9153L13.3601 9.96815C13.8143 9.41034 14.1762 8.78194 14.4242 8.10432C14.4488 8.03708 14.4488 7.96307 14.4242 7.8957C13.4906 5.34464 10.9425 3.50006 7.99985 3.50006Z",
        fill: "currentColor"
    }));
const $a21c86407f311f09$export$bce21421c351deb1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $a21c86407f311f09$var$CustomGlyph,
        ...props
    });

});

parcelRegister("cfzU9", function(module, exports) {

$parcel$export(module.exports, "StarIconButton", () => $0d5e336c9f732951$export$703abb8bd2abdfa5);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $daM3L = parcelRequire("daM3L");

var $hlWtt = parcelRequire("hlWtt");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4vqt4 = parcelRequire("4vqt4");
const $0d5e336c9f732951$var$pressableStarIconStyles = (0, $1ZAYh.xcss)({
    background: 'transparent',
    padding: 'space.0',
    height: '32px',
    width: '32px'
});
const $0d5e336c9f732951$var$hiddenStyles = (0, $1ZAYh.xcss)({
    opacity: 0
});
const $0d5e336c9f732951$export$703abb8bd2abdfa5 = ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isHovered, setIsHovered] = (0, $eUqFw.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        xcss: [
            $0d5e336c9f732951$var$pressableStarIconStyles,
            !visible && $0d5e336c9f732951$var$hiddenStyles
        ],
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }, isStarred || isHovered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hlWtt))), {
        size: "medium",
        label: formatMessage((0, $4vqt4.default).removeFromFavouritesLabel),
        primaryColor: "var(--ds-background-accent-yellow-subtler-pressed, #E2B203)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($daM3L))), {
        size: "medium",
        label: formatMessage((0, $4vqt4.default).clickToFavouriteLabel),
        primaryColor: "var(--ds-background-accent-gray-bolder-hovered, #44546F)"
    }));
};

});
parcelRegister("4vqt4", function(module, exports) {

$parcel$export(module.exports, "default", () => $237a04530def53a1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $237a04530def53a1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    removeFromFavouritesLabel: {
        id: 'rovo-chat.browse-agents.remove-from-favourites-label',
        defaultMessage: 'Remove from favourites',
        description: 'Remove from favourites label'
    },
    clickToFavouriteLabel: {
        id: 'rovo-chat.browse-agents.click-to-favourite-label',
        defaultMessage: 'Not favourited, click to favourite',
        description: 'Click to favourite agent label'
    }
});

});


parcelRegister("aj3Jh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b9eb9dca2dfa43df$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $b9eb9dca2dfa43df$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    agentCreatedBy: {
        id: 'ai-mate.agent-profile-info.created-by',
        defaultMessage: 'Rovo agent by {creatorNameWithLink}',
        description: 'Message to show who created this Rovo agent'
    },
    agentDeactivated: {
        id: 'ai-mate.agent-profile-info.deactivated',
        defaultMessage: '(deactivated)',
        description: 'Message to show that this agent is deactivated'
    },
    starredCount: {
        id: 'ai-mate.agent-profile-info.starred-count',
        defaultMessage: '{count} starred',
        description: 'Message to show how many times this agent has been starred by users'
    },
    hiddenIcon: {
        id: 'ai-mate.agent-profile-info.hidden-icon',
        defaultMessage: 'Hidden',
        description: 'Icon to show that this agent is hidden'
    },
    hiddenTooltip: {
        id: 'ai-mate.agent-profile-info.hidden-tooltip',
        defaultMessage: "Agent won't show in search results",
        description: 'Tooltip to explain what strikethough eye icon means'
    },
    starAgentTooltip: {
        id: 'ai-mate.agent-profile-info.star-agent-tooltip',
        defaultMessage: 'Star Agent',
        description: 'Tooltip to explain what star icon does'
    }
});

});


parcelRegister("18uvb", function(module, exports) {

$parcel$export(module.exports, "useAgentDetailsController", () => $8b4745ade1be5544$export$e65200649bbc56ce);

var $19xaS = parcelRequire("19xaS");
var $dXg8a = parcelRequire("dXg8a");

var $1DkoF = parcelRequire("1DkoF");
var $6n1kb = parcelRequire("6n1kb");
const $8b4745ade1be5544$export$e65200649bbc56ce = ({ agentId: agentId, experienceId: experienceId, product: product, enabled: enabled = true })=>{
    const assistanceService = (0, $1DkoF.useAssistanceService)({
        experienceId: experienceId,
        product: product
    });
    const experience = (0, $dXg8a.useAIMateExperienceTracker)();
    const queryResult = (0, $6n1kb.useQuery)({
        queryKey: [
            'fetchAgentDetails',
            agentId
        ],
        queryFn: ()=>{
            experience.start({
                id: (0, $19xaS.ExperienceName).FETCH_AGENT_BY_AGENT_ID,
                name: (0, $19xaS.ExperienceName).FETCH_AGENT_BY_AGENT_ID
            });
            return assistanceService.getAgentDetails(agentId);
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $19xaS.ExperienceName).FETCH_AGENT_BY_AGENT_ID
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $19xaS.ExperienceName).FETCH_AGENT_BY_AGENT_ID,
                error: error
            });
        },
        enabled: enabled
    });
    return queryResult;
};
const $8b4745ade1be5544$export$7d1c308c0d5404ad = ({ identityAccountId: identityAccountId, experienceId: experienceId, product: product, enabled: enabled = true })=>{
    const assistanceService = (0, $1DkoF.useAssistanceService)({
        experienceId: experienceId,
        product: product
    });
    const experience = (0, $dXg8a.useAIMateExperienceTracker)();
    const queryResult = (0, $6n1kb.useQuery)({
        queryKey: [
            'fetchAgentDetails',
            identityAccountId
        ],
        queryFn: ()=>{
            experience.start({
                id: (0, $19xaS.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID,
                name: (0, $19xaS.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID
            });
            return assistanceService.getAgentDetailsByIdentityAccountId(identityAccountId);
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $19xaS.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $19xaS.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID,
                error: error
            });
        },
        enabled: enabled
    });
    return queryResult;
};

});
parcelRegister("19xaS", function(module, exports) {

$parcel$export(module.exports, "ExperienceName", () => $6575de2c7f86c640$export$b881bd9f00ed8ed1);
const $6575de2c7f86c640$export$b881bd9f00ed8ed1 = {
    LOAD_PANEL: 'aiMateLoadPanel',
    LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
    LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
    FETCH_CHAT: 'aiMateFetchChat',
    FETCH_AGENTS: 'aiMateFetchAgents',
    FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
    FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
    CREATE_AGENT: 'aiMateCreateAgent',
    UPDATE_AGENT: 'aiMateUpdateAgent',
    DELETE_AGENT: 'aiMateDeleteAgent',
    FAVOURITE_AGENT: 'aiMateFavouriteAgent',
    UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
    CLEAR_CHAT: 'aiMateClearChat',
    SEND_MESSAGE: 'aiMateSendMessage',
    ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
    FETCH_FEATURES: 'aiMateFetchFeatures',
    GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
    UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
    CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
    PUBSUB_LISTENER: 'aiMatePubSubListener',
    FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
    RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
    MESSAGE_RENDERER: 'aiMateMessageRenderer',
    FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
    GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
    FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources'
};

});

parcelRegister("dXg8a", function(module, exports) {

$parcel$export(module.exports, "useAIMateExperienceTracker", () => $9d991c98fe9d7243$export$412c53791574f6f0);

var $eUqFw = parcelRequire("eUqFw");

var $hUYqC = parcelRequire("hUYqC");

var $jBIQr = parcelRequire("jBIQr");

var $cIgNV = parcelRequire("cIgNV");

var $9ngKA = parcelRequire("9ngKA");
class $9d991c98fe9d7243$var$ExperienceTrackerHandler {
    constructor(){
        this.experienceTracker = new (0, $hUYqC.ExperienceTracker)();
        this.sendAnalyticsEvent = null;
        this.experienceTracker.subscribe((event)=>{
            // for FailEvent
            if ('error' in event) {
                // do not fail experience tracking if the error is a client fetch error
                if ((0, $jBIQr.isClientFetchError)(event.error)) return;
                // Filter 5xx errors since backend monitoring will cover this
                // as per https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3547354267/Meeting+notes+FE+SLOs+which+one+to+promote
                if (event.error?.metadata?.statusCode >= 500) return;
                const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                (0, $cIgNV.logException)({
                    exception: error,
                    name: event.name,
                    tags: {
                        source: 'aiMateExperienceTracker'
                    }
                });
            }
            this.sendAnalyticsEvent?.({
                eventType: 'operational',
                action: event.action,
                actionSubject: 'ui',
                attributes: {
                    task: event.name,
                    taskId: event.id,
                    startTime: event.startTime,
                    ...event.attributes
                }
            }, {
                removeDefaultTags: true
            });
        });
    }
    setSendAnalyticsEvent(sendAnalyticsEvent) {
        this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
    static getInstance() {
        if (!$9d991c98fe9d7243$var$ExperienceTrackerHandler.instance) $9d991c98fe9d7243$var$ExperienceTrackerHandler.instance = new $9d991c98fe9d7243$var$ExperienceTrackerHandler();
        return $9d991c98fe9d7243$var$ExperienceTrackerHandler.instance;
    }
}
const $9d991c98fe9d7243$export$412c53791574f6f0 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $9ngKA.useAnalytics)();
    (0, $eUqFw.useEffect)(()=>{
        $9d991c98fe9d7243$var$ExperienceTrackerHandler.getInstance().setSendAnalyticsEvent(sendAnalyticsEvent);
    }, [
        sendAnalyticsEvent
    ]);
    return $9d991c98fe9d7243$var$ExperienceTrackerHandler.getInstance().experienceTracker;
};

});
parcelRegister("jBIQr", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $40259eea45a92ab6$export$2e7adc44463c3f4f);
// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
const $40259eea45a92ab6$var$KNOWN_NETWORK_ERRORS = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $40259eea45a92ab6$var$isClientFetchErrorMessage = (message)=>Boolean(message) && !!$40259eea45a92ab6$var$KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $40259eea45a92ab6$var$KNOWN_NETWORK_ERRORS_TYPES = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $40259eea45a92ab6$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($40259eea45a92ab6$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name) || $40259eea45a92ab6$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($40259eea45a92ab6$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || $40259eea45a92ab6$var$isClientFetchErrorMessage(error.cause.message)));

});

parcelRegister("cIgNV", function(module, exports) {

$parcel$export(module.exports, "setupSentryClient", () => $790e2728a7a6a566$export$d8bd0edf6c978788);
$parcel$export(module.exports, "logException", () => $790e2728a7a6a566$export$f86b2a1a2ce291b3);

var $jBIQr = parcelRequire("jBIQr");

var $7SJVd = parcelRequire("7SJVd");

// importing local file instead of from '@sentry/browser' otherwise there will be typescript errors
const $790e2728a7a6a566$var$importSentryAsync = async ()=>Promise.resolve((parcelRequire("itytM")));
let $790e2728a7a6a566$var$sentryClient;
// copied from platform/packages/people-and-teams/teams-client/src/services/sentry/utils/initialise-sentry.ts
const $790e2728a7a6a566$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
const $790e2728a7a6a566$var$getEnvironment = ()=>{
    return 'production';
};
const $790e2728a7a6a566$export$d8bd0edf6c978788 = async ({ accountId: accountId = 'UNKNOWN_AAID', product: product = 'UNKNOWN' })=>{
    if ($790e2728a7a6a566$var$sentryClient) {
        // if sentry is trying to be initialized again with new product or account id
        // update the user and tags
        if (product !== 'UNKNOWN') $790e2728a7a6a566$var$sentryClient.setTag('product', product);
        if (accountId !== 'UNKNOWN_AAID') $790e2728a7a6a566$var$sentryClient.setUser({
            id: accountId
        });
        // do not initialise sentry again, only update the existing one
        return;
    }
    let importedSentry;
    try {
        importedSentry = await $790e2728a7a6a566$var$importSentryAsync();
    } catch (e) {
        console.warn('Failed to load conversation-assistant sentry', e); // eslint-disable-line no-console
        return;
    }
    importedSentry.init({
        // from https://atlassian-2y.sentry.io/projects/ai-mate-conversation-assistant/getting-started/
        dsn: 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680',
        environment: $790e2728a7a6a566$var$getEnvironment(),
        integrations: (integrations)=>{
            return integrations.filter((integration)=>{
                return $790e2728a7a6a566$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        },
        initialScope: {
            user: {
                id: accountId
            },
            tags: {
                packageName: '@atlassian/conversation-assistant',
                product: product
            }
        },
        // referencing jira/src/packages/platform/observability/errors-handling/src/utils/sentry/handling/normalise-sentry-event.tsx
        beforeSend: (event, hint)=>{
            const exception = hint?.originalException;
            // Ignore network-like errors
            if ((0, $jBIQr.isClientFetchError)(exception)) return null;
            if (!event.tags?.name) // we only want to capture errors that has `name` tag from `logException` function below
            // since the `DISABLED_INTEGRATIONS` filter above is not enough to prevent unhandled errors
            return null;
            let updatedEvent = event;
            if (updatedEvent.request?.url) {
                // Ignore events from localhost and staging
                if (updatedEvent.request.url.includes('localhost') || updatedEvent.request.url.includes('jira-dev.com')) return null;
                updatedEvent.request.url = (0, $7SJVd.normaliseUrl)(updatedEvent.request.url);
            }
            return updatedEvent;
        },
        attachStacktrace: true
    });
    $790e2728a7a6a566$var$sentryClient = importedSentry;
};
const $790e2728a7a6a566$var$getSentryClient = async ()=>{
    if (!$790e2728a7a6a566$var$sentryClient) // this only happens if something using sentry before the initialisation in root app
    await $790e2728a7a6a566$export$d8bd0edf6c978788({});
    return $790e2728a7a6a566$var$sentryClient;
};
const $790e2728a7a6a566$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
    const sentryClient = await $790e2728a7a6a566$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        scope.setTag('name', name);
        if (tags) scope.setTags(tags);
        sentryClient.captureException(exception, scope);
    });
};

});
parcelRegister("7SJVd", function(module, exports) {

$parcel$export(module.exports, "normaliseUrl", () => $c57c2115e83c7812$export$d57ae76c6dc57a5);
const $c57c2115e83c7812$var$pathnamePrefixes = [
    '/jira/',
    '/wiki/',
    '/browse/'
];
const $c57c2115e83c7812$var$ATLAS_HOST = 'home.atlassian.com';
const $c57c2115e83c7812$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
const $c57c2115e83c7812$export$d57ae76c6dc57a5 = (url)=>{
    try {
        let parsedUrl = new URL(url);
        let normalizedPath = '/any/';
        if (parsedUrl.host === $c57c2115e83c7812$var$ATLAS_HOST || parsedUrl.host === $c57c2115e83c7812$var$ATLAS_TEAM_HOST) // Replace org ID with "orgId" in the path
        normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
        const prefixRegex = new RegExp(`^(${$c57c2115e83c7812$var$pathnamePrefixes.join('|')})`);
        if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
        const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
        return normalizedUrl;
    } catch (error) {
        return 'https://could-not-parse.example.com';
    }
};

});



parcelRegister("1DkoF", function(module, exports) {

$parcel$export(module.exports, "AssistanceServiceImpl", () => $e9dc854f88cc6758$export$a522c5f4ccda1c94);
$parcel$export(module.exports, "AssistanceServiceProvider", () => $e9dc854f88cc6758$export$8fe647eb935c33db);
$parcel$export(module.exports, "useAssistanceService", () => $e9dc854f88cc6758$export$7e31a1844ebbaf85);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $557eF = parcelRequire("557eF");

var $bxiUx = parcelRequire("bxiUx");

var $cm6c0 = parcelRequire("cm6c0");

var $2zKwB = parcelRequire("2zKwB");

var $5s3f8 = parcelRequire("5s3f8");

var $lA7RZ = parcelRequire("lA7RZ");
class $e9dc854f88cc6758$export$a522c5f4ccda1c94 {
    constructor(props){
        const defaultConfig = {
            baseUrl: '/gateway/api/assist',
            headers: {}
        };
        this.config = {
            baseUrl: props.baseUrl || defaultConfig.baseUrl,
            headers: {
                ...props.headers || defaultConfig.headers,
                'x-product': props.product,
                'x-experience-id': props.experienceId
            }
        };
    }
    createHeaders(init) {
        return new Headers({
            ...this.config.headers || {},
            ...init || {}
        });
    }
    async fetch({ path: path, options: options, throwResponseOnError: throwResponseOnError = false }) {
        const { baseUrl: baseUrl } = this.config;
        const requestUrl = (0, $cm6c0.addPath)(baseUrl, path);
        const response = await (0, $lA7RZ.fetchFn)(requestUrl, options);
        return (0, $cm6c0.processResponse)({
            response: response,
            throwResponseOnError: throwResponseOnError
        });
    }
    async fetchJson({ path: path, options: options, throwResponseOnError: throwResponseOnError }) {
        const response = await this.fetch({
            path: path,
            options: options,
            throwResponseOnError: throwResponseOnError
        });
        const json = await response.json();
        return json;
    }
    async fetchStream({ path: path, options: options, throwResponseOnError: throwResponseOnError }) {
        const response = await this.fetch({
            path: path,
            options: options,
            throwResponseOnError: throwResponseOnError
        });
        return (0, $557eF.readJsonStream)(response);
    }
    async sendMessageStream({ agentNamedId: agentNamedId, agentId: agentId, message: message, conversationId: conversationId, controller: controller, storeMessage: storeMessage = false, citationsEnabled: citationsEnabled = true, editorContext: editorContext, browserContext: browserContext, additionalContext: additionalContext }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        // If browserContext received and context is undefined, assume we're unable to retrieve the context of the page in focus
        const url = browserContext ? browserContext.context?.browserUrl : window?.location?.href;
        const body = {
            content: message,
            context: {
                browser_url: url,
                ...editorContext ? {
                    editor: editorContext
                } : {},
                // If browserUrl is inaccessable, fallback to htmlBody or canvasText if they exist
                ...browserContext ? {
                    browser: {
                        htmlBody: browserContext.context?.htmlBody,
                        canvasText: browserContext.context?.canvasText
                    }
                } : {},
                ...additionalContext
            },
            recipient_agent_named_id: agentNamedId,
            agent_id: agentId,
            mimeType: typeof message === 'string' ? 'text/markdown' : 'text/adf',
            // don't allow store message if feature flag is off
            store_message: (0, $XHGTv.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: citationsEnabled
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/chat/v1/channel/${conversationId}/message/stream`,
            options: options
        });
    }
    async getChat(conversationId) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const rawChat = await this.fetchJson({
            path: `/chat/v1/channel/${conversationId}/messages`,
            options: options
        });
        return rawChat.map((message)=>// Must be converted into StreamResponse
            (0, $bxiUx.isHumanMessage)(message) ? message : (0, $5s3f8.toStreamResponse)(message));
    }
    async deleteChat(conversationId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        await this.fetch({
            path: `/chat/v1/channel/${conversationId}`,
            options: options
        });
    }
    async getFeatures(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: 'features',
            options: options
        });
    }
    async getAgents(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: 'agents/v1',
            options: options
        });
    }
    async getAgentDetails(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `agents/v1/${id}`,
            options: options
        });
    }
    async getAgentDetailsByIdentityAccountId(identityAccountId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `agents/v1/accountid/${identityAccountId}`,
            options: options
        });
    }
    async getAgentFileUploadToken(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: 'agents/v1/media/upload/credentials',
            options: options
        });
    }
    async createAgent(payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        return this.fetchJson({
            path: '/agents/v1',
            options: options
        });
    }
    async updateAgent(id, payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: `/agents/v1/${id}`,
            options: options,
            throwResponseOnError: true
        });
        return response;
    }
    async deleteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/agents/v1/${id}`,
            options: options,
            throwResponseOnError: true
        });
    }
    async favouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'POST',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/agents/v1/${id}/favourite`,
            options: options,
            throwResponseOnError: true
        });
    }
    async unfavouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/agents/v1/${id}/favourite`,
            options: options,
            throwResponseOnError: true
        });
    }
    async createConversationChannel(options) {
        return this.fetchJson({
            path: '/chat/v1/channel',
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    name: options?.name ?? (0, $2zKwB.generateConversationName)(),
                    dialogues: options?.dialogues ?? undefined
                })
            }
        });
    }
    async getConversationChannels() {
        return this.fetchJson({
            path: '/chat/v1/channels',
            options: {
                method: 'GET',
                headers: this.createHeaders()
            }
        });
    }
    updateConversationChannel(id, payload) {
        return this.fetchJson({
            path: `/chat/v1/channel/${id}`,
            options: {
                method: 'PUT',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify(payload)
            }
        });
    }
    async resolveConversationAction(id, payload) {
        return this.fetchJson({
            path: `/chat/v1/channel/${id}/action`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify(payload)
            }
        });
    }
    async speechToText(blob) {
        const formData = new FormData();
        formData.append('audio_recording', blob);
        const response = await this.fetchJson({
            path: '/speech/inference',
            options: {
                method: 'POST',
                headers: this.createHeaders(),
                body: formData
            }
        });
        return response.transcription;
    }
    async generateConversationStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/agents/v1/suggest-conversation-starter',
            options: options
        });
    }
}
const $e9dc854f88cc6758$var$AssistanceServiceContext = /*#__PURE__*/ (0, $eUqFw.createContext)(new $e9dc854f88cc6758$export$a522c5f4ccda1c94({
    baseUrl: '',
    product: '',
    experienceId: ''
}));
const $e9dc854f88cc6758$export$8fe647eb935c33db = ({ value: value, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9dc854f88cc6758$var$AssistanceServiceContext.Provider, {
        value: value
    }, children);
const $e9dc854f88cc6758$export$7e31a1844ebbaf85 = (props)=>{
    const service = (0, $eUqFw.useContext)($e9dc854f88cc6758$var$AssistanceServiceContext);
    if (!props || !props.product || !props.experienceId) return service;
    return new $e9dc854f88cc6758$export$a522c5f4ccda1c94({
        product: props.product,
        experienceId: props.experienceId
    });
};

});
parcelRegister("557eF", function(module, exports) {

$parcel$export(module.exports, "readJsonStream", () => $a80f6e356c62f163$export$1f24b2b263bcfa75);

var $8acmF = parcelRequire("8acmF");
async function* $a80f6e356c62f163$export$1f24b2b263bcfa75(response) {
    const reader = (0, $8acmF.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) try {
            const processedChunks = `${remainder}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            remainder = '';
            for (let chunk of processedChunks)try {
                yield JSON.parse(chunk);
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                remainder = chunk;
            }
        } catch (e) {
            const error = new Error(`Error Processing Stream Data: ${value}`);
            throw error;
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}

});
parcelRegister("8acmF", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $f4d81fef4da7e14c$export$f6383c3ea1307da9);
const $f4d81fef4da7e14c$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};

});


parcelRegister("bxiUx", function(module, exports) {

$parcel$export(module.exports, "isHumanMessage", () => $8a04ac5703dd9200$export$a69fab2afb88c2eb);
$parcel$export(module.exports, "isAssistantMessage", () => $8a04ac5703dd9200$export$6f965deda7f0960c);
$parcel$export(module.exports, "isStreamResponse", () => $8a04ac5703dd9200$export$b4631726cbc1440a);
$parcel$export(module.exports, "isAgentResponse", () => $8a04ac5703dd9200$export$a6e5100ca2770191);
$parcel$export(module.exports, "isStreamError", () => $8a04ac5703dd9200$export$d422a2733a3b5def);
$parcel$export(module.exports, "isStreamAUPError", () => $8a04ac5703dd9200$export$1e1cf807ece63df4);
$parcel$export(module.exports, "isStreamAnswerPart", () => $8a04ac5703dd9200$export$e45102edbc73b240);
$parcel$export(module.exports, "isStreamTrace", () => $8a04ac5703dd9200$export$fd5a05be03f147a0);
$parcel$export(module.exports, "isStreamPluginInvocation", () => $8a04ac5703dd9200$export$51a1b4e474708d74);
$parcel$export(module.exports, "isFollowUpMessage", () => $8a04ac5703dd9200$export$aeae5b4fda357302);
$parcel$export(module.exports, "isChannelNotFoundError", () => $8a04ac5703dd9200$export$6ce1ccc24e75456f);
$parcel$export(module.exports, "isRateLimitedError", () => $8a04ac5703dd9200$export$bc96a6a479480590);
$parcel$export(module.exports, "isConversationChannelDataMessage", () => $8a04ac5703dd9200$export$b454081350f4a578);

var $cfr3D = parcelRequire("cfr3D");
const $8a04ac5703dd9200$export$5945515082cc2cbf = 'CONVERSATION_CHANNEL_NOT_FOUND';
const $8a04ac5703dd9200$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
const $8a04ac5703dd9200$export$fb661125ffb29bd6 = (message)=>{
    return $8a04ac5703dd9200$export$a69fab2afb88c2eb(message) || $8a04ac5703dd9200$export$6f965deda7f0960c(message) || $8a04ac5703dd9200$export$b4631726cbc1440a(message);
};
const $8a04ac5703dd9200$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $8a04ac5703dd9200$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $8a04ac5703dd9200$export$a6e5100ca2770191 = (message)=>message instanceof Object && $8a04ac5703dd9200$export$6f965deda7f0960c(message.message);
const $8a04ac5703dd9200$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $8a04ac5703dd9200$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $8a04ac5703dd9200$export$1e1cf807ece63df4 = (message)=>$8a04ac5703dd9200$export$d422a2733a3b5def(message) && message.message?.message_template === $8a04ac5703dd9200$export$c424fe9570a5f2d9;
const $8a04ac5703dd9200$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $8a04ac5703dd9200$export$fd5a05be03f147a0 = (message)=>message instanceof Object && message.type === 'TRACE';
const $8a04ac5703dd9200$export$51a1b4e474708d74 = (message)=>message instanceof Object && message.type === 'PLUGIN_INVOCATION';
const $8a04ac5703dd9200$export$821c27cda9a33379 = (message)=>message instanceof Object && message.role === 'PLUGIN_INVOCATION';
const $8a04ac5703dd9200$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $8a04ac5703dd9200$export$6ce1ccc24e75456f = (error)=>(0, $cfr3D.isApiError)(error) && error.metadata?.errorCode === $8a04ac5703dd9200$export$5945515082cc2cbf;
const $8a04ac5703dd9200$export$bc96a6a479480590 = (error)=>(0, $cfr3D.isApiError)(error) && error.metadata.statusCode === 429;
const $8a04ac5703dd9200$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';

});
parcelRegister("cfr3D", function(module, exports) {

$parcel$export(module.exports, "ApiError", () => $d45584f6148535cd$export$f2e832acab1bdd79);
$parcel$export(module.exports, "isApiError", () => $d45584f6148535cd$export$89d83cc97c52a37);
$parcel$export(module.exports, "mapErrorToApiError", () => $d45584f6148535cd$export$3c02d1a328d4d808);
class $d45584f6148535cd$export$f2e832acab1bdd79 extends Error {
    constructor(message, metadata){
        super(message);
        this.message = message;
        this.metadata = metadata;
    }
}
const $d45584f6148535cd$export$89d83cc97c52a37 = (error)=>error instanceof $d45584f6148535cd$export$f2e832acab1bdd79;
const $d45584f6148535cd$export$3c02d1a328d4d808 = (error)=>{
    if ($d45584f6148535cd$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $d45584f6148535cd$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};

});


parcelRegister("cm6c0", function(module, exports) {

$parcel$export(module.exports, "addPath", () => $8588739682628087$export$4c25481b843feb0b);
$parcel$export(module.exports, "processResponse", () => $8588739682628087$export$21fcb6cfd5628534);

var $cfr3D = parcelRequire("cfr3D");
const $8588739682628087$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
const $8588739682628087$var$processErrorResponse = async ({ response: response, throwResponseOnError: throwResponseOnError })=>{
    if (throwResponseOnError) {
        const result = await response.json();
        throw result;
    }
    let errorMessage;
    let errorCode;
    const responseText = await response.text();
    try {
        const errorBodyJson = JSON.parse(responseText);
        const { error_code: error_code, error_message: error_message, message_template: message_template } = errorBodyJson;
        errorCode = error_code ?? message_template;
        if (!error_code || !error_message) errorMessage = responseText;
        else errorMessage = `${error_code} - ${error_message}`;
    } catch (err) {
        errorMessage = responseText;
    }
    throw new (0, $cfr3D.ApiError)(`[Code ${response.status}] ${errorMessage}`, {
        errorCode: errorCode,
        statusCode: response.status
    });
};
const $8588739682628087$export$21fcb6cfd5628534 = async ({ response: response, throwResponseOnError: throwResponseOnError })=>{
    if (!response.ok || response.status >= 400) await $8588739682628087$var$processErrorResponse({
        response: response,
        throwResponseOnError: throwResponseOnError
    });
    return response;
};

});

parcelRegister("2zKwB", function(module, exports) {

$parcel$export(module.exports, "generateConversationName", () => $ece6dfd9e7920834$export$11cc4786742ed7c2);
const $ece6dfd9e7920834$export$11cc4786742ed7c2 = ()=>{
    const date = new Date();
    const formattedDate = date.toLocaleDateString(undefined, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    });
    const formattedTime = date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    const name = `${formattedDate} ${formattedTime}`;
    return name;
};

});

parcelRegister("5s3f8", function(module, exports) {

$parcel$export(module.exports, "getId", () => $1e57ca9768887963$export$218c8c3169c024d2);
$parcel$export(module.exports, "updatePluginInvocation", () => $1e57ca9768887963$export$a76cc257b3881cb7);
$parcel$export(module.exports, "addAnswerPart", () => $1e57ca9768887963$export$6e5609c05ab74cc7);
$parcel$export(module.exports, "removeSensitiveData", () => $1e57ca9768887963$export$efd4f6b5d168b654);
$parcel$export(module.exports, "createHumanMessage", () => $1e57ca9768887963$export$4010f996e89e886a);
$parcel$export(module.exports, "toStreamResponse", () => $1e57ca9768887963$export$3220a4ff7b3a96df);

var $bxiUx = parcelRequire("bxiUx");
const $1e57ca9768887963$export$218c8c3169c024d2 = (streamResponse)=>streamResponse.message.message.id;
const $1e57ca9768887963$var$updatePluginInvocationAssistantMessage = (response, streamPluginInvocation)=>{
    const { message: pluginInvocation } = streamPluginInvocation;
    const pluginInvocationMessage = {
        message_id: response.id,
        ...pluginInvocation
    };
    const updatedMessage = {
        ...response
    };
    const updatedPluginInvocations = [
        ...updatedMessage.plugin_invocations
    ];
    const currentIndex = updatedPluginInvocations.findIndex((pi)=>pi.plugin_name === pluginInvocationMessage.plugin_name);
    if (currentIndex === -1) updatedPluginInvocations.push(pluginInvocationMessage);
    else updatedPluginInvocations[currentIndex] = pluginInvocationMessage;
    updatedMessage.plugin_invocations = updatedPluginInvocations;
    return updatedMessage;
};
const $1e57ca9768887963$var$updatePluginInvocationAgentResponse = (response, streamPluginInvocation)=>({
        ...response,
        message: $1e57ca9768887963$var$updatePluginInvocationAssistantMessage(response.message, streamPluginInvocation)
    });
const $1e57ca9768887963$export$a76cc257b3881cb7 = (response, streamPluginInvocation)=>({
        ...response,
        message: $1e57ca9768887963$var$updatePluginInvocationAgentResponse(response.message, streamPluginInvocation)
    });
const $1e57ca9768887963$var$addAnswerPartAssistantMessage = (response, answerPart)=>{
    const content = `${response.content}${answerPart.message.content}`;
    // Remove source indexes, e.g [^1^] from the content
    const cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
    return {
        ...response,
        content: cleanedContent
    };
};
const $1e57ca9768887963$var$addAnswerPartAgentResponse = (response, answerPart)=>({
        ...response,
        message: $1e57ca9768887963$var$addAnswerPartAssistantMessage(response.message, answerPart)
    });
const $1e57ca9768887963$export$6e5609c05ab74cc7 = (response, answerPart)=>({
        ...response,
        message: $1e57ca9768887963$var$addAnswerPartAgentResponse(response.message, answerPart)
    });
const $1e57ca9768887963$var$removeSensitiveDataAssistantMessage = (message)=>{
    const { plugin_invocations: plugin_invocations, ...rest } = message;
    return {
        ...rest,
        plugin_invocations: plugin_invocations.map((pluginInvocation)=>({
                ...pluginInvocation,
                plugin_output: '--PRIVATE--'
            }))
    };
};
const $1e57ca9768887963$var$removeSensitiveDataAgentResponse = (message)=>({
        ...message,
        message: $1e57ca9768887963$var$removeSensitiveDataAssistantMessage(message.message)
    });
const $1e57ca9768887963$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        message: $1e57ca9768887963$var$removeSensitiveDataAgentResponse(message.message)
    });
const $1e57ca9768887963$export$4010f996e89e886a = (id, content, isFromSeededConversation, requestId)=>{
    return {
        role: 'HUMAN',
        id: id,
        content: content,
        time_created: new Date().toISOString(),
        user_ari: 'unknown',
        plugin_invocations: [],
        isFromSeededConversation: isFromSeededConversation,
        requestId: requestId
    };
};
const $1e57ca9768887963$export$3220a4ff7b3a96df = (message)=>{
    if ((0, $bxiUx.isAgentResponse)(message)) return {
        type: 'FINAL_RESPONSE',
        message: message
    };
    return {
        type: 'FINAL_RESPONSE',
        message: {
            message: message
        }
    };
};
const $1e57ca9768887963$export$6304914e90dcefe0 = ()=>({
        account_id: '',
        cloud_id: '',
        env: '',
        env_type: '',
        model: '',
        ai_enabled_on_site: false,
        assistance_feature_enabled: false,
        debug_enabled: false
    });

});

parcelRegister("lA7RZ", function(module, exports) {

$parcel$export(module.exports, "fetchFn", () => $de59aa9f38bde4ce$export$10f0d162cb6dae7c);
const $de59aa9f38bde4ce$export$10f0d162cb6dae7c = window.fetch;

});


parcelRegister("6n1kb", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $a17d33a204558ba9$export$dd0a697e1782aedd);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $WBLbN = parcelRequire("WBLbN");

var $cfr3D = parcelRequire("cfr3D");
const $a17d33a204558ba9$var$store = (0, $WBLbN.createStore)({
    initialState: {
        cache: {}
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            }
    }
});
const $a17d33a204558ba9$var$selector = (0, $WBLbN.createSelector)((state)=>state.cache, (_, key)=>key, (cache, key)=>cache[key] ?? {
        data: null,
        error: null,
        isFetching: false
    });
const $a17d33a204558ba9$var$useCacheEntry = (0, $WBLbN.createHook)($a17d33a204558ba9$var$store, {
    selector: $a17d33a204558ba9$var$selector
});
const $a17d33a204558ba9$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $eUqFw.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $eUqFw.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $eUqFw.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $a17d33a204558ba9$var$useCacheEntry(queryKey);
    const fetchData = (0, $eUqFw.useCallback)(async ()=>{
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            updateCacheEntry(queryKey, {
                data: response
            });
            onSuccessRef.current?.(response);
        } catch (error) {
            const apiError = (0, $cfr3D.mapErrorToApiError)(error);
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $74BVL.bind)(window, {
                type: 'focus',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) fetchData();
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData
    };
};

});


parcelRegister("5OFKT", function(module, exports) {

$parcel$export(module.exports, "useRovoAgentData", () => $fd087b40596c6bba$export$763c7f4444e7eb2d);

var $WBLbN = parcelRequire("WBLbN");
const $fd087b40596c6bba$var$setAgentInfo = (data)=>({ setState: setState })=>{
        setState({
            agentData: data
        });
    };
const $fd087b40596c6bba$var$actions = {
    setAgentInfo: $fd087b40596c6bba$var$setAgentInfo
};
const $fd087b40596c6bba$var$RovoAgentStore = (0, $WBLbN.createStore)({
    initialState: {
        agentData: undefined
    },
    actions: $fd087b40596c6bba$var$actions
});
const $fd087b40596c6bba$export$6301922aaad7e8f5 = (0, $WBLbN.createHook)($fd087b40596c6bba$var$RovoAgentStore, {
    selector: (state)=>state.agentData
});
const $fd087b40596c6bba$export$763c7f4444e7eb2d = ()=>{
    const [agentInfo, { setAgentInfo: setAgentInfo }] = $fd087b40596c6bba$export$6301922aaad7e8f5();
    return {
        agentInfo: agentInfo,
        setAgentInfo: setAgentInfo
    };
};

});

parcelRegister("4vhsL", function(module, exports) {

$parcel$export(module.exports, "App", () => $6241b55617e5ad9a$export$86fbec116b87613f);
$parcel$export(module.exports, "RelativeWrapperOfHeaderImage", () => $6241b55617e5ad9a$export$c0d0370fa0c37541);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $6241b55617e5ad9a$export$86fbec116b87613f = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ccxr90-0"
})`height:100%;*{box-sizing:border-box;}a:hover{text-decoration:none;}`;
const $6241b55617e5ad9a$export$c0d0370fa0c37541 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ccxr90-1"
})`position:relative;`;

});

parcelRegister("kZURK", function(module, exports) {

$parcel$export(module.exports, "useAppConfig", () => $153d740657af5726$export$a3e0ece8c3f698d7);
$parcel$export(module.exports, "default", () => $153d740657af5726$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $153d740657af5726$var$error = new Error('AppConfigProvider is not found in higher components');
const $153d740657af5726$var$defaultState = {
    addFlag: ()=>{
        throw $153d740657af5726$var$error;
    },
    push: ()=>{
        throw $153d740657af5726$var$error;
    },
    replace: ()=>{
        throw $153d740657af5726$var$error;
    },
    history: undefined,
    contextSpaPaths: [],
    contextEntryPoint: '',
    docTitle: {},
    appName: '',
    productName: '',
    env: undefined,
    cloudId: '',
    isJiraAvailable: false,
    productFeatureFlags: {},
    orgId: undefined
};
const $153d740657af5726$var$AppConfigContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($153d740657af5726$var$defaultState);
const $153d740657af5726$export$a3e0ece8c3f698d7 = ()=>{
    return (0, $eUqFw.useContext)($153d740657af5726$var$AppConfigContext);
};
var $153d740657af5726$export$2e2bcd8739ae039 = $153d740657af5726$var$AppConfigContext;

});

parcelRegister("UsOwV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4705b8018767ee$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cAdhl = parcelRequire("cAdhl");

var $d8MGR = parcelRequire("d8MGR");
function $7c4705b8018767ee$export$dd5ad0b65cf665da(props) {
    const { children: children, docTitle: docTitle, title: title } = props;
    const resultTitle = [
        docTitle.start,
        title,
        docTitle.end
    ].filter((s)=>Boolean(s)).join(docTitle.delimiter || ' - ');
    return(// @ts-ignore
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cAdhl))), {
        title: resultTitle
    }, children));
}
var $7c4705b8018767ee$export$2e2bcd8739ae039 = (0, $d8MGR.default)($7c4705b8018767ee$export$dd5ad0b65cf665da);

});
parcelRegister("cAdhl", function(module, exports) {
'use strict';

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $guxOe = parcelRequire("guxOe");
function $929325b2bd5c056d$var$reducePropsToState(propsList) {
    var innermostProps = propsList[propsList.length - 1];
    if (innermostProps) return innermostProps.title;
}
function $929325b2bd5c056d$var$handleStateChangeOnClient(title) {
    var nextTitle = title || '';
    if (nextTitle !== document.title) document.title = nextTitle;
}
function $929325b2bd5c056d$var$DocumentTitle() {}
$929325b2bd5c056d$var$DocumentTitle.prototype = Object.create($eUqFw.Component.prototype);
$929325b2bd5c056d$var$DocumentTitle.displayName = 'DocumentTitle';
$929325b2bd5c056d$var$DocumentTitle.propTypes = {
    title: $1Qivz.string.isRequired
};
$929325b2bd5c056d$var$DocumentTitle.prototype.render = function() {
    if (this.props.children) return $eUqFw.Children.only(this.props.children);
    else return null;
};
module.exports = $guxOe($929325b2bd5c056d$var$reducePropsToState, $929325b2bd5c056d$var$handleStateChangeOnClient)($929325b2bd5c056d$var$DocumentTitle);

});
parcelRegister("guxOe", function(module, exports) {
'use strict';
function $c019ac826b959248$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $eUqFw = parcelRequire("eUqFw");
var $c019ac826b959248$var$React__default = $c019ac826b959248$var$_interopDefault($eUqFw);

var $c019ac826b959248$var$shallowEqual = $c019ac826b959248$var$_interopDefault((parcelRequire("h295B")));
function $c019ac826b959248$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c019ac826b959248$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $c019ac826b959248$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $c019ac826b959248$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_Component) {
            $c019ac826b959248$var$_inheritsLoose(SideEffect, _Component);
            function SideEffect() {
                return _Component.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                return !$c019ac826b959248$var$shallowEqual(nextProps, this.props);
            };
            _proto.componentWillMount = function componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $c019ac826b959248$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($eUqFw.Component);
        $c019ac826b959248$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $c019ac826b959248$var$_defineProperty(SideEffect, "canUseDOM", $c019ac826b959248$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $c019ac826b959248$var$withSideEffect;

});
parcelRegister("h295B", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});



parcelRegister("d8MGR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7eef17aaf0c2ced$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kZURK = parcelRequire("kZURK");
function $e7eef17aaf0c2ced$export$2e2bcd8739ae039(WrappedComponent) {
    const nameOfWrapperComponent = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithDocumentTitleComponent extends (0, $eUqFw.PureComponent) {
        static{
            this.displayName = `withDocumentTitleHOC(${nameOfWrapperComponent})`;
        }
        render() {
            const wrappedComponentProps = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZURK.default).Consumer, null, ({ docTitle: docTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    ...wrappedComponentProps,
                    docTitle: docTitle
                }));
        }
    }
    return WithDocumentTitleComponent;
}

});


parcelRegister("h9to7", function(module, exports) {

$parcel$export(module.exports, "AsideColumn", () => $aeb7a6dc4aea7c6f$export$7fd6f44981b465b2);
$parcel$export(module.exports, "AsideColumnItem", () => $aeb7a6dc4aea7c6f$export$f634bf5b1a9553c4);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ /**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $01qao = parcelRequire("01qao");

var $klWOd = parcelRequire("klWOd");
const $aeb7a6dc4aea7c6f$export$7fd6f44981b465b2 = /*#__PURE__*/ (0, $kwce8.default).aside.withConfig({
    componentId: "xyb5d3-0"
})`${(0, $01qao.baseColumnStyles)};flex:0 0 ${(0, $klWOd.profileGridSizeTimes)(4)}px;margin-bottom:${"var(--ds-space-400, 32px)"};&:last-of-type{margin-bottom:0;}`;
const $aeb7a6dc4aea7c6f$export$f634bf5b1a9553c4 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "xyb5d3-1"
})`&:not(:last-child){margin-bottom:${"var(--ds-space-300, 24px)"};}`;

});
parcelRegister("01qao", function(module, exports) {

$parcel$export(module.exports, "baseColumnStyles", () => $80956a56fbdd5d3d$export$d0f72508c56edec0);
/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line import/order, @repo/internal/styles/use-emotion, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $klWOd = parcelRequire("klWOd");
const $80956a56fbdd5d3d$export$d0f72508c56edec0 = /*#__PURE__*/ (0, $kwce8.css)`padding:0 ${(0, $klWOd.halfGutterSize)}px;min-width:${(0, $klWOd.minColumnWidth)}px;@media (max-width:${(0, $klWOd.responsiveThreshold)}px){flex:1 1;padding:0;}`;

});
parcelRegister("klWOd", function(module, exports) {

$parcel$export(module.exports, "profileGridSizeTimes", () => $d373ac9db6f6a38c$export$4ee2721235c833ba);
$parcel$export(module.exports, "halfGutterSize", () => $d373ac9db6f6a38c$export$a5c9f6dcfaa13620);
$parcel$export(module.exports, "minColumnWidth", () => $d373ac9db6f6a38c$export$78f737406522d217);
$parcel$export(module.exports, "responsiveThreshold", () => $d373ac9db6f6a38c$export$e52bb911ec277d52);
/**
 * Util function for creating sizes based on the profile grid.
 * Takes the form a of function to be consistent with Atlaskit theme grid sizes.
 */ const $d373ac9db6f6a38c$export$4ee2721235c833ba = (n)=>80 * n;
const $d373ac9db6f6a38c$export$a5c9f6dcfaa13620 = 20;
const $d373ac9db6f6a38c$export$78f737406522d217 = $d373ac9db6f6a38c$export$4ee2721235c833ba(3);
const $d373ac9db6f6a38c$export$a3fc3c10977fa604 = 768;
const $d373ac9db6f6a38c$export$e52bb911ec277d52 = $d373ac9db6f6a38c$export$a3fc3c10977fa604 + 64;

});



parcelRegister("92Jzo", function(module, exports) {

$parcel$export(module.exports, "Body", () => $0a4da1be8393684f$export$4b2c32e08f77ff18);

var $eUqFw = parcelRequire("eUqFw");

var $hibcJ = parcelRequire("hibcJ");
const $0a4da1be8393684f$export$4b2c32e08f77ff18 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($hibcJ.Body, null, children);
const $0a4da1be8393684f$export$77acdd2a63439b4c = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($hibcJ.WideBody, null, children);
var $0a4da1be8393684f$export$2e2bcd8739ae039 = $0a4da1be8393684f$export$4b2c32e08f77ff18;

});
parcelRegister("hibcJ", function(module, exports) {

$parcel$export(module.exports, "Body", () => $53a1fac98ea08d07$export$4b2c32e08f77ff18);
$parcel$export(module.exports, "WideBody", () => $53a1fac98ea08d07$export$77acdd2a63439b4c);
/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $klWOd = parcelRequire("klWOd");
const $53a1fac98ea08d07$export$4b2c32e08f77ff18 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1g7almm-0"
})`display:flex;flex-direction:column;justify-content:flex-start;min-height:calc(100vh - 56px);max-width:${(0, $klWOd.profileGridSizeTimes)(12.5)}px;margin:0 auto;padding:0 ${(0, $klWOd.halfGutterSize)}px;@media (max-width:${(0, $klWOd.responsiveThreshold)}px){padding:0 ${"var(--ds-space-300, 24px)"};}padding-bottom:${"var(--ds-space-400, 32px)"};`;
const $53a1fac98ea08d07$export$77acdd2a63439b4c = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1g7almm-1"
})`display:flex;flex-direction:column;justify-content:flex-start;min-height:calc(100vh - 56px);max-width:${(0, $klWOd.profileGridSizeTimes)(18)}px;margin:0 auto;padding:0 ${(0, $klWOd.halfGutterSize)}px;@media (max-width:${(0, $klWOd.responsiveThreshold)}px){padding:0 ${"var(--ds-space-300, 24px)"};}padding-bottom:${"var(--ds-space-400, 32px)"};`;

});


parcelRegister("3fooa", function(module, exports) {

$parcel$export(module.exports, "MainColumn", () => $5c545fabe56c9a11$export$2d9aae88ab6846ab);
$parcel$export(module.exports, "MainColumnItem", () => $5c545fabe56c9a11$export$a3de91dc1c7d9c74);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ /**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $lcnyw = parcelRequire("lcnyw");

var $01qao = parcelRequire("01qao");

var $klWOd = parcelRequire("klWOd");
const $5c545fabe56c9a11$export$2d9aae88ab6846ab = /*#__PURE__*/ (0, $kwce8.default).main.withConfig({
    componentId: "e4gbwm-0"
})`${(0, $01qao.baseColumnStyles)};flex:0 1 ${(0, $klWOd.profileGridSizeTimes)(8)}px;margin-top:${"var(--ds-space-400, 32px)"};margin-bottom:${"var(--ds-space-400, 32px)"};&:last-of-type{margin-bottom:0;}`;
const $5c545fabe56c9a11$export$a3de91dc1c7d9c74 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "e4gbwm-1"
})`scroll-margin-top:${(0, $lcnyw.gridSize)() * 23}px;&:not(:last-child){margin-bottom:${"var(--ds-space-400, 32px)"};}`;
const $5c545fabe56c9a11$export$b59f717f8d137994 = /*#__PURE__*/ (0, $kwce8.default).main.withConfig({
    componentId: "e4gbwm-2"
})`${(0, $01qao.baseColumnStyles)};flex:0 1 ${(0, $klWOd.profileGridSizeTimes)(12)}px;margin-top:${"var(--ds-space-400, 32px)"};margin-bottom:${"var(--ds-space-400, 32px)"};&:last-of-type{margin-bottom:0;}`;

});

parcelRegister("biE4w", function(module, exports) {

$parcel$export(module.exports, "ResponsiveSection", () => $5741c5a99192e0fa$export$6f5ca33df9ef97dc);
/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $klWOd = parcelRequire("klWOd");

var $hmn7h = parcelRequire("hmn7h");
const $5741c5a99192e0fa$export$6f5ca33df9ef97dc = /*#__PURE__*/ (0, $kwce8.default)((0, $hmn7h.Section)).withConfig({
    componentId: "uvj1rq-0"
})`@media (max-width:${(0, $klWOd.responsiveThreshold)}px){flex-direction:column;justify-content:flex-start;}`;

});
parcelRegister("hmn7h", function(module, exports) {

$parcel$export(module.exports, "Section", () => $de2f7dbe74a50baa$export$6e2c8f0811a474ce);
/**
 * Implementation of the People and Teams Page Framework spec.
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/641534197/Page+framework
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $de2f7dbe74a50baa$export$6e2c8f0811a474ce = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "jfynxk-0"
})`display:flex;flex-direction:row;justify-content:center;`;

});


parcelRegister("91PIt", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", () => $dd8729b5be211aa1$export$42f84e610f279c31);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $5QRJ0 = parcelRequire("5QRJ0");
var $74Hyh = parcelRequire("74Hyh");

var $4sj9N = parcelRequire("4sj9N");

var $4EGup = parcelRequire("4EGup");

var $79D9e = parcelRequire("79D9e");
const $dd8729b5be211aa1$export$db8be4c3614e42ec = new Map([
    [
        (0, $4sj9N.ErrorCategory).NotFound,
        (0, $4EGup.UserNotFound)
    ]
]);
const $dd8729b5be211aa1$export$42f84e610f279c31 = ({ error: error })=>{
    const analytics = (0, $74Hyh.default)();
    // Failed analytics
    (0, $eUqFw.useEffect)(()=>{
        analytics.pushTrackEvent({
            action: (0, $1io2n.AnalyticsEventActions).FAILED,
            actionSubject: `${(0, $1io2n.AnalyticsEventSource).USER_PROFILE_SCREEN}Load`,
            source: (0, $1io2n.AnalyticsEventSource).USER_PROFILE_SCREEN
        });
    }, [
        analytics
    ]);
    const errorCategory = (0, $4sj9N.parseErrorObjectToErrorCategory)(error);
    const ErrorComponent = errorCategory !== '' && $dd8729b5be211aa1$export$db8be4c3614e42ec.has(errorCategory) ? $dd8729b5be211aa1$export$db8be4c3614e42ec.get(errorCategory) : (0, $5QRJ0.GenericErrorPage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($79D9e.LoadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ErrorComponent, null));
};

});
parcelRegister("5QRJ0", function(module, exports) {

$parcel$export(module.exports, "GenericErrorPage", () => $5f4e0a9772863911$export$5d76009b056f3e5d);
$parcel$export(module.exports, "default", () => $5f4e0a9772863911$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");

var $7u4fN = parcelRequire("7u4fN");

var $bAnhx = parcelRequire("bAnhx");

var $d2sMa = parcelRequire("d2sMa");

var $diBJy = parcelRequire("diBJy");
const $5f4e0a9772863911$export$2369ec80391a4c8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.ErrorImage, {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($d2sMa)))
});
const $5f4e0a9772863911$export$c120a0e80fd44ca6 = ({ title: title, body: body, image: image, actions: actions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.Container, {
        "data-test-selector": "error-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.ImageOuter, null, image || $5f4e0a9772863911$export$2369ec80391a4c8c), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.ErrorTextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.TitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.Title, null, title)), body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.DescriptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.Description, null, body))), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($diBJy.ButtonContainer, null, actions));
};
const $5f4e0a9772863911$export$5d76009b056f3e5d = (props)=>{
    const actions = props.hasSupportLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        rel: "noopener noreferrer",
        target: "_blank",
        href: `${(0, $bAnhx.getAtlassianContextUrl)('support')}/contact/#/`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $5f4e0a9772863911$var$messages.contactUs));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5f4e0a9772863911$export$c120a0e80fd44ca6, {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $5f4e0a9772863911$var$messages.title),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $5f4e0a9772863911$var$messages.description),
        actions: actions || undefined
    });
};
const $5f4e0a9772863911$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        id: 'pf-home.generic-error-title',
        defaultMessage: 'Something went wrong'
    },
    contactUs: {
        id: 'ptc-directory.error-boundary.message-link-text',
        defaultMessage: 'Contact support',
        description: 'The text of the link leading to the Atlassian support website, shown below the error description on the error pages'
    },
    description: {
        id: 'pf-home.generic-error-description',
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things."
    }
});
var $5f4e0a9772863911$export$2e2bcd8739ae039 = $5f4e0a9772863911$export$c120a0e80fd44ca6;

});
parcelRegister("d2sMa", function(module, exports) {
module.exports = new URL("svg-error-window_ptc.150cf151.svg", import.meta.url).toString();

});

parcelRegister("diBJy", function(module, exports) {

$parcel$export(module.exports, "ErrorImage", () => $193ab7da24e944c3$export$7326e6d938a8137b);
$parcel$export(module.exports, "Container", () => $193ab7da24e944c3$export$42a852a2b6b56249);
$parcel$export(module.exports, "ImageOuter", () => $193ab7da24e944c3$export$6cce79b2fcc860dc);
$parcel$export(module.exports, "TitleWrapper", () => $193ab7da24e944c3$export$585a3b23e887288b);
$parcel$export(module.exports, "ButtonContainer", () => $193ab7da24e944c3$export$eddf54ea3db8d0f0);
$parcel$export(module.exports, "Title", () => $193ab7da24e944c3$export$f99233281efd08a0);
$parcel$export(module.exports, "DescriptionWrapper", () => $193ab7da24e944c3$export$2bf1f2b0d31b60fc);
$parcel$export(module.exports, "Description", () => $193ab7da24e944c3$export$393edc798c47379d);
$parcel$export(module.exports, "ErrorTextContainer", () => $193ab7da24e944c3$export$5086488b1ac4411e);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

const $193ab7da24e944c3$export$7326e6d938a8137b = /*#__PURE__*/ (0, $kwce8.default).img.withConfig({
    componentId: "kvymlk-0"
})`width:263px;margin:0 0 ${"var(--ds-space-600, 48px)"} 0;display:flex;`;
const $193ab7da24e944c3$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "kvymlk-1"
})`align-items:center;justify-content:center;display:flex;flex-wrap:wrap;margin:${"var(--ds-space-1000, 80px)"} auto 0;max-width:600px;flex-direction:column;@media (max-width:640px){flex-direction:column;}`;
const $193ab7da24e944c3$export$6cce79b2fcc860dc = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "kvymlk-2"
})`flex:none;flex-basis:200px;justify-content:center;@media (max-width:640px){margin-right:0;flex-basis:auto;& img{max-width:100%;padding:0 ${"var(--ds-space-300, 24px)"};}}`;
const $193ab7da24e944c3$export$585a3b23e887288b = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "kvymlk-3"
})`display:flex;margin-bottom:${"var(--ds-space-150, 12px)"};@media (max-width:640px){text-align:center;}`;
const $193ab7da24e944c3$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "kvymlk-4"
})`display:flex;justify-content:center;text-align:center;margin-top:${"var(--ds-space-200, 16px)"};`;
const $193ab7da24e944c3$export$f99233281efd08a0 = /*#__PURE__*/ (0, $kwce8.default).h1.withConfig({
    componentId: "kvymlk-5"
})``;
const $193ab7da24e944c3$export$2bf1f2b0d31b60fc = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "kvymlk-6"
})`display:flex;flex-wrap:wrap;`;
const $193ab7da24e944c3$export$393edc798c47379d = /*#__PURE__*/ (0, $kwce8.default).p.withConfig({
    componentId: "kvymlk-7"
})`font-size:1em;line-height:24px;color:${`var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`};@media (max-width:640px){text-align:center;}`;
const $193ab7da24e944c3$export$5086488b1ac4411e = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "kvymlk-8"
})`display:flex;justify-content:center;text-align:center;flex-wrap:wrap;width:80%;flex-direction:column;align-items:center;@media (max-width:640px){max-width:304px;width:100%;}`;

});


parcelRegister("4sj9N", function(module, exports) {

$parcel$export(module.exports, "ErrorCategory", () => $0e51598af5ba9092$export$fe4bb20808298551);
$parcel$export(module.exports, "isRealErrorUserProfile", () => $0e51598af5ba9092$export$ad79d1c90d717965);
$parcel$export(module.exports, "errorUserNotFound", () => $0e51598af5ba9092$export$10bf856e639f2ac5);
$parcel$export(module.exports, "parseErrorObjectToErrorCategory", () => $0e51598af5ba9092$export$cf76974422373a05);
$parcel$export(module.exports, "parseTeamErrorCategory", () => $0e51598af5ba9092$export$cd92fd5c21ce6635);

var $kRC4x = parcelRequire("kRC4x");
var $0e51598af5ba9092$export$fe4bb20808298551;
(function(ErrorCategory) {
    ErrorCategory["NotFound"] = "NotFound";
    ErrorCategory["NotPermitted"] = "NotPermitted";
    ErrorCategory["MalformedInput"] = "MalformedInput";
    ErrorCategory["Internal"] = "Internal";
})($0e51598af5ba9092$export$fe4bb20808298551 || ($0e51598af5ba9092$export$fe4bb20808298551 = {}));
const $0e51598af5ba9092$export$ad79d1c90d717965 = (error)=>{
    if (!error) return false;
    if (error?.message?.includes('User not found') || error?.message?.includes('Access is denied') || error?.message?.includes('TEAM CENTRAL UNAUTHORIZED')) return false;
    if (!error.graphQLErrors) return true;
    // is ApolloError
    return !error.graphQLErrors.every((e)=>!e || e.category === "NotFound" || e.category === "NotPermitted");
};
const $0e51598af5ba9092$export$10bf856e639f2ac5 = new Error('User not found');
function $0e51598af5ba9092$export$cf76974422373a05(error) {
    if (!error) return '';
    if (error?.message === $0e51598af5ba9092$export$10bf856e639f2ac5.message) return "NotFound";
    return error.graphQLErrors?.[0]?.category;
}
const $0e51598af5ba9092$var$MAP_TEAM_STATUS_ERROR_TYPES_MAP = {
    403: (0, $kRC4x.TeamProfileErrorType).NO_PERMISSION,
    404: (0, $kRC4x.TeamProfileErrorType).TEAM_MISSING,
    410: (0, $kRC4x.TeamProfileErrorType).TEAM_DELETED
};
const $0e51598af5ba9092$export$cd92fd5c21ce6635 = (error)=>error ? $0e51598af5ba9092$var$MAP_TEAM_STATUS_ERROR_TYPES_MAP[error.status] || (0, $kRC4x.TeamProfileErrorType).UNKNOWN : null;

});
parcelRegister("kRC4x", function(module, exports) {

$parcel$export(module.exports, "TeamProfileErrorType", () => $dde41d35893af066$export$b89d4f1cb2ee533c);
var $dde41d35893af066$export$b89d4f1cb2ee533c;
(function(TeamProfileErrorType) {
    TeamProfileErrorType["TEAM_MISSING"] = "teamMissing";
    TeamProfileErrorType["NO_PERMISSION"] = "noPermission";
    TeamProfileErrorType["TEAM_DELETED"] = "deleted";
    TeamProfileErrorType["UNKNOWN"] = "unknown";
    TeamProfileErrorType["NO_ACCESS_TO_TEAMS"] = "noAccessToTeams";
})($dde41d35893af066$export$b89d4f1cb2ee533c || ($dde41d35893af066$export$b89d4f1cb2ee533c = {}));

});


parcelRegister("4EGup", function(module, exports) {

$parcel$export(module.exports, "UserNotFound", () => $a7a4164910082b04$export$d1f0ba24af7dd9bb);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $8uD7Y = parcelRequire("8uD7Y");

var $6zOB7 = parcelRequire("6zOB7");

var $5QRJ0 = parcelRequire("5QRJ0");
var $74Hyh = parcelRequire("74Hyh");

var $1w3ff = parcelRequire("1w3ff");

var $kcFkB = parcelRequire("kcFkB");

var $7ZldT = parcelRequire("7ZldT");
const $a7a4164910082b04$var$Actions = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kcFkB.default), {
        href: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $a7a4164910082b04$var$messages.buttonText)));
const $a7a4164910082b04$var$NOT_FOUND_IMAGE_WIDTH = 497;
const $a7a4164910082b04$export$d1f0ba24af7dd9bb = ()=>{
    const analytics = (0, $74Hyh.default)();
    const expTracker = analytics.expTracker();
    // In a weird case, back and forth by browser back/next button causes `Query` of `react-apollo` does not return `error` correctly although user is not exsited.
    // So it is better to abort all current user experience tracking when user is not found.
    (0, $eUqFw.useEffect)(()=>{
        expTracker.abort({
            reason: 'User Not Found'
        });
    }, [
        expTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5QRJ0.default), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $a7a4164910082b04$var$messages.notFoundTitle),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $a7a4164910082b04$var$messages.notFoundDescription1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), $a7a4164910082b04$var$messages.notFoundDescription2)),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7ZldT.NotFoundImage, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($1w3ff))),
            width: $a7a4164910082b04$var$NOT_FOUND_IMAGE_WIDTH
        }),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7a4164910082b04$var$Actions, null)
    });
};
const $a7a4164910082b04$var$messages = (0, $90IgZ.defineMessages)({
    notFoundTitle: {
        id: 'ptc-directory.profile-page.not-found.title',
        defaultMessage: "Looks like we\u2019re off the beaten track",
        description: 'The title of the error page when a user tries to view a user but the user id does not exist'
    },
    notFoundDescription1: {
        id: 'ptc-directory.profile-page.not-found.description.first',
        defaultMessage: 'We landed here for a user that does not exist.',
        description: 'The first line of the description when a user landed on an invalid page'
    },
    notFoundDescription2: {
        id: 'ptc-directory.profile-page.not-found.description.second',
        defaultMessage: 'Head back to the directory to search for another user.',
        description: 'The second line of the description when a user landed on an invalid page'
    },
    buttonText: {
        id: 'ptc-directory.profile-page.error.home.button',
        defaultMessage: 'Back to directory',
        description: 'The button text to return to the search page'
    }
});

});
parcelRegister("1w3ff", function(module, exports) {
module.exports = new URL("svg-user-not-found_ptc.0205a184.svg", import.meta.url).toString();

});

parcelRegister("kcFkB", function(module, exports) {

$parcel$export(module.exports, "default", () => $14139912674d8d40$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $74Hyh = parcelRequire("74Hyh");

var $fef5r = parcelRequire("fef5r");

var $kZURK = parcelRequire("kZURK");
const $14139912674d8d40$var$isModified = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $14139912674d8d40$var$getSpaAndRelativePath = (href, contextSpaPaths)=>{
    const relativePath = (0, $fef5r.getRelativeUrl)(href);
    const isSPA = (0, $fef5r.isSPALink)(relativePath, contextSpaPaths);
    return {
        isSPA: isSPA,
        relativePath: relativePath
    };
};
const $14139912674d8d40$export$a6c7ac8248d6e38a = ({ href: href, onClick: onClick, target: target, ...rest })=>{
    const analytics = (0, $74Hyh.default)();
    const { contextSpaPaths: contextSpaPaths, contextEntryPoint: contextEntryPoint, push: push } = (0, $kZURK.useAppConfig)();
    (0, $eUqFw.useEffect)(()=>{
        if (!href) analytics.pushOperationalEvent({
            source: (0, $1io2n.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: 'link',
            action: (0, $1io2n.AnalyticsEventActions).FAILED,
            attributes: {
                contextSpaPaths: contextSpaPaths,
                contextEntryPoint: contextEntryPoint
            },
            tags: [
                'error'
            ]
        });
    }, [
        analytics,
        contextEntryPoint,
        contextSpaPaths,
        href
    ]);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        if (onClick) onClick(event);
        if (href) {
            const { relativePath: relativePath, isSPA: isSPA } = $14139912674d8d40$var$getSpaAndRelativePath(href, contextSpaPaths);
            if (isSPA && // only use push for links that work for SPA transitions
            !event.defaultPrevented && // set when onClick called preventDefault
            event.button === 0 && // only use push for left mouse button clicks
            (!target || target === '_self') && // let browser handle "_blank" etc
            !$14139912674d8d40$var$isModified(event) // let browser handle clicks with modifier
            ) {
                event.preventDefault();
                push(relativePath);
            }
        }
    }, [
        onClick,
        href,
        contextSpaPaths,
        push,
        target
    ]);
    if (href) {
        const { isSPA: isSPA } = $14139912674d8d40$var$getSpaAndRelativePath(href, contextSpaPaths);
        const props = {
            href: (0, $fef5r.prefixWithContextEntryPoint)(href, contextEntryPoint),
            ...target ? {
                target: target
            } : isSPA ? {} : {
                target: '_blank'
            },
            ...isSPA ? {} : {
                rel: 'noopener noreferrer'
            }
        };
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            ...rest,
            onClick: handleClick,
            ...props
        });
    }
    // if href is missing render <a> with original onClick handler
    // and without href or target
    // Note that we trigger an operational event in `componentDidMount` to monitor why `href` is not passed.
    // I have a suspicion that empty href can cause broken link
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        ...rest,
        onClick: onClick
    });
};
var $14139912674d8d40$export$2e2bcd8739ae039 = $14139912674d8d40$export$a6c7ac8248d6e38a;

});
parcelRegister("fef5r", function(module, exports) {

$parcel$export(module.exports, "getDomainFromLinkUri", () => $440eaf48988a4d90$export$cda14c9dfe45538);
$parcel$export(module.exports, "getRelativeUrl", () => $440eaf48988a4d90$export$d614758658023fd);
$parcel$export(module.exports, "prefixWithContextEntryPoint", () => $440eaf48988a4d90$export$715c8f9057ac0c01);
$parcel$export(module.exports, "isSPALink", () => $440eaf48988a4d90$export$82ba20246315fbed);

var $fECJU = parcelRequire("fECJU");
const $440eaf48988a4d90$export$1cc7e75fbd30f64f = (location)=>`${location.hash}${location.search}`;
const $440eaf48988a4d90$export$cda14c9dfe45538 = (url)=>{
    let hostname;
    try {
        try {
            hostname = $440eaf48988a4d90$export$eb5a321f13bbb969(url);
        } catch (noProtocolError) {
            /**
			 * Backend (Legion) validates whether the string is URI compliant. But URL expects
			 * the string to have a protocol. This is not validated by URI compliancy. So
			 * following is just a quick fix just for display purposes.
			 */ hostname = $440eaf48988a4d90$export$eb5a321f13bbb969('http://' + url);
        }
    } catch (error) {
        return '';
    }
    return hostname.replace(/^www\./, '');
};
const $440eaf48988a4d90$export$eb5a321f13bbb969 = (url)=>{
    const urlObj = new URL(url);
    return urlObj.hostname;
};
const $440eaf48988a4d90$export$c8d36b71889c2b08 = (email)=>{
    const parts = email.split('@');
    if (parts.length === 1) return null;
    else if (parts.length === 2 && !parts[0]) return null;
    else if (!parts[parts.length - 1]) return null;
    return parts[parts.length - 1];
};
const $440eaf48988a4d90$export$d614758658023fd = (url)=>{
    if (!$440eaf48988a4d90$var$isAbsoluteLink(url)) return url;
    try {
        const { pathname: pathname, search: search, hash: hash } = new URL(url);
        return `${pathname}${search}${hash}`;
    } catch (error) {
        (0, $fECJU.logException)(error, 'Cannot parse URL in getRelativeUrl', {
            url: url
        });
    }
    return url;
};
const $440eaf48988a4d90$var$isAbsoluteLink = (url)=>{
    return url.startsWith('http') || url.startsWith('www');
};
const $440eaf48988a4d90$export$715c8f9057ac0c01 = (path, contextEntryPoint = '')=>{
    if ($440eaf48988a4d90$var$isAbsoluteLink(path) || // do not prefix for absolute URL
    contextEntryPoint && path.startsWith(contextEntryPoint) || // do not prefix if the link already has product context path
    path.startsWith('/')) return path;
    return `${contextEntryPoint}/${path}`;
};
const $440eaf48988a4d90$export$82ba20246315fbed = (url, contextSpaPaths)=>{
    if (!contextSpaPaths || !contextSpaPaths.length) return false;
    let isStartWithContextSPA;
    if ($440eaf48988a4d90$var$isAbsoluteLink(url)) try {
        const { pathname: pathname, search: search, hash: hash, origin: origin } = new URL(url);
        const relativeUrl = `${pathname}${search}${hash}`;
        const isSameDomain = window.location.href.includes(origin);
        isStartWithContextSPA = !!contextSpaPaths.find((contextPath)=>{
            return relativeUrl.startsWith(contextPath);
        });
        return isStartWithContextSPA && isSameDomain;
    } catch (error) {
        (0, $fECJU.logException)(error, 'Cannot parse URL in isSPALink', {
            url: url
        });
        return false;
    }
    // is relative link
    isStartWithContextSPA = !!contextSpaPaths.find((contextPath)=>{
        return url.startsWith(contextPath);
    });
    return isStartWithContextSPA || !url.startsWith('/');
};

});


parcelRegister("7ZldT", function(module, exports) {

$parcel$export(module.exports, "NotFoundImage", () => $95fa6dcadf52d716$export$22dc9752913c971e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $95fa6dcadf52d716$export$22dc9752913c971e = /*#__PURE__*/ (0, $kwce8.default).img.withConfig({
    componentId: "sc-1wghneo-0"
})`margin:0 0 ${"var(--ds-space-500, 40px)"} 0;display:flex;`;

});


parcelRegister("79D9e", function(module, exports) {

$parcel$export(module.exports, "SidebarContent", () => $7d886cb82115933d$export$49e8f7b58a4df4ea);
$parcel$export(module.exports, "AvatarWrapper", () => $7d886cb82115933d$export$f7513421c53ce141);
$parcel$export(module.exports, "Details", () => $7d886cb82115933d$export$3e8048d3cf2ba3fd);
$parcel$export(module.exports, "Name", () => $7d886cb82115933d$export$c7bd411105e2dec3);
$parcel$export(module.exports, "Nickname", () => $7d886cb82115933d$export$445f45ad592d8c5);
$parcel$export(module.exports, "LoadingWrapper", () => $7d886cb82115933d$export$43a792a870d28db2);
$parcel$export(module.exports, "NonActiveUserLozenge", () => $7d886cb82115933d$export$184eb2c877f30f66);
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */ 
var $kwce8 = parcelRequire("kwce8");


var $4lTFP = parcelRequire("4lTFP");
const $7d886cb82115933d$export$3f46768c2c1337f2 = -91;
const $7d886cb82115933d$export$49e8f7b58a4df4ea = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1oxac7m-0"
})`margin-top:${$7d886cb82115933d$export$3f46768c2c1337f2}px;`;
const $7d886cb82115933d$export$b4afcc4b43e79a52 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1oxac7m-1"
})`height:0;padding:0;margin:${"var(--ds-space-250, 20px)"} 0 0 0;`;
const $7d886cb82115933d$export$f7513421c53ce141 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1oxac7m-2"
})`position:relative;display:inline-block;height:134px;width:134px;border-radius:50%;margin-bottom:${"var(--ds-space-200, 16px)"};`;
const $7d886cb82115933d$export$3e8048d3cf2ba3fd = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1oxac7m-3"
})`display:flex;flex-direction:column;`;
const $7d886cb82115933d$export$c7bd411105e2dec3 = /*#__PURE__*/ (0, $kwce8.default).h1.withConfig({
    componentId: "sc-1oxac7m-4"
})`${(0, $4lTFP.h700)} margin-top:0;margin-bottom:${"var(--ds-space-150, 12px)"};word-break:break-all;`;
const $7d886cb82115933d$export$445f45ad592d8c5 = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-1oxac7m-5"
})`color:${`var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`};margin-bottom:${"var(--ds-space-150, 12px)"};word-break:break-all;`;
const $7d886cb82115933d$export$43a792a870d28db2 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1oxac7m-6"
})`opacity:${(props)=>props.isLoading ? 0 : 1};`;
const $7d886cb82115933d$export$184eb2c877f30f66 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1oxac7m-7"
})`margin-bottom:${"var(--ds-space-250, 20px)"};margin-top:${"var(--ds-space-050, 4px)"};`;

});


parcelRegister("91BVc", function(module, exports) {

$parcel$export(module.exports, "AgentAboutPanel", () => $7a9de29830a4680a$export$a9a242371bd64127);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $j9fWg = parcelRequire("j9fWg");

var $cS2gQ = parcelRequire("cS2gQ");

var $hWMAc = parcelRequire("hWMAc");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");
const $7a9de29830a4680a$var$agentAboutPanelStyles = (0, $1ZAYh.xcss)({
    boxShadow: 'elevation.shadow.raised',
    borderRadius: '6px',
    padding: 'space.300',
    display: 'flex',
    flexDirection: 'column'
});
const $7a9de29830a4680a$var$headingStyles = (0, $1ZAYh.xcss)({
    textTransform: 'uppercase'
});
const $7a9de29830a4680a$var$AbouSectionHeaders = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $7a9de29830a4680a$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        size: "medium",
        color: "color.text.subtle",
        weight: "semibold"
    }, children));
const $7a9de29830a4680a$export$eceb80593c9ade2e = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        xcss: $7a9de29830a4680a$var$agentAboutPanelStyles,
        space: "space.300"
    }, children);
const $7a9de29830a4680a$export$a9a242371bd64127 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7a9de29830a4680a$export$eceb80593c9ade2e, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7a9de29830a4680a$var$AbouSectionHeaders, null, formatMessage($7a9de29830a4680a$var$messages.aboutLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWMAc))), {
        label: "",
        color: "currentColor"
    }), formatMessage($7a9de29830a4680a$var$messages.rovoAgentLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7a9de29830a4680a$var$AbouSectionHeaders, null, formatMessage($7a9de29830a4680a$var$messages.knowledgeLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        alignBlock: "center"
    }, formatMessage($7a9de29830a4680a$var$messages.emptyKnowledgeLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7a9de29830a4680a$var$AbouSectionHeaders, null, formatMessage($7a9de29830a4680a$var$messages.teamsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cS2gQ))),
        label: "add"
    }), formatMessage($7a9de29830a4680a$var$messages.createTeamLabel))));
};
const $7a9de29830a4680a$var$messages = (0, $90IgZ.defineMessages)({
    aboutLabel: {
        id: 'ptc-directory.agent-profile.about-agent.about-label',
        defaultMessage: 'About',
        description: 'Label for about section of the agent'
    },
    rovoAgentLabel: {
        id: 'ptc-directory.agent-profile.about-agent.rovo-agent-label',
        defaultMessage: 'Rovo Agent',
        description: 'The content inside About section, indicating this profile is a Rovo Agent'
    },
    knowledgeLabel: {
        id: 'ptc-directory.agent-profile.about-agent.knowledge-label',
        defaultMessage: 'Knowledge',
        description: 'Label for knowledge section of the agent'
    },
    emptyKnowledgeLabel: {
        id: 'ptc-directory.agent-profile.about-agent.empty-knowledge-label',
        defaultMessage: 'No knowledge added',
        description: 'Text for knowledge section of the agent when it is empty'
    },
    teamsLabel: {
        id: 'ptc-directory.agent-profile.about-agent.teams-label',
        defaultMessage: 'Teams',
        description: 'Label for teams section of the agent'
    },
    createTeamLabel: {
        id: 'ptc-directory.agent-profile.about-agent.teams-label',
        defaultMessage: 'Create a team together',
        description: 'Label for teams section of the agent'
    }
});

});
parcelRegister("hWMAc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4bcb2d8fcc82eed76abf5115bb378d2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d10d89fd43d4d820$var$_react = $d10d89fd43d4d820$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d10d89fd43d4d820$var$_UNSAFE_baseNew = $d10d89fd43d4d820$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $d10d89fd43d4d820$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Briefcase".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Job title in Atlas, Operations in JSM.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d10d89fd43d4d820$var$BriefcaseIcon = (props)=>/*#__PURE__*/ $d10d89fd43d4d820$var$_react.default.createElement($d10d89fd43d4d820$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 8.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V8.75m-12.5 0V6c0-.69.56-1.25 1.25-1.25h1.75m-3 4H8m6.25 0V6c0-.69-.56-1.25-1.25-1.25h-1.75m3 4H8m0 0V11M4.75 4.75V3c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v1.75m-6.5 0h6.5"/>`
    }, props));
$d10d89fd43d4d820$var$BriefcaseIcon.displayName = 'BriefcaseIcon';
var $d10d89fd43d4d820$var$_default = module.exports.default = $d10d89fd43d4d820$var$BriefcaseIcon;

});


parcelRegister("5BUhr", function(module, exports) {

$parcel$export(module.exports, "AgentActions", () => $cbd9aafdcdee594b$export$a091e6fbe251d12f);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $6zOB7 = parcelRequire("6zOB7");
var $j9fWg = parcelRequire("j9fWg");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $34Io4 = parcelRequire("34Io4");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $kDlNh = parcelRequire("kDlNh");

var $kQ7TK = parcelRequire("kQ7TK");
const $cbd9aafdcdee594b$var$chatToAgentButtonContainer = (0, $1ZAYh.xcss)({
    width: '100%'
});
const $cbd9aafdcdee594b$var$chatToAgentButtonWrapper = (0, $1ZAYh.xcss)({
    display: 'flex',
    justifyContent: 'center',
    lineHeight: '20px',
    padding: 'space.075',
    fontWeight: '500'
});
const $cbd9aafdcdee594b$var$chatPillButtonInlineStyles = (0, $1ZAYh.xcss)({
    paddingInline: 'space.025'
});
const $cbd9aafdcdee594b$var$chatPillTextStyles = (0, $1ZAYh.xcss)({
    wordBreak: 'break-word',
    textAlign: 'left',
    whiteSpace: 'pre-wrap'
});
const $cbd9aafdcdee594b$var$chatPillIconWrapper = (0, $1ZAYh.xcss)({
    minWidth: '20px',
    height: '20px'
});
const $cbd9aafdcdee594b$var$buildAgentActions = ({ onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent })=>{
    return [
        {
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kQ7TK.messages).actionDuplicate),
            onClick: onDuplicateAgent
        },
        {
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kQ7TK.messages).actionCopyLink),
            onClick: onCopyAgent
        }
    ];
};
const $cbd9aafdcdee594b$var$buildAgentSettings = ({ onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent })=>{
    return [
        {
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kQ7TK.messages).actionEdit),
            onClick: onEditAgent
        },
        {
            text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kQ7TK.messages).actionDelete),
            onClick: onDeleteAgent
        }
    ];
};
const $cbd9aafdcdee594b$export$a091e6fbe251d12f = ({ onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent, onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent, onChatClick: onChatClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const agentActions = $cbd9aafdcdee594b$var$buildAgentActions({
        onDuplicateAgent: onDuplicateAgent,
        onCopyAgent: onCopyAgent
    });
    const agentSetting = $cbd9aafdcdee594b$var$buildAgentSettings({
        onEditAgent: onEditAgent,
        onDeleteAgent: onDeleteAgent
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cbd9aafdcdee594b$var$chatToAgentButtonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        shouldFitContainer: true,
        onClick: onChatClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cbd9aafdcdee594b$var$chatToAgentButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.050",
        xcss: $cbd9aafdcdee594b$var$chatPillButtonInlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cbd9aafdcdee594b$var$chatPillIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kDlNh.ChatPillIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $cbd9aafdcdee594b$var$chatPillTextStyles
    }, formatMessage((0, $kQ7TK.messages).actionChatToAgent)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
                ...props,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($34Io4))),
                label: "more",
                ref: triggerRef
            }),
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, agentActions.map(({ text: text, onClick: onClick }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            key: idx,
            onClick: onClick
        }, text);
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        hasSeparator: true
    }, agentSetting.map(({ text: text, onClick: onClick }, idx)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            key: idx,
            onClick: onClick
        }, text);
    }))));
};

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);
/* eslint-disable import/order */ 
var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) // Check if it is within dropdown and it is a trigger button
        // if it is a nested dropdown, clicking trigger won't close the dropdown
        // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
        return;
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    }));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);

const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if (isLayerDisabled()) {
            // if nested dropdown isOpen we need to close on Tab key press
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});


parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});

parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});


parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});

parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jFtVs = parcelRequire("jFtVs");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $jFtVs.useUID)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});


parcelRegister("34Io4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::814443588b4f2d6fcc3849858668de22>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23d42d3583f8fd73$var$_react = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $23d42d3583f8fd73$var$_showMoreHorizontal = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("7JXZ0")));

var $23d42d3583f8fd73$var$_more = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("jG1wZ")));
function $23d42d3583f8fd73$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23d42d3583f8fd73$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $23d42d3583f8fd73$var$_react.default.createElement($23d42d3583f8fd73$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $23d42d3583f8fd73$var$_more.default
    }, props));
$23d42d3583f8fd73$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $23d42d3583f8fd73$var$_default = module.exports.default = $23d42d3583f8fd73$var$ShowMoreHorizontalIcon;

});

parcelRegister("kDlNh", function(module, exports) {

$parcel$export(module.exports, "ChatPillIcon", () => $a3e4a399a3fc0cd1$export$38f9b635c1c454e7);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $a3e4a399a3fc0cd1$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.00023 14.25C7.86431 14.25 7.73094 14.287 7.61439 14.3569L3.75024 16.6752V14V4.99998C3.75024 4.30963 4.30988 3.74999 5.00023 3.74998L15.0002 3.74984C15.6906 3.74984 16.2502 4.30948 16.2502 4.99984V12.9999C16.2502 13.6902 15.6906 14.2498 15.0003 14.2499L8.00023 14.25Z",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        fill: "transparent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "6",
        y: "8",
        width: "2",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "9",
        y: "8",
        width: "2",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "12",
        y: "8",
        width: "2",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }));
const $a3e4a399a3fc0cd1$export$38f9b635c1c454e7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        ...props,
        glyph: $a3e4a399a3fc0cd1$var$CustomGlyph,
        label: "",
        size: "small"
    });

});

parcelRegister("kQ7TK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a148be47cef329d7$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a148be47cef329d7$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    actionChatToAgent: {
        id: 'ptc-directory.agent-profile.action.dropdown.chat-to-agent.nonfinal',
        defaultMessage: 'Chat to Agent',
        description: 'Text for the "chat to agent" action to chat to the agent'
    },
    actionDelete: {
        id: 'ptc-directory.agent-profile.action.dropdown.delete.nonfinal',
        defaultMessage: 'Delete Agent',
        description: 'Text for the "Delete" action to delete an agent'
    },
    actionEdit: {
        id: 'ptc-directory.agent-profile.action.dropdown.edit.nonfinal',
        defaultMessage: 'Edit Agent',
        description: 'Text for the "Edit" action to edit an agent'
    },
    actionCopyLink: {
        id: 'ptc-directory.agent-profile.action.dropdown.copy-link.nonfinal',
        defaultMessage: 'Copy link',
        description: 'Text for the Copy link of an agent'
    },
    actionDuplicate: {
        id: 'ptc-directory.agent-profile.action.dropdown.duplicate.nonfinal',
        defaultMessage: 'Duplicate Agent',
        description: 'Text for the Duplicate Agent action to create a duplicate'
    }
});

});


parcelRegister("jvkFO", function(module, exports) {

$parcel$export(module.exports, "AgentConversationStartersSection", () => $2934ad15767049f9$export$574a87e4832466ff);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $1zbEq = parcelRequire("1zbEq");

var $fc0pM = parcelRequire("fc0pM");

var $effNQ = parcelRequire("effNQ");
const $2934ad15767049f9$export$574a87e4832466ff = ({ isAgentDefault: isAgentDefault, onConversationStarterClick: onConversationStarterClick, userDefinedConversationStarters: userDefinedConversationStarters })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleConversationStarterClick = (conversationStarter)=>{
        onConversationStarterClick(conversationStarter);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $effNQ.MainContentHeaders), null, formatMessage($2934ad15767049f9$var$messages.openChatLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        alignInline: "start",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fc0pM.AgentConversationStarters), {
        isAgentDefault: isAgentDefault,
        onConversationStarterClick: handleConversationStarterClick,
        userDefinedConversationStarters: userDefinedConversationStarters
    })));
};
const $2934ad15767049f9$var$messages = (0, $90IgZ.defineMessages)({
    openChatLabel: {
        id: 'ptc-directory.agent-profile.conversation-starter.header',
        defaultMessage: 'Open chat',
        description: 'Label for about section of the agent'
    }
});

});
parcelRegister("fc0pM", function(module, exports) {

$parcel$export(module.exports, "getConversationStarters", () => $09834075c65ca3b7$export$c2d882153e0984c5);
$parcel$export(module.exports, "AgentConversationStarters", () => $09834075c65ca3b7$export$171adfc74aa509c3);
$parcel$export(module.exports, "ConversationStarters", () => $09834075c65ca3b7$export$ea338c37011da44c);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $j9fWg = parcelRequire("j9fWg");

var $iAqay = parcelRequire("iAqay");

var $9Amv1 = parcelRequire("9Amv1");

var $i1PAb = parcelRequire("i1PAb");

var $8qJMo = parcelRequire("8qJMo");
const $09834075c65ca3b7$export$c2d882153e0984c5 = ({ userDefinedConversationStarters: userDefinedConversationStartersParam, isAgentDefault: isAgentDefault })=>{
    const customAgentConversationStarters = [
        (0, $8qJMo.messages).agentEmptyStateSuggestion1,
        (0, $8qJMo.messages).agentEmptyStateSuggestion2,
        (0, $8qJMo.messages).agentEmptyStateSuggestion3
    ];
    const userDefinedConversationStarters = userDefinedConversationStartersParam ?? [];
    const defaultAgentConversationStarters = [
        (0, $8qJMo.messages).emptyStateSuggestion1,
        (0, $8qJMo.messages).emptyStateSuggestion2,
        (0, $8qJMo.messages).emptyStateSuggestion3
    ];
    const getCombinedConversationStarters = ()=>{
        const shouldCombine = !isAgentDefault;
        if (shouldCombine) // Return default suggestions + user defined suggestions with a max of 3 suggestions
        return [
            ...customAgentConversationStarters.slice(0, 3 - userDefinedConversationStarters.length),
            ...userDefinedConversationStarters
        ];
        return defaultAgentConversationStarters;
    };
    return {
        userDefinedConversationStarters: userDefinedConversationStarters,
        customAgentConversationStarters: customAgentConversationStarters,
        defaultAgentConversationStarters: defaultAgentConversationStarters,
        combinedConversationStarters: getCombinedConversationStarters()
    };
};
const $09834075c65ca3b7$export$171adfc74aa509c3 = ({ userDefinedConversationStarters: userDefinedConversationStarters, isAgentDefault: isAgentDefault, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { combinedConversationStarters: combinedConversationStarters } = (0, $eUqFw.useMemo)(()=>$09834075c65ca3b7$export$c2d882153e0984c5({
            userDefinedConversationStarters: userDefinedConversationStarters,
            isAgentDefault: isAgentDefault
        }), [
        userDefinedConversationStarters,
        isAgentDefault
    ]);
    const starters = (0, $eUqFw.useMemo)(()=>combinedConversationStarters.map((starter)=>typeof starter === 'string' ? starter : formatMessage(starter)), [
        combinedConversationStarters,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($09834075c65ca3b7$export$ea338c37011da44c, {
        starters: starters,
        ...props
    });
};
const $09834075c65ca3b7$export$ea338c37011da44c = ({ starters: starters, onConversationStarterClick: onConversationStarterClick, showReloadButton: showReloadButton = false, onReloadButtonClick: onReloadButtonClick = ()=>{} })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, starters.map((starter, index)=>{
        const isLastStarter = index === starters.length - 1;
        const chatPill = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i1PAb.ChatPill), {
            testId: "conversation-starter",
            key: starter,
            onClick: ()=>onConversationStarterClick(starter)
        }, starter);
        return isLastStarter && showReloadButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            space: "space.050",
            grow: "fill",
            alignInline: "end",
            key: starter
        }, chatPill, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAqay))),
            onClick: onReloadButtonClick,
            appearance: "subtle",
            label: ""
        })) : chatPill;
    }));
};

});
parcelRegister("iAqay", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5045909710eacb77d2c65ed32045ebbb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d87fe36e3f00d89c$var$_react = $d87fe36e3f00d89c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d87fe36e3f00d89c$var$_UNSAFE_baseNew = $d87fe36e3f00d89c$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $d87fe36e3f00d89c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Retry".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d87fe36e3f00d89c$var$RetryIcon = (props)=>/*#__PURE__*/ $d87fe36e3f00d89c$var$_react.default.createElement($d87fe36e3f00d89c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 14a6 6 0 1 1 6-6v3"/><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M15.375 8.375 12.75 11l-2.625-2.625"/>`
    }, props));
$d87fe36e3f00d89c$var$RetryIcon.displayName = 'RetryIcon';
var $d87fe36e3f00d89c$var$_default = module.exports.default = $d87fe36e3f00d89c$var$RetryIcon;

});

parcelRegister("i1PAb", function(module, exports) {

$parcel$export(module.exports, "ChatPill", () => $54ff5c9d6063b7a8$export$e33faa86e0996d96);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $kDlNh = parcelRequire("kDlNh");
const $54ff5c9d6063b7a8$var$buttonStyles = (0, $1ZAYh.xcss)({
    color: 'color.text',
    padding: 'space.100',
    borderRadius: 'border.radius.200',
    borderBottomRightRadius: "var(--ds-border-radius-050, 2px)",
    lineHeight: '16px',
    fontWeight: '500',
    fontSize: '14px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flexShrink: 1,
    backgroundColor: 'color.background.neutral',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.pressed'
    }
});
const $54ff5c9d6063b7a8$var$buttonInlineStyles = (0, $1ZAYh.xcss)({
    paddingInline: 'space.025'
});
const $54ff5c9d6063b7a8$var$queryTextStyles = (0, $1ZAYh.xcss)({
    wordBreak: 'break-word',
    textAlign: 'left'
});
const $54ff5c9d6063b7a8$var$whiteSpacePreWrapStyles = (0, $1ZAYh.xcss)({
    whiteSpace: 'pre-wrap'
});
const $54ff5c9d6063b7a8$export$e33faa86e0996d96 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        ref: ref,
        ...props,
        xcss: $54ff5c9d6063b7a8$var$buttonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.050",
        xcss: $54ff5c9d6063b7a8$var$buttonInlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kDlNh.ChatPillIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $54ff5c9d6063b7a8$var$queryTextStyles,
            whiteSpacePreWrap && $54ff5c9d6063b7a8$var$whiteSpacePreWrapStyles
        ]
    }, children))));

});

parcelRegister("8qJMo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e80cab5507804e86$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $e80cab5507804e86$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    emptyStateSuggestion1: {
        id: 'ai-mate.chat-history.empty-state.suggestion1',
        defaultMessage: 'Are any of my tickets overdue?',
        description: 'The first suggestion displayed in the empty state of the chat history'
    },
    emptyStateSuggestion2: {
        id: 'ai-mate.chat-history.empty-state.suggestion2',
        defaultMessage: 'What should I work on next?',
        description: 'The second suggestion displayed in the empty state of the chat history'
    },
    emptyStateSuggestion3: {
        id: 'ai-mate.chat-history.empty-state.suggestion3',
        defaultMessage: 'Write an update about my week',
        description: 'The third suggestion displayed in the empty state of the chat history'
    },
    agentEmptyStateSuggestion1: {
        id: 'ai-mate.chat-history.empty-state.agent-suggestion1',
        defaultMessage: 'Tell me about yourself',
        description: 'The first suggestion displayed in the empty state when an agent is selected'
    },
    agentEmptyStateSuggestion2: {
        id: 'ai-mate.chat-history.empty-state.agent-suggestion2',
        defaultMessage: 'What can you help me with?',
        description: 'The second suggestion displayed in the empty state when an agent is selected'
    },
    agentEmptyStateSuggestion3: {
        id: 'ai-mate.chat-history.empty-state.agent-suggestion3',
        defaultMessage: "Summarize what I'm looking at",
        description: 'The third suggestion displayed in the empty state when an agent is selected'
    }
});

});


parcelRegister("effNQ", function(module, exports) {

$parcel$export(module.exports, "MainContentHeaders", () => $45b528ee6d46e614$export$161f9e38c5e0d38e);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");
const $45b528ee6d46e614$export$161f9e38c5e0d38e = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h5",
        size: "small"
    }, children);

});


parcelRegister("1g5v7", function(module, exports) {

$parcel$export(module.exports, "AgentCreator", () => $ae5c659b238632be$export$d892e919a94dad49);

var $eUqFw = parcelRequire("eUqFw");

var $920hm = parcelRequire("920hm");

var $j9wA1 = parcelRequire("j9wA1");

var $hKky0 = parcelRequire("hKky0");
const $ae5c659b238632be$export$d892e919a94dad49 = ({ creator: creator, create_type: create_type })=>{
    const userId = create_type === 'CUSTOMER' && creator ? (0, $j9wA1.trimUserARI)(creator) : '';
    const { data: userData, isLoading: userInfoIsLoading } = (0, $hKky0.default)({
        userId: userId || ''
    });
    const getCreator = ()=>{
        switch(create_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                return {
                    type: 'CUSTOMER',
                    name: userData.fullName,
                    profileLink: `/people/${userData.id}`
                };
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $920hm.AgentProfileCreator), {
        creator: getCreator(),
        isLoading: userInfoIsLoading,
        onCreatorLinkClick: ()=>{}
    });
};

});
parcelRegister("j9wA1", function(module, exports) {

$parcel$export(module.exports, "filterExcludedMessages", () => $4bb3163e6510fef5$export$c29ee7cc86cf93b3);
$parcel$export(module.exports, "ORG_ARI_PREFIX", () => $4bb3163e6510fef5$export$1c01d3601a97c3b);
$parcel$export(module.exports, "fromV2ToTeamSearchViewFormat", () => $4bb3163e6510fef5$export$af61e778dfb162b1);
$parcel$export(module.exports, "trimUserARI", () => $4bb3163e6510fef5$export$4fd803d471120b8f);
const $4bb3163e6510fef5$var$EXCLUDED_GRAPHQL_ERROR_MESSAGES = [
    'TeamDeleted'
];
function $4bb3163e6510fef5$export$c29ee7cc86cf93b3(errors) {
    return errors.filter((error)=>$4bb3163e6510fef5$var$EXCLUDED_GRAPHQL_ERROR_MESSAGES.every((excludedMessage)=>!error.message.includes(excludedMessage)) && error?.extensions?.classification !== 'TEAMS_TEAM_DELETED');
}
const $4bb3163e6510fef5$export$ec4e6762fd0f4a48 = 'ari:cloud:teams::team/';
const $4bb3163e6510fef5$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';
const $4bb3163e6510fef5$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $4bb3163e6510fef5$export$1c01d3601a97c3b = 'ari:cloud:platform::org/';
const $4bb3163e6510fef5$export$af61e778dfb162b1 = (nodes)=>{
    return nodes.map((node)=>{
        return {
            id: $4bb3163e6510fef5$export$5916b2f8faacfe5a(node.team.id),
            orgId: node.team.organizationId,
            membershipSettings: node.team.membershipSettings,
            description: node.team.description,
            displayName: node.team.displayName,
            state: node.team.state,
            largeAvatarImageUrl: node.team.largeAvatarImageUrl,
            smallAvatarImageUrl: node.team.smallAvatarImageUrl,
            largeHeaderImageUrl: node.team.largeHeaderImageUrl,
            smallHeaderImageUrl: node.team.smallHeaderImageUrl,
            members: node.team.members?.nodes?.filter((memberNode)=>memberNode.member?.id)?.map((memberNode)=>({
                    id: $4bb3163e6510fef5$export$4fd803d471120b8f(memberNode.member?.id),
                    status: memberNode.member?.accountStatus,
                    fullName: memberNode.member?.name || '',
                    avatarUrl: memberNode.member?.picture
                })),
            memberCount: node.memberCount,
            includesYou: node.includesYou
        };
    });
};
const $4bb3163e6510fef5$export$5916b2f8faacfe5a = (teamId = '')=>{
    return teamId.replace($4bb3163e6510fef5$export$cfedc369802e0c68, '').replace($4bb3163e6510fef5$export$ec4e6762fd0f4a48, ''); // PTC-4213 will remove the references to the old team ARI
};
const $4bb3163e6510fef5$export$4fd803d471120b8f = (userId = '')=>{
    return userId.replace($4bb3163e6510fef5$export$470b0d72e4fdc43a, '');
};
const $4bb3163e6510fef5$export$a94a044414e86bdc = (orgId)=>{
    return orgId?.replace($4bb3163e6510fef5$export$1c01d3601a97c3b, '');
};

});

parcelRegister("hKky0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf83a5773d3bf4a$export$2e2bcd8739ae039);

var $iZuDo = parcelRequire("iZuDo");

var $k7WCG = parcelRequire("k7WCG");
var $fECJU = parcelRequire("fECJU");

var $efuAK = parcelRequire("efuAK");
function $9bf83a5773d3bf4a$var$useCloudUser({ userId: userId }) {
    const { loading: loading, error: error, data: data } = (0, $iZuDo.useQuery)((0, $efuAK.default), {
        client: (0, $k7WCG.getApolloClient)(),
        variables: {
            userId: userId,
            _withCloudId: true
        },
        skip: !userId
    });
    if (error) (0, $fECJU.logErrorMessage)('useCloudUser', error);
    const cloudUser = !error && !loading ? data?.CloudUser : {};
    return {
        data: {
            ...cloudUser,
            userFullName: cloudUser?.fullName || ''
        },
        isLoading: loading,
        hasError: !!error || !loading && !data?.CloudUser,
        error: error
    };
}
var $9bf83a5773d3bf4a$export$2e2bcd8739ae039 = $9bf83a5773d3bf4a$var$useCloudUser;

});
parcelRegister("iZuDo", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $dd35afdbf6e72e7e$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $dd35afdbf6e72e7e$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $dd35afdbf6e72e7e$export$eb9a56e7a29e494);

var $4ErPU = parcelRequire("4ErPU");

var $fKE23 = parcelRequire("fKE23");

var $eUqFw = parcelRequire("eUqFw");

var $jlBDe = parcelRequire("jlBDe");

var $66hGB = parcelRequire("66hGB");

var $8j2fP = parcelRequire("8j2fP");
var $dd35afdbf6e72e7e$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $66hGB.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $8j2fP.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $4ErPU.parser)(document);
        var requiredOperationName = (0, $4ErPU.operationName)(type);
        var usedOperationName = (0, $4ErPU.operationName)(operation.type);
        (0, $8j2fP.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $dd35afdbf6e72e7e$var$QueryData = function(_super) {
    (0, $fKE23.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $jlBDe.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $jlBDe.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $4ErPU.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $fKE23.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $66hGB.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $66hGB.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $66hGB.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $jlBDe.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $jlBDe.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $66hGB.equal)(this.previousOptions.query, query) && (0, $66hGB.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eUqFw.useRef)();
    if (!ref.current || !(0, $66hGB.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $dd35afdbf6e72e7e$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eUqFw.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $dd35afdbf6e72e7e$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $dd35afdbf6e72e7e$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eUqFw.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $eUqFw.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $dd35afdbf6e72e7e$export$dd0a697e1782aedd(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, false);
}
function $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, true);
}
var $dd35afdbf6e72e7e$var$MutationData = function(_super) {
    (0, $fKE23.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $4ErPU.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $4ErPU.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $fKE23.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $fKE23.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $jlBDe.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $66hGB.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eUqFw.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $dd35afdbf6e72e7e$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $dd35afdbf6e72e7e$var$SubscriptionData = function(_super) {
    (0, $fKE23.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $66hGB.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eUqFw.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eUqFw.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $dd35afdbf6e72e7e$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $dd35afdbf6e72e7e$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $4ErPU.getApolloContext)()).client;
    (0, $8j2fP.invariant)(client, 1);
    return client;
}
function $dd35afdbf6e72e7e$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $dd35afdbf6e72e7e$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $dd35afdbf6e72e7e$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});

parcelRegister("efuAK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d62286f4f91f4209$export$2e2bcd8739ae039);

var $9ypom = parcelRequire("9ypom");
var $d62286f4f91f4209$export$2e2bcd8739ae039 = (0, $9ypom.default)`
	query CloudUser($userId: String!, $cloudId: String) {
		CloudUser(userId: $userId, cloudId: $cloudId) {
			id
			fullName
			avatarUrl
			email
			timezone
			locale
			title
			location
			companyName
			department
			statusModifiedDate
			isNotMentionable
			phoneNumber
		}
	}
`;

});



parcelRegister("78YIS", function(module, exports) {

$parcel$export(module.exports, "AgentInstructions", () => $5847f7f86bbb210d$export$48d253a044b54931);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $j9fWg = parcelRequire("j9fWg");

var $dBCpP = parcelRequire("dBCpP");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $effNQ = parcelRequire("effNQ");
const $5847f7f86bbb210d$var$instructionsContainerStyles = (0, $1ZAYh.xcss)({
    border: `1px solid ${"var(--ds-border-input, #8590A2)"}`,
    borderRadius: 'border.radius.100',
    overflowY: 'auto',
    whiteSpace: 'pre-line',
    position: 'relative',
    maxHeight: '100%',
    padding: 'space.100',
    flex: '1'
});
const $5847f7f86bbb210d$var$copyContainerStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: '10px',
    right: '10px'
});
const $5847f7f86bbb210d$var$hiddenStyles = (0, $1ZAYh.xcss)({
    opacity: 0
});
const $5847f7f86bbb210d$export$48d253a044b54931 = ({ promptTemplate: promptTemplate, onCopy: onCopy })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [instructionsHovered, setInstructionsHovered] = (0, $eUqFw.useState)(false);
    const [mouseEnterHappened, setMouseEnterHappened] = (0, $eUqFw.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $effNQ.MainContentHeaders), null, formatMessage($5847f7f86bbb210d$var$messages.instructionsLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $5847f7f86bbb210d$var$instructionsContainerStyles,
        onMouseEnter: ()=>{
            setMouseEnterHappened(true);
            setInstructionsHovered(true);
        },
        onMouseLeave: ()=>{
            setMouseEnterHappened(false);
            setInstructionsHovered(false);
        },
        onFocus: ()=>setInstructionsHovered(true),
        onBlur: ()=>{
            if (!mouseEnterHappened) setInstructionsHovered(false);
        }
    }, promptTemplate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, promptTemplate), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $5847f7f86bbb210d$var$copyContainerStyles,
            !instructionsHovered && $5847f7f86bbb210d$var$hiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage($5847f7f86bbb210d$var$messages.copyInstructionsTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        type: "button",
        onClick: ()=>onCopy(promptTemplate),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dBCpP))),
        appearance: "subtle",
        spacing: "compact",
        label: formatMessage($5847f7f86bbb210d$var$messages.copyInstructionsLabel)
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "em",
        color: "color.text.subtle"
    }, formatMessage($5847f7f86bbb210d$var$messages.noInstructionPlaceholder))));
};
const $5847f7f86bbb210d$var$messages = (0, $90IgZ.defineMessages)({
    instructionsLabel: {
        id: 'ptc-directory.agent-profile.instructions-label',
        defaultMessage: 'Instructions',
        description: 'Label for instructions'
    },
    copyInstructionsLabel: {
        id: 'ptc-directory.agent-profile.copy-instructions-label',
        defaultMessage: 'Copy',
        description: 'Label for copy instructions button'
    },
    copyInstructionsTooltip: {
        id: 'ptc-directory.agent-profile.copy-instructions-tooltip',
        defaultMessage: 'Copy response',
        description: 'Label for copy instructions tooltip'
    },
    noInstructionPlaceholder: {
        id: 'ptc-directory.agent-profile.no-instruction-placeholder',
        defaultMessage: 'This Agent has no custom instructions',
        description: 'Placeholder for no instructionsfdkggkh'
    }
});

});
parcelRegister("dBCpP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d06b6871dd52a33a442123e4596128bc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e7c879c9eefdea2$var$_react = $9e7c879c9eefdea2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9e7c879c9eefdea2$var$_UNSAFE_baseNew = $9e7c879c9eefdea2$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $9e7c879c9eefdea2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e7c879c9eefdea2$var$CopyIcon = (props)=>/*#__PURE__*/ $9e7c879c9eefdea2$var$_react.default.createElement($9e7c879c9eefdea2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentColor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$9e7c879c9eefdea2$var$CopyIcon.displayName = 'CopyIcon';
var $9e7c879c9eefdea2$var$_default = module.exports.default = $9e7c879c9eefdea2$var$CopyIcon;

});


parcelRegister("1V5FM", function(module, exports) {

$parcel$export(module.exports, "useAgentActions", () => $78fdf7c6048d5769$export$9115df56efd01c09);

var $eUqFw = parcelRequire("eUqFw");

var $24e7T = parcelRequire("24e7T");
var $3EWxb = parcelRequire("3EWxb");
var $bH5Sg = parcelRequire("bH5Sg");
const $78fdf7c6048d5769$export$9115df56efd01c09 = ({ product: product, cloudId: cloudId, agentId: agentId })=>{
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $24e7T.useAgentFavourites)({
        experienceId: 'profile-page',
        product: product
    });
    const { onEditAgent: onEditAgent, onCopyAgent: onCopyAgent, onDuplicateAgent: onDuplicateAgent } = (0, $3EWxb.useAgentUrlActions)({
        siteId: cloudId
    });
    const { deleteAgent: deleteRovoAgent } = (0, $bH5Sg.useDeleteAgent)({
        experienceId: 'profile-page',
        product: product
    });
    const setFavouriteAgent = (0, $eUqFw.useCallback)(async (isFavourite)=>{
        if (!agentId) return;
        if (isFavourite) return await favouriteAgent.mutate(agentId);
        else return await unfavouriteAgent.mutate(agentId);
    }, [
        agentId,
        favouriteAgent,
        unfavouriteAgent
    ]);
    const editAgent = ()=>{
        if (!agentId) return;
        onEditAgent(agentId);
    };
    const copyAgent = ()=>{
        if (!agentId) return;
        onCopyAgent(agentId);
    };
    const duplicateAgent = ()=>{
        if (!agentId) return;
        onDuplicateAgent(agentId);
    };
    const deleteAgent = ()=>{
        if (!agentId) return;
        deleteRovoAgent.mutate(agentId);
    };
    return {
        setFavouriteAgent: setFavouriteAgent,
        editAgent: editAgent,
        copyAgent: copyAgent,
        duplicateAgent: duplicateAgent,
        deleteAgent: deleteAgent
    };
};

});
parcelRegister("24e7T", function(module, exports) {

$parcel$export(module.exports, "useAgentFavourites", () => $71277e8a34df4ddc$export$5c4c46b1f93a6e69);

var $19xaS = parcelRequire("19xaS");
var $dXg8a = parcelRequire("dXg8a");

var $1DkoF = parcelRequire("1DkoF");
var $2jCEn = parcelRequire("2jCEn");
const $71277e8a34df4ddc$export$5c4c46b1f93a6e69 = ({ onError: onError, onSuccess: onSuccess, experienceId: experienceId = 'ai-mate', product: product } = {})=>{
    const assistanceService = (0, $1DkoF.useAssistanceService)({
        experienceId: experienceId,
        product: product
    });
    const experience = (0, $dXg8a.useAIMateExperienceTracker)();
    const favouriteAgent = (0, $2jCEn.useMutation)({
        mutationFn: async (id)=>{
            experience.start({
                id: (0, $19xaS.ExperienceName).FAVOURITE_AGENT,
                name: (0, $19xaS.ExperienceName).FAVOURITE_AGENT
            });
            return await assistanceService.favouriteAgent(id);
        },
        onSuccess: async ()=>{
            experience.succeed({
                name: (0, $19xaS.ExperienceName).FAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: true
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $19xaS.ExperienceName).FAVOURITE_AGENT,
                error: error
            });
            onError?.({
                favourite: true
            });
        }
    });
    const unfavouriteAgent = (0, $2jCEn.useMutation)({
        mutationFn: async (id)=>{
            experience.start({
                id: (0, $19xaS.ExperienceName).UNFAVOURITE_AGENT,
                name: (0, $19xaS.ExperienceName).UNFAVOURITE_AGENT
            });
            return await assistanceService.unfavouriteAgent(id);
        },
        onSuccess: async ()=>{
            experience.succeed({
                name: (0, $19xaS.ExperienceName).UNFAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: false
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $19xaS.ExperienceName).UNFAVOURITE_AGENT,
                error: error
            });
            onError?.({
                favourite: false
            });
        }
    });
    return {
        favouriteAgent: favouriteAgent,
        unfavouriteAgent: unfavouriteAgent
    };
};

});
parcelRegister("2jCEn", function(module, exports) {

$parcel$export(module.exports, "useMutation", () => $584bd6830afd3a7d$export$609860bf8b0084c);

var $eUqFw = parcelRequire("eUqFw");

var $cfr3D = parcelRequire("cfr3D");
const $584bd6830afd3a7d$export$609860bf8b0084c = ({ mutationFn: mutationFn, onSuccess: onSuccess, onError: onError })=>{
    const mutationFnRef = (0, $eUqFw.useRef)(mutationFn);
    mutationFnRef.current = mutationFn;
    const onSuccessRef = (0, $eUqFw.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $eUqFw.useRef)(onError);
    onErrorRef.current = onError;
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [isSubmitting, setIsSubmitting] = (0, $eUqFw.useState)(false);
    const mutate = (0, $eUqFw.useCallback)(async (payload, mutateCallback)=>{
        setIsSubmitting(true);
        try {
            const response = await mutationFnRef.current(payload);
            setData(response);
            onSuccessRef.current?.(response);
            mutateCallback?.onSuccess?.(response);
        } catch (error) {
            const apiError = (0, $cfr3D.mapErrorToApiError)(error);
            setError(apiError);
            onErrorRef.current?.(apiError);
            mutateCallback?.onError?.(apiError);
        } finally{
            setIsSubmitting(false);
        }
    }, []);
    return {
        data: data,
        error: error,
        isSubmitting: isSubmitting,
        mutate: mutate
    };
};

});


parcelRegister("3EWxb", function(module, exports) {

$parcel$export(module.exports, "useAgentUrlActions", () => $3b83cfd535b92282$export$56665b80ee272742);

var $eUqFw = parcelRequire("eUqFw");

var $jraxv = parcelRequire("jraxv");

var $2cx0u = parcelRequire("2cx0u");
const $3b83cfd535b92282$export$56665b80ee272742 = ({ siteId: siteId })=>{
    const onEditAgent = (0, $eUqFw.useCallback)((agentId)=>{
        window.open((0, $2cx0u.getAtlasURL)(siteId, `/chat/agents/${agentId}/edit`), '_blank', 'noopener, noreferrer');
    }, [
        siteId
    ]);
    const onCopyAgent = (0, $eUqFw.useCallback)((agentId)=>{
        const rovoParams = (0, $jraxv.encodeRovoParams)({
            pathway: 'chat',
            agentId: agentId
        });
        navigator.clipboard.writeText((0, $2cx0u.getAtlasURL)(siteId, `/chat?${rovoParams}`));
    }, [
        siteId
    ]);
    const onDuplicateAgent = (0, $eUqFw.useCallback)((agentId)=>{
        const rovoParams = (0, $jraxv.encodeRovoParams)({
            pathway: 'agents-create',
            agentId: agentId
        });
        window.open((0, $2cx0u.getAtlasURL)(siteId, `/chat/agents/new?${rovoParams}`), '_blank', 'noopener, noreferrer');
    }, [
        siteId
    ]);
    return {
        onEditAgent: onEditAgent,
        onCopyAgent: onCopyAgent,
        onDuplicateAgent: onDuplicateAgent
    };
};

});
parcelRegister("jraxv", function(module, exports) {

$parcel$export(module.exports, "getRovoParams", () => $3b7d8ccdc00d8b90$export$6405071f390601f7);
$parcel$export(module.exports, "clearPageRovoParams", () => $3b7d8ccdc00d8b90$export$bac15dc8e5e04504);
$parcel$export(module.exports, "addRovoParamsToUrl", () => $3b7d8ccdc00d8b90$export$ef04687636c850fe);
$parcel$export(module.exports, "encodeRovoParams", () => $3b7d8ccdc00d8b90$export$eddc20a009406015);

var $XHGTv = parcelRequire("XHGTv");

var $86gqG = parcelRequire("86gqG");
const $3b7d8ccdc00d8b90$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $3b7d8ccdc00d8b90$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $3b7d8ccdc00d8b90$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch (error) {
        return false;
    }
};
const $3b7d8ccdc00d8b90$export$9748efee331ec573 = (param)=>`${0, $86gqG.ROVO_PARAM_PREFIX}${$3b7d8ccdc00d8b90$export$fda91e425d265029(param)}`;
const $3b7d8ccdc00d8b90$export$f2888183a34644d4 = (param)=>{
    if ((0, $XHGTv.fg)('rovo_chat_params_camelcase')) return $3b7d8ccdc00d8b90$export$858653b7ee3cbb17(param.replace((0, $86gqG.ROVO_PARAM_PREFIX), ''));
    if (param.includes('.')) return param.replace(`${(0, $86gqG.ROVO_PARAM_PREFIX)}.`, '');
    else return $3b7d8ccdc00d8b90$export$858653b7ee3cbb17(param.replace((0, $86gqG.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $3b7d8ccdc00d8b90$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $3b7d8ccdc00d8b90$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $86gqG.ROVO_PARAM_PREFIX))) return;
        const paramKey = $3b7d8ccdc00d8b90$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $3b7d8ccdc00d8b90$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $3b7d8ccdc00d8b90$var$processParams(q).rovoParams;
    } catch (error) {
        return {};
    }
};
const $3b7d8ccdc00d8b90$export$bac15dc8e5e04504 = (clearCloudId)=>{
    const q = new URLSearchParams(window.location.search);
    const { combinedQueryString: combinedQueryString } = $3b7d8ccdc00d8b90$var$processParams(q, {
        filter: clearCloudId ? undefined : [
            'cloudId'
        ]
    });
    window.history.replaceState(null, '', `${window.location.pathname}?${combinedQueryString}`);
};
const $3b7d8ccdc00d8b90$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $3b7d8ccdc00d8b90$export$ef04687636c850fe(window.location.pathname, params));
};
const $3b7d8ccdc00d8b90$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $3b7d8ccdc00d8b90$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $3b7d8ccdc00d8b90$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $3b7d8ccdc00d8b90$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        if ((0, $XHGTv.fg)('rovo_chat_params_camelcase')) acc[$3b7d8ccdc00d8b90$export$9748efee331ec573(key)] = encodeURIComponent(value);
        else {
            acc[`${0, $86gqG.ROVO_PARAM_PREFIX}.${key}`] = encodeURIComponent(value);
            acc[`${0, $86gqG.ROVO_PARAM_PREFIX}${$3b7d8ccdc00d8b90$export$fda91e425d265029(key)}`] = encodeURIComponent(value);
        }
        return acc;
    }, {});
    return Object.entries(params).map(([key, value])=>{
        if ((0, $XHGTv.fg)('rovo_chat_params_camelcase')) return `${$3b7d8ccdc00d8b90$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
        else return `${0, $86gqG.ROVO_PARAM_PREFIX}.${key}=${encodeURIComponent(value)}&${`${0, $86gqG.ROVO_PARAM_PREFIX}${$3b7d8ccdc00d8b90$export$fda91e425d265029(key)}`}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $3b7d8ccdc00d8b90$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $3b7d8ccdc00d8b90$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should 
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    if ((0, $XHGTv.fg)('rovo_chat_params_camelcase')) return (0, $86gqG.ROVO_VALID_PARAMS).map((param)=>`${$3b7d8ccdc00d8b90$export$9748efee331ec573(param)}${suffix}`);
    else return [
        ...(0, $86gqG.ROVO_VALID_PARAMS).map((param)=>`${0, $86gqG.ROVO_PARAM_PREFIX}${$3b7d8ccdc00d8b90$export$fda91e425d265029(param)}${suffix}`),
        ...(0, $86gqG.ROVO_VALID_PARAMS).map((param)=>`${0, $86gqG.ROVO_PARAM_PREFIX}.${param}${suffix}`)
    ];
};

});
parcelRegister("86gqG", function(module, exports) {

$parcel$export(module.exports, "ROVO_PARAM_PREFIX", () => $331b31232415eabe$export$5a550907ffbc9119);
$parcel$export(module.exports, "ROVO_VALID_PARAMS", () => $331b31232415eabe$export$3cd6b610e7ede579);
const $331b31232415eabe$export$5a550907ffbc9119 = 'rovoChat';
const $331b31232415eabe$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId'
];

});


parcelRegister("2cx0u", function(module, exports) {

$parcel$export(module.exports, "getAtlasURL", () => $4c0ab11761f74b7d$export$bfee0f88bf621ad3);

var $jraxv = parcelRequire("jraxv");
const $4c0ab11761f74b7d$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $4c0ab11761f74b7d$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $4c0ab11761f74b7d$var$getAtlasHost = ()=>{
    const host = window.location.host;
    const isStaging = host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('jira-dev.com');
    return isStaging ? $4c0ab11761f74b7d$var$ATLAS_STAGING_URL : $4c0ab11761f74b7d$var$ATLAS_PROD_URL;
};
const $4c0ab11761f74b7d$export$bfee0f88bf621ad3 = (cloudId, path)=>{
    let argConcat = '?';
    let processedPath = path.startsWith('/') ? path : `/${path}`;
    if (processedPath.includes('?')) argConcat = '&';
    return (0, $jraxv.addRovoParamsToUrl)(`${$4c0ab11761f74b7d$var$getAtlasHost()}${processedPath}${argConcat}cloudId=${cloudId}`, {
        cloudId: cloudId
    });
};

});


parcelRegister("bH5Sg", function(module, exports) {

$parcel$export(module.exports, "useDeleteAgent", () => $e03d3ae2ff712ef8$export$89877d4f8d8790ca);

var $19xaS = parcelRequire("19xaS");
var $dXg8a = parcelRequire("dXg8a");

var $1DkoF = parcelRequire("1DkoF");
var $2jCEn = parcelRequire("2jCEn");
const $e03d3ae2ff712ef8$export$89877d4f8d8790ca = ({ experienceId: experienceId, product: product, onSuccess: onSuccess, onError: onError } = {})=>{
    const experience = (0, $dXg8a.useAIMateExperienceTracker)();
    const assistanceService = (0, $1DkoF.useAssistanceService)({
        experienceId: experienceId,
        product: product
    });
    const deleteAgent = (0, $2jCEn.useMutation)({
        mutationFn: async (id)=>{
            experience.start({
                id: (0, $19xaS.ExperienceName).DELETE_AGENT,
                name: (0, $19xaS.ExperienceName).DELETE_AGENT
            });
            return await assistanceService.deleteAgent(id);
        },
        onSuccess: async (data)=>{
            experience.succeed({
                name: (0, $19xaS.ExperienceName).DELETE_AGENT
            });
            onSuccess?.();
            return data;
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $19xaS.ExperienceName).DELETE_AGENT,
                error: error
            });
            onError?.();
        }
    });
    return {
        deleteAgent: deleteAgent
    };
};

});



parcelRegister("c50mH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('023HH');
        const value = parcelRequire('8HmIw');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("023HH").then(()=>parcelRequire('8HmIw'));
}

});


parcelRegister("4RubW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1043d4bd78ae695$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bsMUn = parcelRequire("bsMUn");
var $74Hyh = parcelRequire("74Hyh");

var $kZURK = parcelRequire("kZURK");

var $aVf8h = parcelRequire("aVf8h");
function $d1043d4bd78ae695$var$recordPageVisitOrigin(replace) {
    const url = new URL(window.location.href);
    if (!url || !url.searchParams) return;
    // ref contains a product like confluence, jira etc.
    const ref = url.searchParams.get('ref') || '';
    // src contains a location like appswitcher, peopledrawer etc.
    const src = url.searchParams.get('src') || '';
    if (!ref && !src) return;
    // save referrer info for retrieving it in further screen events
    (0, $bsMUn.default).set({
        src: src,
        ref: ref
    });
    url.searchParams.delete('ref');
    url.searchParams.delete('src');
    // replace location if it changed after removing ref and src query params
    if (replace) replace(`${url.pathname}${url.search}`);
}
function $d1043d4bd78ae695$var$RecordTransition(props) {
    const { name: name } = props;
    const { replace: replace } = (0, $kZURK.useAppConfig)();
    const refInitialLoadTracked = (0, $eUqFw.useRef)(false);
    const analytics = (0, $74Hyh.default)();
    (0, $eUqFw.useEffect)(()=>{
        if (!refInitialLoadTracked.current) {
            refInitialLoadTracked.current = true;
            // stores referrer info
            $d1043d4bd78ae695$var$recordPageVisitOrigin(replace);
        } else // cleanup stored referrer info on transition
        (0, $bsMUn.default).cleanup();
        (0, $aVf8h.default)(name, analytics);
    }, [
        analytics,
        name,
        replace
    ]);
    return null;
}
var $d1043d4bd78ae695$export$2e2bcd8739ae039 = $d1043d4bd78ae695$var$RecordTransition;

});
parcelRegister("aVf8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $b988b1f76895c54f$export$2e2bcd8739ae039);

var $cLI0M = parcelRequire("cLI0M");
let $b988b1f76895c54f$var$dwellHelper = null;
const $b988b1f76895c54f$var$buildDwellEventData = (source)=>{
    return {
        actionSubject: 'page',
        source: source
    };
};
const $b988b1f76895c54f$var$sendDwellEvent = (eventData, analyticsClient)=>{
    analyticsClient.sendTrackEvent(eventData);
};
const $b988b1f76895c54f$var$initialiseDwellTime = (eventSource, analyticsClient)=>{
    if (eventSource) {
        const updatedEventData = $b988b1f76895c54f$var$buildDwellEventData(eventSource);
        $b988b1f76895c54f$var$dwellHelper = (0, $cLI0M.default)((eventData)=>$b988b1f76895c54f$var$sendDwellEvent(eventData, analyticsClient), updatedEventData);
        $b988b1f76895c54f$var$dwellHelper.start();
    }
};
const $b988b1f76895c54f$var$recordNewPageForDwellTime = (eventSource)=>{
    if ($b988b1f76895c54f$var$dwellHelper) {
        if (eventSource) {
            const updatedEventData = $b988b1f76895c54f$var$buildDwellEventData(eventSource);
            $b988b1f76895c54f$var$dwellHelper.newPage(updatedEventData);
        } else // eslint-disable-next-line no-console
        console.error('Unable to record dwell time transition - missing analytics key or source mapping for route');
    } else // eslint-disable-next-line no-console
    console.error('Dwell time has not been initialised');
};
/**
 * Initialises dwell time measurement, or records a page transition if it is already initialised.
 * Note that dwell time will only be initialised on routes that have an analytics key, which should be
 * all routes except for those that result in a redirect.
 */ const $b988b1f76895c54f$var$recordDwellTime = (analyticsKey, analyticsClient)=>{
    const eventName = analyticsClient.mapAnalyticsKeyToEvent(analyticsKey);
    const eventSource = eventName ? `${eventName}Screen` : null;
    if (!$b988b1f76895c54f$var$dwellHelper) $b988b1f76895c54f$var$initialiseDwellTime(eventSource, analyticsClient);
    else $b988b1f76895c54f$var$recordNewPageForDwellTime(eventSource);
};
var $b988b1f76895c54f$export$2e2bcd8739ae039 = $b988b1f76895c54f$var$recordDwellTime;

});
parcelRegister("cLI0M", function(module, exports) {

$parcel$export(module.exports, "default", () => $f442b6c617c34d0a$export$2e2bcd8739ae039);

var $4NcB5 = parcelRequire("4NcB5");
const $f442b6c617c34d0a$var$getDwellTimeHelper = (sendMethod, eventData)=>{
    return new (0, $4NcB5.default)(sendMethod, eventData);
};
var $f442b6c617c34d0a$export$2e2bcd8739ae039 = $f442b6c617c34d0a$var$getDwellTimeHelper;

});




parcelRegister("ghjoM", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a475b509b910560$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $7qMvm = parcelRequire("7qMvm");

var $1DMxn = parcelRequire("1DMxn");

var $4RubW = parcelRequire("4RubW");
function $2a475b509b910560$var$hasProfileProp(state) {
    return !!state && 'profile' in state;
}
const $2a475b509b910560$var$KudosPageRoute = ({ match: match, location: location })=>{
    const { uuid: uuid } = match.params;
    const profile = $2a475b509b910560$var$hasProfileProp(location.state) ? location.state.profile : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RubW.default), {
        name: (0, $1io2n.AnalyticsKeys).KUDOS_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qMvm.default), {
        name: (0, $1io2n.AnalyticsKeys).KUDOS_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1DMxn.default), {
        uuid: uuid,
        referrerProfile: profile
    }));
};
var $2a475b509b910560$export$2e2bcd8739ae039 = $2a475b509b910560$var$KudosPageRoute;

});
parcelRegister("1DMxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c533f04d7033e50$export$2e2bcd8739ae039);

var $bYKiA = parcelRequire("bYKiA");

const $2c533f04d7033e50$var$LazyKudosPage = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("aYfkD")),
    loading: ()=>null
});
$2c533f04d7033e50$var$LazyKudosPage.displayName = 'lazy(KudosPage)';
var $2c533f04d7033e50$export$2e2bcd8739ae039 = $2c533f04d7033e50$var$LazyKudosPage;

});
parcelRegister("aYfkD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('25fzR')
        ]);
        const value = parcelRequire('d5pVi');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("25fzR")
    ]).then(()=>parcelRequire('d5pVi'));
}

});



parcelRegister("4ckcM", function(module, exports) {

$parcel$export(module.exports, "default", () => $32e35733ed476493$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $hYfIu = parcelRequire("hYfIu");
var $74Hyh = parcelRequire("74Hyh");
var $gakch = parcelRequire("gakch");

var $3WT37 = parcelRequire("3WT37");
function $32e35733ed476493$export$2e2bcd8739ae039(props) {
    const { contextEntryPoint: contextEntryPoint, location: location } = props;
    const [{ principalUserId: principalUserId }] = (0, $gakch.usePrincipalUser)();
    const analytics = (0, $74Hyh.default)();
    const url = new URL(window.location.href);
    const ref = (0, $hYfIu.sanitiseValue)(url.searchParams.get('ref') || '', {
        shouldHaveSafeCharsOnly: true,
        shouldEncode: true
    });
    (0, $eUqFw.useEffect)(()=>{
        analytics.pushTrackEvent({
            source: (0, $1io2n.AnalyticsEventSource).USER_PROFILE_SCREEN,
            actionSubject: 'redirectMePathToMyProfile',
            action: (0, $1io2n.AnalyticsEventActions).REDIRECTED,
            attributes: {
                ref: ref
            }
        });
    }, [
        analytics,
        ref
    ]);
    if (!principalUserId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3WT37.default), {
        to: `${contextEntryPoint}/${principalUserId}${location.search}`
    });
}

});
parcelRegister("gakch", function(module, exports) {

$parcel$export(module.exports, "usePrincipalUser", () => $3e5c3574957a0740$export$33e3bf16c7530dd4);

var $WBLbN = parcelRequire("WBLbN");

var $cAxhS = parcelRequire("cAxhS");
var $iuVe2 = parcelRequire("iuVe2");
// Private actions:
// It is called by `getPrincipalUserInfo` action
const $3e5c3574957a0740$var$getIsSiteAdmin = (cloudId)=>async ({ setState: setState })=>{
        if (!cloudId) {
            setState({
                isSiteAdmin: false
            });
            return;
        }
        let isSiteAdmin = false;
        try {
            isSiteAdmin = await (0, $cAxhS.teamsClient).getIsSiteAdmin(cloudId);
        } catch (e) {
        // do nothing because isSiteAdmin is returned as false
        } finally{
            setState({
                isSiteAdmin: isSiteAdmin
            });
        }
    };
// it is called by `getPrincipalUserInfo` action
const $3e5c3574957a0740$var$getMutability = (userId)=>async ({ setState: setState })=>{
        try {
            const data = await (0, $cAxhS.teamsClient).getProfileWithMutability(userId);
            setState({
                mutabilityConstraints: data
            });
        } catch (e) {
        // do nothing because isSiteAdmin is returned as false
        }
    };
const $3e5c3574957a0740$var$actions = {
    /**
	 * Get user information of current logged-in user.
	 * @param cloudId: If Cloud Id is passed, that means People Directory is rendered in a site and we use Cloud Id to check 'isSiteAdmin' info.
	 * If Cloud Id is not passed, `isSiteAdmin` is false by default.
	 */ getPrincipalUserInfo: (cloudId)=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            // stop fetching when it is already fetched
            if (getState().isFetching || getState().hasLoaded) return;
            setState({
                isFetching: true,
                hasLoaded: false
            });
            try {
                const userBasicData = await (0, $iuVe2.userInfoProvider).get();
                setState({
                    principalUserId: userBasicData.userId,
                    ...userBasicData
                });
                dispatch($3e5c3574957a0740$var$getIsSiteAdmin(cloudId));
                dispatch($3e5c3574957a0740$var$getMutability(userBasicData.userId));
                setState({
                    hasLoaded: true
                });
            } catch (e) {
                setState({
                    hasError: true,
                    hasLoaded: false
                });
            } finally{
                setState({
                    isFetching: false
                });
            }
        }
};
const $3e5c3574957a0740$var$initialState = {
    principalUserId: '',
    avatarUrl: '',
    email: '',
    fullName: '',
    title: '',
    isSiteAdmin: false,
    isFetching: false,
    hasError: false,
    hasLoaded: false
};
/**
 * Manage states of a site
 */ const $3e5c3574957a0740$var$Store = (0, $WBLbN.createStore)({
    initialState: $3e5c3574957a0740$var$initialState,
    actions: $3e5c3574957a0740$var$actions,
    name: 'PrincipalUser'
});
const $3e5c3574957a0740$export$33e3bf16c7530dd4 = (0, $WBLbN.createHook)($3e5c3574957a0740$var$Store);

});
parcelRegister("iuVe2", function(module, exports) {

$parcel$export(module.exports, "userInfoProvider", () => $9b8eb04ff6aedda1$export$30a852ca4cb27370);

var $i6gsr = parcelRequire("i6gsr");
// Needs to be declared here to avoid blowing up this earlyInit bundle
class $9b8eb04ff6aedda1$var$FetchError extends Error {
    constructor(response){
        super(`Request failed with status ${response.status}`);
        this.response = response;
        this.name = this.constructor.name;
    }
}
class $9b8eb04ff6aedda1$export$dc10e400a1189789 {
    get(fetchOp = fetch) {
        if (this.promise) return this.promise;
        const getJson = (url)=>fetchOp(url, {
                method: 'GET',
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response)=>{
                if (!response.ok) throw new $9b8eb04ff6aedda1$var$FetchError(response);
                return response.json();
            });
        this.promise = getJson(`${(0, $i6gsr.DEFAULT_CONFIG).stargateRoot}/me`).then((me)=>{
            return {
                userId: me.account_id,
                locale: me.locale,
                fullName: me.name,
                avatarUrl: me.picture,
                email: me.email,
                title: me.extended_profile?.job_title
            };
        });
        return this.promise;
    }
}
const $9b8eb04ff6aedda1$export$30a852ca4cb27370 = new $9b8eb04ff6aedda1$export$dc10e400a1189789();

});


parcelRegister("3WT37", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f185e6d4784d68f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kZURK = parcelRequire("kZURK");
const $0f185e6d4784d68f$var$Redirect = ({ to: to })=>{
    const { replace: replace } = (0, $kZURK.useAppConfig)();
    (0, $eUqFw.useEffect)(()=>{
        replace(to);
    }, [
        replace,
        to
    ]);
    return null;
};
var $0f185e6d4784d68f$export$2e2bcd8739ae039 = $0f185e6d4784d68f$var$Redirect;

});


parcelRegister("p3lye", function(module, exports) {

$parcel$export(module.exports, "default", () => $60adec8a9bcebfae$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3WT37 = parcelRequire("3WT37");
const $60adec8a9bcebfae$var$RootRedirect = ({ location: location })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3WT37.default), {
        to: `search${location.search}`
    });
var $60adec8a9bcebfae$export$2e2bcd8739ae039 = $60adec8a9bcebfae$var$RootRedirect;

});

parcelRegister("3RsMI", function(module, exports) {

$parcel$export(module.exports, "RouteWithOrgIdLoading", () => $2521fe5296456413$export$ae0909755df943ac);

var $eUqFw = parcelRequire("eUqFw");

var $7QNSj = parcelRequire("7QNSj");

var $kwce8 = parcelRequire("kwce8");

var $4Bees = parcelRequire("4Bees");

var $cWYE1 = parcelRequire("cWYE1");

var $jnlyS = parcelRequire("jnlyS");

var $p3lye = parcelRequire("p3lye");
function $2521fe5296456413$export$ae0909755df943ac({ LoadingComponent: LoadingComponent, ...props }) {
    const [{ orgId: orgId }] = (0, $cWYE1.useOrg)();
    const [timedOut, setTimedOut] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(false);
    const handleNoOrgId = (0, $eUqFw.useCallback)(()=>{
        (0, $jnlyS.logErrorMessage)('No orgId found after 10 seconds', {
            ...props
        });
        setTimedOut(true);
    }, [
        setTimedOut,
        props
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (orgId) return;
        const timeout = setTimeout(()=>{
            if (!orgId) handleNoOrgId();
        }, 10000);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        orgId,
        handleNoOrgId
    ]);
    if (timedOut) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $p3lye.default), {
        location: {
            search: ''
        }
    });
    if (!orgId) return LoadingComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadingComponent, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2521fe5296456413$var$DefaultLoadingWrapper, {
        "data-testid": "route-with-org-id-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: 'large'
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7QNSj.default), props);
}
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2521fe5296456413$var$DefaultLoadingWrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1wps406-0"
})`height:100%;width:100%;padding-top:100px;display:flex;justify-content:center;align-items:center;`;

});

parcelRegister("bo3ra", function(module, exports) {

$parcel$export(module.exports, "default", () => $a16a5f36c6fc0864$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $7qMvm = parcelRequire("7qMvm");

var $4RubW = parcelRequire("4RubW");

var $kzCiC = parcelRequire("kzCiC");
const $a16a5f36c6fc0864$var$SearchPageRoute = ()=>{
    const url = new URL(window.location.href);
    const searchQuery = url.searchParams.get('q') || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RubW.default), {
        name: (0, $1io2n.AnalyticsKeys).PEOPLE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qMvm.default), {
        name: (0, $1io2n.AnalyticsKeys).PEOPLE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kzCiC.default), {
        searchQuery: searchQuery
    })));
};
var $a16a5f36c6fc0864$export$2e2bcd8739ae039 = $a16a5f36c6fc0864$var$SearchPageRoute;

});
parcelRegister("kzCiC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3286514e9eaf7b47$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $3286514e9eaf7b47$var$LazySearchPage = (0, $eUqFw.lazy)(()=>(parcelRequire("khkcc")));
var $3286514e9eaf7b47$export$2e2bcd8739ae039 = $3286514e9eaf7b47$var$LazySearchPage;

});
parcelRegister("khkcc", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('2WQSq')
        ]);
        const value = parcelRequire('bGd26');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("2WQSq")
    ]).then(()=>parcelRequire('bGd26'));
}

});



parcelRegister("8ziB5", function(module, exports) {

$parcel$export(module.exports, "default", () => $13ed01243c3b343e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $7qMvm = parcelRequire("7qMvm");

var $4RubW = parcelRequire("4RubW");

var $12fHr = parcelRequire("12fHr");
const $13ed01243c3b343e$var$SearchTeamsError = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RubW.default), {
        name: (0, $1io2n.AnalyticsKeys).ALL_TEAMS_DISABLED
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qMvm.default), {
        name: (0, $1io2n.AnalyticsKeys).ALL_TEAMS_DISABLED
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $12fHr.LazyTeamsDisabled), null));
};
var $13ed01243c3b343e$export$2e2bcd8739ae039 = $13ed01243c3b343e$var$SearchTeamsError;

});
parcelRegister("12fHr", function(module, exports) {

$parcel$export(module.exports, "LazyTeamsDisabled", () => $4473c14b416a00c4$export$f063de2a1a254e59);

var $bYKiA = parcelRequire("bYKiA");

const $4473c14b416a00c4$export$f063de2a1a254e59 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("hG9EE")).then((module)=>module.TeamsDisabled),
    loading: ()=>null
});
$4473c14b416a00c4$export$f063de2a1a254e59.displayName = 'lazy(TeamsDisabled)';

});
parcelRegister("hG9EE", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('facth')
        ]);
        const value = parcelRequire('8CW8y');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("facth")
    ]).then(()=>parcelRequire('8CW8y'));
}

});



parcelRegister("jmvGy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f44c0cbd4595141$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $ezVe4 = parcelRequire("ezVe4");
var $7qMvm = parcelRequire("7qMvm");

var $4RubW = parcelRequire("4RubW");

var $dZdCE = parcelRequire("dZdCE");
const $6f44c0cbd4595141$var$TeamProfileRoute = ({ match: match })=>{
    const { teamId: teamId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RubW.default), {
        name: (0, $1io2n.AnalyticsKeys).TEAM_PROFILE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qMvm.default), {
        name: (0, $1io2n.AnalyticsKeys).TEAM_PROFILE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ezVe4.default), {
        teamId: teamId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dZdCE.default), {
        teamId: teamId
    }));
};
var $6f44c0cbd4595141$export$2e2bcd8739ae039 = $6f44c0cbd4595141$var$TeamProfileRoute;

});
parcelRegister("ezVe4", function(module, exports) {

$parcel$export(module.exports, "default", () => $192ff96f466c6f5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fcW8A = parcelRequire("fcW8A");

var $74Hyh = parcelRequire("74Hyh");
function $192ff96f466c6f5c$export$2e2bcd8739ae039({ teamId: teamId }) {
    const analytics = (0, $74Hyh.default)();
    (0, $fcW8A.useInjectedEventAttribute)('teamId', teamId);
    (0, $eUqFw.useEffect)(()=>{
        analytics.setTeamId(teamId);
        ()=>{
            analytics.setTeamId(undefined);
        };
    }, [
        analytics,
        teamId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
}

});

parcelRegister("dZdCE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e85205f6e8c1e20$export$2e2bcd8739ae039);

var $bYKiA = parcelRequire("bYKiA");

const $7e85205f6e8c1e20$var$TeamProfilePage = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("kPfcd")),
    loading: ()=>null
});
$7e85205f6e8c1e20$var$TeamProfilePage.displayName = 'lazy(TeamProfilePage)';
var $7e85205f6e8c1e20$export$2e2bcd8739ae039 = $7e85205f6e8c1e20$var$TeamProfilePage;

});
parcelRegister("kPfcd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('ilh4r')
        ]);
        const value = parcelRequire('eo3a4');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("ilh4r")
    ]).then(()=>parcelRequire('eo3a4'));
}

});



parcelRegister("eurvo", function(module, exports) {

$parcel$export(module.exports, "default", () => $153608dddf255bbc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3WT37 = parcelRequire("3WT37");
const $153608dddf255bbc$var$TeamNoIdRedirect = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3WT37.default), {
        to: "/search"
    });
var $153608dddf255bbc$export$2e2bcd8739ae039 = $153608dddf255bbc$var$TeamNoIdRedirect;

});

parcelRegister("9j0B5", function(module, exports) {

$parcel$export(module.exports, "default", () => $45cc6fb3e555409d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $7qMvm = parcelRequire("7qMvm");

var $15dFk = parcelRequire("15dFk");

var $4RubW = parcelRequire("4RubW");
const $45cc6fb3e555409d$var$UserProfileRoute = ({ match: match })=>{
    const { userId: userId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RubW.default), {
        name: (0, $1io2n.AnalyticsKeys).PROFILE_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qMvm.default), {
        name: (0, $1io2n.AnalyticsKeys).PROFILE_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15dFk.default), {
        userId: decodeURIComponent(userId)
    }));
};
var $45cc6fb3e555409d$export$2e2bcd8739ae039 = $45cc6fb3e555409d$var$UserProfileRoute;

});
parcelRegister("15dFk", function(module, exports) {

$parcel$export(module.exports, "default", () => $77bcf491c855beb3$export$2e2bcd8739ae039);

var $bYKiA = parcelRequire("bYKiA");

const $77bcf491c855beb3$var$LazyUserProfile = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("aAGju")),
    loading: ()=>null
});
$77bcf491c855beb3$var$LazyUserProfile.displayName = 'lazy(UserProfile)';
var $77bcf491c855beb3$export$2e2bcd8739ae039 = $77bcf491c855beb3$var$LazyUserProfile;

});
parcelRegister("aAGju", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('fl34e')
        ]);
        const value = parcelRequire('83PEA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("fl34e")
    ]).then(()=>parcelRequire('83PEA'));
}

});



parcelRegister("eMmYZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2da85389bd9614b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3WT37 = parcelRequire("3WT37");
const $b2da85389bd9614b$var$UserProfileUnknownRoute = ({ match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3WT37.default), {
        to: match.params.userId
    });
var $b2da85389bd9614b$export$2e2bcd8739ae039 = $b2da85389bd9614b$var$UserProfileUnknownRoute;

});

parcelRegister("jIuH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $22745a6a6b53aa64$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $7qMvm = parcelRequire("7qMvm");

var $4RubW = parcelRequire("4RubW");

var $1MR0s = parcelRequire("1MR0s");
const $22745a6a6b53aa64$var$UserProfileWorkedOn = ({ match: match })=>{
    const { userId: userId } = match.params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RubW.default), {
        name: (0, $1io2n.AnalyticsKeys).PROFILE_WORKED_ON_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7qMvm.default), {
        name: (0, $1io2n.AnalyticsKeys).PROFILE_WORKED_ON_PAGE_VIEW
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MR0s.default), {
        userId: decodeURIComponent(userId)
    }));
};
var $22745a6a6b53aa64$export$2e2bcd8739ae039 = $22745a6a6b53aa64$var$UserProfileWorkedOn;

});
parcelRegister("1MR0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $295887d3801b2452$export$2e2bcd8739ae039);

var $bYKiA = parcelRequire("bYKiA");

const $295887d3801b2452$var$LazyUserProfileWorkedOn = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("bAdWA")),
    loading: ()=>null
});
$295887d3801b2452$var$LazyUserProfileWorkedOn.displayName = 'lazy(UserProfileWorkedOn)';
var $295887d3801b2452$export$2e2bcd8739ae039 = $295887d3801b2452$var$LazyUserProfileWorkedOn;

});
parcelRegister("bAdWA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('kmPrM')
        ]);
        const value = parcelRequire('sCQ1U');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("kmPrM")
    ]).then(()=>parcelRequire('sCQ1U'));
}

});




parcelRegister("jmrxX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d469be16bced186$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1PG9B = parcelRequire("1PG9B");

var $fef5r = parcelRequire("fef5r");

var $kZURK = parcelRequire("kZURK");

var $etZQm = parcelRequire("etZQm");
const $2d469be16bced186$var$appProductMap = {
    '': '',
    'site-directory': '',
    'confluence-directory': (0, $1PG9B.ProductName).CONFLUENCE,
    'jira-directory': (0, $1PG9B.ProductName).JIRA,
    'teamcentral-directory': (0, $1PG9B.ProductName).ATLAS,
    'home-directory': (0, $1PG9B.ProductName).HOME
};
const $2d469be16bced186$var$mapAppToProduct = (app)=>{
    return $2d469be16bced186$var$appProductMap[app];
};
class $2d469be16bced186$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        // This is here to let productFeatureFlags from getting updated via props
        const productFeatureFlags = {
            ...this.state.productFeatureFlags,
            ...this.props.productFeatureFlags
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZURK.default).Provider, {
            value: {
                ...this.props,
                ...this.state,
                productFeatureFlags: productFeatureFlags
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.addFlag = (props)=>{
            const { type: type, ...rest } = props;
            this.props.addFlag({
                ...rest,
                id: rest.id ? `${rest.id}.${Date.now()}` : Date.now(),
                type: type,
                appearance: 'normal',
                icon: (0, $etZQm.getTypeIcon)(type)
            });
        };
        this.push = (path)=>{
            const { contextEntryPoint: contextEntryPoint } = this.props;
            const finalPath = (0, $fef5r.prefixWithContextEntryPoint)(path, contextEntryPoint);
            return this.props.push(finalPath);
        };
        this.replace = (path)=>{
            const { contextEntryPoint: contextEntryPoint } = this.props;
            const finalPath = (0, $fef5r.prefixWithContextEntryPoint)(path, contextEntryPoint);
            return this.props.replace(finalPath);
        };
        this.state = {
            addFlag: this.addFlag,
            push: this.push,
            replace: this.replace,
            productName: $2d469be16bced186$var$mapAppToProduct(this.props.appName),
            productFeatureFlags: this.props.productFeatureFlags,
            invitePeopleHandlers: this.props.invitePeopleHandlers
        };
    }
}

});
parcelRegister("1PG9B", function(module, exports) {

$parcel$export(module.exports, "ShortProductKey", () => $963bd8b8b0e89b4c$export$736dd0bf2ecc436f);
$parcel$export(module.exports, "ProductName", () => $963bd8b8b0e89b4c$export$acdfad52bc8c6626);
/**
 * ShortProductKey is used in code. It should not have a special characters or empty space
 */ var $963bd8b8b0e89b4c$export$736dd0bf2ecc436f;
(function(ShortProductKey) {
    ShortProductKey["CONFLUENCE"] = "confluence";
    ShortProductKey["JIRA"] = "jira";
    ShortProductKey["JIRA_CORE"] = "jira_core";
    ShortProductKey["JIRA_SOFTWARE"] = "jira_software";
    ShortProductKey["JIRA_SERVICE_DESK"] = "jira_service_key";
    ShortProductKey["BITBUCKET"] = "bitbucket";
})($963bd8b8b0e89b4c$export$736dd0bf2ecc436f || ($963bd8b8b0e89b4c$export$736dd0bf2ecc436f = {}));
var $963bd8b8b0e89b4c$export$acdfad52bc8c6626;
(function(ProductName) {
    ProductName["CONFLUENCE"] = "Confluence";
    ProductName["JIRA"] = "Jira";
    ProductName["JIRA_CORE"] = "Jira Core";
    ProductName["JIRA_SOFTWARE"] = "Jira Software";
    ProductName["JIRA_SERVICE_DESK"] = "Jira Service Desk";
    ProductName["BITBUCKET"] = "Bitbucket";
    ProductName["TEAM_CENTRAL"] = "Team Central";
    ProductName["ATLAS"] = "Atlas";
    ProductName["HOME"] = "Atlassian Home";
})($963bd8b8b0e89b4c$export$acdfad52bc8c6626 || ($963bd8b8b0e89b4c$export$acdfad52bc8c6626 = {}));
const $963bd8b8b0e89b4c$export$ff506ffd2c56b336 = {
    ["Jira"]: 'JIRA',
    ["Confluence"]: 'CONFLUENCE',
    ["Team Central"]: 'TOWNSQUARE',
    ["Atlas"]: 'TOWNSQUARE',
    ["Atlassian Home"]: 'HOME'
};
var $963bd8b8b0e89b4c$export$fc3a4bf3fb08b1b4;
(function(LongProductKey) {
    LongProductKey["JIRA_CORE"] = "jira-core.ondemand";
    LongProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    LongProductKey["CONFLUENCE"] = "confluence.ondemand";
    LongProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    LongProductKey["BITBUCKET"] = "bitbucket";
})($963bd8b8b0e89b4c$export$fc3a4bf3fb08b1b4 || ($963bd8b8b0e89b4c$export$fc3a4bf3fb08b1b4 = {}));

});

parcelRegister("etZQm", function(module, exports) {

$parcel$export(module.exports, "getTypeIcon", () => $9ac5cbae8f4c29b0$export$672f92b0d52b7cfe);

var $eUqFw = parcelRequire("eUqFw");

var $cHccS = parcelRequire("cHccS");

var $gw74N = parcelRequire("gw74N");

var $ek6sP = parcelRequire("ek6sP");

var $1Qu2i = parcelRequire("1Qu2i");

const $9ac5cbae8f4c29b0$var$flagIconByType = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gw74N))), {
        label: "error123",
        spacing: "spacious",
        color: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Qu2i))), {
        label: "warning123",
        spacing: "spacious",
        color: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$export$c6930421db9fa514)})`
    }),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ek6sP))), {
        label: "info123",
        spacing: "spacious",
        color: `var(--ds-icon-information, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`
    })
};
const $9ac5cbae8f4c29b0$var$defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cHccS))), {
    label: "winner123",
    spacing: "spacious",
    color: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`
});
const $9ac5cbae8f4c29b0$export$672f92b0d52b7cfe = (type = 'normal')=>$9ac5cbae8f4c29b0$var$flagIconByType[type] || $9ac5cbae8f4c29b0$var$defaultIcon;

});
parcelRegister("ek6sP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d713ff70b5256bc6a2136432b07993d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6d7f28dcbf6a858$var$_react = $a6d7f28dcbf6a858$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a6d7f28dcbf6a858$var$_information = $a6d7f28dcbf6a858$var$_interopRequireDefault((parcelRequire("h6FFs")));

var $a6d7f28dcbf6a858$var$_info = $a6d7f28dcbf6a858$var$_interopRequireDefault((parcelRequire("2bv8J")));
function $a6d7f28dcbf6a858$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: helper message under textfield, information state insection messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6d7f28dcbf6a858$var$InformationIcon = (props)=>/*#__PURE__*/ $a6d7f28dcbf6a858$var$_react.default.createElement($a6d7f28dcbf6a858$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $a6d7f28dcbf6a858$var$_info.default
    }, props));
$a6d7f28dcbf6a858$var$InformationIcon.Name = 'InformationIconMigration';
var $a6d7f28dcbf6a858$var$_default = module.exports.default = $a6d7f28dcbf6a858$var$InformationIcon;

});



parcelRegister("YnDGC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c964cd06fdee6c66$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $5QRJ0 = parcelRequire("5QRJ0");
var $fECJU = parcelRequire("fECJU");
class $c964cd06fdee6c66$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        const { analytics: analytics, appName: appName } = this.props;
        (0, $fECJU.logException)(error, 'Caught error in ErrorBoundaryApp', {
            info: errorInfo,
            tags: {
                severity: 'high'
            }
        });
        analytics.pushOperationalEvent({
            source: (0, $1io2n.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: 'errorBoundary',
            action: (0, $1io2n.AnalyticsEventActions).TRIGGERED,
            attributes: {
                product: appName,
                boundary: 'app',
                error: error.toString()
            },
            tags: [
                'error',
                'error-boundary'
            ]
        });
    }
    render() {
        if (!this.state.hasError) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5QRJ0.GenericErrorPage), {
            hasSupportLink: true
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}

});

parcelRegister("aILpI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d458045efc6862b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1io2n = parcelRequire("1io2n");
var $74Hyh = parcelRequire("74Hyh");
var $gakch = parcelRequire("gakch");
var $hPco0 = parcelRequire("hPco0");
var $6XUHL = parcelRequire("6XUHL");

var $34zWR = parcelRequire("34zWR");
const $6d458045efc6862b$var$mapAppNameToProduct = {
    '': undefined,
    'site-directory': undefined,
    'confluence-directory': 'CONFLUENCE',
    'jira-directory': 'JIRA',
    'teamcentral-directory': 'TOWNSQUARE',
    'home-directory': 'HOME'
};
function $6d458045efc6862b$export$f07589effd6b0ff3(props) {
    const { appName: appName, children: children } = props;
    const [{ cloudId: cloudId }] = (0, $6XUHL.useSite)();
    const [{ principalUserId: principalUserId }, { getPrincipalUserInfo: getPrincipalUserInfo }] = (0, $gakch.usePrincipalUser)();
    const analytics = (0, $74Hyh.default)();
    const [{ hasLoadedSettings: hasLoadedSettings, hasErrorOnFetchSettings: hasErrorOnFetchSettings }, { getSettings: getSettings }] = (0, $hPco0.useSettings)();
    (0, $eUqFw.useEffect)(()=>{
        analytics.startUIViewedEvent(principalUserId);
    }, [
        analytics,
        principalUserId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasLoadedSettings) analytics.pushOperationalEvent({
            action: hasErrorOnFetchSettings ? (0, $1io2n.AnalyticsEventActions).FAILED : (0, $1io2n.AnalyticsEventActions).SUCCEEDED,
            actionSubject: (0, $34zWR.SliAnalytics).GetSettings,
            source: (0, $1io2n.AnalyticsEventSource).DIRECTORY_APP
        });
    }, [
        analytics,
        hasLoadedSettings,
        hasErrorOnFetchSettings
    ]);
    const product = $6d458045efc6862b$var$mapAppNameToProduct[appName];
    (0, $eUqFw.useEffect)(()=>{
        // currently, cloudId is a required prop of Embedded Directory
        if (!hasLoadedSettings && cloudId) getSettings(product, cloudId);
    }, [
        product,
        hasLoadedSettings,
        getSettings,
        cloudId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // currently, cloudId is a required prop of Embedded Directory
        if (cloudId) getPrincipalUserInfo(cloudId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cloudId
    ]);
    return children;
}
var $6d458045efc6862b$export$2e2bcd8739ae039 = $6d458045efc6862b$export$f07589effd6b0ff3;

});
parcelRegister("hPco0", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlag", () => $23bdd30d6f19633d$export$61acb772777ef35d);
$parcel$export(module.exports, "useSettings", () => $23bdd30d6f19633d$export$9115b42802a3e44f);

var $hY5Cf = parcelRequire("hY5Cf");
var $5wKIN = parcelRequire("5wKIN");
const $23bdd30d6f19633d$export$c5cecc6f5d4bab3e = ()=>{
    return true;
};
const $23bdd30d6f19633d$export$61acb772777ef35d = (flagName)=>{
    return (0, $hY5Cf.useFeatureFlag)(flagName);
};
const $23bdd30d6f19633d$export$9115b42802a3e44f = ()=>{
    return (0, $5wKIN.useSettings)();
};

});
parcelRegister("hY5Cf", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlag", () => $96cecbc646ff6917$export$61acb772777ef35d);

var $5wKIN = parcelRequire("5wKIN");

var $WQNHl = parcelRequire("WQNHl");
const $96cecbc646ff6917$export$61acb772777ef35d = (flag)=>{
    const { productFeatureFlags: productFeatureFlags } = (0, $WQNHl.useAppConfig)();
    const flagValue = (0, $5wKIN.useSettingsFeatureFlag)(flag);
    if (productFeatureFlags && productFeatureFlags[flag] !== undefined) return productFeatureFlags[flag];
    return flagValue;
};
const $96cecbc646ff6917$export$80200644648c0ee1 = (flagName)=>!!$96cecbc646ff6917$export$61acb772777ef35d(flagName);

});
parcelRegister("5wKIN", function(module, exports) {

$parcel$export(module.exports, "useSettings", () => $06134dd6c85c5d96$export$9115b42802a3e44f);
$parcel$export(module.exports, "useSettingsFeatureFlag", () => $06134dd6c85c5d96$export$f2df9067cb58ea32);

var $WBLbN = parcelRequire("WBLbN");

var $cAxhS = parcelRequire("cAxhS");

var $jz9bg = parcelRequire("jz9bg");

var $82kzV = parcelRequire("82kzV");
const $06134dd6c85c5d96$export$28456d095a642fd = 'internal.browse-users-allowed';
const $06134dd6c85c5d96$var$actions = {
    /**
	 * Fetches feature flag settings from LaunchDarkly via activity service and directory service
	 * Caches the fetched settings in local storage to be used as optimistic settings on next load
	 * @param product - only Embeddable Directory needs product information. Standalone app does not need this.
	 * @param cloudId - Cloud Id.
	 */ getSettings: (product, cloudId)=>async ({ setState: setState })=>{
            // in siteless, we don't need to query features flags in directory
            const directorySettingPromise = cloudId ? (0, $cAxhS.teamsClient).querySettings(cloudId, product) : Promise.resolve({
                [$06134dd6c85c5d96$export$28456d095a642fd]: true
            });
            return (0, $jz9bg.promiseWithDefault)(directorySettingPromise, {
                [$06134dd6c85c5d96$export$28456d095a642fd]: false
            }).then(({ value: browseUsersEnabled, success: settingsSuccess })=>{
                const settingsFromRequests = {
                    // If settings cannot be accessed, default to permission denied.
                    [$06134dd6c85c5d96$export$28456d095a642fd]: false,
                    ...browseUsersEnabled
                };
                if (settingsSuccess) setState({
                    hasLoadedSettings: true,
                    hasBrowseUsersPermission: !!settingsFromRequests[$06134dd6c85c5d96$export$28456d095a642fd],
                    settings: {
                        ...settingsFromRequests
                    }
                });
                // Fallback as needed to compute effective flag values
                const finalSettings = {
                    ...(0, $82kzV.getSettingsFromStorage)() || {},
                    ...settingsFromRequests
                };
                setState({
                    hasLoadedSettings: true,
                    hasErrorOnFetchSettings: !settingsSuccess,
                    hasBrowseUsersPermission: !!finalSettings[$06134dd6c85c5d96$export$28456d095a642fd],
                    settings: finalSettings
                });
            });
        }
};
const $06134dd6c85c5d96$var$initialState = {
    hasLoadedSettings: false,
    hasErrorOnFetchSettings: false,
    hasBrowseUsersPermission: false,
    settings: {
        [$06134dd6c85c5d96$export$28456d095a642fd]: false,
        ...(0, $82kzV.getSettingsFromStorage)() || {}
    }
};
/**
 * Manage states of settings
 */ const $06134dd6c85c5d96$var$Store = (0, $WBLbN.createStore)({
    initialState: $06134dd6c85c5d96$var$initialState,
    actions: $06134dd6c85c5d96$var$actions,
    name: 'Settings'
});
const $06134dd6c85c5d96$export$8376625f8bb18347 = (0, $WBLbN.createContainer)($06134dd6c85c5d96$var$Store, {
    onInit: ()=>({ setState: setState }, state)=>{
            setState(state);
        }
});
const $06134dd6c85c5d96$export$9115b42802a3e44f = (0, $WBLbN.createHook)($06134dd6c85c5d96$var$Store);
const $06134dd6c85c5d96$export$f2df9067cb58ea32 = (flagName)=>{
    const [{ settings: settings }] = $06134dd6c85c5d96$export$9115b42802a3e44f();
    return settings[flagName];
};

});
parcelRegister("jz9bg", function(module, exports) {

$parcel$export(module.exports, "promiseWithDefault", () => $b245cb500a733aaa$export$a970b469503acdc8);
function $b245cb500a733aaa$export$a970b469503acdc8(promise, defaultValue) {
    return promise.then((value)=>({
            value: value,
            success: true
        })).catch(()=>({
            value: defaultValue,
            success: false
        }));
}

});




parcelRegister("34zWR", function(module, exports) {

$parcel$export(module.exports, "SliAnalytics", () => $1adc48e2f5702dcd$export$9cb5f615baf57db6);
var $1adc48e2f5702dcd$export$9cb5f615baf57db6;
(function(SliAnalytics) {
    SliAnalytics["GetTeamProfile"] = "GetTeamProfile";
    SliAnalytics["GetTeamMembers"] = "GetTeamMembers";
    SliAnalytics["GetTeamLinks"] = "GetTeamLinks";
    SliAnalytics["TeamSearch"] = "TeamSearch";
    SliAnalytics["AccountCentricUserSearch"] = "AccountCentricUserSearch";
    SliAnalytics["LoadProfileAbout"] = "LoadProfileAbout";
    SliAnalytics["GetSettings"] = "GetSettings";
})($1adc48e2f5702dcd$export$9cb5f615baf57db6 || ($1adc48e2f5702dcd$export$9cb5f615baf57db6 = {}));

});




parcelRegister("j0CW6", function(module, exports) {

$parcel$export(module.exports, "createShowFlagHandler", () => $43aa3b2073d8beb6$export$58bf1d914631d59f);

var $eUqFw = parcelRequire("eUqFw");

var $eo17r = parcelRequire("eo17r");

var $iFoSH = parcelRequire("iFoSH");
const $43aa3b2073d8beb6$var$FLAG_PTC_ID_DEFAULT = 'ptc-people-directory.flag-id';
const $43aa3b2073d8beb6$export$58bf1d914631d59f = (showFlag, dismissFlag)=>(flagFromPTC)=>{
        const flagType = flagFromPTC.type === 'success' || flagFromPTC.type === 'error' || flagFromPTC.type === 'info' || flagFromPTC.type === 'warning' ? flagFromPTC.type : 'success';
        const flagTitle = flagFromPTC.title;
        const flagDesc = flagFromPTC.description;
        showFlag({
            render: ({ key: key })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFoSH.default), {
                    key: key,
                    id: key || flagFromPTC.id || $43aa3b2073d8beb6$var$FLAG_PTC_ID_DEFAULT,
                    flagType: flagType,
                    title: flagTitle != null ? flagTitle : '',
                    description: flagDesc != null ? flagDesc : '',
                    isAutoDismiss: true,
                    onDismissed: (id)=>{
                        dismissFlag((0, $eo17r.toFlagId)(id));
                    }
                })
        });
    };

});
parcelRegister("iFoSH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d199b2da5c2aad1c$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $d199b2da5c2aad1c$export$2e2bcd8739ae039 = (0, $kQ0RL.CommonFlag);

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("70r4x")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("70r4x")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("70r4x", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('cCYJs')
        ]);
        const value = parcelRequire('kbpOk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("cCYJs")
    ]).then(()=>parcelRequire('kbpOk'));
}

});

parcelRegister("Tabui", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hkLGi');
        const value = parcelRequire('jkRT2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hkLGi").then(()=>parcelRequire('jkRT2'));
}

});




parcelRegister("7mFxr", function(module, exports) {

$parcel$export(module.exports, "peopleProfilesPageLoad", () => $08b7272d77e81c54$export$37d218590c0c9938);

var $lNfG4 = parcelRequire("lNfG4");
const $08b7272d77e81c54$export$37d218590c0c9938 = (0, $lNfG4.metrics).pageLoad({
    key: 'people-profiles'
});

});



//# sourceMappingURL=async-people-profiles.0cf9a76e.js.map
